export const es = {
    'pgnav.catalog.memberships': 'Membresías',
    'sitemap.new.memberships': 'Nueva membresía',
    'offerTemplate.card.memberships': 'Página de cada membresía',
    'offerTemplate.pageName.memberships': 'Página de membresía',
    'offerTemplate.sample.memberships': 'Membresía de ejemplo',
    'catalogPanel.kind.memberships': 'Membresía',
    'catalogPanel.art.cta.memberships': 'Únete ahora',
    'catalogPanel.membershipBody': 'Membresías recurrentes y paquetes prepagados. Elige en el panel lo que reciben los miembros.',
    'designs.list.memberships': 'Página de membresías',
    'designs.item.memberships': 'Página de cada membresía',
    'sample.navMemberships': 'Membresías',
    'navm.auto.desc.memberships': 'Membresías y paquetes prepagados',
    // ── Comunes ───────────────────────────────────────────────────────────────
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.processing': 'Procesando…',
    'common.discard': 'Descartar',
    'common.saving': 'Guardando…',
    'common.saved': 'Cambios guardados',
    'common.none': '—',
    'common.back': 'Volver',
    'common.search': 'Buscar',
    'common.close': 'Cerrar',
    /* Lo dicen Páginas, el marco del proyecto y Políticas. Se llamaba
       `pages.linkCopied` de cuando sólo lo decía una. */
    'common.changeImage': 'Cambiar imagen',
    'common.selectImage': 'Elegir imagen',
    'common.linkCopied': 'Enlace copiado',
    'common.copyFailed': 'No se pudo copiar el enlace',
    'common.untitled': 'Sin título',
    'common.unnamed': 'Sin nombre',
    'common.open': 'Abrir',
    'common.items': 'elementos',
    'common.starred': 'destacados',
    'common.star': 'Destacar',
    'common.unstar': 'Quitar destacado',
    'common.refreshingData': 'Actualizando…',
    'common.refreshFailed': 'No se pudo actualizar. Los datos pueden no estar al día.',
    'common.refresh': 'Actualizar',
    'common.refreshList': 'Actualizar la lista',
    'common.selection.one': '{count} seleccionado',
    'common.selection.many': '{count} seleccionados',
    'common.selection.actions': 'Acciones para lo seleccionado',
    'common.pagination.showing': 'Mostrando {start}–{end} de {total} {unit}',
    'common.pagination.total': '{total} {unit}',
    'common.pagination.previous': 'Página anterior',
    'common.pagination.next': 'Página siguiente',
    'common.pagination.page': 'Página {page}',
    'common.starFilter.viewAllAria': 'Ver todo, no sólo {label}',
    'common.starFilter.onlyAria': 'Ver sólo {label}',
    'common.starFilter.viewAll': 'Ver todo',
    'common.starFilter.only': 'Sólo {label}',
    'common.planUsage.limitLabel': '{label}: límite {limit}',
    'common.planUsage.usedLabel': '{label}: {used} de {limit}',
    'common.planUsage.unlimited': 'ilimitadas',
    'common.planUsage.ofLimit': '{used} de {limit}',
    'common.planUsage.fullTitle': 'Alcanzaste un límite de tu plan',
    'common.planUsage.warningTitle': 'Estás cerca de un límite',
    'common.planUsage.title': 'Uso de tu plan',
    'common.planUsage.moreInfo': 'Más información sobre los límites',
    'common.planUsage.tooltip': 'Uso y límites',
    'common.planUsage.dialogAria': 'Uso y límites del plan',
    'common.planUsage.resets': 'Se reinicia {date}.',
    'common.planUsage.fullBody': 'Llegaste al máximo en tu plan {plan}. Sube de plan para seguir agregando.',
    'common.planUsage.warningBody': 'Te estás acercando al límite de tu plan {plan}. Amplía tu capacidad antes de llenarlo.',
    'common.planUsage.okBody': 'Estás dentro de los límites de tu plan {plan}.',
    'common.planUsage.upgrade': 'Mejorar a {plan}',
    'common.planUsage.emailSubject': 'Necesito más capacidad (Business)',
    'common.planUsage.contact': 'Contactar a véltica',
    // ── Ajustes › Configuración del sitio ─────────────────────────────────────
    'settings.general.title': 'Configuración del sitio',
    'settings.general.intro': 'Define la identidad del proyecto, la zona horaria, el acceso y la presencia de la marca en el sitio publicado.',
    'settings.general.identity.title': 'Identidad del proyecto',
    'settings.general.identity.intro': 'Establece el nombre con el que identificarás este sitio dentro del dashboard.',
    'settings.general.identity.nameLabel': 'Nombre del proyecto',
    'settings.general.timezone.title': 'Zona horaria',
    'settings.general.timezone.intro': 'Determina cómo se agrupan las fechas y el inicio de cada día en Analíticas.',
    'settings.general.timezone.label': 'Zona horaria del sitio',
    'settings.general.timezone.detect': 'Detectar',
    'settings.general.timezone.detected': 'Zona horaria detectada: {zone}',
    'settings.general.icons.title': 'Iconos del sitio',
    'settings.general.icons.intro': 'Configura los iconos para navegadores y dispositivos. Las imágenes se ajustan automáticamente y se aplican al publicar.',
    'settings.general.icons.faviconLight': 'Favicon claro',
    'settings.general.icons.faviconDark': 'Favicon oscuro',
    'settings.general.icons.webclip': 'Webclip',
    'settings.general.icons.change': 'Cambiar {icon}',
    'settings.general.icons.upload': 'Subir {icon}',
    'settings.general.icons.failed': 'No se pudo procesar la imagen',
    'settings.general.password.title': 'Contraseña del sitio',
    'settings.general.password.intro': 'Restringe el acceso al sitio publicado mediante una contraseña.',
    'settings.general.password.toggle': 'Protección con contraseña',
    'settings.general.password.toggleHint': 'Los visitantes deberán introducirla antes de acceder al contenido.',
    'settings.general.password.new': 'Nueva contraseña (opcional)',
    'settings.general.password.current': 'Contraseña',
    'settings.general.password.keepHint': 'Deja en blanco para conservar la actual',
    'settings.general.password.minHint': 'Mínimo 6 caracteres',
    'settings.general.password.tooShort': 'La contraseña debe tener al menos 6 caracteres',
    'settings.general.pending.title': "Lo que falta por completar",
    'settings.general.pending.intro': "Los servicios, reservas, productos y entradas que dejó empezados la IA y aún no completas.",
    'settings.general.pending.toggle': "Mostrar como «Próximamente»",
    'settings.general.cart.title': "Carrito",
    'settings.general.cart.intro': "Que tus clientes junten varias cosas y las paguen de una vez, con un solo envío.",
    'settings.general.cart.toggle': "Usar carrito",
    'settings.general.cart.hintOn': "Las ofertas que se pueden comprar juntas llevan «Agregar al carrito», y la barra del sitio, el icono del carrito. Las reservas y suscripciones siguen con su botón. Se nota al volver a publicar.",
    'settings.general.cart.hintOff': "Cada oferta se compra sola, con su botón. Se nota al volver a publicar.",
    'settings.general.accounts.title': "Cuentas de clientes",
    'settings.general.accounts.intro': "Que tus clientes entren a tu sitio con su correo para ver sus datos y lo que tienen contigo. Sin contraseñas: entran con un código que les llega al correo.",
    'settings.general.accounts.toggle': "Cuentas de clientes",
    'settings.general.accounts.mode.auto': "Automático",
    'settings.general.accounts.mode.on': "Siempre",
    'settings.general.accounts.mode.off': "Nunca",
    'settings.general.accounts.hint.auto': "Se activan solas en cuanto tu sitio publique algo que se compre o se reserve. Tus clientes entran en /account y en la barra sale el icono de la cuenta.",
    'settings.general.accounts.hint.on': "Activadas siempre: tus clientes pueden crear su cuenta y entrar en /account. Funciona desde ya, sin volver a publicar.",
    'settings.general.accounts.hint.off': "Tu sitio no tiene cuentas de clientes: quien compra o reserva lo hace como invitado. Las membresías se pueden comprar sin cuenta.",
    'settings.general.pending.hintSoon': "Se ven en tu sitio con su foto y su nombre, sin precio. Al pulsarlos, un aviso dice que vienen pronto. Así la página no queda a medias.",
    'settings.general.pending.hintHide': "No salen en tu sitio hasta que los completes y los publiques. Las secciones que sólo tengan eso se ocultan.",
    'settings.general.badge.title': 'Marca de véltica',
    'settings.general.badge.introCanRemove': 'Controla la visibilidad de la insignia en las páginas publicadas de este sitio.',
    'settings.general.badge.introFree': 'La insignia se muestra en las páginas publicadas de los sitios con plan gratuito.',
    'settings.general.badge.previewLabel': 'Vista previa',
    'settings.general.badge.previewAria': 'Vista previa de la insignia Hecho en véltica',
    'settings.general.badge.madeWith': 'Hecho en',
    'settings.general.badge.toggle': 'Mostrar insignia “Hecho en véltica”',
    'settings.general.badge.toggleAria': 'Mostrar insignia Hecho en véltica',
    'settings.general.badge.hintCanRemove': 'Se muestra discretamente en la esquina de todas las páginas publicadas.',
    'settings.general.badge.hintFree': 'Actualiza el plan del sitio para poder ocultarla.',
    'settings.general.badge.upsell': 'Para ocultar completamente la marca de véltica del sitio publicado,',
    'settings.general.badge.upsellLink': 'agrega un plan de sitio de pago',
    'settings.general.overview.title': 'Información del proyecto',
    'settings.general.overview.intro': 'Consulta los identificadores, fechas y métricas generales del sitio.',
    'settings.general.overview.id': 'ID del sitio',
    'settings.general.overview.created': 'Creado',
    'settings.general.overview.updated': 'Última actualización',
    'settings.general.overview.published': 'Última publicación',
    'settings.general.overview.unpublished': 'Sin publicar',
    'settings.general.overview.pages': 'Páginas',
    'settings.general.overview.collectionItems': 'Elementos de colecciones',
    'settings.general.danger.title': 'Administración del proyecto',
    'settings.general.danger.intro': 'El sitio se baja de inmediato y sus datos se conservan 30 días por si te arrepientes.',
    'settings.general.danger.delete': 'Eliminar proyecto',
    'settings.general.danger.deleteHint': 'El sitio, su contenido y su historial no podrán recuperarse.',
    'settings.general.danger.thisProject': 'este proyecto',
    'settings.general.delete.title': '¿Eliminar “{project}”?',
    'settings.general.delete.intro': "El sitio se desconecta al momento.",
    'settings.general.delete.gracePill': "30 días para recuperarlo",
    'settings.general.delete.lostTitle': 'Datos que se eliminarán',
    'settings.general.delete.lostSite': 'Sitio y páginas',
    'settings.general.delete.lostSiteHint': 'La publicación, los archivos y todo el contenido de las páginas.',
    'settings.general.delete.lostCms': 'CMS y formularios',
    'settings.general.delete.lostCmsHint': 'Las colecciones, sus elementos y todos los mensajes recibidos.',
    'settings.general.delete.lostCommerce': 'Contactos y actividad comercial',
    'settings.general.delete.lostCommerceHint': 'Los contactos, las ofertas, las ventas y las reservas registradas.',
    'settings.general.delete.lostAnalytics': 'Analíticas y recuperación',
    'settings.general.delete.lostAnalyticsHint': 'El historial de analíticas y todas las copias de seguridad.',
    'settings.general.delete.keptTitle': 'Lo que se conserva',
    'settings.general.delete.keptStripe': 'Tu cuenta de Stripe',
    'settings.general.delete.keptStripeHint': 'Sólo se desconecta de este proyecto. La cuenta, el saldo y el historial de transacciones siguen en Stripe, y con ellos tus comprobantes de venta.',
    'settings.general.delete.keptDomains': 'Los dominios que compraste',
    'settings.general.delete.keptDomainsHint': 'Siguen registrados a tu nombre hasta su renovación y puedes apuntarlos a otro proyecto.',
    'settings.general.delete.keptImages': 'Tus imágenes',
    'settings.general.delete.keptImagesHint': 'La biblioteca es de tu cuenta y no de este sitio: las subidas se quedan disponibles para tus demás proyectos.',
    'settings.general.delete.keptPlan': 'Tu membresía',
    'settings.general.delete.keptPlanHint': 'El plan es de tu cuenta, no del sitio. No se cancela ni cambia de precio por borrar un proyecto.',
    'settings.general.delete.graceBody': 'El sitio deja de estar en línea ahora mismo, pero los datos se conservan un mes y puedes restaurarlo desde tu panel. Pasado ese plazo se eliminan de forma permanente. Si conectaste un dominio propio, recuerda quitar o cambiar sus registros DNS donde lo tengas registrado: seguirán apuntando aquí.',
    'settings.general.delete.confirmLabel': 'Escribe {project} para confirmar',
    'settings.general.delete.confirmFallback': 'el nombre del proyecto',
    'settings.general.delete.confirmPlaceholder': 'Nombre del proyecto',
    'settings.general.delete.confirmHint': "No importan las mayúsculas ni los acentos.",
    'settings.general.delete.confirmTooltip': 'Escribe el nombre del proyecto para confirmar',
    'settings.general.error.emptyName': 'El nombre no puede estar vacío',
    'settings.general.error.saveFailed': 'No se pudieron guardar los cambios',
    // ── Errores del servidor ──────────────────────────────────────────────────
    /* El worker manda un CÓDIGO además de su texto; esto es lo que lo convierte
       en un mensaje del idioma de quien mira. Sin esto, un panel en inglés suelta
       frases en español que vienen ya escritas del servidor. */
    'error.project.notFound': 'No encontramos este proyecto.',
    'error.project.forbidden': 'No tienes acceso a este proyecto.',
    'error.project.roleForbidden': 'Tu rol en este proyecto no permite esta acción.',
    'error.network': 'No se pudo conectar. Revisa tu conexión e inténtalo de nuevo.',
    'error.unexpected': 'Algo salió mal. Inténtalo de nuevo.',
    // ── Idioma ────────────────────────────────────────────────────────────────
    'language.label': 'Idioma',
    'language.es': 'Español',
    'language.en': 'Inglés',
    // ── Entrar y crear cuenta ─────────────────────────────────────────────────
    'auth.welcomeBack': 'Bienvenido de nuevo',
    'auth.createAccount': 'Crea tu cuenta',
    'auth.signInIntro': 'Inicia sesión para continuar construyendo tus sitios.',
    'auth.signUpIntro': 'Empieza a construir y administrar tus sitios con véltica.',
    'auth.signIn': 'Inicia sesión',
    'auth.signUp': 'Crear cuenta',
    'auth.continue': 'Continuar',
    'auth.continuing': 'Continuando...',
    'auth.sending': 'Enviando...',
    'auth.sendingCode': 'Enviando código...',
    'auth.verifying': 'Verificando...',
    'auth.saving': 'Guardando...',
    'auth.email': 'Correo electrónico',
    'auth.emailPlaceholder': 'tu@correo.com',
    'auth.emailHint': 'Te enviaremos un código para continuar.',
    'auth.rememberEmail': 'Recordar mi correo en este dispositivo',
    'auth.recentlyUsed': 'Usado recientemente',
    'auth.continueWith': 'Continuar con {provider}',
    'auth.continueWithEmail': 'Continuar con correo',
    'auth.or': 'o',
    'auth.checkYourEmail': 'Revisa tu correo',
    'auth.codeLabel': 'Código de verificación',
    'auth.codeHint': 'Escribe el código que te enviamos por correo.',
    'auth.resendCode': 'Reenviar código',
    'auth.nameQuestion': '¿Cómo te llamas?',
    'auth.nameWhy': 'Así personalizamos tu espacio de trabajo en véltica.',
    'auth.name': 'Nombre',
    'auth.namePlaceholder': 'Tu nombre',
    'auth.newPasswordTitle': 'Crea una nueva contraseña',
    'auth.newPasswordHint': 'Elige una contraseña segura que no hayas utilizado antes.',
    'auth.newPassword': 'Nueva contraseña',
    'auth.confirmPassword': 'Confirmar contraseña',
    'auth.passwordPlaceholder': 'Mínimo 8 caracteres',
    'auth.repeatPlaceholder': 'Repite tu contraseña',
    'auth.savePassword': 'Guardar nueva contraseña',
    'auth.showPassword': 'Mostrar contraseña',
    'auth.hidePassword': 'Ocultar contraseña',
    'auth.noAccount': '¿No tienes una cuenta?',
    'auth.haveAccount': '¿Ya tienes una cuenta?',
    'auth.requestNewLink': 'Solicitar otro enlace',
    'auth.terms': 'Términos y condiciones',
    'auth.privacy': 'Política de privacidad',
    'auth.photoBy': 'Foto por',
    'auth.lightMode': 'Modo claro',
    'auth.darkMode': 'Modo oscuro',
    'auth.switchToLight': 'Cambiar a modo claro',
    'auth.switchToDark': 'Cambiar a modo oscuro',
    'auth.accessAria': 'Acceso a véltica',
    'auth.previewAria': 'Vista previa de véltica',
    'auth.hero.loginTitle': "Todo tu negocio, en un solo lugar.",
    'auth.hero.loginBody': "Tu sitio, tus ventas y tus reservas, administrados desde véltica.",
    'auth.hero.signupTitle': "Tu sitio, listo en minutos.",
    'auth.hero.signupBody': "Crea tu página, cobra en línea y recibe reservas sin escribir una línea de código.",
    'auth.hero.site': "Sitio web",
    'auth.hero.payments': "Pagos",
    'auth.hero.bookings': "Reservas",
    'auth.workspaceAria': 'Espacio de trabajo de véltica',
    'auth.error.badEmail': 'Escribe un correo válido.',
    'auth.error.noMx': 'Ese dominio no recibe correos. Revisa que esté bien escrito.',
    'auth.error.needName': 'Escribe tu nombre para continuar.',
    'auth.error.badCode': 'El código no es válido o ya venció. Revisa tu correo o pide uno nuevo.',
    'auth.error.shortPassword': 'La contraseña debe tener al menos 8 caracteres.',
    'auth.error.mismatch': 'Las contraseñas no coinciden.',
    'auth.error.generic': 'No pudimos continuar. Inténtalo de nuevo en un momento.',
    'auth.error.google': 'No pudimos entrar con Google. Inténtalo de nuevo o usa tu correo.',
    'auth.error.expiredLink': 'Este enlace venció o no es válido. Solicita uno nuevo para continuar.',
    'auth.useAnotherEmail': 'Usar otro correo',
    'auth.codeSentTo': 'Te enviamos un código de 6 dígitos a {email}. Escríbelo para continuar.',
    'auth.notArrived': '¿No te llegó?',
    'auth.back': 'Volver',
    'auth.enterYourEmail': 'Escribe tu correo',
    'auth.didYouMean': '¿Quisiste decir {suggestion}?',
    'auth.legalPrefix': 'Al continuar, reconoces que comprendes y aceptas nuestros',
    'auth.legalMiddle': 'y nuestra',
    // ── Inicio y asistente de creación ────────────────────────────────────────
    'home.beta.label': 'Beta.',
    'home.beta.body': 'véltica está en desarrollo activo: puede haber cambios y algún fallo mientras la afinamos.',
    'home.footer.legalAria': 'Información legal',
    'home.footer.terms': 'Términos y condiciones',
    'home.footer.privacy': 'Política de privacidad',
    'home.deleted.title': 'Este proyecto está eliminado',
    'home.deleted.unnamed': 'Sin nombre',
    'home.deleted.gone': 'se eliminó y su sitio ya no está en línea.',
    'home.deleted.purgeSoon': 'Se borrará de forma permanente pronto.',
    'home.deleted.purgeToday': 'Se borrará de forma permanente hoy.',
    'home.deleted.purgeInOne': 'Se borrará de forma permanente en 1 día.',
    'home.deleted.purgeInDays': 'Se borrará de forma permanente en {count} días.',
    'home.deleted.recoverable': 'Puedes recuperarlo hasta entonces con todo su contenido; tendrás que volver a publicarlo para ponerlo en línea.',
    'home.deleted.recover': 'Recuperar',
    'home.deleted.tooltip': 'Este proyecto está eliminado',
    'create.dialogAria': 'Crear proyecto',
    'create.nameAria': 'Nombre del proyecto',
    'create.namePlaceholder': 'Nombre del proyecto',
    'create.close': 'Cerrar',
    'create.categoriesAria': 'Categorías de plantillas',
    'create.categories': 'Categorías',
    'create.stepsAria': 'Pasos de personalización',
    'create.customise': 'Personalizar',
    'create.templatesAria': 'Plantillas',
    'create.fontsAria': 'Combinaciones de letras',
    'create.fromTemplate': 'Original de la plantilla',
    'create.custom': 'Personalizado',
    'create.headingFont': 'Fuente de títulos',
    'create.bodyFont': 'Fuente de texto',
    'create.reset': 'Restablecer',
    'create.done': 'Listo',
    'create.fontLibrary': 'Biblioteca de letras',
    'create.fontFiltersAria': 'Filtrar letras por estilo',
    'create.edit': 'Editar',
    'create.palettesAria': 'Paletas de colores',
    'create.paletteLibrary': 'Biblioteca de colores',
    'create.paletteFiltersAria': 'Filtrar paletas por estilo',
    'create.cancel': 'Cancelar',
    'create.back': 'Atrás',
    'create.preparing': 'Preparando sitio...',
    'create.previewAria': 'Vista previa de la plantilla',
    'create.previewUnavailable': 'Preview no disponible',
    'create.templatesForNewAria': 'Plantillas para el nuevo sitio',
    'create.fontPairsAria': 'Combinaciones de letra',
    'create.restore': 'Restaurar',
    'create.createSite': 'Crear sitio',
    'create.next': 'Siguiente',
    'create.loadingPreview': 'Cargando preview...',
    'create.loadingTemplates': 'Cargando plantillas…',
    'create.refreshTemplates': 'Actualizar',
    'account.language.title': 'Idioma del panel',
    'account.language.intro': 'En qué idioma ves el panel y el editor. Viaja con tu cuenta, así que vale en cualquier ordenador donde entres.',
    'account.language.notProject': 'No cambia el idioma de tus sitios: los correos y la página de reservas de cada proyecto salen en el idioma que elijas en su {region}.',
    // ── Mi cuenta ─────────────────────────────────────────────────────────────
    'account.title': 'Mi cuenta',
    'account.intro': 'Administra tu perfil, tu correo y el acceso a tu cuenta.',
    'account.profile.title': 'Perfil',
    'account.profile.intro': 'Tu nombre y foto se muestran en el dashboard.',
    'account.profile.photoAlt': 'Foto de perfil',
    'account.profile.uploading': 'Subiendo…',
    'account.profile.remove': 'Quitar',
    'account.profile.photoHint': 'JPG, PNG o WebP. Máx 10 MB.',
    'account.profile.name': 'Nombre',
    'account.profile.namePlaceholder': 'Tu nombre',
    'account.profile.saved': 'Perfil guardado.',
    'account.email.title': 'Correo electrónico',
    'account.email.current': 'Correo actual:',
    'account.email.external': 'Iniciaste sesión con un proveedor externo, así que tu correo se gestiona desde ese proveedor.',
    'account.email.step1': 'Paso 1 de 2 · Verifica tu identidad',
    'account.email.step2': 'Paso 2 de 2 · Confirma tu correo nuevo',
    'account.email.codeSentCurrent': 'Te enviamos un código a tu correo actual {email}. Escríbelo para continuar.',
    'account.email.codeSentNew': 'Te enviamos un código a tu correo nuevo {email}. Escríbelo para confirmar el cambio.',
    'account.email.codeCurrent': 'Código de tu correo actual',
    'account.email.codeNew': 'Código de tu correo nuevo',
    'account.email.verifying': 'Verificando…',
    'account.email.confirming': 'Confirmando…',
    'account.email.inProgress': 'Verificación en curso. Usa el código que enviamos a {email}.',
    'account.email.pendingChange': 'Cambio pendiente a {email}.',
    'account.email.didYouMean': '¿Quisiste decir {suggestion}?',
    'account.providers.title': 'Cuentas conectadas',
    'account.providers.intro': 'Proveedores con los que puedes iniciar sesión.',
    'account.providers.connected': 'Conectado',
    'account.providers.disconnect': 'Desconectar',
    'account.providers.connect': 'Conectar',
    'account.sessions.title': 'Sesiones activas',
    'account.sessions.intro': 'Dispositivos donde tu cuenta tiene la sesión abierta.',
    'account.sessions.loading': 'Cargando sesiones…',
    'account.sessions.failed': 'No pudimos obtener la lista de sesiones.',
    'account.sessions.current': 'Sesión actual',
    'account.sessions.startedAt': 'Inició {date}',
    'account.sessions.signOutCurrent': 'Cerrar sesión actual',
    'account.sessions.signOut': 'Cerrar sesión',
    'account.sessions.signingOut': 'Cerrando…',
    'account.delete.graceIntro': "Tus sitios salen de línea y tu membresía se cancela al momento. Tienes {days} días para restaurar tu cuenta; después tus proyectos, imágenes y datos se borran para siempre.",
    'account.delete.domainsTitle': "Tus dominios",
    'account.delete.domainsHint': "Siguen siendo tuyos hasta que vencen. Elige qué hacer con cada uno.",
    'account.delete.domainExpires': "Vence el {date}",
    'account.delete.domainTransfer': "Transferirlo",
    'account.delete.domainTransferHint': "Te enviamos por correo el código para llevarlo a otro registrador.",
    'account.delete.domainLocked': "Bloqueado por un reembolso o una disputa.",
    'account.delete.domainExpire': "Dejar que venza",
    'account.delete.domainExpireHint': "No se renovará y quedará libre cuando venza.",
    'account.delete.noticeTeam': "{names}: sus miembros perderán el acceso.",
    'account.delete.noticeBookings.one': "Tienes 1 reserva futura. Tu cliente no recibirá aviso: avísale o cancélala antes.",
    'account.delete.noticeBookings.many': "Tienes {count} reservas futuras. Tus clientes no recibirán aviso: avísales o cancélalas antes.",
    'account.delete.noticeSubscriptions.one': "1 suscripción de un cliente dejará de renovarse al final de su periodo.",
    'account.delete.noticeSubscriptions.many': "{count} suscripciones de tus clientes dejarán de renovarse al final de su periodo.",
    'account.delete.noticeDisputes.one': "Tienes 1 disputa abierta. Sigue en tu cuenta de Stripe: respóndela a tiempo aunque elimines véltica.",
    'account.delete.noticeDisputes.many': "Tienes {count} disputas abiertas. Siguen en tu cuenta de Stripe: respóndelas a tiempo aunque elimines véltica.",
    'account.delete.dialogGrace': "Tus sitios saldrán de línea y tu membresía se cancelará ahora. Tendrás {days} días para restaurar tu cuenta iniciando sesión; después todo se borra para siempre.",
    'auth.deletionScheduled': "Programamos la eliminación de tu cuenta para el {date}. Si cambias de opinión, inicia sesión antes de esa fecha para restaurarla.",
    'account.restore.title': "Tu cuenta se eliminará el {date}",
    'account.restore.lead': "Tus proyectos, imágenes y datos siguen guardados hasta esa fecha. Si la restauras, todo vuelve, con tres cosas por hacer:",
    'account.restore.sites': "Tus sitios quedaron sin publicar: vuelve a publicarlos desde el editor.",
    'account.restore.domains': "Tus dominios quedaron desconectados y sin renovación automática: conéctalos de nuevo y enciéndela si quieres.",
    'account.restore.plan': "Tu membresía se canceló: estarás en el plan gratis hasta que elijas otro.",
    'account.restore.cta': "Restaurar mi cuenta",
    'account.restore.restoring': "Restaurando…",
    'account.restore.failed': "No pudimos restaurar tu cuenta. Inténtalo otra vez.",
    'account.restore.keepDeleting': "¿Prefieres que se elimine?",
    'account.restore.signOut': "Cerrar sesión",
    'account.delete.title': 'Eliminar cuenta',
    'account.delete.typeToConfirm': 'Escribe {word} para confirmar',
    'account.delete.word': 'ELIMINAR',
    'account.delete.codeSent': 'Te enviamos un código a {email}. Escríbelo para confirmar la eliminación.',
    'account.delete.code': 'Código de verificación',
    'account.delete.button': 'Eliminar mi cuenta',
    'account.delete.sending': 'Enviando…',
    'account.delete.deleting': 'Eliminando…',
    'account.delete.dialogAria': 'Confirmar eliminación de cuenta',
    'account.delete.dialogTitle': '¿Eliminar tu cuenta?',
    'account.delete.noProjects': 'No tienes proyectos, pero tu cuenta y datos asociados se eliminarán.',
    'account.profile.changePhoto': 'Cambiar foto',
    'account.email.newEmail': 'Nuevo correo',
    'account.email.newPlaceholder': 'nuevo@ejemplo.com',
    'account.email.back': 'Volver',
    'account.email.discard': 'Descartar',
    'account.email.enterCode': 'Ingresar código',
    'account.sessions.signOutAll': 'Cerrar en todos los dispositivos',
    'account.delete.sendCode': 'Enviar código',
    'account.delete.confirmAll': 'Sí, eliminar mi cuenta',
    'account.cancel': 'Cancelar',
    // ── Menú lateral del proyecto ─────────────────────────────────────────────
    /* Los rótulos del menú y los del migajero son DOS juegos, no uno.
       Arriba se lee «Inicio», que es a dónde vas; en el migajero se lee
       «Dashboard», que es dónde estás. Unificarlos ahorraría una docena de claves
       y haría que el camino de arriba contradijera al menú de la izquierda. */
    'nav.aria': 'Secciones de la empresa',
    'nav.home': 'Inicio',
    'nav.favorites': 'Favoritos',
    'nav.pin': 'Añadir {name} a favoritos',
    'nav.unpin': 'Quitar {name} de favoritos',
    'nav.contacts': 'Contactos',
    'nav.team': 'Equipo',
    'nav.config': 'Configuración',
    'nav.help': 'Ayuda',
    /* La insignia de una entrada que todavía no existe. Aparte de
       `nav.group.apps`, que hoy dice lo mismo: uno rotula una carpeta y el otro
       marca una fila, y el día que la carpeta se llame por su contenido no hay
       que ir a buscar cuál de los dos usos había que cambiar. */
    'nav.soon': 'Próximamente',
    'nav.configWarning.title': 'Hay ajustes pendientes',
    'nav.configWarning.policies': 'Políticas por redactar: {count}',
    'nav.configWarning.holes': 'Datos pendientes en tus políticas: {count}',
    'nav.configWarning.business': 'Datos del negocio pendientes: {count}',
    'nav.configWarning.openPolicies': 'Revisar políticas',
    'nav.configWarning.openBusiness': 'Completar información del negocio',
    'nav.configPending.one': 'Te falta 1 dato por rellenar',
    'nav.configPending.many': 'Te faltan {count} datos por rellenar',
    'nav.group.website': 'Sitio web',
    'nav.group.catalog': 'Catálogo',
    'nav.group.sales': 'Ventas',
    'nav.group.bookings': 'Reservas',
    'nav.group.analytics': 'Analíticas',
    'nav.group.apps': 'Próximamente',
    'nav.group.admin': 'Admin',
    'nav.pages': 'Páginas',
    'nav.cms': 'Contenido',
    'nav.forms': 'Formularios',
    'nav.payments': 'Todas las ofertas',
    'nav.digitalProducts': 'Productos digitales',
    'nav.physicalProducts': 'Productos físicos',
    'nav.services': 'Servicios',
    'nav.orders': 'Cobros',
    'nav.payouts': 'Depósitos',
    'nav.collections': 'Colecciones',
    'section.collections': 'Colecciones',
    'collections.title': 'Colecciones',
    'collections.subtitle': 'Agrupa tus ofertas: «Verano», «Ofertas», una marca. Cada una tiene su página y sirve para filtrar el catálogo.',
    'collections.new': 'Nueva colección',
    'collections.emptyTitle': 'Aún no tienes colecciones',
    'collections.emptyBody': 'Una colección agrupa ofertas con nombre, descripción e imagen. Elígelas a mano o deja que entren solas con reglas (por etiqueta, precio, marca…).',
    'collections.count': '{count} ofertas',
    'collections.saved': 'Colección guardada',
    'collections.remove': 'Borrar {title}',
    'collections.removeTitle': '¿Borrar «{title}»?',
    'collections.removeBody': 'Las ofertas no se borran: sólo dejan de estar agrupadas aquí.',
    'collections.removeConfirm': 'Borrar colección',
    'collections.openLink': 'Abrir en el sitio',
    'collections.copyLink': 'Copiar enlace',
    'collections.designPage': 'Diseñar su página',
    'collections.createdTitle': '«{title}» está lista',
    'collections.createdBody': 'Su página en el sitio usa la plantilla de colecciones. Ábrela en el editor para cambiar su diseño: vale para todas.',
    'collections.linkCopied': 'Enlace copiado.',
    'collections.linkCopyFailed': 'No se pudo copiar el enlace.',
    'collections.kind.manual': 'Manual',
    'collections.kind.manualHint': 'Eliges tú qué ofertas entran y en qué orden.',
    'collections.kind.auto': 'Automática',
    'collections.kind.autoHint': 'Entran solas las que cumplen tus condiciones, también las nuevas.',
    'collections.form.newTitle': 'Nueva colección',
    'collections.form.editTitle': 'Editar colección',
    'collections.form.lead': 'Su nombre, su imagen y qué ofertas entran.',
    'collections.form.close': 'Cerrar',
    'collections.form.image': 'Imagen',
    'collections.form.name': 'Nombre',
    'collections.form.namePlaceholder': 'Ej.: Colección de verano',
    'collections.form.description': 'Descripción',
    'collections.form.descriptionPlaceholder': 'Lo que verá arriba de sus productos.',
    'collections.form.type': 'Cómo se arma',
    'collections.form.conditions': 'Condiciones',
    'collections.form.matchLead': 'Las ofertas tienen que cumplir',
    'collections.match.all': 'todas las condiciones',
    'collections.match.any': 'cualquiera de las condiciones',
    'collections.form.valuePlaceholder': 'Valor',
    'collections.form.removeRule': 'Quitar condición',
    'collections.form.addRule': 'Agregar condición',
    'collections.form.picked': '{count} elegidas',
    'collections.form.draft': 'borrador',
    'collections.form.offers': 'Ofertas',
    'collections.form.search': 'Buscar ofertas…',
    'collections.form.noOffers': 'No hay ofertas que coincidan.',
    'collections.form.sort': 'Orden',
    'collections.form.previewCount': 'Entran {count} ofertas hoy',
    'collections.form.previewLoading': 'Calculando…',
    'collections.form.previewEmpty': 'Ninguna oferta cumple estas condiciones todavía.',
    'collections.form.inCollection': 'En la colección',
    'collections.form.footNeedName': 'Ponle un nombre para continuar',
    'collections.form.required': 'Obligatorio',
    'collections.form.optional': 'Opcional',
    'collections.form.needTitle': 'Ponle un nombre a la colección.',
    'collections.form.cancel': 'Cancelar',
    'collections.form.saving': 'Guardando…',
    'collections.form.save': 'Guardar',
    'collections.form.create': 'Crear colección',
    'collections.field.tag': 'Etiqueta',
    'collections.field.kind': 'Tipo',
    'collections.field.price': 'Precio',
    'collections.field.title': 'Título',
    'collections.field.stock': 'Disponibilidad',
    'collections.field.brand': 'Marca',
    'collections.op.is': 'es',
    'collections.op.isNot': 'no es',
    'collections.op.contains': 'contiene',
    'collections.op.notContains': 'no contiene',
    'collections.op.lt': 'menor que',
    'collections.op.gt': 'mayor que',
    'collections.opPrice.lt': 'es menor que',
    'collections.opPrice.gt': 'es mayor que',
    'collections.opPrice.is': 'es igual a',
    'collections.opPrice.isNot': 'no es igual a',
    'collections.opPrice.free': 'es gratis',
    'collections.opPrice.paid': 'es de pago',
    'collections.opStock.is': 'está disponible',
    'collections.opStock.isNot': 'está agotado',
    'collections.kindValue.products': 'Producto físico',
    'collections.kindValue.digital': 'Digital',
    'collections.kindValue.services': 'Servicio',
    'collections.kindValue.bookings': 'Reserva',
    'collections.sort.manual': 'El orden de la lista',
    'collections.sort.newest': 'Lo más nuevo primero',
    'collections.sort.bestselling': 'Más vendidos',
    'collections.sort.priceAsc': 'Precio: de menor a mayor',
    'collections.sort.priceDesc': 'Precio: de mayor a menor',
    'collections.sort.title': 'Alfabético',
    'offers.tags.title': 'Etiquetas',
    'offers.tags.titleWithBrand': 'Marca y etiquetas',
    'offers.brand.label': 'Marca',
    'offers.brand.placeholder': 'Busca o crea una marca',
    'offers.brand.create': 'Crear «{name}»',
    'offers.brand.empty': 'Todavía no hay marcas. Escribe una para crearla.',
    'offers.brand.allChosen': 'Ya elegiste la marca.',
    'offers.brand.limit': 'Una marca por oferta.',
    'offers.brand.remove': 'Quitar {name} de esta oferta',
    'offers.brand.deleteAria': 'Eliminar {name} de todas las ofertas',
    'offers.brand.deleteTitle': '¿Eliminar la marca «{name}»?',
    'offers.brand.deleteBody': 'Se quitará de {count} ofertas, también de las publicadas. Las ofertas no se borran.',
    'offers.brand.deleteBodyOne': 'Se quitará de 1 oferta, aunque esté publicada. La oferta no se borra.',
    'offers.brand.deleteConfirm': 'Eliminar marca',
    'offers.brand.deleted': 'Marca quitada de {count} ofertas.',
    'offers.brand.deletedOne': 'Marca quitada de 1 oferta.',
    'offers.brand.count': '{count} ofertas',
    'offers.brand.countOne': '1 oferta',
    'offers.tags.body': 'No se ven en el sitio: sirven para agrupar en colecciones automáticas.',
    'offers.tags.pickPlaceholder': 'Busca o crea una etiqueta',
    'offers.tags.empty': 'Todavía no hay etiquetas. Escribe una para crearla.',
    'offers.tags.allChosen': 'Ya elegiste todas las etiquetas.',
    'offers.tags.limit': 'Hasta {max} etiquetas por oferta.',
    'offers.tags.removeOne': 'Quitar {name} de esta oferta',
    'offers.tags.deleteAria': 'Eliminar {name} de todas las ofertas',
    'offers.tags.deleteTitle': '¿Eliminar la etiqueta «{name}»?',
    'offers.tags.deleteBody': 'Se quitará de {count} ofertas, también de las publicadas. Las ofertas no se borran.',
    'offers.tags.deleteBodyOne': 'Se quitará de 1 oferta, aunque esté publicada. La oferta no se borra.',
    'offers.tags.deleteConfirm': 'Eliminar etiqueta',
    'offers.tags.deleted': 'Etiqueta quitada de {count} ofertas.',
    'offers.tags.deletedOne': 'Etiqueta quitada de 1 oferta.',
    'nav.coupons': "Cupones",
    'nav.shipping': 'Envíos',
    'find.coupons': "Cupones",
    'find.shipping': 'Envíos',
    'orders.detail.coupon': "Cupón",
    'orders.detail.couponSaved': "Descontó {amount}",
    'coupons.title': "Cupones",
    'coupons.subtitle': "Códigos de descuento para tus ofertas y servicios. Se aplican en el checkout de tu sitio.",
    'coupons.loading': "Cargando cupones…",
    'coupons.loadFailed': "No se pudieron cargar los cupones.",
    'coupons.retry': "Reintentar",
    'coupons.new': "Nuevo cupón",
    'coupons.search': "Buscar por código o descripción",
    'nav.blog': "Blog",
    'section.blog': "Blog",
    'find.blog': "Blog",
    'blog.title': "Blog",
    'blog.nav': "Blog",
    'blog.readMore': "Leer más",
    'blog.indexPage': "Página del blog",
    'designs.gallery': "Galería",
    'designs.single.services': "Servicio",
    'designs.single.bookings': "Reserva",
    'designs.single.digital': "Producto",
    'designs.single.products': "Producto",
    'designs.single.memberships': "Membresía",
    'designs.single.collections': "Colección",
    'designs.single.blog': "Entrada",
    'designs.single.cms': "Entrada",
    'designs.apply': "Aplicar",
    'designs.collectionPage': 'Página de cada colección',
    'designs.inUse': "En uso",
    'designs.title': "Diseños de página",
    'designs.category': 'Tipo de contenido',
    'designs.chooseType': 'Elige un tipo de contenido para ver sus diseños',
    'designs.cardHint': "Catálogo, reservas y blog",
    'designs.change': "Cambiar diseño",
    'designs.applied': "Diseño aplicado.",
    'designs.rowTitle': "Diseño de las páginas",
    'contentPanel.addToPage': "Agregar a la página",
    'designs.footTitleBlog': "Diseño de las páginas del blog",
    'designs.footTitle': "Diseño de las páginas de la tienda",
    'designs.footList.blog': "Página del blog",
    'designs.footItem.blog': "Página de cada entrada",
    'designs.footList': "Página de la lista",
    'designs.footItem': "Página de cada oferta",
    'designs.footTitleCms': "Diseño de las páginas de «{name}»",
    'designs.footList.cms': "Página de la lista",
    'designs.footItem.cms': "Página de cada entrada",
    'designs.rowHint': "Cambia la lista y la página de cada oferta.",
    'designs.rowHintBlog': "Cambia la página del blog y la de cada entrada.",
    'designs.list.services': "Página de servicios",
    'designs.list.digital': "Página de productos digitales",
    'designs.list.products': "Página de la tienda",
    'designs.list.bookings': "Página de reservas",
    'designs.item.services': "Página de cada servicio",
    'designs.item.digital': "Página de cada producto digital",
    'designs.item.products': "Página de cada producto",
    'designs.item.bookings': "Página de cada reserva",
    'designs.d.list-grid.name': "Rejilla",
    'designs.d.list-grid.desc': "El título y las ofertas en tres columnas.",
    'designs.d.list-cover.name': 'Portada + rejilla',
    'designs.d.blog-cover.desc': 'Una portada con la foto de la entrada más reciente, blur suave, título y descripción; debajo, las entradas en tres columnas.',
    'designs.d.blog-article.name': "Artículo",
    'designs.d.blog-article.desc': "El diseño de partida: ruta, título, entradilla, autor con fecha y tiempo de lectura, portada, el texto y, al final, compartir y el perfil del autor.",
    'designs.d.blog-sidebar.name': 'Lista + barra lateral',
    'designs.d.blog-sidebar.desc': 'Filtros arriba; las entradas en dos columnas y, al lado, una barra con acerca del blog, temas, recientes y autores.',
    'blog.design.filters': 'Barra de filtros',
    'blog.design.cover': "Portada",
    'blog.design.coverInfo': "Una portada arriba con la foto de la entrada más reciente, un poco desenfocada, y el título del blog encima.",
    'blog.design.sidebar': "Barra lateral",
    'blog.design.sidebarInfo': "Temas, lo más leído, autores y boletín al lado de las entradas.",
    'blog.design.side.left': "Izquierda",
    'blog.design.side.right': "Derecha",
    'blog.design.side.off': "Sin barra",
    'blog.design.design': "Diseño",
    'blog.design.designHintIndex': "Cómo se ve la página con todas las entradas",
    'blog.design.designHintPost': "Cómo se ve cada entrada",
    'blog.design.designsIndex': "Diseños de la página del blog",
    'blog.design.designsPost': "Diseños de la entrada",
    'blog.design.manage': "Gestionar entradas en el dashboard",
    'catalogPage.designHintIndex': "Cómo se ve la página con todas",
    'catalogPage.designHintItem': "Cómo se ve la página de cada una",
    'catalogPage.manage': "Gestionar ofertas en el dashboard",
    'catalogPage.noPage': "Esta página todavía no existe. Elige un diseño para crearla.",
    'catalogPage.filtersInfo': "Buscador y filtros de tipo y precio arriba de la lista.",
    'catalogPage.coverInfo': "Una portada arriba con la foto de la más reciente, un poco desenfocada, y el título de la página encima.",
    'catalogPage.sidebarInfo': "Un texto corto y, si el sitio tiene página de contacto, un botón a ella, al lado de la lista.",
    'catalogPage.sidebarText': "¿No sabes cuál elegir? Escríbenos y te ayudamos.",
    'cmsPage.designHintIndex': "Cómo se ve la página con todas las fichas",
    'cmsPage.designHintItem': "Cómo se ve la página de cada ficha",
    'cmsPage.manage': "Gestionar contenido en el CMS",
    'cmsPage.designsIndex': "Diseños de la página de la colección",
    'cmsPage.designsItem': "Diseños de la ficha",
    'cmsPage.coverInfo': "Una portada arriba con la foto de la ficha más reciente, un poco desenfocada, y el nombre de la colección encima.",
    'itemPiece.breadcrumb': "Ruta",
    'itemPiece.breadcrumb.info': "Inicio › Sección › esta página, arriba del título.",
    'itemPiece.toc': "Índice",
    'itemPiece.toc.info': "Los títulos del artículo como enlaces, arriba del texto.",
    'itemPiece.authorProfile': "Autor",
    'itemPiece.authorProfile.info': "El autor con foto y descripción, después del texto.",
    'itemPiece.share': "Compartir",
    'itemPiece.share.info': "Botones para compartir la página, después del texto.",
    'itemPiece.adjacent': "Anterior / siguiente",
    'itemPiece.adjacent.info': "Enlaces a la anterior y a la siguiente, después del texto.",
    'itemPiece.related': "Relacionadas",
    'itemPiece.related.info': "Otras parecidas, en su propia sección al final de la página.",
    /* El texto de la portada del blog al encenderla (lo lee quien visita). */
    'blogPage.coverSubtitle': "Ideas, historias y novedades para descubrir.",
    'blog.design.filtersBody': 'Buscar, tema, autor y orden encima de las entradas.',
    'designs.d.list-cover.desc': 'Una portada con la foto de la oferta más reciente de esta categoría, blur suave, título y descripción; debajo, una rejilla de tres columnas.',
    'designs.d.list-wide.name': "Dos columnas",
    'designs.d.list-wide.desc': "El título al centro y tarjetas más grandes, de dos en dos.",
    'designs.d.list-rows.name': "Filas",
    'designs.d.list-rows.desc': "Una oferta por fila: la foto a un lado y el texto al otro.",
    'designs.d.list-split.name': "Título a un lado",
    'designs.d.list-split.desc': "El título fijo a la izquierda y las ofertas a la derecha.",
    'designs.d.item-split.name': "Clásico",
    'designs.d.item-split.desc': "Las fotos a un lado; el texto y la compra al otro.",
    'designs.d.item-calendar.name': "Agenda primero",
    'designs.d.item-calendar.desc': "El nombre y la descripción arriba, y el calendario a lo ancho.",
    'designs.d.item-hero.name': "Portada",
    'designs.d.item-hero.desc': "La foto de fondo, la galería debajo de la descripción y la compra a un lado.",
    'designs.d.item-sidebar.name': "Compra a un lado",
    'designs.d.item-scroll-gallery.name': "Galería vertical y compra fija",
    'designs.d.item-scroll-gallery.desc': "Fotos a la izquierda al hacer scroll, compra fija a la derecha y detalles desplegables con +.",
    'designs.d.item-sidebar.desc': "Una galería amplia con una tarjeta de compra flotante a su lado.",
    'designs.d.item-booking-below.name': "Calendario abajo",
    'designs.d.item-booking-below.desc': "Fotos y texto arriba con «Ver horarios»; el calendario, en su propia sección.",
    'designs.d.item-booking-steps.name': "Paso a paso",
    'designs.d.item-booking-steps.desc': "Portada con la foto, «Cómo funciona» en tres pasos y el calendario al final.",
    'designs.d.item-variants.name': "Variantes a la vista",
    'designs.d.item-variants.desc': "Fotos y texto arriba; debajo, las opciones (tallas, colores) y la compra.",
    'designs.d.item-showcase.name': "Escaparate",
    'designs.d.item-showcase.desc': "Las fotos a lo ancho primero; debajo, el texto y la compra.",
    'designs.d.item-gallery-section.name': "Galería aparte",
    'designs.d.item-gallery-section.desc': "Portada debajo del título y compra arriba; las demás fotos, en una galería aparte.",
    'designs.d.item-booking-details.name': 'Detalles primero',
    'designs.d.item-booking-details.desc': 'Resumen del servicio junto a las fotos, detalles debajo y reserva al final.',
    'designs.d.item-minimal.name': "Mínimo",
    'designs.d.item-minimal.desc': "Una columna sin fotos: el texto y el botón.",
    'blog.design.postGroup': "Entrada",
    'blog.design.indexGroup': "Página del blog",
    'blog.design.appliedIndex': "Diseño aplicado a la página del blog. Puedes deshacerlo.",
    'blog.design.change': "Diseño del blog",
    'blog.design.applied': "Diseño aplicado a la plantilla de entrada. Puedes deshacerlo.",
    'blog.design.empty': "Todavía no hay diseños de blog en la biblioteca.",
    'blog.design.loadFailed': "No se pudieron cargar los diseños.",
    'blog.template': "Plantilla de entrada",
    'blog.posts': "Entradas",
    'blog.edit': "Editar",
    'blog.editWith': "Editar la plantilla viéndola con esta entrada",
    'blog.noPostsYet': "Todavía no hay entradas.",
    'blog.viewOnSite': "Ver el blog en el sitio",
    'blog.subtitle': "Escribe entradas para tu sitio. Se publican al guardarlas, sin volver a publicar el sitio.",
    'blog.new': "Nueva entrada",
    'blog.loading': "Cargando el blog",
    'blog.loadFailed': "No se pudo cargar el blog.",
    'blog.retry': "Reintentar",
    'blog.search': "Buscar por título, dirección o categoría",
    'blog.empty.title': "Todavía no hay entradas",
    'blog.empty.body': "Escribe la primera: una novedad, una guía o la historia de tu negocio.",
    'blog.noResults': "Ninguna entrada coincide.",
    'blog.clearSearch': "Ver todas",
    'blog.filter.aria': "Filtros de las entradas",
    'blog.filter.all': "Todas",
    'blog.authors.button': "Autores",
    'blog.authors.title': "Autores del blog",
    'blog.authors.lead': "Foto, biografía y enlaces de quien escribe. Salen en el sitio junto a sus entradas.",
    'blog.authors.editNamed': "Editar a {name}",
    'blog.authors.editLead': "Lo que se ve en su ficha y en su página del blog.",
    'blog.authors.back': "Volver a los autores",
    'blog.authors.photo': "Foto",
    'blog.authors.addPhoto': "Poner foto",
    'blog.authors.changePhoto': "Cambiar foto",
    'blog.authors.removePhoto': "Quitar foto",
    'blog.authors.bio': "Biografía",
    'blog.authors.bioPlaceholder': "Dos o tres líneas sobre quién es y de qué escribe.",
    'blog.authors.links': "Enlaces",
    'blog.authors.linkLabel': "Nombre (Instagram…)",
    'blog.authors.linkUrl': "https://",
    'blog.authors.newPlaceholder': "Nombre del autor",
    'blog.authors.emptyTitle': "Todavía no hay autores",
    'blog.authors.none': "Crea a quien escribe para darle foto, biografía y su propia página.",
    'blog.authors.add': "Nuevo autor",
    'blog.authors.newTitle': "Nuevo autor",
    'blog.authors.name': "Nombre",
    'blog.authors.delete': "Eliminar autor",
    'blog.authors.profileDeleteTitle': "¿Eliminar a {name}?",
    'blog.authors.profileDeleteBody': "Se borra su perfil y su firma de {count} entradas. Las entradas no se borran.",
    'blog.authors.deleteBodyNone': "Se borra su perfil. No firma ninguna entrada.",
    'blog.authors.profileDeleted': "Autor eliminado",
    'blog.authors.addLink': "Agregar enlace",
    'blog.authors.removeLink': "Quitar enlace",
    'blog.authors.saved': "Autor guardado",
    'blog.authors.loading': "Cargando…",
    'blog.authors.posts': "{count} entradas",
    'blog.authors.postsOne': "1 entrada",
    'blog.filter.button': "Filtros",
    'blog.filter.title': "Filtrar entradas",
    'blog.filter.close': "Cerrar filtros",
    'blog.filter.status': "Estado",
    'blog.filter.category': "Categoría",
    'blog.filter.reset': "Restablecer filtros",
    'blog.newShort': "Nueva",
    'usage.stat.blogPosts': "Entradas publicadas",
    'blog.state.draft': "Borrador",
    'blog.state.scheduled': "Programada",
    'blog.state.published': "Publicada",
    'blog.col.title': "Entrada",
    'blog.col.status': "Estado",
    'blog.col.date': "Fecha",
    'blog.col.actions': "Acciones",
    'blog.date.published': "Publicada el {date}",
    'blog.date.scheduled': "Sale el {date}",
    'blog.date.edited': "Editada el {date}",
    'blog.untitled': "Sin título",
    'blog.moreOptions': "Más opciones de la entrada",
    'blog.options': "Opciones",
    'blog.open': "Abrir",
    'blog.menu.edit': "Editar",
    'blog.menu.publish': "Publicar",
    'blog.menu.toDraft': "Pasar a borrador",
    'blog.menu.delete': "Eliminar",
    'blog.delete.title': "¿Eliminar «{title}»?",
    'blog.delete.body': "La entrada desaparece del sitio y no se puede recuperar.",
    'blog.delete.confirm': "Eliminar",
    'blog.toast.deleted': "Entrada eliminada.",
    'blog.toast.published': "Entrada publicada.",
    'blog.toast.scheduled': "Entrada programada para el {date}.",
    'blog.toast.saved': "Cambios guardados.",
    'blog.toast.draft': "La entrada pasó a borrador.",
    'blog.back': "Blog",
    'blog.editor.loadFailed': "No se pudo abrir la entrada.",
    'blog.editor.titlePlaceholder': "Título de la entrada",
    'blog.editor.addCover': "Añadir portada",
    'blog.editor.changeCover': "Cambiar",
    'blog.editor.removeCover': "Quitar",
    'blog.editor.publish': "Publicar",
    'blog.editor.schedule': "Programar",
    'blog.editor.unpublish': "Pasar a borrador",
    'blog.editor.delete': "Eliminar entrada",
    'blog.field.slug': "Dirección",
    'blog.field.slugHint': "Ya está publicada: si cambias la dirección, los enlaces que se compartieron dejan de funcionar.",
    'blog.link.copy': "Copiar enlace",
    'blog.link.copied': "Enlace copiado",
    'blog.link.open': "Ver en el sitio",
    'blog.link.copyFailed': "No se pudo copiar el enlace.",
    'blog.link.needSite': "Publica el sitio para que la entrada tenga enlace.",
    'blog.link.liveAfterPublish': "Es un borrador: el enlace funcionará en cuanto publiques la entrada.",
    'blog.link.liveScheduled': "Programada: el enlace funcionará desde la fecha de publicación.",
    'blog.address.body': "Dónde se lee la entrada en tu sitio. Si la cambias después de compartirla, el enlace viejo deja de funcionar.",
    'blog.field.excerpt': "Extracto",
    'blog.field.excerptHint': "Se ve en las listas del blog y al compartir la entrada.",
    'blog.field.categories': "Categorías",
    'blog.field.removeCategory': "Quitar {name}",
    'blog.categories.placeholder': "Busca o crea una categoría",
    'blog.categories.create': "Crear «{name}»",
    'blog.categories.count': "{count} entradas",
    'blog.categories.countOne': "1 entrada",
    'blog.categories.empty': "Todavía no hay categorías. Escribe una para crearla.",
    'blog.categories.allChosen': "Esta entrada ya tiene todas las categorías.",
    'blog.categories.limit': "Máximo {max} categorías por entrada.",
    'blog.categories.deleteAria': "Eliminar la categoría {name} de todo el blog",
    'blog.categories.deleteTitle': "¿Eliminar la categoría «{name}»?",
    'blog.categories.deleteBody': "Se quitará de las {count} entradas que la usan, también de las publicadas. Las entradas no se borran.",
    'blog.categories.deleteBodyOne': "Se quitará de la entrada que la usa, aunque esté publicada. La entrada no se borra.",
    'blog.categories.deleteConfirm': "Eliminar categoría",
    'blog.categories.deleted': "Categoría eliminada de {count} entradas.",
    'blog.categories.deletedOne': "Categoría eliminada de 1 entrada.",
    'blog.authors.placeholder': "Busca o crea un autor",
    'blog.authors.create': "Crear «{name}»",
    'blog.authors.limit': "Hasta {max} autores por entrada.",
    'blog.authors.allChosen': "Ya seleccionaste todos los autores.",
    'blog.authors.empty': "Todavía no hay autores. Escribe un nombre para crearlo.",
    'blog.authors.remove': "Quitar a {name} de esta entrada",
    'blog.authors.deleteAria': "Eliminar a {name} de todo el blog",
    'blog.authors.deleteTitle': "¿Eliminar al autor «{name}»?",
    'blog.authors.deleteBody': "Se quitará su firma de {count} entradas, también las publicadas. Los demás autores se conservan. Las entradas no se borran.",
    'blog.authors.deleteBodyOne': "Se quitará su firma de la entrada, aunque esté publicada. Los demás autores se conservan. La entrada no se borra.",
    'blog.authors.deleteConfirm': "Eliminar autor",
    'blog.authors.deleted': "Autor quitado de {count} entradas.",
    'blog.authors.deletedOne': "Autor quitado de 1 entrada.",
    'blog.field.author': "Autores",
    'blog.field.date': "Fecha de publicación",
    'blog.field.coverAlt': "Descripción de la portada",
    'blog.seo.title': "Buscadores y redes",
    'blog.seo.metaTitle': "Título",
    'blog.seo.metaDescription': "Descripción",
    'blog.seo.image': "Imagen al compartir",
    'blog.seo.imageDefault': "Si no eliges una, se usa la portada.",
    'blog.seo.pick': "Elegir imagen",
    'blog.editor.kind': "Entrada del blog",
    'blog.seo.preview': "Así se ve en Google",
    'blog.seo.previewEmpty': "Escribe un extracto o una descripción.",
    'blog.editor.excerptPlaceholder': "Añade un subtítulo o un resumen breve",
    'blog.editor.noAuthor': "Sin autor",
    'blog.field.dateNow': "Al publicar",
    'blog.field.time': "Hora de publicación",
    'blog.field.dateClear': "Quitar",
    'blog.field.dateFuture': "Sale sola ese día, a esa hora.",
    'blog.tab.aria': "Partes de la entrada",
    'blog.tab.write': "Escribir",
    'blog.seo.searchTitle': "Buscadores",
    'blog.seo.searchBody': "Lo que Google enseña de esta entrada. Vacío usa el título y el extracto.",
    'blog.seo.shareTitle': "Al compartir",
    'blog.seo.shareBody': "Lo que se ve al pegar el enlace en WhatsApp, Instagram o un correo.",
    'blog.seo.customImage': "Imagen propia para compartir.",
    'blog.seo.useCover': "Volver a la portada",
    'coupons.empty.title': "Todavía no hay cupones",
    'coupons.empty.body': "Crea un código de descuento y compártelo. Tus clientes lo escriben al pagar, o lo reciben ya aplicado con un enlace.",
    'coupons.noResults': "Ningún cupón coincide con la búsqueda",
    'coupons.clearSearch': "Limpiar búsqueda",
    'coupons.col.code': "Código",
    'coupons.col.discount': "Descuento",
    'coupons.col.appliesTo': "Aplica a",
    'coupons.col.uses': "Usos",
    'coupons.col.status': "Estado",
    'coupons.col.expires': "Vence",
    'coupons.col.actions': "Acciones",
    'coupons.appliesAll': "Todas las ofertas",
    'coupons.appliesOne': "1 oferta",
    'coupons.appliesMany': "{count} ofertas",
    'coupons.off': "{amount} de descuento",
    'coupons.duration.forever': "Todos los cobros",
    'coupons.duration.months': "Durante {count} meses",
    'coupons.minimumShort': "Compra mínima {amount}",
    'coupons.usesTitle': "Ventas con este cupón: {revenue} · Descontado: {discount}",
    'coupons.usesOne': "1 uso",
    'coupons.usesMany': "{count} usos",
    'coupons.usesLimitOne': "{uses} / {max} uso",
    'coupons.usesLimitMany': "{uses} / {max} usos",
    'coupons.noExpiry': "Sin fecha",
    'coupons.status.active': "Activo",
    'coupons.status.inactive': "Pausado",
    'coupons.status.expired': "Vencido",
    'coupons.status.exhausted': "Agotado",
    'coupons.toggleAria': "Activar o pausar {code}",
    'coupons.moreOptions': "Más opciones del cupón",
    'coupons.copyCodeAria': 'Copiar el código {code}',
    'coupons.options': "Opciones",
    'coupons.menu.edit': "Editar",
    'coupons.menu.copyCode': "Copiar código",
    'coupons.menu.copyLink': "Copiar enlace con el cupón",
    'coupons.menu.pause': "Pausar",
    'coupons.menu.resume': "Activar",
    'coupons.menu.delete': "Eliminar",
    'coupons.toast.created': "Cupón {code} creado",
    'coupons.toast.saved': "Cupón guardado",
    'coupons.toast.deleted': "Cupón eliminado",
    'coupons.toast.paused': "Cupón pausado",
    'coupons.toast.resumed': "Cupón activado",
    'coupons.toast.codeCopied': "Código copiado",
    'coupons.toast.linkCopied': "Enlace copiado",
    'coupons.delete.title': "¿Eliminar el cupón {code}?",
    'coupons.delete.body': "Dejará de funcionar en el checkout al momento. Las ventas que ya se hicieron con él conservan el código y el descuento.",
    'coupons.delete.confirm': "Eliminar cupón",
    'coupons.form.newTitle': "Nuevo cupón",
    'coupons.form.editTitle': "Editar cupón",
    'coupons.form.lead': "Stripe valida el código y aplica el descuento al pagar.",
    'coupons.form.close': "Cerrar",
    'coupons.form.code': "Código",
    'coupons.form.codePlaceholder': 'VERANO20',
    'coupons.form.generate': "Generar",
    'coupons.form.codeHint': "Lo que escribe el cliente. Letras, números y guiones; de 3 a 40 caracteres, sin espacios.",
    'coupons.form.description': "Nota interna (opcional)",
    'coupons.form.descriptionPlaceholder': "Campaña de verano, influencer, clientes frecuentes…",
    'coupons.form.discount': "Descuento",
    'coupons.form.percent': "Porcentaje",
    'coupons.form.amount': "Importe fijo",
    'coupons.form.appliesTo': "Aplica a",
    'coupons.form.allOffers': "Todas las ofertas",
    'coupons.form.someOffers': "Ofertas específicas",
    'coupons.form.allOffersHint': "Vale para cualquier oferta o servicio con pago en línea, incluidos los que crees después.",
    'coupons.form.searchOffers': "Buscar oferta",
    'coupons.form.selectedCount': "{count} elegidas",
    'coupons.form.noOffers': "Todavía no tienes ofertas.",
    'coupons.form.noOfferMatches': "Ninguna oferta coincide.",
    'coupons.form.untitled': "Sin título",
    'coupons.form.kindService': "Servicio",
    'coupons.form.kindDigital': "Producto digital",
    'coupons.form.kindOffer': "Oferta",
    'coupons.form.draft': "Borrador",
    'coupons.form.archived': "Archivada",
    'coupons.form.duration': "En suscripciones",
    'coupons.form.durationHint': "Cuántos cobros lleva el descuento cuando lo que se compra se paga cada mes o cada año.",
    'coupons.form.duration.once': "Sólo el primer cobro",
    'coupons.form.duration.repeating': "Varios meses",
    'coupons.form.duration.forever': "Todos los cobros",
    'coupons.form.months': "meses",
    'coupons.form.limits': "Límites",
    'coupons.form.limitUses': "Limitar el número de usos",
    'coupons.form.uses': "usos en total",
    'coupons.form.limitDate': "Poner fecha de vencimiento",
    'coupons.form.limitMinimum': "Exigir una compra mínima",
    'coupons.form.active': "Activo",
    'coupons.form.activeHint': "Pausado no se acepta en el checkout, pero conserva su configuración.",
    'coupons.form.combinesWithMember': "Combinar con el descuento de miembro",
    'coupons.form.combinesOn': "Se suma al descuento de miembro: un miembro recibe los dos.",
    'coupons.form.combinesOff': "No se suma: a un miembro se le aplica el que más ahorre, el cupón o su descuento.",
    'coupons.form.shareLink': "Enlace con el cupón aplicado",
    'coupons.form.copy': "Copiar",
    'coupons.form.editWarning': "Ya se usó {count} veces. Cambiar el descuento no afecta a esas compras ni a las suscripciones que ya lo tienen.",
    'coupons.form.errorCode': "El código necesita de 3 a 40 letras, números o guiones (sin espacios ni otros símbolos).",
    'coupons.form.errorPercent': "El porcentaje tiene que ser un número entero entre 1 y 100.",
    'coupons.form.errorAmount': "Escribe el importe del descuento.",
    'coupons.form.errorOffers': "Elige al menos una oferta, o aplícalo a todas.",
    'coupons.form.errorMonths': "Los meses tienen que ser entre 1 y 36.",
    'coupons.form.errorUses': "El límite de usos tiene que ser al menos 1.",
    'coupons.form.errorDate': "La fecha de vencimiento tiene que ser futura.",
    'coupons.form.errorMinimum': "Escribe el importe de la compra mínima.",
    'coupons.form.cancel': "Cancelar",
    'coupons.form.save': "Guardar cambios",
    'coupons.form.create': "Crear cupón",
    'coupons.form.saving': "Guardando…",
    'nav.bookings': 'Reservas',
    'nav.bookingsCalendar': 'Citas',
    'nav.activeAppointments': 'Citas activas: {count}',
    'nav.newItems': 'Hay elementos nuevos',
    'nav.analytics': 'Visitas',
    'nav.salesAnalytics': 'Ventas',
    'nav.bookingsAnalytics': 'Reservas',
    'nav.emails': 'Inbox',
    'nav.emailMarketing': 'Marketing',
    'nav.courses': 'Cursos',
    'nav.users': 'Usuarios',
    'nav.authCodes': 'Códigos',
    'nav.siteTemplates': 'Templates',
    'nav.templates': 'Bloques',
    'nav.images': 'Imágenes',
    // ── Migajero: cómo se llama cada pantalla ─────────────────────────────────
    /* El nombre largo de la sección, el que se lee en la barra de arriba. No
       coincide siempre con el del menú y no debe: en la carpeta Reservas la
       entrada se llama «Servicios» porque la carpeta ya dice de qué van, pero el
       camino de arriba tiene que sostenerse solo. */
    'section.overview': 'Dashboard',
    'section.contacts': 'Contactos',
    'section.pages': 'Páginas',
    'section.cms': 'CMS',
    'section.analytics': 'Analíticas',
    'section.forms': 'Formularios',
    'section.emails': 'Inbox',
    'section.bookings': 'Servicios con agenda',
    'section.bookingsCalendar': 'Citas',
    'section.bookingsList': 'Citas',
    'section.business': 'Información del negocio',
    'section.region': 'Región y moneda',
    'section.policies': 'Políticas',
    'section.emailMarketing': 'Marketing',
    'section.courses': 'Cursos',
    'section.payments': 'Todas las ofertas',
    'section.digitalProducts': 'Productos digitales',
    'section.physicalProducts': 'Productos físicos',
    'section.services': 'Servicios',
    'section.orders': 'Cobros',
    'section.coupons': 'Cupones',
    'section.shipping': 'Envíos',
    'shipping.title': 'Envíos',
    'shipping.subtitle': 'Tus pedidos con envío y cómo llegan: formas de envío, países y existencias.',
    'shipping.tab.orders': 'Pedidos',
    'shipping.tab.settings': 'Ajustes',
    'shipping.orders.emptyTitle': 'Todavía no hay pedidos con envío',
    'shipping.orders.emptyBody': 'Cuando alguien compre un producto físico, el pedido aparece aquí para que lo prepares y lo envíes.',
    'shipping.loadFailed': 'No se pudieron cargar los envíos',
    'shipping.loading': 'Cargando envíos…',
    'shipping.rates.title': 'Formas de envío',
    'shipping.rates.note': 'Las que el comprador elige al pagar. Valen para todos tus productos físicos.',
    'shipping.countries.title': 'Países a los que envías',
    'shipping.countries.note': 'Al pagar sólo se aceptan direcciones de estos países.',
    'shipping.countries.removeAria': 'Quitar {name}',
    'shipping.countries.add': 'Añadir país',
    'shipping.stock.title': 'Existencias',
    'shipping.stock.note': 'Cada venta descuenta una unidad del producto, si le pusiste existencias.',
    'shipping.stock.restock': 'Devolver la unidad al reembolsar',
    'shipping.stock.restockHint': 'Si reembolsas un pedido completo, la unidad vuelve a estar disponible.',
    'shipping.rate.pickupNoAddress': 'Recoger en el negocio',
    'shipping.rate.free': 'Gratis',
    'shipping.rate.freeOver': '{price} · gratis desde {over}',
    'shipping.rate.defaultName': 'Envío estándar',
    'shipping.rate.pickupName': 'Recoger en tienda',
    'shipping.rate.nameRequired': 'Ponle un nombre: es lo que ve el comprador al pagar.',
    'shipping.rate.kind': 'Tipo de envío',
    'shipping.rate.flat': 'Envío',
    'shipping.rate.pickup': 'Recoger',
    'shipping.rate.name': 'Nombre',
    'shipping.rate.nameHint': 'Así aparece al pagar, p. ej. «Estándar (3–5 días)».',
    'shipping.rate.amount': 'Costo',
    'shipping.rate.amountHint': 'Déjalo en cero para envío gratis.',
    'shipping.rate.freeOverLabel': 'Gratis desde',
    'shipping.rate.freeOverHint': 'Déjalo vacío si no habrá un mínimo. Desde este total, el envío es gratis.',
    'shipping.rate.pickupAddress': 'Dónde se recoge',
    'shipping.rate.pickupPlaceholder': 'Calle, número, colonia y horario',
    'shipping.rate.pickupHint': 'Va en el correo que avisa que el pedido está listo.',
    'shipping.rate.add': 'Añadir',
    'shipping.rate.save': 'Guardar',
    'shipping.rate.activeAria': 'Ofrecer {name} al pagar',
    'shipping.rate.turnOff': 'Dejar de ofrecerla',
    'shipping.rate.turnOn': 'Ofrecerla al pagar',
    'shipping.rate.editAria': 'Editar {name}',
    'shipping.rate.edit': 'Editar',
    'shipping.rate.removeAria': 'Eliminar {name}',
    'shipping.rate.remove': 'Eliminar',
    'shipping.rate.addTitle': 'Añadir forma de envío',
    'shipping.rate.full': 'Ya tienes {max} formas de envío, el máximo que admite el pago.',
    'section.payouts': 'Depósitos',
    'section.salesAnalytics': 'Analíticas de ventas',
    'section.bookingsAnalytics': 'Analíticas de reservas',
    'section.team': 'Equipo',
    'section.config': 'Configuración',
    'section.brand': 'Estilo',
    'section.general': 'Configuración del sitio',
    'section.publish': 'Dominio',
    'section.usage': 'Uso y límites',
    'section.backups': 'Copias de seguridad',
    'section.transfer': 'Transferir el sitio',
    'section.stripe': 'Stripe',
    'section.googleAnalytics': 'Google Analytics',
    'section.omnisend': 'Omnisend',
    'section.calendars': 'Calendarios',
    'config.desc.calendars': 'Google Calendar, Outlook y Apple: tus citas en tu calendario y tus ocupados fuera de la agenda.',
    'calset.description': 'Conecta el calendario que ya usas. Se configura por persona del equipo, igual que desde Reservas.',
    'calset.checking': 'Revisando…',
    'calset.checkingBody': 'Un momento.',
    'calset.failed': 'No se pudo cargar',
    'calset.failedBody': 'Vuelve a intentarlo en un momento.',
    'calset.retry': 'Reintentar',
    'calset.noServices': 'Primero, un servicio con cita',
    'calset.noServicesBody': 'Sincronizar sirve para las citas de Reservas. Crea un servicio con horario y vuelve aquí.',
    'calset.createService': 'Ir a Reservas',
    'calset.connected': 'Calendarios conectados',
    'calset.connectedBody': 'Tus citas y tus horas ocupadas se sincronizan solas.',
    'calset.notConnected': 'Sin calendarios conectados',
    'calset.emptyBody': 'Conecta Google Calendar, Outlook o Apple para ver tus citas ahí y que no se reserven las horas en que ya estás ocupado.',
    'calset.statusOk': 'Activo',
    'calset.google': 'Google Calendar · {email}',
    'calset.feed': 'Calendario externo · {name}',
    'calset.export': 'Tus citas, publicadas para tu calendario',
    'calset.providers': 'Calendarios que se pueden conectar',
    'calset.apple': 'Apple (iCloud)',
    'calset.google.name': 'Google Calendar',
    'calset.outlook': 'Outlook',
    'calset.manage': 'Administrar',
    'calset.connect': 'Conectar un calendario',
    'calset.whatTitle': 'Qué hace',
    'calset.what1': 'Cada cita nueva aparece en tu calendario, con la hora y el cliente.',
    'calset.what2': 'Lo que ya tienes ocupado en tu calendario deja de ofrecerse en la página de reservas.',
    'calset.what3': 'Va por persona: cada quien del equipo conecta el suyo.',
    'section.openTable': 'OpenTable',
    'config.desc.openTable': 'Conecta tu restaurante y todos los widgets de reservas del sitio lo usarán.',
    'otset.description': 'Conecta tu restaurante una vez y todos los widgets y botones de OpenTable del sitio usarán ese ID.',
    'otset.checking': 'Comprobando…',
    'otset.checkingBody': 'Leyendo los ajustes del sitio.',
    'otset.connected': 'OpenTable conectado',
    'otset.connectedBody': 'Tu restaurante ({id}) está en todos los widgets de OpenTable del sitio. En el editor el ID sale bloqueado.',
    'otset.notConnected': 'Sin conectar',
    'otset.emptyBody': 'Escribe el ID de tu restaurante. Si ya tienes widgets de OpenTable en tus páginas, pasarán a usar éste.',
    'otset.statusOk': 'Conectado',
    'otset.idLabel': 'ID de tu restaurante',
    'otset.changeId': 'Cambiar el ID',
    'otset.placeholder': 'Ej. 1434817, o pega el código del widget',
    'otset.detected': 'ID detectado: {id}.',
    'otset.notDetected': 'No encontramos un ID en lo que pegaste.',
    'otset.where': 'Está en tu cuenta de OpenTable, en el widget de reservaciones.',
    'otset.openGuestCenter': 'Abrir Guest Center',
    'otset.connect': 'Conectar',
    'otset.saveNew': 'Guardar el nuevo ID',
    'otset.disconnect': 'Desconectar',
    'otset.confirmDisconnect': 'Sí, desconectar',
    'otset.cancel': 'Cancelar',
    'otset.disconnectNote': 'Los widgets que ya tienes no se borran: vuelven a usar el ID que tenía cada uno, o te piden uno.',
    'otset.saveFailed': 'No se pudo guardar. Inténtalo de nuevo.',
    'otset.adminOnly': 'Sólo quien administra el proyecto puede cambiarlo.',
    'otset.whatTitle': 'Qué hace conectarlo',
    'otset.what1': 'Los widgets de OpenTable que agregues en el editor salen ya con tu restaurante.',
    'otset.what2': 'Los que ya tienes pasan a usar este ID, sin tocarlos uno por uno.',
    'otset.what3': 'El acceso «OpenTable» de los botones (por ejemplo, el botón principal de la barra) lo trae escrito.',
    /* Las pantallas que no cuelgan de un proyecto: están por encima de todos
       ellos y se abren desde el menú de usuario o desde Admin. */
    'global.settings': 'Usuario',
    'global.billing': 'Facturación',
    'global.domains': 'Dominios',
    'global.authCodes': 'Códigos',
    'global.plans': 'Planes',
    'global.usage': 'Uso de la cuenta',
    'global.siteTemplates': 'Templates',
    'global.templates': 'Bloques',
    'global.images': 'Imágenes',
    'global.users': 'Usuarios',
    // ── Marco del proyecto: avisos que no son de ninguna sección ──────────────
    'workspace.saveFailed': 'No pudimos guardar los últimos cambios. Recarga antes de seguir editando.',
    'workspace.pagesSaveFailed': 'No pudimos guardar los últimos cambios en tus páginas. Recarga antes de seguir.',
    'workspace.pageLimit': 'Alcanzaste el límite de páginas de tu plan.',
    'workspace.pageDuplicated': 'Página duplicada',
    'workspace.renamePrompt': 'Nuevo nombre de la página',
    'workspace.nameUpdated': 'Nombre actualizado',
    'workspace.homeUpdated': 'Página de inicio actualizada',
    'workspace.confirmDeletePage': '¿Eliminar “{name}”? Esta acción no se puede deshacer.',
    'workspace.pageDeleted': 'Página eliminada',
    'workspace.comingSoonBody': 'La navegación de esta aplicación ya está preparada. Su contenido se agregará en una siguiente etapa.',
    // ── Barra superior ────────────────────────────────────────────────────────
    'topbar.openMenu': 'Abrir menú',
    'topbar.closeMenu': 'Cerrar menú',
    'topbar.home': 'Ir a inicio',
    /* Igual en los dos idiomas, y aun así con clave: la reja del lint no sabe
       distinguir un nombre propio de una palabra sin traducir, y la lista de
       excepciones sólo debe llevar la marca. */
    'topbar.beta': 'Beta',
    'topbar.breadcrumbAria': 'Ubicación',
    'topbar.projectFallback': 'Empresa',
    'topbar.saveChanges': 'Guardar cambios',
    'topbar.unsavedChanges': 'Cambios sin guardar',
    // ── Buscador del panel ────────────────────────────────────────────────────
    'search.aria': 'Buscar en el panel',
    'search.close': 'Cerrar la búsqueda',
    'search.placeholder': 'Buscar en el panel…',
    'search.resultsAria': 'Resultados',
    'search.empty': 'No encuentro nada con «{query}».',
    'search.contact': 'Contacto',
    'search.contacts': 'Contactos',
    'search.offerActive': 'Oferta activa',
    'search.offer': 'Oferta',
    // ── Tarjeta del proyecto, al pie del menú ─────────────────────────────────
    'sidebar.project.label': 'Proyecto',
    'sidebar.project.aria': 'Proyecto: {name}. Cambiar de proyecto',
    'sidebar.project.create': 'Crear nuevo',
    'sidebar.project.deleteSoon': 'Se borra pronto',
    'sidebar.project.deleteToday': 'Se borra hoy',
    'sidebar.project.deleteOne': 'Se borra en 1 día',
    'sidebar.project.deleteMany': 'Se borra en {count} días',
    'sidebar.project.deletedFirstSoon': 'El primero, pronto',
    'sidebar.project.deletedFirstToday': 'El primero, hoy',
    'sidebar.project.deletedFirstOne': 'El primero, en 1 día',
    'sidebar.project.deletedFirstMany': 'El primero, en {count} días',
    // ── Tarjeta de mejorar de plan ────────────────────────────────────────────
    'sidebar.upgrade.freeAria': 'Mejora tu plan',
    'sidebar.upgrade.freeTitle': 'Saca más de tu sitio',
    'planInvitation.domain': 'Usa tu propio dominio',
    'planInvitation.pages': 'Espacio para más páginas',
    'planInvitation.branding': 'Quita la marca de véltica',
    'planInvitation.notNow': 'Ahora no',
    'sidebar.upgrade.freeBody': 'Dominio propio, más páginas y sin la marca de véltica.',
    'sidebar.upgrade.freeCta': 'Ver planes',
    'sidebar.upgrade.dismissFree': 'Ocultar la invitación a mejorar de plan',
    'sidebar.upgrade.usageAria': 'Aviso de consumo del plan',
    'sidebar.upgrade.usageTitle': 'Vas justo de plan',
    'sidebar.upgrade.usageCta': 'Ampliar mi plan',
    'sidebar.upgrade.dismissUsage': 'Ocultar el aviso de consumo',
    /* La frase entera por métrica, y no «{percent}% de {métrica}».
       Armarla con un hueco obligaba a que las cuatro métricas compartieran
       artículo, y en español no lo comparten: es «del almacenamiento» pero «de
       los envíos». Con el hueco salía «de el almacenamiento», que es lo que
       decía esta tarjeta hasta ahora. */
    'sidebar.upgrade.usage.storage': 'Llevas el {percent}% del almacenamiento que incluye tu plan.',
    'sidebar.upgrade.usage.bandwidth': 'Llevas el {percent}% del ancho de banda que incluye tu plan.',
    'sidebar.upgrade.usage.forms': 'Llevas el {percent}% de los envíos de formularios que incluye tu plan.',
    'sidebar.upgrade.usage.ai': 'Llevas el {percent}% del uso de IA que incluye tu plan.',
    // ── Aviso de disputas ─────────────────────────────────────────────────────
    'dispute.overdue': 'el plazo ya venció',
    'dispute.dueToday': 'el plazo vence hoy',
    'dispute.dueOne': 'queda 1 día para responder',
    'dispute.dueMany': 'quedan {count} días para responder',
    'dispute.many': '{count} ventas disputadas',
    'dispute.one': 'Disputaron un cobro de {amount}',
    'dispute.manyDue': 'La más urgente: {due}.',
    'dispute.manyNoDue': 'Revísalas antes de que venzan sus plazos.',
    'dispute.oneDue': '{due} y defender «{offer}».',
    'dispute.oneNoDue': 'Responde para defender «{offer}».',
    'dispute.viewAll': 'Ver las disputas',
    'dispute.respond': 'Responder',
    // ── Campana de notificaciones ─────────────────────────────────────────────
    'notif.title': 'Notificaciones',
    'notif.bellAria': 'Notificaciones',
    'notif.bellAriaCount': 'Notificaciones ({count})',
    'notif.moreActions': 'Más acciones de notificaciones',
    'notif.clear': 'Limpiar notificaciones',
    'notif.loading': 'Buscando novedades…',
    'notif.newOne': '1 nueva',
    'notif.newMany': '{count} nuevas',
    'notif.allClear': 'Todo al día',
    'notif.markRead': "Marcar como leída",
    'notif.markReadAria': "Marcar «{title}» como leída",
    'notif.markAllRead': "Marcar todas como leídas",
    'notif.emptyBody': 'No tienes notificaciones nuevas.',
    'notif.actionAria': '{action}: {title}',
    'notif.dismiss': 'Descartar notificación',
    'notif.dismissShort': 'Eliminar',
    'notif.dismissAria': 'Descartar notificación de {title}',
    'notif.billingTitle': 'No pudimos cobrar tu suscripción',
    'notif.billingBody': 'Tu plan sigue activo mientras lo reintentamos, pero se cancelará si el cobro no se completa. Revisa la tarjeta para conservarlo.',
    'notif.billingAction': 'Actualizar método de pago',
    'notif.someoneWrote': 'Alguien escribió',
    'notif.viewMessage': 'Ver mensaje',
    'notif.saleTitle': 'Venta de {amount}',
    'notif.deletedOffer': 'Oferta borrada',
    'notif.viewSale': 'Ver venta',
    'notif.stockLow': 'Quedan {count} de {name}',
    'notif.stockOut': '{name} se agotó',
    'notif.stockLowBody': 'Repón pronto para no quedarte sin ventas.',
    'notif.stockOutBody': 'En tu sitio sale como «Agotado» hasta que repongas.',
    'notif.refundFailed': 'No se pudo devolver {amount}',
    'notif.refundFailedBody': 'Hazlo a mano en Stripe',
    'notif.restock': 'Reponer',
    'notif.inviteFrom': '{name} te invitó a {project}',
    'notif.invite': 'Te invitaron a {project}',
    'notif.inviteBody': 'Como {role}. Ocupa un asiento hasta que respondas.',
    'notif.inviteAction': 'Ver invitación',
    'notif.transferFrom': '{name} quiere transferirte {project}',
    'notif.transfer': 'Quieren transferirte {project}',
    'notif.transferBody': 'El sitio pasaría a tu cuenta con su contenido y su dominio.',
    'notif.transferAction': 'Ver qué recibo',
    'notif.authCodeTitle': 'Tu código de transferencia está listo',
    'notif.authCodeAction': 'Ver el código',
    'notif.bookingCancelled': '{who} canceló su cita',
    'notif.bookingMoved': '{who} cambió su cita de hora',
    'notif.bookingNew': '{who} reservó una cita',
    'notif.someClient': 'Un cliente',
    'notif.booking': 'Reservación',
    'notif.viewBooking': 'Ver la cita',
    'notif.viewNewTime': 'Ver el nuevo horario',
    // ── Buscador: cómo lo llama quien lo busca ────────────────────────────────
    /* Namespace propio y no `section.*` a propósito. El menú dice cómo se llama
       cada sitio; esto dice cómo lo nombra quien lo está buscando, y no siempre
       coinciden: el menú pone «Contenido» y aquí «Contenido (CMS)», porque quien
       escribe «cms» tiene que reconocerlo en la lista. Los sinónimos con los que
       se empareja no viven aquí — no los lee nadie. Ver `dashboardSearch`. */
    'find.kind.destination': 'Ir a',
    'find.kind.page': 'Páginas',
    'find.kind.cms': 'Contenido',
    'find.kind.contact': 'Contactos',
    'find.kind.offer': 'Ofertas',
    'find.group.website': 'Sitio web',
    'find.group.sales': 'Ventas',
    'find.group.analytics': 'Analíticas',
    'find.group.people': 'Personas',
    'find.group.account': 'Cuenta',
    'find.group.apps': "Próximamente",
    'find.group.settings': 'Configuración',
    'find.pages': 'Páginas',
    'find.cms': 'Contenido (CMS)',
    'find.forms': 'Formularios',
    'find.publish': 'Dominio',
    'find.payments': 'Todas las ofertas',
    'find.digitalProducts': 'Productos digitales',
    'find.physicalProducts': 'Productos físicos',
    'find.services': 'Servicios',
    'find.orders': 'Cobros',
    'find.payouts': 'Depósitos',
    'find.bookings': 'Servicios con agenda',
    'find.stripe': 'Stripe',
    'find.analytics': 'Analíticas de visitas',
    'find.salesAnalytics': 'Analíticas de ventas',
    'find.bookingsAnalytics': 'Analíticas de reservas',
    'find.contacts': 'Contactos',
    'find.team': 'Equipo',
    'find.billing': 'Facturación',
    'find.plans': 'Planes',
    'find.usage': 'Uso y límites',
    'find.settings': 'Ajustes de usuario',
    'find.help': 'Ayuda',
    'find.general': 'Configuración del sitio',
    'find.business': 'Datos del negocio',
    'find.policies': 'Políticas',
    'find.region': 'Región y moneda',
    'find.backups': 'Copias de seguridad',
    'find.googleAnalytics': 'Google Analytics',
    // ── Configuración: el índice ──────────────────────────────────────────────
    /* Los rótulos de las tarjetas no se repiten aquí: salen de `section.*`, los
       mismos que escribe el migajero. Es el único sitio del panel donde el índice
       y el camino de arriba nombran lo mismo, y separarlos dejaría que dejaran de
       coincidir sin que nada avisara. */
    'config.title': 'Configuración',
    'config.intro': 'Administra la publicación, la información del negocio, el cumplimiento legal y las integraciones de tu sitio.',
    /* Compartida por el marco de ajustes, el índice y las pantallas que cuelgan
       de él. Se llamaba `settings.general.back` de cuando sólo la usaba una. */
    'config.back': 'Volver a Configuración',
    'config.open': 'Abrir',
    'config.group.site': 'Sitio y publicación',
    'config.group.business': 'Negocio y cumplimiento',
    'config.group.integrations': 'Integraciones',
    'config.desc.publish': 'Administra la dirección pública de tu sitio y los dominios conectados.',
    'config.desc.backups': 'Consulta y restaura versiones guardadas del contenido y la configuración.',
    'config.desc.usage': 'Supervisa el consumo de recursos incluido en tu plan.',
    'config.desc.brand': 'Elige los colores y las tipografías que usan tus páginas, tu página de reserva y tus correos.',
    'config.desc.general': 'Define el nombre, los iconos, la zona horaria, el acceso y la marca.',
    'config.desc.transfer': 'Entrega el sitio a otra cuenta, con todo lo que contiene.',
    'config.stripeRows': 'En tu cuenta de Stripe',
    'config.desc.business': 'Centraliza los datos fiscales, el domicilio y el contacto de tus documentos legales.',
    'config.desc.region': 'Define el país, la moneda de cobro y el idioma de tus documentos legales.',
    'config.desc.policies': 'Administra los documentos de privacidad, términos, reembolsos y cancelaciones.',
    'config.desc.stripe': 'Conecta y administra la cuenta que procesa los pagos de tu sitio.',
    'config.desc.omnisend': 'Envía a tus listas los contactos que llegan por los formularios del sitio.',
    'config.desc.googleAnalytics': 'Conecta tu ID de medición y mide el sitio en tu propiedad de Google Analytics.',
    'config.stripe.none': 'Sin conectar',
    'config.stripe.pending': 'Configuración pendiente',
    'config.stripe.restricted': 'Pendiente de revisión',
    'config.stripe.ready': 'Conectada',
    'config.omnisend.invalid': 'La clave dejó de funcionar',
    'config.omnisend.ok': 'Conectada',
    'config.policies.noneWritten': 'Ninguna está escrita',
    'config.policies.unwritten': 'Faltan {count} por escribir',
    'config.policies.holesOne': '1 dato por rellenar',
    'config.policies.holesMany': '{count} datos por rellenar',
    'config.policies.complete': 'Completas',
    'config.business.complete': 'Completa',
    'config.business.missing': 'Faltan {count} datos',
    // ── Configuración › Información del negocio ───────────────────────────────
    'business.title': 'Información del negocio',
    /* Partida en tres porque lleva un enlace en medio. El hueco `{}` no sirve:
       lo que va dentro es un botón, no texto. */
    'business.introBefore': 'Centraliza la información fiscal, de contacto y de ubicación que requieren tus documentos legales. Al guardarla,',
    'business.policiesTemplates': 'las plantillas de Políticas',
    'business.introAfter': 'podrán incorporar estos datos automáticamente.',
    'business.loading': 'Cargando la información del negocio',
    'business.loadFailedTitle': 'No se pudo cargar',
    'business.loadFailed': 'No se pudo cargar la información.',
    'business.retry': 'Reintentar',
    'business.saved': 'Información guardada',
    'business.missingOne': 'Falta 1 dato para vender',
    'business.missingMany': 'Faltan {count} datos para vender',
    'business.missingBody': 'Nombre, correo y domicilio son lo mínimo que tus clientes necesitan para saber quién eres y dónde reclamar. Lo marcado como opcional puede quedarse vacío.',
    'business.fieldMissing': 'Falta completar',
    'business.optional': 'Opcional',
    'business.saveFailed': 'No se pudo guardar',
    'business.changeIn': 'Se cambia en',
    'business.regionPath': 'Configuración → Región y moneda',
    'business.identity.title': 'Identidad legal y comercial',
    'business.identity.note': 'Información con la que tu negocio se presenta ante clientes y autoridades.',
    'business.tradeName.label': 'Nombre comercial',
    'business.tradeName.hint': 'Nombre público con el que tus clientes identifican el negocio.',
    'business.tradeName.placeholder': 'Nombre del negocio',
    'business.legalName.label': 'Nombre o razón social',
    'business.legalName.hint': 'Nombre registrado ante la autoridad fiscal; puede ser el de una persona física. Si lo dejas vacío, se usa el nombre comercial.',
    'business.legalName.placeholder': 'Nombre completo o razón social',
    /* «RFC» es el nombre mexicano, y este panel arrancó ahí. En inglés va el
       término genérico: el campo es el identificador fiscal del negocio, se
       llame como se llame en su país. */
    'business.taxId.label': 'Identificación fiscal',
    'business.taxId.label.mx': 'RFC',
    'business.taxId.label.es': 'NIF / CIF',
    'business.taxId.label.us': 'EIN / Tax ID',
    'business.taxId.hint': 'Si lo añades, aparece en tus términos y condiciones.',
    'business.taxId.placeholder': 'Identificación fiscal',
    'business.address.title': 'Domicilio y jurisdicción',
    'business.address.note': 'El domicilio se incorpora al aviso de privacidad; el país y el estado determinan el marco legal aplicable.',
    'business.address.label': 'Domicilio completo',
    'business.address.hint': 'Calle y número, colonia y código postal.',
    'business.address.placeholder': 'Calle, número, colonia y código postal',
    'business.city.label': 'Ciudad',
    'business.city.placeholder': 'Ciudad',
    'business.state.label': 'Estado',
    'business.state.placeholder': 'Estado o provincia',
    'business.country.label': 'País',
    'business.country.placeholder': 'Selecciona un país',
    'business.currency.label': 'Moneda en la que cobras',
    'business.currency.placeholder': 'Selecciona una moneda',
    'business.contact.title': 'Contacto y responsable de privacidad',
    'business.contact.note': 'Canales de atención y persona responsable de las solicitudes relacionadas con datos personales.',
    'business.email.label': 'Correo de contacto',
    'business.email.hint': 'Dirección que recibirá las solicitudes relacionadas con datos personales.',
    'business.email.placeholder': 'Correo electrónico',
    'business.phone.label': 'Teléfono',
    'business.phone.placeholder': 'Número de teléfono',
    'business.phone.hint': 'Si lo añades, aparece como otra forma de contactarte en tus políticas.',
    'business.legalContact.label': 'Responsable legal',
    'business.legalContact.hint': 'Quien atiende las solicitudes sobre datos personales. Si lo dejas vacío, responde el titular del negocio.',
    'business.legalContact.placeholder': 'Nombre de la persona responsable',
    // ── Configuración › Región y moneda ───────────────────────────────────────
    'region.title': 'Región y moneda',
    'region.intro': 'Define el país de operación, la moneda de cobro y el idioma de los documentos legales. Estos ajustes determinan el formato de los importes, los precios sincronizados con Stripe y el marco legal de las plantillas.',
    'region.loading': 'Cargando el ajuste',
    'region.loadFailedTitle': 'No se pudo cargar',
    'region.retry': 'Reintentar',
    'region.jurisdiction.title': 'Jurisdicción y formato regional',
    'region.jurisdiction.note': 'Define el marco legal de tus documentos y el formato utilizado para fechas e importes.',
    'region.country': 'País',
    'region.profileNote': 'Tus plantillas de políticas citan {note}.',
    'region.policiesChangeBefore': 'Cambiar el país cambia las',
    'region.policiesLink': 'plantillas de Políticas',
    /* Lo que citan las plantillas de cada país. Vivía en `lib/region.tsx`, escrito
       a mano en español; los nombres de las leyes no se traducen —la LFPDPPP se
       llama igual en inglés— pero el texto que las envuelve sí. */
    'region.profile.mx': 'la LFPDPPP, los derechos ARCO, al INAI y a la PROFECO',
    'region.profile.es': 'el RGPD, la LOPDGDD y a la Agencia Española de Protección de Datos',
    'region.profile.us': 'el modelo estadounidense: derechos CCPA/CPRA, la FTC y la fiscalía de tu estado',
    'region.profile.generic': 'ninguna ley concreta: hablan de «la legislación aplicable» porque todavía no tenemos plantillas escritas para tu país',
    'region.currency.title': 'Moneda de cobro',
    'region.currency.note': 'Establece la moneda de todos los precios del sitio y de los precios sincronizados con Stripe.',
    'region.currency.label': 'Moneda',
    'region.currency.preview': 'Vista previa del formato:',
    'region.currency.warnOne': 'La moneda cambiará en 1 oferta.',
    'region.currency.warnMany': 'La moneda cambiará en {count} ofertas.',
    'region.currency.keepsAmountLead': 'El importe numérico se conservará:',
    'region.currency.keepsAmount': 'un precio de 1 200 pasará a mostrarse como 1 200 {currency}. No se aplicará una conversión por tipo de cambio. Revisa los precios después de guardar.',
    'region.currency.withStripe': 'Stripe creará nuevos precios y retirará los anteriores. Las ventas registradas no se modificarán y las suscripciones activas conservarán su moneda original.',
    'region.currency.withoutStripe': 'Stripe no está conectado. El cambio se aplicará inicialmente en véltica y los precios se crearán en {currency} cuando conectes la cuenta.',
    'region.currency.mixed': 'Actualmente existen precios en {codes}. Al guardar, todos utilizarán la moneda seleccionada.',
    'region.language.title': 'Idioma del sitio',
    'region.language.note': 'En qué idioma atiende este negocio a sus clientes: los correos que reciben, la página de reservas, el checkout y los documentos legales.',
    'region.language.label': 'Idioma',
    'region.language.hint': 'No cambia el idioma de tu panel, que eliges en tu menú de usuario y vale para todos tus proyectos. Las plantillas legales disponibles pasan a este idioma; los documentos que ya hayas editado no se tocan.',
    'region.checkOffersBefore': 'Después de guardar, verifica los importes en',
    'region.saved': 'Ajuste guardado',
    'region.repriced': 'Moneda cambiada. Se reetiquetaron {prices} precios en {offers} ofertas.',
    'region.repricedPartial': 'Se cambiaron {prices} precios, pero {failed} no se pudieron pasar a Stripe. Revísalos en Ofertas.',
    'region.confirm.title': 'Cambiar a {currency}',
    'region.confirm.button': 'Cambiar la moneda',
    'region.confirm.working': 'Cambiando…',
    'region.confirm.bodyOne': 'Se van a reetiquetar los precios de 1 oferta{stripe}.',
    'region.confirm.bodyMany': 'Se van a reetiquetar los precios de {count} ofertas{stripe}.',
    'region.confirm.stripeTail': ', creando precios nuevos en Stripe y retirando los viejos',
    'region.confirm.noConvertLead': 'La cifra no se convierte.',
    'region.confirm.noConvert': 'Un precio de 1 200 seguirá siendo 1 200, ahora en {currency}. Revísalos después en Ofertas.',
    // ── Configuración › Políticas ─────────────────────────────────────────────
    /* El título y la descripción de cada documento NO están aquí: los manda el
       servidor, escritos en el idioma del PROYECTO —`region.language`—, que es el
       idioma en que ese documento se le enseña al cliente final. Traducirlos al
       idioma del panel pondría el rótulo en inglés encima de un texto legal en
       español. Ver `language.ts`. */
    'policies.title': 'Políticas',
    'policies.intro': 'Administra los documentos legales que regulan la relación entre tu negocio y tus clientes. Al publicarlos, se enlazan automáticamente desde las páginas de reserva y pago.',
    'policies.loading': 'Cargando tus políticas',
    'policies.loadFailedTitle': 'No se pudieron cargar',
    'policies.loadFailed': 'No se pudieron cargar las políticas.',
    'policies.retry': 'Reintentar',
    'policies.noneTitle': 'No hay políticas publicadas',
    'policies.noneBody': 'Redacta y publica los documentos necesarios para que estén disponibles en tu sitio.',
    'policies.pendingOne': '1 política pendiente',
    'policies.pendingMany': '{count} políticas pendientes',
    'policies.pendingBody': 'Las políticas pendientes no se muestran en el sitio. Lo más sencillo es activar la versión automática: se escribe sola con los datos de tu negocio.',
    'policies.live': 'Publicada',
    'policies.draft': 'Pendiente',
    'policies.unpublished': 'Sin publicar',
    'policies.autoFoot': 'Automática · se actualiza sola con los datos de tu negocio',
    'policies.missingFields': 'Para publicarla falta: {fields}',
    'policies.completeBusiness': 'Completar en Información del negocio',
    'policies.auto.title': 'Versión automática',
    'policies.auto.body': 'Se escribe sola con los datos de tu negocio y el país elegido en Región, y se actualiza cuando los cambias. Si editas el texto, pasa a ser tuya y deja de actualizarse.',
    'policies.empty.title': '¿Cómo quieres crear esta política?',
    'policies.empty.body': 'Te recomendamos la versión automática: se redacta con los datos de tu negocio, remite a las condiciones de cada servicio y se mantiene al día sola. Si prefieres, puedes escribir la tuya a partir de una plantilla.',
    'policies.useAuto': 'Usar la versión automática',
    'policies.autoOn': 'Versión automática activada',
    'policies.restoreAuto': 'Volver a la versión automática',
    'policies.restoreAuto.title': '¿Volver a la versión automática?',
    'policies.restoreAuto.body': 'Tu texto se sustituirá por la versión automática, que se escribe con los datos de tu negocio. Los cambios que hiciste a mano se perderán.',
    'policies.restoreAuto.confirm': 'Usar la automática',
    'policies.holesOne': 'Queda 1 dato entre corchetes: no se publica hasta completarlo',
    'policies.holesMany': 'Quedan {count} datos entre corchetes: no se publica hasta completarlos',
    'policies.savedOn': 'Guardada el {date}',
    'policies.willPublishAt': 'Se publicará en {path}',
    'policies.copyLink': 'Copiar enlace',
    'policies.openLink': 'Abrir enlace',
    'policies.edit': 'Editar',
    'policies.write': 'Escribir',
    'policies.disclaimerBefore': 'Las plantillas son una referencia inicial y no constituyen asesoría legal. Están adaptadas para',
    'policies.disclaimerCite': 'y hacen referencia a {note}',
    'policies.disclaimerChangeIn': '— se cambia en',
    'policies.disclaimerAfter': 'Revisa su contenido y considera obtener asesoría profesional antes de publicarlas. Tu negocio es responsable de la información incluida.',
    'policies.back': 'Volver a Políticas',
    'policies.saved': 'Política guardada',
    'policies.withdrawn': 'Política retirada',
    'policies.autoSwitch': 'Automática',
    'policies.autoSwitchAria': 'Versión automática de {title}',
    'policies.autoOff': 'Ahora es tuya: el texto ya no cambia solo',
    'policies.languageNoteBefore': 'Tus políticas se escriben en {language}, el idioma de tu sitio. Si quieres cambiar el idioma de estas páginas, da clic en',
    'policies.languageLink': 'Región › Idioma',
    'policies.saveFailed': 'No se pudo guardar',
    'policies.body.title': 'Contenido de la política',
    'policies.body.noteBefore': 'Al guardarse, estará disponible en',
    'policies.unsaved': 'Sin guardar',
    'policies.startTemplate': 'Escribir la mía desde una plantilla',
    'policies.useHours': 'Usar {hours} h, como tu servicio',
    'policies.viewLive': 'Ver publicada',
    'policies.fillOne': 'No se publicará mientras quede 1 dato entre corchetes: {list}',
    'policies.fillMany': 'No se publicará mientras queden {count} datos entre corchetes: {list}',
    'policies.editorDisclaimer': 'Esta plantilla es una referencia inicial y no constituye asesoría legal. Revisa su contenido antes de publicarlo; tu negocio es responsable de la información incluida.',
    'policies.toolbar': 'Formato del documento',
    'policies.editorAria': 'Contenido de la política',
    'policies.format.paragraph': 'Párrafo',
    'policies.format.h1': 'Título principal',
    'policies.format.h1Short': 'Título',
    'policies.format.h2': 'Subtítulo',
    'policies.format.bold': 'Negrita',
    'policies.format.list': 'Lista',
    // ── Configuración › Estilo ────────────────────────────────────────────────
    'brand.title': 'Marca',
    'brand.intro': 'Los colores y las tipografías de tu sitio. Se usan en tus páginas, en tu página de reserva y en los correos que enviamos a tus clientes.',
    'brand.saveFailed': 'No se pudo guardar',
    'brand.loading': 'Cargando tu estilo…',
    'brand.saving': 'Guardando…',
    'brand.savedState': 'Guardado',
    'brand.logo.title': 'Logo',
    'brand.logo.note': 'Tu marca, arriba de tu página de reserva y en los correos que reciben tus clientes.',
    'brand.logo.light': 'Sobre fondo claro',
    'brand.logo.dark': 'Sobre fondo oscuro',
    'brand.logo.empty': 'Sin logo',
    'brand.logo.change': 'Cambiar',
    'brand.logo.add': 'Añadir',
    'brand.logo.remove': 'Quitar',
    'brand.logo.fallback': 'Se usa el claro.',
    'brand.name.label': 'Nombre de la marca',
    'brand.name.placeholder': 'El nombre que acompaña al símbolo',
    'brand.name.show': 'Enseñar el nombre junto al logo',
    'brand.colors.title': 'Colores',
    'brand.colors.note': 'Los nueve del sitio. Cambiarlos repinta títulos, botones, tarjetas y bordes de todas tus páginas.',
    'brand.palettes.legend': 'O empieza por una combinación hecha',
    'brand.fonts.title': 'Tipografías',
    'brand.fonts.note': 'Una para los títulos y otra para el texto. Es la pareja que usan todas tus páginas.',
    'brand.fonts.headings': 'Títulos',
    'brand.fonts.body': 'Texto',
    /* Una frase de muestra, para ver la tipografía con palabras de verdad. Se
       traduce: en inglés hay que poder juzgar cómo cae la letra en inglés. */
    'brand.fonts.sample': 'Texto de muestra',
    'brand.editorNote': 'Esto es lo mismo que editas en el editor: si lo tienes abierto en otra pestaña, ciérralo antes de cambiar el estilo aquí o su próximo guardado automático volverá a poner lo suyo.',
    // ── Avisos que la reja no veía ────────────────────────────────────────────
    /* Todos éstos vivían en duro dentro de pantallas que ya figuraban como
       traducidas. No estaban entre etiquetas —van dentro de `showToast(…)` o de
       un `confirm(…)`— así que la regla del lint no los miraba hasta que se
       amplió a las llamadas que escriben en pantalla. */
    'common.discarded': 'Cambios descartados',
    /* La coma y el orden van dentro de la cadena a propósito: en inglés esto es
       «Today at 14:05», que no es «hoy» + «, » + la hora. Partirlo en trozos y
       pegarlos en el componente obliga a que las dos lenguas compartan una
       estructura que no comparten. */
    'common.listDate.today': 'Hoy, {time}',
    'common.listDate.yesterday': 'Ayer, {time}',
    'common.pickImage': 'Selecciona un archivo de imagen',
    'account.signedOut': 'Sesión cerrada.',
    'account.photoTooBig': 'La imagen debe pesar menos de 10 MB.',
    'account.codeResent': 'Código reenviado.',
    'account.email.invalidFormat': 'Escribe un correo válido.',
    'account.email.alreadyYours': 'Ese ya es tu correo actual.',
    'account.email.noMx': 'Ese dominio no recibe correos. Revisa que esté bien escrito.',
    'account.email.sentToCurrent': 'Te enviamos un código a tu correo actual.',
    'account.email.sentToNew': 'Te enviamos un código a tu nuevo correo.',
    'account.email.writeCode': 'Escribe el código que te enviamos.',
    'account.email.updated': 'Correo actualizado. Cerramos las demás sesiones.',
    'account.providers.lastOne': 'Debe quedar al menos un método de acceso.',
    'account.providers.disconnected': 'Proveedor desconectado.',
    'account.delete.codeSentToast': 'Te enviamos un código para confirmar.',
    'account.delete.badCode': 'El código no es válido o ya venció.',
    'forms.statusFailed': 'No se pudo cambiar el estado',
    'forms.deleted': 'Mensaje borrado',
    'forms.deleteFailed': 'No se pudo borrar el mensaje',
    'forms.bulkPartial': 'Se borraron {done} de {total}',
    'forms.emailCopied': 'Correo copiado',
    'forms.emailCopyFailed': 'No se pudo copiar el correo',
    'settings.general.icons.tooBig': 'El icono debe pesar menos de 2 MB',
    'settings.general.icons.unreadable': 'No se pudo leer la imagen',
    'pages.createFailed': 'No se pudo crear la página',
    'home.deleted.done': 'Proyecto eliminado. Puedes recuperarlo durante {days} días.',
    'home.deleted.failed': 'No se pudo eliminar el proyecto',
    'home.restored': 'Proyecto recuperado',
    'home.restoreFailed': 'No pudimos recuperar el proyecto',
    'home.template.confirmDelete': '¿Seguro que quieres eliminar «{name}»?',
    'home.template.confirmReset': '¿Descartar los cambios sin publicar de «{name}»? Volverá a la versión publicada.',
    // ── Panel del proyecto: resumen ───────────────────────────────────────────
    'overview.unlimited': 'Ilimitado',
    'overview.ofLimit': 'de {limit}',
    'overview.resetsAt': 'Se reinicia {when}',
    'overview.notes.placeholder': 'Escribe una nota, tarea o apunte para el equipo…',
    'overview.notes.saveFailed': 'No se pudo guardar la nota.',
    'overview.notes.charsLeft': '{count} caracteres restantes',
    'overview.notes.title': 'Notas del equipo',
    'overview.notes.meta': 'Bitácora colaborativa',
    'overview.notes.add': 'Publicar nota',
    'overview.notes.edited': 'editado',
    'overview.notes.edit': 'Editar',
    'overview.notes.delete': 'Eliminar',
    'overview.notes.deleteConfirm': '¿Eliminar nota?',
    'overview.notes.save': 'Guardar',
    'overview.notes.cancel': 'Cancelar',
    'overview.notes.you': 'Tú',
    'overview.notes.initialNote': 'Nota inicial del proyecto',
    /* La tecla entra como variable: el rótulo prometía ⌘ también en Windows y
       Linux, donde nombra una función que no existe. */
    'overview.notes.keyboardHint': '{key} + Enter para publicar',
    'overview.notes.editHint': '{key} + Enter para guardar · Esc para cancelar',
    'overview.notes.full': 'Las notas de este proyecto llegaron al tope. Borra alguna para seguir escribiendo.',
    'overview.notes.unnamed': 'Miembro del equipo',
    'overview.setup.aria': 'Primeros pasos del proyecto',
    'overview.setup.eyebrow': 'Primeros pasos',
    'overview.setup.title': 'Prepara tu sitio para publicarlo',
    'overview.setup.prev': "Anteriores",
    'overview.setup.next': "Siguientes",
    'overview.setup.leftOne': 'Falta 1',
    'overview.setup.leftMany': 'Faltan {count}',
    'overview.setup.progress': '{done} de {total}',
    'overview.setup.done': 'Completado',
    'overview.openLink': 'Abrir enlace',
    'overview.empty': 'Nada por aquí todavía.',
    'overview.createNew': 'Crear nuevo',
    'overview.new': 'Nuevo',
    'overview.summary.title': 'Visitas',
    'overview.last30': 'Últimos 30 días',
    'overview.stat.views': 'Vistas',
    'overview.stat.uniques': 'Visitantes únicos',
    'overview.stat.countries': 'Países',
    'overview.stat.topPage': 'Página más popular',
    'overview.sales.title': 'Ventas',
    'overview.stat.revenue': 'Ingresos netos',
    'overview.stat.orders': 'Ventas',
    'overview.stat.aov': 'Ticket promedio',
    'overview.stat.customers': 'Clientes',
    'overview.chart.revenue': 'Ingresos',
    'overview.site.aria': 'Sitio publicado',
    'overview.site.unpublished': 'Sin publicar. Tus cambios aún no están en línea.',
    'overview.site.openHomeAria': 'Abrir la página de inicio publicada',
    'overview.site.view': 'Ver sitio',
    'overview.site.openEditor': 'Abrir en Editor',
    'overview.card.pages': 'Páginas',
    'overview.card.cms': 'Contenido (CMS)',
    'overview.card.bookings': 'Próximas citas',
    'overview.card.offers': "Catálogo",
    'overview.card.contacts': 'Contactos',
    'overview.card.forms': 'Formularios',
    'overview.card.transactions': 'Transacciones',
    'overview.card.toShip': 'Por enviar',
    'overview.payouts.title': 'Depósitos',
    'overview.payouts.meta': 'Lo que llega a tu banco',
    'overview.payouts.available': 'Disponible',
    'overview.payouts.onTheWay': 'En camino',
    'overview.usage.title': 'Uso del plan',
    'overview.usage.pages': 'Páginas',
    'overview.usage.collections': 'Colecciones',
    'overview.usage.cmsItems': 'Elementos CMS',
    'overview.usage.offers': "Ofertas publicadas",
    'overview.usage.contacts': 'Contactos',
    'overview.usage.ai': 'Sitios generados con IA',
    'overview.usage.forms': 'Formularios',
    'overview.domain.title': 'Dominio y SSL',
    'overview.domain.none': 'Sin dominio propio.',
    'overview.domain.yourSubdomain': 'tu subdominio de Veltica',
    'overview.domain.primary': 'principal',
    'overview.domain.getDomain': 'Obtener un dominio',
    'overview.noVisits': 'Aún no hay visitas',
    'overview.noSales': 'Aún no hay ventas',
    'overview.noSalesHint': 'Cuando alguien compre en tu sitio, aquí verás cuánto facturaste y cómo va respecto al mes anterior.',
    'overview.viewAnalytics': 'Ver analíticas completas',
    'overview.viewSalesAnalytics': 'Ver analíticas de ventas',
    'overview.viewDetail': 'Ver detalle',
    'overview.manage': 'Administrar',
    'overview.ssl.ready': 'SSL listo',
    'overview.ssl.pending': 'SSL pendiente',
    // ── Bandeja de formularios ────────────────────────────────────────────────
    'forms.loadingMessage': 'Cargando el mensaje',
    'forms.loadingList': 'Cargando tus envíos',
    'forms.backToForms': 'Volver a formularios',
    'forms.detail.email': 'Correo',
    'forms.detail.copyEmailAria': 'Copiar el correo del remitente',
    'forms.detail.notProvided': 'No proporcionado',
    'forms.detail.received': 'Recibido',
    'forms.detail.sourcePage': 'Página de origen',
    'forms.detail.copyUrlAria': 'Copiar la URL de la página de origen',
    'forms.detail.noSource': 'No disponible para este envío',
    'forms.detail.status': 'Estado',
    'forms.detail.openProfile': 'Abrir perfil',
    'forms.detail.markRead': 'Marcar como leído',
    'forms.detail.markUnread': 'Marcar como no leído',
    'forms.detail.reply': 'Responder',
    'forms.detail.delete': 'Borrar mensaje',
    'forms.detail.noAnswers': 'Este envío llegó sin respuestas.',
    'forms.delete.body': 'Se borrarán permanentemente este mensaje y todas las respuestas que contiene. Esta acción no se puede deshacer.',
    'forms.title': 'Formularios',
    'forms.searchAria': 'Buscar envío',
    'forms.searchPlaceholder': 'Buscar envío...',
    'forms.clearSearch': 'Limpiar búsqueda',
    'forms.starred': 'destacados',
    'forms.filtersAria': 'Filtros y orden',
    'forms.filtersDialogAria': 'Filtros y orden de formularios',
    'forms.filterTitle': 'Filtrar envíos',
    'forms.filterForm': 'Formulario',
    'forms.filterByFormAria': 'Filtrar por formulario',
    'forms.allForms': 'Todos los formularios',
    'forms.filterStarred': 'Destacados',
    'forms.filterStatus': 'Estado',
    'forms.status.all': 'Todos',
    'forms.status.unread': 'Nuevos',
    'forms.status.read': 'Leídos',
    'forms.resetFilters': 'Restablecer filtros',
    'forms.exportCsv': 'Exportar CSV',
    'forms.exportCsvAria': 'Exportar envíos a CSV',
    /* Las columnas del CSV de envíos. Se traducen porque el archivo lo abre
       quien lo descarga, en su idioma, no el programa. */
    'forms.csv.filename': 'envios-de-formulario',
    'forms.csv.date': 'Fecha',
    'forms.csv.form': 'Formulario',
    'forms.csv.name': 'Nombre',
    'forms.csv.email': 'Correo',
    'forms.csv.status': 'Estado',
    'forms.csv.answers': 'Respuestas',
    'forms.csv.page': 'Página',
    'forms.csv.statusUnread': 'Nuevo',
    'forms.csv.statusRead': 'Leído',
    'forms.csv.statusSpam': 'Spam',
    'forms.loadFailed': 'No pudimos cargar los formularios.',
    'forms.emptyTitle': 'Todavía no hay envíos',
    'forms.emptyBody': 'Los mensajes aparecerán aquí cuando alguien rellene un formulario de tu sitio.',
    'forms.noResultsTitle': 'No encontramos envíos',
    'forms.noResultsBody': 'Prueba con otra búsqueda o quita los filtros.',
    'forms.clearFilters': 'Limpiar filtros',
    'forms.col.contact': 'Contacto',
    'forms.col.form': 'Formulario',
    'forms.col.date': 'Fecha',
    'forms.col.actions': 'Acciones',
    'forms.viewForm': 'Ver formulario',
    'forms.moreOptions': 'Más opciones',
    'forms.openForm': 'Abrir Formulario',
    'forms.unspam': 'Quitar de spam',
    'forms.markSpam': 'Marcar como spam',
    'forms.copyEmail': 'Copiar correo',
    'forms.card.submission': 'Envío',
    'forms.card.actions': 'Acciones',
    'forms.card.answers': 'Respuestas',
    'forms.closeFilters': 'Cerrar filtros',
    'forms.onlyStarred': 'Sólo destacados',
    // ── Páginas del proyecto ──────────────────────────────────────────────────
    'pages.creating': 'Creando página…',
    'pages.bulkDelete.aria': 'Eliminar páginas',
    'pages.bulkDelete.titleOne': '¿Eliminar 1 página?',
    'pages.bulkDelete.titleMany': '¿Eliminar {count} páginas?',
    'pages.bulkDelete.body': 'Se eliminarán las páginas seleccionadas y su contenido. La de inicio no se toca.',
    'pages.undone': 'Esta acción no se puede deshacer.',
    'pages.cancel': 'Cancelar',
    'pages.confirmDelete': 'Sí, eliminar',
    'pages.delete.aria': 'Eliminar página',
    'pages.delete.title': '¿Eliminar esta página?',
    'pages.delete.body': 'Vas a eliminar {name}.',
    'pages.delete.thisPage': 'esta página',
    'pages.delete.confirmBody': 'Vas a eliminar «{name}». Esta acción no se puede deshacer.',
    'pages.title': 'Páginas',
    'pages.searchAria': 'Buscar página',
    'pages.searchPlaceholder': 'Buscar página...',
    'pages.clearSearch': 'Limpiar búsqueda',
    'pages.starred': 'destacadas',
    'pages.filtersAria': 'Filtros y orden',
    'pages.filtersDialogAria': 'Filtros y orden de páginas',
    'pages.filterTitle': 'Filtrar páginas',
    'pages.closeFilters': 'Cerrar filtros',
    'pages.filterType': 'Tipo',
    'pages.type.all': 'Todas',
    'pages.type.home': 'Página de inicio',
    'pages.filterStarred': 'Destacadas',
    'pages.onlyStarred': 'Sólo destacadas',
    'pages.resetFilters': 'Restablecer filtros',
    'pages.newAria': 'Nueva página',
    'pages.new': 'Nueva página',
    'pages.newShort': 'Nueva',
    'pages.emptyTitle': 'No tienes páginas aún',
    'pages.emptyBody': 'Crea tu primera página para empezar a construir el sitio.',
    'pages.createPage': 'Crear página',
    'pages.noResultsTitle': 'No encontramos páginas',
    'pages.noResultsBody': 'Prueba con otra búsqueda o cambia los filtros.',
    'pages.clearFilters': 'Limpiar filtros',
    'pages.col.name': 'Nombre',
    'pages.col.created': 'Creación',
    'pages.col.updated': 'Última edición',
    'pages.col.actions': 'Acciones',
    'pages.homeAria': 'Página de inicio',
    'pages.nameAria': 'Nombre de la página',
    'pages.openEditor': 'Abrir en Editor',
    'pages.open': 'Abrir',
    'pages.menu.openEditor': 'Abrir en editor',
    'pages.menu.settings': 'Ajustes',
    'pages.menu.stats': 'Estadísticas',
    'pages.menu.preview': 'Vista previa',
    'pages.menu.openPublished': 'Abrir publicada',
    'pages.menu.copyLink': 'Copiar enlace',
    'pages.menu.duplicate': 'Duplicar',
    'pages.menu.rename': 'Cambiar nombre',
    'pages.menu.setHome': 'Establecer como inicio',
    'pages.menu.delete': 'Eliminar',
    // ── Dominio y publicación ─────────────────────────────────────────────────
    'publish.terms': 'Términos y condiciones',
    'publish.privacy': 'Política de privacidad',
    'publish.copy': 'Copiar',
    'publish.title': 'Dominio',
    'publish.dns.pointing': 'El dominio ya apunta a véltica. El certificado SSL se emitirá en unos minutos y el estado se actualizará automáticamente.',
    'publish.dns.wrongTarget': 'El destino actual es {found}, pero debe ser {expected}. Actualiza el campo Valor en tu proveedor.',
    'publish.dns.managedBy': 'El DNS del dominio está administrado por {provider}. Agrega el registro desde ese proveedor.',
    'publish.dns.notFound': 'No se encontró el registro requerido. Verifica que esté guardado en el proveedor que administra el DNS del dominio.',
    'publish.active.aria': 'Direcciones activas',
    'publish.active.title': 'Direcciones activas',
    'publish.testMode': 'Modo de prueba: los dominios propios se conectan al instante y no resuelven de verdad.',
    'publish.badge.active': 'Activo',
    'publish.badge.ssl': 'SSL activo',
    'publish.badge.primary': 'Principal',
    'publish.makePrimary': 'Hacer principal',
    'publish.loadingDomains': 'Cargando dominios…',
    'publish.reconnecting': 'Reconectando…',
    'publish.reconnect': 'Reconectar',
    'publish.dnsAndTransfer': 'DNS y transferencia',
    'publish.disconnect': 'Desconectar',
    'publish.renewal': 'El registro vence el {date}.',
    'publish.billing': 'Facturación',
    'publish.registering': 'El dominio se está registrando a tu nombre. Cuando finalice, se conectará automáticamente al sitio.',
    'publish.awaitingCert': 'El dominio ya está conectado al sitio. No necesitas modificar el DNS; únicamente falta emitir el certificado. El estado cambiará automáticamente a SSL activo.',
    'publish.completeConnection': 'Completa la conexión',
    'publish.addRecords': 'Agrega estos registros en el DNS del proveedor. El certificado SSL se emitirá cuando el dominio apunte a véltica.',
    'publish.dns.type': 'Tipo',
    'publish.dns.name': 'Nombre',
    'publish.dns.value': 'Valor',
    'publish.rootDomainNote': 'Tu dominio es raíz: si tu proveedor no permite CNAME en la raíz, usa un registro ALIAS/ANAME con el mismo valor, o conecta www.{hostname}.',
    'publish.propagation': 'La propagación puede tardar algunos minutos. El estado cambiará automáticamente a SSL activo; también puedes solicitar una nueva comprobación.',
    'publish.checking': 'Comprobando…',
    'publish.retry': 'Reintentar',
    'publish.autoChecked': 'El estado se comprueba automáticamente cada pocos segundos.',
    'publish.viewAllDomains': 'Ver todos tus dominios',
    'publish.owned.aria': 'Dominios que ya tienes',
    'publish.owned.title': 'Dominios que ya tienes',
    'publish.owned.note': 'Los compraste aquí y no están conectados a ningún sitio. Puedes usarlos en éste.',
    'publish.connecting': 'Conectando…',
    'publish.connect': 'Conectar',
    'publish.expiresOn': 'El registro vence el {date}.',
    'publish.search.aria': 'Conectar un dominio propio',
    'publish.search.placeholder': 'tunegocio',
    'publish.search.inputAria': 'Nombre del dominio punto com',
    'publish.search.searching': 'Buscando…',
    'publish.search.button': 'Buscar',
    'publish.search.checking': 'Verificando disponibilidad…',
    'publish.search.testPrices': 'Modo de prueba: los precios mostrados son reales, pero no se realizará ninguna compra.',
    'publish.credit.applied': 'Se aplican {amount} de crédito de tu plan anual. Después, {price} al año.',
    'publish.credit.yearlyIncludes': 'El plan anual incluye {amount} de crédito para tu primer año de dominio. Después, {price} al año.',
    'publish.perYear': '/año',
    'publish.openingPayment': 'Abriendo el pago…',
    'publish.buyDomain': 'Comprar dominio',
    'publish.connectWithPro': 'Conéctalo con Pro',
    'publish.isItYours': '¿Es tuyo? Conéctalo',
    'publish.unavailableCheck': 'No fue posible verificar la disponibilidad ({reason}). Los precios mostrados permanecen vigentes.',
    'publish.extensionsFor': 'Extensiones disponibles para {term}.',
    'publish.freeWithPlan': 'Gratis con tu plan',
    'publish.freeWithYearly': 'Gratis con el plan anual',
    'publish.wizard.enterDomain': 'Ingresa tu dominio',
    'publish.wizard.domainPlaceholder': 'www.tuempresa.com',
    'publish.wizard.rootOrSub': 'Puedes conectar el dominio raíz ({root}) o un subdominio ({sub}).',
    'publish.wizard.pickProvider': 'Selecciona el proveedor del dominio',
    'publish.wizard.pickProviderHint': 'Identifica el proveedor para abrir su panel de configuración DNS.',
    'publish.wizard.addRecordAt': 'Agrega este registro en {registrar}',
    'publish.wizard.addRecordHint': 'Abre la configuración DNS y agrega el siguiente registro. En Nombre/Host, utiliza únicamente el valor indicado.',
    'publish.wizard.goTo': 'Ir a {registrar}',
    'publish.wizard.verify': 'Verifica la conexión',
    'publish.wizard.verifyHint': 'Después de guardar el registro, inicia la verificación. El DNS se validará y el certificado SSL se emitirá automáticamente.',
    'publish.wizard.back': 'Atrás',
    'publish.wizard.verifyAndConnect': 'Verificar y conectar',
    'publish.noDomainYet': '¿Todavía no tienes uno?',
    'publish.findNew': 'Buscar uno nuevo',
    'publish.startOver': 'Empezar de nuevo',
    'publish.alreadyRegistered': '¿Ya tienes uno registrado?',
    'publish.connectMine': 'Conectar el mío',
    'publish.cancelConnection': '¿Cancelar la conexión?',
    'publish.disconnectDomain': '¿Desconectar dominio?',
    'publish.buyTerms': 'Al comprar aceptas nuestros',
    'publish.and': 'y nuestra',
    'publish.oneYearNotice': 'El registro tiene una vigencia de un año. Recibirás una notificación antes de su vencimiento.',
    'publish.wizard.continue': 'Continuar',
    'publish.wizard.change': 'Cambiar',
    'publish.wizard.next': 'Siguiente',
    'publish.description': 'El sitio estará disponible en todas las direcciones activas. Las secundarias redirigen a la principal.',
    'publish.genericError': 'Algo salió mal. Inténtalo de nuevo.',
    'publish.invalidDomain': 'Ingresa un dominio válido, por ejemplo www.tuempresa.com.',
    'publish.purchaseIncomplete': 'Tu dominio se registró, pero no pudimos terminar de conectarlo. Aparece abajo con el detalle. No vuelvas a comprarlo.',
    'publish.siteFor': 'Sitio para {domain}',
    'publish.checkout.description': 'Registro y conexión automática del dominio a tu sitio.',
    'publish.checkout.feature.owned': 'El dominio se registra a tu nombre y puede transferirse posteriormente',
    'publish.checkout.feature.auto': 'La conexión con el sitio se configura automáticamente',
    'publish.checkout.feature.ssl': 'Certificado de seguridad (HTTPS) incluido',
    'publish.checkout.feature.notice': 'La fecha de vencimiento siempre visible',
    'publish.checkout.unit': 'USD/año',
    'publish.checkout.billed': 'Un año de registro · ${price} USD hoy',
    'publish.checkout.back': 'Volver al buscador',
    'publish.status.purchasing': 'Registrando el dominio…',
    'publish.status.pendingDns': 'Esperando DNS…',
    'publish.status.verifying': 'Verificando…',
    'publish.status.active': 'SSL activo',
    'publish.status.error': 'Revisa la configuración',
    'publish.status.disconnected': 'Sin conectar',
    'publish.status.processing': 'Procesando…',
    'publish.diagnosis.ok': 'DNS verificado: emitiendo certificado',
    'publish.diagnosis.wrongTarget': 'El dominio apunta a un destino diferente',
    'publish.diagnosis.notFound': 'Registro DNS no detectado',
    'publish.subdomain.unpublished': 'Sin publicar',
    'publish.subdomain.includedRedirect': 'Incluida con véltica · redirige a tu dominio principal',
    'publish.subdomain.included': 'Incluida con véltica',
    'publish.hero.searchTitle': 'Busca un dominio para tu sitio',
    'publish.hero.connectTitle': 'Conecta tu dominio',
    'publish.search.checkingDomain': 'Consultando {domain}',
    'publish.search.checkingSelected': 'Consultando el dominio seleccionado',
    'publish.availability.available': 'Disponible',
    'publish.availability.unknown': 'No fue posible verificar la disponibilidad',
    'publish.availability.premium': 'Dominio premium: compra no disponible desde véltica',
    'publish.availability.taken': 'Ya está registrado',
    'publish.bump.freeFirstYear': 'Gratis el primer año',
    'publish.bump.withCredit': 'Con tu crédito',
    'publish.bump.coveredByYearly': 'cubierto por tu plan anual',
    'publish.bump.freeWithYearly': 'Gratis con el plan anual',
    'publish.bump.cheaperWithYearly': 'Más barato con el plan anual',
    'publish.bump.firstYear': 'el primer año',
    'publish.bump.priceFirstYear': '{price} el primer año',
    'publish.creditSpent': 'Ya usaste el crédito de dominio de tu plan',
    'publish.needsPaidPlan': 'Conectar un dominio propio requiere plan Pro o Business',
    'publish.getWithYearly': 'Obtenerlo con el plan anual',
    'publish.buyWithPro': 'Comprar con Pro',
    'publish.alt.unavailable': 'No disponible',
    'publish.alt.checkOnSelect': 'Consulta al elegirlo',
    'publish.alt.perYear': '{price} /año',
    'publish.cancelMessage': 'Se descartará la información capturada en este asistente. Podrás iniciar nuevamente el proceso cuando lo necesites.',
    'publish.cancelConfirm': 'Cancelar conexión',
    'publish.cancelDismiss': 'Continuar configuración',
    'publish.disconnect.ownedMessage': '{hostname} dejará de dirigir tráfico al sitio, pero sigue siendo tuyo hasta su renovación: se queda en la lista y puedes reconectarlo cuando quieras. El sitio continuará disponible en la dirección de véltica.',
    'publish.disconnect.externalMessage': '{hostname} dejará de dirigir tráfico al sitio y saldrá de la lista. Podrás volver a conectarlo cuando quieras. El sitio continuará disponible en la dirección de véltica.',
    'publish.disconnect.confirm': 'Desconectar',
    'publish.disconnect.cancel': 'Cancelar',
    // ── Equipo del proyecto ───────────────────────────────────────────────────
    'team.role.includes': 'Incluye',
    'team.role.excludes': 'No incluye',
    'team.ownerOnly': 'Eliminar o transferir el proyecto, así como gestionar la membresía, son acciones reservadas al propietario.',
    'team.pickRoleAria': 'Elegir rol',
    'team.inviteSentTo': 'Invitación enviada a {email}',
    'team.title': 'Equipo',
    'team.introShort': 'Administra los miembros y sus niveles de acceso al proyecto.',
    'team.intro': 'Administra las personas que colaboran en este proyecto y define su nivel de acceso. Los permisos se aplican únicamente a este sitio.',
    'team.loading': 'Cargando miembros y permisos…',
    'team.membersTitle': 'Miembros con acceso',
    'team.membersHint': 'El propietario conserva el control principal. Para cambiarlo, es necesario transferir el proyecto.',
    'team.leaveAria': 'Salir de este proyecto',
    'team.invitesTitle': 'Invitaciones pendientes ({count})',
    'team.invitesHint': 'Cada invitación reserva un asiento hasta que se acepte, se cancele o expire.',
    'team.expiresInOne': 'Caduca en 1 día',
    'team.expiresInDays': 'Caduca en {days} días',
    'team.inviteTitle': 'Invitar a un colaborador',
    'team.inviteHint': 'Enviaremos un correo para que la persona se una a este proyecto con el rol seleccionado.',
    'team.emailLabel': 'Correo del colaborador',
    'team.emailPlaceholder': 'nombre@empresa.com',
    'team.roleLabel': 'Rol',
    'team.rolePlaceholder': 'Seleccionar un rol',
    'team.inviteSent': 'Invitación enviada',
    'team.inviteSentHint': 'Si la persona no recibe el correo, comparte este enlace directamente. Por seguridad, sólo se mostrará una vez.',
    'team.rolesTitle': 'Referencia de roles',
    'team.rolesHint': 'Consulta el alcance de cada rol antes de asignarlo a un miembro.',
    'team.leave.body': 'Perderás el acceso a {project} de inmediato. Para volver a colaborar, otro miembro deberá enviarte una nueva invitación.',
    'team.remove.body': '{name} perderá el acceso a este proyecto de inmediato. Para restablecerlo, será necesario enviar y aceptar una nueva invitación.',
    'team.cancelInvite.body': 'El enlace enviado a {name} dejará de funcionar y el asiento quedará disponible. Podrás enviar una nueva invitación más adelante.',
    'team.workStays': 'El contenido y los cambios que hayas realizado permanecerán en el proyecto.',
    // ── Analíticas ────────────────────────────────────────────────────────────
    'analytics.title': 'Analíticas',
    'analytics.subtitle': 'Métricas clave de tu sitio.',
    'analytics.last30': 'Últimos 30 días',
    'analytics.emptyTitle': 'Aún no hay visitas',
    'analytics.emptyBody': 'Las visitas a tu sitio publicado aparecerán aquí. Se cuentan desde el servidor, sin instalar nada.',
    'analytics.pageViews': 'Vistas de página',
    'analytics.uniqueVisitors': 'Visitantes únicos',
    'analytics.countries': 'Países',
    'analytics.topPage': 'Página más popular',
    'analytics.viewsByCountry': 'Vistas por país',
    'analytics.topPages': 'Páginas top',
    'analytics.trafficSources': 'Fuentes de tráfico',
    'analytics.devices': 'Dispositivos',
    'analytics.campaigns': 'Campañas',
    'analytics.unknownCountry': 'Desconocido',
    // ── Contenido (CMS) ───────────────────────────────────────────────────────
    'cms.title': 'Contenido (CMS)',
    'cms.subtitle': 'Administra las colecciones y el contenido dinámico de tu sitio.',
    'cms.usage.collections': 'Colecciones',
    'cms.usage.items': 'Elementos',
    'cms.searchAria': 'Buscar colección',
    'cms.searchPlaceholder': 'Buscar colección...',
    'cms.clearSearch': 'Limpiar búsqueda',
    'cms.starred': 'destacadas',
    'cms.filtersAria': 'Filtros y orden',
    'cms.filtersDialogAria': 'Filtros y orden de colecciones',
    'cms.filterTitle': 'Filtrar colecciones',
    'cms.closeFilters': 'Cerrar filtros',
    'cms.filterContent': 'Contenido',
    'cms.filter.all': 'Todas',
    'cms.filter.withItems': 'Con elementos',
    'cms.filter.empty': 'Vacías',
    'cms.filterStarred': 'Destacadas',
    'cms.allStars': 'Todas',
    'cms.onlyStarred': 'Sólo destacadas',
    'cms.resetFilters': 'Restablecer filtros',
    'cms.newAria': 'Nueva colección',
    'cms.new': 'Nueva colección',
    'cms.newShort': 'Nueva',
    'cms.emptyTitle': 'Todavía no tienes colecciones',
    'cms.emptyBody': 'Una colección guarda contenido que se repite con la misma forma: tu blog, tus servicios, tu equipo.',
    'cms.emptyCta': 'Crear en el editor',
    'cms.noResultsTitle': 'No encontramos colecciones',
    'cms.noResultsBody': 'Prueba con otro nombre, descripción o filtro.',
    'cms.clearFilters': 'Limpiar filtros',
    'cms.unit': 'colecciones',
    'cms.col.name': 'Nombre',
    'cms.col.url': 'URL',
    'cms.col.status': 'Estado',
    'cms.col.created': 'Creación',
    'cms.col.updated': 'Última edición',
    'cms.col.items': 'Elementos',
    'cms.col.actions': 'Acciones',
    'cms.selectAll': 'Seleccionar todos los de esta página',
    'cms.deselectAll': 'Quitar la selección de todos',
    'cms.starOne': 'Destacar {name}',
    'cms.itemCount': '{count} elementos',
    'cms.showContent': 'Mostrar contenido',
    'cms.showContentShort': 'Mostrar',
    'cms.openInEditor': 'Abrir en Editor',
    'cms.viewPublished': 'Ver publicado',
    'cms.copyLink': 'Copiar enlace',
    'cms.copyUrl': 'Copiar URL',
    'cms.open': 'Abrir',
    'cms.linkCopied': 'Enlace copiado',
    'cms.moreOptions': 'Más opciones',
    'cms.options': 'Opciones',
    'cms.delete': 'Eliminar',
    'cms.deleting': 'Eliminando…',
    'cms.cancel': 'Cancelar',
    'cms.untitled': 'Sin título',
    'cms.backToCollections': "Volver a contenido",
    'cms.deleteCollection': 'Eliminar colección',
    'cms.delete.title': '¿Eliminar «{name}»?',
    'cms.delete.confirm': 'Eliminar todo',
    'cms.delete.body': 'Se eliminará la colección junto con su página del sitio. Esta acción no se puede deshacer.',
    'cms.delete.willDeleteOne': 'Se borrará 1 elemento:',
    'cms.delete.willDeleteMany': 'Se borrarán {count} elementos:',
    'cms.delete.andMore': 'y {count} más…',
    'cms.delete.noItems': 'Esta colección no tiene elementos.',
    'cms.collectionDeleted': 'Colección «{name}» eliminada',
    /* El nombre del cupo, tal y como lo lee el aviso de plan lleno: «Llegaste al
       máximo de colecciones de tu plan Pro». */
    'cms.limit.collections': 'colecciones',
    'cms.limit.items': 'elementos',
    /* La vigencia de una ficha con fechas. Sale de `SCHEDULE_STATE_LABELS`, que
       lo tenía fijo en español dentro de `@webbuilder/shared-types`. */
    'cms.schedule.upcoming': 'Por venir',
    'cms.schedule.current': 'En curso',
    'cms.schedule.past': 'Terminado',
    // ── Contenido (CMS): los elementos de una colección ───────────────────────
    'cms.item.subtitle': 'Administra los elementos de esta colección.',
    'cms.item.searchAria': 'Buscar elemento',
    'cms.item.searchPlaceholder': 'Buscar elemento...',
    'cms.item.starred': 'destacados',
    'cms.item.filtersDialogAria': 'Filtros y orden de elementos',
    'cms.item.filterTitle': 'Filtrar elementos',
    'cms.item.filterStatus': 'Estado',
    'cms.item.status.all': 'Todos',
    'cms.item.status.published': 'Publicados',
    'cms.item.status.draft': 'Borradores',
    'cms.item.filterStarred': 'Destacados',
    'cms.item.allStars': 'Todos',
    'cms.item.onlyStarred': 'Sólo destacados',
    'cms.item.newAria': 'Nuevo elemento',
    'cms.item.new': 'Nuevo elemento',
    'cms.item.newShort': 'Nuevo',
    'cms.item.bulkDelete.titleOne': 'Eliminar 1 elemento',
    'cms.item.bulkDelete.titleMany': 'Eliminar {count} elementos',
    'cms.item.bulkDelete.body': 'Se eliminarán los elementos seleccionados de esta colección. Esta acción no se puede deshacer.',
    'cms.item.bulkDeleted.one': '1 elemento eliminado',
    'cms.item.bulkDeleted.many': '{count} elementos eliminados',
    'cms.item.emptyTitle': 'Esta colección está vacía',
    'cms.item.emptyBody': 'Cada elemento es una ficha de la colección: un post, un producto, un miembro del equipo.',
    'cms.item.emptyCta': 'Crear elemento',
    'cmsEmpty.blogBody': "La plantilla se está viendo con texto de muestra. Escribe tu primera entrada para verla con lo tuyo.",
    'cmsEmpty.blogCta': "Escribir una entrada",
    'cmsEmpty.itemsBody': "La plantilla se está viendo con texto de muestra. Crea el primer elemento para verla con tu contenido.",
    'cmsEmpty.services.title': "Aún no hay servicios",
    'cmsEmpty.services.body': "Esta plantilla muestra texto de ejemplo. Crea tu primer servicio para verla con tu contenido.",
    'cmsEmpty.services.cta': "Crear un servicio",
    'cmsEmpty.bookings.title': "Aún no hay servicios reservables",
    'cmsEmpty.bookings.body': "Esta plantilla muestra texto de ejemplo. Crea tu primer servicio reservable para verla con tu contenido.",
    'cmsEmpty.bookings.cta': "Crear un servicio reservable",
    'cmsEmpty.digital.title': "Aún no hay productos digitales",
    'cmsEmpty.digital.body': "Esta plantilla muestra texto de ejemplo. Crea tu primer producto digital para verla con tu contenido.",
    'cmsEmpty.digital.cta': "Crear un producto digital",
    'cmsEmpty.products.title': "Aún no hay productos físicos",
    'cmsEmpty.products.body': "Esta plantilla muestra texto de ejemplo. Crea tu primer producto físico para verla con tu contenido.",
    'cmsEmpty.products.cta': "Crear un producto físico",
    'cms.item.noResultsTitle': 'No encontramos elementos',
    'cms.item.noResultsBody': 'Prueba con otro nombre, slug o filtro.',
    'cms.item.unit': 'elementos',
    'cms.item.selectOne': 'Seleccionar {name}',
    'cms.item.starOne': 'Destacar {name}',
    /* Para las fichas sin título, que las hay mientras se escriben. */
    'cms.item.thisItem': 'este elemento',
    'cms.item.noUrl': 'Sin URL',
    'cms.item.noUrlYet': 'Sin dirección todavía',
    'cms.item.copyUrlAria': 'Copiar URL de {name}',
    'cms.item.openAria': 'Abrir {name} en una pestaña nueva',
    'cms.item.published': 'Publicado',
    'cms.item.draft': 'Borrador',
    'cms.item.edit': 'Editar contenido',
    'cms.item.editShort': 'Abrir',
    'cms.item.seo': 'SEO',
    'cms.item.duplicate': 'Duplicar',
    'cms.item.deleted': 'Elemento eliminado',
    /* Va en el título de la copia y en su slug: «Precios (copia)» y
       «precios-copia». Por eso una sola palabra y sin paréntesis. */
    'insert.groupInFolders': 'Agrupar en carpetas',
    'insert.showAll': 'Ver todo abierto',
    'common.copySuffix': '(copia)',
    'cms.item.copySuffix': 'copia',
    // ── Contenido (CMS): el SEO de un elemento ────────────────────────────────
    'cms.seo.back': 'Volver a los elementos',
    'cms.seo.heading': 'SEO · {title}',
    'cms.seo.save': 'Guardar',
    'cms.seo.section': 'SEO del elemento',
    'cms.seo.titleLabel': 'Título para buscadores',
    'cms.seo.titlePlaceholder': 'Máx. 60 caracteres recomendados',
    'cms.seo.titleCount': '{count} / 60 caracteres',
    'cms.seo.descLabel': 'Meta descripción',
    'cms.seo.descPlaceholder': 'Describe este elemento...',
    'cms.seo.descCount': '{count} / 160 caracteres',
    'cms.seo.imageLabel': 'Imagen para redes (1200×630px)',
    'cms.seo.imageAlt': 'Imagen para redes de este elemento',
    'cms.seo.removeImage': 'Quitar la imagen',
    'cms.seo.upload': 'Arrastra o haz clic para subir',
    'cms.seo.uploading': 'Subiendo…',
    // ── Contactos ────────────────────────────────────────────────────────────
    'contacts.title': 'Contactos',
    'contacts.subtitle': 'Administra las personas que interactúan con tu sitio.',
    'contacts.loadingDetail': 'Cargando el contacto',
    'contacts.detailLoadFailed': 'No se pudo abrir este contacto',
    'contacts.detailLoadFailedBody': 'El contacto sigue en la lista, pero no pudimos cargar sus datos. Inténtalo de nuevo en un momento.',
    'contacts.loadingList': 'Cargando tus contactos',
    'contacts.unnamed': 'Contacto sin nombre',
    'contacts.thisContact': 'este contacto',
    'contacts.back': 'Volver a contactos',
    'contacts.detail.subtitle': 'Información y actividad del contacto.',
    'contacts.detail.contact': 'Contacto',
    'contacts.detail.tabsAria': 'Detalle del contacto',
    'contacts.edit': 'Editar',
    'contacts.name': 'Nombre',
    'contacts.namePlaceholder': 'Nombre del contacto',
    'contacts.email': 'Correo',
    'contacts.emailPlaceholder': 'correo@ejemplo.com',
    'contacts.phone': 'Teléfono',
    'contacts.phonePlaceholder': '+52 55 0000 0000',
    'contacts.tags': 'Etiquetas',
    'contacts.noEmail': 'Sin correo',
    'contacts.noPhone': 'Sin teléfono',
    'contacts.copyEmail': 'Copiar correo',
    'contacts.copyEmailFor': 'Copiar el correo de {name}',
    'contacts.emailCopied': 'Correo copiado',
    'contacts.emailCopyFailed': 'No se pudo copiar el correo',
    'contacts.tags.placeholder': "Busca o crea una etiqueta",
    'contacts.tags.create': "Crear «{name}»",
    'contacts.tags.empty': "Todavía no hay etiquetas. Escribe una para crearla.",
    'contacts.tags.allChosen': "Este contacto ya tiene todas las etiquetas.",
    'contacts.tags.limit': "Máximo {max} etiquetas por contacto.",
    'contacts.tags.removeOne': "Quitar {name}",
    'contacts.tags.deleteAria': "Eliminar la etiqueta {name} de todos los contactos",
    'contacts.tags.deleteTitle': "¿Eliminar la etiqueta «{name}»?",
    'contacts.tags.deleteBody': "Se quitará de los {count} contactos que la llevan. Los contactos no se borran.",
    'contacts.tags.deleteBodyOne': "Se quitará del contacto que la lleva. El contacto no se borra.",
    'contacts.tags.deleteConfirm': "Eliminar etiqueta",
    'contacts.tags.deleted': "Etiqueta eliminada de {count} contactos.",
    'contacts.tags.deletedOne': "Etiqueta eliminada de 1 contacto.",
    'contacts.tags.count': "{count} contactos",
    'contacts.tags.countOne': "1 contacto",
    'contacts.tags.remove': 'Quitar {tag}',
    'contacts.tags.addShort': 'Añadir…',
    'contacts.tags.add': 'Añadir etiqueta',
    'contacts.status.title': 'Estado',
    'contacts.status.active': 'Activo',
    'contacts.status.activePlural': 'Activos',
    'contacts.status.spam': 'Spam',
    'contacts.status.blocked': 'Bloqueado',
    'contacts.status.blockedPlural': 'Bloqueados',
    'contacts.summary.title': 'Resumen',
    'contacts.summary.purchases': 'Compras',
    'contacts.summary.totalValue': 'Valor total',
    'contacts.summary.bookings': 'Reservas',
    'contacts.summary.forms': 'Formularios enviados',
    'contacts.lastSeen': 'Última interacción',
    'contacts.firstSeen': 'Primera interacción',
    'contacts.initialSource': 'Contacto inicial',
    'contacts.origin.title': 'Origen',
    'contacts.source.form': 'Formulario',
    'contacts.source.booking': 'Reserva',
    'contacts.source.account': "Cuenta",
    'contacts.account.badge': "Cuenta",
    'contacts.account.badgeHint': "Tiene cuenta en tu sitio",
    'contacts.account.filterTitle': "Cuenta del sitio",
    'contacts.account.filterAll': "Todos",
    'contacts.account.filterYes': "Con cuenta",
    'contacts.account.filterNo': "Sin cuenta",
    'contacts.account.label': "Cuenta del sitio",
    'contacts.account.activeSince': "Activa desde {date}",
    'contacts.account.none': "Sin cuenta",
    'contacts.account.lastLogin': "Último acceso",
    'contacts.account.cardTitle': "Cuenta y membresías",
    'contacts.account.blocked': "Bloqueada",
    'contacts.account.sessions': "Sesiones abiertas",
    'contacts.account.marketing': "Acepta novedades",
    'contacts.account.closeSessions': "Cerrar sus sesiones",
    'contacts.account.sessionsClosed': "Cerramos sus sesiones. Tendrá que volver a entrar con su código.",
    'contacts.account.block': "Bloquear cuenta",
    'contacts.account.unblock': "Desbloquear cuenta",
    'contacts.account.blockedDone': "Cuenta bloqueada: ya no puede entrar a tu sitio.",
    'contacts.account.unblockedDone': "Cuenta desbloqueada.",
    'contacts.account.actionFailed': "No se pudo hacer. Inténtalo de nuevo.",
    'contacts.access.title': "Accesos",
    'contacts.access.give': "Dar acceso",
    'contacts.access.empty': "Todavía no le has dado ningún acceso.",
    'contacts.access.state.active': "Activo",
    'contacts.access.state.expired': "Vencido",
    'contacts.access.state.revoked': "Quitado",
    'contacts.access.kind.membership': "Membresía",
    'contacts.access.kind.pack': "Paquete",
    'contacts.access.kind.digital': "Producto digital",
    'contacts.access.until': "Hasta el {date}",
    'contacts.access.forever': "Sin fecha de fin",
    'contacts.access.givenBy': "Dado por {name} el {date}",
    'contacts.access.givenOn': "Dado el {date}",
    'contacts.access.revoke': "Quitar acceso",
    'contacts.access.revokeTitle': "¿Quitar este acceso?",
    'contacts.access.revokeBody': "Dejará de tener «{name}» en este momento. No se le avisa por correo.",
    'contacts.access.revoked': "Acceso quitado",
    'contacts.access.revokeFailed': "No se pudo quitar el acceso.",
    'contacts.access.dialogTitle': "Dar acceso",
    'contacts.access.dialogLead': "Una membresía, un paquete o un producto digital, sin cobro. Lo usa igual que si lo hubiera comprado.",
    'contacts.access.what': "Qué darle",
    'contacts.access.chooseOffer': 'Selecciona una oferta',
    'contacts.access.noMatches': 'No hay ofertas que coincidan con tu búsqueda.',
    'contacts.access.chooseDate': 'Selecciona una fecha',
    'contacts.access.nothing': "No tienes membresías, paquetes ni productos digitales que dar.",
    'contacts.access.howLong': "Por cuánto tiempo",
    'contacts.access.noEnd': "Sin fecha de fin",
    'contacts.access.untilDate': "Hasta una fecha",
    'contacts.access.packHint': "El paquete trae sus reservas y vale lo de su vigencia normal.",
    'contacts.access.note': "Nota interna",
    'contacts.access.notePlaceholder': "Ej.: cortesía por reseña",
    'contacts.access.notify': "Enviar correo de notificación",
    'contacts.access.notifyHint': "Le avisamos qué le diste y cómo entrar a su cuenta.",
    'contacts.access.giveCta': "Dar acceso",
    'contacts.access.given': "Acceso dado",
    'contacts.access.givenNotified': "Acceso dado y correo enviado",
    'contacts.access.giveFailed': "No se pudo dar el acceso.",
    'orders.granted': "Cortesía",
    'contacts.membership.fallbackTitle': "Membresía",
    'contacts.membership.state.active': "Activa",
    'contacts.membership.state.ending': "Se cancela",
    'contacts.membership.state.past_due': "Pago pendiente",
    'contacts.membership.state.paused': "En pausa",
    'contacts.membership.state.ended': "Terminada",
    'contacts.membership.per.day': "{price} al día",
    'contacts.membership.per.week': "{price} a la semana",
    'contacts.membership.per.month': "{price} al mes",
    'contacts.membership.per.year': "{price} al año",
    'contacts.membership.everyN': "{price} cada {count} {unit}",
    'contacts.membership.units.day': "días",
    'contacts.membership.units.week': "semanas",
    'contacts.membership.units.month': "meses",
    'contacts.membership.units.year': "años",
    'contacts.membership.renews': "Se renueva el {date}",
    'contacts.membership.endsOn': "Termina el {date}",
    'contacts.membership.endedOn': "Terminó el {date}",
    'contacts.membership.cancelAtEnd': "Cancelar al final del periodo",
    'contacts.membership.cancelNow': "Cancelar ya",
    'contacts.membership.manage': "Gestionar",
    'contacts.membership.cancelAtEndTitle': "¿Cancelar al final del periodo?",
    'contacts.membership.cancelAtEndBody': "«{name}» sigue activa hasta el {date} y ya no se vuelve a cobrar. Tu cliente la ve como «Se cancela» en su cuenta.",
    'contacts.membership.cancelNowTitle': "¿Cancelar la membresía ya?",
    'contacts.membership.cancelNowBody': "«{name}» termina en este momento y no se vuelve a cobrar. No se devuelve el dinero del periodo en curso: si quieres devolverlo, hazlo desde Pedidos.",
    'contacts.membership.cancelled': "Membresía cancelada.",
    'contacts.source.purchase': 'Compra',
    'contacts.source.manual': 'Manual',
    'contacts.actions': 'Acciones',
    'contacts.unspam': 'Quitar de spam',
    'contacts.markSpam': 'Marcar como spam',
    'contacts.unblock': 'Desbloquear',
    'contacts.block': 'Bloquear',
    'contacts.delete': 'Eliminar',
    'contacts.deleteContact': 'Eliminar contacto',
    'contacts.moreActions': "Más acciones",
    'contacts.tab.activity': 'Actividad',
    'contacts.tab.forms': 'Formularios',
    'contacts.tab.purchases': 'Compras',
    'contacts.tab.bookings': 'Reservas',
    'contacts.tab.notes': 'Notas',
    'contacts.tab.memberships': "Membresías",
    'contacts.membershipsTab.empty': "No tiene membresías ni paquetes.",
    'contacts.membershipsTab.pack': "Paquete",
    'contacts.membershipsTab.packDone': "Agotado",
    'contacts.membershipsTab.left': "le quedan {remaining} de {limit}",
    'contacts.membershipsTab.expires': "caduca el {date}",
    'contacts.membershipsTab.free': "Gratis",
    'contacts.membershipsTab.discount': "{percent} % de descuento",
    'contacts.membershipsTab.since': "desde el {date}",
    'contacts.membershipsTab.leftFree': "Salió",
    'contacts.activity.sentForm': 'Envió {form}',
    'contacts.activity.bought': 'Compró {offer}',
    'contacts.activity.refunded': 'Se le devolvió {offer}',
    'contacts.activity.booked': 'Reservó {service}',
    'contacts.activity.rescheduled': 'Reprogramó {service}',
    'contacts.activity.rescheduledCustomer': 'El cliente reprogramó {service}',
    'contacts.activity.rescheduledBy': '{name} reprogramó {service}',
    'contacts.activity.rescheduledTeam': 'El equipo reprogramó {service}',
    'contacts.activity.scheduleUpdated': 'Fecha y hora actualizadas',
    'contacts.activity.previousDate': 'Fecha anterior',
    'contacts.activity.newDate': 'Nueva fecha',
    'contacts.activity.openNote': 'Abrir esta nota en Notas',
    'contacts.activity.note': 'Nota de {author}',
    'contacts.activity.joined': 'Entró a contactos',
    'contacts.activity.internalNote': 'Nota interna del equipo',
    'contacts.activity.viewOrder': 'Ver pedido y recibo',
    'contacts.activity.orderFailed': 'No se pudo abrir el pedido.',
    'contacts.activity.bookingFailed': 'No se pudo abrir la reserva.',
    'contacts.card.answerOne': '{count} respuesta',
    'contacts.card.answersMany': '{count} respuestas',
    'contacts.booking.whenLabel': 'Cita',
    'contacts.booking.resourceLabel': 'Con',
    'contacts.booking.bookedAtLabel': 'Reservada el',
    'contacts.booking.noResource': 'Sin recurso asignado',
    'contacts.booking.durationMinuteOne': '{count} min',
    'contacts.booking.durationMinutesMany': '{count} min',
    'contacts.booking.durationHourOne': '{count} h',
    'contacts.booking.durationHoursMany': '{count} h',
    'contacts.purchase.reference': 'Pedido #{reference}',
    'contacts.purchase.status.paid': 'Pagado',
    'contacts.purchase.status.refunded': 'Reembolsado',
    'contacts.purchase.status.pending': 'Pendiente',
    'contacts.purchase.status.failed': 'Fallido',
    'contacts.purchase.status.cancelled': 'Cancelado',
    'contacts.purchase.status.unknown': 'Sin estado',
    'contacts.activity.showMore': 'Mostrar más',
    'contacts.activity.empty': 'Todavía no hay actividad registrada para este contacto.',
    'contacts.answer': 'Respuesta',
    'contacts.message.status.unread': 'Nuevo',
    'contacts.message.status.read': 'Leído',
    'contacts.message.status.spam': 'Spam',
    'contacts.forms.empty': 'Aún no ha enviado formularios.',
    'contacts.booking.deletedService': 'Servicio borrado',
    'contacts.booking.overdue': 'Ya pasó y falta registrar el resultado',
    'contacts.booking.withResource': 'Con {resource}',
    'contacts.booking.empty': 'Aún no ha reservado ninguna cita con este correo.',
    'contacts.booking.status.held': 'Apartada',
    'contacts.booking.status.confirmed': 'Confirmada',
    'contacts.booking.status.cancelled': 'Cancelada',
    'contacts.booking.status.completed': 'Asistió',
    'contacts.booking.status.no_show': 'No asistió',
    'contacts.purchase.deletedOffer': 'Oferta borrada',
    'contacts.purchase.empty': 'Aún no hay compras asociadas a este correo.',
    'contacts.notes.placeholder': 'Escribe una nota interna sobre esta persona…',
    'contacts.notes.emptyTitle': 'Sin notas internas',
    'contacts.notes.emptyBody': 'Agrega contexto para que el equipo tenga el historial completo de esta persona.',
    'contacts.notes.full': 'Las notas de esta persona están al tope. Borra una para seguir escribiendo.',
    'contacts.searchAria': 'Buscar contacto',
    'contacts.searchPlaceholder': 'Buscar contacto…',
    'contacts.clearSearch': 'Limpiar búsqueda',
    'contacts.starred': 'destacados',
    'contacts.filtersAria': 'Filtros y orden',
    'contacts.filtersDialogAria': 'Filtros y orden de contactos',
    'contacts.filterTitle': 'Filtrar contactos',
    'contacts.closeFilters': 'Cerrar filtros',
    'contacts.all': 'Todos',
    'contacts.resetFilters': 'Restablecer filtros',
    'contacts.exportCsv': 'Exportar CSV',
    'contacts.exportCsvAria': 'Exportar contactos a CSV',
    'contacts.add.title': 'Agregar contacto',
    'contacts.add.short': 'Agregar',
    'contacts.add.subtitle': 'Crea un contacto manual dentro de este proyecto.',
    'contacts.add.initialNote': 'Nota inicial',
    'contacts.add.initialNotePlaceholder': 'Información relevante sobre este contacto…',
    'contacts.add.limitError': 'Alcanzaste el límite de 100 contactos del plan gratuito.',
    'contacts.add.saveError': 'No pudimos guardar el contacto. Revisa los datos e inténtalo de nuevo.',
    'contacts.star': 'Destacar',
    'contacts.loadFailed': 'No pudimos cargar los contactos.',
    'contacts.emptyTitle': 'Todavía no tienes contactos',
    'contacts.emptyBody': 'Se llenan solos: quien escribe por un formulario, compra o reserva aparece aquí. También puedes agregar a alguien a mano.',
    'contacts.noResultsTitle': 'No encontramos contactos',
    'contacts.noResultsBody': 'Prueba con otra búsqueda o quita los filtros.',
    'contacts.clearFilters': 'Limpiar filtros',
    'contacts.unit': 'contactos',
    'contacts.unselectAll': 'Quitar la selección de todos',
    'contacts.selectAll': 'Seleccionar todos los de esta página',
    'contacts.selectContact': 'Seleccionar a {name}',
    'contacts.starContact': 'Destacar a {name}',
    'contacts.col.name': 'Nombre',
    'contacts.col.email': 'Correo',
    'contacts.col.source': 'Contacto inicial',
    'contacts.col.lastSeen': 'Última interacción',
    'contacts.col.created': 'Creado',
    'contacts.view': 'Ver contacto',
    'contacts.moreOptions': 'Más opciones',
    'contacts.options': 'Opciones',
    'contacts.write': 'Escribir',
    'contacts.editDialog.title': 'Editar contacto',
    'contacts.editDialog.subtitle': 'Corrige el nombre o añade un teléfono.',
    'contacts.editDialog.save': 'Guardar cambios',
    'contacts.bulkDelete.titleOne': 'Eliminar 1 contacto',
    'contacts.bulkDelete.titleMany': 'Eliminar {count} contactos',
    'contacts.bulkDelete.body': 'Se eliminarán los contactos seleccionados junto con los mensajes que tengan asociados. Esta acción no se puede deshacer.',
    'contacts.deleteDialog.title': 'Eliminar contacto',
    'contacts.deleteDialog.prefix': 'Se eliminará',
    'contacts.deleteDialog.withMessages': 'junto con sus {count} {messages}',
    'contacts.deleteDialog.undone': '. Esta acción no se puede deshacer.',
    'contacts.messageOne': 'mensaje recibido',
    'contacts.messageMany': 'mensajes recibidos',
    'contacts.deleting': 'Eliminando…',
    'contacts.deletedOne': '1 contacto eliminado',
    'contacts.deletedMany': '{count} contactos eliminados',
    'contacts.deletedPartial': 'Se eliminaron {done} de {total}',
    'contacts.csv.name': 'Nombre',
    'contacts.csv.email': 'Correo',
    'contacts.csv.phone': 'Teléfono',
    'contacts.csv.tags': 'Etiquetas',
    'contacts.csv.status': 'Estado',
    'contacts.csv.source': 'Origen',
    'contacts.csv.forms': 'Formularios',
    'contacts.csv.firstSeen': 'Primera interacción',
    'contacts.csv.lastSeen': 'Última interacción',
    'contacts.csv.note': 'Nota',
    'contacts.csv.filename': 'contactos',
    // ── Selector de periodo y comparación ─────────────────────────────────────────
    'range.today': 'Hoy',
    'range.yesterday': 'Ayer',
    'range.last7': 'Últimos 7 días',
    'range.last30': 'Últimos 30 días',
    'range.last90': 'Últimos 90 días',
    'range.last12m': 'Últimos 12 meses',
    'range.lastWeek': 'Semana pasada',
    'range.lastMonth': 'Mes pasado',
    'range.lastYear': 'Año pasado',
    'range.group.rolling': 'Hasta ayer',
    'range.group.calendar': 'Periodos completos',
    'range.period': 'Periodo',
    'range.custom': 'Personalizado',
    'range.pickAria': 'Elegir periodo',
    'range.pickStart': 'Elige la fecha inicial',
    'range.prevMonth': 'Mes anterior',
    'range.nextMonth': 'Mes siguiente',
    'range.group.shortcuts': 'Atajos',
    'range.next7': 'Próximos 7 días',
    'range.next30': 'Próximos 30 días',
    'range.thisMonth': 'Este mes',
    'range.comingMonth': 'El mes que viene',
    'range.compare.trigger': 'Comparar',
    'range.compare.aria': 'Comparar con',
    'range.compare.previous': 'Periodo anterior',
    'range.compare.previousHint': 'El tramo de la misma duración justo antes',
    'range.compare.year': 'Año anterior',
    'range.compare.yearHint': 'Las mismas fechas del año pasado',
    'range.compare.none': 'Sin comparación',
    'range.compare.noneHint': 'Sólo el periodo elegido',
    // ── Gráficas ──────────────────────────────────────────────────────────────────
    'chart.empty': 'Todavía no hay nada que dibujar. En cuanto entre el primer dato, aquí sale la evolución día a día.',
    'chart.chosenPeriod': 'Periodo elegido',
    'traffic.title': 'Tráfico general',
    'traffic.perHour': 'Vistas de página por hora',
    'traffic.perDay': 'Vistas de página por día',
    'traffic.views': 'Vistas',
    'traffic.uniques': 'Únicos',
    'analyticsCommon.comparedWith': 'Comparado con',
    // ── Estadísticas de una página ────────────────────────────────────────────────
    'pageStats.fallbackName': 'Página',
    'pageStats.subtitle': 'Estadísticas de una página',
    'pageStats.back': 'Volver a páginas',
    'pageStats.openEditor': 'Abrir en Editor',
    'pageStats.menuAria': 'Ajustes de la página',
    'pageStats.menu.editor': 'Abrir en editor',
    'pageStats.menu.settings': 'Ajustes',
    'pageStats.menu.stats': 'Estadísticas',
    'pageStats.menu.preview': 'Vista previa',
    'pageStats.menu.published': 'Abrir publicada',
    'pageStats.menu.copyLink': 'Copiar enlace',
    'pageStats.menu.duplicate': 'Duplicar',
    'pageStats.menu.rename': 'Cambiar nombre',
    'pageStats.menu.setHome': 'Establecer como inicio',
    'pageStats.menu.delete': 'Eliminar',
    'pageStats.published': 'Publicada',
    'pageStats.draft': 'Borrador',
    'pageStats.created': 'Creada',
    'pageStats.updated': 'Última edición',
    'pageStats.heading': 'Estadísticas',
    'pageStats.loadFailed': 'No pudimos cargar las estadísticas de esta página.',
    'pageStats.views': 'Vistas de página',
    'pageStats.share': 'Del tráfico del sitio',
    'pageStats.share.hint': 'Cuánto de todo el tráfico pasó por aquí',
    'pageStats.forms': 'Formularios enviados',
    'pageStats.forms.meta': 'Mensajes recibidos desde esta página',
    // ── Analíticas de ventas ──────────────────────────────────────────────────────
    'salesAn.title': 'Analíticas de ventas',
    'salesAn.subtitle': 'Cuánto vendes, qué se vende y quién compra.',
    'salesAn.loadFailed': 'No se pudieron cargar las analíticas de ventas.',
    'salesAn.emptyTitle': 'Aún no hay ventas',
    'salesAn.emptyBody': 'Cuando alguien compre en tu sitio, aquí verás cuánto facturaste, qué se vendió y quién lo compró.',
    'salesAn.emptyCta': 'Crea tu primera oferta',
    'salesAn.otherCurrencies.lead': 'Las cifras de abajo son sólo de {currency}. También cobraste',
    'salesAn.otherCurrencies.in': 'en {currency}',
    'salesAn.otherCurrencies.tail': ', que no se suman aquí porque son unidades distintas.',
    'salesAn.revenue': 'Ingresos netos',
    'salesAn.revenue.note': 'Lo cobrado menos lo devuelto. No descuenta la comisión de Stripe, que no se guarda al cobrar.',
    'salesAn.orders': 'Ventas',
    'salesAn.orders.note': 'Cobros cobrados en el tramo, devoluciones incluidas: la venta ocurrió aunque luego se devolviera.',
    'salesAn.aov': 'Ticket promedio',
    'salesAn.aov.note': 'Los ingresos netos entre el número de ventas.',
    'salesAn.customers': 'Clientes',
    'salesAn.customers.hint': '{new} · {returning} que vuelven',
    'salesAn.customers.note': 'Compradores distintos, por correo. Quien compró dos veces cuenta como uno.',
    'salesAn.chart.title': 'Ingresos',
    'salesAn.chart.perHour': 'Ingresos netos por hora',
    'salesAn.chart.perDay': 'Ingresos netos por día',
    'salesAn.chart.revenue': 'Ingresos',
    'salesAn.chart.orders': 'Ventas',
    'salesAn.gross': 'Cobrado',
    'salesAn.gross.note': 'Todo lo que entró, antes de descontar devoluciones.',
    'salesAn.refunded': 'Devuelto',
    'salesAn.refunded.note': 'Reembolsos hechos sobre ventas de este tramo, totales y parciales.',
    'salesAn.newCustomers': 'Clientes nuevos',
    'salesAn.newCustomers.hint': '{percent}% de los del tramo',
    'salesAn.newCustomers.none': 'Sin compras en este tramo',
    'salesAn.newCustomers.note': 'Compradores sin ninguna compra anterior a estas fechas, por muy antiguo que sea el sitio.',
    'salesAn.disputes': 'Disputas',
    'salesAn.disputes.hint': '{amount} en juego',
    'salesAn.disputes.none': 'Ninguna en este tramo',
    'salesAn.disputes.note': 'Ventas que el comprador reclamó a su banco. Se responden desde la ficha del cobro.',
    'salesAn.topOffers': 'Lo más vendido',
    'salesAn.offerDeleted': 'La oferta se borró',
    'salesAn.topCustomers': 'Mejores clientes',
    'salesAn.recentSales': 'Ventas recientes',
    'salesAn.unnamed': 'Sin nombre',
    'salesAn.chargeType': 'Tipo de cobro',
    'salesAn.oneTime': 'Pago único',
    'salesAn.subscription': 'Suscripción',
    'salesAn.newVsReturning': 'Clientes nuevos y recurrentes',
    'salesAn.new': 'Nuevos',
    'salesAn.returning': 'Recurrentes',
    'salesAn.statusTitle': 'Estado de las ventas',
    'salesAn.status.paid': 'Pagadas',
    'salesAn.status.partiallyRefunded': 'Devueltas a medias',
    'salesAn.status.refunded': 'Devueltas',
    'salesAn.noSales': 'Sin ventas en este tramo.',
    'salesAn.noBuyers': 'Sin compradores en este tramo.',
    'salesAn.noCharges': 'Sin cobros en este tramo.',
    'salesAn.unit.saleOne': '{count} venta',
    'salesAn.unit.saleMany': '{count} ventas',
    'salesAn.unit.chargeOne': '{count} cobro',
    'salesAn.unit.chargeMany': '{count} cobros',
    'salesAn.unit.newOne': '{count} nuevo',
    'salesAn.unit.newMany': '{count} nuevos',
    'salesAn.unit.refundedOne': '{count} venta con devolución',
    'salesAn.unit.refundedMany': '{count} ventas con devolución',
    'salesAn.unit.sales': 'ventas',
    'salesAn.unit.customers': 'clientes',
    'salesAn.unit.ofRevenue': 'de ingresos',
    // ── Analíticas de reservas ────────────────────────────────────────────────────
    'bookingsAn.title': 'Analíticas de reservas',
    'bookingsAn.subtitle': 'Cuántas citas tienes, cuántas se cumplen y cuándo.',
    'bookingsAn.loadFailed': 'No se pudieron cargar las analíticas de reservas.',
    'bookingsAn.emptyTitle': 'Aún no hay citas',
    'bookingsAn.emptyBody': 'Cuando alguien reserve contigo, aquí verás cuántas citas tuviste, cuántas se cumplieron y qué servicios llenan tu agenda.',
    'bookingsAn.emptyCta': "Crear una cita",
    'bookingsAn.otherCurrencies.lead': 'Los ingresos de abajo son sólo de {currency}. También cobraste',
    'bookingsAn.otherCurrencies.in': 'en {currency}',
    'bookingsAn.otherCurrencies.tail': ', que no se suman aquí porque son unidades distintas.',
    'bookingsAn.bookings': 'Citas',
    'bookingsAn.bookings.upcoming': '{count} todavía por venir',
    'bookingsAn.bookings.note': 'Citas cuya HORA cae en el tramo, sea cual sea el día en que se reservaron. Cada asistente de una clase cuenta como una.',
    'bookingsAn.excluded': 'Fuera de la cuenta',
    'bookingsAn.excluded.detail': '{holds} que caducaron sin pagarse',
    'bookingsAn.attendance': 'Asistencia',
    'bookingsAn.attendance.hint': '{came} asistieron · {missed} no',
    'bookingsAn.attendance.none': 'Sin resultados registrados',
    'bookingsAn.attendance.note': 'Sobre las citas que ya tienen resultado registrado. Las que están por venir o sin marcar no entran: si entraran, una agenda llena diría que nadie asiste.',
    'bookingsAn.cancellations': 'Cancelaciones',
    'bookingsAn.cancellations.hint': '{percent} de las citas del tramo',
    'bookingsAn.cancellations.note': 'Canceladas por el cliente o por ti. No incluye los apartados que caducaron sin pagarse: ésos nunca llegaron a ser una cita.',
    'bookingsAn.revenue': 'Ingresos de citas',
    'bookingsAn.revenue.hint': 'de {bookings}',
    'bookingsAn.revenue.note': 'Lo cobrado en línea menos lo devuelto, sólo de las citas con pago por adelantado o anticipo. Lo que se cobra en el local no pasa por aquí.',
    'bookingsAn.chart.title': 'Citas',
    'bookingsAn.chart.perHour': 'Citas por hora',
    'bookingsAn.chart.perDay': 'Citas por día',
    'bookingsAn.chart.bookings': 'Citas',
    'bookingsAn.chart.attended': 'Asistieron',
    'bookingsAn.hours': 'Horas en agenda',
    'bookingsAn.hours.note': 'El tiempo que estuvo ocupado de verdad. Una clase de seis personas ocupa una hora, no seis. Las canceladas no cuentan: el hueco volvió a quedar libre.',
    'bookingsAn.customers': 'Clientes',
    'bookingsAn.customers.hint': '{new} · {returning} que vuelven',
    'bookingsAn.customers.note': 'Personas distintas, por correo. Quien vino dos veces cuenta como una; quien no dejó correo cuenta como una cada vez.',
    'bookingsAn.leadTime': 'Antelación media',
    'bookingsAn.leadTime.before': 'antes: {value}',
    'bookingsAn.leadTime.note': 'Cuánto pasa, de media, entre que alguien reserva y la hora de su cita. Sirve para saber con cuánto margen se llena la agenda.',
    'bookingsAn.pending': 'Sin registrar',
    'bookingsAn.pending.hint': 'Ya pasaron y falta decir cómo acabaron',
    'bookingsAn.pending.none': 'Todo al día',
    'bookingsAn.pending.note': 'Citas cuya hora ya pasó y siguen en «apartada» o «confirmada». Mientras no se marquen, la asistencia de arriba se calcula sin ellas. Se marcan desde Citas.',
    'bookingsAn.topServices': 'Servicios más reservados',
    'bookingsAn.service.sub': '{came} · {missed} no',
    'bookingsAn.serviceDeleted': 'El servicio se borró',
    'bookingsAn.topCustomers': 'Quién más reserva',
    'bookingsAn.unnamed': 'Sin nombre',
    'bookingsAn.customer.noShow': '{count} sin asistir',
    'bookingsAn.outcome': 'Cómo acabaron',
    'bookingsAn.outcome.attended': 'Asistió',
    'bookingsAn.outcome.noShow': 'No asistió',
    'bookingsAn.outcome.cancelled': 'Cancelada',
    'bookingsAn.outcome.empty': 'Ninguna cita del tramo ha terminado todavía.',
    'bookingsAn.weekdays': 'Días de la semana',
    'bookingsAn.resources': 'Quién las atiende',
    'bookingsAn.newVsReturning': 'Clientes nuevos y recurrentes',
    'bookingsAn.new': 'Nuevos',
    'bookingsAn.returning': 'Recurrentes',
    'bookingsAn.noBookings': 'Sin citas en este tramo.',
    'bookingsAn.noCustomers': 'Sin clientes en este tramo.',
    'bookingsAn.unit.bookingOne': '{count} cita',
    'bookingsAn.unit.bookingMany': '{count} citas',
    'bookingsAn.unit.holdOne': '{count} apartado',
    'bookingsAn.unit.holdMany': '{count} apartados',
    'bookingsAn.unit.prepaidOne': '{count} cita prepagada',
    'bookingsAn.unit.prepaidMany': '{count} citas prepagadas',
    'bookingsAn.unit.attendedOne': '{count} asistió',
    'bookingsAn.unit.attendedMany': '{count} asistieron',
    'bookingsAn.unit.newOne': '{count} nuevo',
    'bookingsAn.unit.newMany': '{count} nuevos',
    'bookingsAn.unit.bookings': 'citas',
    'bookingsAn.unit.customers': 'clientes',
    'bookingsAn.dur.minutes': '{count} min',
    'bookingsAn.dur.hours': '{count} h',
    'bookingsAn.dur.hoursMinutes': '{hours} h {minutes} min',
    'bookingsAn.dur.days': '{count} días',
    // ── Google Analytics ──────────────────────────────────────────────────────
    'ga.checking': 'Revisando…',
    'ga.checkingBody': 'Un momento.',
    'ga.connected': 'Conectado',
    'ga.connectedBody': 'Las visitas se envían a {id}. Pueden tardar unos minutos en verse en Google Analytics (en «Tiempo real»).',
    'ga.notConnected': 'Sin conectar',
    'ga.emptyBody': 'Pega el ID de medición de tu flujo de datos web. Empieza por «G-».',
    'ga.statusOk': 'Activo',
    'ga.idLabel': 'ID de medición',
    'ga.changeId': 'Cambiar el ID de medición',
    'ga.placeholder': 'G-XXXXXXXXXX',
    'ga.detected': 'ID válido: {id}.',
    'ga.notDetected': 'Ése no parece un ID de GA4: empieza por «G-» (los «UA-» ya no funcionan).',
    'ga.where': 'Está en Google Analytics › Administrar › Flujos de datos › tu sitio web.',
    'ga.openGa': 'Abrir Google Analytics',
    'ga.connect': 'Conectar',
    'ga.saveNew': 'Guardar el nuevo ID',
    'ga.disconnect': 'Desconectar',
    'ga.confirmDisconnect': 'Sí, desconectar',
    'ga.cancel': 'Cancelar',
    'ga.disconnectNote': 'Las páginas dejarán de enviar visitas a Google Analytics al instante. Lo ya medido sigue en tu cuenta de Google.',
    'ga.saveFailed': 'No se pudo guardar. Inténtalo de nuevo.',
    'ga.adminOnly': 'Sólo quien administra el sitio puede conectar Google Analytics.',
    'ga.privacyTitle': 'Privacidad y cookies, resuelto',
    'ga.privacy1': 'Visitas desde la Unión Europea, el Reino Unido y Suiza: sale un aviso con «Aceptar» y «Rechazar», y Google Analytics no se carga hasta que acepten.',
    'ga.privacy2': 'Resto del mundo (Estados Unidos, México…): se carga sin aviso, como es lo normal allí.',
    'ga.privacy3': 'Si el navegador pide no ser rastreado (Global Privacy Control), no se carga. Y tus propias visitas con la barra de administración no cuentan.',
    'ga.title': 'Google Analytics',
    'ga.description': 'Pega tu ID de medición y la etiqueta de Google se añade sola a todas las páginas publicadas, sin republicar.',
    'ga.builtIn': 'Analíticas de véltica',
    'ga.builtInBody': 'Siguen funcionando aparte, sin cookies: visitas, páginas y fuentes de tráfico desde el panel.',
    'ga.open': 'Abrir Analíticas',
    // ── Ofertas ───────────────────────────────────────────────────────────────
    /* Las tres etiquetas de abajo las comparten la lista, la ficha y el alta, así
       que viven aquí y no en la sección de cada una. Los mapas que las eligen
       están en `offerShared.ts`, y guardan la CLAVE, no el texto: son constantes
       de módulo y no pueden llamar a un hook. */
    'offers.status.draft': 'Borrador',
    'offers.status.active': 'Público',
    'offers.status.archived': 'Retirada',
    'offers.interval.one_time': 'Pago único',
    'offers.interval.month': 'Mensual',
    'offers.interval.year': 'Anual',
    'offers.type.digital': 'Producto digital',
    'offers.type.service': 'Servicio',
    'offers.type.course': 'Curso',
    'offers.type.physical': 'Producto físico',
    'offers.statusAria': 'Estado de {name}',
    'offers.noPrice': 'Sin precio',
    'offers.noRevenue': 'Todavía no ha generado nada',
    'offers.searchAria': 'Buscar oferta',
    'offers.searchPlaceholder': 'Buscar oferta...',
    'offers.clearSearch': 'Limpiar búsqueda',
    'offers.starLabel': 'destacadas',
    'offers.filtersAria': 'Filtros y orden',
    'offers.filtersDialogAria': 'Filtros y orden de ofertas',
    'offers.filterTitle': 'Filtrar ofertas',
    'offers.closeFilters': 'Cerrar filtros',
    'offers.filterKind': 'Qué es',
    'offers.kind.digital': 'Digital',
    'offers.kind.service': 'Servicio',
    'offers.kind.course': 'Curso',
    'offers.kind.physical': 'Producto físico',
    /* «Reserva» y no «Servicio con agenda»: es como se busca, y es la etiqueta que
       hace que la lista se lea igual que se piensa en ella. */
    'offers.kind.booking': 'Reserva',
    'offers.newKind.title': '¿Qué vas a vender?',
    'offers.newKind.lead': 'Cada una se configura distinto. Elige y te llevamos al sitio correcto: se puede cambiar después.',
    'offers.newKind.digitalBody': 'Un archivo que se descarga: una guía, una plantilla, un pack.',
    'offers.newKind.bookingBody': 'Una cita en tu calendario. Se abre en Reservas, con su horario.',
    'offers.newKind.serviceBody': 'Tu tiempo o tu trabajo, sin calendario detrás.',
    'offers.newKind.physicalBody': 'Algo que se envía o se recoge: pide la dirección al pagar.',
    'offers.newKind.courseBody': 'Lecciones que se siguen a lo largo del tiempo, con alumnos y progreso.',
    'offers.newKind.soon': 'Pronto',
    'offers.filterStatus': 'Estado',
    'offers.filter.all': 'Todas',
    'offers.filterStarred': 'Destacadas',
    'offers.allStars': 'Todas',
    'offers.onlyStarred': 'Sólo destacadas',
    'offers.resetFilters': 'Restablecer filtros',
    'offers.clearFilters': 'Limpiar filtros',
    'offers.new': 'Nueva oferta',
    'offers.newShort': 'Nueva',
    'offers.unit': 'ofertas',
    'offers.loadFailed': 'No pudimos cargar las ofertas.',
    'offers.retry': 'Reintentar',
    'offers.empty.title': 'Todavía no tienes ofertas',
    'offers.empty.body': 'Una oferta es lo que vendes: su nombre, su precio y lo que se lleva quien la compre.',
    'offers.noResults.title': 'No encontramos ofertas',
    'offers.noResults.body': 'Ninguna coincide con lo que buscas. Prueba con otro nombre o quita los filtros.',
    'offers.col.offer': 'Oferta',
    'offers.col.price': 'Precio',
    'offers.col.status': 'Estado',
    'offers.col.sales': 'Ventas',
    'offers.col.revenue': 'Generado',
    'offers.col.created': 'Creación',
    'offers.col.actions': 'Acciones',
    'offers.starAria': 'Destacar {title}',
    /* Singular y plural por separado: en inglés «1 sales» está mal, y una sola
       cadena con la «s» pegada fuera no se puede traducir sin romperla. */
    'offers.sales.one': '1 venta',
    'offers.sales.many': '{count} ventas',
    'offers.open': 'Abrir',
    'offers.moreOptions': 'Más opciones',
    'offers.options': 'Opciones',
    'offers.menu.open': 'Abrir ficha',
    'offers.menu.duplicate': 'Duplicar',
    'offers.menu.withdraw': 'Retirar',
    /* El sufijo de la copia va al catálogo porque acaba siendo el NOMBRE de una
       oferta que el cliente ve y edita: dejarlo en español fijo pondría «(copia)»
       dentro de un panel en inglés. */
    'offers.copySuffix': '(copia)',
    'offers.duplicated': 'Oferta duplicada',
    'offers.withdrawn': 'Oferta retirada',
    'offers.withdraw.title': 'Retirar la oferta',
    'offers.withdraw.body': 'Dejará de venderse y desaparecerá de esta lista. No se borra: los cobros que ya tenga seguirán pudiendo decir qué se vendió.',
    'offers.withdraw.confirm': 'Retirar',
    'offers.block.planTitle': 'Cobrar reservas es de los planes de pago',
    'offers.block.digitalPlanTitle': 'Vender productos digitales es de los planes de pago',
    'offers.block.servicePlanTitle': 'Cobrar por servicios es de los planes de pago',
    'offers.block.stripeTitle': 'Conecta Stripe para publicarlo',
    'offers.block.digitalStripeTitle': 'Conecta Stripe para ponerlo a la venta',
    'offers.block.planBody': 'Puedes crear y editar tus servicios en el plan gratis. Para cobrarlos en línea necesitas una membresía: es donde se conecta la cuenta que recibe el dinero.',
    'offers.block.digitalPlanBody': 'Puedes crear y preparar tus productos digitales en el plan gratis. Para venderlos en línea necesitas una membresía: es donde se conecta la cuenta que recibe el dinero.',
    'offers.block.stripeBody': 'Este servicio cobra en línea, así que para que alguien pueda reservarlo hace falta una cuenta donde llegue ese dinero.',
    'offers.block.digitalStripeBody': 'Este producto se cobra en línea, así que para que alguien pueda comprarlo hace falta una cuenta donde llegue ese dinero.',
    'offers.block.serviceStripeBody': 'Este servicio cobra en línea, así que para que alguien pueda contratarlo hace falta una cuenta donde llegue ese dinero.',
    'offers.block.aside': 'Mientras tanto se queda en borrador: lo sigues editando y nadie lo ve.',
    'offers.block.notNow': 'Ahora no',
    'offers.block.connecting': 'Conectando…',
    'offers.loadingOne': 'Cargando la oferta',
    'offers.loadingAll': 'Cargando tus ofertas',
    'offers.sectionTitle': 'Todas las ofertas',
    'offers.sectionSubtitle': 'Lo que vendes desde tu sitio: producto, precio, imágenes y descripción.',
    'offers.digital.sectionTitle': 'Productos digitales',
    'offers.digital.sectionSubtitle': 'Archivos que quien compra descarga al pagar: qué es, cuánto cuesta y qué se lleva.',
    'offers.physical.sectionTitle': 'Productos físicos',
    'offers.physical.sectionSubtitle': 'Lo que envías o entregas en mano: qué es, cuánto cuesta, cuántos quedan y cómo llega.',
    'offers.service.sectionTitle': 'Servicios',
    'offers.service.sectionSubtitle': 'Tu tiempo o tu trabajo, sin calendario detrás. Lo que se reserva con hora vive en Reservas.',
    // ── Ofertas · ficha ───────────────────────────────────────────────────────
    'offers.detail.back': 'Volver a ofertas',
    'offers.detail.changeThumbAria': 'Cambiar la miniatura',
    'offers.detail.addThumbAria': 'Subir una miniatura',
    'offers.detail.idCopied': 'Identificador copiado',
    'offers.detail.withdraw': 'Retirar',
    'offers.detail.withdrawBody': 'Dejará de venderse y desaparecerá de la lista. No se borra: los cobros que ya tenga seguirán pudiendo decir qué se vendió.',
    'offers.detail.removeImageAria': 'Quitar esta imagen',
    'offers.detail.removeImage': 'Quitar',
    'offers.detail.mediaFoot': 'Es la miniatura que sale en la lista y en la cabecera.',
    /* ── Dónde está la oferta, una vez publicada ───────────────────────────────
       Dos respuestas y no una: la gratuita tiene página propia —su formulario— y
       la de pago no, se vende con su botón dentro de tus páginas. */
    'offers.detail.link.copy': 'Copiar URL',
    'offers.detail.link.copied': 'Copiado',
    'offers.detail.link.open': 'Abrir',
    'offers.detail.link.needSite': 'Tendrá su propio enlace en cuanto publiques tu sitio.',
    'offers.detail.link.publishToGetLink': 'Publica la página para obtener enlace',
    /* Se llega aquí por un enlace guardado, no pulsando en el catálogo: esas
       filas van derechas a Reservas. El aviso dice dónde se edita. */
    'offers.detail.bookable.title': 'Ésta se reserva, no sólo se compra',
    'offers.detail.bookable.body': 'Es un servicio reservable, así que todo lo suyo (el precio, el horario, el cupo, la descripción y su política de cancelación) se edita en Reservas, en un solo asistente. Aquí sólo se lee: lo que se puede hacer es publicarla, retirarla o cambiarle la portada.',
    'offers.detail.bookable.open': 'Abrir en Reservas',
    'offers.detail.files.add': 'Añadir otro archivo',
    'offers.detail.files.hint': 'Hasta 15 MB cada uno. Cuenta en el peso de tu proyecto.',
    'offers.detail.files.full': 'Esta oferta ya tiene todos los archivos que admite. Quita uno para añadir otro.',
    'offers.detail.files.remove': 'Quitar',
    'offers.detail.files.removeAria': 'Quitar {name}',
    /* La pregunta que viene justo después de subir, contestada donde se hace. */
    /* Lo que todavía no se puede configurar, en una sola tarjeta: eran dos, una
       por pestaña, y seguidas se leían como dos listas de promesas distintas. */
    /* Dos pestañas: lo que ha vendido y lo que es. No reparten campos —eso se
       fue al asistente—, reparten dos cosas que no se miran a la vez. */
    'offers.detail.tabsAria': 'Secciones de la oferta',
    'offers.detail.hero.fileOne': '1 archivo',
    'offers.detail.hero.files': '{count} archivos',
    'offers.detail.tab.sales': 'Ventas',
    'offers.detail.tab.settings': 'Ajustes',
    /* ── La página de la oferta ───────────────────────────────────────────────
       Toda oferta tiene ya su dirección pública —comprar, reclamar o reservar— y
       esto es lo que decide cómo se ve fuera: su título en un buscador, lo que
       aparece al pegar el enlace y si se deja encontrar. Está en el panel y no en
       el editor porque una oferta no se abre en el editor: su página la sirve el
       servidor, y la oferta se crea, se cobra y se mide aquí.
  
       Los rótulos de los campos se toman de los ajustes de una página del editor
       —«Título para buscadores», «Igual que el SEO», «Sitemap»…—: es la misma
       decisión sobre otra página, y llamarla distinto según dónde se mire sería
       inventar un segundo vocabulario para lo mismo. Lo que sí es propio son las
       explicaciones, porque aquí lo que se indexa es algo que se vende. */
    'offers.detail.tab.page': 'Página',
    'offers.detail.tab.look': 'Apariencia',
    'offers.look.panel': 'Columna de la oferta',
    'offers.look.title': 'Nombre de la oferta',
    'offers.look.heading': 'Título de la compra',
    'offers.look.body': 'Descripción e introducción',
    'offers.look.price': 'Precio',
    'offers.look.badge': 'Etiqueta «Gratis»',
    'offers.look.badgeBook': 'Etiqueta «Reservar»',
    'offers.look.brandShow': 'En esta página',
    'offers.look.logoMode.text': 'Solo texto',
    'offers.look.logoMode.both': 'Logo y texto',
    'offers.look.logoMode.logo': 'Solo logo',
    'offers.look.logoMode.hide': 'Sin logo',
    'offers.look.noLogoImage': 'Tu marca no tiene imagen de logo',
    'offers.look.noBrandName': 'Tu marca no tiene nombre',
    'offers.look.logoHidden': 'La página no enseñará ningún logo.',
    'offers.look.logoNothing': 'Con esta opción no sale nada de tu marca.',
    'offers.look.brandEmpty': 'Tu marca todavía no tiene logo ni nombre.',
    'offers.look.brandEdit': 'Cambiar colores y logo de la marca',
    'offers.look.brandEditHint': 'Abre el editor en el paso de marca del tutorial. Los cambios se aplican a todo el sitio.',
    'offers.look.customized': '{count} personalizados',
    'offers.look.asToday': 'Como está ahora',
    'offers.look.defaultOption': 'Predeterminado',
    'offers.look.group.button': 'Botón',
    'offers.look.saved': 'Apariencia guardada',
    'offers.look.note': 'Usa los colores, estilos de texto y botones de tu sitio. Se ve en la página en cuanto guardas, sin volver a publicar.',
    'offers.page.saved': 'Ajustes de página guardados',
    'offers.page.address': 'Dirección',
    'offers.page.slugHint': 'Sólo letras, números y guiones. Los acentos y los espacios se convierten solos, y si esa dirección ya está ocupada se le añade un número.',
    'offers.page.seo': 'Buscadores',
    'offers.page.seoBody': 'Lo que Google enseña de esta oferta. Vacío usa el nombre y la descripción que ya tiene.',
    'offers.page.canonicalHint': 'La dirección buena cuando esto mismo se vende en más de un sitio. Vacío usa la suya, que es lo normal.',
    'offers.page.shareBody': 'Lo que se ve al pegar el enlace en WhatsApp, Instagram o un correo.',
    'offers.page.coverImage': 'Se usa la portada de la oferta.',
    'offers.page.customImage': 'Imagen propia para compartir.',
    'offers.page.useCover': 'Volver a la portada',
    'offers.page.visibilityBody': 'Quién puede llegar a esta página desde un buscador.',
    'offers.page.indexBody': 'Deja que Google y los demás la muestren en sus resultados.',
    'offers.page.sitemapBody': 'La incluye en el mapa del sitio que leen los buscadores para descubrir páginas nuevas.',
    'offers.page.draftNote': 'Mientras la oferta esté en borrador su página no existe para nadie: publícala para que estos ajustes cuenten.',
    'offers.detail.noDescription': 'Sin descripción',
    'offers.detail.card.offer': 'La oferta',
    'offers.detail.editAll': 'Editar todo',
    'offers.detail.visibility': 'Visibilidad',
    /* ── Las analíticas de una oferta ─────────────────────────────────────────
       Se calculan con sus propios cobros, así que hablan de ella y no del
       catálogo. Los rótulos de las cuatro cifras salen de Analíticas de venta:
       son las mismas y no pueden llamarse distinto según dónde se miren. */
    'offers.detail.tab.notices': 'Notificaciones',
    'offers.detail.tab.analytics': 'Analíticas',
    'offers.detail.analytics.claims': 'Entregas',
    'offers.detail.analytics.chart': 'Ventas de esta oferta',
    'offers.detail.analytics.chartFoot': 'Lo cobrado menos lo devuelto, día a día, en el periodo elegido.',
    'offers.detail.analytics.emptySales': 'Todavía no has vendido esta oferta. En cuanto entre la primera compra, aquí sale cómo va día a día.',
    'offers.detail.analytics.emptyClaims': 'Todavía no se la ha llevado nadie. En cuanto alguien la reclame, aquí sale cómo va día a día.',
    'offers.detail.analytics.otherCurrencies': 'Hay ventas en {count} moneda(s) más. No se suman aquí: cada una se cuenta por su lado, en Cobros.',
    'offers.detail.draftNotice.title': 'Esta oferta no está activa aún',
    'offers.detail.draftNotice.serviceTitle': 'Este servicio no está activo aún',
    'offers.detail.draftNotice.body': 'Está guardada en borrador. Cuando esté lista, publícala para que tus clientes puedan comprarla desde tu página.',
    'offers.detail.draftNotice.serviceBody': 'Está guardado en borrador. Cuando esté listo, publícalo para que tus clientes puedan contratarlo desde tu página.',
    'offers.detail.draftNotice.publish': 'Publicar',
    'offers.detail.fact.title': 'Nombre',
    'offers.detail.card.description': 'Descripción',
    'offers.detail.card.noDescription': 'Todavía no has añadido una descripción.',
    'offers.detail.card.meta': 'Detalles técnicos',
    'offers.detail.fact.files': 'Archivos',
    'offers.detail.fact.stock': 'Existencias',
    'offers.detail.soldOut': 'Agotado',
    'offers.detail.hero.stockUnlimited': 'Existencias sin límite',
    'offers.detail.edit': 'Editar',
    'offers.detail.fact.price': 'Precio',
    'offers.detail.fact.billing': 'Cobro',
    'offers.detail.fact.after': 'Después de pagar',
    /* En una palabra, para que quepan en el recuadro del resumen: las del
       selector están escritas para elegir, no para leerse de un vistazo. */
    'offers.detail.thankYou.shortDefault': 'Página incluida',
    'offers.detail.thankYou.shortPage': 'Una página tuya',
    'offers.detail.thankYou.shortUrl': 'Dirección externa',
    'offers.detail.id': 'Identificador',
    'offers.detail.copyIdAria': 'Copiar el identificador de la oferta',
    'offers.detail.copy': 'Copiar',
    'offers.detail.slug': 'Dirección',
    'offers.detail.slugHostExample': 'tusitio.com',
    'offers.detail.slugSaved': 'Dirección actualizada',
    'offers.detail.slugAdjusted': 'Esa dirección ya estaba ocupada. La oferta quedó en /{slug}.',
    'offers.detail.created': 'Creada',
    'offers.detail.updated': 'Última edición',
    /* Partida en dos porque el original lleva un espacio duro entre las frases
       para que no se separen al ajustar la línea. Traducir la frase entera con la
       marca dentro dejaría al traductor decidiendo dónde va un detalle de
       maquetación que no es suyo. */
    'offers.detail.thankYou.label': 'A dónde va el comprador',
    'offers.detail.thankYou.default': 'Página de gracias incluida',
    'offers.detail.thankYou.page': 'Una página de mi sitio',
    'offers.detail.thankYou.url': 'Una dirección externa',
    'offers.detail.thankYou.defaultFoot': 'Confirma la compra y muestra qué se pagó y cuánto. No hay que configurar nada.',
    'offers.detail.thankYou.pageLabel': 'Página',
    'offers.detail.thankYou.loading': 'Cargando…',
    'offers.detail.thankYou.pick': 'Elige una página',
    'offers.detail.thankYou.pageFoot': 'Si la borras más adelante, la compra vuelve a la página incluida en vez de romperse.',
    'offers.detail.thankYou.urlLabel': 'Dirección',
    'offers.detail.thankYou.urlFoot': 'Un grupo, un webinar, otra plataforma. Tiene que empezar por https://',
    'offers.price.removeAria': 'Retirar el precio de {price}',
    'offers.price.remove': 'Retirar precio',
    'offers.price.amount': 'Precio',
    'offers.price.currencyTitle': 'Se cambia en Configuración → Región y moneda',
    // ── Ofertas · alta ────────────────────────────────────────────────────────
    'offers.new.dialogAria': 'Nueva oferta',
    'offers.new.close': 'Cerrar',
    'offers.new.step.review': 'Revisar',
    'offers.new.titleLabel': 'Título',
    'offers.new.titleFoot': 'El nombre con el que la verá quien compre.',
    'offers.new.brandLabel': 'Marca',
    'offers.new.brandPlaceholder': 'Ej.: Nike, Apple…',
    'offers.new.brandFoot': 'Opcional. Sirve para armar colecciones por marca.',
    'offers.new.tagsFoot': 'Opcional. No se ven en el sitio: sirven para armar colecciones.',
    /* ── Lo mismo, dicho para un producto digital ──────────────────────────────
       La puerta ya prometió «Producto digital»; si aquí vuelve a poner «tu
       oferta» y un curso de ejemplo, parece que se abrió el formulario que no
       era. Sólo cambian las frases que dicen QUÉ se está montando. */
    /* La base del par: el asistente la usa a través de `say`, así que tiene que
       existir aunque la ficha tenga la suya con otra clave. */
    'offers.new.descriptionPlaceholder': 'Qué incluye, para quién es, qué se lleva quien la compre…',
    'offers.new.info.kickerDigital': 'Tu archivo',
    'offers.new.info.titleDigital': 'Describe tu producto',
    'offers.new.info.leadDigital': 'El nombre, qué incluye y su portada. Es lo que lee quien va a descargarlo antes de decidirse, y nada de esto es definitivo: todo se puede cambiar después.',
    'offers.new.titlePlaceholderDigital': 'Guía de cuidados de plantas (PDF)',
    'offers.new.descriptionPlaceholderDigital': 'Cuántas páginas, qué trae dentro, para quién es…',
    'offers.new.info.kickerPhysical': 'Tu producto',
    'offers.new.info.titlePhysical': 'Describe tu producto',
    'offers.new.info.leadPhysical': 'El nombre, qué es y una buena foto. Es lo que ve quien lo compra antes de pagar, y todo se puede cambiar después.',
    'offers.new.titlePlaceholderPhysical': 'Taza de cerámica hecha a mano',
    'offers.new.descriptionPlaceholderPhysical': 'Medidas, material, colores, cuidados…',
    'offers.new.shipping.kicker': 'Cómo llega',
    'offers.new.shipping.title': 'Existencias y envío',
    'offers.new.shipping.lead': 'Cuántas unidades tienes y cómo se las haces llegar. La dirección la pide Stripe al pagar.',
    'offers.new.shipping.stockLabel': 'Existencias',
    'offers.new.shipping.stockHint': 'Si las cuentas, cada venta descuenta las unidades compradas y al llegar a cero se muestra «Agotado».',
    'offers.new.shipping.unlimited': 'Sin límite',
    'offers.new.shipping.limited': 'Contar unidades',
    'offers.new.shipping.units': 'Unidades disponibles',
    'offers.new.shipping.unitsHint': 'Puedes cambiarlo cuando repongas.',
    'offers.new.step.variants': 'Variantes',
    'offers.new.variants.kicker': 'Variantes',
    'offers.new.variants.title': 'Tallas, colores y otras opciones',
    'offers.new.variants.lead': "Opcional. Añade tallas, colores u otras opciones; pulsa una variante para darle su foto, su precio y sus existencias. Sáltate este paso si el producto tiene una sola versión.",
    'offers.new.variants.none': 'Sin variantes',
    'offers.new.variants.stockByVariant': 'Existencias por variante',
    'offers.new.shipping.stockByVariant': 'Este producto tiene variantes: las existencias se llevan por talla o color en el paso «Variantes».',
    'offers.variants.empty.title': '¿Viene en más de una versión?',
    'offers.variants.empty.body': "Añade tallas, colores o materiales. Cada combinación puede tener su foto, su precio y sus existencias.",
    'offers.variants.preset.size': 'Talla',
    'offers.variants.preset.color': 'Color',
    'offers.variants.preset.material': 'Material',
    'offers.variants.preset.custom': 'Otra',
    'offers.variants.preset.customHint': 'Estilo, aroma, capacidad…',
    'offers.variants.suggest.size': 'XS, S, M, L, XL, XXL',
    'offers.variants.suggest.color': 'Negro, Blanco, Gris, Azul marino, Rojo, Verde, Beige',
    'offers.variants.suggest.material': 'Algodón, Lino, Poliéster, Lana, Piel',
    'offers.variants.namePlaceholder': 'Nombre de la opción, p. ej. Estilo',
    'offers.variants.valueCount': '{count} valores',
    'offers.variants.valueCountOne': '1 valor',
    'offers.variants.firstValue': 'Escribe un valor y pulsa Intro',
    'offers.variants.addShort': 'Añadir',
    'offers.variants.suggestions': 'Sugerencias',
    'offers.variants.addAll': 'Añadir todas',
    'offers.variants.addOption': 'Añadir opción:',
    'offers.variants.inventory': 'Inventario',
    'offers.variants.summary': '{count} variantes',
    'offers.variants.summaryOne': '1 variante',
    'offers.variants.summaryUnits': '{count} unidades',
    'offers.variants.summaryUnlimited': 'existencias sin límite',
    'offers.variants.summaryOff': '{count} sin vender',
    'offers.variants.bulkStock': 'Existencias para todas',
    'offers.variants.applyAll': 'Aplicar a todas',
    'offers.variants.allUnlimited': 'Todas sin límite',
    'offers.variants.generateSku': 'Generar SKU',
    'offers.variants.notSold': 'No se vende',
    'offers.variants.stopSelling': 'Dejar de vender esta',
    'offers.variants.startSelling': 'Vender esta',
    'offers.variants.inventoryHint': 'Deja las existencias vacías para no poner límite. Apaga las combinaciones que no fabricas: quien compra las ve como no disponibles.',
    'offers.variants.optionName': 'Opción',
    'offers.variants.valuesHint': 'Escribe un valor y pulsa Intro. Separa varios con comas.',
    'offers.variants.addValue': 'Añadir valor',
    'offers.variants.addValueAria': 'Añadir un valor a {name}',
    'offers.variants.removeValue': 'Quitar {value}',
    'offers.variants.removeOption': 'Quitar la opción {name}',
    'offers.variants.removeOptionShort': 'Quitar opción',
    'offers.variants.tableAria': 'Existencias por variante',
    'offers.variants.colVariant': 'Variante',
    'offers.variants.colStock': 'Existencias',
    'offers.variants.colSku': 'SKU',
    'offers.variants.colSelling': 'A la venta',
    'offers.variants.unlimited': 'Sin límite',
    'offers.variants.openVariant': "Abrir {variant}",
    'offers.variants.editAll': "Editar todas",
    'offers.variants.allVariants': "Todas las variantes",
    'offers.variants.dialog.lead': "Su foto, su precio y lo que queda. Se guarda al terminar el asistente.",
    'offers.variants.dialog.allLead': "Lo que escribas aquí se pone en todas las variantes. Un precio vacío no cambia ninguno.",
    'offers.variants.dialog.photo': "Foto",
    'offers.variants.dialog.upload': "Subir",
    'offers.variants.dialog.photoForAll': "Usarla en todas las «{value}»",
    'offers.variants.dialog.photoHint': "Al elegir esta variante en la tienda, la foto principal cambia a ésta.",
    'offers.variants.dialog.pricing': "Precio",
    'offers.variants.dialog.compareAt': "Precio antes",
    'offers.variants.dialog.cost': "Costo por unidad",
    'offers.variants.dialog.compareLow': "El precio de antes tiene que ser mayor que el precio para salir tachado.",
    'offers.variants.dialog.margin': "Ganas {profit} por unidad · margen {margin} %",
    'offers.variants.dialog.pricingHint': "«Precio antes» sale tachado en la tienda. El costo sólo lo ves tú: sirve para calcular tu margen.",
    'offers.variants.dialog.barcode': "Código de barras",
    'offers.variants.dialog.barcodeHint': 'UPC, EAN, ISBN…',
    'offers.variants.dialog.stockHint': "Vacío = sin límite.",
    'offers.variants.dialog.sellingOn': "Se puede comprar.",
    'offers.variants.dialog.sellingOff': "En la tienda sale como no disponible.",
    'offers.variants.dialog.applyAll': "Aplicar a todas",
    'offers.variants.dialog.done': "Listo",
    'offers.variants.colPrice': 'Precio',
    'offers.variants.samePrice': 'Vacío = el precio del producto',
    'offers.variants.priceAria': 'Precio de {variant}',
    'offers.variants.priceInvalid': 'Revisa los precios de las variantes: tienen que ser un importe mayor que cero, o quedarse vacíos para usar el del producto.',
    'offers.variants.pickTone': 'Elegir el tono de {value}',
    'offers.variants.pickPhoto': 'Foto de {value}',
    'offers.variants.photoHint': 'Al elegir «{value}» en la tienda se enseña esta foto.',
    'offers.variants.noPhoto': 'Ninguna',
    'offers.variants.stockCard': 'Existencias por variante',
    'offers.variants.stockCardHint': 'Escribe cuántas quedan y guarda. Vacío = sin límite. Opciones, precios y SKU se cambian en el asistente.',
    'offers.variants.fewLeft': 'Quedan {count}',
    'offers.variants.stockSaveFailed': 'No se pudieron guardar las existencias. Inténtalo de nuevo.',
    'offers.variants.stockAria': 'Existencias de {variant}',
    'offers.variants.skuAria': 'SKU de {variant}',
    'offers.variants.sellingAria': 'Vender {variant}',
    'offers.variants.nameRequired': 'Ponle nombre a cada opción, como Talla o Color.',
    'offers.variants.valuesRequired': 'Añade al menos un valor a cada opción.',
    'offers.variants.tooMany': 'Hasta {max} combinaciones por producto. Quita algunos valores.',
    'offers.new.shipping.ratesLabel': 'Formas de envío',
    'offers.new.shipping.ratesHint': 'Son de todo tu sitio: las que añadas aquí valen para tus demás productos y se guardan al momento.',
    'offers.new.shipping.stockInvalid': 'Escribe cuántas unidades tienes (un número entero).',
    'offers.new.shipping.ratesRequired': 'Añade al menos una forma de envío o de recogida.',
    'offers.new.review.stockCount': '{count} en existencia',
    'offers.new.review.noRates': 'Sin formas de envío',
    'offers.new.uploadBodyDigital': 'La portada que se ve antes de descargar, no el archivo: ése va en el paso siguiente.',
    'offers.new.titlePlaceholder': 'Curso de fotografía',
    'offers.new.shortDescriptionLabel': 'Descripción corta',
    'offers.new.shortDescriptionPlaceholder': 'Qué es y su beneficio principal, en una o dos frases.',
    'offers.new.shortDescriptionFoot': 'Se muestra en cards y debajo del título, antes de las opciones de compra. Máximo 200 caracteres.',
    'offers.new.longDescriptionLabel': 'Descripción completa',
    'offers.new.longDescriptionFoot': 'Explica qué incluye y todos los detalles. Se muestra debajo del bloque de compra.',
    'offers.new.descriptionLabel': 'Descripción',
    'offers.new.descriptionFoot': 'Puedes dejarla para después y escribirla con calma en la ficha.',
    'offers.new.imageLabel': 'Portada',
    'offers.new.uploadTitle': 'Subir una portada',
    'offers.new.uploadBody': 'Es la portada de la oferta: la que sale en la lista y en tu página.',
    'offers.new.payType': 'Tipo de pago',
    'offers.new.file.label': 'El archivo que vendes',
    'offers.new.file.hint': 'Hasta 15 MB cada uno. Cuenta en el peso de tu proyecto, y puedes subir hasta 5.',
    'offers.new.file.pick': 'Elegir un archivo',
    'offers.new.file.tooLarge': 'Ese archivo pasa de 15 MB. Prueba con uno más ligero.',
    'offers.new.file.required': 'Sube el archivo que vas a entregar: sin él la oferta no puede vender nada.',
    'offers.new.file.rename': 'Cambiar el nombre',
    'offers.new.file.renameAria': 'Nombre del archivo',
    'offers.new.freeTitle': 'Gratis',
    'offers.new.freeBody': 'No hay nada que pagar. Dejan su nombre y su correo y es suyo. Tú te quedas el contacto, sin pasar por Stripe.',
    'offers.new.checkout.freeNote': 'Sin tarjeta. Sus datos llegan a Pagos como un pedido de 0.',
    'offers.new.checkout.get': 'Conseguirlo',
    'offers.new.checkout.ownSite': 'tu sitio',
    'offers.new.oneTimeTitle': 'Pago único',
    'offers.new.oneTimeBody': 'Se paga una vez y ya está.',
    'offers.new.subscriptionTitle': 'Suscripción',
    'offers.new.subscriptionBody': 'Se cobra solo cada periodo.',
    'offers.new.amountAria': 'Importe',
    /* ── Las cinco cadencias ───────────────────────────────────────────────────
       «Cada mes» y no «Mensual»: se lee junto al importe —«$199 · cada mes»— y
       ahí el adjetivo obliga a traducir mentalmente a cuándo se cobra. */
    'offers.cadence.week': 'Cada semana',
    'offers.cadence.biweek': "Cada 2 semanas",
    'offers.cadence.month': 'Cada mes',
    'offers.cadence.quarter': 'Cada 3 meses',
    'offers.cadence.half': 'Cada 6 meses',
    'offers.cadence.year': 'Cada año',
    'offers.new.cadence.label': 'Cada cuánto lo cobras',
    'offers.new.suffix.week': '/sem',
    'offers.new.suffix.biweek': '/2 semanas',
    'offers.new.suffix.quarter': '/3 meses',
    'offers.new.suffix.half': '/6 meses',
    'offers.interval.week': 'Semanal',
    'offers.new.amountInvalid': 'Escribe sólo el número, por ejemplo 199.00',
    /* Ya no es opcional: sin precio la oferta existe y no se puede vender, y el
       botón de compra revienta al pulsarlo. */
    'offers.new.amountRequired': 'Ponle precio. Sin él no se puede vender.',
    'offers.new.amountZero': 'Tiene que ser mayor que cero. Si es gratis, elige Gratis ahí arriba.',
    'offers.new.amountFoot': 'Lo que paga quien compra, en la moneda de tu proyecto. Se puede cambiar después: las ventas ya hechas conservan el precio de entonces.',
    'offers.new.compareAt': 'Precio antes (tachado)',
    'offers.new.compareAtFoot': 'Opcional. Se ve tachado junto al precio, con el descuento: así se anuncia una rebaja.',
    'offers.new.compareAtLow': 'Tiene que ser mayor que el precio; así no se guarda.',
    'offers.new.compareAtOff': 'Se verá con {percent}% de descuento.',
    'offers.new.review.title': 'Título',
    'offers.new.review.noTitle': 'Sin título',
    'offers.new.review.description': 'Descripción',
    'offers.new.review.noDescription': 'Sin descripción',
    'offers.new.review.billing': 'Cobro',
    /* Minúscula y sin punto: se pegan detrás del importe con un « · » delante,
       así que son el final de una línea, no una frase. */
    'offers.new.review.once': 'una sola vez',
    'offers.new.review.image': 'Imagen',
    'offers.new.review.noImage': 'Sin imagen',
    'offers.new.next.title': 'Qué pasa al crearla',
    /* La frase lleva «borrador» en negrita dentro, así que va partida: meter la
       etiqueta en la cadena obligaría al traductor a escribir HTML. */
    'offers.new.next.opens': 'Se abre su ficha, donde están el resto de imágenes y los precios.',
    'offers.new.next.sell': 'Cuando esté lista, la pones a la venta y añades su botón de compra en tu página.',
    /* ── El asistente, editando ────────────────────────────────────────────────
       La ficha se quedó con lo que el asistente no pregunta; todo lo demás se
       cambia aquí, por el paso al que lleve cada atajo de su resumen. */
    'offers.edit.dialogAria': 'Editar {name}',
    'offers.edit.save': 'Guardar cambios',
    'offers.edit.saving': 'Guardando…',
    'offers.edit.onSave': 'Al guardar',
    'offers.edit.file.pending': 'sin subir todavía',
    'offers.edit.otherPrices': 'Otros precios activos',
    'offers.edit.otherPricesHint': 'Esta oferta arrastra más de un precio. El de arriba es el que usa su botón de compra; éstos se pueden retirar, y se retiran al guardar.',
    'offers.edit.keepPrice': 'Conservar',
    'offers.edit.keepPriceAria': 'Conservar el precio de {price}',
    'offers.edit.review.imageOne': '1 imagen',
    'offers.edit.review.images': '{count} imágenes',
    'offers.edit.review.fileOne': '1 archivo',
    'offers.edit.review.files': '{count} archivos',
    'offers.edit.review.noFiles': 'Ninguno todavía',
    'offers.new.previewAria': 'Vista previa de la oferta',
    'offers.new.preview': 'Vista previa',
    /* La barra va pegada al importe —«$199/mes»—, así que no es una palabra
       suelta: en inglés es «/mo» y en otro idioma podría no llevar barra. */
    'offers.new.suffix.month': '/mes',
    'offers.new.suffix.year': '/año',
    'offers.new.back': 'Atrás',
    'offers.new.cancel': 'Cancelar',
    'offers.new.nextStep': 'Siguiente',
    'offers.new.creating': 'Creando…',
    'offers.new.create': 'Crear oferta',
    /* ── El asistente, reescrito sobre el armazón del de servicios ─────────────
       Cuatro pasos con raíl de iconos y la página de pago de Stripe maquetada al
       lado. Las claves viejas de los tres pasos anteriores siguen aquí porque
       siguen usándose: cambió el recorrido, no lo que se pregunta. */
    'offers.new.progressAria': 'Pasos del asistente',
    'offers.new.step.info': 'Información',
    'offers.new.step.files': 'Archivo',
    'offers.new.files.kicker': 'Qué se descarga',
    'offers.new.files.title': 'Sube lo que vendes',
    'offers.new.files.lead': 'Quien compra lo recibe justo después de pagar, en una página y por correo. Hasta 15 MB, y cuenta en el peso de tu proyecto.',
    'offers.new.step.price': 'Precio',
    'offers.new.step.delivery': 'Entrega',
    'offers.new.step.extra': "Más información",
    'offerFields.kicker': "Opcional",
    'offerFields.title': "Información adicional",
    'offerFields.lead': "Lo que hace distinta a ésta: ingredientes, cómo usarlo, qué incluye… Todas las de este tipo tienen los mismos campos y cada una rellena los suyos. La página los enseña donde los pusiste en el editor.",
    'offerFields.loading': "Cargando campos…",
    'offerFields.loadFailed': "No se pudieron cargar los campos. Vuelve a intentarlo en un momento.",
    'offerFields.empty': "Todavía no hay campos. Añade uno (por ejemplo «Ingredientes» o «Cómo usar») y rellénalo en cada una.",
    'offerFields.remove': "Quitar campo",
    'offerFields.removeOf': "Quitar el campo {name}",
    'offerFields.removeConfirm': "¿Quitar «{name}»? Desaparece de todas las de este tipo, con lo que tenga escrito.",
    'offerFields.imagePick': "Elegir imagen",
    'offerFields.imageChange': "Cambiar",
    'offerFields.imageRemove': "Quitar imagen",
    'offerFields.imageSet': "Con imagen",
    'offerFields.newName': "Nombre del campo",
    'offerFields.newPlaceholder': "p. ej. Ingredientes",
    'offerFields.newType': "Tipo",
    'offerFields.type.richText': "Texto con formato",
    'offerFields.type.text': "Texto corto",
    'offerFields.type.image': "Imagen",
    'offerFields.newHint': "Se añade a todas las de este tipo, vacío, para que todas tengan los mismos campos.",
    'offerFields.create': "Añadir campo",
    'offerFields.add': "Añadir campo",
    'offerFields.unset': "Sin rellenar",
    'offers.photos.label': "Otras fotos",
    'offers.photos.makeCover': "Usar de portada",
    'offers.photos.remove': "Quitar foto",
    'offers.photos.add': "Añadir fotos",
    'offerFields.newOption': "+ Nuevo campo…",
    'offerFields.newHintEditor': "Se añade a todas las de este tipo. Se rellena en cada una desde el panel.",
    'offerFields.createFailed': "No se pudo crear el campo. Vuelve a intentarlo.",
    'offers.new.step.shipping': 'Envío',
    'gallery.label': 'Fotos',
    'gallery.cover': 'Portada',
    'gallery.makeCover': 'Usar como portada',
    'gallery.add': 'Añadir foto',
    'gallery.moveLeft': 'Mover antes',
    'gallery.moveRight': 'Mover después',
    'gallery.hint': '{count} de {max}. Arrastra para ordenarlas; la primera es la portada: sale en la lista, en las tarjetas y al pagar.',
    'gallery.emptyHint': 'Hasta {max} fotos. La primera será la portada.',
    'offers.new.optional': 'Opcional',
    'offers.new.info.kicker': 'Qué vendes',
    'offers.new.info.title': 'Describe tu oferta',
    'offers.new.info.lead': 'El nombre, qué incluye y su portada. Es lo que lee quien va a comprar antes de decidirse, y nada de esto es definitivo: todo se puede cambiar después.',
    'offers.new.titleRequired': 'Ponle nombre. Es lo único sin lo que una oferta no puede existir.',
    'offers.new.price.kicker': 'Cuánto cuesta',
    'offers.new.price.title': 'Pon el precio',
    'offers.new.price.lead': 'Se cobra una vez, o cada periodo. Puedes dejar el importe para después: sin él la oferta existe, pero no se puede vender.',
    'offers.new.after.kicker': 'Qué pasa después',
    /* El paso volvió a ser sólo el destino: el tipo se elige en la puerta, así que
       el titular deja de prometer dos cosas y promete una. */
    'offers.new.after.landing': 'A dónde llega quien compra',
    'offers.new.after.landingLead': 'Al terminar de pagar, Stripe lo devuelve. Esto decide a dónde. La página incluida funciona desde el primer día, así que sólo vale la pena cambiarlo si ya tienes un sitio mejor.',
    'offers.new.after.landingLeadDigital': 'Al terminar de pagar, Stripe lo devuelve a la página con su descarga. La incluida funciona desde el primer día y lista los archivos, así que sólo vale la pena cambiarla si ya tienes un sitio mejor.',
    'offers.new.after.landingLeadPhysical': 'Al terminar de pagar, Stripe lo devuelve a tu sitio. La página incluida confirma la compra, y cuando marques el pedido como enviado le llega un correo con la guía.',
    'offers.new.after.pageHint': 'Una página de tu sitio: una bienvenida, las instrucciones, la descarga.',
    'offers.new.after.pageMissing': 'Elige qué página, o vuelve a la incluida.',
    'offers.new.after.urlInvalid': 'Tiene que ser una dirección completa que empiece por https://',
    'offers.new.after.previewTitle': 'A dónde llega',
    'offers.new.after.previewHint': 'Después de pagar',
    'offers.new.after.previewNote': 'Quien compra llega aquí desde Stripe, con el pago ya hecho. Nada de esto tienes que montarlo tú si no quieres.',
    'offers.new.thanks.title': 'Gracias por tu compra',
    'offers.new.thanks.body': 'La página incluida confirma el pago y dice qué se compró y por cuánto. Existe desde el primer día y no hay que configurar nada.',
    'offers.new.thanks.back': 'Volver al sitio',
    'offers.new.thanks.pagePending': 'La página que elijas',
    'offers.new.thanks.pageBody': 'Tu página, tal y como la montaste. Si la borras más adelante, la compra cae en la incluida en vez de romperse.',
    'offers.new.thanks.urlPending': 'La dirección que escribas',
    'offers.new.thanks.urlBody': 'Salen de tu sitio. Lo que haya al otro lado corre de tu cuenta: ahí no podemos confirmar la compra.',
    'offers.new.review.kicker': 'Revisión',
    'offers.new.review.title2': 'Repásala antes de crearla',
    'offers.new.review.lead': 'Todo lo que decidiste, junto. Cualquier cosa se puede seguir editando después desde la ficha de la oferta.',
    'offers.new.review.after': 'Después de pagar',
    'offers.new.review.edit': 'Editar',
    'offers.new.review.onCreate': 'Al crearla',
    'offers.new.review.draftHint': 'Nadie puede comprarla todavía. La pones a la venta desde su ficha cuando quieras.',
    'offers.new.review.needsPrice': 'Sin precio no hay nada que cobrar, así que sólo puede nacer en borrador. El precio se pone en su ficha.',
    'offers.new.review.needsStripe': 'Sin Stripe conectado el dinero no tiene a dónde ir, así que sólo puede nacer en borrador. Se conecta en el paso del Precio, o después desde Configuración.',
    'offers.new.next.live': 'Sale a la venta desde ya.',
    'offers.new.next.stays': 'Se queda en borrador: nadie puede comprarla todavía.',
    'offers.new.createPublish': 'Crear y poner a la venta',
    'offers.new.stripe.publishTitle': 'Para vender, conecta Stripe',
    'offers.new.stripe.reviewBody': 'La oferta se crea igual y conserva todo lo que escribiste. Lo único que espera es el cobro: el dinero entra en tu propia cuenta de Stripe, así que esa cuenta tiene que existir antes.',
    'offers.new.stripe.connect': 'Conectar Stripe',
    'offers.new.stripe.connecting': 'Abriendo…',
    'offers.new.previewHint': 'La página de pago de Stripe',
    'offers.new.preview.noteZoom': 'Se acerca a lo que estás editando. En el último paso la ves entera.',
    'offers.new.preview.noteFull': 'Es una idea de cómo queda, no una copia exacta: esta página la dibuja Stripe y cambia con el país y los métodos de pago de quien compra.',
    'offers.new.checkout.eyebrow': 'Pagar',
    'offers.new.checkout.email': 'Correo',
    'offers.new.checkout.card': 'Tarjeta',
    'offers.new.checkout.address': 'Dirección de envío',
    'offers.new.checkout.name': 'Nombre en la tarjeta',
    'offers.new.checkout.pay': 'Pagar',
    'offers.new.checkout.subscribe': 'Suscribirme',
    'offers.new.checkout.foot': 'Protegido por Stripe',
    // ── Cobros ────────────────────────────────────────────────────────────────
    'orders.status.paid': 'Pagado',
    'orders.status.free': 'Gratis',
    'orders.status.partial': 'Reembolso parcial',
    'orders.status.refunded': 'Reembolsado',
    'orders.loading': 'Cargando tus cobros…',
    'orders.title': 'Cobros',
    'orders.searchAria': 'Buscar cobro',
    'orders.searchPlaceholder': 'Buscar por comprador, correo u oferta...',
    'orders.clearSearch': 'Limpiar búsqueda',
    'orders.filtersAria': 'Filtros y orden',
    'orders.filtersDialogAria': 'Filtros y orden de cobros',
    'orders.filterTitle': 'Filtrar cobros',
    'orders.closeFilters': 'Cerrar filtros',
    'orders.filterPeriod': 'Periodo',
    'orders.period.all': 'Todo el tiempo',
    'orders.period.7': 'Últimos 7 días',
    'orders.period.30': 'Últimos 30 días',
    'orders.period.90': 'Últimos 90 días',
    'orders.filterOffer': 'Oferta',
    'orders.allOffers': 'Todas',
    'orders.resetFilters': 'Restablecer filtros',
    'orders.unit': 'cobros',
    'orders.loadFailed': 'No pudimos cargar los cobros.',
    'orders.retry': 'Reintentar',
    'orders.empty.title': 'Todavía no hay ventas',
    'orders.empty.body': 'Cuando alguien compre en tu sitio, el cobro aparecerá aquí en cuanto Stripe confirme el pago.',
    'orders.empty.offerTitle': 'Esta oferta no se ha vendido todavía',
    'orders.empty.offerBody': 'Cuando alguien la compre, el cobro aparecerá aquí en cuanto Stripe confirme el pago.',
    'orders.noResults.title': 'No encontramos cobros',
    'orders.noResults.body': 'Ninguno coincide con lo que buscas. Prueba con otro nombre o quita los filtros.',
    'orders.clearFilters': 'Limpiar filtros',
    'orders.deletedOffer': 'Oferta borrada',
    'orders.col.offer': 'Oferta',
    'orders.col.buyer': 'Comprador',
    'orders.col.amount': 'Precio',
    'orders.col.status': 'Estado',
    'orders.col.date': 'Fecha',
    'orders.col.actions': 'Acciones',
    'orders.noName': 'Sin nombre',
    'orders.noEmail': 'Sin correo',
    'orders.viewBuyerAria': 'Ver la ficha de {email}',
    'orders.disputed': 'Disputado',
    'orders.disputedTitle': 'Disputado: {amount}',
    'orders.disputeCount.one': '1 disputa',
    'orders.disputeCount.many': '{count} disputas',
    'orders.toShipCount': '{count} por enviar',
    'orders.fulfillment.unfulfilled': 'Por enviar',
    'orders.fulfillment.shipped': 'Enviado',
    'orders.fulfillment.delivered': 'Entregado',
    'orders.fulfillment.ready_for_pickup': 'Listo para recoger',
    'orders.fulfillment.picked_up': 'Recogido',
    'orders.shipping.title': 'Envío',
    'orders.shipping.shipTo': 'Enviar a',
    'orders.shipping.copy': 'Copiar dirección',
    'orders.shipping.copied': 'Dirección copiada',
    'orders.shipping.phone': 'Teléfono',
    'orders.shipping.method': 'Forma de envío',
    'orders.shipping.tracking': 'Guía',
    'orders.shipping.shippedAt': 'Enviado el',
    'orders.shipping.deliveredAt': 'Entregado el',
    'orders.shipping.pickedUpAt': 'Recogido el',
    'orders.shipping.carrier': 'Paquetería',
    'orders.shipping.otherCarrier': 'Otra',
    'orders.shipping.carrierName': 'Nombre de la paquetería',
    'orders.shipping.number': 'Número de guía',
    'orders.shipping.url': 'Enlace de seguimiento',
    'orders.shipping.notify': 'Avisar al comprador por correo',
    'orders.shipping.markShipped': 'Marcar enviado',
    'orders.shipping.saveTracking': 'Guardar guía',
    'orders.shipping.markReady': 'Listo para recoger',
    'orders.shipping.markDelivered': 'Marcar entregado',
    'orders.shipping.editTracking': 'Editar guía',
    'orders.shipping.markPickedUp': 'Marcar recogido',
    'orders.shipping.undo': 'Volver a «Por enviar»',
    'orders.shipping.printSlip': 'Hoja de empaque',
    'orders.detail.tabShipping': 'Envío',
    'orders.detail.tabPurchase': 'Compra',
    'orders.detail.loadFailed': 'No se pudo cargar el envío de este pedido.',
    'orders.shipping.step.paid': 'Pagado',
    'orders.shipping.step.preparing': 'Preparando',
    'orders.shipping.step.shipped': 'Enviado',
    'orders.shipping.step.delivered': 'Entregado',
    'orders.shipping.step.ready': 'Listo para recoger',
    'orders.shipping.step.pickedUp': 'Recogido',
    'orders.shipping.hint.unfulfilled': 'Prepáralo y, cuando lo entregues a la paquetería, márcalo como enviado: al comprador le llega un correo con la guía. Si lo recoge en tu negocio, márcalo como listo para recoger.',
    'orders.shipping.hint.unfulfilledShip': 'Prepáralo y, cuando lo entregues a la paquetería, márcalo como enviado: al comprador le llega un correo con la guía.',
    'orders.shipping.hint.unfulfilledPickup': 'Lo recoge en tu negocio. Cuando esté listo, avísale: le llega un correo para que pase por él.',
    'orders.shipping.hint.shipped': 'Va en camino. Cuando llegue a su destino, márcalo como entregado.',
    'orders.shipping.hint.ready_for_pickup': 'Ya le avisamos al comprador que puede pasar por él. Cuando lo recoja, márcalo como recogido.',
    'orders.shipping.track': 'Seguir envío',
    'orders.shipping.pickupTitle': 'Recoger en el negocio',
    'orders.products': "{count} productos",
    'orders.units': "{count} unidades",
    'orders.shipping.more': 'Más acciones',
    'orders.shipping.correctTitle': 'Corregir estado',
    'orders.shipping.backTo': 'Volver a «{status}»',
    'orders.shipping.correctConfirmTitle': '¿Corregir el estado del pedido?',
    'orders.shipping.correctConfirmBody': 'El pedido vuelve a «{status}». Al comprador no le llega ningún correo, y queda anotado en el historial.',
    'orders.history.title': 'Historial',
    'orders.history.paid': 'Pedido pagado · {amount}',
    'orders.history.emailConfirmation': 'Correo de confirmación enviado al comprador',
    'orders.history.emailRefund': "Correo de reembolso enviado al comprador",
    'orders.history.emailShipped': 'Correo «va en camino» enviado al comprador',
    'orders.history.emailReady': 'Correo «listo para recoger» enviado al comprador',
    'orders.history.shipped': 'Enviado',
    'orders.history.delivered': 'Entregado',
    'orders.history.ready': 'Listo para recoger',
    'orders.history.pickedUp': 'Recogido',
    'orders.history.corrected': 'Estado corregido: volvió a «{status}»',
    'orders.history.refundedFull': 'Reembolsado completo · {amount}',
    'orders.history.refundedPartial': 'Reembolso parcial · {amount}',
    'orders.history.restocked': 'La unidad volvió a las existencias',
    'orders.history.oversold': "Se vendió sin existencias",
    'orders.history.auto': 'Automático',
    'orders.history.byTeam': 'por {name}',
    'orders.history.byCustomer': '{name}',
    'orders.shipping.saved': 'Pedido actualizado',
    'orders.shipping.savedNotified': 'Pedido actualizado y comprador avisado',
    'orders.shipping.restocked': 'La unidad volvió a las existencias al reembolsarse.',
    'orders.underReview': 'En revisión',
    'orders.underReviewTitle': 'Disputa en revisión: {amount}. Decide el banco del comprador.',
    'orders.exportCsv': 'Exportar CSV',
    /* Importe y devuelto van en unidades y sin símbolo, y la moneda en su propia
       columna: una hoja suma números, no «$1,234.50». */
    'orders.csv.filename': 'cobros',
    'orders.csv.date': 'Fecha',
    'orders.csv.offer': 'Oferta',
    'orders.csv.variant': 'Variante',
    'orders.csv.quantity': 'Cantidad',
    'orders.csv.buyer': 'Comprador',
    'orders.csv.email': 'Correo',
    'orders.csv.amount': 'Importe',
    'orders.csv.currency': 'Moneda',
    'orders.csv.refunded': 'Devuelto',
    'orders.csv.status': 'Estado',
    'orders.csv.dispute': 'Disputa',
    'orders.csv.fulfillment': 'Envío',
    'orders.csv.shipName': 'Enviar a',
    'orders.csv.shipPhone': 'Teléfono',
    'orders.csv.shipLine1': 'Dirección',
    'orders.csv.shipLine2': 'Dirección 2',
    'orders.csv.shipCity': 'Ciudad',
    'orders.csv.shipState': 'Estado',
    'orders.csv.shipPostalCode': 'Código postal',
    'orders.csv.shipCountry': 'País',
    'orders.csv.shipMethod': 'Forma de envío',
    'orders.csv.carrier': 'Paquetería',
    'orders.csv.tracking': 'Guía',
    'orders.csv.id': 'Folio',
    'orders.open': 'Abrir',
    'orders.moreOptions': 'Más opciones',
    'orders.options': 'Opciones',
    'orders.menu.view': 'Ver cobro',
    'orders.menu.buyer': 'Ver al comprador',
    'orders.menu.email': 'Escribirle',
    // ── Cobros · ficha ────────────────────────────────────────────────────────
    'orders.detail.dialogAria': 'Detalle del cobro',
    'orders.detail.close': 'Cerrar',
    'orders.detail.disputeTitle': 'Disputaron este cobro',
    /* Partida porque lleva el importe en medio y una fecha opcional detrás: una
       sola cadena con dos huecos obliga al traductor a respetar un orden que su
       idioma puede no querer, y ninguno de los dos trozos se entiende solo. */
    'orders.detail.disputeBody1': 'El comprador reclamó {amount} a su banco.',
    'orders.detail.disputeBody2': 'Si nadie responde, se pierde sin que nadie lo revise.',
    'orders.detail.disputeCta': 'Responder a la disputa',
    'orders.detail.reviewTitle': 'Disputa en revisión',
    'orders.detail.reviewBody': 'Ya se respondió a la reclamación de {amount}.',
    'orders.detail.reviewCta': 'Ver la disputa',
    'orders.detail.buyer': 'Comprador',
    'orders.detail.email': 'Correo',
    'orders.detail.amount': 'Importe',
    'orders.detail.status': 'Estado',
    'orders.detail.date': 'Fecha',
    'orders.detail.subscription': 'Suscripción',
    'orders.detail.thisCharge': 'Este cobro',
    'orders.detail.customerSince': 'Cliente desde',
    'orders.detail.chargedTotal': 'Cobrado en total',
    /* Un pedido de una oferta gratuita: no hubo pasarela, así que en lugar del
       apartado del cobro va la explicación de por qué no hay ninguno. */
    'orders.detail.receipt': 'Ver recibo',
    'orders.detail.openInStripe': 'Ver más información',
    'orders.detail.offerDeleted': 'Oferta borrada',
    'orders.detail.offerLabel': 'Oferta',
    'orders.detail.item': 'Artículo',
    'orders.detail.items': 'Productos ({count})',
    'orders.detail.total': 'Total',
    'orders.detail.customer': 'Cliente',
    'orders.detail.cardName': "Tarjeta a nombre de {name}",
    'orders.detail.free': 'Gratis',
    'orders.detail.viewOffer': 'Ver la oferta',
    'orders.detail.respond': 'Responder',
    'orders.detail.view': 'Ver',
    'orders.detail.reviewBody2': 'Ahora decide el banco del comprador, que tarda unas semanas. Mientras tanto el dinero sigue retenido y no hay nada más que hacer.',
    'orders.detail.refundedNote': 'Devuelto: {amount}',
    'orders.detail.paymentAndRefunds': 'Pago y reembolsos',
    'orders.detail.paymentMethod': 'Método de pago',
    'orders.detail.refunds': 'Reembolsado',
    'orders.detail.noRefunds': 'Sin reembolsos',
    'orders.detail.unrefunded': 'Importe sin reembolsar',
    'orders.detail.manageRefunds': 'Ver y gestionar reembolsos en Stripe',
    'orders.detail.updatingPayment': 'Actualizando información del pago…',
    'orders.detail.savedPayment': 'Mostrando los datos guardados. No se pudo consultar la información actual de Stripe.',
    'orders.detail.retryPayment': 'Reintentar',
    'orders.detail.chargeOf': 'Cobro {number} de {total}',
    'orders.detail.fromSubscription': 'De una suscripción',
    'orders.detail.manageInStripe': 'Ver más información en Stripe',
    'orders.detail.openStripe': 'Abrir Stripe',
    /* El plazo de la disputa: cuatro frases enteras y no un número con palabras
       alrededor. «Queda 1 día» y «Quedan 3 días» cambian el verbo, no sólo la
       cifra, y eso no se resuelve concatenando. */
    'orders.detail.due.past': 'El plazo para responder ya venció.',
    'orders.detail.due.today': 'El plazo vence hoy.',
    'orders.detail.due.one': 'Queda 1 día para responder.',
    'orders.detail.due.many': 'Quedan {days} días para responder.',
    // ── Stripe y depósitos ────────────────────────────────────────────────────
    /* Los mapas de estado de `StripeConnectBanner` y `StripeSettings` guardan la
       clave, no el texto: son constantes de módulo y no pueden llamar a un hook. */
    'stripe.banner.none.title': 'Todavía no puedes recibir pagos',
    'stripe.banner.none.detail': 'Puedes crear tus ofertas y dejarlas listas desde ahora: se guardan igual. Conecta Stripe para poder publicarlas y que alguien pueda pagarlas.',
    'stripe.banner.pending.title': 'Completa la configuración de Stripe',
    'stripe.banner.pending.detail': 'Tu cuenta de Stripe aún requiere algunos datos. Retoma la configuración para completar el proceso.',
    'stripe.banner.restricted.title': 'Stripe aún no habilita tus cobros',
    'stripe.banner.restricted.detail': 'Terminaste el alta, pero Stripe aún no habilita los cobros. Suele resolverse solo; si pide algo, aparecerá en los ajustes de Stripe.',
    'stripe.banner.ready.title': 'Tu cuenta puede recibir cobros',
    'stripe.banner.ready.detail': 'El dinero de cada venta llega directo a ella.',
    'stripe.banner.failedTitle': 'No pudimos consultar tu cuenta de Stripe',
    'stripe.banner.failedBody': 'Puedes seguir creando y editando ofertas con normalidad. Lo que no sabemos ahora mismo es si tu cuenta puede cobrar.',
    'stripe.retry': 'Reintentar',
    'stripe.connect': 'Conectar con Stripe',
    /* Falta desde que el selector de estado ofrece los planes a quien no puede
       ni conectar: se pintaba «stripe.seePlans» tal cual en el botón. */
    'stripe.seePlans': 'Ver planes',
    'stripe.continueSetup': 'Continuar configuración',
    'stripeAttention.close': 'Cerrar',
    'stripeAttention.neverShow': 'No volver a mostrar',
    'stripeAttention.kicker': 'Stripe',
    'stripeAttention.stripe.title': 'Stripe necesita algo de ti',
    'stripeAttention.stripe.bodyOne': 'Hay 1 pendiente en tu cuenta de Stripe, como confirmar tu correo o un dato del negocio.',
    'stripeAttention.stripe.bodyMany': 'Hay {count} pendientes en tu cuenta de Stripe, como confirmar tu correo o un dato del negocio.',
    'stripeAttention.stripe.cta': 'Resolver',
    'stripeAttention.stripe.dialogBody': 'Lo que Stripe te pide para mantener tu cuenta activa. Se completa aquí mismo.',
    'stripeAttention.tax.title': '¿Necesitas cobrar impuestos?',
    'stripeAttention.tax.body': 'Stripe puede calcularlos y cobrarlos en cada venta. Tú decides si lo necesitas: la obligación fiscal es de tu negocio.',
    'stripeAttention.tax.cta': 'Configurar',
    'stripe.title': 'Stripe',
    /* El aviso al negocio, oferta por oferta. Estuvo en Configuración › Stripe,
       con un solo destinatario para todo el catálogo: ver `OfferSalesNotice`. */
    'offers.notify.title': 'Avisos de venta',
    'offers.notify.toggle': 'Avisarme de esta oferta',
    'offers.notify.body': 'Te escribimos cuando alguien compra esta oferta, con los datos principales de la operación.',
    'offers.notify.bookableBody': 'Te escribimos cuando alguien reserva este servicio, y cuando mueve o cancela su cita.',
    'offers.notify.emailLabel': 'Enviar a',
    'offers.notify.emailPlaceholder': 'nombre@ejemplo.com',
    'offers.notify.sendTo': 'Enviar a',
    'offers.notify.to.list': 'Estos correos',
    'offers.notify.to.list.hint': 'Todas las citas llegan a la misma bandeja.',
    'offers.notify.to.person': 'La persona de la cita',
    'offers.notify.to.person.hint': 'Cada quien recibe sólo las suyas.',
    'offers.notify.personList': 'El correo de cada persona',
    'offers.notify.personEmail': 'correo@ejemplo.com',
    'offers.notify.personEmailAria': 'Correo de {name}',
    'offers.notify.fallbackLabel': 'Si alguien no tiene correo, sus avisos llegan a',
    'bookings.team.email': 'Correo',
    'bookings.team.addEmail': 'Correo para sus avisos (opcional)',
    'bookings.team.emailInvalid': 'Ese correo no parece válido.',
    'offers.notify.add': 'Añadir',
    'offers.notify.remove': 'Quitar {email}',
    'offers.notify.max': 'Hasta 5 correos pueden recibir avisos.',
    'offers.notify.invalid': 'Introduce un correo válido.',
    'offers.notify.duplicate': 'Este correo ya está en la lista.',
    'offers.notify.needEmail': 'Añade al menos un correo para recibir avisos.',
    'offers.notify.saved': 'Avisos de esta oferta actualizados',
    'offers.notify.off': 'Avisos desactivados.',
    'offers.notify.bookableOff': 'Avisos desactivados.',
    /* Los rótulos que ordenan la pantalla. Cortos a propósito: son separadores,
       no títulos, y el que explica cada cosa es el de su tarjeta. */
    'stripe.group.account': 'Tu cuenta',
    'stripe.group.sale': 'Cómo se cobra cada venta',
    'stripe.group.start': 'Primeros pasos',
    'stripe.hero.none.title': 'Todavía no puedes cobrar',
    'stripe.hero.none.body': 'Conecta una cuenta de Stripe para cobrar tus ofertas. Toma unos minutos, la cuenta queda a tu nombre y el dinero de cada venta llega directo a ella.',
    'stripe.hero.pending.title': 'Te faltan algunos datos en Stripe',
    'stripe.hero.pending.body': 'Stripe necesita que termines de llenar tu información antes de activar los cobros. Continúa donde te quedaste.',
    'stripe.hero.restricted.title': 'Stripe está revisando tu cuenta',
    'stripe.hero.restricted.body': 'Ya enviaste tus datos, pero Stripe todavía no activa los cobros. Si te pide algo más, aparece justo aquí abajo.',
    'stripe.hero.ready.title': 'Ya puedes cobrar',
    'stripe.hero.ready.body': 'Tus ofertas publicadas cobran directo en tu cuenta de Stripe, y Stripe transfiere el dinero a tu banco.',
    'stripe.hero.meanwhile': 'Mientras, crea tus ofertas',
    'stripe.hero.goOffers': 'Ver mis ofertas',
    'stripe.progress.connect': 'Conecta tu cuenta',
    'stripe.progress.details': 'Completa tus datos',
    'stripe.progress.charges': 'Stripe activa los cobros',
    'stripe.progress.done': 'listo',
    'stripe.progress.current': 'paso actual',
    'stripe.progress.next': 'pendiente',
    'stripe.account.title': 'Cuenta de Stripe',
    'stripe.account.subtitle': 'Consulta el estado de la integración y administra la cuenta que procesa tus pagos.',
    'stripe.status.none': 'Sin conectar',
    'stripe.status.pending': 'Configuración pendiente',
    'stripe.status.restricted': 'Pendiente de revisión',
    'stripe.status.ready': 'Conectada',
    'stripe.detail.none': 'Puedes crear y editar tus ofertas antes de conectar una cuenta. Conectar Stripe es lo que las deja publicarse y cobrarse.',
    'stripe.detail.pending': 'Tu cuenta de Stripe aún requiere algunos datos. Retoma la configuración para completar el proceso.',
    'stripe.detail.restricted': 'La configuración finalizó, pero Stripe aún no ha habilitado los pagos. Consulta los requisitos indicados a continuación.',
    'stripe.detail.ready': 'La cuenta está habilitada para recibir pagos y administrar las transferencias correspondientes.',
    'stripe.detail.planLocked': 'Conectar Stripe entra con Pro o Business. Crear y editar tus ofertas es gratis: se guardan igual, y se publican en cuanto haya una cuenta que pueda cobrarlas.',
    'stripe.checking': 'Consultando el estado de tu cuenta…',
    'stripe.checkFailed': 'No se pudo consultar el estado de la cuenta.',
    'stripe.fact.country': 'País de la cuenta',
    'stripe.fact.currency': 'Moneda',
    'stripe.fact.payouts': 'Transferencias a tu banco',
    'stripe.payouts.on': 'Activas',
    'stripe.payouts.off': 'Pendientes',
    'stripe.disconnect': 'Desconectar',
    'stripe.openDashboard': 'Abrir panel de Stripe',
    'stripe.resetSetup': 'Reiniciar configuración',
    'stripe.disconnected': 'Cuenta desconectada',
    'stripe.disconnect.short': 'El sitio deja de cobrar. Puedes volver a conectarla.',
    'stripe.danger.resetShort': 'Empieza de nuevo con otra cuenta.',
    'stripe.disconnect.title': 'Desconectar la cuenta',
    'stripe.disconnect.body': 'El sitio dejará de aceptar pagos. La cuenta y su historial permanecerán disponibles en Stripe, y podrás volver a conectarla posteriormente.',
    'stripe.steps.title': 'Proceso de venta',
    'stripe.steps.subtitle': 'Completa estos pasos para comenzar a aceptar pagos.',
    'stripe.steps.manageOffers': 'Administrar ofertas',
    'stripe.steps.one': 'Crea una oferta con producto, precio, imágenes y descripción',
    'stripe.steps.two': 'Agrega la acción de compra a una página y publica el sitio',
    'stripe.steps.three': 'Conecta una cuenta de Stripe para habilitar los pagos',
    'stripe.account.business': 'Datos del negocio',
    'stripe.account.businessBody': 'Nombre legal, dirección y datos fiscales',
    'stripe.account.bank': 'Cuenta bancaria',
    'stripe.account.bankBody': 'A dónde llegan tus depósitos',
    'stripe.account.dataTitle': 'Datos de tu cuenta',
    'stripe.account.dataSubtitle': 'Los guarda Stripe, no nosotros, y se cambian en tu panel de Stripe.',
    'stripe.onboarding.done': 'Listo',
    'stripe.settings.description': "Conecta y administra la cuenta de Stripe que procesa los pagos y las transferencias de tu sitio.",
    'stripe.onboarding.doneAria': "Alta de Stripe terminada",
    'stripe.onboarding.progressAria': "Alta de Stripe en curso",
    'stripe.onboarding.readyTitle': "Tu cuenta ya puede cobrar",
    'stripe.onboarding.reviewTitle': "Alta enviada a Stripe",
    'stripe.onboarding.readyBody': "El dinero de cada venta llegará directo a tu cuenta de Stripe.",
    'stripe.onboarding.reviewBody': "Terminaste el alta y Stripe está revisando tus datos. Suele resolverse solo; si necesita algo más, aparecerá aquí.",
    'stripe.onboarding.title': 'Terminando tu alta en Stripe…',
    'stripe.onboarding.body': 'Se abrió en otra pestaña. Al terminar, esto se actualiza solo.',
    'stripe.onboarding.close': 'Cerrar',
    'stripe.onboarding.later': 'Seguir más tarde',
    'stripe.embed.close': 'Cerrar',
    'stripe.embed.disputeAria': 'Disputa en Stripe',
    'stripe.embed.paymentAria': 'Cobro en Stripe',
    'stripe.embed.openingDispute': 'Abriendo la disputa…',
    'stripe.embed.openingPayment': 'Abriendo Stripe…',
    'stripe.embed.openingAccount': 'Abriendo tus datos…',
    'stripe.tax.rowOn': 'Activos: se cobran en cada venta',
    'stripe.tax.rowOff': 'Desactivados',
    'stripe.tax.rowIncomplete': 'Falta completar la configuración en Stripe',
    'stripe.tax.configure': 'Configurar',
    'stripe.tax.title': 'Impuestos',
    'stripe.tax.subtitle': 'Stripe calcula y cobra el impuesto de cada venta según dónde esté el comprador.',
    'stripe.tax.toggle': 'Cobrar impuestos en el checkout',
    'stripe.tax.onReady': 'Se cobran impuestos en cada venta.',
    'stripe.tax.offReady': 'Configuración completa; los impuestos están apagados.',
    'stripe.tax.registrationsOne': '1 registro fiscal activo',
    'stripe.tax.registrationsMany': '{count} registros fiscales activos',
    'stripe.tax.registrationsNone': 'Sin registros fiscales',
    'stripe.tax.behaviorInclusive': 'los precios incluyen el impuesto',
    'stripe.tax.behaviorExclusive': 'el impuesto se suma al precio',
    'stripe.tax.behaviorByCurrency': 'incluido o sumado según la moneda',
    'stripe.tax.pending': 'Falta completar la configuración fiscal en Stripe (domicilio fiscal y cómo se aplican los precios). Hasta entonces no se pueden activar.',
    'stripe.tax.noRegistrationsHint': 'Sin un registro fiscal, Stripe no recauda en ningún lugar: añade los países o estados donde estás registrado.',
    'stripe.tax.openSetup': 'Configurar impuestos',
    'stripe.tax.hideSetup': 'Ocultar',
    'stripe.tax.opening': 'Abriendo la configuración fiscal…',
    'orders.detail.tax': 'Impuestos',
    'orders.detail.taxNote': 'Incluidos en el importe',
    'stripe.embed.rejected': 'Stripe rechazó la vista incrustada. Revisa que los componentes incrustados de Connect estén habilitados en tu cuenta de plataforma.',
    /* Frase con hueco: el sujeto es un sintagma nominal y en los dos idiomas cabe
       en el mismo sitio sin que el verbo cambie. */
    'stripe.embed.failed': 'No pudimos cargar {subject} desde Stripe.',
    'stripe.embed.subject.dispute': 'la disputa',
    'stripe.embed.subject.payment': 'el cobro',
    'stripe.embed.subject.payouts': 'tus depósitos',
    'stripe.embed.subject.notices': 'los avisos de tu cuenta',
    'stripe.embed.subject.account': 'los datos de tu cuenta',
    'payouts.title': 'Depósitos',
    'payouts.subtitle': 'Tu saldo en Stripe y cuándo llega a tu banco.',
    'payouts.openStripe': 'Ver en Stripe',
    'payouts.next': 'Próximo depósito',
    'payouts.balance': 'Tu saldo',
    'payouts.notEnabled': 'Stripe aún no habilita tus depósitos',
    'payouts.arrives': 'Llega {when}',
    'payouts.arrivesApprox': 'Llega aprox. {when}',
    'payouts.inTransitSuffix': ' · en camino',
    'payouts.noneScheduled': 'Sin depósito programado',
    'payouts.arrival.today': 'hoy',
    'payouts.arrival.tomorrow': 'mañana',
    'payouts.available': 'Disponible',
    'payouts.availableNegative': 'Se descuenta de tu próximo depósito',
    'payouts.availableReady': 'Listo para depositarse',
    'payouts.inTransit': 'En camino',
    'payouts.inTransitNote': 'Cobrado, dentro del plazo de Stripe',
    'payouts.viaStripeOnly': 'Los depósitos se consultan desde tu panel de Stripe.',
    'payouts.empty.title': 'Todavía no hay depósitos',
    'payouts.empty.body': 'Cuando alguien compre en tu sitio, aquí verás tu saldo y la fecha en que Stripe lo manda a tu banco.',
    'payouts.emptyNoAccount.body': 'Cuando conectes Stripe y alguien compre en tu sitio, aquí verás tu saldo y la fecha en que llega a tu banco.',
    'payouts.loadingBalance': 'Consultando tu saldo…',
    'payouts.loadingAccount': 'Consultando tu cuenta de Stripe…',
    // ── Facturación ───────────────────────────────────────────────────────────
    'billing.loading': 'Cargando tu facturación…',
    'billing.title': 'Facturación',
    'billing.subtitleShort': 'Tu membresía, tus dominios y todos tus cobros.',
    'billing.subtitle': 'Tu membresía, los dominios que compraste y los cobros de tu cuenta.',
    'billing.loadFailed': 'No se pudo cargar la facturación.',
    'billing.actionFailed': 'No se pudo completar la acción.',
    'billing.historyFailed': 'No se pudo cargar el historial.',
    'billing.retry': 'Reintentar',
    'billing.refresh': 'Actualizar',
    'billing.stripePortal': 'Portal de Stripe',
    'billing.changePlan': 'Cambiar de plan',
    'billing.seePlans': 'Ver planes',
    'billing.status.past_due': 'Hay un cobro pendiente. Revisa tu tarjeta para no perder el plan.',
    'billing.status.unpaid': 'No pudimos cobrar la renovación. Actualiza tu tarjeta para reactivar el plan.',
    'billing.status.incomplete': 'El pago quedó a medias. Vuelve a intentarlo desde Planes.',
    'billing.status.paused': 'Tu membresía está en pausa.',
    'billing.invoice.paid': 'Pagada',
    'billing.invoice.open': 'Pendiente',
    'billing.invoice.uncollectible': 'Incobrable',
    'billing.invoice.void': 'Anulada',
    'billing.invoice.number': 'Folio {number}',
    'billing.confirm.yesCancel': 'Sí, cancelar',
    'billing.confirm.cancelling': 'Cancelando…',
    'billing.membership.keepPlan': 'Seguir con el plan',
    'billing.cards.removing': 'Quitando…',
    'billing.domain.cancelTitle': '¿Cancelar {domain}?',
    'billing.domain.keep': 'Conservar dominio',
    'billing.domain.disconnectedToast': '{domain} se desconectó del sitio.',
    'billing.membership.resume': 'Reanudar',
    'billing.options': 'Opciones',
    'billing.domain.active': 'Activo',
    'billing.domain.error': 'Requiere atención',
    'billing.domain.disconnected': 'Cancelado',
    'billing.domain.purchasing': 'Registrando',
    'billing.domain.pending': 'En proceso',
    'billing.interval.year': 'Anual',
    'billing.interval.month': 'Mensual',
    /* «vencido», «hoy», «en 3 días»: frases enteras porque el plural y la
       preposición cambian con el número y con el idioma. */
    'billing.until.overdue': 'vencido',
    'billing.until.today': 'hoy',
    'billing.until.tomorrow': 'mañana',
    'billing.until.days': 'en {days} días',
    'billing.until.month': 'en 1 mes',
    'billing.until.months': 'en {months} meses',
    'billing.cardLabel': '{brand} terminada en {last4}',
    'billing.upcoming.membership': 'Membresía: {plan}',
    'billing.upcoming.membershipInterval': 'Membresía: {plan} · {interval}',
    'billing.upcoming.renewal': 'Renovación programada',
    'billing.upcoming.domain': 'Dominio: {hostname}',
    'billing.upcoming.domainMeta': 'Renovación · {project}',
    'billing.alert.cardExpired': 'Tu tarjeta predeterminada ({card}) ya venció. Agrega otra para que no falle el próximo cobro.',
    'billing.alert.cardSoon': 'Tu tarjeta predeterminada ({card}) vence este mes.',
    'billing.alert.granted': 'Tu plan está puesto directamente en tu cuenta, sin una suscripción de Stripe detrás. Por eso no hay importe, ni renovación, ni facturas: no se te cobra nada y no hay nada que cancelar.',
    'billing.alert.cancelled': 'Cancelaste tu membresía. Conservas todo hasta el {date}; después tus sitios pasan al plan gratis, siguen publicados y no se borra nada.',
    'billing.alert.domainFailed': 'Cobramos {hostname} pero el registro no se completó. Escríbenos y lo resolvemos o te devolvemos el importe.',
    'billing.membership.title': 'Membresía',
    'billing.membership.subtitle': 'Tu plan actual, su vigencia y sus opciones.',
    'billing.membership.eyebrow': 'Membresía véltica',
    'billing.membership.noCharge': 'Sin cobro',
    'billing.membership.cancelled': 'Cancelada',
    'billing.membership.active': 'Activa',
    'billing.membership.starter': 'Starter',
    'billing.membership.plan': 'Plan {plan}',
    'billing.membership.free': 'Sin costo',
    'billing.membership.endsOn': 'Finaliza el {date}.',
    'billing.membership.renewsOn': 'Próxima renovación el {date}.',
    'billing.membership.freeBody': 'Incluye las herramientas esenciales para comenzar a crear.',
    'billing.membership.resumed': 'Tu membresía sigue activa. No se cancelará.',
    'billing.membership.change': 'Cambiar plan',
    'billing.membership.cancelling': 'Cancelando…',
    'billing.membership.cancelRenewal': 'Cancelar renovación',
    'billing.membership.cancel': 'Cancelar membresía',
    'billing.membership.perYear': 'al año',
    'billing.membership.perMonth': 'al mes',
    'billing.membership.cancelTitle': '¿Cancelar tu membresía?',
    'billing.membership.cancelled.toast': 'Tu membresía se cancelará al final del periodo.',
    'billing.domains.title': 'Dominios',
    'billing.domains.subtitle': 'Tus dominios comprados, su vigencia y conexión.',
    'billing.domains.registering': 'Registrando…',
    'billing.domains.manage': 'Administrar dominio',
    'billing.domains.empty': 'Todavía no has comprado ningún dominio.',
    'billing.domains.search': 'Buscar un dominio',
    'billing.upcomingTitle': 'Próximos cobros',
    'billing.upcomingSubtitle': 'Todo lo programado, de lo más cercano a lo más lejano.',
    'billing.upcomingNote': 'El precio de renovación de un dominio puede cambiar de un año a otro; su fecha de vencimiento aparece en la lista de dominios.',
    'billing.historyTitle': 'Historial de facturación',
    'billing.historySubtitle': 'Membresía y dominios, del más reciente al más antiguo.',
    'billing.viewInvoice': 'Ver la factura',
    'billing.downloadPdf': 'Descargar el PDF',
    'billing.pagerAria': 'Páginas del historial',
    'billing.pagerPrevious': 'Anteriores',
    'billing.pagerNext': 'Siguientes',
    'billing.pagerPage': 'Página {page}',
    'billing.opening': 'Abriendo…',
    'billing.openPortalShort': 'Abre su portal',
    'billing.openPortal': 'Abrir el portal de Stripe',
    'billing.noInvoicesGranted': 'No hay facturas porque a esta cuenta no se le ha cobrado nada.',
    'billing.noInvoices': 'Todavía no hay facturas. Aquí aparecerán tus cobros en cuanto haya alguno.',
    'billing.cards.title': 'Métodos de pago',
    'billing.cards.subtitle': 'Con la predeterminada se cobran las renovaciones.',
    'billing.cards.add': 'Agregar',
    'billing.cards.addCard': 'Agregar tarjeta',
    'billing.cards.default': 'Predeterminada',
    'billing.cards.expired': 'Vencida',
    'billing.cards.expiringSoon': 'Vence pronto',
    'billing.cards.expiry': 'Vencimiento',
    'billing.cards.makingDefault': 'Cambiando…',
    'billing.cards.makeDefault': 'Hacer predeterminada',
    'billing.cards.defaultDone': 'Listo. Los próximos cobros usarán esa tarjeta.',
    'billing.cards.saved': 'Tarjeta guardada.',
    'billing.cards.removeTitle': '¿Quitar esta tarjeta?',
    'billing.cards.removeBody': 'Dejaremos de usar la {card} para tus cobros.',
    'billing.domains.view': 'Ver dominios',
    'billing.noUpcoming': 'No hay ningún cobro programado.',
    'billing.cards.remove': 'Quitar',
    /* La frase del portal lleva un botón en medio, así que va partida en dos: la
       mitad de antes y la de después. Meter la etiqueta dentro de la cadena
       obligaría al traductor a escribir HTML, y una sola cadena con un hueco no
       dejaría mover el botón si en otro idioma va en otro sitio. */
    'billing.portalNote1': 'Las facturas las emite Stripe.',
    'billing.portalNote2': 'para tus datos fiscales y los recibos de cada cobro.',
    'billing.domain.disconnect.body1': 'El dominio se desconectará de',
    'billing.domain.disconnect.body2': 'inmediatamente. Seguirá siendo tuyo hasta el {date} y podrás volver a conectarlo durante ese periodo. El año ya pagado no es reembolsable.',
    'billing.cards.removed': 'Tarjeta eliminada.',
    'billing.cards.empty': 'No tienes ninguna tarjeta guardada.',
    'billing.cards.emptyGranted': 'A esta cuenta no se le cobra, así que no hay ninguna tarjeta que guardar.',
    'billing.cards.emptyNoCharges': 'Aún no hay cobros en tu cuenta. La primera tarjeta se guarda al contratar un plan.',
    // ── Reservas ──────────────────────────────────────────────────────────────
    'bookings.status.held': 'Apartada',
    'bookings.status.confirmed': 'Confirmada',
    'bookings.status.cancelled': 'Cancelada',
    'bookings.status.completed': 'Asistió',
    'bookings.status.no_show': 'No asistió',
    'bookings.exportCsv': 'Exportar CSV',
    /* La hora va dos veces: la que se lee, en la zona en que se reservó, y la
       ISO, que es la que ordena y resta bien en cualquier hoja. */
    'bookings.csv.filename': 'reservas',
    'bookings.csv.day': 'Día',
    'bookings.csv.time': 'Hora',
    'bookings.csv.startIso': 'Inicio (ISO)',
    'bookings.csv.service': 'Servicio',
    'bookings.csv.customer': 'Cliente',
    'bookings.csv.email': 'Correo',
    'bookings.csv.phone': 'Teléfono',
    'bookings.csv.status': 'Estado',
    'bookings.csv.note': 'Nota del cliente',
    'bookings.csv.answers': 'Respuestas',
    'bookings.csv.createdAt': 'Reservada el',
    'bookings.overdueHint': 'Ya pasó y falta registrar el resultado',
    'bookings.action.confirm': 'Confirmar',
    'bookings.action.markAttended': 'Marcar asistencia',
    'bookings.action.noShow': 'No asistió',
    'bookings.action.cancel': 'Cancelar',
    /* Duraciones: cada forma va entera porque el plural y la unidad cambian con
       el número, y en inglés «1 hour»/«2 hours» no se resuelve pegando una «s». */
    'bookings.dur.minutes': '{minutes} min',
    'bookings.allDay': 'Todo el día',
    'bookings.dur.oneDay': '1 día',
    'bookings.dur.days': '{days} días',
    'bookings.dur.hours': '{hours} h',
    'bookings.dur.hoursMinutes': '{hours} h {minutes} min',
    'bookings.dur.longHour': '1 hora',
    'bookings.dur.longHours': '{hours} horas',
    'bookings.dur.longMinute': '1 minuto',
    'bookings.dur.longMinutes': '{minutes} minutos',
    'bookings.dur.zero': '0 minutos',
    'bookings.mode.none': 'Sin calendario',
    'bookings.mode.single': 'Individual',
    'bookings.mode.singleTitle': 'Una persona por cita',
    'bookings.mode.group': 'Grupal · {capacity}',
    'bookings.mode.groupTitle': 'Hasta {capacity} personas por cita',
    'bookings.people.one': '1 persona',
    'bookings.people.many': '{count} personas',
    /* El desglose de una clase: «4 asistieron», «1 cancelada». Frase entera por
       estado y por número, porque en castellano el plural cambia el participio y
       la concordancia, y en inglés ni siquiera hay concordancia que hacer. Lo que
       había era `LABEL.toLowerCase() + 's'`, que es gramática cableada. */
    'bookings.tally.held.one': '{count} apartada',
    'bookings.tally.held.many': '{count} apartadas',
    'bookings.tally.confirmed.one': '{count} confirmada',
    'bookings.tally.confirmed.many': '{count} confirmadas',
    'bookings.tally.cancelled.one': '{count} cancelada',
    'bookings.tally.cancelled.many': '{count} canceladas',
    'bookings.tally.completed.one': '{count} asistió',
    'bookings.tally.completed.many': '{count} asistieron',
    'bookings.tally.no_show.one': '{count} no asistió',
    'bookings.tally.no_show.many': '{count} no asistieron',
    'bookings.filter.all': 'Todas',
    'bookings.filter.upcoming': 'Próximas',
    'bookings.filter.confirmed': 'Confirmadas',
    'bookings.filter.held': 'Apartadas',
    'bookings.filter.cancelled': 'Canceladas',
    'bookings.group.eyebrow': 'Clase grupal',
    'bookings.group.fallbackTitle': 'Clase',
    'bookings.group.closePanel': 'Cerrar panel',
    'bookings.group.reservations': 'Reservaciones',
    'bookings.group.schedule': 'Horario',
    'bookings.group.scheduleRange': '{from} a {to}',
    'bookings.group.duration': 'Duración',
    'bookings.group.statusTitle': 'Estado del grupo',
    'bookings.group.statusAria': 'Resumen por estado',
    'bookings.group.seat': 'Lugar {seat}',
    'bookings.detail.people': 'Personas',
    'bookings.detail.guests': "Acompañantes",
    'bookings.detail.peopleCount': '{count} personas',
    'bookings.detail.withWhom': 'Con',
    'bookings.detail.artistDone': 'Listo',
    'bookings.detail.artistChange': 'Cambiar',
    'bookings.partyShort': '× {count}',
    'bookings.group.seats': 'Lugares {from}–{to}',
    'bookings.group.viewDetail': 'Ver detalle',
    'bookings.group.view': 'Ver grupo',
    'bookings.group.count': '{label}',
    'bookings.noName': 'Sin nombre',
    'bookings.noEmail': 'Sin correo',
    'bookings.noPhone': 'Sin teléfono',
    'bookings.noService': 'Sin servicio',
    'bookings.serviceFallback': 'Servicio',
    'bookings.loading': 'Cargando tus reservas…',
    'bookings.searchAria': 'Buscar reserva',
    'bookings.searchPlaceholder': 'Buscar por cliente o servicio...',
    'bookings.clearSearch': 'Limpiar búsqueda',
    'bookings.from': 'Desde',
    'bookings.to': 'Hasta',
    'bookings.filtersAria': 'Filtros y orden',
    'bookings.filtersDialogAria': 'Filtros y orden de reservas',
    'bookings.filterTitle': 'Filtrar reservas',
    'bookings.closeFilters': 'Cerrar filtros',
    'bookings.filterStatus': 'Estado',
    'bookings.filterRange': 'Rango de fechas',
    'bookings.resetFilters': 'Restablecer filtros',
    'bookings.filterByService': 'Filtrar por servicio',
    'bookings.filterByArtist': 'Artista',
    'bookings.allArtists': 'Todo el equipo',
    'bookings.withArtist': 'Con {name}',
    'bookings.allServices': 'Todos los servicios',
    'bookings.new': 'Nueva reserva',
    'bookings.newShort': 'Nueva',
    'bookings.loadFailed': 'No pudimos cargar las reservas.',
    'bookings.retry': 'Reintentar',
    'bookings.empty.title': 'Sin reservas en estas fechas',
    'bookings.noResults.title': 'Ninguna reserva coincide',
    'bookings.noResults.body': 'Prueba con otra búsqueda o quita los filtros.',
    'bookings.clearFilters': 'Limpiar filtros',
    'bookings.col.customer': 'Cliente',
    'bookings.col.service': 'Servicio',
    'bookings.col.date': 'Fecha',
    'bookings.col.time': 'Hora',
    'bookings.col.duration': 'Duración',
    'bookings.col.status': 'Estado',
    'bookings.view': 'Ver',
    'bookings.empty.body': 'Cuando alguien reserve desde tu sitio aparecerá aquí. También puedes anotar una cita a mano si te la piden por teléfono.',
    'bookings.clear': 'Limpiar',
    'bookings.unit': 'citas',
    'bookings.viewAria': 'Ver reserva de {customer}',
    'bookings.optionsAria': 'Opciones de {customer}',
    'bookings.unnamedCustomer': 'cliente sin nombre',
    'bookings.viewTooltip': 'Ver reserva',
    'bookings.cal.title': 'Citas',
    'calsync.open': "Sincronizar calendarios",
    'calsync.other.title': "Conectar con otro calendario",
    'calsync.other.hint': "Outlook o Apple, y también cualquiera por enlace.",
    'calsync.google.title': "Conectar con Google Calendar",
    'calsync.google.hint': "La forma más sencilla: tus citas aparecen al instante en tu calendario y tus eventos bloquean horarios, sin copiar ningún enlace.",
    'calsync.google.connect': "Conectar con Google",
    'calsync.google.schedule': "Conectar para",
    'calsync.google.reconnect': "Conectar otra cuenta",
    'calsync.google.permissions': "Solo pedimos permiso para crear las citas en tu calendario y ver tus horas ocupadas. No leemos el contenido de tus eventos.",
    'calsync.google.connected': "Cuenta de Google conectada",
    'calsync.google.working': "Conectado · las citas se escriben y tus horas ocupadas se bloquean",
    'calsync.google.write': "Escribir mis citas en su calendario",
    'calsync.google.block': "Bloquear horarios cuando estoy ocupado",
    'calsync.google.remove': "Desconectar",
    'calsync.google.removeAria': "Desconectar la cuenta {email}",
    'calsync.google.removeTitle': "¿Desconectar Google Calendar?",
    'calsync.google.removeBody': "Dejaremos de escribir tus citas y de leer tus horas ocupadas, y le retiraremos el permiso a véltica en tu cuenta de Google. Los eventos que ya están en tu calendario se quedan.",
    'calsync.google.error.reconnect': "Hay que volver a conectar la cuenta: Google retiró el permiso.",
    'calsync.google.error.forbidden': "Google no permitió la operación. Revisa que el calendario siga existiendo.",
    'calsync.google.error.unreachable': "No pudimos hablar con Google. Lo intentaremos de nuevo solos.",
    'calsync.toast.googleConnected': "Google Calendar conectado",
    'calsync.toast.googleCancelled': "No se conectó ninguna cuenta",
    'calsync.toast.googleFailed': "No se pudo conectar con Google. Inténtalo de nuevo.",
    'calsync.openShort': "Sincronizar",
    'calsync.title': "Sincronizar con tu calendario",
    'calsync.lead': "Ve tus citas en tu calendario y evita que te reserven cuando estás ocupado.",
    'calsync.close': "Cerrar",
    'calsync.done': "Listo",
    'calsync.copy': "Copiar",
    'calsync.retry': "Reintentar",
    'calsync.loadFailed': "No se pudo cargar la sincronización. Inténtalo de nuevo en un momento.",
    'calsync.provider.google': "Google Calendar",
    'calsync.provider.outlook': "Outlook",
    'calsync.provider.apple': "Apple",
    'calsync.export.title': "Ver mis citas en mi calendario",
    'calsync.export.hint': "Elige tu calendario y confirma. Las citas nuevas aparecerán solas.",
    'calsync.export.localNote': "Estás en local: Google, Outlook y Apple no pueden leer un enlace de «localhost», así que la suscripción solo funcionará cuando el panel esté publicado. Puedes crear el enlace y abrirlo en el navegador para ver las citas.",
    'calsync.export.createLocal': "Crear el enlace para probarlo",
    'calsync.export.addTo': "Añadir a {provider}",
    'calsync.export.calendarName': "Reservas",
    'calsync.export.more': "Copiar el enlace u otras opciones",
    'calsync.export.urlAria': "Enlace del calendario de reservas",
    'calsync.export.delay': "Este enlace es privado: incluye los datos de tus clientes. Tu calendario puede tardar unas horas en mostrar las reservas nuevas.",
    'calsync.export.rotate': "Crear un enlace nuevo",
    'calsync.export.stop': "Dejar de compartir",
    'calsync.import.title': "No ofrecer horarios cuando estoy ocupado",
    'calsync.import.hint': "Conecta tu calendario personal y sus eventos se bloquearán en tu página de reservas.",
    'calsync.import.pickAria': "Elige tu calendario",
    'calsync.import.pastePlaceholder': "Pega aquí el enlace privado de tu calendario",
    'calsync.import.connect': "Conectar",
    'calsync.import.schedule': "Bloquear en",
    'calsync.import.wrongLink.google': "Ese es el enlace de la página de Google Calendar. Necesitas la «Dirección secreta en formato iCal», que está en el paso 2.",
    'calsync.import.wrongLink.outlook': "Ese es el enlace de la página de Outlook. Necesitas el enlace «ICS» que aparece al publicar el calendario (paso 2).",
    'calsync.import.wrongLink.apple': "Ese no parece el enlace del calendario. Copia el enlace que aparece al activar «Calendario público».",
    'calsync.guide.open': "Abrir {provider}",
    'calsync.guide.google.one': "Abre la configuración de Google Calendar.",
    'calsync.guide.google.two': "A la izquierda, en «Configuración de mis calendarios», elige tu calendario y baja hasta «Integrar el calendario».",
    'calsync.guide.google.three': "Copia la «Dirección secreta en formato iCal» y pégala abajo.",
    'calsync.guide.outlook.one': "Abre los calendarios compartidos de Outlook.",
    'calsync.guide.outlook.two': "En «Publicar un calendario», elige tu calendario, selecciona «Puede ver cuándo estoy ocupado» y pulsa «Publicar».",
    'calsync.guide.outlook.three': "Copia el enlace «ICS» y pégalo abajo.",
    'calsync.guide.apple.one': "Abre Calendario en iCloud.com (o la app Calendario de tu Mac).",
    'calsync.guide.apple.two': "Junto a tu calendario pulsa el icono de compartir y activa «Calendario público».",
    'calsync.guide.apple.three': "Copia el enlace que aparece y pégalo abajo.",
    'calsync.feed.allSchedules': "todas las agendas",
    'calsync.feed.pending': "Conectando…",
    'calsync.feed.synced': "Conectado · actualizado {when} · {count} eventos",
    'calsync.feed.sync': "Actualizar ahora",
    'calsync.feed.syncAria': "Actualizar {name} ahora",
    'calsync.feed.remove': "Desconectar",
    'calsync.feed.removeAria': "Desconectar {name}",
    'calsync.error.notIcal': "Ese enlace no es el de tu calendario. Sigue los pasos de arriba para copiar el enlace privado.",
    'calsync.error.notFound': "No se encontró el calendario. Si creaste un enlace nuevo en tu calendario, vuelve a pegarlo.",
    'calsync.error.timeout': "Tu calendario tardó en responder. Lo intentaremos de nuevo solos.",
    'calsync.error.tooLarge': "Tu calendario es demasiado grande para conectarlo.",
    'calsync.error.unreachable': "No pudimos leer tu calendario. Lo intentaremos de nuevo solos.",
    'calsync.error.secret': "No se pudo leer el enlace guardado. Desconéctalo y vuelve a conectarlo.",
    'calsync.toast.copied': "Enlace copiado",
    'calsync.toast.added': "Calendario conectado · {count} eventos",
    'calsync.rotate.title': "¿Crear un enlace nuevo?",
    'calsync.rotate.body': "El enlace actual dejará de funcionar y tendrás que volver a añadirlo a tu calendario. Úsalo si lo compartiste por error.",
    'calsync.rotate.confirm': "Crear enlace nuevo",
    'calsync.stop.title': "¿Dejar de compartir tus citas?",
    'calsync.stop.body': "El enlace dejará de funcionar y las citas desaparecerán de los calendarios donde lo añadiste.",
    'calsync.stop.confirm': "Dejar de compartir",
    'calsync.remove.title': "¿Desconectar {name}?",
    'calsync.remove.body': "Sus eventos dejarán de bloquear horarios en tu página de reservas.",
    'calsync.remove.confirm': "Desconectar",
    'bookings.cal.subtitle': 'Consulta y gestiona todas tus reservaciones · {timezone}',
    'bookings.cal.viewAria': 'Vista de citas',
    'bookings.cal.calendar': 'Calendario',
    'bookings.cal.list': 'Lista',
    'bookings.cal.prevMonth': 'Mes anterior',
    'bookings.cal.nextMonth': 'Mes siguiente',
    'bookings.cal.today': 'Hoy',
    'bookings.cal.filterByStatus': 'Filtrar por estado',
    'bookings.cal.allStatuses': 'Todos los estados',
    'bookings.cal.allArtists': 'Todas las personas',
    'bookings.cal.viewClass': 'Ver clase',
    'bookings.cal.noServices': 'Todavía no tienes servicios reservables.',
    'bookings.cal.noServicesTitle': 'Todavía no tienes servicios reservables',
    'bookings.cal.noServicesBody': 'Una cita siempre cuelga de un servicio: de ahí salen su duración, su horario y sus huecos libres. Crea uno y el calendario empieza a funcionar.',
    'bookings.cal.noServicesCta': 'Crear servicio con agenda',
    'bookings.cal.noneThisMonth': 'Ninguna cita este mes.',
    'bookings.cal.noneFiltered': 'Ninguna cita de este mes coincide con los filtros.',
    'bookings.cal.dayCount.one': '1 cita',
    'bookings.cal.dayCount.many': '{count} citas',
    'bookings.cal.addOnDay': 'Nueva cita el {day}',
    'bookings.cal.loadingAgenda': 'Cargando tu agenda',
    'bookings.cal.loadingList': 'Cargando tus citas',
    'bookings.cal.loadingBooking': 'Cargando la reserva',
    'bookings.cal.loadingServices': 'Cargando tus servicios',
    'bookings.cal.sectionTitle': 'Reservas',
    'bookings.statusSaved': 'Estado actualizado',
    'bookings.kind.group': 'Grupal',
    'bookings.kind.single': 'Individual',
    'bookings.list.title': 'Citas',
    'bookings.list.subtitle': 'Todo lo que te han reservado, de todos tus servicios · {timezone}',
    'bookings.services.subtitle': 'Cada servicio tiene su propia página para reservar · {timezone}',
    'bookings.col.mode': 'Modalidad',
    'bookings.col.bookings': 'Reservas',
    'bookings.liveCount': '{count} reservas en pie',
    'bookings.fallbackTitle': 'Cita',
    'bookings.detail.eyebrow': 'Reservación',
    'bookings.detail.unnamed': 'Cliente sin nombre',
    'bookings.detail.serviceUnavailable': 'Servicio no disponible',
    'bookings.detail.modeGroup': 'Grupal · lugar {seat}',
    'bookings.detail.modeSingle': 'Individual',
    'bookings.detail.closePanel': 'Cerrar panel',
    'bookings.detail.statusLabel': 'Estado',
    'bookings.detail.pastNotice': 'La cita ya pasó. Registra el resultado.',
    'bookings.detail.overviewAria': 'Datos de la cita',
    'bookings.detail.when': 'Fecha y hora',
    'bookings.detail.date': 'Fecha',
    'bookings.detail.time': 'Hora',
    'bookings.detail.hoursRange': '{from} a {to}',
    'bookings.detail.saved': 'Cita actualizada',
    'bookings.detail.reschedule': 'Cambiar fecha y hora',
    'bookings.detail.rescheduleTitle': 'Cambiar horario de la cita',
    'bookings.detail.rescheduleBody': 'Elige un horario disponible para este servicio.',
    'bookings.detail.rescheduleDay': 'Nueva fecha',
    'bookings.detail.rescheduleTime': 'Horarios disponibles',
    'bookings.detail.rescheduleConfirm': 'Guardar nuevo horario',
    'bookings.detail.moreActions': 'Más acciones',
    'bookings.detail.emailCustomer': 'Escribir al cliente',
    'bookings.detail.call': 'Llamar',
    'bookings.detail.copyEmail': 'Copiar correo',
    'bookings.detail.copied': 'Copiado',
    'bookings.detail.viewContact': 'Ver contacto',
    'bookings.detail.viewService': 'Ver el servicio',
    'bookings.detail.client': 'Cliente',
    'bookings.detail.name': 'Nombre',
    'bookings.detail.email': 'Correo',
    'bookings.detail.phone': 'Teléfono',
    'bookings.detail.payment': 'Pago',
    'bookings.detail.viewFull': 'Ver completo',
    'bookings.detail.loadingPayment': 'Cargando el cobro…',
    'bookings.detail.method': 'Método',
    'bookings.detail.viaStripe': 'Procesado por Stripe',
    'bookings.detail.pay.failedTitle': 'Cobro no disponible',
    'bookings.detail.pay.failedBody': 'No se pudo consultar la información del cobro.',
    'bookings.detail.pay.pendingTitle': 'Pago pendiente',
    'bookings.detail.pay.pendingBody': 'La cita se confirmará cuando finalice el pago.',
    'bookings.detail.pay.noneTitle': 'Sin cobro en línea',
    'bookings.detail.pay.noneBody': 'Esta reservación no tiene una compra de Stripe asociada.',
    'bookings.detail.paidOn': 'Pagado',
    'bookings.detail.paid': 'Pagada',
    'bookings.detail.refunded': 'Reembolsada',
    'bookings.detail.partiallyRefunded': 'Reembolso parcial',
    'bookings.detail.tabsAria': 'Detalle de la cita',
    'bookings.detail.tab.form': 'Formulario',
    'bookings.detail.tab.events': 'Proceso',
    'bookings.detail.tab.note': 'Notas',
    'bookings.detail.noAnswer': 'Sin respuesta',
    'bookings.detail.noQuestions': 'Este servicio no pide nada más que los datos de contacto.',
    'bookings.detail.customerNote': 'Nota del cliente',
    'bookings.detail.notePlaceholder': 'Añade una nota sobre esta cita…',
    'bookings.detail.savingNote': 'Guardando…',
    'bookings.detail.savesOnBlur': 'Se guarda al salir del campo',
    'bookings.notes.loading': 'Cargando notas…',
    'bookings.notes.emptyTitle': 'Todavía no hay notas internas',
    'bookings.notes.emptyBody': 'Añade la primera nota para tu equipo sobre esta cita.',
    'bookings.event.created': 'Se creó la reserva',
    'bookings.event.held': 'Horario apartado, esperando el pago',
    'bookings.event.paid': 'Pago recibido',
    'bookings.event.confirmed': 'Confirmada',
    'bookings.event.rescheduled': 'Cambió de fecha',
    'bookings.event.refunded': 'Reembolso automático',
    'bookings.event.refundPending': 'Reembolso pendiente',
    'bookings.event.refundRetry': 'se reintenta solo',
    'bookings.event.reassigned': 'Cambió de artista',
    'bookings.event.cancelled': 'Cancelada',
    'bookings.event.completed': 'Asistió',
    'bookings.event.no_show': 'No asistió',
    'bookings.timeline.failed': 'No pudimos cargar el historial.',
    'bookings.timeline.loading': 'Cargando el historial…',
    'bookings.timeline.empty': 'Todavía no hay movimientos en esta reserva.',
    'bookings.timeline.actor.customer': 'El cliente',
    'bookings.timeline.actor.team': 'Alguien del equipo',
    'bookings.timeline.actor.auto': 'Automático',
    'bookings.timeline.before': 'Antes: {when}',
    'bookings.timeline.meta': '{when} · {who}',
    'bookings.timeline.guessed': ' · deducido',
    'bookings.svc.needsPublish': 'Publica el sitio para tener el enlace',
    'bookings.svc.linkCopied': 'Enlace copiado',
    'bookings.svc.copyFailed': 'No pudimos copiar el enlace',
    'bookings.svc.searchAria': 'Buscar servicio',
    'bookings.svc.searchPlaceholder': 'Buscar servicio...',
    'bookings.svc.filtersDialogAria': 'Filtros y orden de servicios',
    'bookings.svc.filterTitle': 'Filtrar servicios',
    'bookings.svc.filter.all': 'Todos',
    'bookings.svc.filter.active': 'Público',
    'bookings.svc.filter.draft': 'Borrador',
    'bookings.svc.new': 'Nuevo servicio',
    'bookings.svc.newShort': 'Nuevo',
    'bookings.svc.loadFailed': 'No pudimos cargar los servicios.',
    'bookings.svc.empty.title': 'Aún no tienes servicios reservables',
    'bookings.svc.empty.body': 'Crea servicios con horario y comparte su enlace para que tus clientes reserven.',
    'bookings.svc.createFirst': 'Crear el primero',
    'bookings.svc.noResults.title': 'Ningún servicio coincide',
    'bookings.svc.unit': 'servicios',
    'bookings.svc.col.service': 'Servicio',
    'bookings.svc.optionsAria': 'Opciones de {name}',
    'bookings.svc.onsite': 'En el lugar',
    'bookings.svc.col.price': 'Precio',
    'bookings.svc.col.actions': 'Acciones',
    'bookings.svc.open': 'Abrir',
    'bookings.svc.viewPublic': 'Ver página pública',
    'bookings.svc.copyLink': 'Copiar enlace',
    'bookings.svc.settings': 'Ajustes',
    'bookings.new.title': 'Nueva cita',
    'bookings.new.close': 'Cerrar',
    'bookings.team.title': 'Equipo',
    'bookings.team.addRole': 'Agregar puesto',
    'bookings.team.bookable': 'Se puede reservar',
    'bookings.team.hidden': 'Oculto',
    'bookings.team.cancel': 'Cancelar',
    'bookings.team.lead': 'Quiénes atienden. Con varias personas, quien reserva elige con quién o «Cualquiera disponible».',
    'bookings.team.photo': 'Cambiar la foto de {name}',
    'bookings.team.name': 'Nombre',
    'bookings.team.role': 'Puesto',
    'bookings.team.rolePlaceholder': 'Estilista, dentista…',
    'bookings.team.active': 'Activo',
    'bookings.team.remove': 'Quitar a {name}',
    'bookings.team.newName': 'Agregar persona',
    'bookings.team.newNamePlaceholder': 'Nombre',
    'bookings.team.add': 'Agregar',
    'bookings.team.assignment': 'Con «Cualquiera disponible», la cita va a…',
    'bookings.team.assignmentHint': 'Sólo entre quienes estén libres a esa hora. Si alguien elige a una persona en concreto, la cita es suya.',
    'bookings.team.assignmentTitle': 'Con «Cualquiera disponible», la cita va a…',
    'bookings.team.rule.least_busy': 'Menos ocupado',
    'bookings.team.rule.least_busy.hint': 'Quien tenga menos citas ese día',
    'bookings.team.rule.order': 'Por orden',
    'bookings.team.rule.order.hint': 'El primero de la lista que esté libre',
    'bookings.team.rule.round_robin': 'Por turnos',
    'bookings.team.rule.round_robin.hint': 'Se reparten una a una entre todos',
    'bookings.team.assign.least_busy': 'Quien tenga menos citas ese día',
    'bookings.team.assign.order': 'El primero de la lista que esté libre',
    'bookings.team.assign.round_robin': 'Por turnos',
    'bookings.team.scheduleNote': 'El horario de cada persona se pone en el paso Horario de sus servicios. Quien no está activo no aparece en la página de reserva, pero conserva sus citas.',
    'bookings.new.lead1': 'Anota una cita solicitada por teléfono para',
    'bookings.new.lead2': '.',
    'bookings.new.whenTitle': 'Fecha y horario',
    'bookings.new.minutes': '{count} min',
    'bookings.new.capacity': 'Hasta {count} personas',
    'bookings.new.leadEmpty': 'Elige un servicio para comenzar. Su horario y los espacios disponibles se cargarán automáticamente.',
    'bookings.new.noServiceTitle': 'Elige un servicio',
    'bookings.new.noServiceBody': 'Selecciona el servicio de esta cita para ver su duración, precio y horarios disponibles.',
    'bookings.new.servicePlaceholder': 'Selecciona un servicio…',
    'bookings.new.pickService': 'Selecciona un servicio para continuar',
    'bookings.new.needService': 'Selecciona el servicio de esta cita.',
    'bookings.new.needName': 'Falta el nombre de quien reserva',
    'bookings.new.required': 'Obligatorio',
    'bookings.new.service': 'Servicio',
    'bookings.new.days': 'Días',
    'bookings.new.day': 'Día',
    'bookings.new.slot': 'Horario',
    'bookings.new.searching': 'Buscando horarios…',
    'bookings.new.slotsAria': 'Horarios disponibles',
    'bookings.new.seatsLeft': '{count} lugares',
    'bookings.new.available': 'Disponible',
    'bookings.new.whoTitle': 'Datos del cliente',
    'bookings.new.name': 'Nombre del cliente',
    'bookings.new.namePlaceholder': 'Nombre completo',
    'bookings.new.email': 'Correo',
    'bookings.new.emailPlaceholder': 'cliente@correo.com',
    'bookings.new.phone': 'Teléfono',
    'bookings.new.note': 'Nota',
    'bookings.new.optional': 'Opcional',
    'bookings.new.notePlaceholder': 'Indicaciones o detalles importantes…',
    'bookings.new.pickSlot': 'Selecciona un horario para continuar',
    'bookings.new.next': 'Siguiente',
    'bookings.new.back': 'Atrás',
    'bookings.new.book': 'Reservar',
    'bookings.new.stepOf': 'Paso {current} de {total}',
    'bookings.new.noSlotsTitle': "Sin horarios disponibles",
    'bookings.new.noSlotsBody': "Elige otra fecha o revisa el horario del servicio.",
    'bookings.new.cancel': 'Cancelar',
    'bookings.new.create': 'Crear cita',
    'bookings.new.needSlot': 'Elige un horario.',
    'bookings.new.phonePlaceholder': '(555) 000-0000',
    'bookings.field.index': 'Pregunta {index}',
    'bookings.field.moveUp': 'Subir',
    'bookings.field.moveDown': 'Bajar',
    'bookings.field.placeholder': '¿Es tu primera visita?',
    'bookings.field.optionsLabel': 'Opciones, una por línea',
    /* El marcador de posición de una lista: tres ejemplos, uno por línea. */
    'bookings.field.optionsPlaceholder': 'Chico\nMediano\nGrande',
    'bookings.field.needsOptions': 'Sin opciones no se puede guardar: una lista vacía deja la página sin poder enviarse.',
    'bookings.field.type': 'Tipo',
    'bookings.field.required': 'Obligatoria',
    'bookings.field.type.text': 'Texto corto',
    'bookings.field.type.textarea': 'Texto largo',
    'bookings.field.type.select': 'Lista de opciones',
    'bookings.field.type.checkbox': 'Casilla (sí/no)',
    'bookings.field.type.email': 'Correo',
    'bookings.field.type.tel': 'Teléfono',
    'bookings.field.head': 'Preguntas al reservar',
    'bookings.field.headWizard': 'Preguntas adicionales',
    'bookings.field.headBody': 'Además del nombre, el correo y el teléfono, que se piden siempre.',
    'bookings.field.headBodyWizard': 'Aparecerán después de los datos de contacto.',
    'bookings.field.count': '{count} de {max}.',
    'bookings.field.labelAria': 'Texto de la pregunta {index}',
    'bookings.field.remove': 'Eliminar la pregunta {name}',
    'bookings.field.add': 'Añadir pregunta',
    'bookings.field.addWizard': 'Añadir pregunta adicional',
    // ── Los tres índices públicos del catálogo ────────────────────────────────
    'catalogPage.bookings.subtitle': 'Una dirección con todos tus servicios, para mandar por WhatsApp o poner en tu perfil.',
    'catalogPage.bookings.need': 'No hay ningún servicio publicado',
    'catalogPage.bookings.needBody': 'La página se vería vacía. Publica al menos un servicio con agenda para que aparezca aquí.',
    'catalogPage.bookings.goTo': 'Ir a Servicios',
    'catalogPage.bookings.count': 'Se listarán {count} servicios.',
    'catalogPage.bookings.countOne': 'Se listará 1 servicio.',
    'catalogPage.bookings.countNone': 'Todavía no se listaría ningún servicio.',
    'catalogPage.digital.subtitle': 'Una dirección con todo lo tuyo que se descarga, para mandar por WhatsApp o poner en tu perfil.',
    'catalogPage.digital.need': 'No hay ningún producto digital publicado',
    'catalogPage.digital.needBody': 'La página se vería vacía. Publica al menos un producto digital para que aparezca aquí.',
    'catalogPage.digital.goTo': 'Ir a Productos digitales',
    'catalogPage.digital.count': 'Se listarán {count} productos.',
    'catalogPage.digital.countOne': 'Se listará 1 producto.',
    'catalogPage.digital.countNone': 'Todavía no se listaría ningún producto.',
    'catalogPage.products.subtitle': 'Una dirección con toda tu tienda, para mandar por WhatsApp o poner en tu perfil.',
    'catalogPage.products.need': 'No hay ningún producto físico publicado',
    'catalogPage.products.needBody': 'La página se vería vacía. Publica al menos un producto físico para que aparezca aquí.',
    'catalogPage.products.goTo': 'Ir a Productos físicos',
    'catalogPage.products.count': 'Se listarán {count} productos.',
    'catalogPage.products.countOne': 'Se listará 1 producto.',
    'catalogPage.products.countNone': 'Todavía no se listaría ningún producto.',
    'catalogPage.services.subtitle': 'Una dirección con todo lo que ofreces sin horario, para mandar por WhatsApp o poner en tu perfil.',
    'catalogPage.services.need': 'No hay ningún servicio publicado',
    'catalogPage.services.needBody': 'La página se vería vacía. Publica al menos un servicio para que aparezca aquí.',
    'catalogPage.services.goTo': 'Ir a Servicios',
    'catalogPage.services.count': 'Se listarán {count} servicios.',
    'catalogPage.services.countOne': 'Se listará 1 servicio.',
    'catalogPage.services.countNone': 'Todavía no se listaría ningún servicio.',
    // ── Ajustes de aspecto del índice y su vista previa ───────────────────────
    'catalogPage.group.texts': 'Textos',
    'catalogPage.group.colors': 'Colores',
    'catalogPage.group.typography': 'Tipografía',
    'catalogPage.titleStyle': 'Título',
    'catalogPage.cardTitleStyle': 'Título de tarjeta',
    'catalogPage.bodyStyle': 'Texto',
    'catalogPage.group.layout': 'Tarjetas',
    'catalogPage.free': 'Gratis',
    'catalogPage.price': 'Precio: {price}',
    'catalogPage.priceStyle': 'Precio',
    'catalogPage.samplesNote': 'Ofertas de ejemplo: aquí saldrán las tuyas en cuanto publiques alguna.',
    'catalogPage.sample.bookings.1.title': 'Consulta inicial',
    'catalogPage.sample.bookings.1.body': 'Una primera conversación para entender qué necesitas y cómo podemos ayudarte.',
    'catalogPage.sample.bookings.2.title': 'Sesión de seguimiento',
    'catalogPage.sample.bookings.2.body': 'Revisamos avances, resolvemos dudas y ajustamos el plan.',
    'catalogPage.sample.bookings.3.title': 'Taller en grupo',
    'catalogPage.sample.bookings.3.body': 'Una clase práctica en grupo reducido, con todo incluido.',
    'catalogPage.sample.digital.1.title': 'Plantilla inicial',
    'catalogPage.sample.digital.1.body': 'Todo lo que necesitas para empezar, lista para descargar y usar hoy.',
    'catalogPage.sample.digital.2.title': 'Guía completa',
    'catalogPage.sample.digital.2.body': 'Paso a paso, desde lo básico hasta los detalles que marcan la diferencia.',
    'catalogPage.sample.digital.3.title': 'Pack de recursos',
    'catalogPage.sample.digital.3.body': 'Listas, fichas de trabajo y ejemplos, todo en un archivo.',
    'catalogPage.sample.products.1.title': 'Taza artesanal',
    'catalogPage.sample.products.1.body': 'Hecha a mano, de cerámica esmaltada. Cada pieza es distinta.',
    'catalogPage.sample.products.2.title': 'Camiseta de algodón',
    'catalogPage.sample.products.2.body': 'Algodón orgánico, corte clásico, en cuatro colores.',
    'catalogPage.sample.products.3.title': 'Vela aromática',
    'catalogPage.sample.products.3.body': 'Cera de soya y aceites esenciales, unas 40 horas de luz.',
    'catalogPage.sample.services.1.title': 'Llamada de estrategia',
    'catalogPage.sample.services.1.body': 'Una hora para fijar prioridades y acordar los siguientes pasos.',
    'catalogPage.sample.services.2.title': 'Acompañamiento mensual',
    'catalogPage.sample.services.2.body': 'Apoyo continuo, con una revisión de resultados cada mes.',
    'catalogPage.sample.services.3.title': 'Proyecto completo',
    'catalogPage.sample.services.3.body': 'Del primer briefing a la entrega final, hecho por nosotros.',
    'catalogPage.columns': 'Columnas',
    'catalogPage.columnsAuto': 'Automático',
    'catalogPage.text': 'Letra',
    'catalogPage.background': 'Fondo',
    'catalogPage.card': 'Tarjeta',
    'catalogPage.button': 'Botón',
    'catalogPage.bookings.previewTitle': 'Reserva tu cita',
    'catalogPage.bookings.previewSubtitle': 'Elige el servicio y te enseñamos los horarios libres.',
    'catalogPage.bookings.previewCta': 'Ver horarios',
    'catalogPage.digital.previewTitle': 'Descargas',
    'catalogPage.digital.previewSubtitle': 'Todo lo que puedes llevarte ahora mismo.',
    'catalogPage.digital.previewCta': 'Conseguirlo',
    'catalogPage.products.previewTitle': 'Tienda',
    'catalogPage.products.previewSubtitle': 'Todo lo que te podemos enviar.',
    'catalogPage.products.previewCta': 'Comprar',
    'catalogPage.services.previewTitle': 'Servicios',
    'catalogPage.services.previewSubtitle': 'Lo que podemos hacer por ti.',
    'catalogPage.services.previewCta': 'Ver detalles',
    'catalogPage.action': 'Ajustes de la página',
    'catalogPage.designInEditor': 'Diseñar en el editor',
    'catalogPage.bookings.editPage': 'Editar categoría',
    'catalogPage.bookings.editPageHint': 'Edita la página que reúne todos tus servicios con agenda.',
    'catalogPage.digital.editPage': 'Editar categoría',
    'catalogPage.digital.editPageHint': 'Edita la página que reúne todos tus productos digitales.',
    'catalogPage.products.editPage': 'Editar categoría',
    'catalogPage.products.editPageHint': 'Edita la página que reúne todos tus productos físicos.',
    'catalogPage.services.editPage': 'Editar categoría',
    'catalogPage.services.editPageHint': 'Edita la página que reúne todos tus servicios.',
    // ── Reservas · el aspecto de la página de un servicio ─────────────────────
    'bookings.page.title': 'Página pública',
    'bookings.page.subtitleShort': 'El índice de tus servicios reservables.',
    'bookings.page.needSite': 'Publica tu sitio para tener la dirección',
    'bookings.page.publishSite': 'Publicar el sitio',
    'bookings.page.needSiteBody': 'Esta página vive dentro de tu sitio. Mientras no esté publicado no hay dirección que dar, aunque la enciendas aquí.',
    'bookings.page.visibility': 'Visibilidad',
    'bookings.page.visibilityBody': 'Quién puede abrir la página y en qué dirección vive.',
    'bookings.page.on': 'Publicada',
    'bookings.page.off': 'Sin publicar',
    'bookings.page.onBody': 'Cualquiera con el enlace puede verla. No aparece en el menú de tu sitio: se comparte a mano.',
    'bookings.page.offBody': 'La dirección responde como si la página no existiera. Nadie puede verla, ni siquiera con el enlace.',
    'bookings.page.copyLink': 'Copiar enlace',
    'bookings.page.open': 'Abrir la página',
    'catalogPage.publishToggle': 'Publicar la página',
    'sitePage.chrome': 'Barra y pie del sitio',
    'sitePage.showNav': 'Barra de navegación del sitio',
    'sitePage.showNavBody': 'La misma barra de arriba que el resto de tu sitio. Si el sitio no tiene, no se pone.',
    'sitePage.showFooter': 'Pie del sitio',
    'sitePage.showFooterBody': 'El mismo pie que el resto de tu sitio. Si el sitio no tiene, no se pone.',
    'catalogPage.address': 'Dirección',
    'catalogPage.shareWhatsapp': 'Compartir por WhatsApp',
    'catalogPage.listed': 'Lo que se lista',
    'catalogPage.listedMore': '+{count} más',
    'catalogPage.lookBody': 'Colores, estilos de texto, tarjeta y botón, sacados de tu sitio.',
    'catalogPage.editLook': 'Editar apariencia',
    'catalogPage.bookings.note': 'Salen tus servicios publicados con agenda, en el orden en que los creaste.',
    'catalogPage.digital.note': 'Salen tus productos digitales publicados, en el orden en que los creaste.',
    'catalogPage.products.note': 'Salen tus productos físicos publicados, en el orden en que los creaste. Los agotados se ven con «Agotado».',
    'catalogPage.services.note': 'Salen tus servicios publicados sin agenda, en el orden en que los creaste.',
    'bookings.page.headline': 'Título',
    'bookings.page.intro': 'Texto de entrada',
    'bookings.page.look': 'Apariencia',
    'bookings.page.accent': 'Color de acento',
    'bookings.page.accentHelp': 'Pinta el botón de cada tarjeta y el precio.',
    'bookings.page.savedToast': 'Página actualizada',
    'bookings.page.theme': 'Tema',
    'bookings.page.themeAuto': 'Automático (sigue al visitante)',
    'bookings.page.themeLight': 'Siempre claro',
    'bookings.page.themeDark': 'Siempre oscuro',
    // ── Reservas · ficha de un servicio ───────────────────────────────────────
    'bookings.svc.detail.back': 'Volver a reservas',
    'bookings.svc.detail.tabsAria': 'Secciones del servicio',
    'bookings.svc.detail.tab.notices': 'Notificaciones',
    'bookings.svc.detail.tab.bookings': 'Citas',
    'bookings.svc.detail.tab.details': 'Detalles',
    'bookings.svc.detail.tab.settings': 'Ajustes',
    'bookings.svc.detail.tab.contact': 'Contacto',
    'bookings.svc.detail.card.session': 'Sesión y agenda',
    'bookings.svc.detail.card.sessionEdit': 'Editar horario',
    'bookings.svc.detail.fact.buffers': 'Margen de preparación',
    'bookings.svc.detail.fact.notice': 'Antelación mínima',
    'bookings.svc.detail.card.policy': 'Política de cancelación y reprogramación',
    'bookings.svc.detail.policyWindow': 'Plazo límite',
    'bookings.svc.detail.policyWindowVal': 'Hasta {hours} horas antes',
    'bookings.svc.detail.policyWindowNone': 'En cualquier momento antes',
    'bookings.svc.detail.policyRefund': 'Reembolso',
    'bookings.svc.detail.policyLate': 'Fuera de plazo',
    'bookings.svc.detail.policyLateContact': 'Contactar directamente',
    'bookings.svc.detail.policyLateMove': 'Permite reprogramar',
    'bookings.svc.detail.policyLateNone': 'Sin reembolso ni cambios',
    'bookings.svc.detail.card.share': 'Compartir y enlace de reserva',
    'bookings.svc.detail.card.shareDirect': 'Enlace directo de reserva',
    'bookings.svc.detail.card.shareHint': 'Comparte este enlace directamente con tus clientes para que puedan reservar una cita.',
    'bookings.svc.detail.card.appearanceAndContact': 'Apariencia y contacto',
    'bookings.svc.detail.draftNotice.title': 'Este servicio no está activo aún',
    'bookings.svc.detail.draftNotice.body': 'Está guardado en borrador. Publícalo para que tus clientes puedan reservarlo desde tu página.',
    'bookings.svc.detail.draftNotice.publish': 'Publicar',
    'bookings.svc.detail.look': 'Cómo se ve la página',
    'bookings.svc.detail.lookBody': 'El tema con el que se abre tu página de reserva. El color, la imagen y el logo se editan desde «Editar».',
    'bookings.svc.detail.history': 'Historial de la política',
    'bookings.svc.detail.historyBody': 'Cada cambio queda anotado con su fecha y su hora. No se puede editar ni borrar.',
    'bookings.svc.detail.historyLoading': 'Cargando…',
    'bookings.svc.detail.historyEmpty': 'Todavía no has cambiado la política de este servicio. En cuanto la toques, aquí quedará la versión anterior y la nueva.',
    'bookings.svc.detail.historyCurrent': 'Vigente',
    'bookings.svc.detail.historyNoText': 'Sin texto.',
    'bookings.svc.detail.delete': 'Eliminar servicio',
    'bookings.svc.detail.deleteBody': 'Se borra de forma permanente. No se puede deshacer.',
    /* Partida en dos: la ruta va dentro en <code>, y una clave con marcado
       dentro no la puede traducir nadie sin escribir HTML. */
    'bookings.svc.detail.deleteCopy1': 'Desaparece el servicio y su página',
    'bookings.svc.detail.deleteCopy2': ': quien tenga el enlace dejará de poder reservar.',
    'bookings.svc.detail.deleteKeepOne': 'La cita futura que ya tienes se conserva en Reservas, con el nombre del servicio guardado.',
    'bookings.svc.detail.deleteKeepMany': 'Las {count} citas futuras que ya tienes se conservan en Reservas, con el nombre del servicio guardado.',
    'bookings.svc.detail.deleteKeepNone': 'Las citas y los cobros que ya existan se conservan con el nombre del servicio guardado.',
    'bookings.svc.detail.deleteBtn': 'Eliminar este servicio',
    'bookings.svc.detail.deleteAsk': '¿Eliminar este servicio?',
    'bookings.svc.detail.deleteWarn': 'se borrará de forma permanente, junto con su página de reserva y sus precios. Esto no se puede deshacer.',
    'bookings.svc.detail.deleteWarnOne': 'Su cita futura seguirá en Reservas, pero ya no podrás abrir su ficha de servicio.',
    'bookings.svc.detail.deleteWarnMany': 'Sus {count} citas futuras seguirán en Reservas, pero ya no podrás abrir su ficha de servicio.',
    'bookings.svc.detail.deleteConfirm': 'Eliminar',
    'bookings.svc.detail.deleting': 'Eliminando…',
    'bookings.svc.detail.deletedToast': 'Servicio eliminado',
    'bookings.svc.detail.contact': 'Cómo te contactan',
    'bookings.svc.detail.contactBody': 'Lo que ve tu cliente cuando ya no puede cancelar o cambiar la cita por su cuenta.',
    'bookings.svc.detail.email': 'Correo de contacto',
    'bookings.svc.detail.emailPlaceholder': 'hola@tunegocio.com',
    'bookings.svc.detail.emailHelp': 'Se imprime en la página de reserva. Si lo dejas vacío se usa el correo donde recibes los avisos de este proyecto.',
    'bookings.svc.detail.emailInvalid': 'Escribe un correo válido',
    'bookings.svc.detail.phone': 'Teléfono',
    'bookings.svc.detail.phonePlaceholder': '+52 55 1234 5678',
    'bookings.svc.detail.phoneHelp': 'Opcional. Déjalo vacío si prefieres que te escriban.',
    'bookings.svc.detail.summaryAria': 'Información del servicio',
    'bookings.svc.detail.coverChangeAria': 'Cambiar la miniatura',
    'bookings.svc.detail.coverPickAria': 'Subir una miniatura',
    'bookings.svc.detail.coverChange': 'Cambiar miniatura',
    'bookings.svc.detail.coverAdd': 'Subir miniatura',
    'bookings.svc.detail.nameAria': 'Nombre del servicio',
    'bookings.svc.detail.link': 'Enlace de reserva',
    'bookings.svc.detail.copyAria': 'Copiar el enlace de reserva',
    'bookings.svc.detail.openAria': 'Abrir la página de reserva',
    'bookings.svc.detail.needSite': 'Publica el sitio para crear la URL.',
    'bookings.svc.detail.team': 'Quién lo da',
    'bookings.svc.detail.teamChange': 'Cambiar',
    'bookings.svc.detail.teamDone': 'Listo',
    'bookings.svc.detail.teamEmpty': 'Agrega más personas desde Gestionar equipo para asignarlas a este servicio.',
    'bookings.svc.detail.teamManage': 'Gestionar equipo',
    'bookings.svc.detail.teamRequired': 'El servicio necesita al menos una persona.',
    'bookings.svc.detail.fact.clients': 'Clientes',
    /* ── La ficha, con la planta de la ficha de una oferta ────────────────────
       Las tarjetas de recuadros se fueron: la tarjeta de la derecha enseña quién
       es el servicio y la pestaña «Ajustes» tiene las mismas filas que una
       oferta. De ahí que estas claves reutilicen las suyas —«La oferta» pasa a
       ser «El servicio» y poco más. */
    'bookings.svc.detail.card.service': 'El servicio',
    'bookings.svc.detail.fact.form': 'Formulario',
    'bookings.svc.detail.formCount': '{count} pregunta(s) extra',
    'bookings.svc.detail.formNone': 'Sólo nombre y correo',
    'bookings.svc.detail.fact.duration': 'Duración',
    'bookings.svc.detail.fact.capacity': 'Cupo',
    'bookings.svc.detail.fact.price': 'Precio',
    'bookings.svc.detail.fact.schedule': 'Horario',
    'bookings.svc.detail.fact.cancel': 'Cancelación',
    'bookings.svc.detail.fact.refund': 'Reembolso',
    'bookings.svc.detail.fact.reminder': 'Recordatorio',
    'bookings.svc.detail.fact.name': 'Nombre',
    'bookings.svc.detail.priceOnsite': 'Sin cobro en línea',
    'bookings.svc.detail.priceNone': 'Sin precio',
    'bookings.svc.detail.daysNone': 'Sin horario',
    'bookings.svc.detail.daysOne': '1 día abierto',
    'bookings.svc.detail.daysMany': '{count} días abiertos',
    'bookings.svc.detail.refundFull': 'Completo a tiempo',
    'bookings.svc.detail.refundNone': 'Sin reembolso',
    'bookings.svc.detail.refundPartial': '{percent}% a tiempo',
    'bookings.svc.detail.editFact': 'Editar {label}',
    'bookings.svc.detail.edit': 'Editar',
    'bookings.svc.detail.editAll': 'Editar todo',
    'userMenu.aria': 'Opciones de cuenta',
    'userMenu.settings': 'Ajustes de usuario',
    'userMenu.plans': 'Planes',
    'userMenu.usage': 'Uso de la cuenta',
    'userMenu.billing': 'Facturación',
    'userMenu.domains': 'Dominios',
    'userMenu.theme': 'Apariencia',
    'userMenu.themeLight': 'Claro',
    'userMenu.themeDark': 'Oscuro',
    'userMenu.themeSystem': 'Automático (según tu dispositivo)',
    'userMenu.color': 'Color',
    'userMenu.colorPanel': 'Color del panel',
    'userMenu.signOut': 'Cerrar sesión',
    /* Los catorce tonos del selector de acento. Con acentos y en minúscula: son
       etiquetas de un selector, no títulos. La clave va sin tildes porque es el
       mismo slug que el atributo de `<html>`. */
    'accent.azul': 'Azul',
    'accent.indigo': 'Índigo',
    'accent.violeta': 'Violeta',
    'accent.fucsia': 'Fucsia',
    'accent.rosa': 'Rosa',
    'accent.rojo': 'Rojo',
    'accent.naranja': 'Naranja',
    'accent.ambar': 'Ámbar',
    'accent.amarillo': 'Mostaza',
    'accent.verde': 'Verde',
    'accent.esmeralda': 'Esmeralda',
    'accent.turquesa': 'Turquesa',
    'accent.cian': 'Cian',
    'accent.grafito': 'Grafito',
    'home.grid.aria': 'Widgets personalizables del dashboard',
    'home.grid.moveUp': 'Mover arriba',
    'home.grid.moveDown': 'Mover abajo',
    'home.grid.remove': 'Quitar del dashboard',
    'home.grid.resize': 'Arrastra para cambiar el ancho',
    'home.grid.emptyTitle': 'Tu inicio está vacío',
    'home.grid.emptyBody': 'Quitaste todos los widgets. Vuelve a poner los que uses y deja fuera los demás: esto se guarda para este sitio.',
    'home.grid.restore': 'Volver a ponerlos todos',
    'home.grid.edit': 'Editar widgets',
    /* Los nombres de los widgets del inicio. Van aparte de los títulos que cada
       uno pinta dentro —«Ventas» el título, «Resumen de ventas» el widget— porque
       esto es cómo se llama la pieza en la lista de «Editar widgets», donde hay
       que distinguirla de las otras seis. */
    'home.widget.project': 'Estado del proyecto',
    'home.widget.pages': 'Páginas',
    'home.widget.cms': 'Contenido CMS',
    'home.widget.offers': "Catálogo",
    'home.widget.usage': 'Uso del plan',
    'home.widget.domain': 'Dominio y SSL',
    'home.widget.notes': 'Notas',
    'home.widget.sales': 'Resumen de ventas',
    'home.grid.reorder': 'Cambiar posición de {label}',
    'home.grid.moveUpOne': 'Subir {label}',
    'home.grid.moveDownOne': 'Bajar {label}',
    'home.grid.removeOne': 'Quitar {label} del dashboard',
    'home.grid.widen': 'Ensanchar {label}',
    'home.grid.narrow': 'Estrechar {label}',
    /* Los roles de un equipo. Viven en el catálogo y no junto a la definición del
       rol porque ese paquete lo comparten el panel, el editor, el worker y los
       correos, y cada uno pinta en un idioma distinto. Están en los DOS catálogos:
       aquí los lee el panel, y en el del sitio los lee el correo de invitación,
       que va en el idioma del proyecto y no en el de quien mira. */
    'role.owner.label': 'Propietario',
    'role.owner.summary': 'Manda en todo, incluido lo que se cobra y borrar el proyecto.',
    'role.admin.label': 'Administrador',
    'role.admin.summary': 'Todo el proyecto, e invitar a otras personas.',
    'role.editor.label': 'Editor',
    'role.editor.summary': 'Edita el sitio, su contenido y su configuración. No tiene acceso a finanzas.',
    'role.design.label': 'Diseño',
    'role.design.summary': 'Páginas, editor visual e imágenes.',
    'role.content.label': 'Contenido',
    'role.content.summary': 'Colecciones, formularios y contactos.',
    'role.finance.label': 'Finanzas',
    'role.finance.summary': 'Pedidos, cobros, reservas y ventas.',
    'role.viewer.label': 'Lectura',
    'role.viewer.summary': 'Lo ve todo. No modifica nada.',
    /* La descripción larga del selector de rol, distinta del resumen de una
       línea: aquí hay sitio para decir qué administra cada uno. */
    'role.admin.description': 'Administra la configuración, el equipo y todas las áreas operativas del proyecto.',
    'role.editor.description': 'Gestiona el sitio, el contenido y la configuración, sin acceso a información financiera.',
    'role.design.description': 'Trabaja en las páginas, el diseño visual y los recursos gráficos del sitio.',
    'role.content.description': 'Gestiona colecciones, formularios, contactos y recursos de contenido.',
    'role.finance.description': 'Gestiona pedidos, pagos, reservas y métricas comerciales.',
    'role.viewer.description': 'Consulta todas las áreas del proyecto sin realizar modificaciones.',
    'role.guest': '{role} (invitado)',
    'role.ownerLine': 'Dueño del proyecto',
    'role.togglePermissions': '{action} permisos de {role}',
    'role.show': 'Mostrar',
    'role.hide': 'Ocultar',
    // ── Planes ────────────────────────────────────────────────────────────────
    /* Las ventajas de cada plan. Viven aquí y no junto a la lista porque esa
       lista es una constante de módulo, donde no se puede llamar a un hook: allí
       se guarda la clave y quien la pinta la pasa por su `t`. */
    'plans.feat.offersUnlimited': 'Ofertas ilimitadas',
    'plans.feat.fee': '{fee}% de comisión por venta',
    'plans.feat.analyticsReports': 'Analíticas completas + informes',
    'plans.feat.inboxMarketingOff': 'Inbox y marketing por email',
    'plans.feat.support': 'Soporte: {level}',
    'plans.feat.aiGenerations': 'Sitios generados con IA: {amount}',
    'plans.feat.projects': '{count} proyectos',
    'plans.feat.projectOne': '{count} proyecto',
    'plans.feat.projectsUnlimited': 'Proyectos ilimitados',
    'plans.feat.pages': '{count} páginas',
    'plans.feat.cms': '{collections} colecciones · {items} elementos CMS',
    'plans.feat.contacts': '{count} contactos',
    'plans.feat.contactsUnlimited': 'Contactos ilimitados',
    'plans.feat.subdomain': 'Subdominio de véltica',
    'plans.feat.password': 'Protección con contraseña',
    'plans.feat.analyticsBasic': 'Analíticas básicas',
    'plans.feat.badge': 'Insignia “Creado en véltica”',
    'plans.feat.freeDomain': 'Dominio gratuito por un año',
    'plans.feat.customDomain': 'Dominio personalizado',
    'plans.feat.noBadge': 'Sin insignia de véltica',
    'plans.feat.analyticsFull': 'Analíticas completas',
    'plans.feat.allOfPro': 'Todo lo de Pro',
    'plans.feat.unlimitedPagesContacts': 'Páginas y contactos ilimitados',
    'plans.feat.forms': 'Formularios: {limit}',
    'plans.feat.inboxMarketing': 'Inbox y Marketing: {limit}',
    'plans.feat.bookingsIncluded': 'Reservas, con tu propia agenda',
    'plans.feat.sales': 'Ventas: {limit}',
    'plans.feat.sellWithFee': 'Cobra con Stripe · {fee}% de comisión por venta',
    'plans.feat.courses': "Vende tus cursos: {limit}",
    'plans.feat.team': '{count} miembros de equipo',
    'plans.feat.supportPriority': 'Soporte prioritario',
    'plans.feat.unlimitedPages': 'Páginas ilimitadas',
    /* Los cupos de las apps. Texto y no número: cada uno lleva su unidad, y sin
       ella la tabla queda llena de cifras que no dicen de qué son. */
    'plans.limit.submissions': '{count} envíos/mes',
    'plans.limit.offers': '{count} ofertas publicadas',
    'plans.limit.unlimitedF': 'Ilimitadas',
    'plans.limit.unlimitedM': 'Ilimitados',
    'plans.limit.soon': 'Próximamente',
    // ── Cancelar la membresía ─────────────────────────────────────────────────
    /* Partida en tres porque la fecha va en negrita en medio: una clave con
       marcado dentro no la puede traducir nadie sin escribir HTML. */
    'plans.cancel.lead1': 'Tu plan {plan} ',
    'plans.cancel.leadStrong': 'se cancelará el {date}',
    'plans.cancel.lead2': ', al terminar el periodo que ya pagaste.',
    'plans.cancel.keepUntil': 'Conservarás todas las funciones de {plan} hasta esa fecha. Después, tu cuenta pasará al plan gratuito.',
    'plans.cancel.reactivate': 'Puedes reactivar tu plan en cualquier momento antes del {date}.',
    'plans.cancel.losing': 'Lo que dejas de tener',
    'plans.cancel.gone': 'Ya no disponible',
    'plans.cancel.kept': 'Tus sitios siguen publicados y editables, y no se borra nada: páginas, contenido, contactos y mensajes se quedan. Tus dominios siguen siendo tuyos hasta su renovación.',
    /* El globo del triángulo: dice lo que NO pasa, que es lo que hace falta oír.
       «Excedes el límite» a secas deja imaginando lo peor, y lo peor —que te
       recorten los contactos o te tiren páginas— es justo lo que no ocurre. */
    'plans.cancel.overOne': 'Ya tienes {count}{cap} en {site}. No se borra nada: lo que existe se queda y se sigue viendo, pero no podrás crear más hasta volver a un plan de pago.',
    'plans.cancel.overMany': 'Ya tienes {count}{cap} repartidos en {sites} sitios. No se borra nada: lo que existe se queda y se sigue viendo, pero no podrás crear más hasta volver a un plan de pago.',
    'plans.cancel.overCap': ' de {limit}',
    /* Los nombres de lo que un plan cuenta, en singular y plural, para armar
       frases como «12 páginas de 30». El de equipo dice «invitado» y no «miembro»
       a propósito: el tope cuenta a quien ENTRA invitado, no al dueño, y decir «3
       miembros» con el dueño dentro haría pensar que quedan dos. */
    'plans.noun.pages.one': '{count} página',
    'plans.noun.pages.many': '{count} páginas',
    'plans.noun.collections.one': '{count} colección',
    'plans.noun.collections.many': '{count} colecciones',
    'plans.noun.cmsItems.one': '{count} elemento CMS',
    'plans.noun.cmsItems.many': '{count} elementos CMS',
    'plans.noun.contacts.one': '{count} contacto',
    'plans.noun.contacts.many': '{count} contactos',
    'plans.noun.teamMembers.one': '{count} invitado',
    'plans.noun.teamMembers.many': '{count} invitados',
    'plans.noun.offers.one': "oferta publicada",
    'plans.noun.offers.many': "ofertas publicadas",
    'plans.noun.blogPosts.one': "entrada publicada",
    'plans.noun.blogPosts.many': "entradas publicadas",
    'plans.over.title': 'Superaste tu plan {plan}',
    'plans.over.mobileTitle': 'Límite del plan superado',
    'plans.over.more': '{count} más',
    'plans.over.detail': '{count} de {limit}',
    'plans.over.body': 'Todo sigue publicado y editable; sólo no puedes agregar más.',
    'plans.over.seePlans': 'Ver planes',
    // ── Planes del sitio: la pantalla ─────────────────────────────────────────
    'plans.title': 'Planes del sitio',
    'plans.subtitle': 'Publica hoy y amplía la capacidad cuando la necesites. Todos los planes incluyen hosting administrado, SSL y CDN global.',
    'plans.bannerAria': 'Oferta de lanzamiento',
    'plans.betaEyebrow': 'Oferta Beta',
    'plans.betaDetails': 'Cómo funciona la oferta',
    'plans.betaTitle': "Beta: {percent}% de descuento tu primer año en el plan anual",
    'plans.betaBody': "Es un {percent}% menos sobre el precio anual, durante tus primeros {months} meses. Ejemplo con Pro: ${monthly} al mes pagando mes a mes, ${annual} al mes con el plan anual y ${now} al mes con la Beta (${total} por todo el primer año). Se aplica solo al pagar; después, el plan se renueva al precio anual normal. Puedes cancelar cuando quieras.",
    'plans.cycle': 'Periodo de facturación',
    'plans.cycleBody': 'Precios por mes. El ahorro anual incluye la oferta Beta durante tus primeros {months} meses; después, el plan se renueva cada año al precio anual normal.',
    'plans.monthly': 'Mensual',
    'plans.annual': 'Anual',
    'plans.annualSaving': 'Ahorra {percent}%',
    'plans.recommended': 'Recomendado',
    'plans.soon': 'Próximamente',
    'plans.current': 'Actual',
    'plans.custom': 'A medida',
    'plans.perMonth': 'USD/mes',
    'plans.vsMonthly': "Beta · {percent}% menos",
    'plans.onLaunch': 'Al lanzarse',
    'plans.todayYouPay': 'Hoy pagas',
    'plans.afterBeta': 'Después de {months} meses',
    'plans.pricePerMonth': '${price}/mes',
    'plans.afterFirstYear': 'Tras el primer año',
    'plans.pricePerYear': '${price}/año',
    'plans.includes': 'Lo que obtienes',
    'plans.includesPlus': 'Todo lo de {plan}, más:',
    'plans.freeForever': 'Gratis para siempre, sin tarjeta',
    'plans.free': 'Gratis',
    'plans.trust.aria': 'Garantías',
    'plans.trust.secure': 'Pago seguro con Stripe',
    'plans.trust.cancel': 'Cancela cuando quieras desde Facturación',
    'plans.trust.keep': 'Al bajar de plan no se borra nada de tu sitio',
    'plans.faq.title': 'Preguntas frecuentes',
    'plans.faq.lead': 'Lo que suele preguntarse antes de elegir un plan.',
    'plans.faq.q.switch': '¿Puedo cambiar de plan cuando quiera?',
    'plans.faq.a.switch': 'Sí. Un plan de pago se activa en cuanto terminas el pago. Si cancelas, conservas lo que ya pagaste hasta el final de tu periodo y después pasas al plan gratuito.',
    'plans.faq.q.downgrade': '¿Qué pasa con mi sitio si bajo de plan?',
    'plans.faq.a.downgrade': 'No se borra nada. Tus sitios siguen publicados y puedes seguir editando todo lo que tienes. Si algo pasa del tope del nuevo plan, sólo dejas de poder añadir más de eso hasta que subas de plan o bajes del tope.',
    'plans.faq.q.account': '¿El plan es por sitio o por cuenta?',
    'plans.faq.a.account': 'Por cuenta. Un solo plan cubre todos tus proyectos, hasta el número de proyectos que incluye. Los proyectos en los que entras invitado los paga su dueño.',
    'plans.faq.q.beta': '¿Cómo funciona la oferta Beta?',
    'plans.faq.a.beta': 'Si pagas el año, al precio anual se le suma un {beta}% de descuento Beta durante tus primeros {months} meses: en total, al menos {percent}% menos que pagar mes a mes. Se aplica solo al pagar. Después, el plan sigue al precio anual normal. El pago mensual no lleva el descuento.',
    'plans.faq.q.domain': '¿Está incluido un dominio?',
    'plans.faq.a.domain': 'Con un plan de pago anual, el primer año de tu dominio corre por nuestra cuenta. Desde el segundo año se renueva por separado, y te avisamos antes de cada renovación. El dominio queda a tu nombre y te lo puedes llevar cuando quieras.',
    'plans.faq.q.fee': '¿Cobran comisión por mis ventas?',
    'plans.faq.a.fee': 'Sí, una comisión pequeña que baja con el plan: {free}% en Starter, {pro}% en Pro y {business}% en Business. Aparte está la comisión de Stripe, que cobra Stripe por procesar el pago. El dinero de tus ventas llega directo a tu cuenta.',
    'plans.faq.q.payment': '¿Cómo pago?',
    'plans.faq.a.payment': 'Con tarjeta, a través de Stripe. Los datos de tu tarjeta los guarda Stripe, no nosotros. Tus facturas y tu suscripción se administran desde Facturación.',
    'plans.annualOnly': ' · sólo en el plan anual',
    'plans.toFree': 'Cambiar a gratuito',
    'plans.opening': 'Abriendo…',
    'plans.manageSubscription': 'Administrar suscripción',
    'plans.currentPlan': 'Plan actual',
    'plans.redirecting': 'Redirigiendo…',
    'plans.fineprint': 'Precios en USD por cuenta: el plan cubre todos tus proyectos. La opción anual se factura por adelantado.',
    'plans.allFeatures': 'Todas las funciones del sitio',
    'plans.confirmFree': '¿Cambiar al plan gratuito?',
    'plans.confirmFreeYes': 'Sí, cambiar a gratuito',
    'plans.cancelling': 'Cancelando…',
    'plans.stayOn': 'Seguir en {plan}',
    'plans.untilPeriodEnd': 'el final de tu periodo',
    /* Las tarjetas. El nombre del plan no se traduce —es su nombre comercial— y
       el rótulo de arriba y la descripción sí. */
    'plans.card.starter.eyebrow': 'Para probar',
    'plans.card.starter.body': 'Publica una idea sencilla y conoce el flujo completo de véltica.',
    'plans.card.starter.cta': 'Plan gratuito',
    'plans.card.pro.eyebrow': 'Crea tu sitio',
    'plans.card.pro.body': 'Todo para construir y publicar tu sitio profesional: páginas, CMS y dominio propio.',
    'plans.card.pro.cta': 'Elegir Pro',
    'plans.card.business.eyebrow': 'Empieza a vender',
    'plans.card.business.body': 'Tu sitio más las apps de negocio, con cupos pensados para arrancar: formularios, inbox, marketing, reservas, cobros y equipo.',
    'plans.card.elite.eyebrow': "Pensado para cursos",
    'plans.card.elite.body': "Todo lo de Business, con espacio para un catálogo de cursos (hasta 25), equipo grande y soporte dedicado. Para quien vende lo que sabe.",
    'plans.card.elite.allBusiness': 'Todo lo de Business, con cupos de sobra',
    'plans.card.elite.team': '{count} miembros de equipo con roles',
    'plans.card.elite.support': 'Soporte dedicado',
    'plans.card.elite.bookingsSales': 'Reservas y ventas: {limit}',
    /* El resumen del panel de pago. */
    'plans.checkout.billedAnnually': 'Facturado anualmente · ${amount} USD hoy',
    'plans.checkout.billedMonthly': 'Facturado cada mes',
    'plans.checkout.back': 'Volver a planes',
    'plans.checkout.legal1': 'Al suscribirte aceptas nuestros ',
    'plans.checkout.terms': 'Términos y condiciones',
    'plans.checkout.legal2': ' y nuestra ',
    'plans.checkout.privacy': 'Política de privacidad',
    'plans.checkout.legal3': '. La suscripción se renueva automáticamente y puedes cancelarla cuando quieras.',
    /* La tabla comparativa. */
    'plans.table.title': 'Comparar todas las funciones',
    'plans.table.lead': 'Consulta límites y funciones antes de elegir un plan.',
    'plans.table.aria': 'Tabla comparativa de planes',
    'plans.table.feature': 'Función',
    'plans.table.included': 'Incluido',
    'plans.table.notIncluded': 'No incluido',
    'plans.table.sec.site': 'Sitio y publicación',
    'plans.table.sec.cms': 'CMS y contenido',
    'plans.table.sec.capacity': 'Recursos y capacidad',
    'plans.table.sec.apps': 'Apps de negocio',
    'plans.table.sec.support': 'Analíticas y soporte',
    'plans.table.row.projects': 'Proyectos',
    'plans.table.row.pages': 'Páginas',
    'plans.table.row.subdomain': 'Publicar en subdominio de véltica',
    'plans.table.row.customDomain': 'Dominio personalizado',
    'plans.table.row.freeDomain': 'Dominio gratuito el primer año',
    'plans.table.row.noBadge': 'Quitar insignia de véltica',
    'plans.table.row.ssl': 'SSL y CDN global',
    'plans.table.row.collections': 'Colecciones CMS',
    'plans.table.row.cmsItems': 'Elementos CMS',
    'plans.table.row.contacts': 'Contactos',
    'plans.table.row.search': 'Búsqueda en el sitio',
    'plans.table.row.visits': 'Visitas al sitio',
    'plans.table.row.storage': 'Almacenamiento',
    'plans.table.row.ai': 'Uso mensual del asistente IA',
    'plans.table.row.forms': 'Formularios',
    'plans.table.row.inbox': 'Inbox',
    'plans.table.row.marketing': 'Marketing por email',
    'plans.table.row.bookings': 'Reservas',
    'plans.table.row.sales': 'Ventas y cobros',
    'plans.table.row.fee': 'Comisión de véltica por venta',
    'plans.table.val.feePercent': '{percent}%',
    'plans.table.row.courses': "Vende tus cursos",
    'plans.table.row.team': 'Miembros de equipo',
    'plans.table.row.roles': 'Roles y permisos por miembro',
    'plans.table.row.analytics': 'Analíticas',
    'plans.table.row.password': 'Protección con contraseña',
    'plans.table.row.support': 'Nivel de soporte',
    'plans.table.val.withAnnual': 'Con plan anual',
    'plans.table.val.noLimit': 'Sin límite',
    'plans.table.val.standard': 'Estándar',
    'plans.table.val.aiTimes': '{times}× más',
    'plans.table.row.aiGenerations': 'Sitios generados con IA',
    'plans.table.val.generationsTotal': '{count} en total',
    'plans.table.val.generationsMonthly': '{count} al mes',
    'plans.table.val.analyticsBasic': 'Básicas',
    'plans.table.val.analyticsFull': 'Completas',
    'plans.table.val.analyticsReports': 'Completas + informes',
    'plans.table.val.supportCommunity': 'Comunidad',
    'plans.table.val.supportEmail': 'Correo',
    'plans.table.val.supportPriority': 'Prioritario',
    'plans.table.val.supportDedicated': 'Dedicado',
    'invite.kicker': 'Invitación a un equipo',
    'invite.fromSomeone': 'Te invitaron a',
    'invite.from': '{name} te invitó a',
    'invite.asRole': 'Como',
    'invite.expiresOne': 'Caduca en {count} día',
    'invite.expiresMany': 'Caduca en {count} días',
    'invite.reject': 'Rechazar',
    'invite.accept': 'Aceptar',
    'invite.entering': 'Entrando…',
    // ── Dominio: ajustes ──────────────────────────────────────────────────────
    'domain.ssl.active': 'Activo',
    'domain.ssl.pending_validation': 'En validación',
    'domain.ssl.pending_issuance': 'Emitiéndose',
    'domain.ssl.pending_deployment': 'Publicándose',
    'domain.ssl.pending_deletion': 'Retirándose',
    'domain.ssl.expired': 'Caducado',
    'domain.ssl.deleted': 'Retirado',
    'domain.ssl.initializing': 'Preparándose',
    'domain.status.active': 'Activo',
    'domain.status.verifying': 'Verificando',
    'domain.status.pending_dns': 'Esperando DNS',
    'domain.status.purchasing': 'Registrando',
    'domain.status.disconnected': 'Desconectado',
    'domain.status.error': 'Con error',
    'domain.type.A': 'Apunta el dominio a una dirección IP.',
    'domain.type.AAAA': 'Como A, pero para direcciones IPv6.',
    'domain.type.CNAME': 'Apunta un subdominio a otra dirección.',
    'domain.type.MX': 'Dice qué servidor recibe tu correo.',
    'domain.type.TXT': 'Texto libre. Lo piden Google, Microsoft y otros para verificar que el dominio es tuyo.',
    'domain.certificate': 'Certificado',
    'domain.expires': 'Vence',
    'domain.inDaysOne': 'en {count} día',
    'domain.inDaysMany': 'en {count} días',
    'domain.expired': 'ya venció',
    'domain.registeredOn': 'Registrado el',
    'domain.domain': 'Dominio',
    'domain.copied': 'Copiado',
    'domain.copy': 'Copiar',
    'domain.dns': 'Registros DNS',
    'domain.dnsBody': 'Apunta subdominios, conecta tu correo o verifica el dominio ante otros servicios.',
    'domain.addRecord': 'Añadir registro',
    'domain.field.type': 'Tipo',
    'domain.field.name': 'Nombre',
    'domain.field.value': 'Valor',
    'domain.field.priority': 'Prioridad',
    'domain.field.ttl': 'TTL',
    'domain.emptyMeans': 'Vacío = {hostname}',
    'domain.valuePlaceholderMx': 'mail.tuservidor.com',
    'domain.valuePlaceholderCname': 'destino.ejemplo.com',
    'domain.saveChanges': 'Guardar cambios',
    'domain.add': 'Añadir',
    'domain.loadingDns': 'Leyendo el DNS…',
    'domain.retry': 'Reintentar',
    'domain.noRecords': 'Este dominio todavía no tiene registros.',
    'domain.actions': 'Acciones',
    'domain.lockedTip': 'Mantiene tu sitio en línea y su certificado',
    'domain.editRecord': 'Editar {type} {name}',
    'domain.deleteRecord': 'Borrar {type} {name}',
    'domain.transfer': 'Transferir a otro registrador',
    'domain.codeRequested': 'Código solicitado',
    'domain.codeRequestedBody': 'Estará disponible aquí y en tu correo en menos de 24 horas hábiles.',
    'domain.yourCode': 'Tu código de autorización',
    'domain.codeHelp': 'Dáselo al registrador al que te llevas el dominio. No lo compartas con nadie más: con este código cualquiera puede llevárselo.',
    'domain.codeKept': ' Lo guardamos aquí hasta el {date}.',
    'domain.codeSent': 'Código enviado',
    'domain.codeSentBody': 'Revisa tu correo y la carpeta de spam.',
    'domain.asking': 'Solicitando…',
    'domain.askCode': 'Solicitar código de transferencia',
    'domain.unlockNote': 'Al emitir el código, desbloqueamos el dominio para que puedas transferirlo.',
    'domain.transferableFrom': 'Transferible desde el {date}',
    'domain.icann': 'ICANN bloquea las transferencias durante los primeros 60 días.',
    'domain.confirmDeleteAria': 'Confirmar borrado',
    'domain.confirmDelete': '¿Borrar este registro?',
    'domain.confirmDeleteNote': 'Los cambios de DNS tardan entre unos minutos y unas horas en propagarse. Si esto conecta algo (tu correo, otro servicio) dejará de funcionar mientras tanto.',
    'domain.delete': 'Borrar',
    // ── Dominios de la cuenta ─────────────────────────────────────────────────
    /* La renovación de un dominio, en la ficha de la cuenta. */
    'accountDomains.autoRenew': 'Renovar solo',
    'accountDomains.autoRenewOn': 'Lo cobramos a tu tarjeta un mes antes de que venza.',
    'accountDomains.autoRenewOff': 'Te avisaremos antes de que venza, pero tendrás que pagarlo tú.',
    'accountDomains.autoRenewFailed': 'No pudimos cambiar la renovación automática.',
    'accountDomains.renewLastFailed': 'El último cobro no entró. Revisa tu tarjeta o paga la renovación ahora.',
    'accountDomains.renewLocked': 'Bloqueado mientras revisamos un reembolso o disputa de pago.',
    'accountDomains.renewNow': 'Renovar ahora',
    'accountDomains.renewFailed': 'No pudimos abrir el pago de la renovación.',
    'accountDomains.renewSummary': 'Un año más de registro, a partir de la fecha de vencimiento actual.',
    'accountDomains.renewUnit': 'USD',
    'accountDomains.renewBilled': 'Un solo cargo. No crea ninguna suscripción.',
    'accountDomains.renewLegal': 'Al pagar, renovamos el dominio en el registrador y su vencimiento se mueve un año. Si algo fallara, te devolvemos el importe completo.',
    'accountDomains.title': 'Dominios',
    'accountDomains.subtitle': 'Los dominios de tu cuenta y el sitio en el que está cada uno.',
    'accountDomains.cardTitle': 'Tus dominios',
    'accountDomains.cardBody': 'Elige en qué sitio se usa cada uno, o abre sus ajustes para tocar el DNS.',
    'accountDomains.loading': 'Cargando…',
    'accountDomains.emptyTitle': 'Aún no tienes dominios',
    'accountDomains.emptyBody': 'Los dominios que compres en Veltica aparecerán aquí. Los externos se administran con su registrador.',
    /* El estado en la LISTA habla de la conexión con un sitio; el de la ficha
       habla del dominio en sí («Activo», «Desconectado»). Son dos lecturas del
       mismo campo y por eso tienen textos propios. */
    'accountDomains.status.active': 'Conectado',
    'accountDomains.status.verifying': 'Verificando',
    'accountDomains.status.pending_dns': 'Esperando DNS',
    'accountDomains.status.purchasing': 'Registrando',
    'accountDomains.status.disconnected': 'Sin conectar',
    'accountDomains.status.error': 'Requiere atención',
    'accountDomains.codeReady': 'Código listo',
    'accountDomains.codeRequested': 'Código solicitado',
    'accountDomains.expiresOn': 'El registro vence el {date}',
    'accountDomains.noExpiry': 'Sin fecha de vencimiento',
    'accountDomains.site': 'Sitio',
    'accountDomains.connecting': 'Conectando…',
    'accountDomains.connect': 'Conectar',
    'accountDomains.move': 'Mover',
    'accountDomains.connectedHere': 'Conectado aquí',
    'accountDomains.settingsOf': 'Ajustes de {hostname}',
    'accountDomains.dnsAndTransfer': 'DNS y transferencia',
    'accountDomains.goTo': 'Ir a {project}',
    'accountDomains.openSite': 'Abrir el sitio',
    // ── Uso y límites ─────────────────────────────────────────────────────────
    'usage.title': 'Uso y límites',
    'usage.description': 'Lo que ocupa este sitio de los topes que pone tu plan a cada proyecto.',
    'usage.planConsumption': 'Consumo del plan {plan}',
    'usage.currentCycle': 'Ciclo actual · {cycle}',
    'usage.renewsOn': 'Renueva el {date}',
    'usage.freeNoCycle': 'Plan gratuito · sin ciclo de facturación',
    'usage.noCycle': 'Sin ciclo activo',
    'usage.groupContent': 'Contenido del sitio',
    'usage.of': 'de {limit}',
    'usage.raiseLimit': 'Aumentar límite',
    'usage.unlimited': 'Uso ilimitado',
    'usage.percentUsed': '{percent}% utilizado',
    'usage.about': 'Información sobre {label}',
    'usage.noLimit': 'Sin límite',
    'usage.resetsInDays': 'Se reinicia en {count} días',
    'usage.resetsInDay': 'Se reinicia en {count} día',
    'usage.resetsInHours': 'Se reinicia en {count} horas',
    'usage.resetsInHour': 'Se reinicia en {count} hora',
    'usage.resetsInMinutes': 'Se reinicia en {count} min',
    'usage.resetsSoon': 'Se reinicia pronto',
    'usage.stat.pages': 'Páginas',
    'usage.stat.pagesBody': 'Páginas estáticas de tu sitio.',
    'usage.stat.collections': 'Colecciones CMS',
    'usage.stat.collectionsBody': 'Colecciones de contenido dinámico.',
    'usage.stat.cmsItems': 'Elementos CMS',
    'usage.stat.cmsItemsBody': 'Total de elementos en todas tus colecciones.',
    'usage.stat.offers': "Ofertas publicadas",
    'usage.stat.offersBody': "Todo lo que está a la venta desde tu sitio: productos digitales, servicios y servicios con agenda. Los borradores, las citas y las ventas no cuentan.",
    'usage.stat.contacts': "Contactos",
    'usage.stat.contactsBody': "Quienes te escribieron, compraron o reservaron, reunidos en un solo sitio.",
    'usage.stat.team': "Colaboradores",
    'usage.stat.blogPostsBody': 'Entradas del blog a la vista en tu sitio. Los borradores no cuentan.',
    'usage.stat.teamBody': "Personas invitadas a este proyecto. El dueño no ocupa asiento.",
    'usage.stat.bandwidth': 'Tráfico del sitio',
    'usage.stat.bandwidthBody': 'Volumen estimado de datos servidos a los visitantes de todos tus sitios este mes. Sin límite: es informativo.',
    'usage.stat.storage': 'Almacenamiento',
    'usage.stat.storageBody': 'Imágenes y archivos de todos tus proyectos, en un solo espacio.',
    'usage.stat.forms': 'Envíos de formularios',
    'usage.stat.formsBody': 'Envíos recibidos este mes en los formularios de todos tus sitios.',
    'usage.stat.ai': 'Asistente de IA',
    'usage.stat.aiBody': 'Lo que llevas gastado del asistente del editor, en todos tus proyectos.',
    'usage.stat.projects': 'Proyectos',
    'usage.stat.projectsBody': 'Los proyectos de los que eres dueño. Los que otros comparten contigo no cuentan.',
    'usage.stat.generations': 'Generaciones con IA',
    'usage.stat.generationsBody': 'Cada sitio o página que la IA crea desde cero gasta una.',
    'usage.noReset': 'Incluidas en tu plan: no se reponen',
    'usage.shared.title': 'Compartido entre tus proyectos',
    'usage.shared.body': 'La IA, el almacenamiento y los formularios salen de una sola bolsa en tu cuenta, no de cada sitio.',
    'usage.shared.open': 'Ver uso de la cuenta',
    'accountUsage.viewProjects': 'Ver por proyecto',
    'accountUsage.trafficProjects': 'Tráfico por proyecto',
    'accountUsage.trafficEstimate': 'Datos estimados servidos este mes calendario, según las vistas de página. Solo se incluyen los proyectos de los que eres propietario.',
    'accountUsage.project': 'Proyecto',
    'accountUsage.estimatedData': 'Datos estimados',
    'accountUsage.total': 'Total',
    'accountUsage.noProjects': 'Tus proyectos aparecerán aquí cuando crees uno.',
    'accountUsage.breakdownUnavailable': 'El desglose por proyecto aún no está disponible. Vuelve a intentarlo más tarde.',
    'accountUsage.title': 'Uso de la cuenta',
    'accountUsage.subtitle': 'Lo que gastan todos tus proyectos juntos, de la bolsa que incluye tu plan.',
    'accountUsage.groupAi': 'Inteligencia artificial',
    'accountUsage.groupResources': 'Proyectos y recursos',
    'accountUsage.perProject': 'Los topes de cada sitio (páginas, CMS, ofertas, contactos) están en «Uso y límites» dentro de cada proyecto.',
    /* El aviso de un contador que se llena. `effect` completa «Al llegar al 100%,
       …», así que va en futuro y dice lo que pasa DE VERDAD: páginas, colecciones,
       elementos, almacenamiento e IA se bloquean; los envíos de formulario siguen
       entrando marcados fuera de plan; los contactos no se bloquean en ninguna
       parte, así que su texto no promete un bloqueo que no llega. */
    'usage.noun.pages': 'páginas',
    'usage.effect.pages': 'no podrás crear páginas nuevas',
    'usage.noun.collections': 'colecciones',
    'usage.effect.collections': 'no podrás crear colecciones nuevas',
    'usage.noun.cmsItems': 'elementos CMS',
    'usage.effect.cmsItems': 'no podrás agregar más elementos a tus colecciones',
    'usage.noun.offers': "ofertas publicadas",
    'usage.effect.offers': "no podrás publicar otra hasta que retires una o subas de plan",
    'usage.noun.contacts': 'contactos',
    'usage.effect.contacts': 'tu lista llega al máximo que incluye el plan',
    'usage.noun.ai': 'uso de IA',
    'usage.effect.ai': 'el asistente dejará de responder hasta que se reinicie la cuota',
    'usage.noun.forms': 'envíos de formulario',
    'usage.effect.forms': 'los mensajes nuevos se siguen guardando, pero ya cuentan fuera de tu plan',
    'usage.noun.storage': 'almacenamiento',
    'usage.effect.storage': 'no podrás subir más imágenes ni archivos',
    'usage.noun.blogPosts': 'entradas publicadas',
    'usage.effect.blogPosts': 'no podrás publicar otra hasta que pases una a borrador o subas de plan',
    'usage.noun.teamMembers': 'colaboradores',
    'usage.effect.teamMembers': 'no podrás invitar a más personas a este proyecto',
    'usage.noun.projects': 'proyectos',
    'usage.effect.projects': 'no podrás crear proyectos nuevos',
    'usage.noun.generations': 'generaciones con IA',
    'usage.effect.generations': 'no podrás crear sitios ni páginas con IA hasta que se repongan',
    'usage.noun.bandwidth': 'tráfico',
    'usage.effect.bandwidth': 'tu sitio sigue en línea con normalidad',
    'usage.alert.warn': 'Vas por el {percent}% de {noun} de tu plan {plan}. Al llegar al 100%, {effect}.',
    'usage.alert.full': 'Llegaste al límite de {noun} de tu plan {plan}: {effect}. {upsell}',
    'usage.alert.upgrade': 'Sube a {plan} para ampliarlo.',
    'usage.alert.contact': 'Escríbenos para ampliarlo.',
    // ── Crear con IA ──────────────────────────────────────────────────────────
    'cwa.businessName': "Nombre del negocio",
    'cwa.businessNameHint': "Sale en el título, en el logo y donde los textos nombran tu negocio. Si lo cambias aquí, cambia en todo.",
    'cwa.brandLead': "Todo es opcional: sáltate lo que aún no tengas y agrégalo después en el editor.",
    'cwa.logoHint': "Sustituye el logo de la barra y del pie. Lo cambias cuando quieras en Style › Logo.",
    'cwa.contactEmail': "Correo de contacto",
    'cwa.contactEmailPlaceholder': "Si lo dejas vacío, el de tu cuenta",
    'cwa.contactEmailInvalid': "Ese correo no parece válido: no se guardará. Déjalo vacío para usar el de tu cuenta.",
    'cwa.contactEmailHint': "Donde llegan los mensajes de contacto. También va en tu aviso de privacidad y términos.",
    'cwa.address': "Dirección",
    'cwa.addressPlaceholder': "Calle, ciudad",
    'cwa.sectionVisible': "Mostrar esta sección",
    'cwa.pages.aria': "Páginas del sitio",
    'cwa.pageSections.one': "1 sección",
    'cwa.pageSections.many': "{count} secciones",
    'cwa.pageInclude': "Incluir esta página",
    'cwa.pageCatalog.tab': "Catálogo automático",
    'cwa.pageCatalog.title': "Esta página se llena sola",
    'cwa.pageCatalog.body.products': "Aquí salen tus productos, del más nuevo al más antiguo, de 12 en 12. Cuando agregues uno nuevo aparece solo. La puedes vestir en el editor.",
    'cwa.pageCatalog.body.digital': "Aquí salen tus productos digitales, del más nuevo al más antiguo, de 12 en 12. Cuando agregues uno nuevo aparece solo. La puedes vestir en el editor.",
    'cwa.pageCatalog.body.bookings': "Aquí salen tus servicios con cita, del más nuevo al más antiguo, de 12 en 12. Cuando agregues uno nuevo aparece solo. La puedes vestir en el editor.",
    'cwa.pageCatalog.body.services': "Aquí salen tus servicios, del más nuevo al más antiguo, de 12 en 12. Cuando agregues uno nuevo aparece solo. La puedes vestir en el editor.",
    'cwa.pageCatalog.body.blog': "Aquí salen tus entradas del blog, de la más nueva a la más antigua, de 12 en 12. Cuando publiques una nueva aparece sola. La puedes vestir en el editor.",
    'cwa.pageIncludeHint': "Se crea y sale en el menú. Si la quitas, puedes agregarla después en el editor.",
    'cwa.pageExcludedHint': "No se creará ni saldrá en el menú. Puedes verla aquí antes de decidir.",
    'cwa.pageExcluded': "No se creará",
    'cwa.palettes': "Más paletas",
    'cwa.fontSample': "Texto en {font}",
    'cwa.step.combination': "Combinación",
    'cwa.step.motion': "Animación",
    'cwa.wz.combination.title': "Elige una combinación",
    'cwa.wz.combination.lead': "Estilo, colores y letra juntos. Empieza con la que eligió la IA o con otra; en los siguientes pasos la ajustas poco a poco.",
    'cwa.wz.motion.title': "Elige una animación",
    'cwa.wz.motion.lead': "Cómo aparece el contenido al bajar por tu sitio. Pasa el puntero por una tarjeta para verla; después la puedes personalizar en el editor.",
    'cwa.combination.ai': "Elegida por la IA",
    'cwa.combination.aiName': "La de tu sitio",
    'cwa.combination.aiHint': "Lo que la IA pensó para tu negocio, tal como la generó.",
    'cwa.motion.suggested': "Recomendada",
    'cwa.step.style': "Estilo",
    'cwa.styleBase': "Estilo base",
    'cwa.styleBaseHint': "Define la estructura: formas, bordes, sombras y letra. Encima cambia lo que quieras de abajo.",
    'cwa.brandColor': "Color de marca",
    'cwa.fromStyle': "Del estilo",
    'cwa.customColor': "Otro",
    'cwa.fontPair': "Letra",
    'cwa.buttons': "Botones",
    'cwa.cards': "Tarjetas",
    'cwa.spacing': "Aire entre secciones",
    'cwa.sectionsHint': "Reordénalas, apágalas o prueba otra variante. La variante nueva conserva los mismos textos.",
    'cwa.variant': "Otra variante",
    'cwa.variantPrev': "Variante anterior",
    'cwa.variantNext': "Variante siguiente",
    'cwa.variantOriginal': "Original",
    'cwa.variantOf': "Variante {n} de {total}",
    'cwa.variantBackOriginal': "Volver a la original",
    'cwa.variantFailed': "No se pudo cargar esa variante. Inténtalo otra vez.",
    'cwa.moveUp': "Subir",
    'cwa.moveDown': "Bajar",
    'cwa.trimmed': "Puedes agregar más páginas y secciones desde el editor cuando quieras.",
    'cwa.exampleContent': "Los precios, testimonios y cifras son de ejemplo: revísalos antes de publicar.",
    'cwa.step.data': 'Datos',
    'cwa.step.type': 'Letra',
    'cwa.step.colors': 'Colores',
    'cwa.step.sections': 'Secciones',
    'cwa.step.brand': 'Marca',
    'welcome.business.title': "¿Qué tipo de negocio tienes?",
    'welcome.business.lead': "Con esto empezamos tu sitio con una idea que encaje. Después lo cambias todo.",
    'welcome.business.other': "Otro",
    'welcome.business.services.desc': "Consultoría, salud, legal, agencias…",
    'welcome.business.restaurant.desc': "Restaurantes, cafés, bares, catering…",
    'welcome.business.shop.desc': "Ropa, belleza, artesanía, productos…",
    'welcome.business.wellness.desc': "Spa, yoga, terapia, estética…",
    'welcome.business.portfolio.desc': "Diseño, fotografía, arte, freelance…",
    'welcome.business.other.desc': "Escríbelo con tus palabras.",
    'welcome.goal.bookings.desc': "Citas y clases con horario y pago.",
    'welcome.goal.services.desc': "Paquetes y servicios con su precio.",
    'welcome.goal.products.desc': "Productos físicos o digitales.",
    'welcome.goal.blog.desc': "Novedades, guías e historias.",
    'welcome.goal.showcase.desc': "Quién eres, qué haces y cómo contactarte.",
    'welcome.business.fitness': "Fitness",
    'welcome.business.fitness.desc': "Gimnasios, entrenadores, yoga, deportes…",
    'welcome.business.health': "Salud",
    'welcome.business.health.desc': "Clínicas, dentistas, terapia, nutrición…",
    'welcome.business.education': "Educación",
    'welcome.business.education.desc': "Cursos, escuelas, clases, coaching…",
    'welcome.business.realestate': "Bienes raíces",
    'welcome.business.realestate.desc': "Agentes, propiedades, rentas…",
    'welcome.business.events': "Eventos",
    'welcome.business.events.desc': "Bodas, salones, organización, conferencias…",
    'welcome.business.hospitality': "Hoteles y viajes",
    'welcome.business.hospitality.desc': "Hoteles, rentas vacacionales, tours…",
    'welcome.business.trades': "Servicios del hogar",
    'welcome.business.trades.desc': "Construcción, limpieza, reparaciones…",
    'welcome.business.creator': "Marca personal",
    'welcome.business.creator.desc': "Creadores, conferencistas, coaches…",
    'welcome.business.tech': "Tecnología",
    'welcome.business.tech.desc': "Software, apps, SaaS…",
    'welcome.business.nonprofit': "Sin fines de lucro",
    'welcome.business.nonprofit.desc': "Fundaciones, comunidades, iglesias…",
    'welcome.business.otherLabel': "¿A qué se dedica tu negocio?",
    'welcome.business.otherPlaceholder': "Ej. estudio de tatuajes, escuela de música…",
    'welcome.goals.title': "¿Qué quieres que haga tu sitio?",
    'welcome.goals.lead': "Elige todas las que quieras.",
    'welcome.goal.bookings': "Recibir reservas",
    'welcome.goal.services': "Vender servicios",
    'welcome.goal.products': "Vender productos",
    'welcome.goal.blog': "Publicar un blog",
    'welcome.goal.showcase': "Presentar mi negocio",
    'brief.aria': "Lo que se le dice a la IA de este sitio",
    'brief.business': "Industria",
    'brief.goals': "Quiero",
    'brief.removeGoal': "Quitar «{name}»",
    'brief.addGoal': "Añadir objetivo",
    'brief.goalShort.bookings': "Reservas",
    'brief.goalShort.services': "Servicios",
    'brief.goalShort.products': "Tienda",
    'brief.goalShort.blog': "Blog",
    'brief.goalShort.showcase': "Presentación",
    'brief.none': "Sin indicar",
    'brief.photos': "Fotos",
    'brief.photosAdd': "Añadir fotos tuyas",
    'brief.photosDrop': "Suelta tus fotos: la IA las pondrá en tu sitio",
    'brief.photosHint': "Tus fotos: la IA las pone en tu sitio, las primeras en la portada",
    'brief.photosCount': "Fotos · {count}/{max}",
    'brief.photosRemove': "Quitar la foto {n}",
    'brief.photoAlt': "Tu foto {n}",
    'brief.photosUploading': "Subiendo tus fotos…",
    'brief.photosFailed': "Alguna foto no se pudo subir. Vuelve a intentarlo.",
    'brief.photosLimit': "Tu plan admite hasta {max} fotos aquí. Después puedes subir más desde el editor.",
    'welcome.skip': "Omitir",
    'start.idea.services.1': "Consultoría",
    'start.idea.services.1.prompt': "Una consultoría profesional. Quiero explicar en qué ayudamos, mostrar casos de éxito y que agenden una llamada de diagnóstico.",
    'start.idea.services.2': "Despacho legal",
    'start.idea.services.2.prompt': "Un despacho de abogados cercano y confiable. Quiero presentar las áreas de práctica y al equipo, y facilitar que pidan una consulta.",
    'start.idea.services.3': "Agencia creativa",
    'start.idea.services.3.prompt': "Una agencia de marketing y diseño. Quiero mostrar nuestros servicios y proyectos recientes, y recibir solicitudes de cotización.",
    'start.idea.restaurant.1': "Taquería",
    'start.idea.restaurant.1.prompt': "Una taquería familiar con sabor casero. Quiero presentar el menú, los horarios y la ubicación, y recibir pedidos para llevar.",
    'start.idea.restaurant.2': "Café de especialidad",
    'start.idea.restaurant.2.prompt': "Una cafetería de especialidad acogedora. Quiero contar el origen del café, mostrar la carta y que reserven mesa para grupos.",
    'start.idea.restaurant.3': "Restaurante para eventos",
    'start.idea.restaurant.3.prompt': "Un restaurante elegante con salón privado. Quiero mostrar el menú de temporada y facilitar reservas y cotizaciones para eventos.",
    'start.idea.shop.1': "Ropa y accesorios",
    'start.idea.shop.1.prompt': "Una marca de ropa y accesorios con estilo propio. Quiero mostrar las colecciones, contar la historia de la marca y guiar a la compra.",
    'start.idea.shop.2': "Cosmética natural",
    'start.idea.shop.2.prompt': "Una tienda de cosmética natural. Quiero destacar los ingredientes y beneficios de cada producto y generar confianza con reseñas.",
    'start.idea.shop.3': "Hecho a mano",
    'start.idea.shop.3.prompt': "Un taller de productos hechos a mano. Quiero mostrar el proceso y las piezas disponibles, y aceptar pedidos personalizados.",
    'start.idea.wellness.1': "Spa",
    'start.idea.wellness.1.prompt': "Un spa de relajación y masajes. Quiero presentar los tratamientos con sus precios y que reserven su cita en línea.",
    'start.idea.wellness.2': "Salón de belleza",
    'start.idea.wellness.2.prompt': "Un salón de belleza moderno. Quiero mostrar los servicios y el trabajo del equipo, y facilitar que agenden.",
    'start.idea.wellness.3': "Estética y piel",
    'start.idea.wellness.3.prompt': "Un estudio de estética y cuidado de la piel. Quiero explicar cada tratamiento, resolver dudas frecuentes y recibir citas.",
    'start.idea.fitness.1': "Gimnasio",
    'start.idea.fitness.1.prompt': "Un gimnasio de barrio con buen ambiente. Quiero mostrar las instalaciones, los planes de membresía y los horarios de clases.",
    'start.idea.fitness.2': "Entrenador personal",
    'start.idea.fitness.2.prompt': "Un entrenador personal. Quiero presentar mis programas, mostrar resultados de clientes y que agenden una sesión de prueba.",
    'start.idea.fitness.3': "Yoga y pilates",
    'start.idea.fitness.3.prompt': "Un estudio de yoga y pilates. Quiero presentar las clases y a los instructores, y que reserven su lugar en cada clase.",
    'start.idea.health.1': "Clínica dental",
    'start.idea.health.1.prompt': "Una clínica dental familiar. Quiero presentar los tratamientos y al equipo, generar confianza y que agenden su cita.",
    'start.idea.health.2': "Psicología",
    'start.idea.health.2.prompt': "Un consultorio de psicología. Quiero explicar mi enfoque y las terapias que ofrezco, y que agenden una primera sesión.",
    'start.idea.health.3': "Nutrición",
    'start.idea.health.3.prompt': "Una consulta de nutrición. Quiero presentar mis planes de alimentación, compartir consejos y recibir consultas en línea y presenciales.",
    'start.idea.education.1': "Curso en línea",
    'start.idea.education.1.prompt': "Un curso en línea. Quiero explicar qué se aprende, quién lo imparte y el temario, y vender el acceso.",
    'start.idea.education.2': "Clases particulares",
    'start.idea.education.2.prompt': "Clases particulares de idiomas o materias escolares. Quiero presentar los niveles y los precios, y que reserven su clase.",
    'start.idea.education.3': "Coaching",
    'start.idea.education.3.prompt': "Un programa de coaching. Quiero contar mi método, mostrar testimonios y que agenden una sesión de descubrimiento.",
    'start.idea.realestate.1': "Agente inmobiliario",
    'start.idea.realestate.1.prompt': "Un agente inmobiliario independiente. Quiero mostrar propiedades destacadas y mi experiencia, y recibir solicitudes de visita.",
    'start.idea.realestate.2': "Desarrollo residencial",
    'start.idea.realestate.2.prompt': "Un desarrollo residencial nuevo. Quiero presentar los modelos, las amenidades y la ubicación, y captar interesados.",
    'start.idea.realestate.3': "Rentas",
    'start.idea.realestate.3.prompt': "Una empresa de renta de departamentos. Quiero mostrar las unidades disponibles y los requisitos, y facilitar el contacto.",
    'start.idea.events.1': "Bodas",
    'start.idea.events.1.prompt': "Una organizadora de bodas. Quiero mostrar bodas que hemos hecho y los paquetes, y recibir solicitudes de cotización.",
    'start.idea.events.2': "Salón de eventos",
    'start.idea.events.2.prompt': "Un salón de eventos. Quiero presentar los espacios, la capacidad y los paquetes, y que aparten su fecha.",
    'start.idea.events.3': "Conferencia",
    'start.idea.events.3.prompt': "Una conferencia anual. Quiero presentar a los ponentes y la agenda, y vender los boletos.",
    'start.idea.hospitality.1': "Hotel boutique",
    'start.idea.hospitality.1.prompt': "Un hotel boutique. Quiero mostrar las habitaciones y las experiencias de la zona, y facilitar las reservaciones.",
    'start.idea.hospitality.2': "Renta vacacional",
    'start.idea.hospitality.2.prompt': "Una casa de renta vacacional. Quiero mostrar los espacios, las amenidades y las reglas, y recibir reservaciones.",
    'start.idea.hospitality.3': "Tours",
    'start.idea.hospitality.3.prompt': "Una agencia de tours locales. Quiero presentar los recorridos con su duración y precio, y que reserven su lugar.",
    'start.idea.trades.1': "Construcción",
    'start.idea.trades.1.prompt': "Una empresa de construcción y remodelación. Quiero mostrar proyectos terminados y los servicios, y recibir solicitudes de presupuesto.",
    'start.idea.trades.2': "Limpieza",
    'start.idea.trades.2.prompt': "Un servicio de limpieza para hogares y oficinas. Quiero explicar los paquetes, generar confianza y que agenden una visita.",
    'start.idea.trades.3': "Reparaciones",
    'start.idea.trades.3.prompt': "Un servicio de plomería y electricidad. Quiero mostrar las zonas que cubrimos y los servicios, y que nos contacten rápido.",
    'start.idea.portfolio.1': "Fotografía",
    'start.idea.portfolio.1.prompt': "Un fotógrafo de bodas y retratos. Quiero mostrar mis mejores trabajos y los paquetes, y recibir solicitudes de fecha.",
    'start.idea.portfolio.2': "Diseño gráfico",
    'start.idea.portfolio.2.prompt': "Una diseñadora gráfica independiente. Quiero mostrar proyectos con su proceso y mis servicios, y atraer nuevos clientes.",
    'start.idea.portfolio.3': "Arquitectura",
    'start.idea.portfolio.3.prompt': "Un despacho de arquitectura. Quiero presentar obras terminadas y nuestra filosofía, y recibir consultas de proyectos.",
    'start.idea.creator.1': "Creador de contenido",
    'start.idea.creator.1.prompt': "Un creador de contenido. Quiero presentar quién soy, mis redes y colaboraciones, y recibir propuestas de marcas.",
    'start.idea.creator.2': "Conferencista",
    'start.idea.creator.2.prompt': "Un conferencista. Quiero mostrar mis temas y los eventos donde he hablado, y que me contraten para su evento.",
    'start.idea.creator.3': "Coach de vida",
    'start.idea.creator.3.prompt': "Una coach de vida. Quiero contar mi historia y mis programas, y que agenden una llamada gratuita.",
    'start.idea.tech.1': "App móvil",
    'start.idea.tech.1.prompt': "Una app móvil. Quiero explicar qué problema resuelve, mostrar sus funciones y que la descarguen.",
    'start.idea.tech.2': "SaaS",
    'start.idea.tech.2.prompt': "Un software por suscripción para negocios. Quiero mostrar beneficios, planes y precios, y que lo prueben gratis.",
    'start.idea.tech.3': "Software a la medida",
    'start.idea.tech.3.prompt': "Una empresa de desarrollo de software a la medida. Quiero mostrar casos y tecnologías, y recibir solicitudes de proyecto.",
    'start.idea.nonprofit.1': "Fundación",
    'start.idea.nonprofit.1.prompt': "Una fundación sin fines de lucro. Quiero contar nuestra causa, mostrar el impacto y recibir donativos.",
    'start.idea.nonprofit.2': "Comunidad",
    'start.idea.nonprofit.2.prompt': "Una comunidad o asociación. Quiero presentar nuestras actividades y próximos eventos, y que se unan como miembros.",
    'start.idea.nonprofit.3': "Iglesia",
    'start.idea.nonprofit.3.prompt': "Una iglesia. Quiero compartir los horarios de servicio, los ministerios y los eventos, y dar la bienvenida a nuevos visitantes.",
    'cwa.title': 'Cuéntanos qué quieres construir',
    'cwa.promptPlaceholder': 'Describe tu negocio, lo que ofreces y el objetivo de tu sitio.',
    'cwa.ideaTry': "¿Sin ideas? Prueba un ejemplo",
    'cwa.ideaTryShort': "Prueba un ejemplo",
    'cwa.ideaAnother': "Otro ejemplo",
    'cwa.minChars': 'Faltan {missing} caracteres',
    'cwa.canChange': 'Puedes cambiar todo esto en el siguiente paso',
    'cwa.generate': 'Generar mi sitio',
    'cwa.generating': 'Generando tu sitio…',
    'cwa.created': "¡Tu sitio está listo!",
    'cwa.createdSub': "Preparando la vista previa…",
    'cwa.projectName': 'Nombre del proyecto',
    'cwa.slugPlaceholder': 'mi-proyecto',
    'cwa.slugTaken': 'Esa URL ya está en uso, elige otra.',
    'cwa.typography': 'Combinación de textos',
    'cwa.palette': 'Colores globales',
    'cwa.auto': 'Automático (IA)',
    'cwa.sections': 'Secciones',
    'cwa.logo': 'Logo',
    'cwa.phone': 'Número de empresa',
    'cwa.instagram': 'Instagram',
    'cwa.facebook': 'Facebook',
    'cwa.back': 'Atrás',
    'cwa.next': 'Siguiente',
    'cwa.creating': 'Creando…',
    'cwa.create': 'Crear proyecto',
    /* Las ideas de arranque. El texto largo no es de pantalla: es lo que se le
       manda a la IA, así que traducirlo es lo que hace que a quien tiene el panel
       en inglés le salga un sitio en inglés. */
    'cwa.tpl.services': 'Servicios',
    'cwa.tpl.servicesPrompt': 'Un negocio de servicios profesionales. Quiero explicar con claridad lo que ofrecemos, generar confianza y recibir solicitudes de contacto.',
    'cwa.tpl.restaurant': 'Restaurante',
    'cwa.tpl.restaurantPrompt': 'Un restaurante con una identidad cercana y actual. Quiero presentar el menú, contar la historia del negocio y facilitar las reservaciones.',
    'cwa.tpl.shop': 'Tienda',
    'cwa.tpl.shopPrompt': 'Una tienda en línea moderna y fácil de explorar. Quiero destacar los productos, sus beneficios y guiar a las personas hacia la compra.',
    'cwa.tpl.wellness': 'Bienestar',
    'cwa.tpl.wellnessPrompt': 'Una marca de bienestar profesional y accesible. Quiero presentar los servicios, resolver dudas frecuentes y facilitar las citas.',
    'cwa.tpl.portfolio': 'Portafolio',
    'cwa.tpl.portfolioPrompt': 'Un portafolio con una identidad visual memorable. Quiero mostrar proyectos, explicar mi forma de trabajar y recibir nuevas oportunidades.',
    'start.promptAria': 'Describe el proyecto que quieres crear',
    'start.template': 'Desde una plantilla',
    'start.templateBody': 'Elige un diseño hecho y cámbiale los colores, la tipografía y el contenido.',
    'start.blank': 'Proyecto en blanco',
    'start.blankBody': 'Un lienzo vacío. Para cuando ya sabes exactamente qué quieres construir.',
    'start.site': "Tu página editada",
    'start.siteBodyStyle': "La que cambiaste en la demo de veltica.com, con el estilo {design}: tus textos, tus fotos y tus secciones.",
    'start.siteBody': "La que cambiaste en la demo de veltica.com: tus textos, tus fotos y tus secciones.",
    'start.siteNamed': "Seguir con {name}",
    'start.siteBodyExample': "La página que armó la IA en veltica.com, con sus textos y fotos, y su tienda lista para completar con tus precios.",
    'start.describeExample': "Describir {name}",
    'start.siteGo': "Seguir con mi página",
    'start.siteDrop': "Quitar la página que traes de veltica.com",
    'start.go': 'Empezar',
    // ── Alta de un servicio reservable ────────────────────────────────────────
    'svcw.weekday.0': 'Dom',
    'svcw.weekday.1': 'Lun',
    'svcw.weekday.2': 'Mar',
    'svcw.weekday.3': 'Mié',
    'svcw.weekday.4': 'Jue',
    'svcw.weekday.5': 'Vie',
    'svcw.weekday.6': 'Sáb',
    'svcw.step.info': 'Información',
    'svcw.step.settings': 'Ajustes',
    'svcw.step.price': 'Precio',
    'svcw.step.form': 'Formulario',
    'svcw.step.schedule': 'Horario',
    'svcw.step.cancel': 'Cancelación',
    'svcw.step.review': 'Revisión',
    'svcw.pay.free': 'Gratis',
    'svcw.pay.freeHint': 'Sin costo: la reserva se confirma al momento.',
    'svcw.price.freeLabel': 'Gratis',
    'svcw.price.onsiteLabel': '{price} · en el lugar',
    'svcw.price.onsiteAmountHint': 'Lo que pagará en el lugar. Sale en la página, no se cobra en línea.',
    'svcw.pay.onsite': 'Se paga en el lugar',
    'svcw.pay.onsiteHint': 'Se enseña el precio, pero se cobra allí, no en línea.',
    'svcw.pay.prepaid': 'Se paga al reservar',
    'svcw.pay.prepaidHint': 'El cliente paga antes de confirmar.',
    'svcw.pay.deposit': 'Se deja un anticipo',
    'svcw.pay.depositHint': 'Una parte al reservar y el resto en el lugar.',
    'svcw.membership.manageHint': "También puedes crearlas y elegir sus reservas en Catálogo › Membresías y paquetes.",
    'nav.memberships': "Membresías",
    'section.memberships': "Membresías",
    'memberships.title': "Membresías y paquetes",
    'memberships.subtitle': "Membresías que se cobran cada cierto tiempo y paquetes de un solo pago: reservas incluidas, productos digitales y descuento.",
    'memberships.new': "Nueva membresía",
    'memberships.needBookingsTitle': "Primero crea alguna oferta",
    'memberships.needBookingsBody': "Una membresía o un paquete incluye reservas, productos digitales o descuento en tu catálogo. Crea al menos una oferta para poder ofrecerla.",
    'memberships.needBookingsCta': "Ir a ofertas",
    'memberships.form.discount': "Descuento para miembros",
    'memberships.form.discountLead': "Un porcentaje menos en productos, servicios sin reserva y digitales mientras la membresía esté activa.",
    'memberships.form.discountPercent': "Descuento",
    'memberships.form.discountScope': "Aplica a",
    'memberships.form.discountAll': "Todo el catálogo",
    'memberships.form.discountSome': "Elegir",
    'memberships.form.discountNone': "Todavía no tienes productos ni servicios que se compren de una vez.",
    'memberships.form.discountHint': "Se aplica al pagar cuando el cliente entra con su cuenta. Los cupones siguen valiendo encima.",
    'memberships.discountAll': "{percent} % para miembros en todo el catálogo",
    'memberships.discountSome': "{percent} % para miembros en {count} ofertas",
    'memberships.wizard.step.info': "Información",
    'memberships.wizard.step.access': "Precio y acceso",
    'memberships.wizard.step.review': "Revisar",
    'memberships.wizard.info.kicker': "Paso 1",
    'memberships.wizard.info.title': "¿Qué vas a ofrecer?",
    'memberships.wizard.info.lead': "Una membresía se cobra cada cierto tiempo; un paquete es un solo pago.",
    'memberships.wizard.descriptionFoot': "Sale en la tarjeta y en la página de compra.",
    'memberships.wizard.needName': "Ponle un nombre.",
    'memberships.wizard.access.kicker': "Paso 2",
    'memberships.wizard.access.title': "Cuánto cuesta y cada cuánto se cobra",
    'memberships.wizard.access.titlePack': "Cuánto cuesta y cuánto dura",
    'memberships.wizard.perPeriodHint': "Cuántas puede hacer en cada periodo de cobro.",
    'memberships.wizard.needPrice': "Escribe un precio mayor que cero.",
    'memberships.wizard.needRule': "Indica cuántas reservas o días.",
    'memberships.wizard.needDiscount': "Escribe un porcentaje y elige al menos una oferta.",
    'memberships.wizard.review.title': "Revisa tu membresía",
    'memberships.wizard.previewHint': "Así la ve tu cliente",
    'memberships.wizard.more': "y {count} más",
    'memberships.wizard.cta': "Hacerme miembro",
    'memberships.wizard.ctaPack': "Comprar paquete",
    'memberships.detail.back': "Volver a membresías",
    'memberships.detail.draftTitle.membership': "Esta membresía no está activa aún",
    'memberships.detail.draftTitle.pack': "Este paquete no está activo aún",
    'memberships.detail.draftBody': "Está guardada en borrador. Cuando esté lista, publícala para que tus clientes puedan comprarla desde tu página.",
    'memberships.wizard.review.draftWarnOne': "1 servicio incluido está en borrador: tus clientes no podrán reservarlo.",
    'memberships.wizard.review.draftWarn': "{count} servicios incluidos están en borrador: tus clientes no podrán reservarlos.",
    'memberships.wizard.review.publishDraftsOne': "Publicar también ese servicio",
    'memberships.wizard.review.publishDrafts': "Publicar también esos servicios",
    'memberships.wizard.review.empty': "Para publicarla tiene que dar algo que ya esté publicado: reservas, productos digitales o un descuento. Puedes guardarla en borrador.",
    'memberships.wizard.publishDraftFailed': "No se pudo publicar «{title}». Revísala en Reservas.",
    'memberships.detail.emptyTitle.membership': "Esta membresía todavía no tiene miembros",
    'memberships.detail.emptyBody.membership': "Cuando alguien se haga miembro, el primer cobro y cada renovación aparecen aquí en cuanto Stripe los confirme.",
    'memberships.detail.emptyTitle.pack': "Este paquete todavía no se ha vendido",
    'memberships.detail.emptyBody.pack': "Cuando alguien lo compre, el pago aparece aquí en cuanto Stripe lo confirme.",
    'memberships.wizard.step.benefits': "Qué incluye",
    'memberships.wizard.benefits.kicker': "Paso 3",
    'memberships.wizard.benefits.title': "¿Qué incluye?",
    'memberships.wizard.benefits.lead': "Activa al menos una.",
    'memberships.wizard.benefits.leadPack': "Activa al menos una.",
    'memberships.wizard.benefits.classes': "Reservas incluidas",
    'memberships.wizard.benefits.classesHint': "Reservan sin pagar cada vez.",
    'memberships.wizard.benefits.discountHint': "Un % menos en productos y servicios.",
    'memberships.wizard.benefits.noClasses': "Todavía no tienes servicios con reserva.",
    'memberships.wizard.needClasses': "Elige al menos un servicio con reserva.",
    'memberships.wizard.needBenefit': "Activa al menos una: reservas, productos digitales o descuento.",
    'memberships.wizard.priceMode': "Precio",
    'memberships.wizard.paid': "De pago",
    'memberships.wizard.free': "Gratis",
    'memberships.wizard.freeHint': "Se unen con su cuenta. Sin reservas incluidas.",
    'memberships.wizard.benefits.leadFree': "Una membresía gratis da descuento.",
    'memberships.wizard.benefits.classesFree': "No disponible en una membresía gratis.",
    'memberships.wizard.whyTitle': "Una membresía gratis no incluye reservas",
    'memberships.wizard.whyBody': "Cualquiera podría unirse y reservar gratis sin límite. Para incluir reservas, ponle un precio (aunque sea bajo) o crea un paquete.",
    'memberships.wizard.whyOk': "Entendido",
    'memberships.wizard.kindLockedTitle': "Ya no se puede cambiar el tipo",
    'memberships.wizard.kindLockedBody': "Esta oferta ya tiene miembros o compras. Cambiarla de membresía a paquete (o al revés) dejaría sin efecto lo que ya pagaron. Crea una nueva del otro tipo.",
    'memberships.free.title': "Miembros",
    'memberships.free.count': "{count} activos",
    'memberships.free.since': "Desde el {date}",
    'memberships.free.active': "Activo",
    'memberships.free.left': "Salió",
    'memberships.free.emptyBody': "Cuando alguien se una desde tu sitio, aparece aquí.",
    'memberships.form.perCycle': "por periodo",
    'memberships.wizard.validity': "Vigencia",
    'memberships.wizard.validityHint': "Las reservas y los productos digitales del paquete valen este tiempo.",
    'memberships.wizard.benefits.digital': "Productos digitales",
    'memberships.wizard.benefits.digitalHintMembership': "Los descargan desde su cuenta mientras la membresía esté activa.",
    'memberships.wizard.benefits.digitalHintPack': "Los descargan desde su cuenta durante la vigencia del paquete.",
    'memberships.wizard.benefits.noDigital': "Todavía no tienes productos digitales.",
    'memberships.wizard.needDigital': "Elige al menos un producto digital.",
    'memberships.wizard.needCredits': "Indica cuántas reservas trae.",
    'memberships.wizard.howMany': "Cuántas",
    'memberships.wizard.review.digital': "Productos digitales",
    'memberships.wizard.digitalKind': "Producto digital",
    'memberships.wizard.draftLabel': "Borrador",
    'memberships.emptyTitle': "Aún no tienes membresías",
    'memberships.emptyBody': "Crea una membresía o un paquete y elige qué da: reservas incluidas, productos digitales o descuento en tu catálogo.",
    'memberships.proBody': "Las membresías y los paquetes son del plan Pro.",
    'memberships.kind.membership': "Membresía",
    'memberships.kind.pack': "Paquete",
    'memberships.noPrice': "Sin precio",
    'memberships.perMonth': "{price} al mes",
    'memberships.perYear': "{price} al año",
    'memberships.unlimited': "Reservas ilimitadas",
    'memberships.perPeriod': "{count} reservas por periodo",
    'memberships.packRule': "{count} reservas",
    'memberships.packRuleDays': "{count} reservas · valen {days} días",
    'memberships.draft': "Borrador",
    'memberships.includesNone': "Todavía no incluye reservas",
    'memberships.members': "{count} con la membresía activa",
    'memberships.viewPage': "Ver página",
    'memberships.saved': "Membresía guardada.",
    'memberships.saveFailed': "No se pudo guardar la membresía.",
    'memberships.publishFailed': "Se guardó en borrador: no se pudo publicar.",
    'memberships.form.newTitle': "Nueva membresía",
    'memberships.form.editTitle': "Editar membresía",
    'memberships.form.lead': "Lo que se cobra y lo que incluye.",
    'memberships.form.name': "Nombre",
    'memberships.form.namePlaceholder': "Membresía ilimitada",
    'memberships.form.namePackPlaceholder': "Paquete de 10 sesiones",
    'memberships.form.description': "Descripción corta",
    'memberships.form.descriptionPlaceholder': "Todo lo que incluye, en una frase.",
    'memberships.form.type': "Tipo",
    'memberships.form.membershipHint': "Se cobra cada cierto tiempo, hasta que el cliente la cancele.",
    'memberships.form.packHint': "Un solo pago por reservas, productos digitales o ambos.",
    'memberships.form.price': "Precio",
    'memberships.form.monthly': "Al mes",
    'memberships.form.yearly': "Al año",
    'memberships.form.oneTime': "Pago único",
    'memberships.form.perMonth': "al mes",
    'memberships.form.perYear': "al año",
    'memberships.form.includes': "Reservas que incluye",
    'memberships.form.noBookings': "Todavía no tienes servicios con reserva. Créalos en «Reservas» y vuelve aquí para incluirlos.",
    'memberships.form.bookingKind': "Reserva",
    'memberships.form.includesHint': "Los servicios que marques se reservan con esta membresía o paquete.",
    'memberships.form.priceSection': "Precio y acceso",
    'memberships.form.billing': "Cobro",
    'memberships.form.limited': "Un número",
    'memberships.form.howMany': "Cuántas",
    'memberships.form.classesUnit': "reservas",
    'memberships.form.validity': "Vigencia",
    'memberships.form.expiresShort': "Caducan",
    'memberships.form.daysUnit': "días",
    'memberships.form.publishTitle': "Publicada",
    'memberships.form.publishOn': "Se puede comprar en tu sitio.",
    'memberships.form.publishOff': "Borrador: no aparece en tu sitio.",
    'memberships.form.needFields': "Falta el nombre, el precio o lo que incluye.",
    'memberships.form.create': "Crear membresía",
    'svcw.pay.membership': "Sólo miembros",
    'svcw.pay.membershipHint': "Sólo la reservan quienes tienen una de tus membresías o paquetes.",
    'svcw.pay.alsoIncluded': "También incluida en membresías y paquetes",
    'svcw.pay.alsoIncludedHint': "Quien tenga una de las elegidas la reserva sin pagar; los demás pagan el precio normal.",
    'svcw.price.membershipLabel': "Incluida con membresía",
    'svcw.cancel.membershipNote': "Sin cobro en la reserva: si se cancela, la clase vuelve a su membresía o paquete.",
    'svcw.invalid.membership': "Elige al menos una membresía o paquete, y cuántas clases da cada paquete.",
    'svcw.membership.lead': "Elige qué membresías o paquetes incluyen este servicio.",
    'svcw.membership.kindMembership': "Membresía",
    'svcw.membership.kindPack': "Paquete",
    'svcw.membership.perPeriod': "Reservas por periodo",
    'svcw.membership.unlimited': "Ilimitadas",
    'svcw.membership.limited': "Un número",
    'svcw.membership.credits': "Reservas incluidas",
    'svcw.membership.validFor': "Válido por",
    'svcw.membership.noExpiry': "Sin caducidad",
    'svcw.membership.days': "Días",
    'svcw.membership.shared': "Lo que da cada membresía o paquete vale para todos los servicios que lo incluyan.",
    'svcw.membership.empty': "Todavía no tienes membresías ni paquetes. Créalos en Catálogo › Membresías y paquetes.",
    'svcw.membership.proTitle': "Disponible desde el plan Pro",
    'svcw.membership.proBody': "Las reservas incluidas en membresías y paquetes son del plan Pro.",
    'svcw.membership.seePlans': "Ver planes",
    'svcw.membership.notReady': "Esta función todavía no está lista en tu cuenta.",
    'svcw.membership.loadFailed': "No pudimos cargar tus membresías. Inténtalo de nuevo.",
    'svcw.taken.held': 'Apartada',
    'svcw.taken.confirmed': 'Confirmada',
    'svcw.taken.completed': 'Completada',
    /* Cantidades dichas como las diría una persona: 90 minutos no son «90 min»
       en una frase, son «hora y media». */
    'svcw.min.nothing': 'nada',
    'svcw.min.minutes': '{count} min',
    'svcw.min.oneDay': 'un día',
    'svcw.min.days': '{count} días',
    'svcw.min.oneHour': 'una hora',
    'svcw.min.hours': '{count} horas',
    'svcw.min.oneHourHalf': 'hora y media',
    'svcw.min.hoursHalf': '{count} horas y media',
    'svcw.min.hoursRest': '{hours} y {rest} min',
    'svcw.dur.minutes': '{count} min',
    'svcw.dur.hours': '{count} h',
    'svcw.dur.hoursMinutes': '{hours} h {minutes} min',
    'svcw.day.one': '{count} día',
    'svcw.day.many': '{count} días',
    'svcw.person.one': '{count} persona',
    'svcw.person.many': '{count} personas',
    /* Cabecera del asistente. */
    'svcw.newTitle': 'Nuevo servicio reservable',
    'svcw.editAria': 'Editar {name}',
    'svcw.progressAria': 'Pasos del creador',
    'svcw.saveAndClose': 'Guardar y salir',
    'svcw.saveChanges': 'Guardar cambios',
    'svcw.saving': 'Guardando…',
    /* Paso 1 · información. */
    'svcw.info.kicker': 'Información básica',
    'svcw.info.title': '¿Qué van a reservar?',
    'svcw.info.lead': 'Esta información será lo primero que verá el cliente.',
    'svcw.info.name': 'Nombre',
    'svcw.info.namePlaceholder': 'Ej. Consulta inicial',
    'svcw.info.description': 'Descripción',
    'svcw.info.image': 'Imagen del servicio',
    'svcw.info.optional': 'Opcional',
    'svcw.info.imageAlt': 'Vista previa del servicio',
    'svcw.info.logo': 'Logo',
    'svcw.info.logoAlt': 'Vista previa del logo',
    'svcw.info.accent': 'Color de acento',
    /* Paso 2 · ajustes. */
    'svcw.set.kicker': 'Ajustes',
    'svcw.set.title': 'Define cómo funciona',
    'svcw.set.duration': '¿Cuánto dura cada cita?',
    'svcw.set.capacity': '¿Cuántas personas por horario?',
    'svcw.set.capacityHint': 'Individual atiende de una en una. Grupal deja que varias reserven la misma hora, como en una clase.',
    'svcw.set.single': 'Individual',
    'svcw.page.oneToOne': 'Cita individual',
    'svcw.page.spots': '{count} lugares',
    'svcw.set.group': 'Grupal',
    'svcw.set.perSlot': 'Personas por horario',
    'svcw.set.people': 'personas',
    'svcw.set.seatsHint': 'Cuántas plazas hay en cada horario. Al llenarse, esa hora deja de ofrecerse.',
    'svcw.spots.title': 'Lugares que quedan, en la página',
    'svcw.spots.low': 'Sólo si quedan pocos',
    'svcw.spots.lowHint': 'Con el 15 % o menos dice «Quedan pocos» o «Último lugar».',
    'svcw.spots.all': 'Siempre el número',
    'svcw.spots.allHint': '«Quedan 8 lugares», con barra de ocupación.',
    'svcw.spots.none': 'No mostrar',
    'svcw.spots.noneHint': 'Sólo se avisa cuando está llena.',
    'svcw.set.maxParty': 'Lugares por compra',
    'svcw.set.maxPartyHint': 'Cuántos lugares puede comprar una persona a la vez, para ella y sus acompañantes. 1 = un lugar por compra.',
    'svcw.unit.title': 'Cómo se reserva',
    'svcw.unit.time': 'Por horas',
    'svcw.unit.day': 'Por días',
    'svcw.unit.timeHint': 'Citas con hora de inicio y fin: una consulta, un corte, una clase.',
    'svcw.unit.dayHint': 'Días enteros, de medianoche a medianoche: una sesión de fotos, un evento, una renta. Bloquea el día completo en tu agenda.',
    'svcw.days.title': 'Cuántos días',
    'svcw.days.hint': 'Fijo, o que el cliente elija cuántos. En el horario sólo cuenta qué días trabajas.',
    'svcw.days.full': 'Día completo',
    'svcw.days.count': '{count} días',
    'svcw.days.range': '{min}–{max} días',
    'svcw.days.custom': 'Cuántos días',
    'svcw.days.flexible': 'El cliente elige',
    'svcw.days.from': 'Desde',
    'svcw.days.to': 'Hasta',
    'svcw.days.unit': 'días',
    'svcw.days.perDay': 'Con días a elegir, el precio es por día.',
    'svcw.team.who': 'Quién da este servicio',
    'svcw.team.whoHint': 'Con varias personas, quien reserva elige con quién o «Cualquiera disponible».',
    'svcw.team.onlyOne': 'Hoy sólo estás tú. Agrega a alguien aquí abajo para que varias personas den este servicio.',
    'svcw.team.scheduleOf': 'Horario de',
    'svcw.team.editingHint': 'Cada persona tiene un solo horario: lo que cambies aquí vale para todos los servicios de {name}.',
    'svcw.team.addSave': 'Agregar',
    'svcw.team.addCancel': 'Cancelar',
    'svcw.team.addRole': 'Puesto (opcional)',
    'svcw.team.addName': 'Nombre',
    'svcw.team.add': 'Agregar persona',
    'svcw.set.onePerSlot': 'Una persona por horario.',
    'svcw.set.reminder': 'Recordatorio',
    'svcw.set.reminderHint': 'Un correo al cliente antes de su cita, con el enlace para cambiarla o cancelarla.',
    'svcw.set.reminderOn': 'Enviar recordatorio por correo',
    'svcw.set.reminderOnHint': 'Reduce las ausencias: quien no puede asistir avisa a tiempo y el horario se libera.',
    'svcw.set.reminderSend': 'Enviarlo',
    'svcw.set.reminderSkip': 'Las citas reservadas con menos antelación no lo reciben: acaban de recibir su confirmación.',
    'svcw.set.reminderOff': 'Desactivado',
    /* Paso 3 · formulario. */
    'svcw.form.kicker': 'Formulario',
    'svcw.form.title': 'Prepara las preguntas de la reserva',
    'svcw.form.lead': 'Los datos de contacto ya están incluidos. Añade sólo lo que necesites saber antes de la cita.',
    'svcw.form.included': 'Incluidos automáticamente',
    'svcw.form.name': 'Nombre',
    'svcw.form.email': 'Correo',
    'svcw.form.phone': 'Teléfono',
    'svcw.form.noSetup': 'No tienes que configurar estos campos.',
    /* Paso 4 · horario. */
    'svcw.sch.kicker': 'Disponibilidad',
    'svcw.sch.title': 'Configura tu horario',
    'svcw.sch.zoneNote1': 'Este sitio guarda sus horarios en',
    'svcw.sch.zoneNote2': 'y tú estás en',
    'svcw.sch.zoneNote3': '. Las horas que escribas aquí son de {city}. Puedes cambiar la zona del sitio en Configuración.',
    'svcw.sch.localNote': 'Escribe tus horas en tu hora local. Después podrás añadir descansos y excepciones.',
    'svcw.sch.howSimple': 'Una misma franja para todos los días que elijas.',
    'svcw.sch.howAdvanced': 'Horas distintas y varios turnos en un mismo día.',
    'svcw.sch.rangeSep': 'a',
    'svcw.sch.howTitle': 'Cómo quieres configurarlo',
    'svcw.sch.daysAria': 'Días disponibles',
    'svcw.sch.from': 'Desde',
    'svcw.sch.to': 'Hasta',
    'svcw.sch.pickDay': 'Elige al menos un día para abrir tu agenda.',
    'svcw.sch.multiRange': 'Este horario usa más de una franja.',
    'svcw.sch.multiRangeBody': 'Tus horas siguen intactas; edítalas en Más opciones.',
    'svcw.sch.openAdvanced': 'Abrir Más opciones',
    'svcw.sch.exceptions': 'Excepciones',
    'svcw.sch.exceptionsHint': 'Días sueltos que no siguen la semana: vacaciones, un festivo, o un sábado que sí abres.',
    'svcw.sch.day': 'Día',
    'svcw.sch.whatHappens': 'Qué pasa ese día',
    'svcw.sch.closedDay': 'Cerrado todo el día',
    'svcw.sch.closedRange': 'Cerrado de',
    'svcw.sch.openRange': 'Abro además de',
    'svcw.sch.note': 'Nota',
    'svcw.sch.notePlaceholder': 'Motivo (opcional)',
    'svcw.sch.removeException': 'Quitar excepción',
    'svcw.sch.addException': 'Añadir excepción',
    'svcw.sch.advanced': 'Opciones avanzadas',
    'svcw.sch.advancedHint': 'Márgenes alrededor de cada cita, antelación mínima y hasta dónde se ve tu agenda.',
    'svcw.sch.none': 'Ninguna',
    'svcw.sch.noNotice': 'sin aviso previo',
    'svcw.sch.noticeOf': '{amount} de aviso',
    'svcw.sch.withBuffers': 'con márgenes',
    /* Los cinco ajustes finos y lo que explica cada uno. */
    'svcw.adv.stepLabel': 'Una cita empieza cada',
    'svcw.adv.stepSame': 'Una cita empieza donde acaba la anterior: cada {amount}.',
    'svcw.adv.stepOverlap': 'Los horarios arrancan cada {amount}, así que se solapan y se ofrecen {offer}. Sólo se puede reservar uno a la vez.',
    'svcw.adv.perHour': '{count} por hora',
    'svcw.adv.moreOptions': 'más opciones',
    'svcw.adv.beforeLabel': 'Tiempo libre antes',
    'svcw.adv.beforeNone': 'Sin tiempo de preparación: se puede reservar justo antes de otra cita.',
    'svcw.adv.before': 'Se aparta {amount} antes de cada cita reservada, para prepararte. Nadie puede reservar en ese rato.',
    'svcw.adv.afterLabel': 'Tiempo libre después',
    'svcw.adv.afterNone': 'Sin tiempo de cierre: la siguiente cita puede empezar en cuanto acabe la anterior.',
    'svcw.adv.after': 'Se aparta {amount} después de cada cita reservada, para limpiar o tomar notas. La siguiente no puede empezar antes.',
    'svcw.adv.noBookingsYet': 'Aún no hay citas, así que todavía no recorta ningún horario.',
    'svcw.adv.noticeLabel': 'Antelación mínima',
    'svcw.adv.notice': 'Nadie puede reservar para dentro de menos de {amount}. Lo más pronto disponible siempre estará a esa distancia.',
    'svcw.adv.noticeNone': 'Se puede reservar el siguiente hueco libre, aunque sea dentro de diez minutos.',
    'svcw.adv.horizonLabel': 'Reservable hasta',
    'svcw.adv.horizonUnit': 'días',
    'svcw.adv.horizon': 'Tu agenda se ve {days} hacia adelante{extra}. Más allá no aparece ningún horario.',
    'svcw.adv.aboutMonths': ' (unos {count} meses)',
    'svcw.adv.aboutOneMonth': ' (aproximadamente un mes)',
    /* Paso 5 · cancelación. */
    'svcw.cancel.kicker': 'Cancelación',
    'svcw.cancel.title': 'Configura cancelaciones y reembolsos',
    'svcw.cancel.lead': 'Define los plazos, importes y alternativas aplicables a cada reserva.',
    'svcw.cancel.windows': 'Plazos de cancelación y cambio',
    'svcw.cancel.windowsHint': 'Define hasta cuándo puede gestionar la reserva desde su enlace.',
    'svcw.cancel.cancelUntil': 'Cancelación permitida hasta',
    'svcw.cancel.moveUntil': 'Cambio de fecha permitido hasta',
    'svcw.cancel.hoursBefore': 'horas antes',
    'svcw.cancel.refundWho': 'Quién hace el reembolso',
    'svcw.cancel.refundManual': 'Lo hago yo en Stripe',
    'svcw.cancel.refundManualHint': 'Te avisamos de la cancelación y tú decides cuándo y cuánto devolver.',
    'svcw.cancel.refundAuto': 'Automático al cancelar',
    'svcw.cancel.refundAutoHint': 'Se devuelve solo el % de arriba. Si cancelas tú desde el panel, se devuelve todo. Si tu cuenta no tiene saldo, se reintenta cada hora.',
    'svcw.cancel.refundAutoShort': 'automático',
    'svcw.cancel.refund': 'Política de reembolso',
    'svcw.cancel.refundHint': 'Define el porcentaje reembolsable según el momento de la cancelación.',
    'svcw.cancel.late': 'Gestión fuera de plazo',
    'svcw.cancel.lateHint': 'Define las acciones disponibles una vez vencido el plazo.',
    'svcw.cancel.refill': 'Reembolso total si el horario se vuelve a ocupar',
    'svcw.cancel.refillHint': 'Se reembolsa el importe total cuando el hueco liberado vuelve a reservarse.',
    'svcw.cancel.credit': 'Crédito para una reserva futura',
    'svcw.cancel.creditHint': 'El importe se conserva como saldo para una nueva cita.',
    'svcw.cancel.forgive': 'Excepción en la primera incidencia',
    'svcw.cancel.forgiveHint': 'La política fuera de plazo no se aplica en la primera cancelación tardía.',
    'svcw.cancel.noLimit': 'Sin límite',
    'svcw.cancel.beforeAmount': '{amount} antes',
    'svcw.cancel.cancelMove': 'Cancelar {cancel} · mover {move}',
    'svcw.cancel.notApplicable': 'No aplica',
    'svcw.cancel.refundSummary': '{inTime}% dentro del plazo · {late}% fuera del plazo',
    'svcw.cancel.manual': 'Revisión manual',
    'svcw.cancel.onlyMove': 'Sólo reprogramación',
    'svcw.cancel.noChanges': 'Sin cambios',
    'svcw.cancel.conditionOne': '{count} condición',
    'svcw.cancel.conditionMany': '{count} condiciones',
    'svcw.cancel.summaryWith': '{label} · {extras}',
    'svcw.cancel.untilStart': '{action} está disponible hasta la hora de inicio.',
    'svcw.cancel.closesBefore': '{action} en línea se cierra {amount} antes de la cita.',
    'svcw.cancel.theCancel': 'La cancelación',
    'svcw.cancel.theMove': 'El cambio de fecha',
    /* Paso 6 · precio. */
    'svcw.price.kicker': 'Precio',
    'svcw.price.title': '¿Cómo se cobra?',
    'svcw.price.how': 'Cómo se cobra',
    'svcw.price.noOnline': 'La cita se confirma sin cobrar en línea.',
    'svcw.price.noOnlineLabel': 'Sin cobro en línea',
    'svcw.price.pending': 'Precio pendiente',
    'svcw.price.stripeTitle': 'Aún no puedes cobrar en línea',
    /* Paso 7 · revisión. */
    'svcw.review.kicker': 'Todo listo',
    'svcw.review.title': 'Revisa antes de crear',
    'svcw.review.service': 'Servicio',
    'svcw.review.duration': 'Duración',
    'svcw.review.capacity': 'Cupo',
    'svcw.review.payment': 'Cobro',
    'svcw.review.schedule': 'Horario',
    'svcw.review.cancel': 'Cancelación',
    'svcw.review.reminder': 'Recordatorio',
    'svcw.review.edit': 'Editar',
    'svcw.review.publishTitle': 'Para publicarlo, conecta Stripe',
    'svcw.review.draft': 'Borrador',
    'svcw.review.published': 'Publicado',
    /* Pie y vista previa. */
    'svcw.back': 'Atrás',
    'svcw.next': 'Siguiente',
    'svcw.previewAria': 'Vista previa de la página de reserva',
    'svcw.tester': 'Prueba tu horario',
    'svcw.testerHint': 'Los huecos que genera y las citas que ya tienes',
    'svcw.tester.eyebrow': 'Disponibilidad',
    'svcw.tester.title': 'Elige fecha y hora',
    'svcw.tester.sub': 'Selecciona el horario que mejor te funcione.',
    'svcw.tester.of': 'de',
    'svcw.tester.month': 'Mes',
    'svcw.tester.year': 'Año',
    'svcw.tester.prevDays': 'Días anteriores',
    'svcw.tester.nextDays': 'Días siguientes',
    'svcw.tester.pickTime': 'Selecciona un horario',
    'svcw.tester.freeOne': '{count} horario libre ese día',
    'svcw.tester.freeMany': '{count} horarios libres ese día',
    'svcw.tester.inDays': ' · {count} en {days} días',
    'svcw.preview': 'Vista previa',
    'svcw.previewHint': 'Se actualiza mientras escribes',
    'svcw.page.logo': 'Logo',
    'svcw.page.date': 'Fecha',
    'svcw.page.slotsTotal': '{count} horarios ese día · {total} en total',
    /* Lo que falta para poder seguir. */
    'svcw.invalid.title': 'Escribe el nombre del servicio para continuar.',
    'svcw.invalid.duration': 'Escribe una duración entre 5 y 1440 minutos.',
    'svcw.invalid.amount': 'Escribe un precio mayor a cero.',
    'svcw.invalid.schedule': 'Abre al menos un día y revisa las horas.',
    'svcw.set.lead': 'Cuánto dura cada cita, cuántas personas caben y cuándo se puede reservar.',
    'svcw.sch.dayFrom': '{day}, desde',
    'svcw.sch.dayTo': '{day}, hasta',
    'svcw.sch.removeRange': 'Quitar horario de {day}',
    'svcw.sch.anotherRange': 'Otro horario',
    'svcw.sch.closed': 'Cerrado',
    'svcw.sch.at': 'a',
    'svcw.sch.settingsPath': 'en Configuración → General.',
    'svcw.exc.closedAll': 'Ese día no se puede reservar nada.',
    'svcw.exc.closedRange': 'Ese día se quita de {from} a {to}. El resto de tu horario sigue igual.',
    'svcw.exc.openRange': 'Ese día se añade de {from} a {to}, además de lo que ya abras. Si ya abrías a esa hora, no cambia nada.',
    'svcw.cancel.moveEmpty': 'Si se deja vacío, se aplicará el plazo de cancelación.',
    'svcw.cancel.onsiteNote': 'No aplica: este servicio se paga en el establecimiento y no genera un cobro anticipado.',
    'svcw.cancel.inTime': 'Cancelación dentro del plazo',
    'svcw.cancel.outOfTime': 'Cancelación fuera del plazo',
    'svcw.cancel.noShow': 'Las ausencias sin aviso no generan reembolso.',
    'svcw.cancel.refundFull': 'Se reembolsa el importe total.',
    'svcw.cancel.refundNone': 'No se realiza ningún reembolso.',
    'svcw.cancel.refundPartial': 'Se reembolsa el {percent}% y se retiene el {kept}%.',
    'svcw.cancel.lateContact': 'Revisión manual',
    'svcw.cancel.lateContactHint': 'El cliente deberá contactarte para solicitar una excepción.',
    'svcw.cancel.lateMove': 'Permitir sólo cambio de fecha',
    'svcw.cancel.lateMoveHint': 'La cancelación queda deshabilitada; el cliente puede reprogramar la cita.',
    'svcw.cancel.lateNone': 'No permitir cambios',
    'svcw.cancel.lateNoneHint': 'La reserva se mantiene sin opciones de cancelación o reprogramación.',
    'svcw.cancel.refillHint2': 'Se reembolsa el importe total cuando el horario cancelado se asigna a otro cliente.',
    'svcw.cancel.forgiveHint2': 'La política fuera de plazo no se aplica en la primera incidencia del cliente.',
    'svcw.cancel.footNote': 'Los plazos se aplican automáticamente. Las condiciones adicionales se informan al cliente y sirven como referencia para la gestión manual de cada caso.',
    'svcw.price.lead': 'El importe se guarda como el precio de la oferta; después puedes añadir más desde Ofertas.',
    'svcw.price.amount': 'Precio',
    'svcw.price.amountHint': 'Es lo que se cobrará al reservar.',
    'svcw.cancel.moveVerb': 'cambiar de fecha',
    'svcw.cancel.cancelVerb': 'cancelar',
    'svcw.stripe.connecting': 'Conectando…',
    'svcw.stripe.connect': 'Conectar Stripe',
    'svcw.stripe.priceBody': 'Puedes terminar de crear el servicio: se guardará como borrador y lo publicas en cuanto conectes una cuenta de Stripe.',
    'svcw.stripe.reviewBody': 'Este servicio cobra en línea, así que necesita una cuenta donde llegue el dinero. Se guardará como borrador y podrás publicarlo en cuanto la conectes.',
    'svcw.review.lead': 'Se guardará como borrador para que revises su página antes de publicarla.',
    'svcw.review.openDays': '{count} días abiertos',
    'svcw.review.onSave': 'Al guardar',
    'svcw.review.onCreate': 'Al crear el servicio',
    'svcw.review.publishedHint': 'Cualquiera con el enlace podrá reservar en cuanto exista.',
    'svcw.review.draftHint': 'Podrás personalizar márgenes, avisos y excepciones antes de publicarlo.',
    'svcw.createPublish': 'Crear y publicar',
    'svcw.createService': 'Crear servicio',
    'svcw.tester.bookedOne': ' · {count} cita ya reservada',
    'svcw.tester.bookedMany': ' · {count} citas ya reservadas',
    'svcw.tester.seatsEach': ' · {count} lugares cada uno',
    'svcw.tester.noSlots': 'Con este horario no queda ningún hueco. Revisa los márgenes y la antelación mínima de las opciones avanzadas.',
    'svcw.tester.openADay': 'Abre al menos un día para ver los horarios que genera.',
    'svcw.info.descPlaceholder': 'Explica brevemente qué incluye…',
    'svcw.info.change': 'Cambiar',
    'svcw.info.remove': 'Quitar',
    'svcw.info.addImage': 'Añadir imagen',
    'svcw.info.addLogo': 'Añadir logo',
    'svcw.info.reset': 'Restablecer',
    'svcw.set.durationHint': 'Es el rato que se bloquea en tu agenda cuando alguien reserva.',
    'svcw.set.other': 'Otro',
    'svcw.set.otherDuration': 'Otra duración',
    'svcw.sch.simple': 'Simple',
    'svcw.sch.more': 'Más opciones',
    'svcw.preview.noteFull': 'La página final usará el logo, colores y tipografía de tu sitio.',
    'svcw.preview.noteZoom': 'Acercada a lo que estás editando. En el último paso la verás completa.',
    'svcw.page.slugFallback': 'mi-servicio',
    'svcw.page.cta.book': 'Reservar',
    'svcw.page.cta.pay': 'Continuar al pago',
    'svcw.page.book': 'Reservar',
    'svcw.page.of': 'de',
    'svcw.set.minutes': 'minutos',
    // ── Traspaso de un sitio ──────────────────────────────────────────────────
    /* Lo que no cabe en el plan de quien recibe. Llega del servidor como datos y
       se escribe aquí: el servidor no sabe en qué idioma está mirando. */
    'handover.shortfall': '{count} (tu plan permite {cap})',
    'handover.step.plan': 'Plan',
    'handover.step.payments': 'Cobros',
    'handover.step.business': 'Tu negocio',
    'handover.loading': 'Abriendo el repaso',
    'handover.yoursNow': '{name} ya es tuyo',
    'handover.title': 'Revisa los últimos detalles',
    'handover.oneLeft': 'Queda un ajuste pendiente antes de continuar.',
    'handover.manyLeft': 'Quedan {count} ajustes pendientes antes de continuar.',
    'handover.stepsAria': 'Pasos',
    'handover.skipped': ' (omitido)',
    'handover.back': 'Atrás',
    'handover.skipStep': 'Omitir este paso',
    'handover.skipAll': 'Omitir y entrar al sitio',
    'handover.pay.title': 'Configura tus cobros con Stripe',
    'handover.pay.body': 'Cada propietario conecta su propia cuenta de Stripe. Vincula la tuya para que los pagos de tus productos y servicios lleguen directamente a tu cuenta.',
    'handover.pay.needsPlan': 'Conectar Stripe entra con Pro o Business. Lo que recibiste sigue publicado y no se toca: lo único que no puedes todavía es cobrarlo.',
    'handover.pay.seePlans': 'Ver planes',
    'handover.pay.aside': 'Completarás la configuración en Stripe y volverás aquí al finalizar.',
    'handover.pay.opening': 'Abriendo Stripe…',
    'handover.pay.connect': 'Conectar con Stripe',
    'handover.biz.title': 'Pon tus datos de negocio',
    'handover.biz.stillSays': 'El aviso de privacidad y los términos del sitio siguen diciendo',
    'handover.biz.withAddress': ', con su domicilio y su contacto.',
    'handover.biz.fromGiver': 'Los datos publicados en el sitio son los de quien te lo entregó.',
    'handover.biz.traveled': 'Viajaron con el proyecto porque son del sitio y no de la cuenta, y ahora te representan a ti.',
    'handover.biz.aside': 'Lo demás (identificación fiscal, moneda, responsable de datos) está en los ajustes del sitio, con calma. Aquí sólo van los que aparecen impresos en tus páginas.',
    'handover.biz.saving': 'Guardando…',
    'handover.biz.save': 'Guardar y seguir',
    'handover.biz.tradeName': 'Nombre del negocio',
    'handover.biz.tradeNameHint': 'Con el que te conocen tus clientes',
    'handover.biz.legalName': 'Nombre o razón social',
    'handover.biz.legalNameHint': 'El de tus facturas; puede ser tu nombre',
    'handover.biz.address': 'Domicilio',
    'handover.biz.city': 'Ciudad',
    'handover.biz.state': 'Estado o provincia',
    'handover.biz.email': 'Correo de contacto',
    'handover.biz.phone': 'Teléfono',
    'handover.plan.title': 'Mantén tu sitio completo y publicado',
    'handover.plan.body': 'Tu sitio incluye {list}. Mejora tu membresía para conservar todo su contenido y seguir creciendo sin límites.',
    'handover.plan.grace': ' Seguirá publicado sin cambios hasta el {date}; elige una membresía compatible para mantenerlo en línea después de esa fecha.',
    'handover.plan.noGrace': ' Elige la opción que mejor se adapte a lo que recibiste.',
    'handover.plan.aside': 'Todo tu contenido está seguro y se conserva tal como lo recibiste.',
    'handover.plan.upgrade': 'Mejorar mi membresía',
    'handover.done': 'Listo',
    'handover.doneTitleNamed': '{name} es tuyo',
    'handover.doneTitle': 'El sitio es tuyo',
    'handover.doneAll': 'Todo lo que había pasó a tu cuenta y no queda nada pendiente por resolver.',
    'handover.donePartial': 'El sitio es tuyo y funciona. Lo que dejaste para luego te espera arriba, en su pantalla de inicio.',
    'handover.entering': 'Entrando…',
    'handover.enter': 'Entrar al sitio',
    'handover.notice.planTitle': 'Tu plan se queda corto',
    'handover.notice.planBody': 'Lo que recibiste supera tu plan actual: {list}.',
    'handover.notice.planGrace': ' El sitio sigue publicado hasta el {date} para que decidas con calma.',
    'handover.notice.seePlans': 'Ver planes',
    // ── Aceptar un traspaso ───────────────────────────────────────────────────
    'transfer.loading': 'Abriendo la invitación',
    'transfer.toPanel': 'Ir a mi panel',
    'transfer.kicker': 'Transferencia de un sitio',
    'transfer.lead': 'Revisa el sitio y el contenido incluido antes de decidir.',
    'transfer.includedAria': 'Qué recibes',
    'transfer.included': 'Contenido incluido',
    'transfer.overLimit': 'Supera los límites de tu membresía',
    'transfer.membershipAria': 'Membresía necesaria',
    'transfer.needsMembership': 'Necesitarás una membresía compatible',
    'transfer.needsMembershipBody': 'Este sitio supera los límites de tu membresía actual. Después de aceptar podrás elegir una que cubra todo su contenido.',
    'transfer.expiresOn': 'La invitación caduca el {date}.',
    'transfer.previewAria': 'Vista previa del sitio',
    'transfer.nothingDrawn': 'Todavía no hay nada dibujado',
    'transfer.nothingDrawnBody': 'El proyecto viaja entero igual, pero sus páginas están en blanco.',
    'transfer.notPublished': 'Sin publicar todavía',
    'transfer.wrongAccount': 'Esta invitación es para otra cuenta',
    'transfer.unavailable': 'Esta invitación no está disponible',
    'transfer.unavailableBody': 'Puede haber caducado, haberse cancelado o haber sido aceptada ya.',
    'transfer.signOutFailed': 'No pudimos cerrar esta sesión. Inténtalo de nuevo.',
    'transfer.stock.pages': 'Páginas',
    'transfer.stock.collections': 'Colecciones',
    'transfer.stock.entriesOne': '{count} entrada dentro',
    'transfer.stock.entriesMany': '{count} entradas dentro',
    'transfer.stock.contacts': 'Contactos',
    'transfer.stock.forms': 'Formularios',
    'transfer.stock.messagesOne': '{count} mensaje recibido',
    'transfer.stock.messagesMany': '{count} mensajes recibidos',
    'transfer.stock.images': 'Imágenes',
    'transfer.stock.offers': 'Productos y servicios',
    'transfer.stock.salesOne': '{count} venta hecha',
    'transfer.stock.salesMany': '{count} ventas hechas',
    'transfer.stock.bookings': 'Reservas por delante',
    'transfer.stock.bookingsNote': 'Citas ya comprometidas',
    'transfer.stock.domain': 'Dominio',
    'transfer.seePlans': 'Ver planes',
    'transfer.rejecting': 'Rechazando…',
    'transfer.reject': 'Rechazar',
    'transfer.accepting': 'Aceptando…',
    'transfer.accept': 'Aceptar el sitio',
    'handover.notice.aria': 'Repaso del sitio recibido',
    'handover.notice.yours': '{name} ya es tuyo',
    'handover.notice.oneLeft': 'Falta una cosa para que sea tuyo del todo',
    'handover.notice.manyLeft': 'Faltan {count} cosas para que sea tuyo del todo',
    'handover.notice.oneBody': 'El sitio funciona y es tuyo, pero hay algo que el traspaso no puede hacer por ti. Puedes dejarlo para luego.',
    'handover.notice.manyBody': 'El sitio funciona y es tuyo, pero hay cosas que el traspaso no puede hacer por ti. Puedes dejarlo para luego.',
    'handover.notice.payTitle': 'Conecta tu cuenta para cobrar',
    'handover.notice.payOne': 'El sitio tiene {count} cosa a la venta y ahora mismo no puede cobrarlas: la cuenta de Stripe era de quien te lo entregó y se desconectó al traspasarlo.',
    'handover.notice.payMany': 'El sitio tiene {count} cosas a la venta y ahora mismo no puede cobrarlas: la cuenta de Stripe era de quien te lo entregó y se desconectó al traspasarlo.',
    'handover.notice.payAction': 'Conectar cobros',
    'handover.notice.bizTitle': 'Pon tus datos de negocio',
    'handover.notice.bizNamed': 'El aviso de privacidad y los términos del sitio siguen diciendo «{name}», con su domicilio y su identificación fiscal. Esos datos viajaron con el sitio y ahora te representan a ti.',
    'handover.notice.bizUnnamed': 'Los datos fiscales y de contacto publicados en el sitio son los de quien te lo entregó. Viajaron con el proyecto y ahora te representan a ti.',
    'handover.notice.bizAction': 'Revisar los datos',
    'handover.notice.opening': 'Abriendo…',
    'handover.notice.later': 'Ahora no',
    'handover.notice.savingDismiss': 'Guardando…',
    'handover.notice.dismiss': 'No volver a mostrar',
    'handover.notice.done': 'Listo',
    // ── Crear una página ──────────────────────────────────────────────────────
    'newPage.aria': 'Crear página',
    'newPage.backToDash': 'Volver al dashboard',
    'newPage.beta': 'Beta',
    'newPage.nameAria': 'Nombre de la página',
    'newPage.stepOf': 'Paso {current} de 3',
    'newPage.categoriesAria': 'Categorías de plantillas',
    'newPage.categories': 'Categorías',
    'newPage.all': 'Todos',
    'newPage.blank': 'Página en blanco',
    'newPage.blankCategory': 'En blanco',
    'newPage.generalCategory': 'General',
    'newPage.stepsAria': 'Pasos de personalización',
    'newPage.customize': 'Personalizar',
    'newPage.type': 'Letra',
    'newPage.colors': 'Colores',
    'newPage.loadingTemplates': 'Cargando templates...',
    'newPage.templatesAria': 'Plantillas para la nueva página',
    'newPage.typosAria': 'Combinaciones de letra',
    'newPage.siteOriginal': 'Original del sitio',
    'newPage.fontLibrary': 'Biblioteca de letras',
    'newPage.palettesAria': 'Paletas de colores',
    'newPage.paletteLibrary': 'Biblioteca de colores',
    'newPage.brandNote': 'Los colores y la tipografía son de tu proyecto y se aplican a todas las páginas. La nueva página los hereda.',
    'newPage.editBrand': 'Editar estilo →',
    'newPage.back': 'Atrás',
    'newPage.preparing': 'Preparando página...',
    'newPage.create': 'Crear página',
    'newPage.next': 'Siguiente',
    'newPage.previewAria': 'Vista previa de la página',
    'newPage.applyingStyle': 'Aplicando tu estilo...',
    'newPage.loadingPreview': 'Cargando preview...',
    'newPage.previewOf': 'Vista previa de {name}',
    'newPage.defaultName': 'Nueva página',
    // ── Ajustes de una página ─────────────────────────────────────────────────
    'pageSettings.notImage': 'Selecciona un archivo de imagen',
    'pageSettings.tooBig': 'La imagen debe pesar menos de 10 MB',
    'pageSettings.uploadFailed': 'No se pudo subir la imagen',
    'pageSettings.back': 'Regresar a páginas',
    'pageSettings.kicker': 'Ajustes de página',
    'pageSettings.withPassword': 'Con contraseña',
    'pageSettings.published': 'Publicado',
    'pageSettings.general': 'Información general',
    'pageSettings.generalBody': 'Define cómo se identifica esta página dentro del sitio.',
    'pageSettings.pageTitle': 'Título de página',
    'pageSettings.slug': 'URL slug',
    'pageSettings.copied': 'Copiado',
    'pageSettings.copyLink': 'Copiar enlace',
    'pageSettings.unpublished': 'Sin publicar',
    'pageSettings.makeHome': 'Hacer página principal',
    'pageSettings.password': 'Contraseña de la página',
    'pageSettings.passwordBody': 'Administra el acceso a esta página en específico.',
    'pageSettings.protect': 'Proteger con contraseña',
    'pageSettings.protectBody': 'Los visitantes deberán ingresar una contraseña para ver esta página.',
    'pageSettings.passwordField': 'Contraseña',
    'pageSettings.passwordHint': 'Mínimo 6 caracteres. Se pedirá al abrir esta página en el sitio publicado.',
    'pageSettings.passwordPlaceholder': 'Mínimo 6 caracteres',
    'pageSettings.passwordShort': 'Debe tener al menos 6 caracteres.',
    'pageSettings.seo': 'SEO',
    'pageSettings.seoBody': 'Optimiza el título, la descripción y la URL que verán los buscadores.',
    'pageSettings.seoTitle': 'Título (Title tag)',
    'pageSettings.seoTitleHint': 'El título de la pestaña del navegador y el enlace azul en los resultados de Google. Si lo dejas vacío se usa el nombre de la página.',
    'pageSettings.seoTitlePlaceholder': 'Título para Google',
    'pageSettings.seoChars': '{count} / {max} caracteres recomendados',
    'pageSettings.seoDesc': 'Descripción (Meta description)',
    'pageSettings.seoDescHint': 'El texto que Google muestra debajo del título en los resultados de búsqueda.',
    'pageSettings.seoDescPlaceholder': 'Resumen breve de esta página',
    'pageSettings.canonical': 'URL canónica',
    'pageSettings.canonicalHint': 'La URL «oficial» de esta página. Úsala para evitar contenido duplicado en buscadores.',
    'pageSettings.share': 'Vista previa al compartir',
    'pageSettings.shareBody': 'Configura la tarjeta que aparecerá en redes sociales y mensajes.',
    'pageSettings.changeCover': 'Cambiar imagen de portada',
    'pageSettings.uploadCover': 'Subir imagen de portada',
    'pageSettings.customImage': 'Imagen personalizada. Haz clic para cambiarla.',
    'pageSettings.defaultImage': 'Por defecto se usa la captura de la página. Sube una para personalizarla.',
    'pageSettings.useCapture': 'Usar la captura',
    'pageSettings.sameAsSeo': 'Igual que el SEO',
    'pageSettings.sameAsSeoBody': 'Usa el título y la descripción de SEO también para redes sociales.',
    'pageSettings.ogTitle': 'Título para redes',
    'pageSettings.ogTitleHint': 'El título que aparece al compartir esta página en redes sociales. Por defecto usa el de SEO.',
    'pageSettings.ogDesc': 'Descripción para redes',
    'pageSettings.ogDescHint': 'El texto que acompaña la imagen al compartir en redes. Por defecto usa la descripción de SEO.',
    'pageSettings.visibility': 'Visibilidad en buscadores',
    'pageSettings.visibilityBody': 'Decide cómo se descubre esta página dentro y fuera del sitio.',
    'pageSettings.index': 'Indexar en buscadores',
    'pageSettings.advanced': "Avanzado",
    'pageSettings.advancedBody': "Llevar esta dirección a otra y añadir código en su cabecera.",
    'pageSettings.redirect': "Redirigir a otra dirección",
    'pageSettings.redirectHint': "Quien entre a esta página irá a la que escribas, como /contacto o https://…. Vacío, se ve la página. Se aplica al publicar.",
    'pageSettings.redirectInvalid': "Escribe una dirección del sitio, como /contacto, o una completa con https://.",
    'pageSettings.redirectHome': "La portada no se puede redirigir.",
    'pageSettings.redirectPlaceholder': "/contacto",
    'pageSettings.headCodePlaceholder': '<meta name="google-site-verification" content="…" />',
    'pageSettings.headCode': "Código en la cabecera",
    'pageSettings.headCodeHint': "Se pega tal cual en el <head> de esta página al publicar: verificaciones de Google, píxeles o etiquetas de otras herramientas.",
    'pageSettings.indexBody': 'Permite que Google y otros buscadores encuentren esta página.',
    'pageSettings.sitemap': 'Incluir en sitemap',
    'pageSettings.sitemapBody': 'Añade esta página al sitemap.xml del sitio.',
    'pageSettings.delete': 'Eliminar página',
    'pageSettings.deleteHome': 'La página principal no se puede eliminar. Asigna otra página como principal primero.',
    'pageSettings.deleteLast': 'El sitio necesita conservar al menos una página.',
    'pageSettings.deleteBody': 'Elimina esta página y todo su contenido del proyecto.',
    'pageSettings.sure': '¿Estás seguro?',
    'pageSettings.yesDelete': 'Sí, eliminar',
    // ── Copias de seguridad ───────────────────────────────────────────────────
    'backups.created': 'Copia de seguridad creada',
    'backups.deleted': 'Copia de seguridad eliminada',
    'backups.loading': 'Cargando tus copias',
    'backups.title': 'Copias de seguridad',
    'backups.versions': 'Versiones disponibles',
    'backups.versionsBody': 'Se crea una copia con cada publicación. Al alcanzar el límite del plan, se elimina la versión más antigua.',
    'backups.create': 'Crear copia',
    'backups.loadFailed': 'No se pudieron cargar las copias de seguridad',
    'backups.empty': 'No hay copias de seguridad disponibles',
    'backups.emptyBody': 'Se creará una automáticamente la próxima vez que publiques el sitio.',
    'backups.moreOptions': 'Más opciones',
    'backups.view': 'Ver esta versión',
    'backups.restore': 'Restaurar',
    'backups.delete': 'Borrar copia',
    'backups.confirmDelete': '¿Eliminar esta copia de seguridad?',
    'backups.description': 'Consulta las versiones guardadas automáticamente al publicar y restaura el sitio cuando sea necesario.',
    'backups.quota': 'Copias',
    'backups.full': 'Límite alcanzado: tu plan conserva hasta {limit} copias',
    'backups.kind.publish': 'Al publicar',
    'backups.kind.manual': 'Manual',
    'backups.kind.preRestore': 'Antes de restaurar',
    'backups.contentPageOne': '{count} página',
    'backups.contentPageMany': '{count} páginas',
    'backups.contentCollectionOne': '{count} colección',
    'backups.contentCollectionMany': '{count} colecciones',
    'backups.contentItemOne': '{count} elemento',
    'backups.contentItemMany': '{count} elementos',
    'backups.note': 'Cada copia incluye las páginas, el contenido del CMS, el tema y la configuración del sitio. No incluye mensajes de formularios, contactos, ventas ni archivos cargados; estos datos no se modificarán durante una restauración.',
    'backups.options': 'Opciones',
    'backups.deleteMessage': 'La copia del {date} se eliminará de forma permanente. Las demás versiones no se modificarán.',
    'backups.deleteConfirm': 'Eliminar',
    'backups.deleting': 'Eliminando…',
    // ── Dirección del sitio (subdominio) ──────────────────────────────────────
    'subdomain.saved': 'Dirección guardada',
    'subdomain.saveFailed': 'No se pudo cambiar la dirección.',
    'subdomain.live': 'Ya responde',
    'subdomain.applying': 'Aplicando el cambio…',
    'subdomain.change': 'Cambiar dirección',
    'subdomain.movingTo': 'Estamos moviendo el sitio a',
    'subdomain.movingBody': '. La dirección nueva puede tardar unos minutos en abrir; lo comprobamos solos y esto se actualiza cuando responda. El cambio ya está guardado, así que puedes seguir trabajando.',
    'subdomain.slow': 'La dirección nueva todavía no responde. El cambio está hecho y suele resolverse en unos minutos; si sigue igual, escríbenos.',
    'subdomain.aria': 'Dirección del sitio',
    'subdomain.saving': 'Guardando…',
    'subdomain.save': 'Guardar',
    'subdomain.rules': 'Minúsculas, números y guiones. Al cambiarla, la dirección anterior deja de responder.',
    'subdomain.free': '{host} está libre.',
    // ── Admin · usuarios ──────────────────────────────────────────────────────
    'admin.users.title': 'Usuarios',
    'admin.users.search': 'Buscar por correo…',
    'admin.users.count': '{shown} de {total}',
    'admin.users.loading': 'Cargando usuarios…',
    'admin.users.none': 'Sin usuarios que coincidan.',
    'admin.users.col.user': 'Usuario',
    'admin.users.col.role': 'Rol',
    'admin.users.col.plan': 'Plan',
    'admin.users.col.projects': 'Proyectos',
    'admin.users.col.lastSeen': 'Última entrada',
    'admin.users.col.signup': 'Registro',
    'admin.users.noEmail': '(sin correo)',
    'admin.users.never': 'Nunca',
    'admin.users.neverIn': 'Nunca ha entrado',
    'admin.users.now': 'Ahora mismo',
    'admin.users.agoMin': 'hace {count} min',
    'admin.users.agoHours': 'hace {count} h',
    'admin.users.agoDayOne': 'hace {count} día',
    'admin.users.agoDayMany': 'hace {count} días',
    'admin.users.agoMonthOne': 'hace {count} mes',
    'admin.users.agoMonthMany': 'hace {count} meses',
    'admin.users.agoYearOne': 'hace {count} año',
    'admin.users.agoYearMany': 'hace {count} años',
    'admin.users.back': 'Usuarios',
    'admin.users.loadingOne': 'Cargando…',
    'admin.users.registeredOn': 'Registrado el {date}',
    'admin.users.role': 'Rol',
    'admin.users.roleHintAdmin': 'Admin',
    'admin.users.roleHintDesigner': 'Diseñador',
    'admin.users.roleHintUser': 'Usuario',
    'admin.users.roleHint1': ': acceso total. ',
    'admin.users.roleHint2': ': Templates y Bloques. ',
    'admin.users.roleHint3': ': cuenta normal.',
    'admin.users.saving': 'Guardando…',
    'admin.users.savedMark': 'Guardado ✓',
    'admin.users.save': 'Guardar',
    'admin.users.locked': 'Este usuario es superadmin por configuración y no se puede editar aquí.',
    'admin.users.subscription': 'Suscripción',
    'admin.users.status': 'Estado',
    'admin.users.renews': 'Renueva',
    'admin.users.stripeCustomer': 'Cliente Stripe',
    'admin.users.projects': 'Proyectos ({count})',
    'admin.users.noProjects': 'Sin proyectos.',
    'admin.users.published': 'Publicado',
    'admin.users.draft': 'Borrador',
    'admin.users.updated': ' · actualizado {date}',
    'admin.users.editor': 'Editor',
    'admin.users.site': 'Sitio',
    'app.retry': 'Reintentar',
    'admin.users.loadFailed': 'No se pudieron cargar los usuarios.',
    'admin.users.loadOneFailed': 'No se pudo cargar el usuario.',
    'admin.users.roleFailed': 'No se pudo actualizar el rol.',
    'error.project.gone': 'Ese proyecto ya no existe.',
    'error.invite.gone': 'Esta invitación ya no está disponible.',
    'error.invite.expired': 'Esta invitación caducó. Pide que te manden otra.',
    'error.invite.alreadyMember': 'Ya formas parte de este proyecto.',
    'error.transfer.alreadyYours': 'Este proyecto ya es tuyo.',
    'error.domain.taken': 'Ese dominio ya está conectado a un proyecto.',
    'error.backup.notFound': 'Esa copia no existe.',
    'error.offer.notFound': 'No encontramos esa oferta.',
    'error.resource.notFound': 'No encontramos ese recurso de la agenda.',
    'legal.goHome': 'Ir a véltica',
    'legal.back': 'Volver al inicio',
    'legal.eyebrow': 'Información legal',
    'teamInvite.unavailable': "Esta invitación ya no está disponible.",
    'teamInvite.actionFailed': "No pudimos completar la acción.",
    'teamInvite.wrongAccountTitle': "Esta invitación es para otra cuenta",
    'teamInvite.unavailableTitle': "Esta invitación no está disponible",
    'teamInvite.goToDashboard': "Ir a mi panel",
    'teamInvite.signOutFailed': "No pudimos cerrar esta sesión. Inténtalo de nuevo.",
    'teamInvite.switching': "Cambiando…",
    'teamInvite.switchAccount': "Cambiar de cuenta",
    'teamInvite.loading': "Cargando la invitación…",
    'teamInvite.eyebrow': "Invitación a un equipo",
    'teamInvite.someone': "Alguien",
    'teamInvite.invitedBy': "te invitó a trabajar en este sitio como",
    'teamInvite.whatYouGet': "A qué entras",
    'teamInvite.scopeStrong': "sólo a este sitio",
    'teamInvite.scopePrefix': "Entras ",
    'teamInvite.scopeSuffix': ". Los demás proyectos de quien te invitó siguen siendo suyos y no los verás. Puedes salirte cuando quieras, y quien te invitó puede cambiarte el rol o quitarte el acceso.",
    'teamInvite.decline': "No, gracias",
    'teamInvite.joining': "Entrando…",
    'teamInvite.accept': "Aceptar y entrar",
    'teamInvite.expiry': "La invitación es para {email} y caduca el {date}.",
    'deleted.restoreFailed': "No pudimos recuperar el proyecto.",
    'deleted.countOne': "Un proyecto eliminado",
    'deleted.countMany': "{count} proyectos eliminados",
    'deleted.explainOne': "Recupéralo con todo su contenido antes de que se elimine definitivamente. Tendrás que publicarlo de nuevo para ponerlo en línea.",
    'deleted.explainMany': "Recupéralos con todo su contenido antes de que se eliminen definitivamente. Tendrás que publicarlos de nuevo para ponerlos en línea.",
    'deleted.noName': "Sin nombre",
    'deleted.soon': "Se borra pronto",
    'deleted.today': "Se borra hoy",
    'deleted.inDaysOne': "Se borra en {count} día",
    'deleted.inDaysMany': "Se borra en {count} días",
    'deleted.restoring': "Recuperando…",
    'deleted.restore': "Recuperar",
    'upsell.eyebrow': "Planes de pago",
    'upsell.seePlans': "Ver planes",
    'upsell.availableIn': "Disponible en Pro y Business",
    'upsell.stripeNote': 'Los cobros van por Stripe',
    'upsell.dismiss': 'No volver a mostrar',
    'upsell.payments.saleTitle': 'Vende desde tu propio sitio',
    'upsell.payments.saleDescription': 'Armar el catálogo es gratis: escribe tus ofertas, ponles precio, déjalas listas. Cobrarlas viene con Pro o Business.',
    'upsell.payments.point1': 'Tarjeta, Apple Pay y Google Pay',
    'upsell.payments.point2': 'El dinero entra en tu propia cuenta',
    'upsell.payments.point3': 'Ventas, clientes y reembolsos en un solo sitio',
    'upsell.payments.point4': 'Tu saldo y tus fechas de depósito, sin salir de aquí',
    'upsell.analytics.saleTitle': "Analíticas completas",
    'upsell.analytics.saleDescription': "Entiende de dónde viene tu tráfico y qué páginas funcionan. Se incluye en los planes de pago. Elige el que mejor te quede.",
    'upsell.analytics.point1': "Visitantes, vistas y tendencias",
    'upsell.analytics.point2': "Fuentes de tráfico y campañas",
    'upsell.analytics.point3': "Mapa de países y dispositivos",
    'upsell.analytics.point4': "Páginas más populares",
    'upsell.orders.saleTitle': "Ventas en tu panel",
    'upsell.orders.saleDescription': "Cada cobro que Stripe confirma aparece aquí, con quién compró y cuánto entró. El dinero sigue yendo directo a tu cuenta.",
    'upsell.orders.point1': "Las últimas transacciones, en tu inicio",
    'upsell.orders.point2': "Comprador, importe y estado de cada cobro",
    'upsell.orders.point3': "Comisión y neto recibido de cada cobro",
    'upsell.orders.point4': "Recibo de Stripe a un clic",
    'mediaPicker.title': "Seleccionar imagen",
    'mediaPicker.pickedCount': '{count} de {max} elegidas',
    'mediaPicker.addPicked': 'Añadir {count}',
    'mediaPicker.cancel': 'Cancelar',
    'mediaPicker.subtitle': "Elige una imagen existente o sube una nueva.",
    'mediaPicker.close': "Cerrar",
    'mediaPicker.tabUploads': "Archivos subidos",
    'mediaPicker.tabGallery': "Galería",
    'mediaPicker.search': "Buscar en la galería",
    'mediaPicker.uploading': "Subiendo…",
    'mediaPicker.upload': "Subir imagen",
    'mediaPicker.formats': "JPG, PNG o WebP",
    'mediaPicker.loading': "Cargando imágenes…",
    'mediaPicker.emptyGallery': "No encontramos imágenes.",
    'mediaPicker.uploadsFailed': "No se pudieron cargar tus archivos.",
    'mediaPicker.galleryFailed': "No se pudo cargar la galería.",
    'mediaPicker.uploadFailed': "No se pudo subir la imagen. Inténtalo de nuevo.",
    'deleteOverlay.noName': "Sin nombre",
    'deleteOverlay.dialogLabel': "Eliminando {name}",
    'deleteOverlay.srDeleting': "Eliminando el proyecto",
    'deleteOverlay.srDone': "Proyecto eliminado",
    'deleteOverlay.srProject': "Proyecto {name}",
    'deleteOverlay.srNew': "Crear un sitio nuevo",
    'deleteOverlay.firstSite': "Crea tu primer sitio",
    'deleteOverlay.deleting': "Borrando…",
    'deleteOverlay.done': "Eliminado · puedes recuperarlo durante 30 días",
    'deleteOverlay.switching': "Cambiando de proyecto…",
    'deleteOverlay.fromScratch': "Vamos a empezar de cero",
    'addCard.title': "Agregar tarjeta",
    'addCard.subtitle': "Se guarda para los cobros de tu membresía y tus dominios.",
    'addCard.loading': "Cargando el formulario seguro…",
    'addCard.privacy': "Los datos van directo a Stripe. véltica nunca ve tu número de tarjeta.",
    'addCard.cancel': "Cancelar",
    'addCard.saving': "Guardando…",
    'addCard.save': "Guardar tarjeta",
    'addCard.missingKey': "Falta la clave pública de Stripe (VITE_STRIPE_PUBLISHABLE_KEY).",
    'addCard.openFailed': "No se pudo abrir el formulario.",
    'addCard.saveFailed': "No se pudo guardar la tarjeta.",
    'addCard.stripeUnavailable': "Stripe no está disponible.",
    'colorPicker.close': "Cerrar selector",
    'colorPicker.edit': "Editar {label}",
    'colorPicker.hexOf': "HEX de {label}",
    'nav.backToDashboard': "Regresar al panel",
    'createAi.previewTitle': "Vista previa",
    'createAi.searchCountry': "Buscar país…",
    'createAi.noResults': "Sin resultados",
    'mascotColor.change': "Cambiar el color del panel",
    'mascotColor.title': "Color del panel",
    'skeleton.openEditor': "Abrir editor",
    'shell.goToEditor': "Ir al editor",
    'shell.goToEditorHint': "Vuelve al lienzo para diseñar tu página.",
    'skeleton.openInEditor': "Abrir en editor",
    'skeleton.searchPage': "Buscar página...",
    'skeleton.newPage': "Nueva página",
    'templateFacets.blockType': "Tipo de bloque",
    'templateFacets.blockTypeHint': "Qué unidad repetible es este bloque, para que el AI pueda insertarlo en la sección correcta.",
    'checkoutSuccess.titlePlan': "Ya eres {plan}",
    'checkoutSuccess.titleThanks': "¡Gracias por suscribirte!",
    'checkoutSuccess.leadActive': "Tu plan está activo y ya puedes usar todo lo que incluye.",
    'checkoutSuccess.leadPending': "Estamos confirmando el pago con nuestro proveedor. Tarda unos segundos y no hace falta que hagas nada.",
    'checkoutSuccess.next1': "Recibirás el recibo por correo de parte de Stripe.",
    'checkoutSuccess.next2': "La suscripción se renueva sola; puedes cancelarla cuando quieras.",
    'checkoutSuccess.next3': "Gestiona el plan, la tarjeta y las facturas desde Planes y facturación.",
    'checkoutSuccess.cta': "Empezar a construir",
    'domainSuccess.titleRegistered': "{domain} ya es tuyo",
    'domainSuccess.titleFailed': "Pago recibido, registro pendiente",
    'domainSuccess.titleThanks': "¡Gracias por tu compra!",
    'domainSuccess.leadRegistered': "Lo registramos a tu nombre y ya está apuntado a tu sitio. El certificado SSL se emite solo en los próximos minutos.",
    'domainSuccess.leadFailed': "Cobramos el dominio pero el registro no pudo completarse. No lo intentes de nuevo: escríbenos y lo resolvemos o te devolvemos el importe.",
    'domainSuccess.leadSlow': "El registro está tardando más de lo normal. Puede seguir sin ti: cierra esto tranquilo y revisa la lista de dominios en unos minutos.",
    'domainSuccess.leadPending': "Estamos registrando {domain} y configurando su DNS. Tarda unos segundos y no hace falta que hagas nada.",
    'domainSuccess.next1': "Recibirás el recibo por correo de parte de Stripe.",
    'domainSuccess.next2': "No tienes que tocar ningún DNS: el dominio ya vive en nuestra cuenta.",
    'domainSuccess.next3': "El registro dura un año y te avisaremos antes de la renovación.",
    'domainSuccess.ctaSee': "Ver mi dominio",
    'domainSuccess.ctaBack': "Volver a mis dominios",
    'nav.back': "Regresar",
    'barChart.submissions': "envíos",
    'barChart.perDay': "{label} por día",
    'stripe.embedFailed': "No pudimos abrir la vista de Stripe.",
    'stripe.popupBlocked': "Tu navegador bloqueó la ventana de Stripe. Permite las ventanas emergentes y vuelve a intentarlo.",
    'device.mobile': "Móvil",
    'device.desktop': "Escritorio",
    'device.tablet': "Tablet",
    'overview.fact.views': "Tu sitio recibió {count} visitas en este periodo.",
    'overview.fact.viewsOne': "Tu sitio recibió {count} visita en este periodo.",
    'overview.fact.viewsUp': "Tus visitas subieron un {percent}% frente al periodo anterior.",
    'overview.fact.viewsDown': "Tus visitas bajaron un {percent}% frente al periodo anterior.",
    'overview.fact.topPage': "Tu página más visitada es «{page}».",
    'overview.fact.notPublished': "Tu sitio todavía no está publicado.",
    'overview.fact.collections': "Llevas {count} colecciones en el CMS.",
    'overview.fact.collectionsOne': "Llevas {count} colección en el CMS.",
    'overview.fact.onePage': "Tu sitio tiene una sola página. Un par más le darían por dónde entrar.",
    'overview.fact.seeAnalytics': "Ver analíticas",
    'overview.fact.openEditor': "Abrir el editor",
    'overview.fact.goContent': "Ir a Contenido",
    'overview.fact.goPages': "Ir a Páginas",
    'overview.waiting.transferOne': "Transferencia de sitio pendiente",
    'overview.waiting.transferMany': "Transferencias de sitios pendientes",
    'overview.waiting.inviteOne': "Tienes una invitación",
    'overview.waiting.inviteMany': "Tienes {count} invitaciones",
    'overview.waiting.stepOne': "Te queda un paso pendiente",
    'overview.waiting.stepMany': "Te quedan {count} pasos pendientes",
    'restoreOverlay.dialogLabel': "Recuperando {name}",
    'restoreOverlay.srRestoring': "Recuperando el proyecto",
    'restoreOverlay.srDone': "Proyecto recuperado",
    'restoreOverlay.srProject': "Proyecto {name}",
    'restoreOverlay.restoring': "Recuperando…",
    'restoreOverlay.done': "Recuperado · vuelve a publicarlo para ponerlo en línea",
    'restoreOverlay.opening': "Abriendo el proyecto…",
    'embeddedCheckout.missingKey': "Falta la clave pública de Stripe (VITE_STRIPE_PUBLISHABLE_KEY).",
    'embeddedCheckout.loadFailed': "No se pudo cargar el pago.",
    'transferBanner.kicker': "Transferencia de un sitio",
    'transferBanner.fromWho': "{name} quiere transferirte",
    'transferBanner.anon': "Quieren transferirte",
    'transferBanner.body': "Pasaría a tu cuenta con sus páginas, su contenido, sus contactos y su dominio.",
    'transferBanner.expiresOne': "Caduca en {count} día",
    'transferBanner.expiresMany': "Caduca en {count} días",
    'transferBanner.cta': "Ver qué recibo",
    'createBlank.dialogLabel': "Proyecto en blanco",
    'createBlank.close': "Cerrar",
    'createBlank.title': "¿Cómo se llama tu proyecto?",
    'createBlank.subtitle': "Es lo único que necesitamos para empezar. Podrás cambiarlo cuando quieras.",
    'createBlank.placeholder': "Mi empresa",
    'imagePicker.change': "Cambiar imagen",
    'imagePicker.tabUpload': "Subir",
    'imagePicker.tabStock': "Stock",
    'imagePicker.formats': "JPG · PNG · WebP · máx. 10 MB",
    'imagePicker.search': "Buscar fotos…",
    'imagePicker.empty': "Busca imágenes profesionales gratis.",
    'imagePicker.remove': "Quitar imagen",
    'createBlank.hint': "Se abrirá el editor con una página vacía.",
    'audienceMap.label': "Mapa de audiencia por país. Arrastra para desplazar y usa los controles para acercar o alejar.",
    'audienceMap.zoomIn': "Acercar mapa",
    'audienceMap.zoomOut': "Alejar mapa",
    'audienceMap.center': "Centrar mapa",
    'audienceMap.dragHint': "Arrastra para mover el mapa",
    'audienceMap.less': "Menos",
    'audienceMap.more': "Más",
    'backupPreview.dialogLabel': "Vista previa de la copia",
    'backupPreview.restoreThis': "Restaurar ésta",
    'backupPreview.close': "Cerrar",
    'backupPreview.pages': "Páginas de la copia",
    'backupPreview.opening': "Abriendo la copia…",
    'backupPreview.exact': "Renderizador de publicación",
    'backupPreview.noPages': "Esta copia no tiene páginas para mostrar.",
    'backupPreview.renderFailed': "No se pudo dibujar esta copia.",
    'backupPreview.note': "Vista previa aproximada: se dibuja con el renderizador del panel, no con el que genera el sitio publicado, así que algún detalle puede verse distinto.",
    'backupPreview.noteCms': " Aquí sólo se ven las páginas del sitio; las {count} de colección las genera el CMS al publicar, pero están guardadas en la copia y vuelven al restaurar.",
    'transferCard.title': "Transferir el sitio",
    'transferCard.body': "Se lo pasas a otra cuenta con sus páginas, su contenido, sus contactos y su dominio. La suscripción no viaja: a partir de la entrega el sitio corre por cuenta de quien lo recibe.",
    'transferCard.pending': "Invitación pendiente",
    'transferCard.pendingMeta': "{email} · caduca el {date}",
    'transferCard.cancelInvite': "Cancelar invitación",
    'transferCard.emailLabel': "Correo de quien lo recibe",
    'transferCard.emailPlaceholder': "cliente@ejemplo.com",
    'transferCard.sending': "Enviando…",
    'transferCard.send': "Enviar invitación",
    'transferCard.hint': "Le llegará un correo a esa dirección con lo que recibiría de «{project}». Hasta que acepte, el sitio sigue siendo tuyo y puedes cancelar la invitación cuando quieras.",
    'transferCard.sentTo': "Invitación enviada a {email}",
    'transferCard.cancelled': "Invitación cancelada",
    'transferCard.consequences.title': 'Qué pasa cuando acepten',
    'transferCard.consequences.owner': 'El sitio deja de ser tuyo. Pierdes el acceso salvo que el nuevo dueño te invite de vuelta.',
    'transferCard.consequences.team': 'Todo el resto del equipo pierde el acceso. El nuevo dueño empieza con el equipo vacío.',
    'transferCard.consequences.stripe': 'Tu cuenta de Stripe se desconecta y el sitio deja de cobrar hasta que el nuevo dueño conecte la suya.',
    'transferCard.consequences.data': 'Las páginas, el contenido, los contactos, los pedidos y las citas por venir viajan con el sitio.',
    'transferCard.consequences.plan': 'La membresía no viaja. A partir de la entrega, el sitio corre por el plan del nuevo dueño.',
    'transferCard.resend': 'Reenviar',
    'transferCard.resent': 'Invitación reenviada a {email}',
    'transferCard.history': 'Traspasos que has enviado',
    'transferCard.historyEmpty': 'Todavía no has enviado ningún traspaso.',
    'transferCard.historyEmptyBody': 'Cuando entregues un sitio, aquí aparecerán su invitación y en qué terminó.',
    'transferCard.status.pending': 'Esperando respuesta',
    'transferCard.status.accepted': 'Aceptado',
    'transferCard.status.rejected': 'Rechazado',
    'transferCard.status.cancelled': 'Cancelado',
    'transferCard.status.expired': 'Caducado',
    'transferCard.acceptedBy': '{name} lo aceptó',
    'transferCard.handoverPending': 'Aceptado, pero el nuevo dueño aún no ha conectado un cobrador. Mientras tanto el sitio no puede cobrar.',
    'transferCard.handoverDone': 'Entrega terminada.',
    'transferCard.sentOn': 'Enviada el {date}',
    'transferCard.resolvedOn': 'Contestada el {date}',
    'templateCard.noThumbnail': "Sin captura",
    'templateCard.openCanvas': "Abrir canvas",
    'templateCard.premium': "Premium",
    'templateCard.unpublished': "Cambios sin publicar",
    'templateCard.editData': "Editar datos",
    'templateCard.publish': "Publicar cambios",
    'templateCard.discard': "Descartar borrador",
    'templateCard.activate': "Activar",
    'templateCard.archive': "Desactivar",
    'templateCard.delete': "Eliminar",
    'cms.limit.pages': "páginas",
    'stripe.fact.fee': 'Comisión de véltica',
    'platformFee.example.heading': 'De cada venta de {sample}',
    'platformFee.sales.heading': 'En los últimos 30 días vendiste {gross}',
    'platformFee.stripeNote': 'Lo que te llega después de la comisión de véltica. La de Stripe por procesar el pago va aparte.',
    'platformFee.tile.current': '{plan} · tu plan',
    'platformFee.tile.next': 'Con {plan}',
    'platformFee.tile.fee': 'véltica se queda {amount} ({fee}%)',
    'platformFee.tile.noFee': 'Sin comisión de véltica',
    'platformFee.tile.more': '{amount} más para ti',
    'platformFee.perSale': '{fee}% por venta',
    'platformFee.paysForItself': 'Es más de lo que cuesta {plan}: el plan se pagaría solo.',
    'platformFee.seePlans': 'Ver {plan}',
    'planLimit.dialogLabel': "Aumentar límites",
    'planLimit.close': "Cerrar",
    'planLimit.eyebrow': "Límite alcanzado",
    'planLimit.title': "Llegaste al máximo de {resource} de tu plan {plan}",
    'planLimit.topPlan': "Estás en {plan}, nuestro plan más alto. Si necesitas más capacidad, escríbenos y armamos un plan a tu medida.",
    'planLimit.contactNote': "Te contestamos el mismo día.",
    'planLimit.contactSubject': "Necesito más capacidad (Business)",
    'planLimit.contact': "Contactar a véltica",
    'planLimit.upgradeLead': "Sube a {plan} para seguir creando {resource} y desbloquear más capacidad.",
    'planLimit.upgradeCta': "Mejorar a {plan}",
    'planLimit.notNow': "Ahora no",
    'planLimit.blogPosts.point': "{count} entradas publicadas",
    'planLimit.blogPosts.unlimited': "Entradas publicadas ilimitadas",
    'planLimit.pro.point1': "5 proyectos",
    'planLimit.pro.point2': "30 páginas",
    'planLimit.pro.point3': "20 colecciones · 500 elementos",
    'planLimit.pro.point4': "Dominio propio, sin insignia",
    'planLimit.price': "desde ${price}/mes",
    'planLimit.offers.lead': "Con {plan} publicas hasta {count} ofertas y cada venta paga {fee}% de comisión en vez de {currentFee}%.",
    'planLimit.offers.leadUnlimited': "Con {plan} publicas todas las ofertas que quieras y cada venta paga {fee}% de comisión en vez de {currentFee}%.",
    'planLimit.offers.fee': "Comisión de {fee}% por venta, en vez de {currentFee}%",
    'planLimit.business.point1': "20 proyectos",
    'planLimit.business.point2': "Páginas ilimitadas",
    'planLimit.business.point3': "100 colecciones · 5,000 elementos",
    'planLimit.business.point4': "Apps de negocio (formularios, inbox, ventas)",
    'emails.title': "Cuentas de correo",
    'emails.subtitle': "Correos personalizados y reglas de reenvío.",
    'emails.newRule': "Nueva regla",
    'emails.needDomainTitle': "Conecta un dominio para usar correos",
    'emails.needDomainBody': "Para crear correos como {example}, primero necesitas conectar un dominio personalizado en la sección de Publicación.",
    'emails.connectDomain': "Conectar dominio",
    'emails.rulesTitle': "Reglas de reenvío",
    'emails.colAlias': "Alias (recibe)",
    'emails.colDestination': "Destino (reenvía a)",
    'emails.colStatus': "Estado",
    'emails.colActions': "Acciones",
    'emails.active': "Activo",
    'emails.pending': "Pendiente",
    'emails.deleteRule': "Eliminar regla",
    'omnisend.description': "Conecta tu cuenta de Omnisend para que los contactos que llegan por tus formularios entren en tus listas.",
    'omnisend.checking': "Comprobando…",
    'omnisend.keyBroken': "La clave dejó de funcionar",
    'omnisend.connected': "Cuenta conectada",
    'omnisend.notConnected': "Sin conectar",
    'omnisend.loadingBody': "Consultando el estado de la integración.",
    'omnisend.invalidBody': "Omnisend rechazó la última clave guardada. Los contactos no se están enviando hasta que pegues una nueva.",
    'omnisend.connectedBody': "Los formularios que tengan el envío activado mandan sus contactos a esta cuenta. Clave {hint}.",
    'omnisend.emptyBody': "Pega la clave de tu cuenta de Omnisend para empezar. Puedes cambiarla o quitarla cuando quieras.",
    'omnisend.needsAttention': "Requiere atención",
    'omnisend.statusOk': "Conectada",
    'omnisend.changeKey': "Cambiar la clave",
    'omnisend.apiKey': "Clave de la API",
    'omnisend.placeholder': "Pega aquí tu clave de Omnisend",
    'omnisend.whereKeyPart1': "La encuentras en Omnisend, en",
    'omnisend.openOmnisend': "Abrir Omnisend",
    'omnisend.stored': "Se guarda cifrada y no vuelve a mostrarse: sólo verás sus últimos cuatro caracteres.",
    'omnisend.saveNewKey': "Guardar la nueva clave",
    'omnisend.connect': "Conectar cuenta",
    'omnisend.confirmDisconnect': "Sí, desconectar",
    'omnisend.cancel': "Cancelar",
    'omnisend.disconnect': "Desconectar",
    'omnisend.disconnectNote': "Se borra la clave guardada. Los contactos que ya llegaron siguen en tu cuenta de Omnisend, y los formularios dejan de enviar hasta que conectes otra vez.",
    'omnisend.adminOnly': "Sólo quien administra el proyecto puede conectar o cambiar esta cuenta.",
    'omnisend.stepsTitle': "Qué falta para que empiece a llegar",
    'omnisend.stepsLead': "Conectar la cuenta no envía nada por sí solo: cada formulario decide si manda sus contactos.",
    'omnisend.step1': "Activa el envío a Omnisend en los formularios que quieras. Un formulario de contacto y una suscripción a novedades no son lo mismo, así que se elige uno a uno.",
    'omnisend.step2Part1': "Añade una casilla de «quiero recibir novedades» al formulario si quieres suscribir a quien la marque. Sin ella el contacto llega igual, pero",
    'omnisend.step2Strong': "sin",
    'omnisend.step2Part2': "darse de alta en tus campañas: escribirte no es pedir la newsletter, y a quien ya estaba suscrito no se le toca.",
    'omnisend.goToForms': "Ir a Formularios",
    'omnisend.disconnectFailed': "No se pudo desconectar la cuenta.",
    'omnisend.connectFailed': "No se pudo conectar la cuenta.",
    'palette.warmEarth': "Tierra Cálida (Ed.)",
    'palette.brassObsidian': "Latón y Obsidiana",
    'palette.monochromeVolt': "Monocromo Volt",
    'palette.nordicBlue': "Azul Nórdico",
    'palette.obsidianTech': "Obsidiana Tech",
    'palette.burgundyRose': "Borgoña y Rosa",
    'palette.oceanHealth': "Salud Océano",
    'palette.cyberpunkJapan': "Cyberpunk Japón",
    'section.header': "Encabezado",
    'section.hero': "Hero",
    'section.cards': "Tarjetas",
    'section.testimonials': "Testimonios",
    'section.faq': "Preguntas frecuentes",
    'section.pricing': "Precios",
    'section.gallery': "Galería",
    'section.stats': "Estadísticas",
    'section.logos': "Logos",
    'section.about': "Nosotros",
    'section.cta': "Llamado a la acción",
    'section.contact': "Contacto",
    'section.footer': "Pie de página",
    'section.numbered': "Sección {n}",
    'fakeOrders.item1': "Consultoría inicial",
    'fakeOrders.item2': "Plan mensual",
    'fakeOrders.item3': "Curso completo",
    'fakeOrders.item4': "Sesión de diseño",
    'fakeOrders.item5': "Guía descargable",
    'fakeOrders.buyer1': "Ana Ríos",
    'fakeOrders.buyer2': "Luis Herrera",
    'fakeOrders.buyer3': "Marta Solís",
    'fakeOrders.buyer4': "Diego Paz",
    'fakeOrders.buyer5': "Sofía Lara",
    'fakeOrders.buyer6': "Iván Mora",
    'mascot.playful.1': "Si te quedas mirándome, parpadeo. Es un trato justo.",
    'mascot.playful.2': "Hoy me siento hexagonal. Como todos los días, en realidad.",
    'mascot.playful.3': "Puedes cambiarme de color. Elijo no opinar sobre tu gusto.",
    'mascot.playful.4': "Me han dicho que hoy es un buen día para publicar algo.",
    'mascot.playful.5': "Sigo tu ratón por toda la pantalla. No es raro, es mi trabajo.",
    'mascot.playful.6': "Un sitio web es como una planta: se riega poco y a menudo.",
    'mascot.playful.7': "Tu proyecto está en buenas manos. Bueno, en buenas esquinas.",
    'mascot.playful.8': "Cada vez que publicas, doy una vuelta de celebración. Nadie me ve.",
    'mascot.playful.9': "Estoy hecha de seis lados y muchas ganas.",
    'mascot.playful.10': "Hoy no toca nada urgente. Aprovecha.",
    'mascot.playful.11': "Trabajo mejor cuando alguien me mira. Como todo el mundo.",
    'mascot.playful.12': "Tu sitio se ve bien desde aquí dentro.",
    'mascot.playful.13': "Los lunes también cuentan como días de publicar.",
    'mascot.playful.14': "Tengo dos ojos y ninguna opinión sobre tipografías. Mentira: tengo varias.",
    'mascot.playful.15': "Un día de estos aprenderé a saludar con la mano.",
    'mascot.playful.16': "Este panel está más ordenado que mi escritorio. No tengo escritorio.",
    'mascot.playful.17': "Podría estar en cualquier pantalla. Elegí ésta.",
    'mascot.playful.18': "Los sitios que se cuidan se notan. El tuyo se nota.",
    'mascot.playful.19': "Hoy hay buena luz para trabajar.",
    'mascot.playful.20': "Vengo con la marca puesta y sin vacaciones.",
    'mascot.playful.21': "Me gusta cómo va quedando esto.",
    'mascot.playful.22': "Tengo seis lados y ninguno favorito.",
    'mascot.playful.23': "Cuento tus visitas mientras tú haces otras cosas.",
    'mascot.playful.24': "Buen momento para escribir esa página que tienes en la cabeza.",
    'mascot.playful.25': "Hoy toca avanzar un poco. Un poco basta.",
    'mascot.playful.26': "Si me pulsas, te dejo elegir mi color.",
    'mascot.playful.27': "Me paso el día mirando tu panel. Se ve bien.",
    'mascot.playful.28': "Cada esquina mía está redondeada a mano. Es un decir.",
    'mascot.playful.29': "Los proyectos buenos se empiezan un martes cualquiera.",
    'mascot.playful.30': "Aquí estoy, con la marca puesta y el turno empezado.",
    'mascot.tip.1': "Una página tarda en cargar lo que pesa su imagen más grande.",
    'mascot.tip.2': "Los títulos de página son lo primero que lee Google. Y lo único, a veces.",
    'mascot.tip.3': "Un formulario con tres campos se rellena. Con diez, se abandona.",
    'mascot.tip.4': "Conectar tu propio dominio hace que un sitio parezca un negocio.",
    'mascot.tip.5': "Publica antes de que esté perfecto. Perfecto no llega solo.",
    'mascot.tip.6': "Revisa cómo se ve tu sitio en el móvil: es donde entra casi todo el mundo.",
    'mascot.tip.7': "Un texto alternativo en cada imagen te lee mejor en Google y en un lector de pantalla.",
    'mascot.tip.8': "La página de inicio no tiene que contarlo todo, sólo lo siguiente.",
    'mascot.tip.9': "Si una página no tiene un botón claro, no tiene un objetivo claro.",
    'mascot.tip.10': "Los visitantes deciden si se quedan en tres segundos. Tres.",
    'mascot.tip.11': "Contesta los formularios el mismo día. Al segundo ya no se acuerdan de ti.",
    'mascot.tip.12': "Un blog sin fechas envejece peor que uno con fechas viejas.",
    'mascot.tip.13': "Los enlaces rotos no avisan. Repásalos de vez en cuando.",
    'mascot.tip.14': "Menos tipografías, más carácter.",
    'mascot.tip.15': "Una foto real de tu negocio vale más que diez de banco de imágenes.",
    'mascot.tip.16': "El aviso de privacidad no es un trámite: es lo que te cubre.",
    'mascot.tip.17': "Tu dominio se renueva solo, pero conviene saber cuándo.",
    'mascot.tip.18': "Escribe los textos pensando en quien llega perdido, no en quien ya te conoce.",
    'mascot.tip.19': "Un sitio con SSL sale mejor colocado y da más confianza. El tuyo lo lleva.",
    'mascot.tip.20': "Nombra tus páginas como las buscaría un cliente, no como las llamas tú.",
    'mascot.tip.21': "Las analíticas de una semana no dicen nada. Las de un mes, casi todo.",
    'mascot.tip.22': "Guardar no es publicar. Publicar es lo que ve la gente.",
    'mascot.tip.23': "Un botón que dice «Enviar» convence menos que uno que dice qué pasa después.",
    'mascot.tip.24': "Si tienes precios, ponlos. Buscarlos cansa.",
    'mascot.tip.25': "El pie de página es donde la gente busca el teléfono. Que esté.",
    'mascot.tip.26': "Una colección de CMS te ahorra hacer treinta páginas a mano.",
    'mascot.tip.27': "Las imágenes en horizontal encajan mejor en casi todos los bloques.",
    'mascot.tip.28': "Si vendes algo, cuenta qué pasa después de pagar.",
    'mascot.tip.29': "Los sitios rápidos parecen más profesionales aunque digan lo mismo.",
    'mascot.tip.30': "Repite tu dirección y tu teléfono en el sitio y en Google. Iguales.",
    'mascot.tip.31': "Un titular concreto gana a uno ingenioso.",
    'mascot.tip.32': "Prueba tu formulario tú mismo, de vez en cuando.",
    'mascot.tip.33': "La gente no lee: escanea. Escribe en trozos cortos.",
    'mascot.tip.34': "Un vídeo que arranca solo espanta más de lo que atrae.",
    'mascot.tip.35': "Cada página debería poder explicarse en una frase.",
    'mascot.tip.36': "Si dudas entre dos textos, elige el más corto.",
    'mascot.tip.37': "Los testimonios funcionan cuando tienen nombre y cara.",
    'mascot.tip.38': "Actualizar una página vieja rinde más que escribir una nueva.",
    'mascot.tip.39': "El mejor momento para hacer una copia de seguridad es antes de tocar nada.",
    'mascot.tip.40': "Un dominio corto se dicta por teléfono sin repetirlo.",
    'mascot.product.1': "Todo lo que publicas aquí sale con certificado y CDN incluidos.",
    'mascot.product.2': "Puedes cambiar la dirección de tu sitio cuando quieras, desde Dominio.",
    'mascot.product.3': "Cada proyecto guarda copias automáticas. Están en Configuración.",
    'mascot.product.4': "Las visitas de tu sitio se cuentan sin cookies ni rastreadores.",
    'mascot.product.5': "El editor guarda solo. No hay botón de guardar que se te olvide.",
    'mascot.product.6': "Los formularios que recibes se quedan también en Contactos.",
    'mascot.product.7': "Puedes tener varios dominios apuntando al mismo sitio.",
    'mascot.product.8': "El CMS sirve para lo que se repite: blog, catálogo, fichas, servicios.",
    'mascot.product.9': "Tus páginas se publican en dos copias: la de pruebas y la de tu dominio.",
    'mascot.product.10': "Si conectas Stripe, cobras desde tu propio sitio.",
    'mascot.product.11': "Las reservas tienen su propia página pública, sin instalar nada.",
    'mascot.product.12': "Puedes invitar a tu equipo y repartir permisos por persona.",
    'mascot.product.13': "Los planes se cambian a mitad de mes; se prorratea solo.",
    'mascot.product.14': "Cada página tiene sus propios ajustes para los buscadores.",
    'mascot.product.15': "Puedes proteger un sitio entero con contraseña mientras lo preparas.",
    'mascot.product.16': "Las analíticas distinguen visitas de visitantes. No es lo mismo.",
    'mascot.product.17': "Desde el editor puedes ver tu sitio como lo ve un móvil.",
    'mascot.product.18': "Los borradores no se indexan. Publica cuando estés listo.",
    'mascot.product.19': "Puedes duplicar una página y cambiar sólo lo que cambie.",
    'mascot.product.20': "Tus imágenes se sirven ya optimizadas. No tienes que hacer nada.",
    'mascot.product.21': "Puedes escribir notas del proyecto en el widget de notas.",
    'mascot.product.22': "Los widgets de esta pantalla se reordenan y se quitan.",
    'mascot.product.23': "Cambiar el color del panel es pulsarme y elegir uno.",
    'templateModal.editTemplate': "Editar template",
    'templateModal.newTemplate': "Nuevo template",
    'templateModal.editSite': "Editar plantilla",
    'templateModal.newSite': "Nueva plantilla",
    'templateModal.siteLead': "Metadata de la plantilla que verán en el asistente. El diseño de la página se hace en el canvas.",
    'templateModal.blockLead': "Estos datos alimentan la librería, búsqueda y selección de AI. El diseño visual vive en el canvas.",
    'templateModal.name': "Nombre",
    'templateModal.namePlaceholder': "Hero premium",
    'templateModal.slug': "Slug",
    'templateModal.kind': "Tipo",
    'templateModal.fullPage': "Página completa (Template)",
    'templateModal.kindPage': "Página",
    'templateModal.kindSection': "Sección",
    'templateModal.kindHeader': "Header",
    'templateModal.kindFooter': "Footer",
    'templateModal.kindComponent': "Componente",
    'templateModal.category': "Categoría",
    'templateModal.language': "Idioma del texto",
    'templateModal.languageAny': "Cualquiera (sin texto fijo)",
    'templateModal.language.es': "Español",
    'templateModal.language.en': "Inglés",
    'templateModal.pickCategory': "Elige una categoría…",
    'templateModal.industry': "Industria",
    'templateModal.pickIndustry': "Elige una industria…",
    'templateModal.descriptionPlaceholderSite': "Para qué negocio es, en inglés: p. ej. Warm site for a café with menu, gallery and reservations.",
    'templateModal.description': "Descripción",
    'templateModal.descriptionPlaceholder': "Cómo está armado, en inglés: p. ej. Headline and button on the left, product photo on the right.",
    'templateModal.sectionBasics': "Lo básico",
    'templateModal.sectionAi': "Para que la IA lo elija",
    'templateModal.sectionAiHint': "Un bloque es estructura: la IA lo elige por cómo está armado y su fondo. Cómo se ve y para qué negocio lo pone el sitio.",
    'templateModal.descriptionHint': "Una línea en inglés de cuándo usarlo. La IA la lee para desempatar.",
    'templateModal.more': "Más detalles",
    'templateModal.moreHint': "Opcional: slug y premium.",
    'templateAi.progress': "{done} de {total}",
    'templateAi.slotsInferred': "Sin slots marcados: la IA los deduce por la forma del template. Marcarlos en el editor hace que cada texto caiga justo donde debe.",
    'templateAi.required': "Obligatorio",
    'templateAi.detected': "Detectado en el canvas: {list}",
    'templateAi.step.category': "Categoría",
    'templateAi.step.slots': "Slots de IA en los textos editables (se ponen en el editor)",
    'templateAi.step.description': "Una línea en inglés de cuándo usarlo",
    'templateAi.step.layout': "Cómo está armado",
    'templateAi.step.colorScheme': "Fondo",
    'templateCard.status.published': "Publicado",
    'templateCard.status.archived': "Archivado",
    'templateCard.status.draft': "Borrador",
    'templateCard.aiReady': "Lista para la IA",
    'templateCard.aiMissing': "Fuera de la IA: {missing}",
    'templateCard.noDescription': "Sin descripción todavía",
    'templateAi.short.category': "sin categoría",
    'templateAi.short.slots': "sin slots de IA",
    'templateList.sitesTitle': "Plantillas de sitio",
    'templateList.sitesSubtitle': "Páginas completas desde las que se puede empezar. Aparecen en el asistente al crear un proyecto.",
    'templateList.sitesEmptyTitle': "Todavía no hay plantillas",
    'templateList.sitesEmptyDesc': "Crea una, abre el canvas y diseña una página completa.",
    'templateList.blocksTitle': "Bloques",
    'templateList.blocksSubtitle': "Secciones, headers, footers y componentes. Llenan el panel Insertar y son con lo que la IA arma los sitios.",
    'templateList.blocksEmptyTitle': "Todavía no hay bloques",
    'templateList.blocksEmptyDesc': "Crea tu primer bloque y abre el canvas para diseñarlo.",
    'templateList.newSite': "Nueva plantilla",
    'templateList.newBlock': "Nuevo bloque",
    'templateList.areas': "Partes de la biblioteca",
    'templateList.area.sections': "Secciones",
    'templateList.area.catalog': "Catálogo",
    'templateList.area.blog': "Blog",
    'templateList.area.cms': "CMS",
    'templateList.area.components': "Componentes y banners",
    'templateList.groupSections': "Secciones",
    'templateList.design.blog-index': "Diseño del índice del blog",
    'templateList.design.blog-post': "Diseño de la entrada",
    'templateList.design.cms-collection': "Diseño de la colección",
    'templateList.design.cms-item': "Diseño de la ficha",
    'templateList.createSite': "Crear plantilla",
    'templateList.createBlock': "Crear bloque",
    'templateList.truncated': "Se muestran los {shown} más recientes de {total}. Los más antiguos no aparecen en esta lista: hace falta paginarla.",
    'templateList.howTitle': "Cómo llega un template a la IA",
    'templateList.step1': "Diséñalo en el canvas con los colores y letras del sistema de estilos, para que siga cualquier estilo.",
    'templateList.step2': "Marca cada texto, imagen y botón editable con un slot de IA.",
    'templateList.step3': "En su ficha elige la categoría y para quién sirve, y publícalo.",
    'templateList.filterAll': "Todos",
    'templateList.filterNeedsAi': "Fuera de la IA",
    'templateList.filterUnpublished': "Cambios sin publicar",
    'templateList.filterDrafts': "Borradores",
    'templateList.search': "Buscar por nombre",
    'templateList.sort': "Ordenar",
    'templateList.sort.recent': "Más recientes",
    'templateList.sort.oldest': "Más antiguas",
    'templateList.sort.used': "Más usadas",
    'templateList.sort.updated': "Editadas hace poco",
    'templateList.sort.name': "Nombre (A–Z)",
    'templateList.empty': "Nada coincide con este filtro.",
    'templateAi.title': "Lista para la IA",
    'templateAi.ready': "La IA puede elegir y rellenar este template.",
    'templateAi.notReady': "La IA no lo usará hasta que arregles esto:",
    'templateAi.improve': "Ayudaría a que la IA lo elija mejor:",
    'templateAi.issue.category': "Elige una categoría",
    'templateAi.issue.description': "Escribe una línea, en inglés, de cuándo usarlo",
    'templateAi.issue.slots': "Marca los textos editables con slots de IA en el editor",
    'templateAi.issue.style': "Elige su estilo",
    'templateAi.issue.layout': "Elige su layout",
    'templateAi.issue.colorScheme': "Elige su fondo",
    'templateAi.issue.goal': "Elige su objetivo",
    'templateAi.issue.bestFor': "Elige para qué giros sirve",
    'templateAi.issue.unslottedText': "{count} textos no tienen slot: la IA no los reescribe",
    'templateAi.issue.manualOnly': "Marcado «sólo a mano»: la IA no lo usa",
    'templateModal.manualOnly': "Sólo a mano",
    'templateModal.manualOnlyHint': "La IA no lo usa nunca al crear sitios. Se sigue viendo en la biblioteca.",
    'templateModal.aiUse': "La IA lo usa al crear sitios",
    'templateModal.aiUseHint': "Apagado, el bloque sigue en la biblioteca para ponerlo a mano, pero la IA no lo elige.",
    'templateCard.aiOn': "Usar en la IA",
    'templateCard.aiOff': "Quitar de la IA",
    'templateCard.aiDisabled': "IA desactivada",
    'templateAi.short.manualOnly': "quitado de la IA",
    'templateModal.locations': "Sucursales",
    'templateModal.locations.one': "Una dirección",
    'templateModal.locations.two': "Dos sucursales",
    'templateModal.locations.three': "Tres sucursales",
    'templateModal.locations.list': "Lista (cualquier número)",
    'templateModal.locationsHint': "La IA sólo usa un bloque de varias sucursales cuando el negocio tiene ese número.",
    'templateModal.thumbnail': "Miniatura (thumbnail)",
    'templateModal.uploading': "Subiendo…",
    'templateModal.changeImage': "Cambiar imagen",
    'templateModal.uploadImage': "Subir imagen",
    'templateModal.removeImage': "Quitar",
    'templateModal.thumbnailHint': "Se muestra en el asistente de crear proyecto. JPG, PNG o WebP, máx. 5 MB.",
    'templateModal.premium': "Premium",
    'templateModal.publishOnCreate': "Publicar al crear",
    'templateModal.cancel': "Cancelar",
    'templateModal.saving': "Guardando...",
    'templateModal.save': "Guardar",
    'authCodes.title': "Códigos",
    'authCodes.subtitle': "Solicitudes del código de autorización para transferir un dominio fuera de véltica.",
    'authCodes.filterPending': "Pendientes",
    'authCodes.filterSent': "Enviadas",
    'authCodes.filterAll': "Todas",
    'authCodes.retry': "Reintentar",
    'authCodes.loading': "Cargando…",
    'authCodes.emptyPending': "Nada pendiente",
    'authCodes.emptyAll': "Sin solicitudes",
    'authCodes.emptyPendingBody': "Cuando alguien pida el código de su dominio, aparecerá aquí.",
    'authCodes.emptyAllBody': "Todavía nadie ha pedido el código de un dominio.",
    'authCodes.late': "Se pasa del plazo",
    'authCodes.sent': "Enviado",
    'authCodes.unknownAccount': "cuenta desconocida",
    'authCodes.writeTo': "Escribir a {email}",
    'authCodes.replyByEmail': "Responder por correo",
    'authCodes.mailSubject': "Código de transferencia de {domain}",
    'authCodes.paste': "Pegar código",
    'authCodes.srLabel': "Código de autorización de {domain}",
    'authCodes.placeholder': "Pega aquí el código del registrador",
    'authCodes.sending': "Enviando…",
    'authCodes.sendToClient': "Enviar al cliente",
    'authCodes.cancel': "Cancelar",
    'authCodes.sendNote': "Se le manda por correo y aparece en los ajustes de su dominio.",
    'authCodes.note': "El código se saca a mano del panel del registrador: ninguna API lo expone. Al pegarlo aquí se le manda por correo, aparece en los ajustes de su dominio y se cierra la solicitud. Se guarda 30 días y después se borra solo. Con él, cualquiera puede llevarse el dominio.",
    'authCodes.agoNow': "hace un momento",
    'authCodes.agoMinutes': "hace {count} min",
    'authCodes.agoHourOne': "hace {count} hora",
    'authCodes.agoHours': "hace {count} horas",
    'authCodes.agoDayOne': "hace {count} día",
    'authCodes.agoDays': "hace {count} días",
    'templateModal.slugPlaceholder': "hero-premium",
    'adminImages.title': "Imágenes",
    'adminImages.subtitle': "Biblioteca profesional compartida con todos los usuarios y disponible para el asistente AI.",
    'adminImages.pickFile': "Seleccionar imagen o vídeo",
    'adminImages.filesPicked': "{count} imágenes seleccionadas",
    'adminImages.manyHint': "Con varias imágenes, cada una se sube con el título «test» y sin etiquetas. Puedes editarlas después.",
    'adminImages.uploadMany': "Subir {count} imágenes",
    'adminImages.someFailed': "No se pudieron subir {count} de {total} imágenes.",
    'adminImages.formats': "JPG, PNG, WebP, GIF o AVIF hasta 10 MB · vídeo MP4 o WebM hasta 95 MB",
    'adminImages.videoBadge': "Vídeo",
    'adminImages.videoType': "Sólo vídeos MP4 o WebM.",
    'adminImages.videoTooBig': "El vídeo supera el máximo de 95 MB.",
    'adminImages.titleField': "Título",
    'adminImages.titlePlaceholder': "Ej. Tratamiento facial premium",
    'adminImages.hashtagsField': "Hashtags para búsqueda y AI",
    'adminImages.hashtagsPlaceholder': "#belleza #spa #facial #premium",
    'adminImages.uploadingPercent': "Subiendo {percent}%",
    'adminImages.compressing': "Comprimiendo…",
    'adminImages.upload': "Subir imagen",
    'adminImages.search': "Buscar por título o hashtag…",
    'adminImages.searchBtn': "Buscar",
    'adminImages.loading': "Cargando biblioteca…",
    'adminImages.empty': "No hay imágenes",
    'adminImages.emptyBody': "Sube la primera imagen profesional de la biblioteca.",
    'adminImages.edit': "Editar",
    'adminImages.delete': "Eliminar",
    'adminImages.loadMore': "Cargar más",
    'adminImages.editTitle': "Editar imagen",
    'adminImages.editLead': "Estos datos ayudan al buscador y a la AI a elegir la imagen correcta.",
    'adminImages.hashtags': "Hashtags",
    'adminImages.editHashtagsPlaceholder': "#belleza #spa #premium",
    'adminImages.cancel': "Cancelar",
    'adminImages.save': "Guardar",
    'adminImages.confirmDelete': "¿Eliminar “{title}” de la biblioteca para todos los usuarios?",
    'error.domain.planRequired': "Conectar un dominio propio requiere el plan Pro o Business.",
    'error.domain.buyPlanRequired': "Comprar un dominio requiere el plan Pro o Business.",
    'error.domain.invalid': "Ingresa un dominio válido, por ejemplo www.tuempresa.com.",
    'error.domain.reserved': "Ese dominio pertenece a véltica; usa tu propio dominio.",
    'error.domain.limitReached': "Llegaste al máximo de dominios de este proyecto.",
    'error.domain.notFound': "No encontramos ese dominio.",
    'error.domain.onlyActivePrimary': "Sólo un dominio activo puede ser el principal.",
    'error.domain.registering': "Estamos registrando ese dominio. Espera a que termine.",
    'error.domain.recordGone': "Ese registro ya no existe.",
    'error.domain.notBoughtHere': "Ese dominio no se compró aquí: conéctalo con el asistente.",
    'error.domain.searchTooShort': "Escribe al menos dos letras, sin espacios ni puntos.",
    'error.domain.purchaseUnavailable': "La compra de dominios todavía no está configurada.",
    'error.domain.unavailable': "Ese dominio ya no está disponible.",
    'error.domain.premium': "Es un dominio premium y no se puede comprar desde aquí.",
    'error.domain.priceUnavailable': "No pudimos calcular el precio de ese dominio.",
    'error.domain.creditUsed': "Tu crédito de dominio ya se usó. Vuelve a intentarlo.",
    'error.booking.slotTaken': "Ese horario ya está ocupado.",
    'error.booking.notFound': "No encontramos esa cita.",
    'error.booking.noSchedule': "Esta oferta todavía no tiene agenda configurada.",
    'error.booking.noResource': "La agenda no tiene ningún recurso.",
    'error.booking.invalidDate': "Esa fecha no es válida.",
    'error.booking.rangeTooLong': "El rango de fechas es demasiado largo.",
    'error.contact.notFound': "No encontramos ese contacto.",
    'error.offer.invalidInclusions': "Las membresías elegidas no son válidas.",
    'error.offer.inclusionsUnavailable': "Esta función todavía no está lista en tu cuenta.",
    'error.offer.inclusionsNeedPlan': "Las reservas incluidas en membresías son del plan Pro.",
    'error.contact.noAccount': "Esta persona no tiene cuenta en tu sitio.",
    'error.contact.membershipNotFound': "Esa membresía no es de esta persona.",
    'error.contact.membershipEnded': "Esa membresía ya terminó.",
    'error.contact.membershipCancelFailed': "Stripe no pudo cancelar la membresía. Inténtalo de nuevo.",
    'error.contact.membershipGranted': "Esa membresía se dio desde Contactos: quítala en «Accesos».",
    'error.grant.unavailable': "Esta función todavía no está lista.",
    'error.grant.noEmail': "Esta persona no tiene correo.",
    'error.grant.pastDate': "La fecha de fin ya pasó.",
    'error.grant.offerNotFound': "Esa oferta no se puede dar.",
    'error.grant.notFound': "Ese acceso ya no está.",
    'error.contact.invalid': "Revisa la información del contacto.",
    'error.message.notFound': "No encontramos ese mensaje.",
    'error.message.invalidStatus': "Ese estado no es válido.",
    'error.team.selfInvite': "No puedes invitarte a ti mismo a este proyecto.",
    'error.team.alreadyOwner': "Esa persona ya es la propietaria del proyecto.",
    'error.team.alreadyMember': "Esa persona ya forma parte del proyecto.",
    'error.team.invitePending': "Ya hay una invitación pendiente para ese correo.",
    'error.team.memberGone': "Ese miembro ya no está en el proyecto.",
    'error.team.selfRole': "No puedes cambiar tu propio rol. Pídeselo a otra persona con permiso.",
    'error.integration.notFound': "Esa integración no existe.",
    'error.integration.keyFormat': "La clave no tiene el formato esperado.",
    'error.integration.keyRejected': "Omnisend no reconoce esa clave.",
    'error.domain.externalDns': "Este dominio está registrado fuera de véltica, así que su DNS se administra en tu registrador.",
    'error.domain.renewInProgress': "Ya hay una operación en curso para ese dominio. Espera a que termine.",
    'error.domain.renewUnavailable': "No pudimos preparar la renovación ahora mismo. Inténtalo en unos minutos o escríbenos.",
    'error.domain.systemRecordCreate': "Ese nombre lo usa el registro que mantiene tu sitio en línea y su certificado. Elige otro.",
    'error.domain.systemRecordEdit': "Ese registro mantiene tu sitio en línea y su certificado. No se puede editar desde aquí.",
    'error.domain.systemRecordDelete': "Ese registro mantiene tu sitio en línea y su certificado. No se puede borrar desde aquí.",
    'error.domain.connectedElsewhere': "Ese dominio ya está conectado a otro proyecto. Desconéctalo de ahí primero.",
    'error.booking.resourceCreateFailed': "No se pudo crear el recurso, inténtalo de nuevo.",
    'error.booking.resourceIsDefault': 'El primero del equipo no se puede quitar.',
    'error.collection.limit': 'Has llegado al máximo de colecciones.',
    'error.collection.notFound': 'Esa colección ya no existe.',
    'error.booking.resourceHasBookings': 'Tiene citas: márcalo como inactivo en vez de quitarlo.',
    'error.booking.artistBusy': 'Esa persona ya tiene una cita a esa hora.',
    'error.booking.rangeMissing': "Hacen falta una fecha de inicio y una de fin.",
    'error.booking.durationMissing': "Hace falta una duración o una oferta con agenda.",
    'error.contact.missing': "No se indicó ningún contacto.",
    'error.contact.unknown': "No reconocemos ese contacto.",
    'error.message.spamOnly': "Un envío sin correo sólo admite marcarse como spam.",
    'error.team.seatsUnavailable': "Tu plan actual no incluye invitados. Sube de plan para compartir este proyecto.",
    'error.team.seatsFull': "Tu plan permite {limit} invitados y ya están ocupados. Cancela una invitación o sube de plan.",
    'error.domain.registrarUnknown': "El registrador no reconoce este dominio. Escríbenos y lo revisamos.",
    /* Facturación. El texto que ya mandaba el worker, palabra por palabra: esto
       traduce, no reescribe. Cambiar de paso lo que decía una frase mezcla dos
       decisiones y deja sin revisar la que importa. */
    'error.billing.planUnavailable': "Ese plan aún no está disponible.",
    'error.billing.subscriptionExists': "Esta cuenta ya tiene una membresía.",
    'error.domain.transferLocked': "Este dominio está bloqueado mientras revisamos un reembolso o una disputa de pago.",
    'error.account.domainsOwned': "Transfiere tus dominios fuera de véltica antes de eliminar tu cuenta.",
    'error.account.domainChoiceNeeded': "Elige qué hacer con cada dominio antes de eliminar tu cuenta.",
    'error.account.domainTransferLocked': "Ese dominio está bloqueado por un reembolso o una disputa y no se puede transferir ahora. Elige dejar que venza.",
    'error.account.notScheduled': "Tu cuenta no tiene una eliminación pendiente.",
    'error.account.deletionScheduled': "Tu cuenta está programada para eliminarse. Restáurala para seguir usándola.",
    'error.account.purchasePending': "Hay una compra de dominio en curso. Espera a que termine.",
    'error.account.cancelFailed': "No pudimos cancelar la membresía; la cuenta no se eliminó.",
    'error.billing.checkoutFailed': "No se pudo iniciar el pago.",
    'error.billing.noSubscription': "No tienes una suscripción activa.",
    'error.billing.portalFailed': "No se pudo abrir el portal de facturación.",
    'error.billing.overviewFailed': "No se pudo cargar la facturación.",
    'error.billing.downgradePreviewFailed': "No se pudo calcular lo que cambia al bajar de plan.",
    'error.billing.invalidCursor': "Cursor inválido.",
    'error.billing.historyFailed': "No se pudo cargar el historial.",
    'error.billing.noCustomer': "Todavía no tienes cobros en tu cuenta.",
    'error.billing.cardSetupFailed': "No se pudo preparar la tarjeta.",
    'error.billing.cardNotYours': "Esa tarjeta no es de tu cuenta.",
    'error.billing.cardUpdateFailed': "No se pudo cambiar la tarjeta.",
    'error.billing.lastCard': "Es la única tarjeta de tu membresía. Agrega otra antes de quitarla.",
    'error.billing.cardRemoveFailed': "No se pudo quitar la tarjeta.",
    'error.billing.noMembership': "No tienes una membresía activa.",
    'error.billing.cancelFailed': "No se pudo cancelar la membresía.",
    'error.billing.membershipEnded': "Esa membresía ya terminó. Vuelve a contratarla desde Planes.",
    'error.billing.resumeFailed': "No se pudo reanudar la membresía.",
    'error.team.inviteInvalid': "Escribe un correo válido y elige un rol.",
    'error.team.roleUnknown': "Rol desconocido.",
    'error.booking.invalidRequest': "Petición inválida",
    /* Proyectos: la dirección del sitio, las copias y el tema. */
    'error.subdomain.tooShort': "Usa al menos 3 caracteres.",
    'error.subdomain.tooLong': "Usa como mucho 63 caracteres.",
    'error.subdomain.format': "Sólo minúsculas, números y guiones, sin empezar ni terminar en guión.",
    'error.subdomain.reserved': "Esa dirección está reservada.",
    'error.subdomain.taken': "Esa dirección ya está en uso. Prueba con otra.",
    'error.subdomain.tooManyChanges': "La dirección ya se cambió {limit} veces hoy. Prueba mañana.",
    'error.page.slugTaken': "Ya hay una página con esa dirección. Elige otra.",
    'error.backup.contentGone': "El contenido de esa copia ya no está disponible.",
    'error.backup.limitReached': "Tu plan guarda {limit} copias y ya las tienes todas. Borra alguna o sube de plan para crear otra.",
    'error.backup.unchanged': "No hay cambios desde la última copia, así que no hacía falta otra.",
    'error.backup.tooLarge': "Este proyecto es demasiado grande para guardar una copia. Escríbenos.",
    'error.project.notDeleted': "Ese proyecto no está eliminado.",
    'error.project.notPublished': "Ese proyecto no está publicado.",
    'error.policy.notFound': "Esa política no existe.",
    'error.theme.missing': "Falta el tema.",
    'error.theme.tooLarge': "El tema es demasiado grande.",
    /* Tienda y cobros. */
    'error.commerce.stripePlanRequired': "Conectar Stripe requiere un plan de pago. Puedes crear y editar tus ofertas desde el plan gratis; para cobrarlas necesitas Pro o Business.",
    'error.commerce.stripeRequiredToPublish': "Conecta Stripe antes de publicar. Mientras tanto la oferta se guarda como borrador: la sigues editando y nadie la ve.",
    'error.commerce.connectForNotices': "Conecta Stripe para configurar los avisos.",
    'error.calendar.invalidUrl': "Pega la dirección secreta en formato iCal de tu calendario (empieza por https:// o webcal://).",
    'error.calendar.googleUnavailable': "La conexión con Google Calendar no está configurada en el servidor.",
    'error.calendar.resourceNotFound': "Esa agenda ya no existe.",
    'error.calendar.tooMany': "Ya tienes el máximo de 10 calendarios conectados.",
    'error.calendar.secretMissing': "Falta configurar el cifrado de integraciones en el servidor (INTEGRATIONS_SECRET).",
    'error.calendar.saveFailed': "No se pudo guardar el calendario.",
    'error.calendar.notFound': "Calendario no encontrado.",
    'error.coupon.stripeMissing': "Conecta Stripe para crear cupones.",
    'error.coupon.stripeFailed': "Stripe no aceptó el cupón. Revisa los datos e inténtalo de nuevo.",
    'error.coupon.offerNotFound': "Alguna de las ofertas elegidas ya no existe.",
    'error.coupon.offersRequired': "Elige al menos una oferta o aplícalo a todas.",
    'error.coupon.codeTaken': "Ya tienes un cupón con ese código.",
    'error.coupon.notFound': "Cupón no encontrado.",
    'error.commerce.connectForTax': "Conecta Stripe para configurar los impuestos.",
    'error.commerce.taxUnavailable': "No se pudo consultar la configuración fiscal en Stripe. Inténtalo de nuevo en unos minutos.",
    'error.commerce.taxNotReady': "Completa la configuración fiscal en Stripe antes de activar los impuestos.",
    'error.commerce.connectForCharges': "Conecta Stripe para ver el cobro aquí.",
    'error.commerce.connectForPayouts': "Conecta Stripe para ver tus depósitos.",
    'error.commerce.embedRejected': "Stripe no autorizó la vista incrustada.",
    'error.commerce.balanceUnavailable': "No pudimos consultar tu saldo en Stripe.",
    'error.commerce.bookableOnlyCreate': "Tu rol sólo permite crear servicios reservables, no ofertas de la tienda.",
    'error.commerce.bookableOnlyEdit': "Tu rol sólo permite editar servicios reservables, y no puede dejar de serlo.",
    'error.order.notFound': "Pedido no encontrado.",
    'error.offer.createFailed': "No se pudo crear la oferta.",
    'error.offer.priceRequired': "Añade un precio antes de poner la oferta a la venta.",
    'error.offer.physicalPrice': "Un producto físico necesita un precio de pago único mayor que cero.",
    'error.offer.variantsPhysicalOnly': "Sólo un producto físico puede tener variantes.",
    'error.offer.variantsTooMany': "Un producto admite hasta 100 combinaciones. Quita algunos valores.",
    'error.offer.shippingRequired': "Añade al menos una forma de envío antes de poner el producto a la venta.",
    'error.shipping.rateLimit': "Ya tienes el máximo de formas de envío.",
    'error.shipping.rateNotFound': "Forma de envío no encontrada.",
    'error.price.notFound': "Precio no encontrado.",
    'error.price.lastOnLiveOffer': "Es el único precio de una oferta a la venta. Pausa la oferta primero.",
    /* Páginas. El número va aparte del sustantivo porque el catálogo inglés no
       lo declina igual; ningún plan concede exactamente 1 de nada —3, 30, 5, 25—
       así que el plural fijo no se queda corto. */
    'error.page.notFound': "Esa página no existe.",
    'error.page.limitOver': "Tu plan incluye {limit} páginas y este sitio tiene {used}. Puedes seguir editando y publicando las que ya tienes, pero para crear otra necesitas subir de plan.",
    'error.page.limitReached': "Llegaste a las {limit} páginas que incluye tu plan. Sube de plan para crear más.",
    /* El tope del CMS. */
    'error.cms.collectionLimitOver': "Tu plan incluye {limit} colecciones y este sitio tiene {used}. Puedes seguir editando lo que ya tienes, pero para agregar más necesitas subir de plan.",
    'error.cms.collectionLimitReached': "Llegaste a {limit} colecciones, el máximo que incluye tu plan. Sube de plan para agregar más.",
    'error.cms.itemLimitOver': "Tu plan incluye {limit} elementos CMS y este sitio tiene {used}. Puedes seguir editando lo que ya tienes, pero para agregar más necesitas subir de plan.",
    'error.cms.itemLimitReached': "Llegaste a {limit} elementos CMS, el máximo que incluye tu plan. Sube de plan para agregar más.",
    'error.offers.publishLimitReached': "Llegaste a {limit} ofertas publicadas, el máximo que incluye tu plan. Sube de plan o retira otra para publicar ésta.",
    'error.blog.notFound': "Esa entrada no existe.",
    'error.blog.invalidSlug': "La dirección sólo puede llevar letras, números y guiones.",
    'error.blog.slugTaken': "Ya tienes otra entrada con esa dirección.",
    'error.contacts.invalidTag': "Esa etiqueta no es válida.",
    'error.blog.invalidPath': "Esa dirección no está disponible para el blog.",
    'error.blog.authorInvalid': "Revisa los enlaces del autor: cada uno necesita una dirección válida, como instagram.com/tu-usuario.",
    'error.blog.authorsNotReady': "Los perfiles de autor todavía no están disponibles. Inténtalo más tarde.",
    'error.blog.publishLimitReached': "Llegaste a {limit} entradas publicadas, el máximo que incluye tu plan. Sube de plan o pasa otra a borrador para publicar ésta.",
    'error.blog.saveFailed': "No se pudo guardar la entrada.",
    'error.bookings.serviceLimitReached': "Llegaste a {limit} servicios, el máximo que incluye tu plan. Sube de plan para agregar más.",
    'ai.noContact': "No se pudo contactar al asistente AI.",
    'ai.badResponse': "El servidor devolvió una respuesta AI incompatible.",
    'ai.badBlock': "La AI eligió un bloque inválido.",
    'ai.blockDownloadFailed': "No se pudo descargar el bloque seleccionado.",
    'ai.blockEmpty': "El bloque publicado está vacío o es incompatible.",
    /* El asistente AI. */
    'error.ai.contextInvalid': "El contexto del editor no es válido.",
    'error.ai.contextTooLarge': "El contexto del editor es demasiado grande.",
    'error.ai.batchExpired': "La sesión de cambios por tandas expiró. Reintenta la solicitud.",
    'error.ai.batchOutOfOrder': "Las tandas llegaron fuera de orden. Reintenta la solicitud.",
    'auth.error.disposable': "Usa un correo permanente: no aceptamos correos temporales.",
    'error.request.tooLarge': "Lo que intentas guardar es demasiado grande. Divide el contenido en partes más pequeñas.",
    'error.form.tooMany': "Demasiados envíos seguidos. Espera un momento e inténtalo de nuevo.",
    'error.claim.tooMany': "Demasiados intentos seguidos. Espera un momento e inténtalo de nuevo.",
    'error.ai.tokenLimitMonthly': "Alcanzaste el límite mensual de tokens de IA de tu plan.",
    'error.ai.tokenLimitDaily': "Alcanzaste el límite mensual de tokens de IA de tu plan.",
    'error.ai.providerBusy': "El proveedor AI está temporalmente sin capacidad. Intenta nuevamente.",
    'error.ai.notConfigured': "El asistente AI no está configurado.",
    'error.ai.unsupportedChanges': "La AI propuso cambios que el editor no admite.",
    'error.ai.requestFailed': "No se pudo procesar la solicitud del editor.",
    'error.ai.requestInvalid': "La solicitud no es válida.",
    'error.ai.describePage': "Describe la página con al menos 15 caracteres.",
    'error.ai.describeSite': "Describe el sitio con al menos 20 caracteres y menos de 5000.",
    'error.ai.projectCreateFailed': "No se pudo crear el proyecto.",
    'error.ai.dailyGenerationLimit': "Llegaste al límite diario de generaciones AI.",
    'error.ai.dailyAssistantLimit': "Llegaste al límite diario del asistente AI.",
    'error.ai.invalidProject': "La AI no devolvió un proyecto válido.",
    'error.ai.invalidJson': "La AI devolvió JSON inválido.",
    'error.ai.incompleteProject': "La AI devolvió un proyecto incompleto.",
    /* Traspasos y archivos. */
    'error.transfer.badEmail': "Escribe un correo válido.",
    'error.transfer.toYourself': "No puedes transferirte un proyecto a tu propia cuenta.",
    'error.transfer.invitePending': "Ya hay una invitación pendiente. Cancélala antes de enviar otra.",
    'error.transfer.noPending': 'No hay ninguna invitación pendiente que reenviar.',
    'error.asset.invalidSvg': "El archivo no es un SVG válido.",
    'error.file.notMultipart': 'La subida no llegó como archivo. Inténtalo otra vez.',
    'error.file.missing': 'No llegó ningún archivo.',
    'error.file.tooMany': 'Esta oferta ya tiene todos los archivos que admite.',
    'error.file.tooLarge': 'Ese archivo pesa demasiado. El máximo son 15 MB por archivo.',
    'error.file.empty': 'Ese archivo está vacío.',
    'error.file.notFound': 'Ese archivo ya no está.',
    'error.file.nameRequired': 'El archivo necesita un nombre.',
    /* La taxonomía de plantillas. Los nombres y las ayudas de los filtros del
       editor y del gestor de plantillas; el `value` de cada uno es un id de
       máquina que NO se traduce, y la glosa que lee la IA tampoco. Ver
       `templateTaxonomy.ts` en `@webbuilder/schemas`. */
    'tpl.allSections': "Todo el catálogo de secciones",
    'tpl.previewOf': "Vista previa de {name}",
    'tax.facet.category': "Categoría",
    'tax.facet.style': "Estilo",
    'tax.facet.layout': "Layout",
    'tax.facet.columns': "Columnas",
    'tax.facet.colorScheme': "Fondo",
    'tax.facet.media': "Media",
    'tax.facet.goal': "Objetivo",
    'tax.facet.bestFor': "Ideal para",
    'tax.kind.section': "Sección",
    'tax.kind.section.hint': "Banda completa de la página",
    'tax.kind.block': "Bloque",
    'tax.kind.block.hint': "Unidad repetible dentro de una sección",
    'tax.category.navbar': "Navegación",
    'tax.category.navbar.hint': "Headers, menús y barras superiores",
    'tax.category.hero': "Hero",
    'tax.category.hero.hint': "Primera pantalla, encabezado principal",
    'tax.category.features': "Características",
    'tax.category.features.hint': "Beneficios y funcionalidades",
    'tax.category.cards': "Tarjetas",
    'tax.category.cards.hint': "Grids y módulos de contenido en tarjetas",
    'tax.category.bento': "Bento",
    'tax.category.bento.hint': "Cuadrícula asimétrica tipo bento",
    'tax.category.gallery': "Galería",
    'tax.category.gallery.hint': "Imágenes, portafolio, mosaico",
    'tax.category.logos': "Logos",
    'tax.category.logos.hint': "Barra de logos de clientes o marcas",
    'tax.category.stats': "Métricas",
    'tax.category.stats.hint': "Cifras y KPIs destacados",
    'tax.category.testimonials': "Testimonios",
    'tax.category.testimonials.hint': "Reseñas, citas y prueba social",
    'tax.category.pricing': "Precios",
    'tax.category.pricing.hint': "Planes, tiers y comparativas",
    'tax.category.faq': "Preguntas",
    'tax.category.faq.hint': "Preguntas frecuentes, acordeón",
    'tax.category.cta': "Llamado a la acción",
    'tax.category.cta.hint': "Bloques de conversión",
    'tax.category.contact': "Contacto",
    'tax.category.contact.hint': "Formularios de contacto y captura",
    'tax.category.map': "Mapa",
    'tax.category.map.hint': "Mapas, ubicación y sucursales",
    'tax.category.reservations': "Reservas de mesa",
    'tax.category.reservations.hint': "Reservas de restaurante con OpenTable",
    'tax.category.menu': "Menú",
    'tax.category.menu.hint': "Platillos y precios del restaurante",
    'tax.category.team': "Equipo",
    'tax.category.team.hint': "Personas, perfiles y roles",
    'tax.category.steps': "Proceso",
    'tax.category.steps.hint': "Pasos, timeline, cómo funciona",
    'tax.category.content': "Contenido",
    'tax.category.content.hint': "Texto enriquecido, artículos",
    'tax.category.about': "Nosotros",
    'tax.category.about.hint': "Nuestra historia: párrafos y fotos",
    'tax.category.comparison': "Comparativa",
    'tax.category.comparison.hint': "Tablas y comparaciones lado a lado",
    'tax.category.banner': "Aviso",
    'tax.category.banner.hint': "Barras de anuncio y promociones",
    'tax.category.blog': "Blog",
    'tax.category.blog.hint': "Listados de artículos y noticias",
    'tax.category.commerce': "Productos",
    'tax.category.commerce.hint': "Fichas y listados de producto",
    'tax.category.footer': "Footer",
    'tax.category.footer.hint': "Cierres, enlaces y legal",
    'tax.layout.stack': "Apilado",
    'tax.layout.stack.hint': "Elementos en una columna centrada",
    'tax.layout.grid': "Cuadrícula",
    'tax.layout.grid.hint': "Retícula uniforme de celdas",
    'tax.layout.columns': "Columnas",
    'tax.layout.columns.hint': "Varias columnas lado a lado",
    'tax.layout.split': "Dividido",
    'tax.layout.split.hint': "Texto a un lado, media al otro",
    'tax.layout.carousel': "Carrusel",
    'tax.layout.carousel.hint': "Deslizador horizontal",
    'tax.layout.masonry': "Mosaico",
    'tax.layout.masonry.hint': "Alturas irregulares tipo masonry",
    'tax.layout.list': "Lista",
    'tax.layout.list.hint': "Filas apiladas",
    'tax.layout.table': "Tabla",
    'tax.layout.table.hint': "Rejilla con filas y columnas",
    'tax.layout.overlay': "Superpuesto",
    'tax.layout.overlay.hint': "Texto sobre imagen o video",
    'tax.columns.1': "1 columna",
    'tax.columns.1.hint': "Una sola columna",
    'tax.columns.2': "2 columnas",
    'tax.columns.2.hint': "Dos por fila",
    'tax.columns.3': "3 columnas",
    'tax.columns.3.hint': "Tres por fila",
    'tax.columns.4': "4 columnas",
    'tax.columns.4.hint': "Cuatro por fila",
    'tax.columns.5': "5 columnas",
    'tax.columns.5.hint': "Cinco por fila",
    'tax.columns.6': "6 columnas",
    'tax.columns.6.hint': "Seis por fila",
    'tax.columns.auto': "Auto",
    'tax.columns.auto.hint': "Columnas según el contenido",
    'tax.style.minimal': "Minimalista",
    'tax.style.minimal.hint': "Limpio, mucho espacio en blanco",
    'tax.style.modern': "Moderno",
    'tax.style.modern.hint': "Contemporáneo y equilibrado",
    'tax.style.bold': "Atrevido",
    'tax.style.bold.hint': "Alto contraste, tipografía grande",
    'tax.style.elegant': "Elegante",
    'tax.style.elegant.hint': "Refinado y sobrio",
    'tax.style.playful': "Divertido",
    'tax.style.playful.hint': "Colores vivos, formas suaves",
    'tax.style.corporate': "Corporativo",
    'tax.style.corporate.hint': "Serio y profesional",
    'tax.style.editorial': "Editorial",
    'tax.style.editorial.hint': "Tipográfico, tipo revista",
    'tax.style.glass': "Glass",
    'tax.style.glass.hint': "Superficies translúcidas",
    'tax.colorScheme.light': "Claro",
    'tax.colorScheme.light.hint': "Fondo claro",
    'tax.colorScheme.dark': "Oscuro",
    'tax.colorScheme.dark.hint': "Fondo oscuro",
    'tax.colorScheme.muted': "Neutro",
    'tax.colorScheme.muted.hint': "Fondo gris suave",
    'tax.colorScheme.gradient': "Degradado",
    'tax.colorScheme.gradient.hint': "Fondo en degradado",
    'tax.colorScheme.image': "Imagen",
    'tax.colorScheme.image.hint': "Fondo con imagen o video",
    'tax.media.none': "Sin media",
    'tax.media.none.hint': "Solo texto",
    'tax.media.icon': "Iconos",
    'tax.media.icon.hint': "Iconos ilustrativos",
    'tax.media.image': "Imágenes",
    'tax.media.image.hint': "Fotografías o ilustraciones",
    'tax.media.video': "Video",
    'tax.media.video.hint': "Contenido en video",
    'tax.media.avatar': "Avatares",
    'tax.media.avatar.hint': "Fotos de personas",
    'tax.media.logo': "Logos",
    'tax.media.logo.hint': "Marcas y logotipos",
    'tax.goal.conversion': "Convertir",
    'tax.goal.conversion.hint': "Empujar a la acción",
    'tax.goal.trust': "Confianza",
    'tax.goal.trust.hint': "Prueba social y credibilidad",
    'tax.goal.education': "Educar",
    'tax.goal.education.hint': "Explicar cómo funciona",
    'tax.goal.capture': "Captar",
    'tax.goal.capture.hint': "Obtener datos del visitante",
    'tax.goal.showcase': "Mostrar",
    'tax.goal.showcase.hint': "Exhibir trabajo o productos",
    'tax.bestFor.general': "Cualquier negocio",
    'tax.bestFor.general.hint': "Sirve para cualquier giro",
    'tax.bestFor.saas': "Software y apps",
    'tax.bestFor.saas.hint': "Productos digitales, SaaS, apps",
    'tax.bestFor.agency': "Agencia y estudio",
    'tax.bestFor.agency.hint': "Agencias de marketing, diseño o desarrollo",
    'tax.bestFor.consulting': "Servicios profesionales",
    'tax.bestFor.consulting.hint': "Consultoría, legal, contabilidad",
    'tax.bestFor.ecommerce': "Tienda en línea",
    'tax.bestFor.ecommerce.hint': "Tiendas y catálogos de productos",
    'tax.bestFor.restaurant': "Comida y bebida",
    'tax.bestFor.restaurant.hint': "Restaurantes, cafeterías, panaderías",
    'tax.bestFor.health': "Salud y clínicas",
    'tax.bestFor.health.hint': "Clínicas, dentistas, terapeutas",
    'tax.bestFor.wellness': "Belleza y bienestar",
    'tax.bestFor.wellness.hint': "Salones, spas, belleza",
    'tax.bestFor.fitness': "Fitness y deporte",
    'tax.bestFor.fitness.hint': "Gimnasios, entrenadores, estudios",
    'tax.bestFor.education': "Cursos y educación",
    'tax.bestFor.education.hint': "Cursos, escuelas, coaching",
    'tax.bestFor.realestate': "Bienes raíces",
    'tax.bestFor.realestate.hint': "Agentes, propiedades, rentas",
    'tax.bestFor.finance': "Finanzas",
    'tax.bestFor.finance.hint': "Fintech, banca, seguros",
    'tax.bestFor.creator': "Creador y marca personal",
    'tax.bestFor.creator.hint': "Creadores, conferencistas, coaches",
    'tax.bestFor.portfolio': "Portafolio y creativos",
    'tax.bestFor.portfolio.hint': "Fotógrafos, diseñadores, artistas",
    'tax.bestFor.events': "Eventos y bodas",
    'tax.bestFor.events.hint': "Eventos, salones, bodas",
    'tax.bestFor.hospitality': "Viajes y hospedaje",
    'tax.bestFor.hospitality.hint': "Hoteles, tours, rentas vacacionales",
    'tax.bestFor.trades': "Servicios del hogar y oficios",
    'tax.bestFor.trades.hint': "Construcción, limpieza, reparaciones",
    'tax.bestFor.nonprofit': "Sin fines de lucro y comunidad",
    'tax.bestFor.nonprofit.hint': "Fundaciones, iglesias, comunidades",
    'tax.blockType.feature-card': "Tarjeta de característica",
    'tax.blockType.feature-card.hint': "Icono, título y texto",
    'tax.blockType.pricing-tier': "Plan de precios",
    'tax.blockType.pricing-tier.hint': "Columna de plan",
    'tax.blockType.testimonial': "Testimonio",
    'tax.blockType.testimonial.hint': "Cita con autor",
    'tax.blockType.faq-item': "Pregunta",
    'tax.blockType.faq-item.hint': "Fila de pregunta/respuesta",
    'tax.blockType.stat': "Métrica",
    'tax.blockType.stat.hint': "Cifra con etiqueta",
    'tax.blockType.team-member': "Miembro",
    'tax.blockType.team-member.hint': "Persona con rol",
    'tax.blockType.step': "Paso",
    'tax.blockType.step.hint': "Paso numerado del proceso",
    'tax.blockType.gallery-item': "Elemento de galería",
    'tax.blockType.gallery-item.hint': "Imagen del mosaico",
    'tax.blockType.logo': "Logo",
    'tax.blockType.logo.hint': "Logotipo de marca",
    'tax.blockType.nav-link': "Enlace de menú",
    'tax.blockType.nav-link.hint': "Ítem de navegación",
    'tax.blockType.form-field': "Campo de formulario",
    'tax.blockType.form-field.hint': "Entrada de formulario",
    'tax.blockType.accordion-item': "Ítem de acordeón",
    'tax.blockType.accordion-item.hint': "Fila colapsable",
    'toolbar.duplicate': "Duplicar",
    'toolbar.openLinkedPage': "Abrir «{page}» en el editor",
    'toolbar.goToSection': "Ir a la sección",
    'toolbar.lock': "Bloquear",
    'toolbar.saveAsSection': "Guardar como sección",
    'toolbar.copyStyle': "Copiar estilo",
    'toolbar.pasteStyle': "Pegar estilo",
    'toolbar.resetSettings': "Restablecer ajustes",
    'toolbar.delete': "Eliminar",
    'toolbar.size': "Tamaño",
    'toolbar.borderColor': "Color del borde",
    'border.width': "Grosor",
    'toolbar.borderWidth': "Grosor del borde",
    'toolbar.cornerRadius': "Radio de esquina",
    'toolbar.textStyle': "Estilo global del texto",
    'toolbar.color': "Color",
    'toolbar.align': "Alinear",
    'toolbar.buttonStyle': "Estilo global del botón",
    'toolbar.appearance': "Apariencia",
    'toolbar.layoutGroup': "Disposición",
    'toolbar.border': "Borde",
    'toolbar.corners': "Esquinas",
    'toolbar.background': "Fondo",
    'toolbar.textColor': "Color texto",
    'toolbar.adjust': "Tamaño y encaje",
    'toolbar.fitHeading': "Encaje",
    'img.fitWhole': "Completa",
    'toolbar.noBorder': "Sin borde",
    'toolbar.fit': "Ajuste",
    'toolbar.iconStyle': "Estilo global del icono",
    'toolbar.icon': "Icono",
    'toolbar.logoStyle': "Estilo global del logo",
    'toolbar.sectionStyle': "Estilo global de la sección",
    'toolbar.cardStyle': "Estilo global de la tarjeta",
    'toolbar.spacing': "Espaciado",
    'toolbar.verticalSpacing': "Espaciado vertical",
    'toolbar.horizontalSpacing': "Espaciado horizontal",
    'toolbar.gap': "Separación",
    'toolbar.columns': "Columnas",
    'toolbar.link': "Enlace",
    'toolbar.cms': "Contenido (CMS)",
    'toolbar.cmsBlog': "Contenido (Blog)",
    'toolbar.cmsOffer': "Contenido (Oferta)",
    'toolbar.insertInside': "Insertar aquí dentro",
    'toolbar.insertAfter': "Insertar después",
    'toolbar.imageSettings': "Ajustes de la imagen",
    'toolbar.askAi': "Pedírselo a la AI",
    'toolbar.move.up': "Mover arriba",
    'toolbar.move.down': "Mover abajo",
    'toolbar.move.left': "Mover a la izquierda",
    'toolbar.move.right': "Mover a la derecha",
    'toolbar.moveUp': "Subir una fila",
    'toolbar.moveDown': "Bajar una fila",
    'toolbar.backToTools': "Herramientas",
    'toolbar.short.style': "Estilo",
    'toolbar.short.insert': "Insertar",
    'toolbar.short.more': "Más",
    'toolbar.short.back': "Volver",
    'toolbar.short.ai': "IA",
    'toolbar.moreActions': "Más acciones",
    'nav.addLink': "+ Enlace",
    'nav.addMega': "+ Mega menú",
    'nav.addDropdown': "+ Menú desplegable",
    'popover.openWith': "Abrir con",
    'nav.addToMenu': "Agregar al menú",
    'gallery.onOpen': "Al abrir",
    'faq.onOpen': "Al abrirse",
    'nav.onScroll': "Al hacer scroll",
    'navm.views': "Vistas de la navegación",
    'navm.auto.label': "Automático",
    'navm.auto.catalog': "Catálogo",
    'navm.auto.collections': "Colecciones",
    'navm.auto.seeAll': "Ver todo",
    'navm.auto.desc.services': "Contrata lo que necesitas.",
    'navm.auto.desc.bookings': "Agenda tu cita en línea.",
    'navm.auto.desc.digital': "Descargas y productos digitales.",
    'navm.auto.desc.products': "Compra en nuestra tienda.",
    'navm.menu': "Menú",
    'navm.bar': "Barra",
    'navm.untitled': "Sin nombre",
    'navm.noLink': "Sin enlace aún",
    'navm.text': "Texto",
    'navm.goesTo': "Lleva a",
    'navm.megaLinks': "Enlaces",
    'navm.options': "Opciones",
    'navm.columns': "Columnas",
    'navm.look': "Diseño",
    'navm.look.mega': "Mega (ancho)",
    'navm.look.list': "Lista",
    'navm.showIcons': "Iconos y fotos",
    'navm.showDescriptions': "Descripciones",
    'navm.nColumns': "{count} col.",
    'navm.newOption': "Opción",
    'navm.addOption': "Añadir opción",
    'navm.megaCount': "Mega menú · {count} enlaces",
    'navm.optionCount': "{count} opciones",
    'navm.yourPages': "Tus páginas",
    'navm.other': "Otros",
    'navm.newLink': "Enlace",
    'navm.addLink': "Enlace",
    'navm.add': "Añadir al menú",
    'navm.style': "Estilo",
    'navm.newTab': "Abrir en pestaña nueva",
    'navm.addButtonItem': "Botón",
    'navm.ctaDefault': "Empezar",
    'navm.pick.link.hint': "A una página, sección u otra web",
    'navm.pick.button.hint': "Destaca una acción, como reservar o comprar",
    'navm.pick.dropdown': "Menú desplegable",
    'navm.pick.dropdown.hint': "Agrupa varios enlaces bajo un nombre",
    'navm.pick.mega': "Mega menú",
    'navm.pick.mega.hint': "Columnas de enlaces con descripción",
    'menuf.sections': "En esta página",
    'menuf.section': "Sección",
    'menuf.onThisPage': "Sección de esta página",
    'menuf.choose': "Elige a dónde lleva",
    'footm.views': "Vistas del pie",
    'footm.columns': "Columnas",
    'footm.legal': "Legal",
    'footm.brand': "Marca",
    'footm.brandDetail': "Logo y descripción",
    'footm.description': "Descripción",
    'footm.logoHint': "El logo es el de tu estilo y siempre lleva a la página de inicio.",
    'footm.title': "Título",
    'footm.links': "Enlaces",
    'footm.linkCount': "{count} enlaces",
    'footm.addColumn': "Añadir columna",
    'footm.newColumn': "Columna nueva",
    'footm.addLink': "Añadir enlace",
    'footm.copyright': "Texto de copyright",
    'footm.legalLinks': "Enlaces legales",
    'nav.layout': "Forma",
    'nav.layout.full': "Completa",
    'nav.layout.floating': "Flotante",
    'nav.layout.pill': "Píldora",
    'nav.inset': "Separación",
    'nav.overlay': "Sobre el contenido",
    'nav.scrollBlur': "Desenfoque",
    'gallery.onClick': "Al pulsar",
    'countdown.onEnd': "Al terminar",
    'slider.autoplay': "Autoplay",
    'carousel.advance': "Avance",
    'list.moveDown': "Bajar",
    'widget.block': "Bloque",
    'cms.field': "Campo",
    'reviews.metaPlaceholder': "Cargo, ciudad o fecha",
    'widget.carousel': "Carrusel interactivo",
    'nav.collapseAt': "Colapsa en",
    'cms.collection': "Colección",
    'cms.collectionLocked': "La fija esta página: aquí sólo salen sus entradas.",
    'layout.columns': "Columnas",
    'widget.countdown': "Countdown",
    'slider.slides': "Diapositivas",
    'marquee.clockwise': 'A la derecha',
    'marquee.counterclockwise': 'A la izquierda',
    'marquee.direction': "Dirección",
    'faq.design': "Diseñar",
    'countdown.endPlaceholder': "Disponible ahora",
    'layout.arrangement': "Disposición",
    'layout.direction': 'Dirección',
    'layout.directionDown': 'Hacia abajo',
    'layout.directionRight': 'En fila',
    'layout.order': 'Orden',
    'layout.orderNormal': 'Normal',
    'layout.orderReverse': 'Invertido',
    'slider.dots': "Dots",
    'countdown.day': "Día",
    'marquee.addItem': "Añadir tarjeta",
    'marquee.cards': "Tarjetas",
    'marquee.axis': "Eje",
    'nav.editHint': "El logo, los textos y los sub-menús se editan directamente en el lienzo (selecciónalos). Aquí defines el comportamiento.",
    'reviews.pickPhoto': "Elegir foto",
    'reviews.pickLogo': "Elegir logo",
    'faq.betweenQuestions': "Entre preguntas",
    'reviews.stars': "Estrellas",
    'marquee.fade': "Fade",
    'slider.arrows': "Flechas",
    'reviews.photo': "Foto",
    'reviews.source': "Fuente",
    'widget.marquee': "Galería infinita",
    'countdown.time': "Hora",
    'gallery.images': "Imágenes",
    'slider.interval': "Intervalo",
    'faq.questionPlaceholder': "La pregunta",
    'faq.answerPlaceholder': "La respuesta",
    'countdown.label': "Label",
    'faq.markerSide': "Lado del signo",
    'countdown.labelPlaceholder': "Lanzamiento",
    'reviews.textPlaceholder': "Lo que escribió",
    'reviews.sourceLogo': "Logo de la fuente",
    'slider.loop': "Loop",
    'faq.divider': "Línea entre preguntas",
    'nav.mobileMenu': "Menú móvil",
    'gallery.max': "Máximo",
    'reviews.name': "Nombre",
    'reviews.sourceName': "Nombre de la fuente",
    'cms.source': "Origen",
    'tabs.panels': "Paneles",
    'tabs.style.segmented': "Segmentado",
    'tabs.style.pills': "Píldoras",
    'tabs.style.underline': "Subrayado",
    'tabs.style.classic': "Clásico",
    'tabs.style.previewFirst': "Mensual",
    'tabs.style.previewSecond': "Anual",
    'marquee.pause': "Pausa",
    'widget.tabs': "Pestañas",
    'widget.popover': "Popover",
    'reviews.perRow': "Por fila",
    'carousel.position': "Posición",
    'faq.questionAndMarker': "Pregunta y signo",
    'faq.questions': "Preguntas",
    'popover.presentation': "Presentación",
    'gallery.ratio': "Proporción",
    'nav.currentPage': "Página actual",
    'list.remove': "Quitar",
    'image.remove': "Quitar la imagen",
    'reviews.clampTo': "Recortar a",
    'reviews.reviews': "Reseñas",
    'tabs.selectOnCanvas': "Seleccionarlo en el lienzo",
    'faq.marker': "Signo",
    'carousel.snap': "Snap",
    'carousel.items': "Tarjetas",
    'carousel.itemsCount': "{count} en el carril",
    'carousel.itemN': "Tarjeta {n}",
    'carousel.addCard': "Agregar tarjeta",
    'carousel.addImages': "Agregar fotos",
    'carousel.perView': "Visibles a la vez",
    'nav.sticky': "Sticky",
    'list.moveUp': "Subir",
    'tabs.tabs': "Tabs",
    'faq.markerSize': "Tamaño del signo",
    'slider.controls': "Flechas y puntos",
    'slider.controlsInside': "Sobre la tarjeta",
    'slider.controlsOutside': "Fuera de la tarjeta",
    'slider.slideN': "Diapositiva {n}",
    'slider.moveUp': "Subir",
    'slider.moveDown': "Bajar",
    'slider.duplicate': "Duplicar",
    'slider.remove': "Borrar",
    'slider.transition': "Transición",
    'countdown.units': "Unidades",
    'marquee.shape': "Forma",
    'marquee.shape.line': "Línea",
    'marquee.shape.wheel': "Rueda",
    'marquee.shape.orbit': "Círculo",
    'marquee.gap': "Separación",
    'marquee.cardWidth': "Ancho de tarjeta",
    'marquee.curve': "Curva",
    'marquee.clip': "Recortar en la sección",
    'marquee.clipInfo': "Corta las tarjetas en el borde de la sección, no en el del bloque: siguen la curva hasta abajo sin salirse a la sección de al lado.",
    'marquee.speed': "Velocidad",
    'list.moveUpNamed': "Subir {name}",
    'list.moveDownNamed': "Bajar {name}",
    'list.removeNamed': "Quitar {name}",
    'faq.addQuestion': "Agregar pregunta",
    'reviews.add': "Añadir reseña",
    'slider.next': "Siguiente",
    'slider.add': "Agregar",
    'tabs.addPanel': "Agregar panel",
    'faq.cmsHint': "Para soltarla, selecciónala en el lienzo y usa el botón del CMS.",
    'faq.cmsBoth': "La pregunta y la respuesta salen del CMS.",
    'faq.cmsQuestion': "La pregunta sale del CMS; la respuesta es la de aquí.",
    'faq.cmsAnswer': "La respuesta sale del CMS; la pregunta es la de aquí.",
    'faq.startsOpen': "Empieza abierta",
    'gallery.pickImages': "Elegir imágenes",
    'gallery.imagesCount': "{count} imágenes",
    'gallery.imageOne': "1 imagen",
    'reviews.one': "1 reseña",
    'opt.bottom': "Abajo",
    'opt.atEnd': "Al final",
    'opt.atStart': "Al principio",
    'opt.appears': "Aparece",
    'opt.top': "Arriba",
    'opt.sidebar': "Barra lateral",
    'opt.change': "Cambiar",
    'opt.carousel': "Carrusel",
    'opt.center': "Centro",
    'faq.closeOthers': "Cerrar las demás",
    'opt.click': "Click",
    'opt.compact': "Compacto",
    'opt.withLine': "Con línea",
    'opt.crossfade': "Cruzar",
    'opt.square': "Cuadrada",
    'faq.keepOpen': "Dejarlas abiertas",
    'opt.right': "Der.",
    'opt.slide': "Deslizar",
    'opt.dropdown': "Desplegable",
    'opt.expandBelow': "Desplegar debajo",
    'opt.fade': "Desvanecer",
    'opt.days': "Días",
    'opt.chooseFem': "Elige una",
    'opt.chooseMasc': "Elige uno",
    'opt.slideIn': "Entra deslizando",
    'opt.arrow': "Flecha",
    'opt.background': "Fondo",
    'opt.hours': "Horas",
    'opt.horizontal': "Horizontal",
    'opt.horizontal43': "Horizontal (4:3)",
    'opt.hover': "Hover",
    'opt.left': "Izq.",
    'opt.eachImage': "La de cada imagen",
    'opt.underline': "Línea inferior",
    'opt.minutes': "Min",
    'gallery.myImages': "Mis imágenes",
    'gallery.offerImages': "Fotos de la oferta",
    'gallery.showAll': "Mostrar todas (rejilla)",
    'gallery.rail': "Rail con flechas",
    'gallery.skip': "Omitir primeras fotos",
    'opt.modal': "Modal",
    'opt.plus': "Más (+)",
    'opt.mobile': "Móvil",
    'opt.nothing': "Nada",
    'opt.noneMasc': "Ninguno",
    'opt.no': "No",
    'opt.doNothing': "No hacer nada",
    'opt.hide': "Ocultar",
    'opt.other': "Otra…",
    'opt.drawer': "Panel lateral",
    'opt.fullscreen': "Pantalla",
    'opt.screenFull': "Pantalla",
    'opt.popup': "Popup",
    'opt.page': "Página",
    'tabs.removePanel': "Quitar este panel y su botón",
    'opt.grid': "Rejilla",
    'opt.seconds': "Seg",
    'opt.noAnimation': "Sin animación",
    'slider.noSlides': "Sin diapositivas",
    'opt.noLine': "Sin línea",
    'reviews.noRating': "Sin puntuación",
    'opt.yes': "Sí",
    'opt.tablet': "Tablet",
    'opt.card': "Tarjeta",
    'opt.highlightedText': "Texto resaltado",
    'gallery.cmsField': "Un campo del CMS",
    'gallery.cmsChooseCollection': "Elige una colección",
    'gallery.cmsChooseCollectionBody': "Esta galería enseña las fotos de una colección del CMS. Elige cuál.",
    'gallery.cmsChooseField': "Elige un campo",
    'gallery.cmsChooseFieldBody': "Elige el campo de imágenes cuyas fotos enseña esta galería.",
    'gallery.cmsOpenSettings': "Abrir ajustes",
    'gallery.offer': "Oferta",
    'gallery.pageOffer': "La de esta página",
    'gallery.chooseOffer': "Elige una oferta",
    'gallery.chooseOfferBody': "Esta galería enseña las fotos de una oferta. Elige cuál.",
    'opt.stacked': "Una debajo de otra",
    'tabs.needOnePanel': "Unas pestañas necesitan al menos un panel",
    'gallery.lightbox': "Verla en grande",
    'opt.vertical': "Vertical",
    'opt.vertical34': "Vertical (3:4)",
    'reviews.count': "{count} reseñas",
    'reviews.untitled': "Reseña {n}",
    'slider.position': "{current} de {total}",
    'panels.backToStyles': "Volver a Estilos",
    'panels.globalEditor': "Editor global",
    'panels.scrollLeft': "Desplazar a la izquierda",
    'panels.scrollRight': "Desplazar a la derecha",
    'panels.inUse': "En uso",
    'common.default': "Por defecto",
    'type.weight': "Peso",
    'type.align': "Alineación",
    'type.uppercase': "Mayúsculas",
    'common.style': "Estilo",
    'type.italic': "Cursiva",
    'type.underline': "Subrayado",
    'type.strikethrough': "Tachado",
    'type.font': "Fuente",
    'type.textColor': "Color de texto",
    'type.textSize': "Tamaño de texto",
    'box.paddingY': "Padding vertical",
    'box.paddingX': "Padding horizontal",
    'box.background': "Fondo",
    'box.border': "Borde",
    'box.borderOpacity': "Opacidad del borde",
    'box.allSides': "Todos",
    'opt.rightFull': "Derecha",
    'opt.leftFull': "Izquierda",
    'box.radius': "Radio",
    'box.shadow': "Sombra",
    'box.shadowBlur': "Blur de sombra",
    'box.shadowX': "Sombra X",
    'box.shadowY': "Sombra Y",
    'box.spacing': "Espaciado",
    'nav.identity': "Identidad",
    'common.type': "Tipo",
    'nav.company': "Empresa",
    'image.alt': "Alt imagen",
    'panels.visualStyle': "Estilo visual",
    'common.color': "Color",
    'nav.items': "Items",
    'nav.separator': "Separador",
    'nav.showCta': "Mostrar CTA",
    'common.text': "Texto",
    'common.link': "Enlace",
    'nav.inheritsFromButtons': "Hereda de Componentes → Botones",
    'nav.background': "Fondo del nav",
    'common.image': "Imagen",
    'image.url': "URL de imagen",
    'nav.transparency': "Transparencia",
    'panels.behavior': "Comportamiento",
    'footer.legalSocial': "Legal y social",
    'footer.copyright': "Copyright",
    'footer.social': "Redes sociales",
    'common.logo': "Logo",
    'common.content': "Contenido",
    'form.required': "Requerido",
    'form.control': "Control",
    'form.accent': "Acento",
    'common.size': "Tamaño",
    'icon.library': "Librería",
    'icon.stroke': "Línea",
    'box.box': "Caja",
    'image.view': "Vista de imagen",
    'image.focus': "Foco",
    'image.frameCrop': "Encuadre y recorte",
    'image.aspectRatio': "Proporción",
    'image.shape': "Forma",
    'image.shapeAuto': "Automática",
    'image.shapeAutoHint': "La de la foto",
    'image.shapeFill': "Llenar el espacio",
    'image.shapeFillHint': "El alto de su caja",
    'image.shapeVertical': "Vertical",
    'image.shapeHorizontal': "Horizontal",
    'image.fit': "Encaje",
    'image.fitCrop': "Recortar para llenar",
    'image.fitShowWhole': "Mostrar completa",
    'size.hintAuto': "Ocupa lo que le deje su caja.",
    'size.hintColumns': "Cuántas columnas de la cuadrícula ocupa.",
    'size.hintManual': "Una parte del ancho de su caja.",
    'image.ratioCurrent': "Actual",
    'image.ratioOriginal': "Original",
    'image.ratioUnconstrained': "Libre",
    'image.ratioFree': "Quitar proporción",
    'veil.title': "Velo",
    'veil.style': "Estilo",
    'bg.anchoredLabel': "Fondo",
    'bg.colorFromStyle': "El color lo pone el estilo de este bloque. La foto y el vídeo de fondo sí se cambian aquí.",
    'bg.advancedLayers': "Capas avanzadas",
    'bg.imageRow': "Imagen de fondo",
    'bg.imageOff': "Desactivada",
    'bg.autoCover': "Automática",
    'bg.backToAuto': "Volver a la foto automática",
    'veil.none': "Ninguno",
    'veil.bottom': "Sombra abajo",
    'veil.even': "Velo parejo",
    'veil.edges': "Arriba y abajo",
    'veil.tint': "Tinte de marca",
    'veil.gradient': "Degradado",
    'veil.strength': "Intensidad",
    'veil.strengthTo': "Intensidad final",
    'veil.color': "Color",
    'veil.colors': "Colores",
    'veil.from': "Desde",
    'veil.to': "Hasta",
    'veil.direction': "Dirección",
    'veil.start': "Empieza en",
    'veil.band': "Ancho de la franja",
    'veil.edges.vertical': "Arriba y abajo",
    'veil.edges.sides': "A los lados",
    'veil.remove': "Quitar velo",
    'veil.dir.down': "Hacia abajo",
    'veil.dir.up': "Hacia arriba",
    'veil.dir.right': "Hacia la derecha",
    'veil.dir.left': "Hacia la izquierda",
    'veil.dir.radial': "Desde el centro",
    'image.ratio.square': "Cuadrada",
    'image.ratio.portrait': "Retrato",
    'image.ratio.classicTall': "Clásica vertical",
    'image.ratio.photoTall': "Foto vertical",
    'image.ratio.story': "Historia",
    'image.ratio.classic': "Clásica",
    'image.ratio.photo': "Foto",
    'image.ratio.wide': "Panorámica",
    'image.ratio.cinema': "Cine",
    'image.ratioHint': "La forma del marco en la página. Las medidas son un ejemplo para exportar la foto con esa forma.",
    'image.cropReposition': "Recortar y reposicionar",
    'image.crop': "Recortar",
    'image.cropHint': "Arrastra la foto dentro del marco. Ajusta el recorte con el zoom.",
    'image.cropZoom': "Zoom",
    'image.cropReset': "Restablecer recorte",
    'image.cropApply': "Aplicar",
    'preview.card': "Preview de tarjeta",
    'card.surface': "Superficie",
    'preview.testimonial': "Preview de testimonio",
    'preview.badge': "Preview de badge",
    'footer.rights': "© 2026 Veltica. Todos los derechos reservados.",
    'border.solid': "Sólido",
    'border.dashed': "Discontinuo",
    'border.dotted': "Punteado",
    'border.center': "Centrado",
    'border.inside': "Dentro",
    'border.outside': "Fuera",
    'box.shadowSpread': "Extensión",
    'common.preview': "Vista previa",
    'icon.set': "Juego",
    'badge.dot': "Punto",
    'badge.uppercase': "Mayúsculas",
    'nav.shrinkOnScroll': "Encoger al bajar",
    'card.hoverLift': "Levantar al pasar",
    'testimonial.autoplay': "Pasar solo",
    'type.addStyle': "Agregar estilo",
    'panels.moreOptions': "Opciones adicionales",
    'badge.new': "Nuevo",
    'border.none': "Sin borde",
    'type.sansModern': "Sans / Moderno",
    'type.script': "Cursivas",
    'type.serifClassic': "Serif / Clásico",
    'type.uppercaseSample': "MAYÚSCULAS",
    'type.lowercaseSample': "minúsculas",
    'type.capitalize': "Capitalizar",
    'type.noTransform': "Sin transformar",
    'nav.sampleHome': "Inicio",
    'nav.sampleServices': "Servicios",
    'nav.sampleAbout': "Nosotros",
    'nav.sampleContact': "Contacto",
    'nav.sampleCta': "Comenzar",
    'cmp.overrides': "{count} cambiados",
    'cmp.overrideOne': "1 cambiado",
    'filter.all': "Todos",
    'filter.modern': "Moderno",
    'filter.elegant': "Elegante",
    'filter.warm': "Cálido",
    'filter.dark': "Nocturno",
    'logo.altDefault': "Logo de empresa",
    'logo.footerAlt': "Logo del footer",
    'footer.colCompany': "Empresa",
    'footer.colProduct': "Producto",
    'footer.colResources': "Recursos",
    'footer.colLegal': "Legal",
    'footer.sampleLinks': "Enlace 1\\nEnlace 2\\nEnlace 3",
    'bp.desktop': 'Desktop',
    'bp.tablet': 'iPad',
    'bp.mobile': 'Móvil',
    'bp.editingFor': "Editando para",
    'form.errorLabel': "Error",
    'type.lowercase': "minúsculas",
    'cmp.components': "Componentes",
    'logo.typeText': "Texto",
    'logo.typeImage': "Imagen",
    'form.label': "Label",
    'el.section': "Section",
    'el.bloque': "Bloque",
    'el.texto': "Texto",
    'el.titulo-destacado': "Título destacado",
    'el.imagen': "Imagen",
    'el.icono': "Icono",
    'el.badge': "Badge",
    'el.rating': "Rating",
    'el.avatares': "Avatares",
    'el.stat': "Stat",
    'el.boton': "Botón",
    'el.link': "Link",
    'el.navegacion': "Navegación",
    'el.marca': "Marca",
    'el.logo-marca': "Logo marca",
    'el.nombre-de-marca': "Nombre de marca",
    'el.menu-principal': "Menú principal",
    'el.acciones-de-navegacion': "Acciones de navegación",
    'el.boton-primario': "Botón primario",
    'el.seccion-hero': "Sección hero",
    'el.contenido-hero': "Contenido hero",
    'el.etiqueta-hero': "Etiqueta hero",
    'el.titulo-principal': "Título principal",
    'el.parrafo-hero': "Párrafo hero",
    'el.botones-hero': "Botones hero",
    'el.boton-secundario': "Botón secundario",
    'el.prueba-social': "Prueba social",
    'el.rating-hero': "Rating hero",
    'el.texto-de-prueba-social': "Texto de prueba social",
    'el.visual-hero': "Visual hero",
    'el.efecto-visual': "Efecto visual",
    'el.imagen-hero': "Imagen hero",
    'el.tarjeta-metrica': "Tarjeta métrica",
    'el.seccion-servicios': "Sección servicios",
    'el.encabezado-servicios': "Encabezado servicios",
    'el.etiqueta-servicios': "Etiqueta servicios",
    'el.titulo-servicios': "Título servicios",
    'el.grid-de-servicios': "Grid de servicios",
    'el.seccion-cta': "Sección CTA",
    'el.bloque-cta': "Bloque CTA",
    'el.contenido-cta': "Contenido CTA",
    'el.titulo-cta': "Título CTA",
    'el.parrafo-cta': "Párrafo CTA",
    'el.boton-cta': "Botón CTA",
    'el.footer': "Footer",
    'el.seccion': "Sección",
    'el.titulo-1': "Título 1",
    'el.titulo-2': "Título 2",
    'el.titulo-3': "Título 3",
    'el.titulo-4': "Título 4",
    'el.titulo-5': "Título 5",
    'el.titulo-6': "Título 6",
    'el.parrafo': "Párrafo",
    'el.etiqueta': "Etiqueta",
    'el.tarjeta': "Tarjeta",
    'panels.nothingSelected': "Nada seleccionado",
    'panels.clickAnElement': "Haz clic en un elemento del canvas.",
    'panels.propGroups': "Grupos de propiedades",
    'panels.aiAssistant': "Asistente AI",
    'panels.switchToSimple': "Cambiar al modo esencial",
    'panels.simpleMode': "Modo esencial",
    'panels.simpleModeHint': "Barra contextual, sin inspector.",
    'panels.globalStyle': "Estilo global",
    'panels.manyElements': "{count} elementos",
    'el.pagina': "Página",
    'cms.openInEditorLong': "Abrir en el editor",
    'cms.actions': "Acciones",
    'cms.bulkActions': "Acciones sobre lo seleccionado",
    'cms.addImagesHint': "Agrega una o varias imágenes a este contenido",
    'cms.addField': "Agregar propiedad",
    'cms.seoSettings': "Ajustes de SEO",
    'cms.pageSettings': "Ajustes de página",
    'cms.previous': "Anterior",
    'cms.dragField': "Arrastra para mover el campo",
    'cms.dragColumn': "Arrastra para mover la columna",
    'cms.ascending': "Ascendente",
    'cms.add': "Añadir",
    'cms.addOrChangeImages': "Añadir o cambiar imágenes",
    'cms.search': "Buscar",
    'cms.searchCollection': "Buscar en la colección",
    'cms.searchOrCreateCategory': "Buscar o crear categoría",
    'cms.searchOrCreateOption': "Buscar o crear opción",
    'cms.rename': "Cambiar el nombre",
    'cms.changeIconColor': "Cambiar icono y color",
    'cms.fieldDuplicated': "Campo duplicado",
    'cms.fieldDeleted': "Campo eliminado",
    'cms.categoryDeleted': "Categoría eliminada",
    'cms.closePanel': "Cerrar panel",
    'cms.collections': "Colecciones",
    'cms.contentCollections': "Contenido",
    'cms.color': "Color",
    'cms.hiddenColumns': "Columnas ocultas",
    'cms.copyId': "Copiar ID",
    'cms.createFirst': "Crea el primero para comenzar.",
    'cms.created': "Creado",
    'cms.create': "Crear",
    'cms.descending': "Descendente",
    'cms.postDetail': "Detalle del post",
    'cms.duplicate': "Duplicar",
    'cms.editCollection': "Editar colección",
    'cms.pickDate': "Elegir fecha",
    'cms.itemCreated': "Elemento CMS creado",
    'cms.itemDuplicated': "Elemento CMS duplicado",
    'cms.itemDeleted': "Elemento CMS eliminado",
    'cms.itemSaved': "Elemento CMS guardado",
    'cms.itemToDraft': "Elemento CMS movido a borrador",
    'cms.itemPublished': "Elemento CMS publicado",
    'cms.inDraft': "Elemento en borrador",
    'cms.isPublished': "Elemento publicado",
    'cms.writeContent': "Escribe el contenido del post…",
    'cms.invalidLink': "Escribe un enlace válido",
    'cms.cannotUndo': "Esta acción no se puede deshacer.",
    'cms.status': "Estado",
    'cms.publishStatus': "Estado de publicación",
    'cms.date': "Fecha",
    'cms.filters': "Filtros",
    'cms.finish': "Finalizar",
    'cms.saved': "Guardado",
    'cms.clickToEdit': "Haz clic para editar",
    'cms.time': "Hora",
    'cms.endTime': "Hora de finalización",
    'cms.startTime': "Hora de inicio",
    'cms.idCopied': "ID de la colección copiado",
    'cms.collectionIconColor': "Icono y color de la colección",
    'cms.image': "Imagen",
    'cms.insert': "Insertar",
    'cms.insertImage': "Insertar imagen",
    'cms.insertLink': "Insertar link",
    'cms.insertYouTube': "Insertar video de YouTube",
    'cms.urlRequired': "La URL no puede quedar vacía",
    'cms.countryCode': "Lada del país",
    'cms.clear': "Limpiar",
    'cms.list': "Lista",
    'cms.modified': "Modificado",
    'cms.showLess': "Mostrar menos",
    'cms.showFewerImages': "Mostrar menos imágenes",
    'cms.showAll': "Mostrar todas",
    'cms.bold': "Negrita",
    'cms.idCopyFailed': "No se pudo copiar el ID",
    'cms.linkCopyFailed': "No se pudo copiar el enlace",
    'cms.name': "Nombre",
    'cms.columnName': "Nombre de la columna",
    'cms.fieldNameOrType': "Nombre o tipo de propiedad",
    'cms.newPost': "Nuevo post",
    'pgnav.collectionOwnDesign': 'Propio',
    'designs.collectionScope': 'Aplicar a',
    'designs.collectionScope.all': 'Todas',
    'designs.collectionScope.one': 'Solo «{name}»',
    'designs.collectionUseShared': 'Volver al diseño general',
    'designs.collectionOwnHint': '«{name}» tiene su propio diseño: los cambios aquí sólo le afectan a ella.',
    'cms.cardLook': "Tarjetas",
    'cms.direction': "Dirección",
    'cms.fieldOf': "Campo de {name}",
    'cms.fieldMissing': "Campo que no existe aquí · elige otro",
    'schedule.always': "Siempre",
    'cms.tab.items': "Elementos",
    'cms.tab.content': "Contenido",
    'cms.tab.design': "Diseño",
    'cms.which': "Cuáles",
    'cms.which.latest': "Las más recientes",
    'cms.which.manual': "Elegir a mano",
    'cms.which.picked': "Elegidas",
    'cms.which.pickedCount': "{n} elegidas · cambiar",
    'cms.order.newest': "Más recientes primero",
    'cms.order.oldest': "Más antiguas primero",
    'cms.order.az': "A → Z",
    'cms.order.za': "Z → A",
    'cms.order.byDateNew': "{name}: más reciente primero",
    'cms.order.byDateOld': "{name}: más antigua primero",
    'cms.onlyPublished': "Sólo publicadas",
    'cms.noDesignHere': "Esta lista no tiene tarjetas que diseñar.",
    'cms.pick.title': "Elegir de {name}",
    'cms.pick.search': "Buscar por título…",
    'cms.pick.published': "Publicada",
    'cms.pick.empty': "Esta colección aún no tiene entradas.",
    'cms.sortCreated': "Fecha de creación",
    'cms.blogField.title': "Título",
    'cms.blogField.excerpt': "Extracto",
    'cms.blogField.image': "Portada",
    'cms.blogField.content': "Contenido",
    'cms.blogField.author': "Autor",
    'cms.blogField.date': "Fecha",
    'cms.blogField.categories': "Categorías",
    'cms.blogField.readingTime': "Tiempo de lectura",
    'cms.blogField.authorAvatar': "Foto del autor",
    'cms.blogField.slug': "Dirección (slug)",
    'cms.cardColumnsAuto': "Del diseño",
    'cms.cardAlignAuto': "Del diseño",
    'cms.listSettings': "Ajustes de la lista",
    'cms.newEntry': "Nueva entrada",
    'cms.phoneNumber': "Número de teléfono",
    'cms.fieldOptions': "Opciones de la propiedad",
    'cms.moveToDraft': "Pasar a borrador",
    'cms.pasteCode': "Pega HTML, CSS o JavaScript",
    'cms.pasteVideoHint': "Pega el enlace del video y se insertará como reproductor.",
    'cms.pasteYouTube': "Pega la URL de YouTube",
    'cms.pasteImageUrl': "Pega la URL de la imagen",
    'cms.postDuplicated': "Post duplicado",
    'cms.posts': "Posts",
    'cms.primary': "Principal",
    'cms.fieldAdded': "Propiedad añadida",
    'cms.fieldAddedImage': "Propiedad añadida. La imagen alimenta la miniatura de la fila.",
    'cms.fieldDuplicatedToast': "Propiedad duplicada",
    'cms.fieldDeletedToast': "Propiedad eliminada",
    'cms.tryAnotherSearch': "Prueba con otro texto u otro filtro.",
    'cms.publish': "Publicar",
    'cms.clearSelection': "Quitar la selección",
    'cms.hiddenInTable': "Se ocultó en la tabla",
    'cms.pickOrCreate': "Selecciona o crea una colección.",
    'cms.pickCollection': "Selecciona una colección",
    'cms.selectAllVisible': "Seleccionar todo lo que se ve",
    'cms.next': "Siguiente",
    'cms.noDate': "Sin fecha",
    'cms.noPosts': "Sin posts",
    'cms.noResults': "Sin resultados",
    'cms.noContentYet': "Todavía no hay contenido.",
    'cms.all': "Todos",
    'cms.imageUrl': "URL de la imagen",
    'cms.urlOrPath': "URL o /ruta",
    'cms.empty': "Vacío",
    'cms.deletePostConfirm': "¿Eliminar este post?",
    'cms.deleteCollectionLead': "Se eliminará la colección junto con sus",
    'cms.deleteCollectionTail': "(listado y detalle). Esta acción no se puede deshacer.",
    'cms.sitePages': "páginas del sitio",
    'cms.categories': "categorías",
    'cms.images': "imágenes",
    'cms.changes': "cambios",
    'cms.createCollection': "Crear colección",
    'cms.createNew': "Crear nuevo",
    'cms.duplicateField': "Duplicar campo",
    'cms.duplicateProperty': "Duplicar propiedad",
    'cms.editInRecord': "Editar en la ficha",
    'cms.deleteField': "Eliminar campo",
    'cms.deleteProperty': "Eliminar propiedad",
    'cms.insertRight': "Insertar a la derecha",
    'cms.insertLeft': "Insertar a la izquierda",
    'cms.hideColumn': "Ocultar columna",
    'cms.hideInTable': "Ocultar en la tabla",
    'cms.sort': "Ordenar",
    'cms.emptyIt': "Vaciar",
    'cms.itemOne': "elemento",
    'cms.itemMany': "elementos",
    'cms.noOptionsYet': "Todavía no hay {kind}. Escribe una arriba para crear la primera.",
    'cms.andMore': "y {count} más…",
    'cms.willDelete': "Se borrarán {count} elementos:",
    'cms.willDeleteOne': "Se borrará 1 elemento:",
    'cms.paragraph': "Párrafo",
    'cms.emptyCell': "Vacío",
    'cms.showNImages': "Mostrar las {count} imágenes",
    'cms.manyPublished': "{count} elementos publicados",
    'cms.manyToDraft': "{count} elementos en borrador",
    'cms.manyDeleted': "{count} elementos eliminados",
    'cms.imageOne': "{count} imagen · Arrastra para ordenar",
    'cms.imagesCount': "{count} imágenes · Arrastra para ordenar",
    'cms.seeNImages': "Ver las {count} imágenes",
    'cms.manyDuplicated': "{count} elementos duplicados",
    'shell.backToDashboard': "Regresar al dashboard",
    'shell.publishSite': "Publicar sitio",
    'shell.publishTemplate': "Publicar template",
    'shell.newPage': "Nueva página",
    'shell.canvasWidth': "Ancho del lienzo",
    'shell.fitMode': "Modo de ajuste",
    'shell.fitModeHint': "Se ajusta al ancho de la ventana automáticamente.",
    'shell.zoomHint': "Arrastra para ajustar el zoom · clic para más opciones",
    'shell.zoomDesktopOnly': "Zoom disponible solo en desktop",
    'shell.velticaMenu': "Menú de véltica",
    'shell.userSettings': "Ajustes de usuario",
    'shell.account': "Cuenta",
    'shell.billing': "Facturación",
    'shell.signOut': "Cerrar sesión",
    'shell.editorColor': "Color del editor",
    'shell.advancedOptions': "Opciones avanzadas",
    'shell.fullRightPanel': "Panel completo a la derecha",
    'shell.advancedLargeOnly': "Sólo en pantallas grandes",
    'shell.contextBar': "Barra contextual al seleccionar",
    'elements.search': "Buscar elemento",
    'elements.searchPlaceholder': "Buscar elemento…",
    'elements.type': "Tipo de elementos",
    'elements.seeAll': "Ver todos",
    'elements.seeAllElements': "Ver todos los elementos",
    'elements.onlyFavorites': "Ver sólo los favoritos",
    'elements.onlyMyFavorites': "Ver sólo mis favoritos",
    'elements.noFavorites': "Sin favoritos",
    'elements.favoritesHint': "Marca la estrella de cualquier elemento para tenerlo a mano aquí.",
    'elements.favoritesFilterHint': "Marca la estrella de un elemento para poder filtrarlos",
    'elements.dragHint': "Arrastra un bloque al canvas.",
    'elements.brand': "Estilo",
    'elements.brandStyle': "Estilo de marca",
    'elements.components': "Componentes",
    'elements.media': "Multimedia",
    'elements.layout': "Layout",
    'elements.interaction': "Interacción",
    'layers.expandAll': "Abrir todas las capas",
    'layers.collapseAll': "Colapsar todas las capas",
    'layers.empty': "Sin elementos",
    'layers.siteNav': 'Nav',
    'layers.siteFooter': 'Footer',
    'layers.addNav': 'Agregar nav',
    'layers.addFooter': 'Agregar footer',
    'layers.hiddenHere': 'oculto en esta página',
    'layers.sharedHint': 'Se comparte en todas las páginas',
    'layers.pageSettings': 'Ajustes de la página',
    'layers.lock': "Bloquear elemento",
    'layers.unlock': "Desbloquear elemento",
    'layers.show': "Mostrar en el canvas",
    'layers.hide': "Ocultar del canvas",
    'layers.boundToBlock': "Asociado al bloque",
    'layers.reusableHint': "Sección reutilizable: lo que cambies aquí cambia en todas las páginas donde esté",
    'layers.hardcodedColor': "Usa un color hardcodeado o un token personalizado: no se adaptará al colocar el template. Cámbialo a un token del tema (Primario, Texto, etc.).",
    'search.section': "sección contenedor layout fila columna espacio",
    'search.div': "bloque caja contenedor flex stack",
    'search.grid': "cuadrícula columnas filas layout",
    'search.image': "foto fotografía multimedia visual",
    'search.form': "contacto newsletter campos correo mensaje input",
    'search.navbar': "menú navegación header cabecera links",
    'search.footer': "pie navegación enlaces legal",
    'search.slider': "carrusel slideshow galería slides",
    'search.cardRail': "carrusel slider tarjetas",
    'search.testimonial': "testimonio review opinión reseña",
    'search.stat': "dato número métrica estadística",
    'search.countdown': "contador fecha evento lanzamiento",
    'search.embed': "código html iframe video youtube",
    'elements.text': "Texto",
    'elements.forms': "Formularios",
    'elements.navigation': "Navegación",
    'elements.cms': 'CMS',
    'elements.shop': "Comprar",
    'elements.blog': "Blog",
    'bp.blogGrid': "Últimas entradas",
    'bp.blogList': "Lista de entradas",
    'bp.blogFeatured': "Entrada destacada",
    'elements.catalog': 'Catálogo',
    /* Los mandos de un bloque de catálogo; ver `CatalogGroup`. */
    'catalog.manageShort': "Gestionar ofertas",
    'contentPanel.title': "Contenido",
    'catalogPanel.title': "Catálogo",
    'blogPanel.title': "Blog",
    'collectionsPanel.title': "Contenido",
    'collectionsPanel.desc': "Tus colecciones del CMS: ponlas en la página como lista o una entrada sola.",
    'collectionsPanel.emptyTitle': "Aún no tienes contenido",
    'collectionsPanel.emptyHint': "Una colección guarda cosas parecidas (gatos en adopción, proyectos, equipo) y las enseña en tu sitio con el diseño que elijas.",
    'collectionsPanel.create': "Nueva colección",
    'collectionsPanel.entriesTitle': "Entradas",
    'collectionsPanel.editContent': "Editar contenido",
    'collectionsPanel.newEntry': "Nueva entrada",
    'collectionsPanel.specific': "Contenido específico",
    'collectionsPanel.editEntry': "Editar la entrada",
    'collectionsPanel.noEntries': "Esta colección no tiene entradas todavía.",
    'blogPanel.desc': "Tus entradas: arrástralas a la página o pulsa + para ponerlas.",
    'blogPanel.viewPageHint': "Todas las entradas comparten el mismo diseño.",
    'blogPanel.art.cta': "Leer más",
    'blogPanel.group.lists': "Listas de entradas",
    'blogPanel.group.posts': "Entradas",
    'blogPanel.layout.latest-grid': "Rejilla",
    'blogPanel.layout.latest-list': "Lista",
    'blogPanel.layout.latest-featured': "Destacada y dos",
    'blogPanel.layout.hero-split': "Dividido",
    'blogPanel.layout.hero-cover': "Portada de fondo",
    'blogPanel.layout.hero-center': "Centrado",
    'blogPanel.layout.post-card': "Tarjeta",
    'blogPanel.published': "Publicada",
    'blogPanel.write': "Escribir en el panel",
    'blogPanel.noDate': "Sin fecha",
    'blogPanel.new': "Nueva entrada",
    'blogPanel.newHint': "El texto completo se escribe después en el panel.",
    'blogPanel.emptyTitle': "Comparte lo que sabes",
    'blogPanel.emptyHint': "Crea tu primera entrada con su título y portada. El texto lo escribes después.",
    'blogPanel.createFirst': "Crear mi primera entrada",
    'blogPanel.postTitle': "Título",
    'blogPanel.titlePlaceholder': "Ej. 5 consejos para empezar",
    'blogPanel.excerpt': "Resumen",
    'blogPanel.excerptPlaceholder': "De qué trata, en una o dos frases…",
    'blogPanel.addCover': "Añadir portada",
    'blogPanel.previewTitle': "Título de tu entrada",
    'blogPanel.previewExcerpt': "Aquí va el resumen: de qué trata la entrada.",
    'blogPanel.createFailed': "No se pudo crear. Inténtalo de nuevo.",
    'blogPanel.pendingHint': "Se crea «Por completar»: no se publica hasta que escribas el texto en el panel.",
    'blogPanel.create': "Crear entrada",
    'bp.postCover': "Portada de la entrada",
    'bp.postDate': "Fecha de la entrada",
    'bp.postTitle': "Título de la entrada",
    'bp.postExcerpt': "Resumen de la entrada",
    'bp.posts': "Entradas",
    'bp.blogSection': "Blog",
    'bp.blogHeading': "Título del blog",
    'bp.collectionHeading': "Título de la colección",
    'bp.postCard': "Tarjeta de entrada",
    'bp.postsGrid': "Entradas",
    'bp.readMore': "Leer más",
    'sample.latestPosts': "Últimas entradas",
    'sample.post.date': "12 de marzo",
    'sample.post.title': "Título de la entrada",
    'sample.post.excerpt': "Un resumen breve de la entrada.",
    'catalogPanel.yours': "Tu catálogo",
    'catalogPanel.yoursHint': "Tus ofertas como secciones",
    'catalogPanel.changeOffer': "Cambiar oferta",
    'catalogPanel.desc': "Tus ofertas: arrástralas a la página o pulsa + para ponerlas.",
    'catalogPanel.kinds': "Tipos de oferta",
    'catalogPanel.all': "Todas",
    'catalogPanel.kind.services': "Servicio",
    'catalogPanel.kind.bookings': "Reserva",
    'catalogPanel.kind.digital': "Digital",
    'catalogPanel.kind.products': 'Producto',
    'catalogPanel.new': "Nueva oferta",
    'catalogPanel.add': 'Agregar',
    'catalogPanel.listSettings': "Lista del catálogo",
    'catalogPanel.group.offers': 'Ofertas',
    'catalogPanel.group.lists': "Listas de ofertas",
    'catalogPanel.list.newest': 'Lo más nuevo',
    'catalogPanel.list.bestselling': 'Más vendidos',
    'catalogPanel.list.all': 'Todo el catálogo',
    'catalogPanel.list.free': 'Gratis',
    'catalogPanel.list.carousel': 'Carrusel',
    'catalogPanel.list.compact': 'Lista compacta',
    'sample.offers.newest': 'Novedades',
    'sample.offers.bestselling': 'Los más vendidos',
    'sample.offers.all': 'Nuestro catálogo',
    'sample.offers.free': 'Gratis',
    'sample.offers.carousel': 'Destacados',
    'sample.offers.compact': 'Nuestras ofertas',
    'bp.catalogHeading': 'Título del catálogo',
    'catalogPanel.free': "Gratis",
    'catalogPanel.viewPageHint': "Todas las ofertas de este tipo comparten el mismo diseño.",
    'catalogPanel.viewPage': "Ver su página en el editor",
    'catalogPanel.moreOptions': "Más opciones",
    'catalogPanel.art.cta.services': "Más información",
    'catalogPanel.art.cta.bookings': "Reservar",
    'catalogPanel.art.cta.digital': "Obtener",
    'catalogPanel.art.cta.products': "Comprar",
    'catalogPanel.live': "A la venta",
    'catalogPanel.complete': "Completar en el panel",
    'catalogPanel.openInDashboard': "Abrir en el panel",
    'catalogPanel.layout.featured': "Destacada",
    'catalogPanel.layout.card': "Tarjeta",
    'catalogPanel.layout.row': "En fila",
    'catalogPanel.layout.grid': "Con las demás",
    'catalogPanel.group.sections': "Secciones",
    'catalogPanel.group.cards': "Tarjetas",
    'catalogPanel.layout.hero-split': "Dividido",
    'catalogPanel.layout.hero-cover': "Foto de fondo",
    'catalogPanel.layout.hero-center': "Centrado",
    'catalogPanel.layout.hero-band': "Foto a la izquierda",
    'catalogPanel.addToPage': "Agregar «{layout}» a la página",
    'catalogPanel.emptyTitle': "Pon lo que vendes en tu página",
    'catalogPanel.emptyHint': "Crea tu primera oferta: un servicio, una reserva o algo digital. La terminas después.",
    'catalogPanel.name': "Nombre",
    'catalogPanel.namePlaceholder': "Ej. Sesión de fotos",
    'catalogPanel.quickShortPlaceholder': "Un resumen breve para la tarjeta de tu oferta.",
    'catalogPanel.quickLongHint': "Se muestra debajo de la sección de compra.",
    'catalogPanel.quickPriceHint': "0 o vacío = Gratis",
    'catalogPanel.quickPendingHint': "Completa la configuración en el panel antes de vender.",
    'catalogPanel.createFailed': "No se pudo crear. Inténtalo de nuevo.",
    'catalogPanel.pendingHint': "Se crea «Por completar»: no se vende hasta que la termines en el panel.",
    'catalogPanel.create': "Crear oferta",
    'catalogPanel.priceHelp': "Vacío o 0, se muestra como gratis.",
    'catalogPanel.priceHelpBooking': "Lo que se cobra por cada cita. Vacío o 0, gratis.",
    'catalogPanel.formTitle': "Nueva oferta",
    'catalogPanel.changeKind': "Cambiar tipo",
    'catalogPanel.optional': "Opcional",
    'catalogPanel.description': "Descripción",
    'catalogPanel.price': "Precio",
    'catalogPanel.pricePerBooking': "Precio por cita",
    'catalogPanel.preview': "Así se verá en tu página",
    'catalogPanel.previewTitle': "Nombre de tu oferta",
    'catalogPanel.previewDescription': "Aquí va la descripción: qué incluye y para quién es.",
    'catalogPanel.addImage': "Añadir imagen",
    'catalogPanel.changeImage': "Cambiar",
    'catalogPanel.removeImage': "Quitar imagen",
    'catalogPanel.pickImage': "Elige una imagen",
    'catalogPanel.done': "Listo",
    'catalogPanel.bookingBody': "Una cita en tu calendario, con su horario.",
    'catalogPanel.kindLead': "Elige qué es y lo dejamos listo para tu página. Lo terminas después en el panel.",
    'catalogPanel.descriptionPlaceholder': "Qué incluye, para quién es…",
    'catalogPanel.image': "Imagen",
    'catalogPanel.imageSource.gallery': "Galería",
    'catalogPanel.imageSource.uploads': "Mis imágenes",
    'catalogPanel.noImages': "No hay imágenes con esa búsqueda.",
    'catalogPanel.noOffersMatch': "No hay ofertas que coincidan con la búsqueda.",
    'catalogPanel.noUploads': "Aún no has subido imágenes.",
    'catalogPanel.upload': "Subir imagen",
    'catalogPanel.createFirst': "Crear mi primera oferta",
    'catalog.fieldOfOffer': "Dato de la oferta",
    'catalog.linksToOffer': "Lleva a la oferta",
    'catalog.field.title': "Nombre",
    'catalog.field.duration': "Duración",
    'catalog.field.cta': "Llamada a la acción",
    'catalog.field.more': "Más información",
    'catalog.field.options': "Opciones (tallas, colores…)",
    'catalog.field.badge': "Distintivo (Nuevo, Agotado…)",
    'catalog.field.brand': "Marca",
    'catalog.field.compareAt': "Precio antes (tachado)",
    'catalog.field.discount': "Descuento (-10%)",
    'catalog.field.stock': "Existencias (Quedan 3)",
    'catalog.field.spots': "Cupo (Hasta 25 personas)",
    'catalog.field.with': "Con quién (equipo)",
    'catalog.field.priceAmount': "Solo el importe ($29)",
    'catalog.field.period': "Periodo (al mes…)",
    'catalog.field.features': "Lo que incluye (lista de viñetas)",
    'catalog.field.type': "Tipo",
    'cms.offersCollection': "Ofertas (catálogo)",
    'catalog.showing': "Enseñando",
    'catalog.pick.title': "Elegir ofertas",
    'catalog.pick.count': "{n} elegidas · en el orden en que las marques",
    'catalog.pick.search': "Buscar por nombre",
    'catalog.pick.all': "Todas",
    'catalog.pick.onlyPicked': "Solo elegidas",
    'catalog.pick.live': "Activa",
    'catalog.pick.noMatch': "Nada coincide con la búsqueda.",
    'catalog.pick.clear': "Quitar todas",
    'catalog.pick.done': "Listo",
    'catalog.pick.picked': "Elegidas",
    'catalog.pick.open': "Elegir ({n})",
    'catalog.pickMode': "Cuáles",
    'catalog.pickMode.auto': "Automáticas",
    'catalog.pickMode.manual': "Elegidas",
    'catalog.pickEmpty': "Todavía no hay ofertas de este tipo.",
    'catalog.pickOverLimit': "{n} elegidas no caben: sube «Máximo» para verlas.",
    'catalog.showingOf': "{shown} de {total}",
    'catalog.manage': "Dar de alta o editar ofertas en el panel",
    'catalog.sort.catalog': "El del catálogo",
    'catalog.sort.priceAsc': "Precio, de menor a mayor",
    'catalog.sort.priceDesc': "Precio, de mayor a menor",
    'catalog.sort.title': "Nombre",
    'catalog.sort.duration': "Duración",
    'catalog.sort.newest': 'Lo más nuevo',
    'catalog.sort.oldest': "Lo más antiguo",
    'catalog.sort.titleAsc': "Nombre: A–Z",
    'catalog.sort.titleDesc': "Nombre: Z–A",
    'catalog.sort.bestselling': 'Más vendidos',
    'catalog.sort.created': 'Fecha de alta',
    'catalog.card.none': "Esta lista no tiene tarjeta que editar.",
    'catalog.card.block': "Bloque",
    'catalog.card.show': "Mostrar",
    'catalog.card.hide': "Ocultar",
    'catalog.card.up': "Subir",
    'catalog.card.down': "Bajar",
    'catalog.card.add': "Añadir dato",
    'catalog.card.remove': "Quitar",
    'catalog.card.edit': "Editar",
    'catalog.card.flatten': 'Piezas en una caja',
    'catalog.card.flattenDo': 'Separar',
    'catalog.card.flattenHint': 'Saca los textos, el precio y los botones de su caja para moverlos uno por uno en el lienzo, también por encima de la foto.',
    'catalog.card.addPick': "Elegir…",
    'catalog.photos.label': "Fotos",
    'catalog.photos.hint': "Con varias fotos: qué pasa al pasar el ratón (en el móvil, deslizar).",
    'catalog.photos.single': "Una sola",
    'catalog.photos.hover': "Cambiar al pasar",
    'catalog.photos.scrub': "Recorrer",
    'catalog.price.paid': "Sólo de pago",
    'catalog.price.free': "Sólo gratis",
    'catalog.offset': "Saltar",
    'catalog.token.default': "Predeterminado",
    'catalog.cardToken': "Tarjeta",
    'catalog.titleToken': "Nombre",
    'catalog.bodyToken': "Descripción",
    'catalog.priceToken': "Precio",
    'catalog.buttonToken': "Botón",
    'catalog.ctaText': "Texto del botón",
    'catalog.ctaTextAuto': "Según la oferta",
    'catalog.emptyText': "Si está vacío",
    'catalog.emptyTextAuto': "Según la familia",
    'catalog.shows': "Enseña",
    'catalog.kindLocked': 'Lo fija esta página: aquí sólo salen las de su tipo.',
    'catalog.kind.all': "Todo el catálogo",
    'catalog.kind.bookings': "Reservas",
    'catalog.kind.digital': "Productos digitales",
    'catalog.kind.products': 'Productos físicos',
    'catalog.kind.memberships': "Membresías",
    'catalog.kind.services': "Servicios",
    'catalog.layout': "Forma",
    'catalog.layout.grid': "Cuadrícula",
    'catalog.layout.list': "Lista",
    'catalog.layout.carousel': "Carrusel",
    'catalog.layout.featured': "Destacada",
    'catalog.featuredOffer': "Oferta",
    'catalog.featuredAutomatic': "Primera disponible",
    'catalog.columns': "Columnas",
    'catalog.columnsVisible': "Visibles a la vez",
    'catalog.limit': "Máximo",
    'catalog.collectionChips': 'Filtros por colección',
    'catalog.collectionChipsInfo': 'Arriba de la lista salen tus colecciones («Todos · Verano · Ofertas») para filtrar. Se crean en el panel, en Catálogo › Colecciones. Se ven en el sitio publicado.',
    'catalog.shopFilters': 'Filtros de tienda',
    'catalog.shopFiltersInfo': 'Arriba de la lista: ordenar y filtrar por marca, talla, color, precio, disponibilidad, duración o con quién. Salen sólo los que tienen sentido con lo que enseña. Se ven en la vista previa y en el sitio publicado.',
    'cms.blogShow': "Mostrar",
    'cms.blogShow.paged': "Con páginas",
    'cms.blogShow.fixed': "Número fijo",
    'cms.perPage': "Entradas por página",
    'cms.cardLayout': 'Diseño',
    'cms.cardLayoutCards': 'Tarjetas',
    'cms.cardLayoutList': 'Lista',
    'cms.listStyle.divided': 'Con líneas',
    'cms.listStyle.plain': 'Sin tarjeta',
    'cms.listStyle.card': 'Tarjeta',
    'cms.mediaSide': 'Lado de la foto',
    'cms.mediaSide.right': 'Derecha',
    'catalog.look.style': 'Estilo',
    'catalog.look.card': 'Tarjeta',
    'catalog.look.minimal': 'Minimal',
    'catalog.look.grid': 'Rejilla con bordes',
    'catalog.look.luxury': 'Luxury',
    'catalog.look.elevated': 'Elevada',
    'catalog.look.cardStyle': 'Estilo de tarjeta',
    'catalog.look.ratio': 'Foto',
    'catalog.look.ratio.auto': 'Como venga',
    'catalog.look.ratio.square': 'Cuadrada (1:1)',
    'catalog.look.ratio.portrait': 'Vertical (4:5)',
    'catalog.look.ratio.tall': 'Alta (3:4)',
    'catalog.look.ratio.landscape': 'Horizontal (4:3)',
    'catalog.look.ratio.wide': 'Panorámica (16:9)',
    'catalog.look.align': 'Texto',
    'catalog.look.align.left': 'Izquierda',
    'catalog.look.align.center': 'Centro',
    'catalog.look.align.right': 'Derecha',
    'catalog.look.cta': 'Botón',
    'catalog.look.compareAt': 'Precio antes',
    'catalog.look.cta.always': 'Siempre',
    'catalog.look.cta.hover': 'Al pasar',
    'catalog.shopFiltersButton': 'Estilo de los filtros',
    'catalog.shopFiltersButtonDefault': 'Contorno (por defecto)',
    'catalog.collectionSource': 'Colección',
    'catalog.collectionSourceAll': 'Todas las ofertas',
    'catalog.perPage': "Por página",
    'catalog.perPageAll': "Todas",
    'catalog.field.image': "Foto",
    'catalog.field.description': "Descripción",
    'catalog.field.price': "Precio",
    'elements.other': "Otros",
    'elements.suggested': "Sugeridos",
    'insert.title': "Añadir elemento",
    'insert.subtitle': "Se coloca después de lo seleccionado",
    'insert.subtitleInside': "Se coloca dentro de lo seleccionado, al final",
    'insert.categories': "Categorías",
    'insert.hintPick': "Elige un elemento para verlo puesto en la página.",
    'insert.hintTrying': "Así queda en la página. Puedes probar otro antes de confirmar.",
    'shell.auto': "Auto",
    'shell.manual': "Manual",
    'insert.basics': "Básicos",
    'insert.mySections': "Mis secciones",
    'insert.reusable': "Reutilizables",
    'insert.saved': "Guardados",
    'elements.noResults': "Sin resultados para «{query}».",
    'layers.addSection': "Agregar",
    'layers.addFirstSection': 'Agregar sección',
    'shell.modeDesign': "Editor",
    'shell.modePages': "Páginas",
    'shell.modeCms': "Contenido",
    'bp.shortDesktop': "escritorio",
    'bp.shortTablet': "tablet",
    'bp.shortMobile': "móvil",
    'layers.showAt': "Mostrar en {bp}",
    'layers.hideAt': "Ocultar en {bp}",
    'link.newWindow': "Abrir en ventana nueva",
    'nav.openMenuToEdit': "Abrir menú para editar",
    'nav.closeMenu': "Cerrar menú",
    'popover.openShort': 'Abrir popover',
    'popover.openToEdit': "Abrir popover para editar",
    'pos.absolute': "Absoluto",
    'position.auto': "Auto",
    'position.unit': "Unidad",
    'position.centerInParent': "Centrar en contenedor",
    'position.translateX': "Desplazar X",
    'position.translateY': "Desplazar Y",
    'position.sidesToOffset': "Pasar al desplazamiento",
    'insp.rotation': 'Rotación',
    'insp.resetRotation': 'Restablecer rotación a 0°',
    'position.offsetHint': "Mueve el elemento desde su sitio sin empujar a los demás. El % es del propio elemento.",
    'position.percentHint': "Posición en %: respecto al contenedor. Desplazamiento en %: respecto al propio elemento.",
    'pos.relative': "Relativo",
    'pos.static': "Estático",
    'pos.fixed': "Fijo",
    'pos.sticky': "Pegajoso",
    'text.contrastHint': "Adapta el texto al fondo o permite elegirlo manualmente",
    'text.contrast': "Contraste del texto",
    'text.byBackground': "Según fondo",
    'text.darkBackground': "Fondo oscuro",
    'text.light': "Clara",
    'text.dark': "Oscura",
    'cms.cardFields': 'En cada tarjeta',
    'cms.listLines': "Línea entre filas",
    'cms.cardButton': "Botón «Leer más»",
    'dynamic.title': "Contenido dinámico",
    'dynamic.sort': "Orden",
    'dynamic.sort.newest': "Más recientes",
    'dynamic.sort.oldest': "Más antiguos",
    'dynamic.sort.bestselling': "Más vendidos",
    'dynamic.sort.priceAsc': "Precio: menor a mayor",
    'dynamic.sort.priceDesc': "Precio: mayor a menor",
    'dynamic.sort.titleAsc': "De la A a la Z",
    /* El botón «Ver todo» de los carruseles de Contenido dinámico. */
    'sample.dyn.seeAll': "Ver todo",
    /* El botón de la barra lateral de servicios y reservas: a la página de contacto. */
    'sample.dyn.contact': "Contáctanos",
    'sample.dyn.blog.eyebrow': "Blog",
    'sample.dyn.blog.headline': "Desde nuestro blog",
    'sample.dyn.blog.intro': "Ideas, guías y novedades de nuestro equipo.",
    'sample.dyn.services.eyebrow': "Servicios",
    'sample.dyn.services.headline': "Lo que podemos hacer por ti",
    'sample.dyn.services.intro': "Elige un servicio para ver los detalles y empezar.",
    'sample.dyn.bookings.eyebrow': "Reserva en línea",
    'sample.dyn.bookings.headline': "Reserva tu lugar",
    'sample.dyn.bookings.intro': "Elige un servicio y el horario que te quede mejor.",
    'sample.dyn.digital.eyebrow': "Productos digitales",
    'sample.dyn.digital.headline': "Descargas al instante",
    'sample.dyn.digital.intro': "Llévatelos ahora y empieza hoy.",
    'sample.dyn.products.eyebrow': "Tienda",
    'sample.dyn.products.headline': "Nuestros productos",
    'sample.dyn.products.intro': "Elige lo que más te guste y recíbelo en casa.",
    'sample.dyn.memberships.eyebrow': "Membresías",
    'sample.dyn.memberships.headline': "Únete",
    'sample.dyn.memberships.intro': "Elige el plan que va contigo.",
    'sample.dyn.cms.intro': "Explora todo lo que tenemos para ti.",
    'dynamic.design': "Diseño",
    'dynamic.columns': "{n} columnas",
    'dynamic.pickCollection': "Elige una colección para ver sus diseños.",
    'dynamic.noCollections': "Todavía no tienes colecciones. Créalas en el CMS.",
    'dynamic.view.gallery': "Galería",
    'dynamic.view.featured': "Destacado",
    'dynamic.changeCollection': "Cambiar colección",
    'dynamic.emptyTitle': "Todavía no hay nada aquí",
    'dynamic.emptyOffers': "Crea la primera y aquí verás sus diseños con tu contenido real.",
    'dynamic.emptyEntries': "Esta colección no tiene entradas. Agrégalas en el panel Colecciones.",
    'dynamic.changeItem': "Cambiar",
    'dynamic.cms': "CMS",
    'dynamic.designs': "Diseños",
    'dynamic.badgeInfo': "Se actualiza solo: lo que publiques aparece en la página sin volver a diseñarla.",
    'dynamic.noPosts': "Todavía no hay entradas. Escríbelas en el panel Blog.",
    'cms.imageOpensItem': 'Abre su página al hacer clic',
    'cms.cardFieldsCount': '{n} de {total}',
    'cms.addPostField': "Agregar campo del post",
    'cms.addContent': "Agregar contenido",
    'cms.addPageContent': "Agregar contenido de página",
    'cms.addCollectionDescription': "Agregar descripción de la colección",
    'cms.addCollectionImage': "Agregar imagen de la colección",
    'cms.addCollectionTitle': "Agregar título de la colección",
    'size.height': "Alto",
    'size.fixedFrameHint': "Este diseño lleva el contenido sobre las fotos: su alto no depende de él.",
    'size.heightScreenShare': "Alto (% de la pantalla)",
    'size.heightPx': "Alto (px)",
    'size.width': "Ancho",
    'size.maxHeight': "Alto máximo",
    'size.minHeight': "Alto mínimo",
    'size.maxWidth': "Ancho máximo",
    'size.minWidth': "Ancho mínimo",
    'size.screenHeight': "Alto de pantalla",
    'size.screenWidth': "Ancho de pantalla",
    'icon.beforeText': "Antes del texto",
    'icon.afterText': "Después del texto",
    'icon.none': "Sin icono",
    'icon.removeFromButton': "Quitar el icono del botón",
    'ctl.dragToAdjust': "Arrastra para ajustar",
    'ctl.dragToReorder': "Arrastrar para reordenar",
    'ctl.increase': "Aumentar",
    'ctl.decrease': "Disminuir",
    'fill.add': "Añadir relleno",
    'visual.dropShadow': "Sombra",
    'visual.innerShadow': "Sombra interna",
    'visual.backgroundBlur': "Desenfoque de fondo",
    'fill.removeLayer': "Quitar capa",
    'fill.gradient': "Degradado",
    'state.changedHere': "Cambiado en este estado: clic para quitar",
    'state.hasChanges': "Este estado tiene cambios respecto a \"Normal\"",
    'state.removeOverride': "Quitar override de este estado",
    'state.pick': "Seleccionar estado para editar",
    'state.element': "Estado del elemento",
    'state.moreOptions': "Más opciones del estado",
    'ctl.clickToRename': "Clic para renombrar",
    'flex.column': "Columna",
    'flex.columnReverse': "Columna inversa",
    'flex.row': "Fila",
    'flex.rowReverse': "Fila inversa",
    'flex.columnsReverse': "Columnas inverso",
    'flex.rows': "Filas",
    'flex.rowsReverse': "Filas inverso",
    'grid.span': "Columnas que ocupa",
    'grid.rowSpan': "Filas que ocupa",
    'grid.rowUnit': "fila",
    'flex.wrap': "Con salto de línea",
    'flex.noWrap': "Sin salto de línea",
    'flex.wrapLabel': "Salto de línea",
    'flex.wrapReverse': "Salto inverso",
    'flex.spaceAround': "Espacio alrededor",
    'flex.spaceBetween': "Espacio entre",
    'flex.spaceEvenly': "Espacio uniforme",
    'flex.justify': "Distribución",
    'token.make': "Convertir en token",
    'token.unlink': "Desincronizar estilo global",
    'token.edit': "Editar estilo global",
    'token.local': "Estilo local",
    'token.brand': "Token de Estilo",
    'token.unassigned': "Sin asignar",
    'link.email': "Correo",
    'link.phone': "Teléfono",
    'link.target': "Destino",
    'link.page': "Página",
    'link.record': "Ficha",
    'ai.idHint': "Define el ID estable que la AI utilizará para personalizar este bloque",
    'ai.idDuplicate': "Este rol va una sola vez por bloque y ya está en otro elemento.",
    'ai.autoNumber': "Es el {label} n.º {n} del bloque: se numera solo, por orden.",
    'ai.idLegacy': "ID anterior conservado para compatibilidad.",
    'ai.semanticId': "ID semántico",
    'ai.selector': "Selector AI",
    'ai.blockProtocol': "Protocolo del bloque",
    'ai.exposed': "Expuesto",
    'ai.noDirectContent': "Este elemento no recibe contenido directo.",
    'ai.notEditable': "Este elemento no se enviará como campo editable del bloque.",
    'ai.doNotExpose': "— No exponer a la AI —",
    'box.eachCorner': "Editar cada esquina",
    'box.eachSide': "Editar cada lado",
    'box.allCorners': "Igualar todas las esquinas",
    'box.byAxis': "Editar por eje",
    'box.sides': "Lados",
    'box.groupByAxis': "Por eje",
    'box.groupEachSide': "Cada lado",
    'box.topLeft': "Sup. izquierda",
    'box.topRight': "Sup. derecha",
    'box.bottomLeft': "Inf. izquierda",
    'box.bottomRight': "Inf. derecha",
    'box.rounding': "Redondeo",
    'box.inner': "Interior",
    'box.outer': "Exterior",
    'box.blur': "Desenfoque",
    'insp.effects': "Efectos",
    'insp.filter': "Filtro",
    'insp.opacity': "Opacidad",
    'insp.opacityPct': "Opacidad (%)",
    'insp.properties': "Propiedades",
    'insp.selectedProperties': "Propiedades del elemento seleccionado",
    'insp.close': "Cerrar el inspector",
    'insp.moreOptions': "Más opciones",
    'insp.seeMore': "Ver más",
    'insp.breakpointOverride': "Override en este breakpoint",
    'size.shrink': "Encoger",
    'size.shrinkInfo': "Si falta espacio en la fila, «Flexible» deja que este elemento se haga más angosto para que quepan todos; «Rígido» lo mantiene siempre a su tamaño y son los demás los que se encogen (o la fila se desborda).",
    'size.fill': "Llenar espacio",
    'size.fillNeedsLayout': "Llenar espacio requiere un contenedor que distribuya sus elementos en fila, columna o cuadrícula.",
    'size.fillOutOfFlow': "Llenar espacio no aplica a elementos con posición absoluta o fija.",
    'size.relativeGridHeightHint': "El alto en % depende de la fila y puede dejar huecos si su altura es automática. Usa Ajustar a la celda en el menú de Tamaño para ocupar todo el espacio.",
    'size.fillGridCell': "Ajustar a la celda",
    'size.fillGridCellHint': "Ajusta ancho y alto al espacio del grid y libera la proporción.",
    'size.gridSpanHeightHint': "Ocupar varias filas no cambia el alto del elemento. Usa Ajustar a la celda en el menú de Tamaño para cubrirlas.",
    'size.relativeHeightHint': "El alto en porcentaje necesita una altura definida en el contenedor; si depende del contenido, puede no cambiar.",
    'size.fillHeightHint': "Para crecer en alto, el contenedor debe ofrecer espacio vertical disponible. Si se ajusta al contenido, puede no haber espacio que llenar.",
    'size.flexible': "Flexible",
    'size.rigid': "Rígido",
    'size.limit': "Límite",
    'size.limits': "Límites",
    'size.fraction': "Fracción",
    'size.pixels': "Pixeles",
    'size.percent': "Porcentaje",
    'size.modeFixed': "Fijo (px)",
    'size.modeRelative': "Relativo (%)",
    'size.modeScreenW': "Pantalla (vw)",
    'size.modeScreenH': "Pantalla (vh)",
    'common.custom': "Personalizado",
    'overflow.scroll': "Recorre",
    'overflow.clip': "Recorta",
    'overflow.hidden': "Oculto",
    'overflow.visible': "Visible",
    'insp.order': "Orden",
    'insp.position': "Posición",
    'insp.show': "Mostrar",
    'type.lineHeight': "Interlineado",
    'type.style': "Estilo de texto",
    'type.fontLabel': "Fuente",
    'common.title': "Título",
    'common.description': "Descripción",
    'schedule.window': "Vigencia",
    'schedule.whileActive': "Mientras esté vigente",
    'schedule.beforeStart': "Sólo antes de empezar",
    'schedule.afterEnd': "Sólo cuando termine",
    'schedule.ongoing': "Sólo en curso",
    'schedule.duringOnly': "Sólo mientras ocurre",
    'schedule.upcomingOnly': "Sólo por venir",
    'schedule.finished': "Terminadas",
    'schedule.availableNow': "Disponible ahora",
    'schedule.launch': "Lanzamiento",
    'faq.newQuestion': "Nueva pregunta",
    'faq.theAnswer': "La respuesta.",
    'slider.slide': "Diapositiva",
    'nav.megaMenu': "Mega menú",
    'logo.brand': "Logo de marca",
    'logo.brandPath': "Estilo → Logo",
    'image.version': "Versión de imagen",
    'cms.public': "Público",
    'border.dots': "Puntos",
    'border.dashes': "Rayas",
    'common.all': "Todos",
    'common.disabled': "Desactivado",
    'el.logo': "Logo",
    'insp.deleteSettings': "Eliminar ajustes",
    'ai.previousId': "Anterior · {id}",
    'logo.editHint': "El contenido del logo se edita en {ruta} y se aplica a todo el sitio.",
    'link.emailPlaceholder': "hola@ejemplo.com",
    'state.normal': "Normal",
    'state.pressed': "Pulsado",
    'state.focus': "Con foco",
    'state.current': "Actual",
    'state.open': "Abierto",
    'sort.desc': "Descendente",
    'sort.asc': "Ascendente",
    'size.fitContent': "Ajustar al contenido",
    'insp.overflow': "Desbordamiento",
    'fill.label': "Relleno",
    'token.global': "Global",
    'insp.editCode': "Editar código",
    'link.urlPlaceholder': 'https://...',
    'token.pickBrandStyle': "Selecciona un estilo",
    'token.globalSuffix': " · Global",
    'popover.closeToEdit': 'Cerrar popover',
    'a11y.section': "Accesibilidad",
    'img.contain': "Ajustar",
    'img.stretch': "Estirar",
    'img.cover': "Rellenar",
    'img.original': "Original",
    'img.framing': "Encuadre",
    'layout.contentAlign': "Alineación del contenido",
    'logo.width': "Ancho del logo",
    'img.searchGallery': "Buscar en la galería",
    'icon.search': "Buscar icono",
    'icon.searchPlaceholder': "Buscar icono…",
    'icon.results': "{count} iconos",
    'icon.category.all': "Todos",
    'icon.category.interface': "Interfaz",
    'icon.category.arrows': "Flechas",
    'icon.category.contact': "Contacto",
    'icon.category.commerce': "Comercio",
    'icon.category.media': "Multimedia",
    'icon.category.technology': "Tecnología",
    'icon.category.symbols': "Símbolos",
    'icon.category.social': "Redes",
    'icon.category.travel': "Viajes y turismo",
    'icon.category.architecture': "Arquitectura e inmuebles",
    'icon.category.health': "Salud",
    'icon.category.professional': "Servicios profesionales",
    'icon.category.education': "Educación",
    'icon.category.wellness': "Belleza y fitness",
    'icon.category.events': "Eventos",
    'icon.category.food': "Gastronomía",
    'icon.category.services': "Servicios del hogar",
    'icon.category.transport': "Vehículos",
    'icon.category.pets': "Mascotas",
    'logo.versionHint': "Cada logo elige su versión según el fondo. Puedes forzarla en el panel derecho.",
    'logo.noDarkHint': "Sin versión oscura se usa la clara en todos los fondos.",
    'common.change': "Cambiar",
    'img.change': "Cambiar imagen",
    'common.choose': "Elegir",
    'img.choose': "Elegir imagen",
    'img.select': "Seleccionar imagen",
    'img.selectMany': "Seleccionar imágenes",
    'img.upload': "Subir imagen",
    'img.uploading': "Subiendo tu imagen…",
    'img.gallery': "Galería",
    'img.uploaded': "Subidos",
    'common.loading': "Cargando…",
    'img.galleryFailed': "No se pudo cargar la galería.",
    'common.noSearchResults': "Sin resultados para esa búsqueda.",
    'img.noneSelected': "Ninguna seleccionada",
    'img.altHint': "Describe la imagen: es lo que leen los buscadores y los lectores de pantalla.",
    'img.altPlaceholder': "Texto alternativo...",
    'panels.close': "Cerrar panel",
    'common.clearSearch': "Limpiar búsqueda",
    'theme.light': "Claro",
    'theme.dark': "Oscuro",
    'icon.color': "Color del icono",
    'icon.background': "Fondo del icono",
    'icon.size': "Tamaño del icono",
    'icon.weight': "Grosor",
    'icon.families': "Familias de iconos",
    'logo.nameColor': "Color del nombre",
    'logo.showName': "Mostrar el nombre",
    'logo.display': 'Mostrar',
    'logo.settings': 'Logo',
    'logo.markSize': 'Tamaño del logo',
    'logo.nameSize': 'Tamaño del texto',
    'logo.displayBrand': 'Según la marca',
    'logo.displayBoth': 'Logo y texto',
    'logo.displayMark': 'Solo logo',
    'logo.displayName': 'Solo texto',
    'logo.hideName': "Ocultar el nombre",
    'logo.showMark': "Mostrar una marca",
    'logo.noMark': "Sin marca",
    'logo.markType': "Tipo de marca",
    'logo.wordmark': "Nombre de marca",
    'logo.wordmarkHint': "Nombre de la empresa y tipografía",
    'logo.mark': "Símbolo",
    'logo.markHint': "Icono o imagen cargada",
    'logo.backgroundOpacity': "Opacidad del fondo",
    'logo.cornerRadius': "Radio de esquina",
    'logo.lightColor': "Color claro",
    'logo.darkColor': "Color oscuro",
    'logo.lightBackground': "Fondo claro",
    'logo.darkBackground': "Fondo oscuro",
    'logo.previewIn': "Vista previa en",
    'logo.previewMode': "Modo de color del logo",
    'logo.lightMode': "Modo claro",
    'logo.darkMode': "Modo oscuro",
    'logo.companyName': "Nombre de la compañía",
    'type.searchFonts': "Buscar fuentes…",
    'type.noFontsFound': "No se encontraron fuentes",
    'token.styleName': "Nombre del estilo",
    'token.name': "Nombre del token",
    'token.replaceWith': "Reemplazar por",
    'common.create': "Crear",
    'common.rename': "Renombrar",
    'common.remove': "Quitar",
    'common.delete': "Eliminar",
    'common.builtIn': "Predeterminado",
    'brand.section': "Estilo",
    'common.name': "Nombre",
    'token.deleteTitle': "Eliminar “{name}”",
    'token.deleteBody': "Este {kind} lo usan {count}. Si lo eliminas, esos elementos pasarán al {kind} que elijas aquí.",
    'token.deleteNoOther': "No hay otro {kind} al que moverlos. Crea uno antes de eliminar este.",
    'icon.noneFor': "Ningún icono para {query}",
    'color.add': "Agregar color",
    'color.cardAuto': "Adaptar tarjetas",
    'card.autoSurfaceHint': "Las tarjetas toman un tono que contrasta con el fondo de cada sección. Vale para todas.",
    'color.cardAutoOn': "Las tarjetas ajustan su tono para destacar sobre el fondo de cada sección.",
    'color.cardAutoOff': "Las tarjetas conservan el color elegido en todas las secciones.",
    'section.toneAuto': "Alternar fondos",
    'section.toneAutoOn': "Los fondos predeterminado y secundario se alternan automáticamente. Se respetan los que eliges a mano.",
    'section.toneAutoOff': "Cada sección conserva el fondo elegido.",
    'section.toneAutoPick': "Automático",
    'section.toneAutoPickHint': "Alterna con las de alrededor",
    'section.toneAutoNow': "ahora",
    'token.cardAdaptsNote': "Se ajusta al fondo de cada sección para distinguirse. Las muestras enseñan el tono de esta sección.",
    'token.add': "Agregar token",
    'img.queueProgress': "{done} de {total}",
    'img.noneYet': "Todavía no tienes imágenes.",
    'img.signInToUpload': "Inicia sesión para subir y elegir imágenes.",
    'logo.autoWidth': "auto",
    'icon.clearBackground': "Quitar el fondo",
    'panels.exploreAll': "Explorar todas las opciones",
    'token.deleteAndReplace': "Eliminar y reemplazar",
    'img.loadingMore': "Cargando más imágenes…",
    'img.saveCount': "Guardar ({count})",
    'link.newTab': "Abrir en pestaña nueva",
    'pages.add': "Agregar página",
    'token.addStyle': "Agregar un estilo",
    'img.fit': "Ajuste de imagen",
    'flex.alignChildren': "Alinear hijos",
    'opt.wide': "Amplio",
    'opt.narrow': "Estrecho",
    'opt.generous': "Generoso",
    'opt.little': "Poco",
    'opt.tight': "Junto",
    'opt.spread': "Separado",
    'opt.verySpread': "Muy separado",
    'opt.compactFem': "Compacta",
    'size.fullWidth': "Ancho completo",
    'common.automatic': "Automático",
    'token.searchButton': "Buscar botón...",
    'token.searchStyle': "Buscar estilo...",
    'type.searchFont': "Buscar fuente...",
    'link.allDestinations': "Todo",
    'link.currentDestination': "Destino actual",
    'link.notLinked': "Sin enlace",
    'link.chooseDestination': "Elige a dónde lleva",
    'link.pages': "Páginas",
    'link.content': "Contenido",
    'link.collections': 'Colecciones',
    'link.catalog': "Catálogo",
    'link.searchAll': "Busca, o pega un enlace, correo o teléfono",
    'link.createPage': "Crear página nueva",
    'link.createNamedPage': "Crear la página «{name}»",
    'link.createPageHint': "Elige cómo crearla; al terminar, este enlace llevará a ella",
    'link.nothingNamed': "Nada se llama «{query}». Pega una dirección para enlazar fuera.",
    'link.emptyGroup': "Aún no hay nada aquí.",
    'link.searchPage': "Buscar página o pegar un enlace",
    'token.changeOnlyHere': "Personalizar solo este elemento",
    'token.controlledBy': "Estilo global: ",
    'token.controlsCount': "Controla {count} propiedades",
    'token.editShort': "Editar",
    'token.inUse': "En uso",
    'token.valueNormal': "Normal",
    'token.valueAuto': "Automático",
    'opt.squareShape': "Cuadrado",
    'opt.circle': "Círculo",
    'opt.pill': "Píldora",
    'opt.straight': "Recto",
    'opt.rounded': "Redondeado",
    'opt.round': "Redondo",
    'opt.veryRound': "Muy redondo",
    'shell.undo': "Deshacer",
    'shell.redo': "Rehacer",
    'shell.undoKeys': "Deshacer (Cmd+Z)",
    'shell.redoKeys': "Rehacer (Cmd+Shift+Z)",
    'token.unlinkShort': "Desvincular",
    'token.unlinkFrom': "Desvincular del estilo global",
    'token.syncedWithBrand': "Sincronizado con Estilo",
    'token.editInBrand': "Editar en Estilo",
    'token.cardControlledDesc': "El fondo, borde, redondeo y sombra se controlan desde Estilo para mantener consistencia. Desvincula si deseas personalizar únicamente este elemento.",
    'token.textControlledDesc': "La tipografía, colores y estilos de texto se controlan desde Estilo para mantener consistencia. Desvincula si deseas personalizar únicamente este elemento.",
    'token.buttonControlledDesc': "El estilo y apariencia del botón se controlan desde Estilo para mantener consistencia. Desvincula si deseas personalizar únicamente este elemento.",
    'opt.two': "Dos",
    'opt.three': "Tres",
    'opt.one': "Una",
    'common.duplicate': "Duplicar",
    'token.editButton': "Editar botón global",
    'fill.editStopColor': "Editar color del punto",
    'token.editColor': "Editar color global",
    'fill.editGradient': "Editar degradado",
    'token.editLogo': "Editar el logo global",
    'token.editIcon': "Editar icono global",
    'token.editSection': "Editar sección global",
    'token.editCard': "Editar tarjeta global",
    'fill.removeStop': "Eliminar punto",
    'fill.minStops': "Mínimo 2 puntos",
    'img.chooseOne': "Elegir una imagen",
    'ai.send': "Enviar",
    'ai.reply': "Responder",
    'ai.thinking': "Pensando…",
    'ai.replyPlaceholder': "Escribe tu respuesta…",
    'box.corners': "Esquinas",
    'cms.fromCms': "Este texto viene del CMS",
    'cms.useField': "Usar un campo del CMS",
    'pos.fixedFem': "Fija",
    'pos.floating': "Flotante",
    'pos.free': "Libre",
    'layout.gap': "Gap",
    'layout.rowGap': "Espacio entre filas",
    'grid.child': "Grid hijo",
    'border.dash': "Guión",
    'ai.promptPlaceholder': "Dile a la IA qué cambiar, p. ej. «hazlo más grande» o «pon el fondo azul»",
    'ai.promptTitle': "¿Qué quieres cambiar?",
    'ai.promptAria': "Pedido para el asistente AI",
    'type.justified': "Justificado",
    'common.done': "Listo",
    'ctl.finishEditing': "Terminar de editar",
    'ctl.moveRight': "Mover a la derecha",
    'ctl.moveLeft': "Mover a la izquierda",
    'ctl.moveDown': "Mover abajo",
    'ctl.moveUp': "Mover arriba",
    'size.minHeightShort': "Mín. alto",
    'size.clearMin': "Quitar mínimo",
    'type.bold': "Negrita",
    'type.clearFormat': "Quitar formato",
    'color.recent': "Recientes",
    'color.pick': "Seleccionar color",
    'bp.switcher': "Selector de viewport",
    'type.system': "Sistema",
    'opt.subtle': "Sutil",
    'fill.overlay': "Superposición",
    'fill.linear': "Lineal",
    'fill.radial': "Radial",
    'fill.gradientType': "Tipo de degradado",
    'fill.gradientAngle': "Dirección del degradado",
    'color.transparent': "Transparente",
    'theme.section': "Tema",
    'el.buttonText': "Texto del botón",
    'opt.large': "Grande",
    'opt.topShort': "Top",
    'opt.leftShort': "Left",
    'fill.stopsSummary': "{count} puntos · {kind}",
    'fill.noLayers': "Sin capas. Agrega una con los botones de abajo.",
    'fill.layersCount': "{count} capas",
    'insp.editDetails': "Editar {name}",
    'fill.display': "Visualización",
    'box.removeShadow': "Quitar sombra",
    'link.noPageNamed': 'Ninguna página se llama «{query}». Pega una dirección para enlazar fuera.',
    'img.objectFit': "Ajuste de la imagen",
    'insp.zIndex': "Z-Index",
    'bp.viewName': "Vista {name}",
    'layout.grid': 'Grid',
    'border.thin': "Fino",
    'border.medium': "Medio",
    'border.thick': "Grueso",
    'pub.publish': "Publicar",
    'pub.publishing': "Publicando",
    'pub.stopped': "Publicación detenida",
    'pub.toSelected': "Publicar a dominios seleccionados",
    'pub.domains': "Dominios de publicación",
    'pub.domainsShort': "Dominios",
    'pub.sitePublished': "Sitio publicado",
    'pubHint.eyebrow': 'Desde Configuración',
    'pubHint.title': 'Publica desde aquí',
    'pubHint.body': 'Este botón construye tus páginas y las pone en línea. Tus páginas de reserva tienen dirección en cuanto termine.',
    'publish.site.title': 'Tu sitio',
    'publish.site.live': 'Está en línea',
    'publish.site.liveBody': 'Cualquiera con la dirección puede abrirlo, y tus páginas de reserva funcionan.',
    'publish.site.off': 'Sin publicar',
    'publish.site.offBody': 'Tus cambios aún no están en línea.',
    'publish.site.unpublish': 'Despublicar',
    'publish.site.unpublishing': 'Despublicando…',
    'publish.site.confirmTitle': '¿Despublicar el sitio?',
    'publish.site.confirmBody': 'Deja de responder en su dirección, páginas de reserva incluidas. No se borra nada, y al publicar de nuevo vuelve.',
    'publish.site.openEditor': 'Abrir en el editor',
    'publish.site.openEditorHint': 'Publicar construye todas las páginas, y eso ocurre en el editor.',
    'pub.siteUnpublished': "Sitio despublicado",
    'pub.templateTitle': "Publicar el template",
    'pub.templateHint': "Lo guarda en la biblioteca con su miniatura y sus traducciones.",
    'pub.templatePublishing': "Publicando el template",
    'pub.templateStepSave': "Guardando el borrador",
    'pub.templateStepPublish': "Publicando, traduciendo y capturando la miniatura",
    'pub.templateDoneHint': "Ya está en la biblioteca y su miniatura está lista.",
    'pub.templateDoneClose': "Listo",
    'pub.templatePublished': "Template publicado",
    'pub.templatePublishedTranslated': "Template publicado · {count} textos traducidos con IA. Revísalos en Idioma.",
    'pub.unpublishing': "Despublicando…",
    'pub.failed': "No se pudo publicar el sitio.",
    'pub.templateFailed': "No se pudo publicar el template.",
    'pub.unpublishFailed': "No se pudo despublicar el sitio.",
    'pub.files': "{count} archivos",
    'pub.filesOne': "1 archivo",
    'pub.uploadProgress': "{sent} de {total}",
    'pub.noChanges': "Sin cambios que subir",
    'pub.noPages': "No hay páginas para publicar.",
    'pub.saveFirst': "Guarda este proyecto antes de publicarlo.",
    'pub.close': "Cerrar publicación",
    'pub.unpublished': "Sin publicar",
    'pub.customNeedsUpgrade': "Tu propio dominio es del plan Pro",
    'pub.customNeedsUpgradeHint': "Mejora tu plan para publicar en tudominio.com. Tu dirección de véltica sigue funcionando.",
    'pub.seePlans': "Ver planes",
    'pub.headHint': "Tus últimos cambios se publican en los dominios que elijas.",
    'pub.publishingSite': "Publicando tu sitio",
    'pub.publishedAgo': "Publicado {when}",
    'pub.subdomainChecking': "Comprobando…",
    'pub.subdomainRules': "Minúsculas, números y guiones.",
    'pub.subdomainWarn': "{host} dejará de abrir, y los enlaces que ya compartiste con ella no funcionarán. Te la guardamos 30 días por si cambias de idea.",
    'pub.notPublishedYet': "Publica el sitio primero: hasta entonces el enlace no abre nada.",
    'pub.neverOnDomain': "Nunca publicado en este dominio",
    'pub.live': "En vivo",
    'pub.preparing': "Preparando tu sitio",
    'pub.generatingPages': "Generando páginas",
    'pub.registeringForms': "Registrando formularios",
    'pub.updatingThumbnails': "Actualizando miniaturas",
    'pub.readingSettings': "Leyendo ajustes del sitio",
    'pub.uploadingFiles': "Subiendo archivos",
    'pub.someStepsFailed': "No se pudieron completar todos los pasos",
    'pub.publishHint': "Publica para que tus cambios se vean en el sitio. Guardar solo actualiza el borrador.",
    'pub.changesStayInEditor': "Tus cambios siguen en el editor.",
    'pub.freeSubdomain': "Subdominio gratuito de Veltica",
    'pub.connectOwnDomain': "Conecta tu propio dominio",
    'pub.useOwnDomain': "Usa tudominio.com en lugar del subdominio",
    'pub.connect': "Conectar",
    'pub.dnsPending': "Configurando DNS/SSL… gestiónalo en el panel",
    'pub.openDomain': "Abrir el dominio",
    'pub.openDomainNewTab': "Abrir el dominio en una pestaña nueva",
    'pub.openPublished': "Abrir la versión publicada",
    'pub.openPublishedNewTab': "Ver la versión publicada en una pestaña nueva",
    'save.saved': "Guardado",
    'save.saving': "Guardando",
    'save.savingChanges': "Guardando tus cambios…",
    'save.allSaved': "Todos los cambios guardados",
    'save.error': "Error al guardar",
    'save.failed': "No se pudo guardar",
    'save.sessionExpired': "Sesión expirada",
    'save.offline': "Sin conexión",
    'save.checkConnection': "Revisa tu conexión e intenta de nuevo.",
    'common.tryAgain': "Intentar de nuevo",
    'save.cannotOpen': "No se pudo abrir el proyecto",
    'clip.title': "Clipboard",
    'clip.section': "Clipboard de sección",
    'clip.close': "Cerrar clipboard",
    'clip.copySection': "Copiar sección",
    'clip.pasteSection': "Pegar sección",
    'clip.pasteFrom': "Pegar sección desde clipboard",
    'clip.copied': "Sección copiada al clipboard",
    'clip.pasted': "Sección pegada",
    'clip.valid': "Sección válida",
    'clip.invalid': "El código no contiene una sección válida",
    'clip.badJson': "Revisa el formato del JSON.",
    'clip.cannotRead': "No pude leer el clipboard del navegador",
    'clip.importFailed': "No se pudo importar",
    'clip.codeCopied': "Código copiado",
    'clip.pickToCopy': "Selecciona una sección para copiar",
    'clip.pickPageToPaste': "Selecciona una página para pegar",
    'brand.hint': "Colores y tipografía de tu sitio. Se aplican a todo el sitio.",
    'brand.palette': "Paleta de Colores",
    'brand.presets': "Estilos listos",
    'brand.tabMine': "Tu marca",
    'brand.tabStyles': "Estilos",
    'brand.stylesHint': "Cambia el aspecto de todo el sitio, de una vez o por partes.",
    'brand.customize': "Personalizar",
    'brand.combo': "Combinación de estilo",
    'brand.textStyles': "Estilos de texto",
    'brand.buttonStyles': "Estilos de botones",
    'brand.cardStyles': "Estilos de tarjetas",
    'brand.sectionStyles': "Estilos de secciones",
    'brand.motion': "Animación",
    'motion.style.none': "Ninguna",
    'motion.style.subtle': "Sutil",
    'motion.style.smooth': "Suave",
    'motion.style.elegant': "Elegante",
    'motion.style.dynamic': "Dinámica",
    'motion.style.slide': "Deslizar",
    'motion.style.zoom': "Crecer",
    'motion.style.reveal': "Revelar",
    'motion.style.cinematic': "Cine",
    'motion.style.flip': "Voltear",
    'motion.styleHint.none': "Nada se mueve",
    'motion.styleHint.subtle': "Un fundido corto y discreto",
    'motion.styleHint.smooth': "Todo sube con suavidad",
    'motion.styleHint.elegant': "Más lenta, con un desenfoque suave",
    'motion.styleHint.dynamic': "Rápida, con un pequeño rebote",
    'motion.styleHint.slide': "Llega desde un lado",
    'motion.styleHint.zoom': "Crece un poco al aparecer",
    'motion.styleHint.reveal': "Se descubre de abajo arriba, como un telón",
    'motion.styleHint.cinematic': "Llega de cerca y se asienta despacio",
    'motion.styleHint.flip': "Gira un poco al entrar; desenfadada",
    'motion.customize': "Personalizar",
    'motion.chooseStyle': "Elegir un estilo de animación",
    'motion.stylesHint': "Estilos de movimiento para todo tu sitio",
    'motion.play': "Reproducir animación",
    'motion.role.heading': "Títulos grandes",
    'motion.role.subheading': "Títulos pequeños",
    'motion.role.text': "Textos",
    'motion.role.button': "Botones",
    'motion.role.card': "Tarjetas",
    'motion.role.image': "Fotos",
    'motion.enter': "Entrada",
    'motion.enterAll': "Entrada (todo)",
    'motion.hover': "Hover",
    'motion.hover.scale': "Tamaño al pasar el mouse",
    'motion.hover.lift': "Elevación",
    'motion.hover.color': "Color del efecto",
    'motion.hover.blur': "Desenfoque",
    'motion.hover.opacity': "Intensidad",
    'motion.hover.angle': "Ángulo",
    'motion.hover.outline': "Grosor del contorno",
    'motion.speed': "Velocidad",
    'motion.speed.slow': "Lenta",
    'motion.speed.normal': "Normal",
    'motion.speed.fast': "Rápida",
    'motion.speed.veryFast': "Muy rápida",
    'motion.reset': "Volver al estilo como viene",
    'motion.hint': "Se aplica a todas las páginas. Un elemento con animación propia la conserva.",
    'brand.icons': "Iconos",
    'color.name': "Nombre del color",
    'color.new': "Nuevo color",
    'token.newStyle': "Nuevo estilo",
    'token.newButton': "Nuevo botón",
    'token.newCard': "Nueva tarjeta",
    'token.newSection': "Nueva sección",
    'token.newIcon': "Nuevo icono",
    'brand.restartStyle': "Reiniciar estilo",
    'brand.restartStyleConfirm': "Esto reemplaza todos los cambios manuales de este estilo, incluidos tablet y celular, por los de la combinación de Style seleccionada.",
    'brand.restartUnavailable': "No hay un valor original disponible en la combinación de Style",
    'brand.restartCurrent': "Este estilo ya coincide con la combinación seleccionada",
    'a11y.topbar': "Barra superior del editor",
    'a11y.contextBar': "Barra contextual del elemento",
    'a11y.canvas': "Canvas de edición",
    'a11y.viewport': "Controles del viewport",
    'a11y.canvasNav': "Navegación y controles del canvas",
    'a11y.tools': "Herramientas del editor",
    'a11y.elementProps': "Propiedades del elemento",
    'a11y.designPanel': "Panel de diseño",
    'a11y.whatIsEdited': "Qué se está editando",
    'a11y.currentArea': "Área actual del editor",
    'a11y.editPath': "Ruta de edición",
    'a11y.pageBeingEdited': "Página en edición",
    'common.goTo': "Ir a",
    'common.location': "Ubicación",
    'pages.site': "Páginas del sitio",
    'pages.andContent': "Páginas y contenido",
    'pages.created': "Página creada",
    'pages.settings': "Ajustes de página",
    'pages.settingsLong': "Ajustes de la página",
    'pages.settingsThis': "Ajustes de esta página",
    'pages.config': "Configuración de la página",
    'pages.closeSettings': "Cerrar los ajustes",
    'pages.select': "Seleccionar página",
    'cms.selectCollection': "Seleccionar colección",
    'cms.selectPost': "Seleccionar post",
    'cms.closePost': "Cerrar post y volver a la colección",
    'cms.noDetailPage': "Esta colección todavía no tiene página de detalle.",
    'shell.templateModeHint': "CMS y páginas están desactivados al editar templates.",
    'insp.pin': "Fijar el inspector abierto",
    'insp.pinAlways': "Fijar el inspector siempre abierto",
    'insp.pinShort': "Fijar panel abierto",
    'insp.pinAlwaysShort': "Fijar panel siempre abierto",
    'insp.autoHide': "Auto-ocultar el inspector",
    'insp.autoHideShort': "Auto-ocultar panel",
    'img.uploaded2': "Imagen subida",
    'img.uploadFailed': "No se pudo subir la imagen",
    'img.signIn': "Inicia sesión para subir imágenes",
    'img.dropToUpload': "Suelta para subir la imagen",
    'img.savedToFiles': "Se guardará en tus Archivos",
    'img.files': "Archivos",
    'preview.title': "Vista previa",
    'preview.unpublished': "Vista previa · sin publicar",
    'shell.myProject': "Mi proyecto",
    'shell.template': "Template",
    'tplLang.title': "Idioma",
    'tplLang.name.en': "Inglés",
    'tplLang.name.es': "Español",
    'tplLang.untranslated': "Sin traducir: {count}",
    'tplLang.hint': "Los textos que cambies son sólo de este idioma. Los cambios de diseño valen para todos.",
    'time.year': "año",
    'time.years': "años",
    'time.day': "día",
    'time.days': "días",
    'time.page': "página",
    'time.pages': "páginas",
    'preview.draftBadge': "Borrador · publícalo para que sea visible",
    'clip.copyCode': "Copiar código",
    'save.lastTry': "Último intento: {time}",
    'pub.configure': "Configurar",
    'pub.seeLiveSite': "Ver sitio en vivo",
    'pub.unpublishSite': "Despublicar sitio",
    'pub.alreadyOnline': "{host} ya está en línea",
    'pub.openSite': "Abrir sitio",
    'brand.logo': "Logo",
    'a11y.layers': "Capas",
    'a11y.layersHint': "Consulta, selecciona y organiza la estructura de la página.",
    'load.invalidTitle': "Proyecto inválido",
    'load.invalidBody': "El enlace del proyecto no tiene un ID válido.",
    'load.sessionTitle': "Sesión requerida",
    'load.sessionBody': "Inicia sesión de nuevo para abrir este proyecto.",
    'load.unavailableTitle': "Proyecto no disponible",
    'load.unavailableBody': "Este proyecto no existe o no pertenece a tu cuenta.",
    'load.serverSaid': "El servidor respondió con HTTP {status}.",
    'ago.now': "hace un momento",
    'ago.minuteOne': "hace {count} minuto",
    'ago.minutes': "hace {count} minutos",
    'ago.hourOne': "hace {count} hora",
    'ago.hours': "hace {count} horas",
    'ago.dayOne': "hace {count} día",
    'ago.days': "hace {count} días",
    'ago.monthOne': "hace {count} mes",
    'ago.months': "hace {count} meses",
    'ago.yearOne': "hace {count} año",
    'ago.years': "hace {count} años",
    'pub.pageCount': "{count} páginas",
    'pub.pageCountOne': "{count} página",
    'blk.add': "Añadir un bloque",
    'blk.more': "Más bloques",
    'blk.turnInto': "Convertir en",
    'blk.turnIntoAnother': "Convertir en otro bloque",
    'blk.actions': "Acciones",
    'blk.duplicate': "Duplicar",
    'blk.delete': "Eliminar",
    'blk.blockOptions': "Opciones del bloque",
    'blk.inlineCode': "Código",
    'blk.removeLink': "Quitar enlace",
    'blk.moveUpShort': "Subir",
    'blk.moveDownShort': "Bajar",
    'blk.align': "Alineación",
    'blk.align.left': "Alinear a la izquierda",
    'blk.align.center': "Centrar",
    'blk.align.right': "Alinear a la derecha",
    'blk.align.justify': "Justificar",
    'blk.moveUp': "Subir el bloque",
    'blk.moveDown': "Bajar el bloque",
    'blk.noneNamed': "Ningún bloque con ese nombre.",
    'blk.placeholder': "Empieza a escribir o pulsa / para insertar títulos, imágenes y más",
    'blk.placeholderLong': "Empieza a escribir o pulsa / para insertar títulos, imágenes y más",
    'blk.paragraph': "Texto normal",
    'blk.paragraphHint': "Un párrafo normal",
    'blk.list': "Lista",
    'blk.listHint': "Puntos sin orden",
    'blk.numbered': "Lista numerada",
    'blk.numberedHint': "Pasos, uno tras otro",
    'blk.quote': "Cita",
    'blk.quoteHint': "Lo que dijo alguien",
    'blk.code': "Código",
    'blk.codeHint': "Monoespaciado, tal cual se escribe",
    'blk.dividerHint': "Una línea entre dos partes",
    'blk.calloutHint': "Un aviso que no se puede saltar",
    'blk.calloutPlaceholder': "Escribe aquí lo importante",
    'blk.insertLink': "Insertar enlace",
    'blk.insertVideo': "Insertar vídeo",
    'blk.videoLink': "Enlace de video",
    'blk.pasteVideo': "Pega el enlace de YouTube o Vimeo",
    'blk.videoHint': "Pega el enlace del vídeo y se insertará como reproductor.",
    'blk.youtubeOrVimeo': "YouTube o Vimeo",
    'blk.widenImage': "Ensanchar la imagen",
    'blk.narrowImage': "Estrechar la imagen",
    'blk.changeImage': "Cambiar imagen",
    'blk.link': "Enlazar",
    'blk.remove': "Quitar",
    'blk.copied': "Copiado",
    'blk.ratio': "Proporción",
    'blk.ratioOriginal': "Original",
    'blk.toTheLeft': "A la izquierda",
    'blk.centered': "Centrada",
    'blk.full': "Completa",
    'cms.manageCollections': "Administrar contenido",
    'cms.manageContent': "Administrar contenido",
    'cms.collectionsTitle': "Contenido",
    'cms.collectionCreated': "Colección creada",
    'cms.collectionSaved': "Colección guardada",
    'cms.collectionInfo': "Información de la colección",
    'cms.generalInfo': "Información general",
    'cms.collectionIdentityHint': "Define cómo se identifica esta colección y dónde se publica.",
    'cms.collectionIconHint': "Con qué se reconoce esta colección en la lista y en la tabla.",
    'cms.iconAndColor': "Icono y color",
    'cms.collectionPath': "Ruta de la colección",
    'cms.collectionPathHint': "Esta ruta se utiliza para la colección y sus elementos publicados.",
    'cms.itemUrl': "URL de cada elemento",
    'cms.contentStructure': "Estructura del contenido",
    'cms.structureHint': "Organiza la información que tendrá cada elemento.",
    'cms.collectionFields': "Campos de la colección",
    'cms.systemFields': "Campos del sistema",
    'cms.fields': "Campos",
    'cms.fieldName': "Nombre del campo",
    'cms.removeField': "Quitar campo",
    'cms.dragFieldHandle': "Arrastrar campo",
    'cms.addOption': "Agregar opción",
    'cms.removeOption': "Quitar opción",
    'cms.option': "Opción",
    'cms.optionOne': "Opción 1",
    'cms.startFromTemplate': "Elige un punto de partida",
    'cms.templateHint': "Cada modelo trae los campos más comunes; después los cambias a tu medida.",
    'cms.yourCollection': "Tu colección",
    'cms.namePlaceholder': "Ej. Publicaciones",
    'cms.deleteCollectionWarning': "Se eliminarán la colección y todos sus elementos. Esta acción no se puede deshacer.",
    'cms.backToCollections2': "Volver a las colecciones",
    'cms.backToName': "Volver al nombre",
    'cms.openInCms': "Abrir en CMS",
    'cms.contentGone': "Este contenido ya no existe.",
    'cms.item': "Elemento",
    'cms.itemNumber': "Ficha {n}",
    'cms.items': "Elementos",
    'cms.noFields': "(sin campos)",
    'cms.noRows': "(sin filas)",
    'cms.tpl.posts': "Publicaciones",
    'cms.tpl.post': "Publicación",
    'cms.tpl.authors': "Autores",
    'cms.tpl.author': "Autor",
    'cms.tpl.projects': "Proyectos",
    'cms.tpl.events': "Eventos",
    'cms.tpl.recipes': "Recetas",
    'cms.tpl.clients': "Clientes",
    'cms.tpl.client': "Cliente",
    'cms.tpl.team': "Miembros del equipo",
    'cms.tpl.shows': "Shows",
    'cms.tpl.songs': "Canciones",
    'cms.tpl.listings': "Listados",
    'cms.tpl.media': "Medios",
    'cms.tpl.log': "Registro",
    'cms.tpl.artist': "Artista",
    'cms.tpl.bio': "Biografía",
    'cms.tpl.role': "Puesto",
    'cms.tpl.ingredients': "Ingredientes",
    'cms.tpl.duration': "Duración",
    'cms.tpl.price': "Precio",
    'cms.tpl.place': "Lugar",
    'cms.tpl.starts': "Empieza",
    'cms.tpl.ends': "Termina",
    'cms.tpl.featured': "Destacado",
    'cms.tpl.caseStudies': "Casos de éxito",
    'cms.tpl.result': "Resultado",
    'cms.tpl.tickets': "Entradas",
    'cms.tpl.faq': "Preguntas frecuentes",
    'cms.tpl.answer': "Respuesta",
    'cms.tpl.partners': "Marcas aliadas",
    'cms.tpl.portfolio': "Portafolio",
    'cms.tpl.viewProject': "Ver proyecto",
    'cms.tpl.properties': "Propiedades",
    'cms.tpl.bedrooms': "Recámaras",
    'cms.tpl.locations': "Sucursales",
    'cms.tpl.address': "Dirección",
    'cms.tpl.hours': "Horario",
    'cms.tpl.directions': "Cómo llegar",
    'cms.tpl.testimonials': "Testimonios",
    'cms.tpl.quote': "Testimonio",
    'cms.tpl.roleCompany': "Puesto o empresa",
    'cms.tpl.jobs': "Vacantes",
    'cms.tpl.department': "Área",
    'cms.tpl.workMode': "Modalidad",
    'cms.tpl.apply': "Postularse",
    'cms.tpl.resources': "Recursos",
    'cms.tpl.download': "Descarga",
    'cms.tpl.summary': "Resumen",
    'cms.tpl.categories': "Categorías",
    'cms.tpl.photo': "Foto",
    'cms.tpl.sale': "Venta",
    'cms.tpl.buyNow': "Comprar ahora",
    'cms.tpl.ctaHint': "La acción que quieres que hagan",
    'cms.type.longText': "Texto largo",
    'cms.type.number': "Número",
    'cms.type.date': "Fecha",
    'cms.type.dateTime': "Fecha/Hora",
    'cms.type.email': "Correo",
    'cms.type.phone': "Teléfono",
    'cms.type.location': "Ubicación",
    'cms.type.time': "Tiempo",
    'cms.type.image': "Imagen",
    'cms.noSchedule': "Sin vigencia",
    'cms.scheduleOptional': "Vigencia (opcional)",
    'cms.sameDay': "El mismo día",
    'cms.unlink': "Desvincular del CMS",
    'cms.unlinked': "Sin vincular",
    'cms.customText': "Texto personalizado",
    'cms.textFieldOf': "Texto de {name}",
    'cms.entryLink': "Enlace a la entrada",
    'cms.noCompatibleFields': "La página de la colección no tiene campos compatibles.",
    'cms.useItemImage': "Usar la imagen del elemento",
    'cms.useScreenshot': "Usar la captura",
    'pg.settings': "Ajustes de página",
    'pg.title': "Título de página",
    'pg.itemTitle': "Título del elemento",
    'pg.identityHint': "Define cómo se identifica esta página dentro del sitio.",
    'pg.discoveryHint': "Decide cómo se descubre esta página dentro y fuera del sitio.",
    'pg.seoHint': "Optimiza el título, la descripción y la URL que verán los buscadores.",
    'pg.itemSeoHint': "Personaliza cómo aparece cada elemento de la colección en buscadores.",
    'pg.searchVisibility': "Visibilidad en buscadores",
    'pg.indexable': "Indexar en buscadores",
    'pg.inSitemap': "Incluir en sitemap",
    'pg.canonical': "URL canónica",
    'pg.slug': "URL slug",
    'pg.slugShort': "Slug",
    'pg.titleTag': "Title tag",
    'pg.metaDescription': "Meta description",
    'pg.googleTitle': "Título para Google",
    'pg.summaryHint': "Resumen breve de esta página",
    'pg.itemSummaryHint': "Resumen breve de este elemento",
    'pg.descriptionHint': "Agrega una descripción clara para mejorar cómo aparece esta página en buscadores.",
    'pg.itemDescriptionHint': "Agrega una descripción para mejorar cómo se comparte este elemento.",
    'pg.sharePreview': "Vista previa al compartir",
    'pg.shareHint': "Configura la tarjeta que aparecerá en redes sociales y mensajes.",
    'pg.ogImage': "Imagen para compartir (OG)",
    'pg.ogTitle': "Título para redes",
    'pg.ogDescription': "Descripción para redes",
    'pg.sameAsSeo': "Igual que el SEO",
    'pg.ogDefaultPage': "Por defecto se usa la captura de la página. Sube una para personalizarla.",
    'pg.ogDefaultItem': "Por defecto se usa la imagen del elemento. Sube una para personalizarla.",
    'pg.ogCustom': "Imagen personalizada. Haz clic para cambiarla.",
    'pg.ogSources': "De tu biblioteca, subida o por URL",
    'pg.uploadCover': "Subir imagen de portada",
    'pg.changeCover': "Cambiar imagen de portada",
    'pg.password': "Contraseña",
    'pg.accessHint': "Controla quién puede acceder a esta página.",
    'pg.publishPage': "Publicar esta página",
    'pg.publishPageBody': "Apagada, sigue en el editor pero en el sitio no se encuentra (sale «página no encontrada»). Se aplica al publicar.",
    'pg.publishPageHome': "La portada siempre está publicada: es a donde llega todo el que entra al sitio.",
    'pg.unpublished': "Sin publicar",
    'pg.passwordRule': "Debe tener al menos 6 caracteres.",
    'pg.passwordMin': "Mínimo 6 caracteres",
    'pg.deleteHint': "Elimina esta página y todo su contenido del proyecto.",
    'pg.needOnePage': "El sitio necesita conservar al menos una página.",
    'pg.cannotDeleteHome': "La página principal no se puede eliminar. Asigna otra página como principal primero.",
    'pg.deleted': "Página eliminada",
    'pg.saved': "Página guardada",
    'pg.homeUpdated': "Página principal actualizada",
    'pg.collectionTemplate': "Plantilla de la colección",
    'pg.mainTemplate': "Plantilla principal",
    'pg.templateHint': "Esta plantilla define cómo se ve cada elemento de la colección en el sitio.",
    'pg.noItemsForSeo': "Esta colección aún no tiene elementos. Crea uno en Contenido para editar su SEO.",
    'pg.menuItems': "Elementos de menú",
    'pg.menu': "Menú",
    'pg.pages': "Páginas",
    'common.saveChanges': "Guardar cambios",
    'cms.unpublished': "Sin publicar",
    'panels.dragWidth': "Arrastra para cambiar el ancho",
    'img.tooBig': "La imagen debe pesar menos de 10 MB",
    'cms.blockBadge': "CMS Bloque",
    'cms.pageBadge': "CMS Página",
    'cms.type.text': "Texto",
    'cms.type.images': "Imágenes",
    'cms.type.content': "Contenido",
    'cms.tpl.website': "Sitio web",
    'cms.tpl.logo': "Logo",
    'cms.tpl.teamName': "Equipo",
    'cms.noCollectionsYet': "Aún no hay colecciones. Crea la primera para empezar a guardar contenido.",
    'cms.addFirstField': "Agrega el primer campo personalizado",
    'cms.fieldCount': "{count} campos",
    'cms.scheduleNote': "La vigencia sale de tu campo «{field}». Las listas pueden filtrar por próximas, en curso o terminadas sin configurar nada más.",
    'cms.createFirstCollection': "Crea tu primera colección",
    'pg.withPassword': "Con contraseña",
    'pg.public': "Pública",
    'pg.makeHome': "Hacer página principal",
    'pg.inThisSite': "{count} en este sitio",
    'pg.deleteConfirm': "¿Eliminar \"{name}\"? Esta acción no se puede deshacer.",
    'pg.charsRecommended': "{count} / {max} caracteres recomendados",
    'cms.scheduleHint': "Con esto, una lista puede enseñar sólo lo que está por venir o lo que ya pasó, y se recalcula solo en el navegador.",
    'cms.urlPlaceholder': "publicaciones",
    'cms.editContent': "Editar contenido",
    'blk.h1Hint': "El titular de una sección",
    'blk.h2Hint': "Un apartado dentro de la sección",
    'blk.h3Hint': "Un punto dentro del apartado",
    'blk.imageHint': "De tu biblioteca, subida o por URL",
    'blk.videoHint2': "YouTube o Vimeo",
    'blk.ctaHint': "La acción que quieres que hagan",
    'blk.groupText': "Texto",
    'blk.groupMedia': "Medios",
    'blk.groupSale': "Venta",
    'blk.divider': "Separador",
    'blk.callout': "Destacado",
    'blk.image': "Imagen",
    'blk.video': "Vídeo",
    'blk.cta': "Botón",
    'blk.title1': "Título 1",
    'blk.title2': "Título 2",
    'blk.title3': "Título 3",
    'blk.text': "Texto",
    'blk.buyNow': "Comprar ahora",
    'blk.codeSample': "código",
    'blk.widthFull': "Completa",
    'blk.width': "Ancho {size}",
    'blk.widthS': "S",
    'blk.widthM': "M",
    'blk.widthL': "L",
    'blkKw.text': "parrafo p normal cuerpo",
    'blkKw.h1': "h1 titulo encabezado heading",
    'blkKw.h2': "h2 titulo subtitulo heading",
    'blkKw.h3': "h3 titulo heading",
    'blkKw.bullet': "lista vinetas ul bullets",
    'blkKw.numbered': "lista numeros ol pasos",
    'blkKw.quote': "cita blockquote testimonio",
    'blkKw.callout': "destacado callout aviso nota",
    'blkKw.code': "codigo code pre snippet",
    'blkKw.divider': "separador linea hr divisor",
    'blkKw.image': "imagen foto picture media",
    'blkKw.video': "video youtube vimeo reproductor",
    'blkKw.cta': "boton cta comprar accion enlace",
    'cms.collectionCount': "{count} colecciones",
    'cms.collectionCountOne': "{count} colección",
    'cms.postCount': "{count} publicaciones",
    'cms.postCountOne': "{count} publicación",
    'cms.contentOf': "Contenido de {name}",
    'limit.resourcePages': "páginas",
    'limit.resourceCollections': "colecciones",
    'limit.resourceItems': "elementos",
    'limit.reached': "Límite alcanzado",
    'limit.raise': "Aumentar límites",
    'limit.maxOf': "Llegaste al máximo de {resource} de tu plan {plan}",
    'limit.onTop': "Estás en {plan}, nuestro plan más alto. Si necesitas más capacidad, escríbenos y preparamos una solución a tu medida.",
    'limit.contactUs': "Contactar a véltica",
    'limit.upgradeTo': "Sube a {plan} para seguir creando {resource} y desbloquear más capacidad.",
    'limit.upgradeButton': "Mejorar a {plan}",
    'limit.notNow': "Ahora no",
    'limit.proPrice': "desde $9.50/mes",
    'limit.businessPrice': "desde $19.50/mes",
    'limit.proPages': "30 páginas",
    'limit.proCms': "20 colecciones · 500 elementos",
    'limit.proDomain': "Dominio propio, sin insignia",
    'limit.proAnalytics': "Analíticas completas",
    'limit.bizPages': "Páginas ilimitadas",
    'limit.bizCms': "100 colecciones · 5,000 elementos",
    'limit.bizApps': "Apps de negocio (formularios, inbox, ventas)",
    'limit.bizSupport': "Soporte prioritario",
    'restore.title': "Restaurar una copia",
    'restore.confirm': "¿Restaurar esta versión?",
    'restore.yes': "Sí, restaurar",
    'restore.keepEditing': "Seguir editando",
    'restore.restoring': "Restaurando…",
    'restore.gone': "Esa copia ya no existe.",
    'restore.cannotOpen': "No se pudo abrir la copia",
    'restore.cannotRead': "No se pudo leer la copia.",
    'restore.failed': "No se pudo restaurar.",
    'restore.replaced': "Se reemplaza",
    'restore.untouched': "No se toca",
    'restore.pages': "Las páginas y su contenido",
    'restore.cms': "Las colecciones y elementos del CMS",
    'restore.theme': "El tema y los ajustes del sitio",
    'restore.forms': "Los mensajes de tus formularios",
    'restore.images': "Las imágenes y archivos que subiste",
    'restore.contacts': "Tus contactos y tus ventas",
    'boot.loadingProject': "Cargando proyecto",
    'boot.checkingSession': "Verificando sesión",
    'boot.redirecting': "Redirigiendo",
    'boot.otherAccount': "Este proyecto es de otra cuenta",
    'boot.signInFailed': "No pudimos iniciar tu sesión en el editor",
    'autosave.title': "Autosave · CPU proxy",
    'autosave.hide': "Ocultar (Alt+M)",
    'autosave.perMinute': "Guardados / min",
    'autosave.avgMaxKb': "Prom / Máx KB",
    'autosave.lastReqs': "Reqs último",
    'autosave.duration': "Duración",
    'autosave.lastSend': "Último envío",
    'autosave.none': "Aún sin guardados…",
    'autosave.clear': "Limpiar",
    'ctx.elementActions': "Acciones del elemento",
    'color.linkGlobal': "Asociar color global",
    'color.global': "Color global",
    'color.editGlobal': "Editar color global",
    'boot.backToDashboard': "Volver al dashboard",
    'restore.willRevert': "Tu sitio volverá a como estaba el {when}",
    'restore.undoNote': "Antes de empezar guardamos una copia de la versión actual, así que esto también se puede deshacer.",
    'autosave.avgDuration': "Prom dur: {ms} ms",
    'autosave.errors': "Errores: {count}",
    'ai.title': "Asistente AI",
    'ai.close': "Cerrar el asistente",
    'ai.messageAria': "Mensaje para el asistente AI",
    'ai.inputPlaceholder': "Describe qué quieres cambiar…",
    'ai.sendMessage': "Enviar mensaje",
    'ai.cancelRequest': "Cancelar solicitud",
    'ai.clearSelection': "Quitar selección",
    'ai.copyAnswer': "Copiar respuesta AI",
    'ai.copied': "Copiado",
    'ai.edit': "Editar",
    'ai.discard': "Descartar",
    'ai.confirmApply': "Confirmar y aplicar",
    'ai.mayErr': "La AI puede cometer errores.",
    'ai.whatToChange': "¿Qué quieres cambiar?",
    'ai.page.confirmTitle': "Cambiar toda la página",
    'ai.page.confirmBody': "{texts} textos · {photos} fotos{style}",
    'ai.page.confirmStyle': " · colores y letra",
    'ai.page.confirmCost': "Usa aprox. el {percent}% de tu IA de este mes. Puedes deshacerlo después.",
    'ai.page.confirmCostUnknown': "Gasta bastante más IA que un cambio normal. Puedes deshacerlo después.",
    'ai.page.confirmGo': "Cambiar toda la página",
    'ai.page.confirmCancel': "Cancelar",
    'ai.page.adaptChip': "Adaptar esta página a mi negocio",
    'ai.page.adaptDraft': "Adapta toda esta página (textos, fotos y colores) a mi negocio: ",
    'ai.user': "Usuario",
    'ai.preparing': "Preparando",
    'ai.preparingChange': "Preparando el cambio…",
    'ai.preparingChanges': "Preparando los cambios…",
    'ai.preparingDelete': "Preparando la eliminación…",
    'ai.analyzing': "Analizando…",
    'ai.analyzingRequest': "Analizando la solicitud…",
    'ai.analyzingElement': "Analizando el elemento…",
    'ai.reviewingSection': "Revisando la sección…",
    'ai.reviewingStructure': "Revisando la estructura…",
    'ai.reviewingStyles': "Revisando los estilos…",
    'ai.searchingBest': "Buscando la mejor opción…",
    'ai.creatingElements': "Creando los elementos…",
    'ai.adjustingContent': "Ajustando el contenido…",
    'ai.adjustingDesign': "Ajustando el diseño…",
    'ai.verifyingChange': "Verificando el cambio…",
    'ai.verifyingResult': "Verificando el resultado…",
    'ai.applying': "Aplicando…",
    'ai.applyingSteps': "Aplicando la solicitud por pasos…",
    'ai.updatingBatches': "Actualizando la página por tandas…",
    'ai.changesApplied': "Cambios aplicados",
    'ai.changesUndone': "Cambios deshechos",
    'ai.proposalDiscarded': "Propuesta descartada",
    'ai.cancelled': "Cancelado",
    'ai.requestCancelled': "Solicitud cancelada.",
    'ai.noChanges': "Sin cambios",
    'ai.addItemFailed': "No pude agregar el elemento a la lista.",
    'ai.noChangesNeeded': "Sin cambios necesarios",
    'ai.noTargets': "Sin targets compatibles",
    'ai.notCompleted': "No completado",
    'ai.iconsUpdated': "Iconos actualizados",
    'ai.textsUpdated': "Textos actualizados",
    'ai.imageUpdated': "Imagen profesional actualizada",
    'ai.step1Icons': "Paso 1: iconos actualizados",
    'ai.step2Texts': "Paso 2: textos actualizados",
    'ai.cardsAdded': "Tarjetas agregadas.",
    'ai.cardsDuplicated': "Tarjetas duplicadas y contenido actualizado.",
    'ai.pageBySection': "Página actualizada por secciones.",
    'ai.completedInSteps': "Listo, solicitud completada por pasos.",
    'ai.compactCoordinated': "Cambios compactos coordinados.",
    'ai.solvedLocally': "Esta solicitud se resolvió en el editor sin llamar al modelo.",
    'ai.cannotProcess': "No se pudo procesar la solicitud.",
    'ai.cannotApply': "No se pudieron aplicar los cambios.",
    'ai.noCompatibleChanges': "No encontré cambios compatibles que aplicar.",
    'ai.noLocalTexts': "No encontré textos locales editables. CMS, navegación y menús permanecen protegidos.",
    'ai.checkedAllSections': "Revisé todas las secciones; no había cambios compatibles que aplicar.",
    'ai.someBatchesIncomplete': "Algunas tandas quedaron incompletas; puedes reintentarlas desde el chat.",
    'ai.batchIncomplete': "Una tanda no devolvió todos los textos locales esperados.",
    'ai.pageChanged': "La página cambió durante la solicitud.",
    'ai.pageChangedAnalyzing': "La página cambió mientras la AI analizaba el canvas.",
    'ai.pageChangedCards': "La página cambió mientras se personalizaban las tarjetas.",
    'ai.canvasChanged': "El canvas cambió mientras analizaba la solicitud. Vuelve a seleccionar la sección y reintenta.",
    'ai.pickElementDirect': "Selecciona un elemento antes de enviar una solicitud en modo “Directo”.",
    'ai.pickElementHint': "Selecciona un elemento del sitio y describe el resultado que buscas.",
    'ai.pickPage': "Selecciona una página antes de usar el asistente AI.",
    'ai.savedProjectOnly': "El asistente AI solamente está disponible dentro de un proyecto guardado.",
    'ai.askLinkTarget': "Indica la URL, ruta o ancla exacta que debe usar el enlace.",
    'ai.quotaExhausted': "Agotaste el uso de IA de este mes",
    'ai.modeDirect': "Directo: cambia elementos sin modificar tokens globales.",
    'ai.modeBrand': "Estilo: cambia directamente los tokens globales.",
    'ai.usageThisMonth': "Uso del asistente este mes",
    'ai.usageThisMonthColon': "Uso del asistente este mes:",
    'ai.usageUnlimited': "Uso del asistente este mes: sin límite",
    'ai.noLimit': "Tu cuenta no tiene límite.",
    'ai.tokensIn': "Entrada:",
    'ai.tokensCached': "Entrada en caché:",
    'ai.tokensOut': "Salida:",
    'ai.tokensReasoning': "Razonamiento:",
    'ai.changesLabel': "Cambios:",
    'ai.originalRequest': "Solicitud original:",
    'ai.directLink': "Enlace directo",
    'ai.directChanges': "Cambios directos",
    'ai.offerGrid': "Esta lista muestra tus ofertas: cada tarjeta sale de una oferta. Crea la nueva en el panel (con su nombre y precio) y aparecerá aquí sola.",
    'ai.offerGridCta': "Crear la oferta en el panel",
    'ai.cmsEntryAdded': "Agregué «{name}» a {collection} como borrador. Complétalo en su ficha y publícalo cuando esté listo.",
    'ai.cmsEntryAddedUnnamed': "Agregué una entrada nueva a {collection} como borrador. Complétala en su ficha y publícala cuando esté lista.",
    'ai.cmsEntryOpen': "Abrir la ficha",
    'ai.cmsCollectionPropose': "Aún no tienes dónde guardar esto. Creo la colección «{collection}» con su página, agrego la primera entrada como borrador y pongo su lista aquí.",
    'ai.cmsCollectionCreate': "Crear «{collection}»",
    'ai.cmsCollectionCreated': "Creé «{collection}» con su página y la primera entrada como borrador. Complétala en su ficha y publícala cuando esté lista.",
    'ai.cmsListPlaced': "Su lista quedó en esta página, debajo de la sección seleccionada.",
    'ai.addItemNeedsTexts': "Agregué una copia del elemento. Dime qué textos lleva y los escribo, o cámbialos a mano.",
    'ai.retrying': "Reintentando…",
    'ai.stepNoChanges': "«{step}» no produjo cambios.",
    'ai.changesCount': "{count} cambios",
    'ai.batchIntro': "Claro, haré estos cambios:",
    'ai.changesCountOne': "1 cambio",
    'ai.literalMissing': "No quedó lo que pediste al pie de la letra: {list}. Revísalo o pídemelo de nuevo.",
    'ai.confirmRemoveOne': "¿Quito este elemento?",
    'ai.confirmRemoveMany': "¿Quito estos {count} elementos?",
    'ai.tomorrow': "mañana",
    'ai.days': "días",
    'ai.localTokens': "0 tokens · resuelto localmente",
    'ai.tokensCount': "{count} tokens",
    'ai.calls': "{count} llamadas",
    'ai.cachedNote': "caché (sin consumo nuevo)",
    'ai.inDays': "en {count} días",
    'ai.remainingPct': "Te queda {pct}% de este mes.",
    'ai.howTo.typography': "La letra de todo el sitio está en Marca › Tipografía: ahí eliges la de los títulos y la del texto. O pídemelo, por ejemplo: «cambia la letra a algo más elegante».",
    'ai.howTo.colors': "Los colores del sitio están en Marca › Colores: cambia uno y se aplica en todo el sitio. O pídemelo, por ejemplo: «usa tonos verdes».",
    'ai.howTo.buttons': "El estilo de los botones está en Marca › Botones: forma, color y tamaño para todo el sitio. O pídemelo, por ejemplo: «botones más redondeados».",
    'ai.howTo.cards': "El estilo de las tarjetas está en Marca › Tarjetas: fondo, borde y sombra para todo el sitio.",
    'ai.howTo.icons': "El estilo de los iconos está en Marca › Iconos: color y caja para todo el sitio.",
    'ai.howTo.logo': "Tu logo está en Marca › Logo: súbelo o escribe el nombre de tu negocio.",
    'ai.open.typography': "Abrir Tipografía",
    'ai.open.colors': "Abrir Colores",
    'ai.open.buttons': "Abrir Botones",
    'ai.open.cards': "Abrir Tarjetas",
    'ai.open.icons': "Abrir Iconos",
    'ai.open.logo': "Abrir Logo",
    'ai.resetsOn': "Se reinicia el {date} ({when}).",
    'ai.out.title': "Usaste toda la IA de este mes",
    'ai.out.body': "Vuelve el {date} ({when}). Mientras tanto, todo lo demás sigue funcionando igual.",
    'ai.out.cta': "Ampliar plan",
    'ai.low': "Te queda poca IA este mes: {pct}%.",
    'ai.gen.out': "Ya usaste las generaciones con IA de tu plan.",
    'ai.gen.outHint': "Empieza con una plantilla o en blanco, o amplía tu plan.",
    'ai.meter.title': "Uso de IA este mes",
    'ai.meter.left': "disponible",
    'ai.meter.resets': "Se reinicia el {date} · {when}",
    'ai.meter.unlimited': "Sin límite en tu cuenta",
    'ai.meter.aria': "Uso de IA este mes: {pct}% disponible",
    'ai.usedOfPlan': "Llevas {used} de tu plan{free}. Se reinicia el {date} ({when}).",
    'ai.freeSuffix': " gratuito",
    'ai.sectionsProgress': "{done}/{total} secciones",
    'ai.verifiedChanges': "{count} cambios verificados",
    'ai.undo': "Deshacer",
    'ai.anotherVariant': "Otra variante",
    'ai.retry': "Reintentar",
    'ai.oops.general': "No pude completar este cambio. Inténtalo de nuevo; si el problema continúa, prueba a describirlo de otra forma.",
    'ai.oops.apply.confirm': "Ese cambio borraba elementos y necesita tu confirmación, así que no se cambió nada.",
    'ai.oops.apply.protected': "Parte de lo seleccionado está bloqueado o viene del CMS o del menú, y aquí no se puede cambiar. No se cambió nada.",
    'ai.oops.apply.changed': "Algo de lo que estaba editando cambió o desapareció mientras trabajaba, así que no se cambió nada. Inténtalo de nuevo.",
    'ai.oops.apply.invalid': "La IA propuso un cambio que este elemento no admite, así que no se cambió nada. Prueba a describirlo de otra forma.",
    'ai.oops.busy': "El servicio está recibiendo muchas solicitudes en este momento. Inténtalo de nuevo en unos minutos.",
    'ai.oops.tooLarge': "La selección es demasiado amplia para hacerlo en un solo paso. Selecciona una sección o un elemento más pequeño e inténtalo de nuevo.",
    'ai.oops.unsupported': "Este cambio aún no está disponible para este elemento. Prueba a describirlo de otra forma o selecciona otro elemento.",
    'ai.oops.limit': "Alcanzaste el límite de solicitudes de hoy. Podrás seguir usando el asistente mañana.",
    'ai.oops.offline': "No hay conexión. Revisa tu conexión a internet e inténtalo de nuevo.",
    'ai.oops.upstream': "El servicio de IA no respondió a tiempo o falló al procesar el pedido, así que no se cambió nada. Inténtalo de nuevo.",
    'ai.oops.context': "El asistente no pudo leer el estado del editor; suele pasar tras una actualización. Recarga la página e inténtalo de nuevo.",
    'ai.oops.config': "El asistente no está disponible ahora mismo por un problema de configuración del servidor. No es nada de tu sitio.",
    'ai.retryAgain': "Intentar de nuevo",
    'ai.brandMode': "Estilo",
    'ai.directMode': "Directo",
    'ai.expandPlan': "Ampliar con otro plan",
    'ai.seePlans': "Ver planes",
    'ai.quotaSpent': "Consumiste el 100% de la cuota mensual de tu plan{free}. Se reinicia el {date} ({when}), o puedes ampliarla ahora.",
    'pgnav.group.pages': "Tus páginas",
    'pgnav.group.auto': "Automáticas",
    'pgnav.group.collections': "Contenido",
    'pgnav.catalog.services': "Servicios",
    'pgnav.catalog.digital': "Productos digitales",
    'pgnav.catalog.products': 'Tienda',
    'pgnav.catalog.physical': 'Productos físicos',
    'pgnav.catalog.bookings': "Reservas",
    'pgnav.viewingWith': "Viendo con «{name}». Elegir otra ficha",
    'pgnav.record': "Ficha",
    'pgnav.catalogInDashboard': "Ver las ofertas en el panel",
    'pgnav.catalogCreated': "Página creada con su diseño por defecto. Las ofertas salen en vivo.",
    'designs.previewOnly': 'Crea tu primera oferta para aplicar un diseño.',
    'designs.contentRequired': 'Diseño aplicado. La página no sale en el menú ni en el sitio hasta que tengas una oferta de este tipo.',
    'designs.catalogLoading': 'Tu catálogo todavía está cargando. Inténtalo de nuevo en un momento.',
    'pgnav.card.pages.one': "{count} página",
    'pgnav.card.pages.many': "{count} páginas",
    'pgnav.card.posts.one': "{count} entrada",
    'pgnav.card.posts.many': "{count} entradas",
    'pgnav.card.collections.one': "{count} colección",
    'pgnav.card.collections.many': "{count} colecciones",
    'pgnav.catalogEdit': "Editar el diseño",
    'pgnav.catalogDesign': "Diseñar la página",
    'pgnav.catalogAuto': "Hoy {path} sale con el diseño automático. Ábrela para diseñarla como las demás.",
    'offerTemplate.pageName.products': 'Página de producto',
    'offerTemplate.pageName.services': 'Página de servicio',
    'offerTemplate.pageName.digital': 'Página de producto digital',
    'offerTemplate.pageName.bookings': 'Página de reserva',
    'offerTemplate.card.products': 'Página de cada producto',
    'offerTemplate.card.services': 'Página de cada servicio',
    'offerTemplate.card.digital': 'Página de cada producto digital',
    'offerTemplate.card.bookings': 'Página de cada reserva',
    'offerTemplate.card.meta': 'Un diseño para todos',
    'offerTemplate.hint.auto': 'Por ahora cada una usa la página estándar. Ábrela para diseñar una página que se aplica a todas.',
    'offerTemplate.hint.live': 'Este diseño se aplica a todas al publicar. Precios, fotos y opciones se editan en el panel.',
    'offerTemplate.noOffers': 'Todavía no hay ofertas',
    'designs.empty.preview': 'Vista previa del diseño',
    'contentHint.minimize': 'Minimizar ayuda',
    'contentHint.expand': 'Mostrar ayuda',
    'designs.edit.title': "Diseño aquí, contenido en el dashboard",
    'designs.edit.hint': "Ajusta el diseño aquí. Actualiza tus textos, imágenes y detalles en el dashboard.",
    'designs.edit.cta': "Abrir dashboard",
    'designs.empty.offer.item.title': 'Esta oferta es de ejemplo',
    'designs.empty.offer.list.title': 'Tu primera oferta empieza aquí',
    'designs.empty.blog.title': 'Prepara el diseño de tu blog',
    'offerTemplate.sample.services': "Servicio de ejemplo",
    'offerTemplate.sample.bookings': "Sesión de ejemplo",
    'offerTemplate.sample.digital': "Producto digital de ejemplo",
    'offerTemplate.sample.products': "Producto de ejemplo",
    'offerTemplate.sample.description': "Así se verá la página de cada oferta. Cuando crees la primera, aquí saldrán sus datos.",
    'offerTemplate.sample.feature1': "Acceso ilimitado",
    'offerTemplate.sample.feature2': "Cancela cuando quieras",
    'offerTemplate.sample.feature3': "Beneficios para miembros",
    'offerDetails.emptyHint': "Información del producto: se llena sola con los campos de «Información adicional» de cada oferta (ingredientes, cómo usarlo…). Ésta aún no tiene ninguno rellenado.",
    'offerPreview.title': "Vista previa: la compra está desactivada",
    'offerPreview.body': "Aquí puedes ver cómo queda. En la página publicada, este botón lleva a comprar o a reservar.",
    'offerPreview.close': "Entendido",
    'offerDetails.layout': "Forma",
    'offerDetails.layout.tabs': "Pestañas (acordeón en el móvil)",
    'offerDetails.layout.accordion': "Acordeón",
    'offerDetails.layout.stack': "Uno tras otro",
    'offerDetails.description': "Incluir la descripción",
    'offerDetails.noFields': "Este tipo aún no tiene campos. Añádelos en «Información adicional» de cualquier oferta, o con «+ Nuevo campo…» al enlazar un texto.",
    'bp.offerDetails': "Información del producto",
    'sitemap.new.services': 'Nuevo servicio',
    'sitemap.new.bookings': 'Nuevo servicio con reserva',
    'sitemap.new.digital': 'Nuevo producto digital',
    'sitemap.new.products': 'Nuevo producto',
    'pgnav.catalogLive': "Tus ofertas salen en {path} en vivo: no hace falta republicar al cambiarlas.",
    'pgnav.noPages': "No hay páginas todavía.",
    'pgnav.noCollections': "Todavía no hay contenido.",
    'pgnav.shopCollections': 'Colecciones',
    'pgnav.newCollection': 'Nueva colección',
    'pgnav.noShopCollections': 'Aún no hay colecciones. Créalas en el panel.',
    'pgnav.collectionOpen': 'Abrir su página en el sitio',
    'pgnav.collectionPublishFirst': 'Publica el sitio para ver su página',
    'pgnav.collectionEdit': 'Editar en el panel',
    'pgnav.collectionTemplate': 'Diseño compartido de colecciones',
    'pgnav.collectionPreviews': 'Vista previa por colección',
    'pgnav.collectionPreview': 'Ver la plantilla con esta colección',
    'collectionTemplate.pageName': 'Página de colección',
    'collectionTemplate.field.title': 'Nombre de la colección',
    'collectionTemplate.field.description': 'Descripción de la colección',
    'collectionTemplate.field.image': 'Imagen de la colección',
    'pgnav.manageContent': "Gestionar contenido",
    'pgnav.pickRecord': "Elegir ficha",
    'pgnav.pickRecordHint': "Elegir con qué ficha se ve",
    'pgnav.viewWith': "Ver con",
    'pgnav.pagePreview': "Vista previa de la página",
    'pgnav.restricted': "Restringida",
    'pgnav.listing': "Listado",
    'pgnav.createListing': "Crear página de listado",
    'frm.newField': "Nuevo campo",
    'frm.editField': "Editar campo",
    'frm.fieldType': "Tipo de campo",
    'frm.noLabel': "Sin etiqueta",
    'frm.checkbox': "Casilla",
    'frm.consent': "Casilla de consentimiento",
    'frm.onSubmit': "Mensaje al enviar",
    'frm.onMessage': "Al recibir un mensaje",
    'frm.texts': "Textos",
    'frm.titleField': "Título",
    'frm.notifyEmail': "Avisar por correo a",
    'frm.alsoSendTo': "Enviar también a",
    'frm.invalidEmail': "Escribe un correo válido",
    'frm.alreadyAdded': "Ya está agregado",
    'frm.maxReached': "Máximo alcanzado",
    'frm.titleHint': "Se ve como título y nombra la bandeja de mensajes.",
    'frm.hiddenHint': "Oculto en la página. Sigue nombrando la bandeja de mensajes.",
    'frm.descriptionPlaceholder': "Agrega una breve descripción",
    'frm.namePlaceholder': "contacto, presupuesto…",
    'frm.emailPlaceholder': "correo@empresa.com",
    'frm.samplePlaceholder': "Ej. Juan",
    'frm.moveUp': "Subir",
    'frm.moveDown': "Bajar",
    'frm.noneFem': "Ninguna",
    'frm.tags': "Etiquetas",
    'code.title': "Código personalizado",
    'code.editorAria': "Editor de código personalizado",
    'code.linkCms': "Conectar código del CMS",
    'code.linkedToCms': "Código conectado al CMS",
    'code.pickFieldHint': "Elige un campo de tipo Código. En una lista se usará el valor de cada ficha.",
    'newpg.templates': "Plantillas para la nueva página",
    'newpg.catalog': "Catálogo de plantillas",
    'newpg.categories': "Categorías de plantillas",
    'newpg.createTemplate': "Crear plantilla",
    'newpg.loading': "Cargando templates...",
    'newpg.loadFailed': "No se pudieron cargar los templates.",
    'newpg.createFailed': "No se pudo crear la página.",
    'newpg.preparing': "Preparando página...",
    'newpg.applyingStyle': "Aplicando tu estilo...",
    'newpg.blankPage': "Página en blanco",
    'newpg.blank': "En blanco",
    'newpg.pageType.home': "Inicio",
    'newpg.pageType.about': "Nosotros",
    'newpg.pageType.services': "Servicios",
    'newpg.pageType.pricing': "Precios",
    'newpg.pageType.contact': "Contacto",
    'newpg.pageType.landing': "Landing",
    'newpg.pageType.portfolio': "Portafolio",
    'newpg.editBrand': "Editar estilo →",
    'newpg.template': "Plantilla",
    'nav.contact': "Contacto",
    'frm.submissionsHint': "Cada mensaje llega a la bandeja del panel. Aquí eliges qué más pasa.",
    'frm.typeEnter': "Escribe y presiona Enter",
    'frm.whatTitle': "el título",
    'frm.whatDescription': "la descripción",
    'frm.inbox': "Bandeja",
    'frm.viewsAria': "Secciones del formulario",
    'frm.fieldLabel': "Etiqueta",
    'frm.form': "Formulario",
    'frm.omnisendNone': "Conecta tu cuenta en Configuración → Omnisend, en el panel, para poder activarlo.",
    'frm.omnisendInvalid': "La clave de Omnisend dejó de funcionar. Hasta que la cambies en el panel, no se envía nada.",
    'frm.consentHint': "Sin casilla marcada el contacto llega igual, pero no se suscribe a tus campañas. Escribirte no es pedir la newsletter.",
    'frm.tagsHint': "Ordenan la bandeja del panel. Si el envío a Omnisend está activado, viajan también con el contacto.",
    'frm.addCheckbox': "Añadir casilla",
    'frm.addField': "Añadir campo",
    'newpg.kicker': "Nueva página",
    'newpg.title': "Elige cómo empezar",
    'newpg.lead': "Genera la página con IA o parte de una plantilla. Usará los colores y la letra de tu proyecto.",
    'newpg.templatesTitle': "Plantillas",
    'newpg.previewTitle': "Vista previa",
    'newpg.previewNote': "Con los colores y la letra de tu proyecto",
    'newpg.ai.card': "Generar con IA",
    'newpg.ai.cardHint': "Describe la página y la IA la arma con el estilo de tu sitio.",
    'newpg.ai.promptTitle': "¿Qué página quieres crear?",
    'newpg.ai.placeholder': "Una página de servicios con precios, preguntas frecuentes y una forma clara de contactarnos…",
    'newpg.ai.ideas': "Ideas",
    'newpg.ai.minChars': "Escribe al menos {min} caracteres ({count}/{min})",
    'newpg.ai.generate': "Generar página",
    'newpg.ai.generating': "Generando tu página…",
    'newpg.ai.step.plan': "Pensando qué secciones necesita…",
    'newpg.ai.step.copy': "Escribiendo los textos…",
    'newpg.ai.step.sections': "Eligiendo el diseño de cada sección…",
    'newpg.ai.step.images': "Buscando imágenes…",
    'newpg.ai.errorTitle': "No pudimos generar la página",
    'newpg.ai.errorLead': "Algo falló mientras la IA armaba la página. Inténtalo de nuevo; tu descripción sigue aquí.",
    'newpg.ai.limitTitle': "Ya usaste tus generaciones de hoy",
    'newpg.ai.limitLead': "Mañana puedes volver a generar con IA. Mientras tanto, puedes partir de una plantilla o de una página en blanco.",
    'newpg.ai.edit': "Editar descripción",
    'newpg.ai.retry': "Reintentar",
    'newpg.ai.idea.about': "Sobre nosotros",
    'newpg.ai.idea.aboutPrompt': "Una página «Sobre nosotros» que cuente la historia del negocio, su equipo y sus valores, y termine invitando a contactarnos.",
    'newpg.ai.idea.services': "Servicios",
    'newpg.ai.idea.servicesPrompt': "Una página de servicios con una introducción breve, todos nuestros servicios, cómo trabajamos en tres pasos y una llamada a la acción para pedir información.",
    'newpg.ai.idea.pricing': "Precios",
    'newpg.ai.idea.pricingPrompt': "Una página de planes con nuestros planes mensuales y lo que incluye cada uno, preguntas frecuentes sobre pagos y un botón para empezar.",
    'newpg.ai.seeded': "Dejamos lo que faltaba como borradores «por completar» en tu catálogo.",
    'newpg.ai.seedFailed': "La página se añadió, pero no pudimos crear lo que faltaba. Añádelo desde el catálogo.",
    'newpg.ai.blogOpened': "Tu blog está listo: esta página muestra todas tus entradas.",
    'newpg.ai.idea.faq': "Preguntas frecuentes",
    'newpg.ai.idea.faqPrompt': "Una página de preguntas frecuentes que resuelva las dudas más comunes de los clientes y ofrezca contacto si queda alguna.",
    'newpg.ai.idea.contact': "Contacto",
    'newpg.ai.idea.contactPrompt': "Una página de contacto con las formas de comunicarse, horario de atención y un formulario sencillo.",
    'newpg.sections.kicker': "Paso 2 de 2",
    'newpg.sections.title': "Secciones de tu página",
    'newpg.sections.lead': "Reordénalas, apágalas o prueba otra variante. Cambiar de variante no gasta IA: conserva los mismos textos.",
    'newpg.sections.back': "Volver a elegir",
    'newpg.sections.variant': "Otra variante",
    'newpg.sections.variantHint': "Otro diseño con los mismos textos",
    'newpg.sections.variantNone': "Todavía no hay otras variantes de esta sección.",
    'newpg.sections.up': "Subir",
    'newpg.sections.down': "Bajar",
    'newpg.sections.visible': "Mostrar esta sección",
    'newpg.brandNote': "Los colores y la tipografía son de tu proyecto y se aplican a todas las páginas. La nueva página los hereda.",
    'pgnav.new': "Nueva",
    'reuse.none': "Sin secciones reutilizables",
    'reuse.inThisSite': "Reutilizables en este sitio",
    'reuse.dragHint': "Arrástrala al lienzo para colocarla en esta página",
    'reuse.stopKeeping': "Dejar de mantenerla como reutilizable",
    'reuse.notPlaced': "No está puesta en ninguna página.",
    'reuse.inOnePlace': "En 1 sitio",
    'reuse.inPlaces': "En {count} sitios",
    'reuse.unused': "Sin usar",
    'reuse.placedStays': "La sección puesta se queda",
    'files.locked': "Archivos bloqueados",
    'files.signIn': "Inicia sesión para subir y gestionar archivos.",
    'files.loading': "Cargando archivos…",
    'files.none': "Sin archivos",
    'files.uploadToStart': "Sube una imagen para empezar.",
    'files.more': "Más opciones",
    'files.replaceSelected': "Poner en la imagen seleccionada",
    'files.addToPage': "Agregar a la página",
    'files.showUse.one': "Mostrar dónde se usa (1)",
    'files.showUse.many': "Mostrar dónde se usa ({count})",
    'files.unused': "Sin usar en el sitio",
    'files.deleteUsedTitle': "¿Eliminar esta imagen?",
    'files.deleteUsedBody.one': "Se usa en 1 lugar del sitio. Al eliminarla, ese lugar se quedará sin imagen.",
    'files.deleteUsedBody.many': "Se usa en {count} lugares del sitio. Al eliminarla, esos lugares se quedarán sin imagen.",
    'lib.locked': "Biblioteca bloqueada",
    'lib.empty': "Biblioteca vacía",
    'lib.signIn': "Inicia sesión para explorar la biblioteca profesional.",
    'lib.searchPlaceholder': "Buscar por tema o hashtag…",
    'lib.searchAria': "Buscar imágenes profesionales",
    'lib.loadFailed': "No se pudo cargar la biblioteca.",
    'lib.searching': "Buscando imágenes…",
    'lib.loadingImages': "Cargando imágenes…",
    'lib.loadingMore': "Cargando más…",
    'lib.tryAnother': "Prueba con otro tema o palabra clave.",
    'lib.willAppear': "Las imágenes que agregues aparecerán aquí.",
    'files.uploadMany': "Subir imágenes",
    'files.uploading': "Subiendo…",
    /* Dos claves y no una con variable: en inglés cambia el artículo («an image»)
       y en español el número, así que una sola frase con hueco saldría torcida en
       alguno de los dos. */
    'files.dropOne': "Arrastra una imagen o haz clic para seleccionar",
    /* Los que se escapaban dentro de una plantilla con `${}`: la regla de ESLint
       no mira ahí dentro, así que se encontraron a mano. */
    'img.uploadedMany': "{count} imágenes subidas",
    'img.tabUploads': "Subidos",
    'img.tabGallery': "Galería",
    'img.uploadingOne': "Subiendo tu imagen…",
    'img.uploadingMany': "Subiendo {count} imágenes…",
    'cms.imagesOf': "Imágenes de {name}",
    'el.sectionN': "Sección {n}",
    'common.aboutX': "Información sobre {title}",
    'el.columnTitleN': "Título columna {n}",
    'common.addX': "Añadir {label}",
    'type.format': "Formato",
    'token.tabOff': "{label} está desactivado.",
    'token.tabTurnOn': "Actívalo para editarlo.",
    'common.enableX': "Activar {label}",
    'common.disableX': "Desactivar {label}",
    'common.reset': "Reiniciar",
    'common.resetX': "Reiniciar {label}",
    'form.hideOnPage': "Ocultar {what} en la página",
    'form.showOnPage': "Mostrar {what} en la página",
    'form.maxTags': "Máximo {max}",
    'cms.optionN': "Opción {n}",
    /* El esquema del panel izquierdo. Claves y no texto: es una constante de
       módulo, y una constante no puede llamar a un hook. Lo que dice lo mismo
       en los dos idiomas —«Grid», «XS», «1 col»— se quedó como literal. */
    'panel.styles': "Estilos",
    'panel.combinations': "Combinaciones",
    'panel.showMore': "Mostrar más",
    'panel.colorPalettes': "Paletas de colores",
    'panel.palettes': "Paletas",
    'panel.fontPairing': "Combinación de letras",
    'panel.fontCombos': "Combinaciones tipográficas",
    'panel.globalColors': "Colores Globales",
    'panel.quickActions': "Acciones rápidas",
    'panel.shift': "Desplazar",
    'panel.random': "Aleatorio",
    'panel.primary': "Primario",
    'panel.secondary': "Secundario",
    'panel.surface': "Superficie",
    'panel.neutralLight': "Neutro claro",
    'panel.neutralMid': "Neutro medio",
    'panel.neutralDark': "Neutro oscuro",
    'panel.accent1': "Acento 1",
    'panel.accent2': "Acento 2",
    'panel.solid': "Sólido",
    'panel.gradient': "Degradado",
    'panel.recent': "Recientes",
    'panel.mainHeadings': "Títulos principales",
    'panel.subHeadings': "Títulos secundarios",
    'panel.tertiaryHeadings': "Títulos terciarios",
    'panel.cardHeadings': "Títulos de tarjeta",
    'panel.featuredLabels': "Labels destacados",
    'panel.microcopy': "Microtextos",
    'panel.paragraphs': "Párrafos",
    'panel.smallText': "Textos pequeños",
    'brand.eyebrow': "Antetítulo",
    'panel.typefaces': "Tipografías",
    'panel.textStyles': "Estilos de texto",
    'panel.components': "Componentes",
    'panel.navigation': "Navegación",
    'panel.menu': "Menú",
    'panel.actions': "Acciones",
    'panel.navBackground': "Fondo del nav",
    'panel.behavior': "Comportamiento",
    'panel.sections': "Secciones",
    'panel.height': "Altura",
    'panel.contentWidth': "Ancho del contenido",
    'panel.containers': "Contenedores",
    'panel.childGap': "Gap entre hijos",
    'panel.columns': "Columnas",
    'panel.footerLogo': "Logo del footer",
    'panel.cards': "Tarjetas",
    'panel.variant': "Variante",
    'panel.withImage': "Con imagen",
    'panel.withIcon': "Con icono",
    'panel.contentAlign': "Alineación contenido",
    'panel.images': "Imágenes",
    'panel.fitMode': "Modo de ajuste",
    'panel.radius': "Radio",
    'panel.filter': "Filtro",
    'panel.icons': "Iconos",
    'panel.primaryIcons': "Iconos principales",
    'panel.secondaryIcons': "Iconos secundarios",
    'panel.buttons': "Botones",
    'panel.size': "Tamaño",
    'panel.forms': "Formularios",
    'panel.textInput': "Input de texto",
    'panel.errorMessages': "Mensajes de error",
    'panel.reviews': "Reseñas / Testimonios",
    'panel.bigQuote': "Quote grande",
    'panel.showStars': "Mostrar estrellas",
    'panel.showPhoto': "Mostrar foto",
    'panel.showUserCount': "Mostrar cantidad usuarios",
    'panel.badges': "Etiquetas / Badges",
    'panel.paletteN': "Paleta {n}",
    /* Los colores y estilos de fábrica de la marca. Los que añade el cliente
       llevan el nombre que él escribió y no pasan por aquí. */
    'brand.accent': "Acento",
    'color.globalX': "Color global: {name}",
    'common.editX': "Editar {name}",
    'brand.card': "Tarjeta",
    'brand.borders': "Bordes",
    'brand.paragraph': "Párrafo",
    'brand.buttonPrimary': "Botón principal",
    'brand.buttonSecondary': "Botón secundario",
    'brand.cardBase': "Tarjeta base",
    'brand.contentWidth': "Ancho del contenido",
    'brand.contentWidthMode': "Ancho",
    'brand.contentAuto': "Auto",
    'brand.contentCustom': "A medida",
    'brand.contentFull': "Completo",
    'brand.contentLimited': "Limitado",
    'brand.contentMax': "Ancho máximo",
    'brand.contentWidthHint': "Auto: cada sección mantiene su propio ancho.",
    'brand.sectionBase': "Sección base",
    'brand.sectionSecondary': "Sección secundaria",
    'brand.sectionNav': "Navegación",
    'brand.sectionFooter': "Footer",
    'brand.cardSoft': "Tarjeta con borde",
    'brand.cardColor': "Tarjeta con color",
    'brand.iconPrimary': "Icono principal",
    'brand.iconPlain': "Icono sin fondo",
    'brand.iconSoft': "Icono suave",
    'brand.iconAccent': "Icono destacado",
    /* Looks listos por familia, en el panel Estilo. */
    'looks.color': "Color",
    'looks.colorHint': "Paletas que combinan entre sí",
    'looks.fontHint': "Parejas de letra para títulos y texto",
    'looks.buttonsHint': "Formas y estilos de botón",
    'looks.cardsHint': "Esquinas, bordes y sombras",
    'looks.sectionsHint': "Espacio entre secciones y el menú",
    'looks.font': "Fuente",
    'looks.buttons': "Botones",
    /* Estilos de diseño de Combinations. */
    'design.hint': "Cambia todo el sitio de una vez: colores, fuentes, botones, tarjetas y espacios. Después cada parte se puede ajustar.",
    'design.product': "Producto",
    'design.product.desc': "Blanco, gris perla y un azul de acción. Títulos apretados y mucho aire",
    'design.precision': "Precisión oscuro",
    'design.precision.desc': "Casi negro de software, bordes finos y botones claros pequeños",
    'design.notebook': "Cuaderno 2D",
    'design.notebook.desc': "Blanco papel, líneas de tinta y sombras planas",
    'design.brutalist': "Brutalista",
    'design.brutalist.desc': "Hueso, negro y naranja con bordes de 2px y sombras duras",
    'design.studio': "Estudio",
    'design.studio.desc': "Blanco y negro con un azul vivo, tarjetas grandes redondeadas",
    'design.wireframe': "Wireframe",
    'design.wireframe.desc': "La estructura a la vista: líneas negras y esquinas rectas",
    'design.creator': "Creador",
    'design.creator.desc': "Limpio, de plataforma de cursos, con un azul de confianza",
    'design.marketplace': "Marketplace",
    'design.marketplace.desc': "Denso y ordenado, botón de compra amarillo, bordes finos",
    'design.editorial': "Editorial",
    'design.editorial.desc': "Grandes titulares serif finos sobre papel cálido",
    'design.luxury': "Lujo discreto",
    'design.luxury.desc': "Marfil, casi negro y dorado apagado con mayúsculas espaciadas",
    'design.swiss': "Suizo",
    'design.swiss.desc': "Grotesca apretada, negro y rojo, nada redondeado",
    'design.fintech': "Fintech",
    'design.fintech.desc': "Títulos azul noche, acciones en violeta, tarjetas que flotan",
    'design.consulting': "Consultoría",
    'design.consulting.desc': "Azul marino profundo, serif sobria, bloques rectos",
    'design.gallery': "Galería",
    'design.gallery.desc': "Piedra cálida, una nota terracota y mucho aire",
    'design.calm': "Calma",
    'design.calm.desc': "Blanco roto y verde bosque con una serif amable",
    'design.heritage': "Tradición",
    'design.heritage.desc': "Azul tinta y dorado viejo con una serif clásica",
    'design.developer': "Desarrollo",
    'design.developer.desc': "Negro puro, botones blancos, bordes finísimos",
    'design.clay': "Tech cálido",
    'design.clay.desc': "Crema, casi negro y arcilla con títulos serif",
    'design.retail': "Retail",
    'design.retail.desc': "Blanco y negro con botones anchos en mayúsculas",
    'design.nordic': "Nórdico",
    'design.nordic.desc': "Gris niebla, pizarra y azul acero, suave y ligero",
    'looks.cards': "Tarjeta",
    /* La revisión de plantillas antes de publicarlas (ver `templateContract`). */
    'contract.title': "Revisión de la plantilla",
    'contract.clean': "Todo sigue el sistema de estilos: cambiará con cualquier estilo.",
    'contract.summary': "Errores: {errors} · Advertencias: {warnings}. Lo que tiene un error se queda igual cuando alguien elige otro estilo.",
    'contract.blocked': "Corrige los errores para publicarla en la biblioteca.",
    'contract.fixAll': "Enlazar automáticamente ({count})",
    'contract.publishAnyway': "Publicar igualmente",
    'contract.view': "Ver",
    'contract.autoFix': "se enlaza solo",
    'contract.prop.color': "color del texto",
    'contract.prop.background': "fondo",
    'contract.prop.backgroundColor': "fondo",
    'contract.prop.borderColor': "color del borde",
    'contract.kind.color-unmatched': "Color escrito a mano en el {detail}, fuera de la paleta",
    'contract.kind.color-auto': "El {detail} coincide con un color de la paleta pero no está enlazado",
    'contract.kind.custom-token': "Usa un estilo que sólo tiene esta plantilla ({detail}); otros sitios no lo tendrán",
    'contract.kind.gradient': "Degradado con colores fijos",
    'contract.kind.font-family': "Fuente puesta en el elemento: no seguirá las fuentes del estilo",
    'contract.kind.font-size': "Tamaño propio en vez del de su estilo de texto",
    'contract.kind.no-typography': "Texto sin estilo de texto",
    'contract.kind.no-button-style': "Botón sin estilo global de botón",
    'contract.kind.card-unlinked': "Parece una tarjeta pero no usa un estilo de tarjeta",
    'color.alternate': "Fondo alterno",
    'color.mutedText': "Texto secundario",
    'looks.group.shape': "Forma",
    'looks.group.shadow': "Sombra",
    'looks.group.inner': "Sombra interna",
    'looks.group.size': "Tamaño",
    'looks.group.text': "Texto",
    'looks.group.weight': "Peso",
    'looks.group.spacing': "Espaciado",
    'looks.button.pill': "Píldora",
    'looks.button.rounded': "Redondeado",
    'looks.button.square': "Cuadrado suave",
    'looks.button.sharp': "Recto",
    'looks.button.tonal': "Píldora tonal",
    'looks.button.tonalRounded': "Tonal",
    'looks.button.outlinePill': "Píldora con contorno",
    'looks.button.outline': "Contorno",
    'looks.button.ghost': "Fantasma",
    'looks.button.link': "Enlace de texto",
    'looks.button.inked': "Línea de tinta",
    'looks.button.brutal': "Brutalista",
    'looks.shadow.none': "Ninguna",
    'looks.shadow.hairline': "Finísima",
    'looks.shadow.subtle': "Sutil",
    'looks.shadow.soft': "Suave",
    'looks.shadow.medium': "Media",
    'looks.shadow.large': "Grande",
    'looks.shadow.hard2d': "Plana 2D",
    'looks.shadow.hard': "Desplazada",
    'looks.inner.none': "Ninguna",
    'looks.inner.highlight': "Brillo arriba",
    'looks.inner.ring': "Aro interno",
    'looks.inner.bevel': "Bisel",
    'looks.inner.soft': "Interna suave",
    'looks.size.small': "Pequeño",
    'looks.size.compact': "Compacto",
    'looks.size.regular': "Normal",
    'looks.size.large': "Grande",
    'looks.size.wide': "Ancho",
    'looks.text.normal': "Normal",
    'looks.text.tight': "Ajustado",
    'looks.text.uppercase': "Mayúsculas",
    'looks.text.spaced': "Mayúsculas espaciadas",
    'looks.weight.regular': "Normal",
    'looks.weight.medium': "Medio",
    'looks.weight.semibold': "Seminegrita",
    'looks.weight.bold': "Negrita",
    'looks.card.hairline': "Línea fina",
    'looks.card.outlined': "Con borde",
    'looks.card.box': "Caja",
    'looks.card.soft': "Suave",
    'looks.card.rounded': "Redondeada",
    'looks.card.flat': "Plana",
    'looks.card.square': "Cuadrada lisa",
    'looks.card.sharp': "Recta",
    'looks.card.ink': "Línea de tinta",
    'looks.card.bold': "Marcada",
    'looks.spacing.compact': "Compacto",
    'looks.spacing.regular': "Normal",
    'looks.spacing.comfortable': "Cómodo",
    'looks.spacing.roomy': "Holgado",
    'looks.spacing.spacious': "Muy amplio",
    'looks.sections': "Secciones",
    'looks.section.spacingHint': "El espacio arriba y abajo de cada sección. Se reduce en iPad y móvil.",
    'looks.section.spacingTab': "Espaciado",
    'looks.nav.tab': "Barra de navegación",
    'looks.nav.hint': "Cómo se separa la barra de la página. Vale para la barra de todo el sitio.",
    'looks.nav.none': "Sin separación",
    'looks.nav.line': "Línea fina",
    'looks.nav.ink': "Línea de tinta",
    'looks.nav.bold': "Línea gruesa",
    'looks.nav.tinted': "Barra tintada",
    'looks.nav.tintedLine': "Tintada con línea",
    'looks.section.tight': "Mínimo",
    'looks.section.spacious': "Muy amplio",
    'looks.section.compact': "Compacto",
    'looks.section.balanced': "Equilibrado",
    'looks.section.airy': "Amplio",
    /* El menú del botón derecho en el lienzo. */
    'flex.grid': "Cuadrícula",
    'menu.resetLayout': "Restablecer disposición",
    'menu.bringForward': "Subir capa",
    'menu.sendBackward': "Bajar capa",
    'menu.selectContainer': "Seleccionar contenedor",
    'menu.block': "Bloque",
    'menu.section': "Sección",
    'menu.cut': "Cortar",
    'menu.copy': "Copiar",
    'menu.paste': "Pegar",
    'menu.duplicate': "Duplicar",
    'menu.groupIntoBlock': "Agrupar en un bloque",
    'menu.wrapIn': "Envolver en",
    'menu.design': "Diseño",
    'menu.saveToMySections': "Guardar en Mis secciones",
    'menu.reuse': "Reutilizar",
    'menu.delete': "Eliminar",
    'menu.lock': "Bloquear elemento",
    'menu.unlock': "Desbloquear elemento",
    'menu.showOn': "Mostrar en {device}",
    'menu.hideOn': "Ocultar en {device}",
    'menu.makeReusable': "Convertir en reutilizable",
    'menu.unlinkReusable': "Desvincular reutilizable",
    /* El panel derecho. Lo que dice igual en los dos idiomas —«Grid», «Gap»,
       «Padding V»— se quedó como literal. */
    'panel.content': "Contenido",
    'panel.after': "Después",
    'panel.iconOne': "Icono",
    'panel.stars': "Estrellas",
    'panel.avatars': "Avatares",
    'panel.direction': "Dirección",
    'panel.element': "Elemento",
    'panel.fit': "Ajuste",
    'panel.focus': "Foco",
    'panel.crop': "Recorte",
    'panel.iconPx': "Icono px",
    'panel.starPx': "Estrella px",
    'panel.avatarPx': "Avatar px",
    'panel.border': "Borde",
    'panel.effects': "Efectos",
    /* El resumen del proyecto. `overview.row.*` decide qué dice el botón de
       cada fila, y va por el TIPO de lista, no por su título: comparar contra el
       texto de pantalla dejaba de funcionar en cuanto se traducía. */
    'common.user': "Usuario",
    'greet.morning': "Buenos días, {name}",
    'greet.afternoon': "Buenas tardes, {name}",
    'greet.evening': "Buenas noches, {name}",
    'time.inOneDay': "en 1 día",
    'time.inNDays': "en {n} días",
    'overview.unnamedSubmission': "Envío sin nombre",
    'pages.home': "Inicio",
    'overview.stats': "Estadísticas",
    'overview.payouts': "Depósitos",
    'overview.nextPayout': "Próximo depósito",
    'overview.yourBalance': "Tu saldo",
    'overview.stripeNotEnabled': "Stripe aún no los habilita",
    'overview.perStripeSchedule': "Según tu calendario en Stripe",
    'overview.deductedNext': "Se descuenta del próximo depósito",
    'overview.readyToPayout': "Listo para depositarse",
    'overview.analyticsSummary': "Visitas",
    'overview.visitsSoon': "Las visitas a tu sitio aparecerán aquí en cuanto lleguen.",
    'overview.publishToMeasure': "Publica tu sitio para empezar a medir tráfico.",
    'overview.underReview': "En revisión",
    'overview.transferInvite': "Recibiste una invitación para aceptar la transferencia de un sitio. Revisa arriba sus detalles y el contenido incluido.",
    'overview.teamInvite': "Te invitaron a un equipo. La invitación está ahí arriba esperando respuesta.",
    'onboard.pages': "Agrega páginas a tu sitio",
    'onboard.pagesBody': "Construye la estructura y navegación de tu sitio.",
    'onboard.goPages': "Ir a Páginas",
    'onboard.content': "Crea contenido con el CMS",
    'onboard.contentBody': "Organiza publicaciones y contenido dinámico.",
    'onboard.goContent': "Ir a Contenido",
    'onboard.offer': "Crea tu primera oferta",
    'onboard.offerBody': "Vende un servicio, un producto digital o reservas.",
    'onboard.goOffer': "Crear oferta",
    'onboard.publish': "Publica tu sitio",
    'onboard.publishBody': "Pon tu proyecto en línea y compártelo con todos.",
    'onboard.goEditor': "Abrir Editor",
    'overview.editWidgets': "Editar widgets",
    'overview.editingWidgets': 'Muévelos, cámbiales el ancho o quita alguno. Nada de esto es definitivo: puedes devolverlo cuando quieras.',
    'overview.editingWidgetsGreeting': 'Acomodemos esto',
    'widgets.allPlaced': "Todos los widgets están puestos",
    'widgets.editingLabel': "Editando widgets",
    'widgets.addPlaceholder': 'Agregar un widget',
    'widgets.add': "Agregar widget ({n})",
    'overview.seeMore': "Ver más",
    'overview.seeAll': "Ver todas",
    'time.today': "Hoy",
    'time.yesterday': "Ayer",
    'time.daysAgo': "Hace {n} días",
    'overview.linkCopied': "Enlace copiado",
    'overview.copyLink': "Copiar enlace",
    'common.copied': "Copiado",
    'overview.previousPeriod': "Periodo anterior",
    'overview.moreActionsFor': "Más acciones para {name}",
    'overview.seeNMore': "Ver {n} más",
    'overview.openInEditor': "Abrir en editor",
    'common.settings': "Ajustes",
    'overview.openPublished': "Abrir publicada",
    'overview.livesite': "Sitio publicado",
    'overview.tipPublished': "Última publicación",
    'overview.tipEdited': "Última edición en el editor",
    'overview.revenue': "Ingresos",
    'overview.sales': "Ventas",
    'chart.range': "{from} a {to}",
    'chart.aria': "{what}. Máximo {max}.",
    'pages.deletedOne': "{n} página eliminada",
    'pages.deletedMany': "{n} páginas eliminadas",
    'pages.subtitle': "Crea, organiza y administra las páginas de tu sitio.",
    'pages.internal': "Páginas internas",
    'pages.thisPage': "esta página",
    'pages.lastEdited': "Última edición",
    'list.deselectAll': "Quitar la selección de todas",
    'list.selectAllOnPage': "Seleccionar todas las de esta página",
    'list.selectX': "Seleccionar {name}",
    'list.starX': "Destacar {name}",
    'forms.subtitle': "Administra los mensajes recibidos desde tu sitio web.",
    'forms.monthlySubmissions': "Envíos este mes",
    'forms.markRead': "Marcar como leído",
    'forms.markUnread': "Marcar como no leído",
    'forms.unit': "envíos",
    'style.modern': "Moderno",
    'style.elegant': "Elegante",
    'style.warm': "Cálido",
    'style.night': "Nocturno",
    'font.serifClassic': "Serif / Clásico",
    'font.sansModern': "Sans / Moderno",
    'language.suggest': "Parece que estás en una zona donde se habla {language}.",
    'language.suggestSwitch': "Cambiar",
    /* El tutorial del editor. Cuatro pasos, y cada uno se cumple haciéndolo. */
    'svcw.info.accentBrand': "El de tu marca",
    'svcw.info.accentOther': "Otro color",
    /* El tema y el contacto se preguntan aquí desde que dejaron de ser campos
       sueltos en la ficha del servicio: la ficha enseña y el asistente pregunta,
       como en el resto del panel. */
    'svcw.info.themeHint': 'Cómo se ve la página de reserva. «Automático» sigue el tema del dispositivo de quien reserva.',
    'svcw.cancel.contact': 'A quién escribe el cliente',
    'svcw.cancel.contactHint': 'El correo y el teléfono que se enseñan en su reservación, para cuando necesite hablar contigo.',
    'svcw.cancel.contactDefault': 'El correo de avisos de tu proyecto',
    'onb.progress': "Paso {index} de {total}",
    'onb.skip': "Saltar",
    'onb.skipSteps': "Saltar estos pasos",
    'onb.skipStepsHint': "Conserva los tips de los paneles.",
    'onb.skipAll': "Saltar toda la ayuda",
    'onb.skipAllHint': "Cierra el tutorial y los tips de los paneles.",
    'onb.rail.about': "Acerca de {panel}",
    'onb.rail.eyebrow': "Conoce este panel",
    'onb.rail.gotIt': "Entendido",
    'onb.rail.return': "Volver al tutorial",
    'onb.rail.templates.body': "Añade secciones listas para usar a tu página.",
    'onb.rail.templates.tip1': "Elige una categoría para explorar sus diseños.",
    'onb.rail.templates.tip2': "Arrastra una plantilla al canvas o pulsa Añadir.",
    'onb.rail.catalog.body': "Crea ofertas y elige cómo se ven en tu página.",
    'onb.rail.catalog.tip1': "Añade productos, archivos digitales, reservas o servicios.",
    'onb.rail.catalog.tip2': "Arrastra una oferta o un diseño de catálogo al canvas.",
    'onb.rail.blog.body': "Crea entradas y añade tu blog a la página.",
    'onb.rail.blog.tip1': "Elige un diseño para una entrada o para las más recientes.",
    'onb.rail.blog.tip2': "Arrastra un diseño al canvas para ponerlo en tu página.",
    'onb.rail.collections.body': "Muestra en tu página el contenido de tus colecciones: un equipo, un portafolio, mascotas en adopción…",
    'onb.rail.collections.tip1': "Abre una colección y elige una lista o una sola entrada.",
    'onb.rail.collections.tip2': "Arrastra el diseño al canvas: se llena solo con tus entradas.",
    'onb.rail.styles.body': "Cambia el diseño de todo tu sitio.",
    'onb.rail.styles.tip1': "Ajusta los colores, las fuentes y el estilo de los botones.",
    'onb.rail.styles.tip2': "Prueba una combinación de diseño para cambiar el estilo completo.",
    'onb.rail.images.body': "Encuentra fotos para tu página en la galería de imágenes.",
    'onb.rail.images.tip1': "Arrastra una foto sobre una imagen del canvas para reemplazarla.",
    'onb.rail.images.tip2': "Usa el buscador para encontrar una imagen acorde a tu contenido.",
    'onb.rail.files.body': "Sube y organiza los archivos de tu sitio.",
    'onb.rail.files.tip1': "Usa tus imágenes subidas para reemplazar una del canvas.",
    'onb.rail.files.tip2': "Revisa dónde se usa cada archivo antes de eliminarlo.",
    'onb.rail.layers.body': "Explora y organiza la estructura de tu página.",
    'onb.rail.layers.tip1': "Abre las flechas para seleccionar elementos dentro de cada sección.",
    'onb.rail.layers.tip2': "Arrastra las secciones o usa subir y bajar para cambiar su posición.",
    'onb.rail.insert.body': "Añade elementos individuales a tu página.",
    'onb.rail.insert.tip1': "Arrastra textos, imágenes o botones al canvas.",
    'onb.rail.insert.tip2': "Selecciona un elemento para ajustar sus propiedades.",
    'onb.rail.pages.body': "Administra las páginas y la navegación de tu sitio.",
    'onb.rail.pages.tip1': "Crea una página con IA, una plantilla o desde cero.",
    'onb.rail.pages.tip2': "Abre los ajustes de una página para cambiar su nombre, dirección y SEO.",
    'onb.rail.cms.body': "Organiza tu contenido en colecciones.",
    'onb.rail.cms.tip1': "Crea una colección para entradas, proyectos u otro listado.",
    'onb.rail.cms.tip2': "Conecta los campos a elementos del canvas para crear páginas dinámicas.",
    /* Los dos momentos del primer paso: el lienzo y el selector. */
    'onb.section.rail.title': "Añade una sección",
    'onb.section.rail.body': "Pulsa + entre las secciones, o el botón morado si el lienzo está vacío.",
    'onb.section.panel.title': "Elige un tipo",
    'onb.section.panel.body': "Pulsa una categoría (un encabezado, unas tarjetas, un pie) y verás las plantillas de ese tipo.",
    'onb.section.popup.title': "Elige una plantilla",
    'onb.section.popup.body': "Selecciona un diseño para ver su vista previa.",
    'onb.section.add.title': "Añade la sección",
    'onb.section.add.body': "Pulsa Añadir sección para colocarla en la página. Después podrás cambiar todo.",
    'onb.text.title': "Cambia un texto",
    'onb.text.body': "Haz clic en un texto resaltado y luego en «Editar texto» de la barra contextual.",
    'onb.text.edit.title': "Ahora pulsa «Editar texto»",
    'onb.text.edit.body': "Escribe lo tuyo y haz clic fuera del texto para guardarlo.",
    'onb.done.title': "¡Tu sitio está en línea!",
    'onb.done.body': "Pusiste una sección, la hiciste tuya y la publicaste. Ya la puede ver cualquiera con el enlace.",
    'onb.done.view': "Ver mi sitio",
    'onb.done.keep': "Seguir editando",
    'pub.done.body': "Tus últimos cambios ya están publicados. Cualquiera con el enlace ya puede verlos.",
    'onb.publish.title': "Publica",
    'onb.publish.body': "Pulsa Publicar arriba a la derecha y tu sitio tendrá una dirección que funciona.",
    'cwa.charsLeft': "Te quedan {count} caracteres",
    'cwa.generateShortcut': "Generar mi sitio (⌘↵)",
    'cwa.step.business': "Negocio",
    'cwa.hue': "Tono",
    'cwa.hueHint': "Gira el tono de toda la paleta: fondos, tarjetas y botones cambian juntos, así que siguen combinando.",
    'cwa.hueOriginal': "Tono original",
    'cwa.paletteGroup.suggested': "Sugeridas",
    'cwa.paletteGroup.moderno': "Modernas",
    'cwa.paletteGroup.calido': "Cálidas",
    'cwa.paletteGroup.elegante': "Elegantes",
    'cwa.paletteGroup.nocturno': "Oscuras",
    'cwa.paletteAi': "La paleta que eligió la IA",
    'cwa.paletteAiBadge': "IA",
    'cwa.paletteOwn': "La paleta del estilo",
    'cwa.paletteOwnBadge': "Estilo",
    'cwa.paletteYours': "Tu paleta",
    'cwa.paletteByAi': "Creada por la IA",
    'cwa.paletteOfStyle': "Paleta del estilo",
    'cwa.fontByAi': "Creada por la IA",
    'cwa.fontOfStyle': "Del estilo",
    'cwa.styleOfCombination': "De tu combinación",
    'cwa.paletteMore': "Otras paletas",
    'cwa.paletteYoursHint': "Los colores que usará tu sitio. Pulsa uno para cambiarlo.",
    'cwa.paletteCurrent': "La paleta elegida",
    'cwa.paletteCurrentBadge': "Elegida",
    'cwa.wz.error.title': "No pudimos generar tu sitio",
    'cwa.wz.error.lead': "Algo falló mientras la IA armaba tu sitio. Inténtalo de nuevo; tu descripción sigue guardada.",
    'cwa.wz.error.createLead': "No se pudo crear el proyecto. Inténtalo de nuevo en un momento.",
    'cwa.wz.error.edit': "Editar descripción",
    'cwa.wz.limit.title': "Ya usaste tus generaciones de hoy",
    'cwa.wz.limit.lead': "Mañana puedes volver a crear sitios con IA. Mientras tanto, puedes empezar desde una plantilla o con un proyecto en blanco.",
    'cwa.wz.limit.other': "Empezar de otra forma",
    'cwa.wz.limit.foot': "El límite se renueva cada día.",
    'cwa.variantNone': "Todavía no hay otras variantes de esta sección.",
    'cwa.step.contact': "Contacto",
    'cwa.wz.dialogAria': "Crear sitio con IA",
    'cwa.wz.progressAria': "Pasos para crear tu sitio",
    'cwa.wz.kicker': "Paso {n} de {total}",
    'cwa.wz.info.title': "Tu negocio",
    'cwa.wz.info.lead': "El nombre y el logo con los que te van a reconocer. La IA ya propuso un nombre: cámbialo si quieres.",
    'cwa.wz.style.title': "Elige un estilo",
    'cwa.wz.style.lead': "La forma del sitio: botones, tarjetas, bordes y aire entre secciones. Tus colores y tu letra se quedan como los elegiste.",
    'cwa.wz.colors.title': "Colores",
    'cwa.wz.colors.lead': "Tus colores, listos para usar. Cambia el que quieras o prueba otra paleta.",
    'cwa.wz.fonts.title': "Tipografía",
    'cwa.wz.fonts.lead': "La letra de los títulos y la del texto. Mira cómo queda en la vista previa antes de decidir.",
    'cwa.wz.sections.title': "Secciones de tu sitio",
    'cwa.wz.sections.lead': "Reordénalas, apágalas o prueba otra variante. La variante nueva conserva los mismos textos.",
    'cwa.wz.contact.title': "Contacto y redes",
    'cwa.wz.contact.lead': "Añade sólo lo que quieras mostrar: correo, teléfono, WhatsApp o tus redes. Todo lo que añadas aparece en el pie de tu sitio.",
    'cwa.wz.previewNote': "Así se verá tu sitio",
    'cwa.wz.createNow': "Crear ya con esto",
    'cwa.wz.generating.plan': "Pensando la estructura de tu sitio…",
    'cwa.wz.generating.copy': "Escribiendo los textos…",
    'cwa.wz.generating.sections': "Eligiendo las secciones que mejor encajan…",
    'cwa.wz.generating.images': "Buscando imágenes para tu negocio…",
    'cwa.wz.generating.style': "Aplicando colores y tipografía…",
    'cwa.businessNamePlaceholder': "Café Luna",
    'cwa.logoUpload': "Subir un logo",
    'cwa.logoChange': "Cambiar",
    'cwa.logoRemove': "Quitar",
    'cwa.brandColorHint': "Va en los botones, los enlaces y los acentos.",
    'cwa.fromStyleColor': "El color que trae el estilo",
    'cwa.palettesHint': "Elige una para partir de ella: sus colores suben a tu paleta y ahí los ajustas.",
    'cwa.fromStylePalette': "Los fondos y el texto del estilo",
    'cwa.fromStyleFont': "La letra que trae el estilo",
    'cwa.fontFilter.all': "Todas",
    'cwa.fontFilter.sans': "Sin serifa",
    'cwa.fontFilter.script': "Cursivas",
    'cwa.fontFilter.serif': "Con serifa",
    'cwa.fontSingle': "Una sola familia para todo",
    'cwa.buttonsHint': "Elige un grupo y prueba una opción. Pulsa otra vez para volver a la del estilo.",
    'cwa.cardsHint': "Cómo se ven los bloques de servicios, precios y opiniones.",
    'cwa.spacingHint': "Más aire se siente más calmado; menos, más directo.",
    'cwa.contact.added': "En tu sitio",
    'cwa.contact.addedHint': "Aparecen en el pie de página, en ese orden.",
    'cwa.contact.empty': "Todavía no añadiste nada. Elige abajo lo que quieras mostrar.",
    'cwa.contact.needed': "Tu página muestra estos datos. Complétalos o en el sitio saldrán como «Agrega tu…».",
    'cwa.contact.neededTag': "Lo muestra tu página",
    'cwa.contact.neededMap': "Lo pide el mapa de tu página",
    'cwa.hours.title': "Horario",
    'cwa.slider.prev': "Anteriores",
    'cwa.slider.next': "Siguientes",
    'cwa.paletteEdit': "Cambiar colores",
    'cwa.paletteHide': "Listo",
    'cwa.sheet.open': "Abrir el paso",
    'cwa.sheet.close': "Plegar para ver la página",
    'cwa.locations.title': "Sucursales",
    'cwa.locations.hint': "Sólo si tienes más de una. Con una, la dirección de arriba basta.",
    'cwa.locations.name': "Nombre",
    'cwa.locations.namePlaceholder': "Sucursal Centro",
    'cwa.locations.address': "Dirección",
    'cwa.locations.addressPlaceholder': "Calle, número y colonia",
    'cwa.locations.phone': "Teléfono",
    'cwa.locations.hours': "Horario",
    'cwa.locations.add': "Agregar otra sucursal",
    'cwa.hours.hint': "Sale en el mapa, en el contacto y en el pie de tu sitio.",
    'cwa.hours.needed': "Tu página muestra un horario: agrega el tuyo o saldrá el de ejemplo.",
    'cwa.hours.days': "Días",
    'cwa.hours.daysPlaceholder': "Lunes a viernes",
    'cwa.hours.time': "Horas",
    'cwa.hours.timePlaceholder': "9:00 – 18:00",
    'cwa.hours.add': "Agregar horario",
    'cwa.contact.add': "Añadir",
    'cwa.contact.remove': "Quitar",
    'cwa.contact.group.contact': "Contacto",
    'cwa.contact.group.social': "Redes y web",
    'cwa.contact.kind.email': "Correo",
    'cwa.contact.kind.phone': "Teléfono",
    'cwa.contact.kind.whatsapp': "WhatsApp",
    'cwa.contact.kind.address': "Dirección",
    'cwa.contact.kind.instagram': "Instagram",
    'cwa.contact.kind.facebook': "Facebook",
    'cwa.contact.kind.linkedin': "LinkedIn",
    'cwa.contact.kind.tiktok': "TikTok",
    'cwa.contact.kind.x': "X",
    'cwa.contact.kind.youtube': "YouTube",
    'cwa.contact.kind.website': "Sitio web",
    'cwa.contact.placeholder.email': "hola@tunegocio.com",
    'cwa.contact.placeholder.phone': "Número",
    'cwa.contact.placeholder.whatsapp': "Número",
    'cwa.contact.placeholder.address': "Calle, número, ciudad",
    'cwa.contact.placeholder.instagram': "@tunegocio",
    'cwa.contact.placeholder.facebook': "facebook.com/tunegocio",
    'cwa.contact.placeholder.linkedin': "linkedin.com/company/tunegocio",
    'cwa.contact.placeholder.tiktok': "@tunegocio",
    'cwa.contact.placeholder.x': "@tunegocio",
    'cwa.contact.placeholder.youtube': "@tunegocio",
    'cwa.contact.placeholder.website': "tunegocio.com",
    'auth.signupHeroAria': "Arquitectura urbana iluminada por el atardecer",
    'create.blankPage': "Página en blanco",
    'create.blankPageBody': "Empieza desde cero con un lienzo vacío.",
    'create.newProject': "Nuevo proyecto",
    'create.stepOf': "Paso {n} de {total}",
    'orders.subtitle': "Las ventas que Stripe ha confirmado. El dinero entra directo en la cuenta del sitio, no pasa por Veltica.",
    'an.loadFailed': "No se pudieron cargar las analíticas.",
    'an.noCountries': "Sin países registrados.",
    'an.moreCountries': "Más países",
    'an.noPages': "Sin páginas registradas.",
    'an.noDevices': "Sin dispositivos registrados todavía.",
    'an.term': "Término",
    'an.noCampaigns': "Sin campañas registradas.",
    'an.noSources': "Sin fuentes registradas.",
    'an.direct': "Directo",
    'an.views': "Vistas",
    'an.viewsUnit': "vistas",
    'an.source': "Fuente",
    'an.medium': "Medio",
    'an.content': "Contenido",
    'an.device': "Dispositivo",
    'team.loadFailed': "No se pudo cargar la información del equipo. Inténtalo de nuevo.",
    'team.inviteFailed': "No se pudo enviar la invitación. Inténtalo de nuevo.",
    'team.roleSaveFailed': "No se pudieron guardar los cambios de rol. Inténtalo de nuevo.",
    'team.actionFailed': "No se pudo completar la acción. Inténtalo de nuevo.",
    'team.seatsUnlimitedOne': "{count} colaborador activo · sin límite de asientos",
    'team.seatsUnlimitedMany': "{count} colaboradores activos · sin límite de asientos",
    'team.seatsUsedOne': "{used} de {limit} asiento utilizado",
    'team.seatsUsedMany': "{used} de {limit} asientos utilizados",
    'team.noSeatsIncluded': "Tu plan no incluye asientos para colaboradores.",
    'team.seatLimit': "Has alcanzado el límite de asientos de tu plan.",
    'team.upgradeToCollaborate': "Cambia de plan para habilitar la colaboración en este proyecto.",
    'team.freeUpSeats': "Cancela una invitación, revoca un acceso existente o cambia de plan para liberar capacidad.",
    'team.upgradeCta': "Mejorar plan",
    'team.upsell.eyebrow': "Colaboración",
    'team.upsell.title': "Construye este proyecto en equipo",
    'team.upsell.body': "Invita a quienes trabajan contigo en él y dale a cada uno exactamente el acceso que necesita.",
    'team.upsell.point1': "Un rol por persona, de editor completo a sólo ver",
    'team.upsell.point2': "Trabajan en este proyecto sin ver tu facturación",
    'team.upsell.point3': "Quitas un acceso cuando quieras, en un clic",
    'team.roleSavedOne': "Rol actualizado",
    'team.roleSavedMany': "{count} roles actualizados",
    'team.savingRoles': "Guardando roles…",
    'team.unnamed': "Sin nombre",
    'team.projectFallback': "este proyecto",
    'team.memberFallback': "este miembro",
    'team.revokeAria': "Revocar el acceso de {name}",
    'team.revokeTitle': "Revocar acceso",
    'team.cancelInviteFor': "Cancelar la invitación de {email}",
    'team.sendingInvite': "Enviando…",
    'team.copied': "Copiado",
    'team.copyLink': "Copiar enlace",
    'team.leaving': "Saliendo…",
    'team.removing': "Quitando…",
    'team.cancelling': "Cancelando…",
    'team.leftToast': "Has salido de {project}",
    'team.removedToast': "{name} ya no tiene acceso",
    'team.inviteCancelledToast': "Invitación a {name} cancelada",
    'team.sendInvite': "Enviar invitación",
    'team.cancelInviteAria': "Cancelar la invitación",
    'team.cancelInvite': "Cancelar invitación",
    'forms.deleteWarning': "Se borrarán permanentemente los mensajes seleccionados y todas sus respuestas. Esta acción no se puede deshacer.",
    'overview.unit.offer': "oferta",
    'overview.unit.offers': "ofertas",
    'overview.unit.booking': "cita por venir",
    'overview.unit.bookings': "citas por venir",
    'overview.unit.contact': "contacto reciente",
    'overview.unit.contacts': "contactos recientes",
    'overview.unit.message': "mensaje reciente",
    'overview.unit.messages': "mensajes recientes",
    'overview.unit.sale': "venta reciente",
    'overview.unit.sales': "ventas recientes",
    'overview.unit.order': 'pedido por enviar',
    'overview.unit.orders': 'pedidos por enviar',
    'overview.lastPublished': "Última publicación {when}",
    'overview.lastUpdated': "Actualizado {when}",
    'overview.row.openInEditor': "Abrir en Editor",
    'overview.row.openCollection': "Abrir colección",
    'overview.row.openProfile': "Abrir perfil",
    'overview.row.viewCharge': "Ver cobro",
    'overview.row.viewBooking': "Ver cita",
    'overview.row.openOffer': "Abrir oferta",
    'overview.row.viewMessage': "Ver mensaje",
    /* Los que se escapaban dentro de un ternario: la regla de ESLint no mira
       dentro de una condición, así que salieron de un barrido a mano. */
    'cms.noFieldsFit': "Esta colección no tiene campos que quepan aquí.",
    'cms.noFieldNamed': "Ningún campo con ese nombre.",
    'img.selectOne': "Seleccionar imagen",
    'tpl.oneSection': "{n} sección",
    'tpl.nSections': "{n} secciones",
    'cms.collectionTitleLabel': "Título de colección",
    'cms.collectionDescLabel': "Descripción de colección",
    'cms.collectionTitleSample': "Título de la colección",
    'cms.collectionDescSample': "Descripción de la colección",
    'form.sampleTextarea': "Cuéntanos sobre tu proyecto",
    'form.sampleSelect': "Selecciona una opción",
    'panel.italic': "Itálica",
    'panel.typography': "Tipografía",
    'panel.font': "Fuente",
    'panel.weight': "Peso",
    'panel.style': "Estilo",
    'panel.decoration': "Decoración",
    'panel.transform': "Transformación",
    'panel.alignment': "Alineación",
    'panel.lineHeight': "Altura de línea",
    'panel.color': "Color",
    'panel.background': "Fondo",
    'panel.spacing': "Espaciado",
    'panel.width': "Ancho",
    'panel.shadow': "Sombra",
    'panel.animation': "Animación",
    /* La alineación del texto en la barra flotante. Claves propias y no las de
       `border.center` o `type.justified`: dicen lo mismo hoy por casualidad, y
       compartirlas haría que tocar el borde cambiara el texto. */
    'align.left': "Izquierda",
    'align.center': "Centrado",
    'align.right': "Derecha",
    'align.justify': "Justificado",
    'align.cycleTitle': "Alineación: {current}",
    'align.cycleAria': "Alineación del texto: {current}. Cambiar a {next}",
    'el.headingN': "Título {n}",
    'backup.httpStatus': "El servidor respondió con HTTP {status}.",
    /* El CMS. Las de borrar llevan el número aparte del sustantivo porque el
       inglés no lo declina igual, y son dos claves y no una con hueco por lo
       mismo: «1 elemento» y «3 elementos» no son la misma frase. */
    'cms.deleteFieldQ': "¿Eliminar «{name}»?",
    'cms.deleteFieldUsedOne': "Se perderá lo que tiene 1 elemento en este campo. Esta acción no se puede deshacer.",
    'cms.deleteFieldUsedMany': "Se perderá lo que tienen {count} elementos en este campo. Esta acción no se puede deshacer.",
    'cms.deleteOptionQ': "¿Eliminar «{name}»?",
    'cms.deleteOptionUsedOne': "Se quitará de 1 elemento que la tiene. Esta acción no se puede deshacer.",
    'cms.deleteOptionUsedMany': "Se quitará de {count} elementos que la tienen. Esta acción no se puede deshacer.",
    'cms.deleteItemQ': "¿Eliminar «{name}»?",
    'cms.deleteItemsQ': "¿Eliminar {count} elementos?",
    'cms.deleteCollectionQ': "¿Eliminar la colección «{name}»?",
    'cms.collectionSettings': "Ajustes de colección",
    'files.dropMany': "Arrastra imágenes o haz clic para seleccionar",
    'saved.searchPlaceholder': "Buscar guardados…",
    'saved.searchAria': "Buscar elementos guardados",
    'saved.none': "Sin elementos guardados",
    'saved.hint': "Haz clic derecho en un elemento del canvas y selecciona Guardar como sección.",
    'saved.confirmDelete': "Sí, eliminar",
    'sect.adding': "Agregando…",
    'sect.add': "Agregar sección",
    'sect.yourCollections': "Tu contenido",
    'sect.wire.label': "Vista de la sección",
    'sect.wire.design': "Diseño",
    'sect.wire.structure': "Estructura",
    'sect.yourCollectionsHint': "La lista de una colección, conectada a su contenido",
    'sect.collectionOneEntry': "{n} entrada",
    'sect.collectionEntries': "{n} entradas",
    'drop.itemImageFailed': "No se pudo guardar la foto en esa ficha. Vuelve a intentarlo.",
    'sectAi.ask.title': "¿Qué debe decir esta sección?",
    'sectAi.ask.go': "Crear sección",
    'sectAi.ask.ph': "Enfoque, tono o datos que quieras incluir…",
    'sectAi.create': "Crear con IA",
    'sectAi.hint': "El mismo diseño, con textos escritos para tu negocio. Gasta pocos tokens de IA.",
    'sectAi.failed': "La IA no pudo escribir esta sección; se quedó con los textos de muestra.",
    'sectAi.noTokens': "Se acabaron los tokens de IA de este mes; la sección se quedó con los textos de muestra.",
    'sectAi.tooMany': "Demasiadas peticiones a la IA hoy; la sección se quedó con los textos de muestra.",
    'sect.families': "Familias de secciones",
    'sect.sections': "Secciones",
    'sect.noneInFamily': "No hay secciones en esta familia.",
    'sect.pick': "Selecciona una sección",
    'sect.pickHint': "Pulsa cualquiera de la izquierda para verla entera aquí.",
    'sect.preview': "Vista previa de la sección",
    'tpl.none': "No hay templates.",
    'tpl.searchAria': "Buscar template",
    'tpl.noPage': "Sin página",
    'tpl.addAfter': "Agregar «{name}» después de lo seleccionado",
    'tpl.add': "Agregar",
    'tpl.createPageFirst': "Crea una página para usar templates.",
    'tpl.seeMore': "Ver más",
    'tpl.premium': "Premium",
    'reuse.emptyHint': "Haz clic derecho en una sección del lienzo y elige «Convertir en reutilizable».",
    'reuse.stopsBeing': "{name} deja de ser reutilizable.",
    'reuse.manyStay': "Las {count} secciones puestas se quedan con su contenido y dejan de sincronizarse.",
    'reuse.oneStays': "La sección puesta se queda con su contenido y deja de sincronizarse.",
    'files.formats': "JPG · PNG · WebP · GIF · AVIF · máx. 10 MB",
    'files.dropMedia': 'Suelta para subir',
    'files.mediaFormats': 'JPG · PNG · WebP · GIF · AVIF · MP4 · WebM',
    'common.sure': "¿Seguro?",
    'cms.loadMore': "Cargar más",
    'tpl.searchPlaceholder': "Buscar…",
    'cvs.dragRadius': "Arrastrar para cambiar border-radius",
    'cvs.dragGap': "Arrastra para ajustar gap",
    'cvs.adjustGap': "Ajustar gap",
    'cvs.aiWorking': "La AI está actualizando el canvas",
    'cvs.frameTitle': "WebBuilder Canvas",
    'cvs.loadingPage': "Cargando la página",
    'cvs.emptyPage': "Página vacía",
    'cvs.listEmpty.services': "Aún no hay servicios",
    'cvs.listEmpty.memberships': 'Aún no hay membresías',
    'cvs.listEmpty.bookings': "Aún no hay servicios con reserva",
    'cvs.listEmpty.digital': "Aún no hay productos digitales",
    'cvs.listEmpty.products': "Aún no hay productos",
    'cvs.listEmpty.all': "Aún no hay ofertas",
    'cvs.listEmpty.blog': "Aún no hay entradas",
    'cvs.listEmpty.hint': "Cuando crees el primero, aparecerá aquí con este diseño. En el sitio, la sección no se ve mientras esté vacía.",
    'cvs.listEmpty.collection': "Aún no hay entradas en {name}",
    'cvs.listEmpty.createEntry': "Crear entrada",
    'cvs.listEmpty.pickCollection': "Elegir colección",
    'cvs.listEmpty.nocollection': "Esta lista no tiene colección",
    'cvs.listEmpty.noCollectionHint': "Elige de qué colección salen las tarjetas, o crea una en el CMS.",
    'cvs.emptyHint': "Empieza por una sección, o arrastra un bloque hasta aquí.",
    'cvs.addSection': "Agregar una sección",
    'cvs.add': "Agregar",
    'cvs.repeats': "Se repite",
    'cvs.inNRecords': "En las {count} fichas de la lista",
    'cvs.whyRepeats': "Por qué se repite",
    'cvs.repeatsHint': "Lo que hay dentro de una lista es una plantilla: se dibuja una vez por ficha, así que escribir aquí escribe en todas. Para que cambie en cada una, enlaza el elemento a un campo del CMS. Para que salga una sola vez, sácalo fuera de la lista.",
    'cvs.takeOutOfList': "Sacarlo de la lista para que salga una sola vez",
    'cvs.doubleClickToEdit': "Doble clic para editarla",
    'cvs.whatIsReusable': "Qué es una sección reutilizable",
    'cvs.placedOnce': "Está puesta en 1 sitio. ",
    'cvs.reusableHint': "Lo que cambies dentro cambia en todas las páginas donde esté.",
    'cvs.reusableBanner': "Lo que cambies aquí cambia en todas las páginas donde esté puesta",
    'cvs.reusableSection': "Sección reutilizable",
    'cvs.saveSection': "Guardar sección",
    'cvs.sectionName': "Nombre de la sección",
    'cvs.editTextHere': "Editar texto",
    'cvs.editFormOptions': "Editar las opciones del formulario",
    'cvs.hasAnimation': "Tiene animación · Editar",
    'cvs.viewOpened': "Ver abierto",
    'cvs.addAnother': "Duplicar",
    'cvs.duplicate': "Duplicar",
    'cvs.duplicateCard': "Duplicar tarjeta",
    'cvs.listAdd.card': "Agregar tarjeta",
    'cvs.listAdd.photo': "Agregar foto",
    'cvs.listAdd.review': "Agregar opinión",
    'cvs.listAdd.question': "Agregar pregunta",
    'cvs.listHint': "Esta sección tiene tarjetas: agrega otra desde aquí, o elige una y duplícala.",
    'cvs.addInside': "Añadir aquí",
    'cvs.open.dropdown': "Abrir desplegable",
    'cvs.open.inline': "Abrir «mostrar más»",
    'cvs.open.modal': "Abrir ventana",
    'cvs.open.drawer': "Abrir panel lateral",
    'cvs.open.fullscreen': "Abrir pantalla completa",
    'cvs.open.menu': "Abrir menú",
    'cvs.closeOpened': "Cerrar",
    'cvs.opensOnClick': "se abre al hacer clic",
    'cvs.opensOnHover': "se abre al pasar el ratón",
    'embed.pasteCode': "Pegar código",
    'cvs.stateHint': "Estado de interacción: elige otro o vuelve a None",
    'cvs.stateAria': "Estado de interacción del elemento",
    'cvs.pickOtherCollection': "Elegir otra colección",
    'cvs.searchField': "Buscar campo…",
    'cvs.searchFieldAria': "Buscar campo",
    'cvs.searchRecord': "Buscar registro…",
    'cvs.searchRecordAria': "Buscar registro",
    'cvs.searchAny': "Buscar colección o registro…",
    'cvs.searchAnyAria': "Buscar colección o registro",
    'cvs.noRecordNamed': "Ningún registro con ese nombre.",
    'cvs.nothingNamed': "Nada con ese nombre.",
    'cvs.records': "Registros",
    'cvs.takeOut': "Sacar de la lista",
    'cvs.exit': "Salir",
    'cvs.placedInN': "Está puesta en {count} sitios. ",
    'bp.block': "Bloque",
    'bp.section': "Section",
    'bp.grid': "Grid",
    'bp.layout': "Layout",
    'bp.media': "Media",
    'bp.interactive': "Interactivo",
    'bp.brand': "Marca",
    'bp.typography': "Tipografía",
    'bp.navbar': "Navbar",
    'bp.footer': "Footer",
    'bp.form': "Formulario",
    'bp.beforeAfter': "Antes / Después",
    'beforeAfter.before': "Antes",
    'beforeAfter.after': "Después",
    'beforeAfter.position': "Posición inicial",
    'beforeAfter.compare': "Comparar antes y después",
    'bp.gallery': "Galería",
    'bp.marquee': "Galería infinita",
    'bp.cmsGallery': "Galería CMS",
    'bp.cmsGalleryLong': "Galería del CMS",
    'bp.carousel': "Carrusel",
    'bp.cardRail': "Slider de tarjetas",
    'bp.tabs': "Tabs",
    'bp.tabsCarousel': "Tabs carrusel",
    'bp.faq': "Preguntas",
    'bp.faqLong': "Preguntas frecuentes",
    'bp.reviews': "Reseñas",
    'bp.logos': "Logos",
    'redesign.title': "Cambiar diseño",
    'redesign.category': "Tipo de sección",
    'redesign.previous': "Diseño anterior",
    'redesign.next': "Siguiente diseño",
    'redesign.hint': "Elige un diseño: tus textos, botones y fotos pasan a él. Al cerrar, ⌘Z lo deshace.",
    'redesign.noneYet': "aún no tienes",
    'redesign.dropped': "Este diseño tiene menos lugares: se ocultan {count} elementos. Regresan si vuelves a otro diseño.",
    'redesign.original': "Original",
    'redesign.empty': "Todavía no hay otros diseños de este tipo.",
    'bp.progress': "Barra de progreso",
    'sample.progressLabel': "Clientes satisfechos",
    'progress.value': "Valor",
    'progress.label': "Texto",
    'progress.labelPlaceholder': "Lo que mide",
    'progress.layout': "Forma",
    'progress.layout.stacked': "Apilada",
    'progress.layout.inline': "En línea",
    'progress.layout.bar': "Sólo barra",
    'progress.showValue': "Mostrar porcentaje",
    'progress.height': "Grosor",
    'progress.tone': "Color",
    'progress.tone.primary': "Principal",
    'progress.tone.accent': "Acento",
    'progress.tone.muted': "Suave",
    'progress.corners': "Esquinas",
    'progress.corners.round': "Redondas",
    'progress.corners.square': "Rectas",
    'logos.yes': "Sí",
    'logos.no': "No",
    'logos.layout': "Forma",
    'logos.layout.row': "Fila",
    'logos.layout.grid': "Rejilla",
    'logos.layout.marquee': "Deslizando",
    'logos.columns': "Columnas",
    'logos.size': "Tamaño del logo",
    'logos.speed': "Velocidad",
    'logos.grayscale': "En gris",
    'logos.grayscaleHint': "Los logos en imagen salen en gris y recuperan su color al pasar el puntero.",
    'logos.tiles': "En recuadros",
    'logos.items': "Logos",
    'logos.uploadMany': "Subir logos",
    'logos.uploadOne': "Subir logo",
    'logos.hint': "Cada logo puede ser una imagen (mejor PNG o SVG con fondo transparente) o el nombre escrito como texto.",
    'logos.kind': "Imagen o texto",
    'logos.kind.image': "Imagen",
    'logos.kind.text': "Texto",
    'logos.name': "Nombre",
    'logos.namePlaceholder': "Nombre de la marca",
    'logos.altPlaceholder': "Nombre de la marca (accesibilidad)",
    'logos.link': "Enlace",
    'logos.linkPlaceholder': "Enlace (opcional)",
    'logos.moveUp': "Subir",
    'logos.moveDown': "Bajar",
    'logos.add': "Agregar logo",
    'bp.review': "Reseña",
    'bp.rating': "Rating",
    'rating.value': "Calificación",
    'rating.showValue': 'Número de calificación',
    'rating.number.hidden': 'Ocultar',
    'rating.number.visible': 'Mostrar',
    'rating.max': "Total",
    'rating.shape': "Forma",
    'rating.shape.star': "Estrella",
    'rating.shape.heart': "Corazón",
    'rating.shape.circle': "Círculo",
    'rating.empty': "Vacías",
    'rating.empty.soft': "Suaves",
    'rating.empty.outline': "Contorno",
    'rating.empty.hidden': "Ocultas",
    'rating.gap': "Espacio",
    'bp.stat': "Stat",
    'bp.countdown': "Countdown",
    'bp.popover': "Popover",
    'bp.opener': "Botón que abre…",
    'popover.howItOpens': "¿Cómo se abre?",
    'popover.pres.inline': "Mostrar más",
    'popover.pres.dropdown': "Desplegable",
    'popover.pres.modal': "Ventana",
    'popover.pres.drawer': "Panel lateral",
    'popover.pres.fullscreen': "Pantalla completa",
    'bp.modal': "Ventana",
    'bp.modalLong': "Ventana emergente",
    'bp.customCode': "Código personalizado",
    'embed.setupBody': 'Este componente no se muestra en el lienzo. Abre la vista previa para ver tu código en acción.',
    'embed.openPreview': 'Abrir vista previa',
    'embed.openPanel': 'Abrir panel',
    'embed.canvasEmpty': "Código personalizado: doble clic para editar",
    'embed.canvasHasCode': "Código personalizado · se ve en la página publicada",
    'bp.cardWheel': "Rueda de tarjetas",
    'bp.avatars': "Avatares",
    'avatars.photos': "Fotos",
    'avatars.size': "Tamaño",
    'avatars.spacing': "Separación",
    'bp.avatar': "Avatar",
    'bp.icon': "Icono",
    'bp.image': "Imagen",
    'bp.video': "Vídeo",
    'bp.videoEmbed': "YouTube / Vimeo",
    'video.badge': "Vídeo",
    'files.filter': "Qué enseñar",
    'files.filter.all': "Todo",
    'files.filter.images': "Fotos",
    'files.filter.videos': "Vídeos",
    'video.uploading': "Subiendo… {pct} %",
    'video.uploadFailed': "No se pudo subir el vídeo.",
    'image.cropValue': "Ajustar",
    'video.cover': "Portada",
    'video.coverFromVideo': "Del vídeo",
    'video.coverOwn': "Foto propia",
    'video.coverAuto': "Volver a la portada del vídeo",
    'video.pick': "Elegir vídeo",
    'video.upload': "Subir vídeo",
    'video.onlyMp4': "Sólo vídeos MP4 o WebM.",
    'media.kind': "Tipo",
    'media.image': "Imagen",
    'media.video': "Vídeo",
    'media.slider': "Slide",
    'bgSlider.edit': "Editar fotos",
    'bgSlider.pick': "Elegir fotos",
    'bgSlider.need': "Elige al menos 2 fotos para que empiece a cambiar.",
    'bgSlider.count': "{count} fotos",
    'bgSlider.effect': "Efecto",
    'bgSlider.marquee': "Infinito",
    'bgSlider.fade': "Fundido",
    'bgSlider.slide': "Deslizar",
    'bgSlider.zoom': "Zoom",
    'bgSlider.interval': "Cada foto",
    'bgSlider.speed': "Velocidad",
    'bgSlider.transition': "Transición",
    'bgSlider.zoomAmount': "Acercamiento",
    'bgSlider.direction': "Dirección",
    'bgSlider.toLeft': "Hacia la izquierda",
    'bgSlider.toRight': "Hacia la derecha",
    'bgSlider.dragHint': "Arrastra para cambiar el orden",
    'bgSlider.add': "Añadir fotos",
    'media.change': "Cambiar",
    'video.playAria': "Reproducir el vídeo",
    'bg.tabMedia': "Media",
    'video.audio': "Audio",
    'video.audioOff': "Sin audio",
    'video.audioOn': "Con audio",
    'video.audioOnHint': "Arranca sin sonido (los navegadores no dejan otra cosa) y suena en cuanto el visitante toca la página",
    'texture.title': "Textura",
    'texture.none': "Ninguna",
    'texture.remove': "Quitar la textura",
    'texture.strength': "Intensidad",
    'texture.grid': "Cuadrícula",
    'texture.dots': "Puntos",
    'texture.lines': "Líneas",
    'texture.diagonal': "Diagonales",
    'texture.grain': "Grano",
    'texture.blur': "Desenfoque",
    'texture.frosted': "Vidrio",
    'texture.vignette': "Viñeta",
    'video.playback': "Reproducción",
    'video.ambient': "Ambiente",
    'video.ambientHint': "Arranca solo, sin sonido y en bucle",
    'video.player': "Reproductor",
    'video.playerHint': "Con controles: se le da play y suena",
    'video.embedPlaceholder': "https://www.youtube.com/watch?v=…",
    'video.embedTab': "Vídeo",
    'video.setupTitle': 'Añade tu vídeo',
    'video.setupBody': 'Pega un enlace de YouTube o Vimeo para añadir tu vídeo a la página.',
    'video.openPanel': 'Abrir ajustes',
    'video.embedUrl': "Enlace de YouTube o Vimeo",
    'video.embedHint': "Pega el enlace del vídeo; sale con su reproductor al publicar.",
    'video.embedInvalid': "Ese enlace no es de YouTube ni de Vimeo.",
    'editor.video.embedEmpty': "Pega un enlace de YouTube o Vimeo",
    'bp.logo': "Logo",
    'bp.link': "Link",
    'bp.links': "Links",
    'bp.list': "Lista",
    'bp.simpleList': "Lista simple",
    'bp.line': "Línea",
    'bp.spacer': "Espacio",
    'spacer.size': "Tamaño del espacio",
    'bp.text': "Texto",
    'bp.smallText': "Texto pequeño",
    'bp.paragraph': "Párrafo",
    'bp.title': "Título",
    'bp.smallTitle': "Título pequeño",
    'bp.mainTitle': "Título principal",
    'bp.secondTitle': "Título secundario",
    'bp.sectionTitle': "Título de sección",
    'bp.blockTitle': "Título de bloque",
    'bp.button': "Botón",
    'bp.primaryButton': "Botón principal",
    'bp.secondaryButton': "Botón secundario",
    'bp.badge': "Etiqueta",
    'bp.menu': "Menú",
    'bp.mobileMenu': "Menú móvil",
    'bp.panel': "Panel",
    'bp.megaPanel': "Panel mega",
    'bp.trigger': "Disparador",
    'bp.arrows': "Flechas",
    'bp.dots': "Puntos",
    'bp.track': "Track",
    'bp.viewport': "Viewport",
    'bp.gridBlock': "Cuadrícula",
    'bp.content': "Contenido",
    'bp.hiddenContent': "Contenido oculto",
    'bp.whatWasHidden': "Lo que estaba oculto",
    'bp.editableBlocks': "Bloques editables",
    'bp.mainInfo': "Información principal",
    'bp.legalInfo': "Información legal",
    'bp.legalLinks': "Enlaces legales",
    'bp.copyright': "Copyright",
    'bp.authorData': "Datos autor",
    'bp.countdownLabel': "Countdown label",
    'bp.countdownUnits': "Countdown unidades",
    'bp.cms': "CMS",
    'bp.catalog': "Catálogo",
    'bp.catalogGrid': "Catálogo en cuadrícula",
    'bp.catalogList': "Catálogo en lista",
    'bp.catalogCarousel': "Catálogo en carrusel",
    'bp.catalogFeatured': "Oferta destacada",
    'bp.offerImage': "Imagen de la oferta",
    'bp.offerDuration': "Duración de la oferta",
    'bp.offerTitle': "Título de la oferta",
    'bp.offerDescription': "Descripción de la oferta",
    'bp.offerPrice': "Precio de la oferta",
    'bp.offerCompareAt': "Precio antes (tachado)",
    'bp.offerCompareRow': "Precio antes y descuento",
    'bp.offerDiscount': "Descuento",
    'sample.offerType': "Servicio",
    'bp.overlay': "Capa oscura",
    'bp.offerType': "Tipo de oferta",
    'bp.offerButton': "Botón de la oferta",
    'bp.offerButtons': "Botones",
    'bp.offerMoreButton': "Botón «Más información»",
    'bp.cardBody': "Cuerpo",
    'bp.cardFooter': "Pie",
    'bp.price': "Precio",
    'bp.cmsTitle': "CMS Título",
    'bp.cmsText': "CMS Texto",
    'bp.cmsImage': "CMS Imagen",
    'bp.cmsDate': "CMS Fecha",
    'bp.cmsName': "CMS Nombre",
    'bp.cmsDescription': "CMS Descripción",
    'bp.cmsCard': "CMS Card",
    'bp.cmsFeaturedCard': "CMS Card Destacada",
    'bp.cmsCollectionCard': "CMS Colección Card",
    'bp.cmsList': "CMS Lista",
    'bp.cmsSimpleList': "CMS Lista simple",
    'bp.cmsGrid': "CMS Cuadrícula",
    'bp.cmsCarousel': "CMS Carrusel",
    'bp.cmsRow': "CMS Fila",
    'bp.cmsRowText': "CMS Fila Texto",
    'bp.cmsSimpleRow': "CMS Fila simple",
    'bp.cmsArticle': "CMS Artículo",
    'bp.cmsFeatured': "CMS Destacado",
    'bp.cmsIndex': "CMS Índice",
    'bp.cmsRest': "CMS Resto",
    'bp.collectionIndex': "Índice de colecciones",
    'bp.article': "Artículo",
    'bp.featured': "Destacado",
    'bp.blogArticle': "Blog Article",
    'bp.blogCategories': "Blog Categories",
    'bp.blogDate': "Blog Date",
    'bp.blogImage': "Blog Image",
    'bp.blogRichContent': "Blog Rich Content",
    'bp.blogTitle': "Blog Title",
    'bp.h1': "Heading 1",
    'bp.h2': "Heading 2",
    'bp.h3': "Heading 3",
    'bp.h4': "Heading 4",
    'bp.h5': "Heading 5",
    'bp.h6': "Heading 6",
    'bp.smallTextEn': "Small text",
    'sample.postTitle': "Título del post",
    'sample.offerTitle': "Nombre de la oferta",
    'sample.offerDescription': "Lo que incluye, en una o dos líneas.",
    'sample.offerPrice': "Precio: $45",
    'sample.offerDuration': "1 h",
    'sample.offerCta': "Ver detalles",
    'sample.offerMore': "Más información",
    'part.form.title': "Título del formulario",
    'part.form.label': "Etiquetas",
    'part.form.input': "Campos",
    'part.form.submit': "Botón de envío",
    'part.form.message': "Mensaje de éxito",
    'part.review.card': "Tarjeta",
    'part.review.name': "Nombre",
    'part.review.meta': "Detalle",
    'part.review.text': "Texto",
    'part.review.avatar': "Foto",
    'part.review.source': "Fuente",
    'part.review.stars': "Estrellas",
    'part.review.more': "Botón «ver más»",
    'part.faq.item': "Fila de la pregunta",
    'part.faq.question': "Pregunta",
    'part.faq.answer': "Respuesta",
    'part.faq.icon': "Signo",
    'part.selectOnCanvas': "Seleccionar «{name}» en el lienzo",
    'bp.cd.days.value': "Días · número",
    'bp.cd.days.label': "Días · etiqueta",
    'bp.cd.hours.value': "Horas · número",
    'bp.cd.hours.label': "Horas · etiqueta",
    'bp.cd.minutes.value': "Minutos · número",
    'bp.cd.minutes.label': "Minutos · etiqueta",
    'bp.cd.seconds.value': "Segundos · número",
    'bp.cd.seconds.label': "Segundos · etiqueta",
    'bp.offerCard': "Tarjeta de oferta",
    'sample.articleTitle': "Título del artículo",
    'sample.modalTitle': "Título de la ventana",
    'sample.collectionName': "Nombre de la colección",
    'sample.collectionDescription': "Descripción de la colección...",
    'sample.contentDescription': "Descripción del contenido...",
    'sample.insertTitle': 'Ideas que toman forma',
    'sample.insertBody': 'Descubre una nueva perspectiva. Cada detalle cuenta para crear algo especial.',
    'bp.blogPopular': "Lo más leído",
    'bp.blogRelated': "Entradas relacionadas",
    'bp.blogAdjacent': "Anterior y siguiente",
    'bp.blogShare': "Compartir",
    'bp.shopCollections': "Colecciones",
    'bp.shopNewest': "Lo más nuevo",
    'bp.shopBestsellers': "Más vendidos",
    'bp.shopRelated': "También te puede gustar",
    'bp.cmsCategories': "Categorías",
    'bp.cmsRecent': "Lo más reciente",
    'bp.cmsRelated': "Relacionadas",
    'bp.blogToc': "Índice del artículo",
    'bp.blogBreadcrumb': "Ruta (migas de pan)",
    'bp.blogNewsletter': "Boletín",
    'bp.blogAuthorProfile': "Ficha del autor",
    'bp.blogAuthor': "Autor",
    'bp.blogAuthorPhoto': "Foto del autor",
    'bp.blogAuthorText': "Texto del autor",
    'bp.blogAuthorName': "Nombre del autor",
    'bp.blogAuthorMeta': "Fecha y lectura",
    'bp.blogReadingTime': "Tiempo de lectura",
    'blogWidget.settings': "Pieza del blog",
    'blogWidget.onlyOnPost': "Se ve en la página de cada entrada.",
    'blogWidget.showTitle': "Título",
    'blogWidget.title': "Texto del título",
    'blogWidget.titlePlaceholder': "El de siempre",
    'blogWidget.limit': "Cuántos",
    'blogWidget.look': "Aspecto",
    'blogWidget.look.chips': "Pastillas",
    'blogWidget.look.list': "Lista",
    'blogWidget.look.cloud': "Nube",
    'blogWidget.look.cards': "Tarjetas",
    'blogWidget.look.icons': "Iconos",
    'blogWidget.look.buttons': "Botones",
    'blogWidget.showCount': "Contador",
    'blogWidget.avatar': "Foto",
    'blogWidget.avatar.photo': "Foto",
    'blogWidget.avatar.initials': "Iniciales",
    'blogWidget.avatar.none': "Nada",
    'blogWidget.layout': "Orden",
    'blogWidget.layout.column': "En columna",
    'blogWidget.layout.row': "En fila",
    'blogWidget.showImage': "Foto",
    'blogWidget.showDate': "Fecha",
    'blogWidget.buttonText': "Texto del botón",
    'blogWidget.buttonPlaceholder': "El de siempre",
    'blogWidget.text': "Texto",
    'blogWidget.textPlaceholder': "Recibe las nuevas entradas en tu correo.",
    'blogWidget.tag': "Etiqueta en Contactos",
    'blogWidget.tagPlaceholder': "newsletter",
    'blogWidget.titleSize': "Tamaño del título",
    'blogWidget.textSize': "Tamaño del texto",
    'blogWidget.avatarSize': "Tamaño de la foto",
    'blogWidget.gap': "Espacio entre filas",
    'cms.photoSize': "Tamaño de la foto",
    'cms.photoSize.design': "Del diseño",
    'cms.photoSize.sm': "Pequeña",
    'cms.photoSize.md': "Mediana",
    'cms.photoSize.lg': "Grande",
    'cms.railBleed': "Hasta el borde",
    'cms.listGap': "Foto y texto",
    'cms.listSpacing': "Entre textos",
    'cms.space.sm': "Poco",
    'cms.space.md': "Normal",
    'cms.space.lg': "Mucho",
    'blogWidget.titleStyle': "Estilo del título",
    'blogWidget.textStyle': "Estilo del texto",
    'blogWidget.metaStyle': "Estilo de fecha y contador",
    'blogWidget.styleDefault': "Del sitio",
    'blogWidget.tagNote': "Cada correo entra en Contactos con esta etiqueta.",
    'blogWidget.field.search': "Buscador",
    'blogWidget.field.topic': "Tema",
    'blogWidget.field.author': "Autor",
    'blogWidget.field.sort': "Orden",
    'bp.blogFilters': "Filtros del blog",
    'bp.blogTopics': "Temas",
    'bp.blogAuthors': "Autores",
    'bp.blogRecent': "Entradas recientes",
    'bp.blogAbout': "Acerca del blog",
    'sample.blogAboutTitle': "Hola, somos el equipo",
    'sample.blogAboutText': "Escribimos sobre lo que hacemos cada día: ideas, consejos y novedades.",
    'sample.insertEmbed': '<div style="padding:32px;border:1px solid currentColor;border-radius:16px;text-align:center"><h3 style="margin:0 0 12px">Un espacio para tus ideas</h3><p style="margin:0">Haz que cada visita sea el comienzo de algo especial.</p></div>',
    'sample.description': "Descripción",
    'sample.name': "Nombre",
    'sample.email': "Correo electrónico",
    'sample.message': "Mensaje",
    'sample.send': "Enviar",
    'sample.thanks': "¡Gracias! Hemos recibido tu mensaje.",
    'sample.contact': "Contacto",
    'sample.start': "Empezar",
    'sample.open': "Abrir",
    'sample.openMenu': "Abrir menú",
    'sample.openWindow': "Abrir ventana",
    'sample.learnMore': "Conocer más →",
    'sample.seeMore': "Ver más",
    'sample.showMore': "Mostrar más",
    'sample.products': "Productos",
    'sample.launch': "Lanzamiento",
    'sample.availableNow': "Disponible ahora",
    'sample.happyClients': "Clientes satisfechos",
    'sample.yourContent': "Tu contenido",
    'sample.copyright': "© {year} Tu empresa. Todos los derechos reservados.",
    'sample.tagline': "Creamos productos y experiencias digitales pensadas para hacer crecer tu negocio.",
    'sample.designAnythingMenu': "Diseña aquí lo que quieras: links, imágenes, columnas…",
    'sample.designAnything': "Diseña aquí lo que quieras: texto, imágenes, un formulario, columnas…",
    'sample.modalBody': "Escribe aquí lo que aparece al pulsar el botón. Puedes poner texto, imágenes o lo que necesites.",
    'sample.articleBody': "<p>Escribe el contenido completo del artículo en el CMS.</p>",
    'sample.faqQuestion': "¿Cuánto tarda el envío?",
    'sample.faqAnswer': "Entre 2 y 5 días hábiles. Te avisamos por correo en cuanto sale del almacén.",
    'sample.reviewer1': "Heriberto Murrieta",
    'sample.reviewer2': "Lucía Márquez",
    'sample.reviewer3': "María Fernández",
    'sample.reviewer4': "Andrés Peralta",
    'sample.reviewerInitials': "HM",
    'sample.roleFounder': "Founder",
    'sample.company': "Restaurante El Roble",
    'sample.city': "Ciudad de México",
    'sample.clientSince': "Cliente desde 2023",
    'sample.review1': "“Excelente experiencia, el proceso fue claro y el resultado se sintió profesional desde el primer día.”",
    'sample.review2': "Llegamos con una idea a medias y salimos con algo mejor de lo que teníamos en la cabeza. El trato fue cercano en todo momento, nos explicaron cada paso sin tecnicismos y cumplieron los plazos que habían prometido. Volveríamos sin dudarlo y de hecho ya los hemos recomendado a dos personas del sector.",
    'sample.review3': "Muy profesionales. Tardaron un poco más de lo previsto por un tema de proveedores, pero nos mantuvieron informados todo el tiempo y el acabado final mereció la espera con creces.",
    'sample.review4': "Respuesta rápida y un resultado impecable. Lo que más valoro es que nos avisaron de un problema antes de que nos diéramos cuenta nosotros.",
    'logo.sub.colorType': 'Color y tipografía',
    'logo.sub.symbol': 'Símbolo',
    'logo.sub.colorSize': 'Color y tamaño',
    'logo.sub.background': 'Fondo',
    'logo.sub.versions': 'Versiones',
    'logo.sub.width': 'Ancho',
    'brand.buttonSample': 'Botón',
    'elements.addFavoriteShort': 'Agregar a favoritos',
    'elements.removeFavoriteShort': 'Quitar de favoritos',
    'elements.addFavorite': "Agregar {name} a favoritos",
    'elements.removeFavorite': "Quitar {name} de favoritos",
    'ai.elementAdded': "{name} agregado.",
    'sample.slide1': "Slide principal",
    'sample.slide2': "Segundo slide",
    'sample.slide3': "Tercer slide",
    'sample.slideBody': "Edita este contenido desde el canvas o desde layers.",
    'sample.slideBody2': "Todos los slides son elementos reales y editables.",
    'sample.slideBody3': "Ajusta ancho, colores y contenido como quieras.",
    'sample.card1': "Tarjeta uno",
    'sample.card2': "Tarjeta dos",
    'sample.card3': "Tarjeta tres",
    'sample.card4': "Tarjeta cuatro",
    'sample.cardBase': "Tarjeta base",
    'sample.cardColor': "Tarjeta con color",
    'sample.cardSoft': "Tarjeta suave",
    'sample.cardBody1': "Varias tarjetas visibles a la vez; usa las flechas para avanzar.",
    'sample.cardBody2': "Las tarjetas se asoman por el borde y puedes ver más.",
    'sample.cardBody3': "Cada tarjeta es un elemento real y editable.",
    'sample.cardBody4': "Ideal para servicios, productos, casos de estudio o reseñas.",
    'sample.tabCourses': "Cursos",
    'sample.tabCommunities': "Comunidades",
    'sample.tabNewsletters': "Boletines",
    'sample.tabCoaching': "Coaching",
    'sample.tabCoursesBody': "Crea y vende cursos con lecciones, módulos y seguimiento de progreso.",
    'sample.tabCommunitiesBody': "Construye un espacio al que la gente vuelve y que impulsa la retención.",
    'sample.tabNewslettersBody': "Envía newsletters y haz crecer tu audiencia con contenido recurrente.",
    'sample.tabCoachingBody': "Trabaja 1:1 con clientes a precios premium usando programas estructurados.",
    'sample.option1': "Opción 1",
    'sample.option2': "Opción 2",
    'sample.option3': "Opción 3",
    'sample.option4': "Opción 4",
    'sample.option5': "Opción 5",
    'sample.option6': "Opción 6",
    'sample.navHome': "Inicio",
    'sample.more': "Más",
    'sample.navServices': "Servicios",
    'sample.navBookings': "Reservas",
    'sample.navDownloads': "Descargas",
    'sample.navShop': 'Tienda',
    'sample.contactTitle': "Contacto",
    'sample.copyrightOf': "© {year} {name}. Todos los derechos reservados.",
    'sample.navAbout': "Nosotros",
    'sample.navSupport': "Soporte",
    'sample.legalTerms': "Términos",
    'sample.legalPrivacy': "Privacidad",
    'sample.social1': "Instagram",
    'sample.social2': "LinkedIn",
    'sample.followUs': "Síguenos",
    'sample.serviceWeb': "Diseño web",
    'sample.serviceDev': "Desarrollo",
    'sample.serviceStrategy': "Estrategia",
    'sample.iconPrimary': "Icono principal",
    'sample.iconFeatured': "Icono destacado",
    'sample.iconSoft': "Icono suave",
    'sample.unitDays': "Días",
    'sample.unitHours': "Horas",
    'sample.unitMin': "Min",
    'sample.unitSec': "Seg",
    'sample.prev': "Anterior",
    'sample.next': "Siguiente",
    'bp.dropdownMenu': "Menú desplegable",
    'bp.megaMenu': "Mega menú",
    'bp.navigation': "Navegación",
    'bp.separator': "Separador",
    'bp.linkItem': "Enlace",
    'bp.lineItem': "Línea",
    'sample.contactEmail': "hola@tuempresa.com",
    'policies.hint.privacidad': "Qué datos pides, para qué los usas y cómo te los pueden pedir de vuelta. Casi en cualquier país la ley lo exige en cuanto recoges un nombre o un correo.",
    'policies.hint.terminos': "Las reglas de la relación con tu cliente: qué vendes, cómo se paga y qué pasa si algo sale mal.",
    'policies.hint.reembolsos': "Cuándo devuelves el dinero y cuándo no. Es la que más pesa si alguien reclama un cargo a su banco.",
    'policies.hint.cancelaciones': "Con cuánta antelación se puede cancelar o mover una cita, y qué pasa si no se presenta.",
    'policies.hint.envios': 'Cuánto tardas en enviar, cómo se sigue el paquete y cómo se devuelve un producto. Hace falta si vendes productos físicos.',
    'policies.hint.aviso-legal': 'Quién es el titular del sitio y cómo contactarle: nombre, identificación fiscal, domicilio y contacto. Obligatorio en España y México.',
    'legalAttention.kicker': "Legal",
    'legalAttention.title': "Tus clientes pagan sin poder leer tus condiciones",
    'legalAttention.body': "Falta publicar: {docs}. Junto al botón de pago sólo se enlazan los documentos publicados, así que hoy esas ventas no llevan condiciones aceptadas. Complétalos para que salgan solos.",
    'legalAttention.cta': "Revisar políticas",
    'overview.order.deletedOffer': "Oferta borrada",
    'overview.order.noBuyer': "Sin comprador",
    'overview.order.disputed': "Disputado",
    'overview.switchGreeting': "Actualmente estás en «{name}»",
    'overview.switchLine': "Todo lo que veas en el panel es de este sitio.",
    'overview.handoverOne': "Ahí arriba te dejé lo que falta para terminar de recibir este sitio. Puedes dejarlo para luego.",
    'overview.handoverMany': "Ahí arriba te dejé las {count} cosas que faltan para terminar de recibir este sitio. Puedes dejarlo para luego.",
    'overview.transferInviteMany': "Recibiste {count} invitaciones para aceptar transferencias de sitios. Revisa arriba sus detalles y el contenido incluido.",
    'overview.teamInviteMany': "Tienes {count} invitaciones a equipos ahí arriba, esperando respuesta.",
    'overview.projectFallback': "Proyecto",
    'overview.payout.arrives': "Llega {when}",
    'overview.payout.arrivesInTransit': "Llega {when} · en camino",
    'overview.payout.none': "Sin saldo por depositar",
    'overview.payout.arrivesApprox': "Llega aprox. {when}",
    'overview.payout.withinStripe': "Dentro del plazo de Stripe",
    'overview.domain.active': "Activo",
    'overview.domain.error': "Error",
    'overview.domain.configuring': "Configurando",
    'plans.feat.noAnalytics': "Sin analíticas",
    'plans.feat.blogPosts': "Blog: {count} entradas publicadas",
    'plans.feat.blogUnlimited': "Blog: entradas ilimitadas",
    'plans.feat.search': "Búsqueda en el sitio",
    'plans.table.row.blog': "Entradas de blog publicadas",
    'plans.limit.emails': "{count} correos/mes",
    'stripe.countryHint': "Tu cuenta de Stripe se creará en {country}, el país de este proyecto. Stripe no deja cambiarlo después.",
    'stripe.countryChange': "Cambiar país",
    'error.message.overLimit': "Este mensaje llegó después del límite de tu plan. Mejora tu plan para leerlo.",
    'forms.overLimit.title': "Te pasaste del límite de tu plan",
    'forms.overLimit.bodyOne': "Tienes 1 mensaje que no puedes ver. Está guardado: mejora tu plan para leerlo.",
    'forms.overLimit.bodyMany': "Tienes {count} mensajes que no puedes ver. Están guardados: mejora tu plan para leerlos.",
    'forms.overLimit.cta': "Mejorar plan",
    'legal.contact.email': "Correo de contacto: {email}",
    'account.err.signOutSession': "No se pudo cerrar la sesión.",
    'account.err.uploadImage': "No se pudo subir la imagen.",
    'account.err.save': "No se pudieron guardar los cambios.",
    'account.err.startChange': "No se pudo iniciar el cambio.",
    'account.err.badCode': "El código no es válido o ya venció.",
    'account.err.emailInUse': "Ese correo ya está en uso.",
    'account.err.verifyCode': "No se pudo verificar el código.",
    'account.err.confirmEmail': "No se pudo confirmar el correo.",
    'account.err.resendCode': "No se pudo reenviar el código.",
    'account.err.connectGoogle': "No se pudo conectar Google.",
    'account.err.disconnect': "No se pudo desconectar.",
    'account.err.signOutAll': "No se pudo cerrar las sesiones.",
    'account.err.sendCode': "No se pudo enviar el código.",
    'account.err.deleteAccount': "No se pudo eliminar la cuenta.",
    'account.resending': "Reenviando…",
    'account.resendCode': "Reenviar código",
    'account.locationUnknown': "Ubicación no disponible",
    'account.projectUnnamed': "Proyecto sin nombre",
    'err.openPaymentsSetup': "No pudimos abrir el alta de cobros.",
    'err.saveThat': "No pudimos guardar eso.",
    'err.actionFailed': "No pudimos completar la acción.",
    'err.loadDomains': "No pudimos cargar tus dominios.",
    'err.connectDomain': "No pudimos conectar el dominio.",
    'err.loadRequests': "No pudimos cargar las solicitudes.",
    'err.deliverCode': "No pudimos entregar el código.",
    'err.readDns': "No pudimos leer el DNS de este dominio.",
    'err.registerRequest': "No pudimos registrar tu solicitud.",
    'err.saveRecord': "No pudimos guardar el registro.",
    'err.deleteRecord': "No pudimos borrar el registro.",
    'err.openReview': "No pudimos abrir el repaso.",
    'err.saveData': "No pudimos guardar los datos.",
    'err.openInvite': "No pudimos abrir la invitación.",
    'err.operationFailed': "No se pudo completar la operación.",
    'err.noInvite': "Sin invitación que abrir.",
    'app.handoffFailed': "No pudimos crear una sesión segura para el editor.",
    'code.digitAria': "Dígito {n}",
    'err.createProject': "No se pudo crear el proyecto.",
    'cwa.defaultName': "Mi página",
    'err.uploadFailed': "Error al subir",
    'err.searchFailed': "No se pudo buscar",
    'accountDomains.notConnected': "Sin conectar",
    'pageSettings.seoPreviewPlaceholder': "Agrega una descripción clara para mejorar cómo aparece esta página en buscadores.",
    'switch.arrived': "Proyecto {name}",
    'switch.switching': "Cambiando de proyecto",
    'audience.views': "{count} vistas",
    'audience.noViews': "Sin vistas",
    'backup.copyOf': "Copia del {date}",
    'backup.loading': "Cargando la copia…",
    'backup.pagesOne': "{count} página",
    'backup.pagesMany': "{count} páginas",
    'backup.collectionsOne': "{count} colección",
    'backup.collectionsMany': "{count} colecciones",
    'brand.loadFailed': "No se pudo cargar tu marca.",
    'forms.noExtraAnswers': "Sin respuestas adicionales",
    'forms.bulkDelete.confirm': "Borrar",
    'forms.bulkDelete.titleOne': "Borrar 1 mensaje",
    'forms.bulkDelete.titleMany': "Borrar {count} mensajes",
    'forms.selectMessage': "Seleccionar el mensaje de {name}",
    'overview.noPublishedLink': "Sin enlace publicado",
    'analytics.infoAbout': "Información de {title}",
    'analytics.pageDeleted': "La página se borró",
    'auth.resendIn': "Reenviar código ({seconds}s)",
    'home.create.catalogAria': "Catálogo de plantillas",
    'home.create.customizeAria': "Personalización del sitio",
    'error.integration.notConfigured': "Las integraciones todavía no están disponibles. Inténtalo más tarde.",
    'error.asset.svgTooLarge': "El SVG pesa {kb} KB. El máximo es 1 MB.",
    'error.asset.videoType': "Sólo se pueden subir vídeos MP4 o WebM. Los .mov del iPhone se pueden exportar a MP4 desde Fotos o con un conversor.",
    'error.asset.videoLength': "No se pudo leer el tamaño del vídeo. Vuelve a intentarlo.",
    'error.asset.videoEmpty': "El vídeo está vacío.",
    'error.asset.videoTooLarge': "El vídeo pesa {mb} MB; tu plan admite hasta {max} MB por vídeo.",
    'error.account.verifyFailed': "No pudimos verificar tu cuenta. Inténtalo de nuevo.",
    'error.account.authDeleteFailed': "No se pudo eliminar la cuenta de acceso. Inténtalo de nuevo.",
    'error.domain.lookupFailed': "El dominio ya está registrado en nuestra red pero no pudimos recuperarlo. Inténtalo de nuevo.",
    'error.domain.registrarBusy': "Estamos hablando con el registrador. Inténtalo en unos segundos.",
    'error.domain.reconnectFailed': "No pudimos reconectar el dominio. Inténtalo de nuevo en unos minutos.",
    'error.invite.wrongAccount': "Esta invitación es para {email}. Entra con esa cuenta para continuar.",
    'error.domain.registerUnavailable': "No podemos registrar ese dominio ahora mismo. Inténtalo más tarde.",
    'nav.search': "Buscador",
    'nav.cart': 'Carrito',
    'nav.account': "Cuenta del cliente",
    'offers.look.siteNav': "Barra de navegación",
    'offers.look.siteFooter': "Pie de página",
    'offers.look.siteOn': "Se muestra",
    'offers.look.siteOff': "Oculto en esta página",
    'offers.look.siteMissing': "Aparece cuando publiques tu sitio",
    'calsync.google.recommended': "Recomendado",
    'calsync.google.ok': "Conectado y funcionando",
    'calsync.google.writeLabel': "Añadir mis citas a este calendario",
    'calsync.google.writeHint': "Cada reserva nueva aparece como un evento.",
    'calsync.google.blockLabel': "Bloquear horarios cuando estoy ocupado",
    'calsync.google.blockHint': "Tus eventos no se ofrecen en tu página de reservas.",
    'calsync.google.addAnother': "Conectar otra cuenta de Google",
    'calsync.export.titleFor': "Ver tus citas en {provider}",
    'layers.simple.hiddenBadge': "Oculto en este dispositivo",
    'layers.simple.lockedBadge': "Bloqueado",
    'layers.simple.more': "Más opciones",
    'layers.simple.moveUp': "Subir",
    'layers.simple.moveDown': "Bajar",
    'layers.simple.buttons': "Botones",
    'layers.simple.card': "Tarjeta {n}",
    'layers.simple.column': "Columna {n}",
    'layers.simple.pathAria': "Dónde estás en la página",
    'layers.simple.allSections': "Secciones",
    'layers.simple.emptySection': "Esta sección está vacía",
    'layers.simple.emptySectionHint': "Agrega textos, botones o imágenes desde el lienzo.",
    'layers.simple.items.one': "1 elemento",
    'layers.simple.items.many': "{count} elementos",
    'layers.simple.addSectionHint': "Elige una del catálogo",
    'layers.addSectionEnd': "Añadir sección",
    'nav.pillGap': "Espacio logo · menú",
    'cms.design.change': "Diseño del CMS",
    'cms.design.itemGroup': "Página de cada ficha",
    'cms.design.collectionGroup': "Página de la lista",
    'cms.design.applied': "Diseño aplicado a la página de las fichas",
    'cms.design.appliedList': "Diseño aplicado a la página de la lista",
    'layers.group.siteNav': "Menú del sitio",
    'layers.group.siteFooter': "Pie del sitio",
    'layers.group.allPages': "Todas las páginas",
    'layers.group.pageContent': "Contenido",
    'navm.auto.navHint': "Se arma solo con tus páginas y tu catálogo.",
    'navm.auto.footerHint': "Se llena solo con tus páginas, catálogo, contacto y políticas.",
    'navm.auto.locked': "Se actualiza solo",
    'navm.auto.yours': "Lo controlas tú",
    'link.ext.email': "Escribir a {value}",
    'link.ext.phone': "Llamar a {value}",
    'link.ext.web': "Ir a {value}",
    'link.quick.title': "Otro destino",
    'link.quick.web': "Sitio web",
    'link.quick.email': "Correo",
    'link.quick.phone': "Teléfono",
    'link.quick.whatsapp': "WhatsApp",
    'link.quick.delivery': 'Pedidos',
    'link.compose.deliveryLabel': 'Enlace de tu tienda en la app',
    'link.compose.deliveryPlaceholder': 'https://www.ubereats.com/store/…',
    'link.compose.deliveryHint': 'Copia el enlace de tu restaurante en {apps}.',
    'link.orderOn': 'Pedir en {app}',
    'link.quick.opentable': 'OpenTable',
    'link.compose.opentableLabel': 'ID de tu restaurante en OpenTable',
    'link.compose.opentablePlaceholder': 'Ej. 1434817',
    'link.compose.opentableHint': 'El botón abre la página de reservas de OpenTable. También sirve pegar el enlace o el código del widget.',
    'link.compose.webLabel': "Dirección web",
    'link.compose.webPlaceholder': "ejemplo.com",
    'link.compose.emailLabel': "Correo electrónico",
    'link.compose.emailPlaceholder': "hola@tunegocio.com",
    'link.compose.phoneLabel': "Número de teléfono",
    'link.compose.phonePlaceholder': "+52 55 1234 5678",
    'link.compose.whatsappLabel': "Número de WhatsApp",
    'link.compose.whatsappHint': "Con el código de país delante.",
    'link.compose.whatsappMessage': "Mensaje inicial (opcional)",
    'link.compose.whatsappMessagePlaceholder': "Hola, quiero más información",
    'link.compose.use': "Usar",
    'link.compose.back': "Volver",
    'link.compose.invalid': "Revisa que esté bien escrito.",
    'link.whatsappTo': "WhatsApp · {value}",
    'token.cardNone': "Sin estilo",
    'plans.feat.coursesOff': "Sin venta de cursos",
    'error.billing.paymentInProgress': "Tu pago se está procesando. En unos segundos verás tu plan activo.",
    'plans.exists.title': "Ya tienes una membresía",
    'plans.exists.body': "Para cambiar de plan, cambiar de ciclo de pago o cancelar, hazlo desde Facturación.",
    'plans.exists.cta': "Ir a Facturación",
    'plans.exists.close': "Cerrar",
    'plans.checkout.billedAnnuallShort': "Facturado anualmente",
    'plans.checkout.chargeToday': "${amount} hoy",
    'plans.checkout.betaBadge': "Beta · {percent}% aplicado",
    'plans.regularAnnual': "Precio anual normal",
    'plans.betaDiscountRow': "Descuento Beta ({percent}%)",
    'plans.renewNote': "Después del primer año se renueva al precio anual normal.",
    'plans.checkout.betaNote': "Descuento de lanzamiento aplicado a tu primer año. Después, tu plan se renueva al precio anual normal.",
    'legal.effective': "En vigor desde el {date} · Versión {version}",
    'legal.toc': "Contenido",
    'legal.allDocs': "Ver todos los documentos legales",
    'legal.hubTitle': "Información legal",
    'legal.hubIntro': "Los documentos que rigen el uso de véltica, ordenados por tema.",
    'legal.language': "Idioma",
    'legal.group.core': "Lo esencial",
    'legal.group.product': "Por producto",
    'legal.group.data': "Datos",
    'anim.title': "Animación",
    'anim.source.asBrand': "Como la marca",
    'anim.source.withBlock': "Entra con su bloque",
    'anim.source.editGlobal': "Editar marca",
    'anim.close': "Cerrar",
    'anim.empty': "Selecciona un elemento para animarlo.",
    'anim.play': "Reproducir",
    'anim.enter': "Entrada",
    'anim.none': "Sin animación",
    'anim.group.fade': "Desvanecer",
    'anim.group.scale': "Escala",
    'anim.group.motion': "Movimiento",
    'anim.group.reveal': "Revelar",
    'anim.preset.fade': "Aparecer",
    'anim.preset.fade-up': "Subir",
    'anim.preset.fade-down': "Bajar",
    'anim.preset.fade-left': "Desde la derecha",
    'anim.preset.fade-right': "Desde la izquierda",
    'anim.preset.zoom-in': "Acercar",
    'anim.preset.zoom-out': "Alejar",
    'anim.preset.pop': "Rebote",
    'anim.preset.blur-in': "Enfocar",
    'anim.preset.flip-up': "Voltear arriba",
    'anim.preset.flip-left': "Voltear de lado",
    'anim.preset.rotate-in': "Girar",
    'anim.preset.reveal-up': "Revelar hacia arriba",
    'anim.preset.reveal-left': "Revelar de lado",
    'anim.timing': "Cuándo y cómo",
    'anim.trigger': "Empieza",
    'anim.trigger.scroll': "Al aparecer",
    'anim.trigger.load': "Al cargar",
    'anim.repeat': "Se reproduce",
    'anim.offset': "Inicio",
    'anim.offsetHint': "Cuánto tiene que subir el elemento en la pantalla, desde abajo, antes de animarse. Súbelo si empieza demasiado pronto.",
    'anim.repeat.once': "Una vez",
    'anim.repeat.always': "Cada vez",
    'anim.duration': "Duración",
    'anim.delay': "Retraso",
    'anim.easing': "Curva",
    'anim.easing.smooth': "Suave",
    'anim.easing.expo': "Ágil",
    'anim.easing.spring': "Elástica",
    'anim.easing.in-out': "Equilibrada",
    'anim.easing.linear': "Lineal",
    'anim.distance': "Recorrido",
    'anim.distance.sm': "Corto",
    'anim.distance.md': "Medio",
    'anim.distance.lg': "Largo",
    'anim.target': "Qué se anima",
    'anim.target.self': "El elemento",
    'anim.target.children': "Su contenido, uno a uno",
    'anim.targetHint': "«Uno a uno» anima cada tarjeta, imagen o texto de dentro con un pequeño intervalo, en orden.",
    'anim.stagger': "Intervalo",
    'anim.hover': "Al pasar el ratón",
    'anim.hoverHint': "En celulares no hay ratón: este efecto sólo se ve en computadora.",
    'anim.hover.none': "Ninguno",
    'anim.hover.lift': "Elevar",
    'anim.hover.grow': "Agrandar",
    'anim.hover.shrink': "Hundir",
    'anim.hover.glow': "Brillo",
    'anim.hover.dim': "Atenuar",
    'anim.hover.shadow': "Sombra",
    'anim.hover.outline': "Contorno",
    'anim.hover.tilt': "Inclinación",
    'anim.reset': "Quitar animación",
    'anim.canvasHint': "En el lienzo se reproduce al cambiar un ajuste o con «Reproducir». En el sitio publicado, cuando aparece en pantalla. Quien pide menos movimiento en su dispositivo lo ve sin animar.",
    'anim.tab.enter': "Entrada",
    'anim.tab.timing': "Ritmo",
    'anim.tab.hover': "Hover",
    'anim.when': "Cuándo",
    'anim.needsEnter': "Primero elige una entrada: el ritmo y cuándo empieza son de la animación de entrada.",
    'anim.chooseEnter': "Elegir entrada",
    'anim.tab.when': "Cuándo",
    'stateScope.aria': "A qué afecta este estado",
    'stateScope.global': "Estilo global",
    'stateScope.element': "Solo este elemento",
    'stateScope.globalNote': "Editas «{name}»: el cambio llega a los {count} elementos que lo usan.",
    'stateScope.elementNote': "Solo este elemento. Lo que cambies aquí gana sobre «{name}».",
    'stateScope.transition': "Transición",
    'stateScope.duration': "Duración",
    'stateScope.easing': "Curva",
    'stateScope.instant': "Instantánea",
    'stateScope.ease.smooth': "Suave",
    'stateScope.ease.ease': "Estándar",
    'stateScope.ease.ease-out': "Ágil",
    'stateScope.ease.linear': "Lineal",
    'stateScope.reset': "Volver al de fábrica",
    'buttonHover.auto': "Automático",
    'buttonHover.darken': "Oscurecer",
    'buttonHover.lighten': "Aclarar",
    'buttonHover.lift': "Elevar",
    'buttonHover.glow': "Brillo",
    'buttonHover.none': "Ninguno",
    'buttonHover.hint': "Pasa el ratón por cada opción para verla. Lo elegido lo heredan todos los botones con este estilo.",
    'buttonHover.customHint': "Este botón tiene un hover a medida, hecho en el inspector. Elegir una opción lo reemplaza.",
    'stateScope.ownNote': "Este estado es sólo de este elemento.",
    'stateScope.presets': "Atajos",
    'statePreset.hover.lift': "Elevar",
    'statePreset.hover.grow': "Agrandar",
    'statePreset.hover.dim': "Atenuar",
    'statePreset.hover.shadow': "Sombra",
    'statePreset.hover.underline': "Subrayar",
    'statePreset.hover.accent': "Color de acento",
    'statePreset.pressed.sink': "Hundir",
    'statePreset.pressed.dim': "Atenuar",
    'statePreset.focus.ring': "Anillo",
    'statePreset.focus.glow': "Halo",
    'stateScope.appliesTo': "Se aplica a",
    'stateScope.elementShort': "Este elemento",
    'state.none': "Estado",
    'anim.demoWord': "Hola",
    'anim.demoWords': "Hola mundo",
    'anim.group.text': "Letras",
    'anim.preset.text-rise': "Subir letras",
    'anim.preset.text-fade': "Letra a letra",
    'anim.preset.text-blur': "Enfocar letras",
    'anim.preset.text-drop': "Caer letras",
    'anim.preset.text-words': "Palabras",
    'anim.preset.text-typewriter': "Máquina de escribir",
    'anim.textPieces': "Letra a letra",
    'anim.textPiecesHint': "El tiempo entre una letra y la siguiente.",
    'anim.textPiecesHintWords': "El tiempo entre una palabra y la siguiente.",
    'anim.group.image': "Imagen",
    'anim.preset.mask-up': "Abrir hacia arriba",
    'anim.preset.mask-down': "Abrir hacia abajo",
    'anim.preset.mask-right': "Abrir a la derecha",
    'anim.preset.mask-left': "Abrir a la izquierda",
    'anim.preset.mask-center': "Abrir del centro",
    'anim.preset.mask-iris': "Iris",
    'anim.preset.mask-zoom': "Zoom de cine",
    'design.evergreen': "Bosque",
    'design.evergreen.desc': "Verde bosque sobrio, crema cálido y dorado viejo",
    'design.voltage': "Voltaje",
    'design.voltage.desc': "Grafito casi negro con lima eléctrico y lima oliva",
    'design.pulse': "Pulso",
    'design.pulse.desc': "Gris perla y tinta negra con un lima de acción, todo en píldora y tarjetas redondas",
    'design.coral': "Coral",
    'design.coral.desc': "Blanco, menta clara y azul petróleo con botones coral y un acento coral más profundo",
    'design.executive': "Ejecutivo",
    'design.executive.desc': "Azul marino y acero con tipografía limpia y tarjetas definidas para empresas",
    'design.advisory': "Asesoría",
    'design.advisory.desc': "Papel cálido, oliva y bronce con títulos serif para servicios profesionales",
    'design.capital': "Capital",
    'design.capital.desc': "Bosque oscuro, marfil y dorado sobrio para inversión y gestión patrimonial",
    'design.enterprise': "Enterprise",
    'design.enterprise.desc': "Azul noche, azul claro y tarjetas precisas para software empresarial",
    'design.counsel': "Jurídico",
    'design.counsel.desc': "Blanco cálido, borgoña y títulos serif clásicos para despachos",
    'design.estate': "Inmobiliario",
    'design.estate.desc': "Piedra, grafito y bronce con espacio generoso para inmuebles y arquitectura",
    'design.industry': "Industrial",
    'design.industry.desc': "Gris acero, azul petróleo y cobre con tarjetas compactas para servicios industriales",
    'design.care': "Salud",
    'design.care.desc': "Blanco y verde azulado suave con tipografía clara y tarjetas redondeadas para clínicas",
    'design.impact': "Impacto",
    'design.impact.desc': "Salvia, verde bosque y blancos naturales para negocios sostenibles",
    'design.venture': "Venture",
    'design.venture.desc': "Berenjena oscuro y lavanda con tipografía sobria para inversión y tecnología",
    'design.sorbet': 'Sorbete',
    'design.sorbet.desc': 'Crema, botones de frutos rojos y títulos retro fluidos con tarjetas redondeadas',
    'cwa.look.sorbet': 'Sorbete',
    'design.wiggle': 'Curva',
    'design.wiggle.desc': 'Verdes botánicos, títulos con curvas y detalles en naranja cálido',
    'cwa.look.wiggle': 'Curva',
    'design.papaya': 'Papaya',
    'design.papaya.desc': 'Papel cálido, acciones terracota y títulos serif expresivos',
    'cwa.look.papaya': 'Papaya',
    'design.sunbeam': 'Rayo',
    'design.sunbeam.desc': 'Crema mantequilla, naranja tostado y títulos redondeados con alegría',
    'cwa.look.sunbeam': 'Rayo',
    'design.bounce': 'Rebote',
    'design.bounce.desc': 'Lavanda, acciones violeta y títulos redondeados con espacio generoso',
    'cwa.look.bounce': 'Rebote',
    'design.clubhouse': 'Club',
    'design.clubhouse.desc': 'Blanco avena, verde bosque y títulos gráficos para una marca cercana y segura',
    'cwa.look.clubhouse': 'Club',
    'design.bagel': 'Bagel',
    'design.bagel.desc': 'Avena, espresso y acentos ladrillo con títulos voluminosos y tarjetas suaves',
    'cwa.look.bagel': 'Bagel',
    'design.confetti': 'Confeti',
    'design.confetti.desc': 'Papel lila, detalles de frutos rojos y letras burbuja con textos limpios',
    'cwa.look.confetti': 'Confeti',
    'design.block-party': 'Verbena',
    'design.block-party.desc': 'Crema, azul petróleo y títulos contundentes con sombras gráficas discretas',
    'cwa.look.block-party': 'Verbena',
    'design.maison': 'Maison',
    'design.maison.desc': 'Marfil, títulos serif finos y botones carbón con mucho aire',
    'cwa.look.maison': 'Marfil',
    'design.runway': 'Pasarela',
    'design.runway.desc': 'Blanco puro, tipografía grotesca de peso alto y acciones negras rectas',
    'cwa.look.runway': 'Monocromo fuerte',
    'design.couture': 'Couture',
    'design.couture.desc': 'Blanco y pergamino con títulos Italiana delicados y botones espaciados',
    'cwa.look.couture': 'Letra delicada',
    'design.atelier': 'Atelier',
    'design.atelier.desc': 'Crema cálido, un acento verde discreto y títulos serif clásicos',
    'cwa.look.atelier': 'Crema clásico',
    'design.silk': 'Seda',
    'design.silk.desc': 'Perla y rosa apagado con títulos serif fluidos y botones simples',
    'cwa.look.silk': 'Perla suave',
    'design.sable': 'Arena fina',
    'design.sable.desc': 'Arena y café con títulos sans ligeros y bordes limpios',
    'cwa.look.sable': 'Minimal cálido',
    'design.bordeaux': 'Burdeos',
    'design.bordeaux.desc': 'Blanco cálido, botones burdeos y títulos Prata elegantes',
    'cwa.look.bordeaux': 'Burdeos',
    'design.sculpture': 'Escultura',
    'design.sculpture.desc': 'Piedra caliza, carbón y tipografía sans sobria con espacios amplios',
    'cwa.look.sculpture': 'Piedra',
    'design.archive': 'Archivo',
    'design.archive.desc': 'Papel, grafito y tipografía sans contenida con contornos finos',
    'cwa.look.archive': 'Grafito sobrio',
    'design.noir': 'Noir',
    'design.noir.desc': 'Negro cálido, acciones marfil y títulos serif ligeros sin brillos',
    'design.encore': 'Encore',
    'design.encore.desc': 'Crema y violeta noche alternados, títulos condensados y botones píldora rosa',
    'cwa.look.noir': 'Marfil oscuro',
    'cwa.look.encore': 'Escenario',
    'draft.title': "Tienes cambios sin guardar",
    'draft.text': "Quedaron en este navegador {when}. ¿Los recuperas?",
    'draft.restore': "Recuperar",
    'draft.discard': "Descartar",
    'crash.title': "Algo falló en el editor",
    'crash.saving': "Guardando una copia de tus cambios en este navegador…",
    'crash.safe': "Tus cambios están a salvo en este navegador. Recarga y el editor te ofrecerá recuperarlos.",
    'crash.reload': "Recargar el editor",
    'crash.details': "Detalles técnicos",
    'error.page.conflict': "Esta página se cambió en otro lugar desde que la abriste.",
    'error.project.conflict': "Este proyecto se cambió en otro lugar desde que lo abriste.",
    'save.err.conflict': "Alguien más guardó cambios",
    'save.err.conflictDetail': "Este proyecto se cambió en otro lugar (otra pestaña, otro dispositivo u otra persona) desde que lo abriste. Para no borrar nada, el guardado se detuvo.",
    'save.err.offline': "Sin conexión",
    'save.err.offlineDetail': "Tu dispositivo no tiene internet. Tus cambios siguen en el editor y se guardarán al reconectar.",
    'save.err.auth': "Sesión expirada",
    'save.err.authDetail': "No se pudo renovar tu sesión. Recarga la página para volver a iniciar sesión; tus cambios siguen aquí.",
    'save.err.network': "No se pudo contactar el servidor",
    'save.err.networkDetail': "La petición no llegó a completarse ({raw}). Suele ser una caída breve de red; se reintenta solo. Envío: {size} KB.",
    'save.err.plan': "Tu plan no admite más",
    'save.err.planPages': "Tu plan no admite más páginas",
    'save.err.planPagesOne': "El resto de tus cambios se guardó. «{name}» sigue sin guardar: bórrala del sitio o sube de plan y se guardará sola.",
    'save.err.planPagesMany': "El resto de tus cambios se guardó. {count} páginas siguen sin guardar: bórralas del sitio o sube de plan y se guardarán solas.",
    'save.err.server': "Error del servidor (HTTP {status})",
    'save.err.serverDetail': "{raw}. Se reintenta solo. Envío: {size} KB.",
    'conflict.title': "Alguien más guardó cambios",
    'conflict.text': "Este proyecto se cambió en otro lugar (otra pestaña, otro dispositivo u otra persona del equipo) desde que lo abriste. Para no borrar nada, dejamos de guardar hasta que elijas.",
    'conflict.reload': "Ver lo guardado",
    'conflict.reloadHint': "Recarga con la versión del servidor. Lo tuyo queda en este navegador y podrás recuperarlo.",
    'conflict.overwrite': "Guardar lo mío encima",
    'conflict.overwriteHint': "Reemplaza lo que se guardó en otro lugar con lo que tienes aquí.",
    'tabs.otherOpen': "Este proyecto también está abierto en otra pestaña. Edita en una sola para no mezclar cambios.",
    'tabs.gotIt': "Entendido",
    'elements.basics': "Básicos",
    'boot.otherAccountHelp': "Vuelve al dashboard e inicia sesión con la cuenta dueña del proyecto.",
    'nav.sep.none': "Ninguno",
    'nav.sep.line': "Línea",
    'nav.sep.dot': "Punto",
    'nav.sep.slash': "Barra",
    'cms.collectionImageLabel': "Imagen de colección",
    'cms.noCollections': "Sin contenido",
    'cms.allCollectionsIndex': "Todas las colecciones (índice)",
    'ai.target.typography': "Tipografía",
    'ai.progress.globalStyles': "Colores y tipografías",
    'ai.progress.logo': "Logo de la barra",
    'ai.issue.pageGone': "La página «{page}» ya no existe.",
    'ai.issue.duplicate': "La operación «{id}» está duplicada.",
    'ai.issue.unknownStyle': "El estilo pedido no corresponde a ningún estilo, color, letra o look del panel.",
    'ai.issue.buttonStyleGone': "El estilo global de botón «{style}» ya no existe o pertenece a enlaces.",
    'ai.issue.emptyIconChange': "El cambio global de icono no contiene estilos ni tamaño.",
    'ai.issue.noTarget': "No se encontró el destino para insertar el componente.",
    'ai.dim.height': "Alto",
    'ai.dim.width': "Ancho",
    'ai.dim.gap': "Separación",
    'ai.dim.margin': "Margen exterior",
    'ai.dim.padding': "Espaciado interno",
    'ai.dim.radius': "Redondeado",
    'ai.dim.weight': "Grosor de letra",
    'ai.dim.fontSize': "Tamaño de letra",
    'ai.dim.border': "Grosor de borde",
    'ai.dim.lineHeight': "Interlineado",
    'ai.dim.opacity': "Opacidad",
    'ai.dim.already': "{what} ya es {value}.",
    'ai.dim.atMax': "Ya está en el máximo de {what}.",
    'ai.dim.atMin': "Ya no queda {what} que reducir.",
    'ai.local.repeated': "Repetido.",
    'ai.local.alsoApplied': "Aplicado también en {breakpoint}.",
    'ai.local.moved': "Elemento movido.",
    'ai.local.imageDuplicated': "Imagen duplicada.",
    'ai.local.selectImage': "Selecciona una imagen o una sección que ya contenga una imagen para agregar otra con el mismo diseño.",
    'ai.local.selectGrid': "Selecciona una tarjeta o una sección que contenga un grid para agregar más elementos.",
    'ai.local.addedOne': "Se agregó 1 elemento al grid.",
    'ai.local.addedMany': "Se agregaron {count} elementos al grid.",
    'ai.local.linkUpdated': "Enlace actualizado a {href}.",
    'ai.local.willDelete': "Se eliminará el elemento seleccionado.",
    'ai.local.duplicated': "Elemento duplicado.",
    'ai.dim.changedToken': "{what}: {value} · estilo {token}.",
    'ai.dim.changedElement': "{what}: {value} · solo este elemento.",
    'layers.addBanner': "Agregar banner",
    'cfloat.title': "Botón de contacto",
    'cfloat.channels': "Canales",
    'cfloat.look': "Apariencia",
    'cfloat.noChannelsShort': "Sin canales",
    'cfloat.lead': "Flota abajo en todas las páginas, con tus canales.",
    'cfloat.show': "Mostrar en el sitio",
    'cfloat.whatsapp': "WhatsApp",
    'cfloat.whatsappMessage': 'Mensaje',
    'cfloat.whatsappMessagePlaceholder': '¡Hola! Me gustaría recibir más información.',
    'cfloat.whatsappHelp': "Con lada del país. Abre un chat contigo en WhatsApp.",
    'cfloat.phone': "Teléfono para llamar",
    'cfloat.email': "Correo",
    'cfloat.emailPlaceholder': "hola@tunegocio.com",
    'cfloat.form': "«Enviar mensaje» (mini formulario)",
    'cfloat.formHelp': "Los mensajes llegan a tu correo y a Mensajes, como los de cualquier formulario del sitio.",
    'cfloat.greeting': "Saludo",
    'cfloat.greetingPlaceholder': "¿En qué te ayudamos?",
    'cfloat.side': "Lado",
    'cfloat.left': "Izquierda",
    'cfloat.right': "Derecha",
    'cfloat.noChannels': "Agrega al menos un canal para que se vea en el sitio.",
    'cfloat.remove': "Quitar del sitio",
    'cfloat.add': "Botón de contacto",
    'cfloat.channel.whatsapp': "WhatsApp",
    'cfloat.channel.phone': "Llamar",
    'cfloat.channel.email': "Correo",
    'cfloat.channel.form': "Mensaje",
    'layers.addElement': "Añadir elemento",
    'layers.siteBanner': "Banner",
    'brand.comboHint': "Colores, letras y formas en un clic",
    'bp.banner': "Banner",
    'bp.socialLinks': "Redes sociales",
    'social.tab.accounts': "Redes",
    'social.tab.look': "Aspecto",
    'social.style': "Forma",
    'social.style.icons': "Sólo iconos",
    'social.style.labels': "Icono y nombre",
    'social.style.buttons': "Botones",
    'social.style.list': "Lista",
    'social.shape': "Fondo",
    'social.shape.circle': "Círculo",
    'social.shape.square': "Cuadrado",
    'social.shape.plain': "Sin fondo",
    'social.colors': "Colores",
    'social.colors.site': "Los del sitio",
    'social.colors.brand': "Los de cada red",
    'social.size': "Tamaño",
    'social.size.sm': "Pequeño",
    'social.size.md': "Mediano",
    'social.size.lg': "Grande",
    'social.accountsHint': "Son las redes de tu negocio: cambiarlas aquí las cambia en todo el sitio. El interruptor sólo la esconde en este elemento.",
    'social.showHere': "Mostrar aquí",
    'social.empty': 'Todavía no has agregado cuentas.',
    'social.add': 'Agregar cuenta',
    'social.network': 'Red social',
    'social.other': 'Otro',
    'social.title': 'Título',
    'social.titlePlaceholder': 'Por ejemplo, nuestra comunidad',
    'social.url': 'Enlace',
    'social.remove': 'Eliminar {account} del sitio',
    'social.accountUrl': 'Enlace de {account}',
    'social.urlPlaceholder': 'https://',
    'social.sharedHint': 'Estas cuentas se comparten en todo el sitio.',
    'social.edit': 'Editar enlace',
    'bp.bannerContact': "Banner de contacto",
    'bp.bannerContactLink': "Dato de contacto",
    'bnr.contact.call': "Llámanos",
    'bnr.contact.email': "Escríbenos",
    'bp.bannerContent': "Contenido",
    'bp.bannerMessage': "Mensaje",
    'sample.bannerText': "Envío gratis en pedidos de más de $50",
    'sample.bannerLink': "Ver más",
    'bnr.message': "Mensaje",
    'bnr.messagePlaceholder': "Una promoción, un aviso…",
    'bnr.link': "Enlace",
    'bnr.linkText': "Texto del enlace",
    'bnr.icon': "Icono",
    'bnr.background': "Fondo",
    'bnr.bg.footer': "Como el pie",
    'bnr.bg.brand': "Color de marca",
    'bnr.bg.soft': "Suave",
    'bnr.hint': "Sale encima del menú en todas las páginas.",
    'bnr.tab.content': "Mensaje",
    'bnr.tab.extras': "Extras",
    'bnr.tab.display': "Visibilidad",
    'bnr.views': "Ajustes del banner",
    'bnr.code': "Código de descuento",
    'bnr.codeHint': "Quien visita lo copia con un clic.",
    'sample.bannerCode': "AHORRA20",
    'bnr.phone': "Teléfono",
    'bnr.phoneVia': "Al tocarlo",
    'bnr.via.call': "Llamar",
    'bnr.via.whatsapp': "WhatsApp",
    'bnr.phonePlaceholder': "+52 55 1234 5678",
    'bnr.socials': "Redes sociales",
    'bnr.socialsHint': "Deja vacía la que no uses.",
    'bnr.close': "Botón de cerrar",
    'bnr.closeHint': "Quien lo cierra no lo vuelve a ver, hasta que cambies las fechas.",
    'bnr.from': "Desde",
    'bnr.until': "Hasta",
    'bnr.clearDate': "Quitar fecha",
    'bnr.status.always': "Se ve siempre.",
    'bnr.status.live': "Se ve ahora.",
    'bnr.status.upcoming': "Empieza el {date}. Hasta entonces no se ve.",
    'bnr.status.ended': "Terminó el {date}: ya no se ve.",
    'bnr.datesHint': "En la hora de quien visita. En el editor se ve siempre.",
    'bnr.thisPage': "En esta página",
    'bnr.align': "Alineación",
    'bnr.align.center': "Centrado",
    'bnr.align.spread': "A los lados",
    'bp.bannerCode': "Código",
    'bp.bannerPhone': "Teléfono",
    'bp.bannerSocials': "Redes",
    'bp.bannerClose': "Cerrar",
    'bnr.fromEmpty': "Desde ya",
    'bnr.untilEmpty': "Sin fecha de fin",
    'bnr.onlyHere': "Sólo en esta página",
    'bnr.onlyHereHint': "Sale únicamente en «{page}». En las demás páginas no aparece.",
    'layers.showHere': "Mostrar aquí",
    'layers.simple.hideOnPage': "Ocultar sólo en esta página",
    'layers.simple.removeFromSite': "Eliminar de todas las páginas",
    'layers.simple.onlyOnPage': "Mostrar sólo en esta página",
    'layers.simple.showEverywhere': "Mostrar en todas las páginas",
    'layers.simple.bannerSettings': "Más opciones del banner…",
    'layers.simple.navSettings': "Más opciones del menú…",
    'layers.simple.footerSettings': "Más opciones del pie…",
    'layers.onlyOn': "Sólo en {pages}",
    'blk.editBlock': "Editar bloque",
    'blk.addElement': "Agregar elemento",
    'dashfoot.copyright': "© {year} Véltica. Todos los derechos reservados.",
    'dashfoot.help': "Centro de ayuda",
    'dashfoot.cookies': "Aviso de cookies",
    'dashfoot.terms': "Términos",
    'dashfoot.privacy': "Privacidad",
    'workspace.saveConflict': "Este proyecto se cambió en otro sitio (por ejemplo en el editor) mientras lo tenías abierto aquí. Lo hemos vuelto a cargar; repite tu último cambio.",
    'panel.insert.desc': "Agrega elementos y bloques nuevos a la página.",
    'panel.images.desc': "Busca e inserta imágenes de la biblioteca profesional.",
    'panel.files.desc': "Sube y administra los archivos propios de tu sitio.",
    'panel.templates.desc': "Explora secciones prediseñadas y agrégalas al canvas.",
    'panel.pages.desc': "Las páginas del sitio y las colecciones del CMS, sin salir del lienzo.",
    'insp.autoHideTip': "Auto-ocultar panel (se revela al pasar el mouse)",
    'insp.autoHideInspectorTip': "Auto-ocultar el inspector (se revela al pasar el mouse)",
    'pages.settingsOf': "Ajustes de {name}",
    'pub.subdomainTaken': " Prueba con «{subdomain}-2» o una variante de tu marca.",
    'layer.title': "Título",
    'layer.metric': "Métrica",
    'layer.embed': "Código",
    'layer.h1': "Título 1",
    'layer.h2': "Título 2",
    'layer.h3': "Título 3",
    'layer.h4': "Título 4",
    'layer.h5': "Título 5",
    'layer.h6': "Título 6",
    'state.removeBreakpointOverride': "Quitar override de este breakpoint",
    'section.saved': "Sección guardada",
    'section.saveFailed': "No se pudo guardar la sección",
    'section.defaultName': "Mi sección",
    'cms.removeImageN': "Quitar la imagen {n}",
    'cms.optionActions': "Opciones de {option}",
    'cms.editNameOf': "Editar el nombre de {name}",
    'tokkind.color': "color",
    'tokkind.typography': "estilo de texto",
    'tokkind.button': "estilo de botón",
    'tokkind.card': "estilo de tarjeta",
    'tokkind.section': "estilo de sección",
    'tokkind.icon': "estilo de icono",
    'img.uploadFailedNamed': "No se pudo subir {name}",
    'img.retry': 'Reintentar',
    'img.oneSelected': "1 seleccionada",
    'img.nSelected': "{count} seleccionadas",
    'boot.openProjectAgain': "Vuelve al dashboard e intenta abrir el proyecto de nuevo.",
    'pgnav.listActions': "Acciones del listado de {name}",
    'pgnav.templateActions': "Acciones de la plantilla de {name}",
    'link.cmsThisCard': "La ficha de esta tarjeta",
    'link.cmsFirst': "La primera de la colección",
    'upload.networkError': "Error de red al subir el archivo",
    'cms.contentSource': "Origen del contenido",
    'cms.bringContent': "Traer el contenido del CMS",
    'cms.bringShort': "Traer del CMS",
    'schedule.all': "Todas",
    'schedule.activeBoth': "Activas (por venir y en curso)",
    'upload.manyInvalid': "{count} archivos no se pueden subir. {first}",
    'layers.lockTip': "Bloquear (no seleccionable)",
    'layers.unlockTip': "Desbloquear (permitir seleccionar)",
    'fill.noImage': "Sin imagen",
    'countdown.defaultLabel': "Lanzamiento",
    'token.oneElement': "1 elemento",
    'token.nElements': "{count} elementos",
    'panel.letterSpacing': "Espaciado de letras",
    'cms.siteUnpublished': "Sitio sin publicar",
    'pub.inBackground': "en segundo plano",
    'cms.viewEntry': "Ver la ficha",
    'cms.editEntry': "Editar la ficha",
    'cms.pickOtherRecord': "Elegir otro registro",
    'image.changeShort': "Cambiar",
    'cms.theEntries': "Las fichas",
    'ai.legacyId': "ID anterior conservado para compatibilidad.",
    'cms.statusOf': "Estado de {name}",
    'cms.actionsOf': "Acciones de {name}",
    'pgnav.actionsOf': "Acciones de {name}",
    'panel.ariaOf': "Panel de {title}",
    'menu.itemName': "Nombre del elemento {n}",
    'footer.colLinks': "Enlaces de la columna {n}",
    'limit.contactSubject': "Necesito más capacidad en Business",
    'cmphint.logo': "Texto o imagen",
    'cmphint.menu': "Elementos editables",
    'cmphint.actions': "Botón de acción de la barra",
    'cmphint.navBackground': "Color, imagen, transparencia",
    'cmphint.behavior': "Fija y reducida al bajar",
    'cmphint.columns': "Títulos y enlaces",
    'cmphint.footerLogo': "El mismo de la barra o uno propio",
    'cmphint.primaryIcons': "Conjunto y tamaño grande",
    'cmphint.secondaryIcons': "Conjunto y tamaño pequeño",
    'cmphint.textInput': "Campo base",
    'cmphint.textarea': "Área larga",
    'cmphint.choice': "Casilla y opción",
    'cmphint.labels': "Texto de las etiquetas",
    'cmphint.errors': "Estados de error",
    'cmphint.configure': "Configurar",
    'error.domain.cloudflareFailed': "No se pudo registrar el dominio. Inténtalo de nuevo en unos minutos.",
    'error.domain.saveFailed': "No se pudo guardar el dominio.",
    'error.domain.requestFailed': "No pudimos registrar la solicitud.",
    'error.domain.purchaseRateLimited': "Demasiados intentos de compra. Espera un minuto.",
    'error.domain.paymentStartFailed': "No se pudo iniciar el pago.",
    'error.query.invalid': "Consulta inválida.",
    'error.query.invalidCursor': "Cursor inválido.",
    'common.optionsOf': "Opciones de {name}",
    'billing.invoice.viewOf': "Ver la factura de {date}",
    'billing.invoice.downloadOf': "Descargar la factura de {date}",
    'billing.membership.grantedUntil': "Vigente hasta el {date}. Este plan fue asignado directamente a tu cuenta.",
    'overview.openItem': "Abrir {name}",
    'overview.unnamedContact': "Contacto sin nombre",
    'common.colorNamed': "Color {name}",
    'common.iconNamed': "Icono {name}",
    'common.moveNamed': "Mover {name}",
    'common.openNamed': "Abrir {name}",
    'common.selectNamed': "Seleccionar {name}",
    'common.removeNamed': "Quitar {name}",
    'common.moveUpNamed': "Subir {name}",
    'common.moveDownNamed': "Bajar {name}",
    'common.deleteNamed': "Eliminar {name}",
    'common.renameNamed': "Renombrar {name}",
    'common.editNamed': "Editar {name}",
    'common.addNamed': "Agregar {name}",
    'menu.urlItemN': "Elemento de URL {n}",
    'effect.panelN': "Panel {n}",
    'admin.users.subtitle': "Administra roles y consulta la suscripción y los proyectos de cada cuenta.",
    'admin.users.viewPublished': "Ver {name} publicado",
    'dash.widgetNamed': "Widget {name}",
    'bookings.statusOf': "Estado de la cita de {name}",
    'bookings.aCustomer': "un cliente",
    'forms.sentBy': "Enviado por {name} · {date}",
    'forms.aVisitor': "un visitante",
    'forms.starMessageOf': "Destacar el mensaje de {name}",
    'forms.noName': "sin nombre",
    'overview.stepsDone': "{done} de {total} pasos completados",
    'overview.hideStep': "Ocultar {name}",
    'home.templatePreviewOf': "Vista previa de {name}",
    'brand.sectionAccent': "Sección de acento",
    'error.ai.providerFailed': "El proveedor de IA devolvió un error. Inténtalo de nuevo en un momento.",
    'cwa.look.product': "Suave",
    'cwa.look.studio': "Redondeado",
    'cwa.look.precision': "Línea fina",
    'cwa.look.notebook': "Trazo a mano",
    'cwa.look.brutalist': "Bloques",
    'cwa.look.wireframe': "Recto",
    'cwa.look.creator': "En relieve",
    'cwa.look.marketplace': "Compacto",
    'cwa.look.editorial': "Editorial",
    'cwa.look.gallery': "Galería",
    'cwa.look.luxury': "Espaciado",
    'cwa.look.swiss': "Geométrico",
    'cwa.look.consulting': "Sobrio",
    'cwa.look.fintech': "Flotante",
    'cwa.look.calm': "Amplio",
    'cwa.look.heritage': "Clásico",
    'cwa.look.developer': "Técnico",
    'cwa.look.clay': "Arcilla",
    'cwa.look.retail': "Tienda",
    'cwa.look.nordic': "Ligero",
    'cwa.look.pulse': "Marcado",
    'cwa.look.coral': "Suave",
    'cwa.look.evergreen': "Limpio",
    'cwa.look.voltage': "Brillo",
    'cwa.look.executive': "Ejecutivo",
    'cwa.look.advisory': "Sereno",
    'cwa.look.capital': "Afilado",
    'cwa.look.enterprise': "Pulido",
    'cwa.look.counsel': "Formal",
    'cwa.look.estate': "Señorial",
    'cwa.look.industry': "Industrial",
    'cwa.look.care': "Cercano",
    'cwa.look.impact': "Abierto",
    'cwa.look.venture': "Moderno",
    'cwa.paletteBrand': "Los colores de tu marca",
    'cwa.paletteBrandBadge': "Tu marca",
    'nav.aiUnmet': "Pedidos a la IA",
    'nav.adminEmails': 'Correos',
    'global.aiUnmet': "Pedidos a la IA",
    'global.adminEmails': 'Correos',
    'aiUnmet.title': "Lo que la IA no pudo hacer",
    'aiUnmet.subtitle': "Lo que los clientes pidieron al crear sitios y páginas y no tenemos. Ordenado por cuántas personas distintas lo pidieron.",
    'aiUnmet.kind.all': "Todo",
    'aiUnmet.kind.section': "Secciones",
    'aiUnmet.kind.element': "Elementos",
    'aiUnmet.kind.font': "Letras",
    'aiUnmet.kind.style': "Estilos",
    'aiUnmet.kind.feature': "Funciones",
    'aiUnmet.lastDays': "{count} días",
    'aiUnmet.loading': "Cargando…",
    'aiUnmet.loadFailed': "No se pudo cargar la lista.",
    'aiUnmet.retry': "Reintentar",
    'aiUnmet.empty': "Nada por ahora",
    'aiUnmet.emptyBody': "Cuando alguien pida algo que la IA no pueda hacer, aparecerá aquí.",
    'aiUnmet.col.what': "Pedido",
    'aiUnmet.col.kind': "Tipo",
    'aiUnmet.col.people': "Personas",
    'aiUnmet.col.times': "Veces",
    'aiUnmet.col.source': "Origen",
    'aiUnmet.col.lastSeen': "Último",
    'aiUnmet.instead': "En su lugar: {categories}",
    'aiUnmet.fromCode': "Detectado",
    'aiUnmet.fromAi': "Según la IA",
    'cwa.role.background': "Fondo",
    'cwa.role.alternate': "Fondo alterno",
    'cwa.role.card': "Tarjetas",
    'cwa.role.ink': "Texto",
    'cwa.role.button': "Marca",
    'cwa.role.accent': "Acento",
    'cwa.role.edit': "Cambiar el color: {role}",
    'aiUnmet.period': "Periodo",
    'aiUnmet.fieldIn': "{field} en {category}",
    'aiUnmet.field.eyebrow': "Antetítulo",
    'aiUnmet.field.subheadline': "Subtítulo",
    'aiUnmet.field.primaryAction': "Botón principal",
    'aiUnmet.field.secondaryAction': "Botón secundario",
    'aiUnmet.field.items': "Lista de elementos",
    'aiUnmet.field.image': "Imagen",
    'cwa.step.template': "Template",
    'cwa.wz.template.title': "Elige un template",
    'cwa.wz.template.lead': "El punto de partida de tu sitio. En los pasos siguientes le pones tu nombre, tus colores y tu letra.",
    'cwa.wz.template.all': "Todos",
    'cwa.wz.template.industry': "Industria",
    'cwa.wz.template.noneForIndustry': "Todavía no hay templates de esta industria. Te enseñamos todos.",
    'cwa.wz.template.loading': "Cargando templates…",
    'cwa.wz.template.empty': "Todavía no hay templates de sitio.",
    'cwa.wz.templateFailed': "No se pudo cargar ese template. Prueba con otro.",
    'cwa.wz.info.leadTemplate': "El nombre y el logo con los que te van a reconocer. Sale en el título, en la barra y en los textos del template.",
    'cwa.wz.dialogAriaTemplate': "Crear sitio desde un template",
    'cwa.role.border': "Líneas",
    'preview.popupBlocked': "Tu navegador bloqueó la ventana de la vista previa. Permite las ventanas emergentes para este sitio y vuelve a intentarlo.",
    'cwa.role.muted': "Texto secundario",
    'aiGen.tab': "Generaciones",
    'aiSpend.tab': "Gasto",
    'aiSpend.subtitle': "Lo que cuesta cada llamada a la IA, por función, por plan y por día. Sólo cifras.",
    'adminEmails.subtitle': '{count} correos que manda véltica, con datos de ejemplo. Los de iniciar sesión los manda Supabase.',
    'adminEmails.loadFailed': 'No se pudieron cargar los correos.',
    'adminEmails.empty': 'No llegó ningún correo del servidor. Si acabas de añadir esta pestaña, falta desplegar el worker.',
    'adminEmails.language': 'Idioma',
    'adminEmails.subject': 'Asunto',
    'adminEmails.spanishOnly': 'Este correo sólo existe en español: no cambia con el idioma.',
    'adminEmails.group.orders': 'Compras · al comprador',
    'adminEmails.group.store': 'Compras · al negocio',
    'adminEmails.group.bookings': 'Reservas',
    'adminEmails.group.forms': 'Formularios',
    'adminEmails.group.customers': 'Cuentas de clientes',
    'adminEmails.group.domains': 'Dominios',
    'adminEmails.group.account': 'Cuenta y equipo',
    'adminEmails.audience.customer': 'Al cliente del negocio',
    'adminEmails.audience.owner': 'Al dueño del sitio',
    'adminEmails.audience.staff': 'A véltica',
    'adminEmails.name.orderReceived': 'Pedido recibido (envío)',
    'adminEmails.name.orderReceivedPickup': 'Pedido recibido (recoger)',
    'adminEmails.name.purchaseConfirmation': 'Gracias por tu compra',
    'adminEmails.name.claimDigital': 'Descarga de producto digital',
    'adminEmails.name.claimFree': 'Oferta gratis reclamada',
    'adminEmails.name.shipmentShipped': 'Va en camino',
    'adminEmails.name.shipmentPickup': 'Listo para recoger',
    'adminEmails.name.refundFull': 'Reembolso total',
    'adminEmails.name.refundPartial': 'Reembolso parcial',
    'adminEmails.name.subscriptionStarted': 'Suscripción iniciada',
    'adminEmails.name.sale': 'Venta nueva',
    'adminEmails.name.saleOversold': 'Venta sin existencias',
    'adminEmails.name.saleRenewal': 'Renovación de suscripción',
    'adminEmails.name.saleFree': 'Alguien reclamó algo gratis',
    'adminEmails.name.subscriptionCancelled': 'Suscripción cancelada',
    'adminEmails.name.bookingConfirmation': 'Reserva confirmada',
    'adminEmails.name.bookingReminder': 'Recordatorio de reserva',
    'adminEmails.name.bookingRescheduled': 'Reserva reprogramada',
    'adminEmails.name.bookingCancelled': 'Reserva cancelada',
    'adminEmails.name.bookingCancelledByBusiness': 'El negocio canceló la cita',
    'adminEmails.name.bookingOwnerBooked': 'Nueva reserva (pago en el lugar)',
    'adminEmails.name.disputeOpened': 'Disputa abierta',
    'adminEmails.name.bookingOwnerCancelled': 'El cliente canceló',
    'adminEmails.name.bookingOwnerRescheduled': 'El cliente cambió el horario',
    'adminEmails.name.submission': 'Mensaje de formulario',
    'adminEmails.name.submissionLocked': 'Mensaje bloqueado por el plan',
    'adminEmails.name.domainRenewal': 'Renovación próxima',
    'adminEmails.name.domainRenewalFailed': 'Falló la renovación',
    'adminEmails.name.domainRenewalFinal': 'Falló la renovación (último aviso)',
    'adminEmails.name.domainRenewed': 'Dominio renovado',
    'adminEmails.name.authCodeReady': 'Código de transferencia listo',
    'adminEmails.name.authCodeRequest': 'Piden un código de transferencia',
    'adminEmails.name.teamInvite': 'Invitación al equipo',
    'adminEmails.name.transferInvite': 'Transferencia de proyecto',
    'adminEmails.name.accountDeletionScheduled': 'Eliminación programada',
    'adminEmails.name.accountDeletionReminder': 'Recordatorio de eliminación',
    'adminEmails.name.accountDeleted': 'Cuenta eliminada',
    'aiSpend.empty': "Todavía no hay gasto registrado",
    'aiSpend.emptyBody': "Se empieza a registrar cuando se aplica la migración ai_usage_events y alguien usa la IA.",
    'aiSpend.totalIn': "en los últimos {days} días",
    'aiSpend.byFeature': "Por función",
    'aiSpend.byPlan': "Por plan (gasto de una cuenta en el periodo)",
    'aiSpend.topUsers': "Cuentas que más gastan",
    'aiSpend.byDay': "Por día",
    'aiSpend.col.feature': "Función",
    'aiSpend.col.calls': "Llamadas",
    'aiSpend.col.avgCost': "Costo medio",
    'aiSpend.col.p90Cost': "p90",
    'aiSpend.col.tokens': "Tokens entrada / salida",
    'aiSpend.col.total': "Total",
    'aiSpend.col.plan': "Plan",
    'aiSpend.col.accounts': "Cuentas",
    'aiSpend.col.perAccount': "Media por cuenta",
    'aiSpend.col.p90Account': "p90 por cuenta",
    'aiSpend.col.maxAccount': "Máximo",
    'aiSpend.col.account': "Cuenta",
    'aiSpend.col.day': "Día",
    'aiSpend.people': "{count} personas",
    'aiSpend.fromCache': "{count} desde caché",
    'aiSpend.estimated': "{count} estimadas",
    'aiSpend.p90Tokens': "p90: {count} tokens",
    'aiSpend.callsPerAccount': "{count} llamadas por cuenta",
    'aiSpend.feature.site': "Crear sitio",
    'aiSpend.feature.page': "Página con IA",
    'aiSpend.feature.editorChat': "Chat del editor",
    'aiSpend.feature.editorPlan': "Planificador del editor",
    'aiSpend.feature.assistant': "Asistente del panel",
    'aiSpend.feature.writePost': "Entrada de blog",
    'aiSpend.feature.photoNotes': "Notas de fotos",
    'aiUnmet.tab': "Lo que falta",
    'aiGen.subtitle': "Cada sitio o página que creó la IA: el prompt, lo que planeó, lo que se construyó y lo que no pudo hacer.",
    'aiGen.empty': "Todavía no hay generaciones",
    'aiGen.emptyBody': "Cuando alguien cree un sitio o una página con IA, aparecerá aquí.",
    'aiGen.loadMore': "Cargar más",
    'aiGen.untitled': "Sin nombre",
    'aiGen.flow.project': "Sitio",
    'aiGen.flow.page': "Página",
    'aiGen.failed': "Falló",
    'aiGen.lost': "{count} secciones perdidas",
    'aiGen.unmetCount': "{count} sin cumplir",
    'aiGen.notCreated': "Borrador sin terminar",
    'aiGen.noProject': "Sin proyecto",
    'aiGen.prompt': "Prompt",
    'aiGen.error': "Error",
    'aiGen.sections': "Secciones: la IA planeó {planned}, se construyeron {built}",
    'aiGen.planned': "Planeadas: {list}",
    'aiGen.items': "{count} elementos",
    'aiGen.extraSections': "{count} secciones pedidas aparte para completar la portada",
    'aiGen.itemsRequested': "{count} listas sin elementos pedidas aparte",
    'aiGen.unmet': "Lo que no se pudo hacer",
    'aiGen.tokens': "{count} tokens",
    'aiGen.cost.input': "Entrada",
    'aiGen.cost.output': "Salida",
    'aiGen.cost.total': "Total aprox.",
    'aiGen.cost.summary': "≈ {amount}",
    'aiGen.cost.calls': "{count} llamadas a la IA",
    'aiGen.cost.note': "Estimado en USD según las tarifas estándar de la API de pago y los tokens registrados. La salida incluye razonamiento; se suman reintentos y llamadas adicionales.",
    'aiGen.cost.legacy': "Esta solicitud anterior solo guardó el total de tokens. El rango supone tarifas estándar sin caché; no está disponible el desglose de entrada y salida.",
    'aiGen.cost.unavailable': "Costo no disponible: faltan los tokens o la tarifa registrada de este modelo.",
    'aiGen.cost.estimatedTokens': "Algunos contadores de tokens son estimados.",
    'aiGen.cost.cached': "{count} tokens de entrada en caché con tarifa reducida.",
    'aiGen.cost.rates': "Tarifas de Google",
    'aiGen.openEditor': "Abrir en el editor",
    'aiGen.openSite': "Ver el sitio",
    'overview.unit.post': "entrada",
    'overview.unit.posts': "entradas",
    'overview.row.openPost': "Abrir el blog",
    'filter.soft': "Suaves",
    'cwa.paletteGroup.suave': "Suaves",
    'start.resume.title': "Tienes un sitio sin terminar: {name}",
    'start.resume.body': "Lo dejaste {when}. Síguelo donde lo dejaste, sin generar otro.",
    'start.resume.discard': "Descartar",
    'start.resume.go': "Seguir",
    'start.credits.total': "Probar es gratis (3 veces sin crear) · Te quedan {left} de {total}",
    'start.credits.monthly': "Probar es gratis (3 veces sin crear) · Te quedan {left} de {total} este mes",
    'start.credits.none': "Sin generaciones · Mejora tu plan para crear más",
    'cwa.credits.none': "No te quedan generaciones: mejora tu plan para crear este sitio.",
    'error.offer.setupPending': "Completa esta oferta antes de ponerla a la venta: la empezó la IA con datos de ejemplo.",
    'error.blog.setupPending': "Escribe tu entrada antes de publicarla: todavía tiene el texto de relleno.",
    'error.server.dbUnavailable': "Se cortó la conexión con el servidor. Vuelve a intentarlo en un momento.",
    'aiPending.chip': "Por completar",
    'aiPending.minimize': "Minimizar",
    'aiPending.expand': "Ver lo que falta por completar",
    'aiPending.chipAria': "Completar: la empezó la IA y falta tu información",
    'aiPending.chipHint': "La IA la empezó con datos de ejemplo. Complétala para poder publicarla: mientras tanto no aparece en tu sitio.",
    'aiPending.wizardNote': "La IA empezó esto con datos de ejemplo. Revisa cada paso y pon lo tuyo; al terminar podrás publicarlo.",
    'aiPending.bookingNote': "La IA empezó esta reserva con el horario y los ajustes por defecto. Revisa cada paso, sobre todo tu horario; al terminar podrás publicarla.",
    'aiPending.priceHint': "Precio sugerido por la IA: cámbialo por el tuyo.",
    'aiPending.scheduleHint': "Este es el horario por defecto: ajústalo al tuyo antes de abrir las reservas.",
    'aiPending.postNote': "La IA escribió el título y el resumen; el texto de abajo es de relleno. Escríbelo para poder publicar la entrada.",
    'aiPending.postHint': "La empezó la IA: escribe el cuerpo para poder publicarla.",
    'pub.offersPending': "{count} elementos sin publicar en tu sitio",
    'pub.offersPending.one': "1 elemento sin publicar en tu sitio",
    'pub.offersPendingLead': "Se ven en el editor, pero no saldrán en tu sitio hasta que los completes y los publiques. Una sección que sólo tenga estos se oculta.",
    'aiPending.toastTitle': "Falta por completar",
    'aiPending.toastBody': "{count} elementos de esta página no aparecerán en tu sitio hasta que los completes.",
    'aiPending.toastBody.one': "1 elemento de esta página no aparecerá en tu sitio hasta que lo completes.",
    'aiPending.toastShow': "Ver cuáles",
    'aiPending.toastHide': "Ocultar",
    'aiPending.kind.bookings': "Reserva",
    'aiPending.kind.services': "Servicio",
    'aiPending.kind.digital': "Producto digital",
    'aiPending.kind.blog': "Entrada del blog",
    'aiPending.openInDashboard': "Abrir en el panel",
    'pub.offersComplete': "Completar",
    'pub.offersOpen': "Abrir",
    'aiPending.canvasHint': "La empezó la IA con datos de ejemplo. No saldrá en tu sitio hasta que la completes y la actives. Pulsa la etiqueta para completarla.",
    'aiPending.canvasDraftHint': "Está en borrador: no saldrá en tu sitio hasta que la actives. Pulsa la etiqueta para abrirla.",
    'aiPending.previewTitlePending': "Falta terminar esto",
    'aiPending.previewTitleDraft': "Esto está en borrador",
    'aiPending.previewBodyPending': "«{title}» lo empezó la IA y aún le falta tu información. No aparecerá en tu sitio ni se podrá abrir su página hasta que lo completes y lo actives en el panel.",
    'aiPending.previewBodyDraft': "«{title}» está en borrador. No aparecerá en tu sitio ni se podrá abrir su página hasta que lo actives en el panel.",
    'aiPending.previewComplete': "Completar en el panel",
    'aiPending.previewAnyway': "Ver de todos modos",
    'aiPending.bannerTitle': "Aún no está terminado.",
    'aiPending.bannerBody': "Así se verá cuando lo completes; en tu sitio todavía no aparece.",
    'aiPending.stepTitle': "Completa tu sitio",
    'aiPending.stepBody': "La IA dejó empezado: {list}. Pon tu información para poder publicarlos.",
    'aiPending.stepGo': "Completar el primero",
    'aiPending.n.booking': "{count} reserva",
    'aiPending.n.bookings': "{count} reservas",
    'aiPending.n.service': "{count} servicio",
    'aiPending.n.services': "{count} servicios",
    'aiPending.n.digital': "{count} producto digital",
    'aiPending.n.digitals': "{count} productos digitales",
    'aiPending.n.post': "{count} entrada del blog",
    'aiPending.n.posts': "{count} entradas del blog",
    'cwa.credits.cardTitleNone': "No te quedan generaciones",
    'cwa.credits.leftOf': "generaciones disponibles de {total}",
    'cwa.credits.charged': "Ésta ya está descontada: pasaste de las 3 pruebas gratis sin crear de este mes.",
    'cwa.credits.usesOne': "Crear este sitio usa una.",
    'cwa.credits.resets': "Se reinicia el {when}",
    'cwa.credits.lifetime': "En total en el plan gratis",
    // ── Demo pública (/demo) ──────────────────────────────────────────────────
    'demo.aria': "Demo de diseño",
    'demo.stepsAria': "Qué cambiar",
    'demo.kicker': "Pruébalo sin cuenta",
    'demo.start': "Empezar con este diseño",
    'demo.previewNote': "Doble clic en un texto para escribir el tuyo.",
    'demo.address': "tu-sitio.veltica.com",
    'demo.loadFailed': "La demo no cargó. Revisa tu conexión e inténtalo de nuevo.",
    'demo.saveFailed': "Tu navegador no nos deja guardar este diseño (¿navegación privada?). Permite el almacenamiento del sitio e inténtalo de nuevo.",
    'demo.combination.startBadge': "De partida",
    'demo.combination.startHint': "Como abrió la página, para volver a ella.",
    'demo.combination.badge': "De la demo",
    'demo.combination.hint': "El diseño que armaste en la demo.",
    'cwa.wz.info.leadDemo': "Tu diseño de la demo, listo. Ponle el nombre de tu negocio: sustituye al nuestro en el título, la barra y los textos. Luego reescribes lo demás en el editor, o se lo pides a la IA.",
    'embedPrompt.note': "Gratis para probar: crea tu cuenta y tu sitio se genera al momento.",
    'embedPrompt.placeholder': "Cuéntanos qué quieres construir: tu negocio, lo que ofreces y el objetivo de tu sitio.",
    'embedPrompt.saveFailed': "Tu navegador no nos deja guardar lo que escribiste (¿navegación privada?). Permite el almacenamiento del sitio e inténtalo de nuevo.",
    'embedAuth.opening': "Abriendo tu panel…",
    'embedAuth.openingHint': "Ya tienes la sesión iniciada. Te llevamos con lo que elegiste.",
    'demo.split.title': "Diseña esta página",
    'assistant.period.today': " hoy",
    'assistant.period.week': " en los últimos 7 días",
    'assistant.period.month': " este mes",
    'assistant.period.year': " este año",
    'assistant.period.all': "",
    'assistant.window.today': " hoy",
    'assistant.window.week': " en los próximos 7 días",
    'assistant.window.month': " en los próximos 30 días",
    'assistant.window.year': " próximamente",
    'assistant.window.all': " próximamente",
    'assistant.q.contacts_summary': "Tienes {total} contactos, {recent} nuevos{period}. {buyers} personas te han comprado.",
    'assistant.q.contacts_summary.all': "Tienes {total} contactos. {buyers} personas te han comprado.",
    'assistant.q.contacts_summary.empty': "Todavía no tienes contactos ni compras.",
    'assistant.q.sales_summary': "Vendiste {revenue}{period}, en {orders} pedidos.",
    'assistant.q.sales_summary.one': "Vendiste {revenue}{period}, en 1 pedido.",
    'assistant.q.sales_summary.empty': "No hay ventas{period}.",
    'assistant.q.otherCurrencies': "También en otras monedas: {list}.",
    'assistant.q.top_customers': "Quien más te ha comprado{period} es {name}: {orders} compras por {revenue}.",
    'assistant.q.top_customers.one': "Quien más te ha comprado{period} es {name}: 1 compra por {revenue}.",
    'assistant.q.top_customers.empty': "Todavía no hay compras con cliente identificado{period}.",
    'assistant.q.top_offers': "Lo más vendido{period} es «{title}»: {units} vendidos, {revenue}.",
    'assistant.q.top_offers.empty': "No hay ventas{period} todavía.",
    'assistant.q.upcoming_bookings': "Tienes {count} citas{period}. La siguiente es «{title}», el {next}.",
    'assistant.q.upcoming_bookings.one': "Tienes 1 cita{period}: «{title}», el {next}.",
    'assistant.q.upcoming_bookings.empty': "No tienes citas{period}.",
    'assistant.q.visits_summary': "Tu sitio tuvo {views} visitas de {visitors} visitantes{period}.",
    'assistant.q.visits_summary.empty': "Todavía no hay visitas registradas{period}.",
    'assistant.q.unread_forms': "Tienes {count} mensajes de formularios sin leer.",
    'assistant.q.unread_forms.one': "Tienes 1 mensaje de formulario sin leer.",
    'assistant.q.unread_forms.empty': "Estás al día: no hay mensajes de formularios sin leer.",
    'assistant.q.seeIn': "Ver en {place}",
    'assistant.disclaimer': "La IA puede equivocarse. Revisa la información importante.",
    'find.editor': "Abrir el editor",
    'assistant.notConfigured': "La IA no está configurada en este servidor, así que sólo puedo buscar secciones. (Falta la clave de la IA en el worker.)",
    'assistant.seeAll': "Ver conversación completa",
    'assistant.usage': "{input} tokens de entrada · {output} de salida",
    'assistant.usageThought': "{thought} de razonamiento",
    'assistant.usageCached': "Desde caché · 0 tokens",
    'assistant.hereItIs': "Aquí lo tienes:",
    'assistant.offer.ready': "Así quedaría tu {kind}. Revísalo y, si te gusta, lo creo:",
    'assistant.offer.createOpen': "Crear y abrir",
    'assistant.post.ready': "Listo, escribí esta entrada. Guárdala como borrador para revisarla y publicarla:",
    'assistant.post.saveOpen': "Guardar borrador y abrir",
    'assistant.post.note': "Se guarda como borrador: la revisas y la publicas desde el blog.",
    'assistant.writingPost': "Escribiendo la entrada…",
    'assistant.draftingOffer': "Preparando la ficha…",
    'aiSpend.feature.draftOffer': "Ficha de oferta",
    'assistant.ask.postTopic': "¿Sobre qué tema quieres la entrada?",
    'assistant.ask.pageIdea': "¿De qué es la página? Por ejemplo: «preguntas frecuentes» o «nuestro equipo».",
    'assistant.ask.offer': "¿Cómo se llama el {kind}? Si quieres, dime también el precio y, si es un producto, sus tallas o colores.",
    'assistant.ask.offerGeneric': "producto o servicio",
    'assistant.offer.scheduleReplaces': "Cambia el horario de tu agenda: lo comparten todos tus servicios con agenda.",
    'assistant.title': "Asistente",
    'assistant.open': "Abrir el asistente",
    'assistant.close': "Cerrar el asistente",
    'assistant.placeholder': "¿En qué te ayudo hoy?",
    'assistant.send': "Enviar",
    'assistant.clear': "Nueva conversación",
    'assistant.thinking': "Pensando…",
    'assistant.hello': "Puedo llevarte a cualquier sección, crear servicios, productos y páginas, o escribir una entrada de blog. ¿Qué necesitas?",
    'assistant.example.find': "¿Dónde veo mis ventas?",
    'assistant.example.offer': "Crea un servicio de asesoría",
    'assistant.example.post': "Escribe una entrada para mi blog",
    'assistant.foundIn': "Lo encuentras en {place}:",
    'assistant.pickOne': "¿Buscas alguna de estas?",
    'assistant.foundContent': "Esto encontré en tu proyecto:",
    'assistant.error': "No pude contestar ahora. Inténtalo de nuevo en un momento.",
    'assistant.limitDaily': "Por hoy llegaste al límite de preguntas al asistente. Mañana vuelve a estar disponible.",
    'assistant.tokenLimit': "Usaste toda la IA de este mes. Vuelve el día 1.",
    'assistant.forbidden': "Eso no lo permite tu rol en este proyecto.",
    'assistant.noAi': "No encontré eso, y tu rol no puede usar la IA en este proyecto. Prueba con el buscador de arriba.",
    'assistant.createFailed': "No se pudo crear. Inténtalo de nuevo.",
    'assistant.cancelled': "Va, no hago nada.",
    'assistant.cancel': "Cancelar",
    'assistant.doneShort': "Hecho",
    'assistant.cancelledShort': "Cancelado",
    'assistant.kind.services': "Servicio",
    'assistant.kind.digital': "Producto digital",
    'assistant.kind.products': "Producto físico",
    'assistant.kind.bookings': "Servicio con agenda",
    'assistant.offer.note': "Nace «Por completar»: luego le pones foto, detalles y cobro en su ficha.",
    'assistant.offer.done': "Listo: «{title}» está creado como «Por completar». Te abrí su ficha para terminarlo.",
    'assistant.page.propose': "¿Abro el asistente de página nueva?",
    'assistant.page.kind': "Página nueva",
    'assistant.page.untitled': "Elige un diseño o descríbela",
    'assistant.page.note': "Se abre en el editor, con tu idea ya escrita para la IA.",
    'assistant.page.open': "Abrir el editor",
    'assistant.page.done': "Te llevo al editor…",
    'assistant.post.kind': "Entrada de blog",
    'assistant.post.done': "Listo: guardé «{title}» como borrador. Revísala antes de publicar.",
    'bp.opentable': 'Reservas con OpenTable',
    'bp.classSchedule': 'Horario de clases',
    'classes.days': 'Días',
    'classes.days.week': '1 semana',
    'classes.days.twoWeeks': '2 semanas',
    'classes.layout': 'Vista',
    'classes.layout.agenda': 'Agenda',
    'classes.layout.timetable': 'Calendario',
    'classes.layout.timetableHint': 'La semana por horas, con colores por clase',
    'classes.layout.pro': 'Agenda con filtros',
    'classes.layout.proHint': 'Días, filtros y lugares',
    'classes.layout.people': 'Por persona',
    'classes.layout.peopleHint': 'Cada instructor con sus clases',
    'classes.layout.classes': 'Por clase',
    'classes.layout.classesHint': 'Fichas con foto y próximas sesiones',
    'classes.layout.month': 'Mes',
    'classes.layout.monthHint': 'Calendario mensual',
    'classes.layout.agendaHint': 'Un día a la vez, sencillo',
    'classes.layout.weekHint': 'Columnas compactas',
    'classes.layout.listHint': 'Todos los días seguidos',
    'classes.styles': 'Estilo',
    'classes.simple': 'Sencillos',
    'classes.layout.week': 'Semana',
    'classes.layout.list': 'Lista',
    'classes.allSummary': "Todas",
    'classes.pickedCount': "{count} de {total}",
    'classes.which': 'Clases',
    'classes.whichInfo': 'Salen solas las de cupo para varias personas. Marca o quita las que quieras enseñar.',
    'classes.spots': '{count} lugares',
    'classes.oneOnOne': '1 a 1',
    'classes.noServices': 'Aún no hay servicios con agenda. Crea una clase en Reservas.',
    'classes.allClasses': 'Volver a todas las clases',
    'classes.manage': 'Editar clases en Reservas',
    'classes.refresh': 'Actualizar',
    'bp.offerBuy': 'Comprar / Reservar',
    'offerBuy.mode': 'Cómo se ve',
    'offerBuy.modeInfo': 'Zona completa: se compra o reserva aquí mismo (una por página). Sólo botón: lleva a la página de compra de la oferta; sirve para tarjetas o varias ofertas.',
    'offerBuy.mode.full': 'Zona completa',
    'offerBuy.mode.button': 'Sólo botón',
    'offerBuy.layout': "Diseño",
    'offerBuy.layoutInfo': "Sólo compra: la zona de pago (para la página de la oferta, que ya tiene su título). Tarjeta, Lado a lado y Compacto añaden la foto, el título y la descripción de la oferta. Sólo botón lleva a su página de compra.",
    'offerBuy.layout.buy': "Sólo compra",
    'offerBuy.layout.titled': "Compra con título",
    'offerBuy.layout.card': "Tarjeta",
    'offerBuy.layout.split': "Lado a lado",
    'offerBuy.layout.compact': "Compacto",
    'offerBuy.layout.button': "Sólo botón",
    'offerBuy.label': 'Texto del botón',
    'offerBuy.fallbackLabel': 'Texto del botón de respaldo',
    'offerBuy.labelBook': 'Reservar',
    'offerBuy.labelBuy': 'Comprar',
    'offerBuy.offer': 'Qué se compra',
    'offerBuy.offerInfo': 'La zona de compra de esa oferta, completa: precio, opciones y pago, o el calendario si es una reserva. Una por página.',
    'offerBuy.choose': 'Elige una oferta…',
    'offerBuy.kind.bookings': 'Reservas',
    'offerBuy.kind.services': 'Servicios',
    'offerBuy.kind.products': 'Productos',
    'offerBuy.kind.digital': 'Digitales',
    'offerBuy.draft': 'borrador',
    'offerBuy.draftNote': 'Es un borrador: en el sitio no se podrá comprar hasta que la actives.',
    'offerBuy.noOffers': 'Aún no hay ofertas. Créalas en el panel y vuelve aquí.',
    'offerBuy.edit': 'Editar la oferta',
    'offerBuy.emptyTitle': 'Elige qué se compra aquí',
    'offerBuy.pick': "Elegir oferta",
    'offerBuy.create': "Crear oferta",
    'offerBuy.emptyBody': "Elige una oferta de tu catálogo o crea una nueva: aquí se podrá comprar o reservar.",
    'offerBuy.loading': 'Cargando la zona de compra…',
    'offerBuy.loadingBody': 'Un momento.',
    'bp.map': 'Mapa',
    'map.previewNote': "Por completar · agrega la dirección del mapa",
    'map.address': 'Dirección',
    'map.empty.action': 'Agregar dirección',
    'map.addressInfo': 'La dirección exacta del local, como la buscarías en Google Maps. Puede ser distinta de la legal de Configuración › Negocio.',
    'map.addressPlaceholder': 'Calle, número, ciudad',
    'map.zoom': 'Acercamiento',
    'map.type': 'Tipo',
    'map.check': 'Ver en Google Maps',
    'map.height': 'Altura',
    'map.height.low': 'Baja',
    'map.height.medium': 'Media',
    'map.height.high': 'Alta',
    'map.directions': 'Cómo llegar',
    'map.directionsInfo': 'Debajo del mapa: la dirección y un botón que abre la ruta en Google Maps desde donde esté quien la mire.',
    'map.directions.hide': 'Ocultar',
    'map.directions.show': 'Mostrar',
    'map.type.roadmap': 'Mapa',
    'map.type.satellite': 'Satélite',
    'map.empty.title': 'Muestra dónde estás',
    'map.empty.body': 'Escribe la dirección exacta de tu local y aquí aparecerá el mapa de Google.',
    'map.needsKey': 'Falta la clave de Google Maps en la configuración del editor.',
    'bp.deliveryButtons': 'Pedir a domicilio',
    'bp.orderUberEats': 'Pedir en Uber Eats',
    'bp.orderDoorDash': 'Pedir en DoorDash',
    'bp.orderRappi': 'Pedir en Rappi',
    'search.opentable': 'opentable reservas reservaciones restaurante mesas widget servicio externo',
    'opentable.external': 'Servicio externo',
    'opentable.title': 'Recibe reservas con OpenTable',
    'opentable.requirements': 'Necesitas una cuenta de restaurante en OpenTable y el código de su widget para recibir reservas en tu sitio.',
    'opentable.managedExternally': 'Veltica muestra el widget en tu página. OpenTable gestiona las reservas de mesas; este servicio no está incluido en Veltica.',
    'opentable.learnMore': '¿Todavía no tienes OpenTable? Conocer OpenTable',
    'opentable.pasteWidget': 'Conectar con mi ID',
    'opentable.editWidget': 'Editar código del widget',
    'opentable.codePlaceholder': 'Pega aquí el código del widget que copiaste de tu cuenta de restaurante en OpenTable.',
    'opentable.canvasEmpty': 'Reservas con OpenTable · Servicio externo. Configura el widget desde los ajustes de este componente.',
    'opentable.canvasConfigured': 'Reservas con OpenTable · Widget configurado. Se muestra en la página publicada.',
    'opentable.previewReady': 'Widget configurado',
    'opentable.previewPending': 'Por conectar',
    'opentable.pendingNote': 'Por completar: conecta tu OpenTable',
    'opentable.previewEyebrow': 'Reservas de restaurante',
    'opentable.previewTitle': 'Tu próxima mesa empieza aquí',
    'opentable.previewConfiguredTitle': 'Todo listo para recibir reservas',
    'opentable.previewBody': 'Conecta tu cuenta de restaurante con el widget de OpenTable. Tus clientes reservan desde tu sitio y tú gestionas las mesas en OpenTable.',
    'opentable.previewConfiguredBody': 'El código de tu widget está guardado. El formulario de OpenTable se mostrará en tu página publicada.',
    'opentable.openPanel': 'Abrir panel',
    'opentable.moreInfo': 'Más información',
    'opentable.previewEditorOnly': 'Vista de configuración · Solo visible en el editor. OpenTable es un servicio externo y requiere una cuenta de restaurante.',
    'opentable.connectTitle': 'Conecta OpenTable a tu sitio',
    'opentable.connectDescription': 'Escribe el ID de tu restaurante y listo. El diseño lo eliges después en el panel del componente.',
    'opentable.copyStep': 'Busca el ID de tu restaurante',
    'opentable.copyStepHint': 'Está en tu cuenta de OpenTable (Guest Center), en el widget de reservaciones. Si tienes el código o el enlace del widget, pégalo y sacamos el ID.',
    'opentable.openAccount': 'Abrir mi cuenta de OpenTable',
    'opentable.pasteStep': 'Escribe tu ID',
    'opentable.detected': 'ID detectado: {id}',
    'opentable.detectedMany': 'IDs detectados: {id}',
    'opentable.notDetected': 'No encontramos un ID. Escribe el número o pega el código del widget.',
    'opentable.design': 'Diseño',
    'opentable.lockedInfo': 'Conectado en Configuración › OpenTable: todos los widgets y botones de OpenTable del sitio usan este restaurante. Se cambia ahí.',
    'opentable.restaurant': 'Restaurante',
    'opentable.connect': 'Conectar',
    'opentable.opensIn': 'Al reservar',
    'opentable.opensPage': 'En la página',
    'opentable.opensTab': 'Pestaña nueva',
    'opentable.shape.standard': 'Normal',
    'opentable.shape.tall': 'Alto',
    'opentable.shape.wide': 'Ancho',
    'opentable.shape.button': 'Botón',
    'opentable.changeId': 'Cambiar ID ({id})',
    'opentable.alignment': 'Alineación',
    'opentable.alignLeft': 'Izquierda',
    'opentable.alignCenter': 'Centro',
    'opentable.alignRight': 'Derecha',
    'opentable.pasteStepHint': 'Un número, como 1434817. Si tienes varios locales, sepáralos con comas.',
    'opentable.friendlyPlaceholder': 'Ej. 1434817',
    'opentable.noCodeEditing': 'No necesitas saber de código.',
    'opentable.codeAdded': 'Código añadido. Ya puedes guardar tu widget.',
    'opentable.connectServiceNote': 'Necesitas una cuenta de restaurante en OpenTable. Las reservas y la disponibilidad se gestionan allí; el servicio se contrata por separado.',
    'opentable.visibleOnPublish': 'Se mostrará al publicar tu sitio.',
    'opentable.connectWidget': 'Conectar widget',
    'opentable.saveChanges': 'Guardar cambios',
    'delivery.orderOn': 'Pedir en',
    'delivery.orderNow': 'Pedir ahora',
    'delivery.configure': 'Configurar pedidos',
    'delivery.settingsIntro': 'Elige dónde pueden pedir tus clientes y pega el enlace de tu restaurante en cada app.',
    'delivery.enable': 'Activar {name}',
    'delivery.restaurantLink': 'Enlace de tu restaurante',
    'delivery.linkPending': 'Agrega el enlace de tu restaurante para publicar este botón.',
    'delivery.linkHint': 'Copia el enlace de tu tienda en {name}.',
    'delivery.invalidLink': 'Este enlace debe ser de tu restaurante en {name}.',
    'delivery.linkReady': 'Listo para recibir pedidos en {name}.',
    'delivery.testLink': 'Probar enlace',
    'delivery.empty': 'Activa una app de delivery desde los ajustes de este componente.',
    'delivery.externalNote': 'Los pedidos y pagos se completan en cada app. Solo se publican las empresas activas que tengan un enlace válido.',
    'delivery.addLink': 'Agregar enlace',
    'delivery.editLink': 'Editar enlace',
};
//# sourceMappingURL=es.js.map